(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1404],{

/***/ 26625:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://static-cny.howxm.com/_next/static/media/empty.06f714ea.png","height":144,"width":144,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEXK+fzF9vrF9fnM+v3F9fnE9fnL+v3K+v3I+PvL+v3I+PvF9vq/8vaM096M090AlrHK+f3K+fzJ+fzS//+77/S67/Sw6O+w6O6v6O6v5+6t5u2s5u2s5e2s5eyo4+uf3eZhvs1hvc0AoblAlxEYAAAAE3RSTlMAAAApKSnBwcHCwu7u+fn5+vr68Ga4GQAAAEVJREFUeNoFQAkWQCAQ/aSSog2poej+h/QwcOmc5CO4TrUmPWE+1py3fUFIZ4xXCvD329r3eCiyvVsSYKYQFcMAJrxXDD+VUQQzZETURQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 14122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1.986256f7.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAgElEQVR42g3CsQ7CIBAA0Du4Qmk7aBqNi3HQ3V/2oxyMLkZdmhqNkFgqcNiXh+ebXfQPobouuMvXDO1eklxWDbH/jK/DMe6uehPnW5nC2w01aTz13vj7SG1VlsghcyRSDmoySq2atUBGRAD1tHKmMUSkH4PHImeYCgSbuMjoU/4Dp/M5KORgw/kAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 88775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/10.d18fc664.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AMX/7Lfg0IWfkOO4c+LAieG+gcrpzsH97QDD/erA6dzIx8fyyq3v1r/15dLS7ty//OoAvfjl1/3w////7/b27fL1////1PzwvvjlAL755tX67v/8/vXu6/Px8f/+/9X67b755gC/+ebQ/O7z+fTw2srr9vHz/frQ++y/+ebK6Gk6eVTPiAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 96865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/11.65fbb010.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAfUlEQVR42hXGUQqCQBQF0PumwRmiodpCtIA++u7HXbeDoAh3UKAFQoRFljbep56vI1qe9sdrVrwCWv6a/F6m21W624jeDk1Yf+ne1bMj54vlFLWrL1ahzjsDz78nNYSZjdSPWgwUHRUmcYmoAsMFZpzEvKjO2WMCClswAtID4fI/5+V4yc8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 53705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/12.889566a4.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAfklEQVR42hXJSwrCMBAA0N7/QoIIJqILERdKTaFYP9SFWFuTNjNNZqZBfduXaaR8wOpyffaP0tx2i8qwKB8zFaRo3vb+cpJmW1rv01l4+Q8ggzH4vvtYN/g0yWkkDTHTQEcc27Zx1iFAYi4Cq1+skA4Q55u6rLsgTFPKA2uIX3e0bVL2gd8bAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 44570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/13.2d5cdcdc.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAgUlEQVR42h3J0QqCMBQAUD81+h1/oK/ooeg9oXARLGovghHFcMPNdduNclnspr6ek1DNeClT8c02x+1epKLjZ9ljQnWeFXp6oNl8sVqeJpzWhR5DM2dUaV5C3i5XX2FEMKTyIX6oENHDA+42hA+1TayG2HUgXWM9WAQX2nd8alLsD974aS8qhQo5AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 24029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/14.a779c0c7.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AMb95rTq7GSc/Wag/JGo5Zq2yrPv5cb86ADH/uas5O5tbNo8afMAY/4FYfau5uzH/uYAwProzPXl29bX0tv809z90tr/xvTrwfrmAL/558/66/Ly8fTx7Pj28P/++dH77L755gDB+ujJ+efh7Obh6uno8vD0/PrN+uvA+ecwKGPpD41vKwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 23746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/15.38e1f4e4.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAfElEQVR42hWLuw6CQBRE+XMrS79kK3qxNjHsooBQaiTs6yKNzyXcYZlqck5OIgn1430/i0bvU7ERu62yofBIpEdjQqfbA/msrY/5qbCzWoXlckCYMBrzdH5mVANyy4l0XBF+/9DruD6ekhDhWlxH3PQnzTpDr+/EF4JyvABdy2pX2dnmZQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 59676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/16.82d3c4e6.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAfElEQVR42g3BuxLCIBAF0LsEyCBELLTwf7T3px1LbSwsfEyqdMao+Aq75hzabGtT7+PEm/Oh6fL1ybNIZrHS/pfcca1c0KfdnGU6tmXMdyzp0ubYt1kwtLr4MlfBN2+rQerFJZGKXkSQEnUPgSbdC6qRASgxCHChgPDtgz9CZjZmO8BwwgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 32534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/17.f43ad578.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAaUlEQVR42h2NQRLDIAwD+f/T2hQe0UsnYIohGI+ATEh02NFFWvPu3g2yPdgRFj/95gu7IT2IKPyjj8SZcylVRM5uGK1VyYkrF3z3Rkmb6jlMgqzgF0Es2lafc96LDd6tX3iL4B6BQ9jgL0Mkb+ZXySKeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 50970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/18.dea1780c.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAYUlEQVR42i3MSwqFMBBE0ex/g+85UieCYGL8paOdrlKDcEYFdR2mX5oH3UZKQApMHjJj+jvEbj1E8knSSFTP6Bg71ZJFADMrLwCxdVz6rHZpAWmovodvdPflqOkUXhLhmxsvD3OR4A0jbQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/19.17e90644.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAbElEQVR42hWMWwqDMBAAvf+pqjlGS1sQTB+BmH0mu1HU+R1mhiB+R37/04K0kHyQn1InsWESjywlpVqta9kVftZv3E5hUZQASBQgc8mx2ngWQX0uSDlbu6AVI+u1GrnNzdF7Nodte33xQTWoHUoPcBQS1uY/AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 81120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/2.80a3f5c3.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAeUlEQVR42hXIsQ7BYBQF4HOuq60K0kGnSgSTUeL9maweQxhEVVtN/3vpN3489fe0KjeXc/3prnGRFavZbvFMUoWbajLdHtPeD6+3LPPHWIZ0M8YTW+9B5mhU4lso4a3izw1NXbUmgmweCR2gEgxAFwlEZMSvIpjT+QOEOy6dtV2SJAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 38149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/20.aef8965a.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAf0lEQVR42g3HrQ7CMBQG0O+2tyQjhSaEPQIajUTx4jgChhAEZqEKguG3ZLfr3cQRh/R+OMXf+dIYQhZprnGzXi0XcwaZ5zttd8d6FsZVVdh/kwBEets/Sv1KnbPG8sB5V3wbGcBkGqow+oiV3Klh6/4QMFSZCqgEzsMsG5NbKHompTNCom/17wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 98784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/21.98becd88.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/ANTv/4qbqUJJT1JfZ1ZhaTJDSoqfrdTw/wDV8f9neYYAAABsSUJZOy4AAAB/hpHV8f8A0e3/wMnRtbOxvry8wb+/ycK+zdHZz+z/AM3q/+/2/fj29u/x9+js9/////b+/8vo/gDP6//h7fre5vTm7ffu8vf29/ns9v7N6f9FrldtuC3diAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 41732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/22.db51cbe8.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAgElEQVR42gVAOw7CIBj+P6AvjEyOLk1Tj+PiEd09g3oCBxd3LfFRowkm0gJ/g8PwKMKvve7yW+x0Oq5UU21yMVMMyDia11ZdTvmC7LKpizUJYO+tZmrfvfxT0uVnLqwsB0ARMUTGuiYjKyWNkE/qPY8CBAafu+/dOZ8Fl4VICYQJbiAy7mjHSzgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 94494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/23.e57883bc.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42g3JvQ6CMBRA4b7/bHwEJzajCdjEgRiKxP/BKgNKtBY0ECC1rTfptcMZTj6C9RbOkZ6O62CU0flhv3PFCqsN8f3yeEioZkseTOLsBI8jyjVBwaApemM1QK+sseC6O4qE4IvZz62sTNsO7+arLGJXuqcHmSpxmYXXKOKU8nCR+0WZ/gFN9WinsnugPAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 48108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/24.842d83b6.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAdElEQVR42gUAWwrCMKxJ00eGTkTwx19/vP8d/BzeYCdQcA462yYZ8FyXvL6k6XnMTQBKucTDzA8yqbJMrWw83IIM+HuPmCDdYSr1+v14NGaWLqAC6Od8JI94SpQDUYwuoWJovTsDqmotYte/bcV5tkAKIGo7Zg04qVtemGcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 66206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/25.2275786e.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/APbSuLCqm9jCn/jAgvLCj/LEl/O+evvhvgDhvqUAbH7QrHvzmwDroEfn2KznrWz50q8A+OfU4OXp7efj7+Tf8enl+fz4+v35/erUAP/w3vr17/r18Pn28fr38f748/r18f7u2wD+7Nb+8N//793/793/793+7tz+797/69UU72TlDPkM4gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 10466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/26.b3d39fde.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAfklEQVR42g3IQQrCMBAF0D8zUVsTyELcKHgCF97KG3g+RTyDolu1CIKLFoW0mTFv+eio79w08XCK7fNxuWFey3Y3xBnth1fofsvz3VLy04oCX1eLbjxxyJlr79cbOCkcCdvHNDkDBPCphyqoZxYalYMjQJnaUIlwAYPmLxn9AVNPLuAhS5VfAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 59358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/27.b91157d0.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAh0lEQVR42iXMuw6CMBQA0P64k5s/wIATk2FUExnVRRdEjSYObiiGtiHl0ctta72SMJ/ksBOnchEWj5UsNodktp5Onrv4KomlJcEyPOb7iOfzdBtEwT2JbwNcJInW1LKqP0Kr1hrsvzQ07CxIgbGqovcLmwZ0B9ZnI4jO9ejAeO0InVdIGf/9AYyOaW/ydfTuAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/28.57a0b019.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAZ0lEQVR42hXLOw7CMBAE0JlZO8RlKBH3vwv3QEGCEoVfWA+ketWjL6cc9osmOVtrUXe+n/m8FdhSHSMUlaC7wTAgAN39A72+uQIu1Qb/gqRzXK6C8XAOUwgAiimtb84znFtQ5fFgxQ/nQC7BrH6ROgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 64849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/29.b08f7cf2.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAeklEQVR42g3MPRLCIBBAYe5/AluPYGeTSoh2thY2KXDiHwQiyy4Lkp153TfzlIbyuOowHsN5uO13h0Hfp+mSUJnMb+/CbP1zprh0wsSsE6kxs41gX8tKLXFH7r402SgD5ZPZRfxhlQCrp2oEBL+FVwBsTSr/5mo9JdoAQdNuWGINl+0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 80455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/3.036ce555.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAcklEQVR42jXLyw6CMBAF0P7/b7kHxYXBGDVqkQESw2NuOy3MuOLsjzMqZbjxt0ZbY3jo7G18aVs4688AGFHyJtRkQFKy7uSsqySCeVkYfL/kGFRXo+M+QkQU5G0lnwKsr5xSodNHJ69zo+Nbrwf9PY3KP2xXcFm9xAnhAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 37771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/30.a33cd928.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAa0lEQVR42k3NMQ7CMAwAwPz/WW1hDgOsSBWQEGqSYMeq7QxAp0q3nxs1Huy5kyaNgwTndXlhCQVChYTl9k7QPt7AXSwLMVWc7+0RmZH6Kuee3UmhCueVr0BzbtiFunhb3KBx2hzt71eO2/EFt1xtlCDUL2UAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 57783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/31.b7e8efe4.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAg0lEQVR42gUAwQqCMHTfHx2Crn1EgZdCGKTVdDNihw4GWoemrpxKSqzce0JQJ/WNbVazwPcSEYUBNRnHShDUokj5fLH0dv4+4ustfd8vWHGCirkm/5i6NxrtgG7E7gHPE4Eixlf6lwd7piBDkEcor1jGBBTDNv/2bWf0aAdwP2gyVGwCmKVoNMc30cAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 81586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/32.ab5bd487.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAd0lEQVR42mO4/P7//huvMsoai5snAFFmWdO+66+AggxXPvzfefGxvp5VUHRWcEy2vqENkAsUZLjy/v+uy08ZgEBLm93MHEjvvPQUKMgAMury0+WuxutDfTZFBqQwMGyH6Lj0/v+h668OV1afa+0Aot3llQfAdgAAm+FJc6KJHiQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 29000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/33.bb73e0ed.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAeElEQVR42mPY+vLGpD0bZh3aBkbbp+3f3L9z7ZJLRxgWXzpiwGDgYe9vomRlresozqDKwMCQ09PKsPza8ZjgaAdbFwMNYwNNYytzOzUG6YoZ/QxAXbZCZtIM0gxIIA+oA2jHxN3rJ+/dOGnvBiCavG8j0I7Flw4DAByoNAzzeeCwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 45005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/34.fca2eff5.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAeUlEQVR42mP4//bCzSPruioLprVWTG0ubynOvHV0HVCQ4f+7i6e3L2ZgkLSS1NJhEGdgYDi1bcH/95dAEud3L9dj0gyxsfMztwBKnNu5GCpxZudSIN9CUNWEUwHIOA3V8fbCjcNrqzMTO8oy20szSpIibh5Z8//tRQDdhEA7xF5a7QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 33284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/35.3dbabb88.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AMf77LfAuJeXibfDwMDQ0cjT1M3d2sX56ADH++ugn5tpTkWlp6qirbGSnaGXp6jI+uoAvfLgRGhqADxLMU9Xj2NjlVlZjnRvvPLhALfw355hX7dOUKhFRp1CRqhITZliYLrx3wC89OKRm5OXj4mSkIpbiINShoNpl5G+9OIJcEmIpHck9gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 92850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/36.66c37c9d.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAhElEQVR42mM4+ef/nINHgmNjE4qK08or7H18p+zad+rvf4Zjf/9v2LFrm4XyVnebrR62mxgYVm/acgwoAZScvmOXOQODha6utaEhAwND/8Ytp/+BJSZs2qrKwOBsby8nwM/AwNC9fhNI4uif/9sPHNqblbKntvJIQ02Dv3fvzj1n/v4HAAsTQYLuGqqnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 42595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/37.cf1ec4d3.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAdElEQVR42mP4//Lsz0fHty6etH5u35qZnYv66z7c2v//9TkGoMS3+0diffzFGbg5GEDg6flt/99eAEs8OFqcFO9lYOahr2/EIvn84vb/b4ASr0A64nwDxBjYmdB0/Hx8fO2srvk9NYv66+d2Vb2/uf//63MAs6lHsok/cyoAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 39781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/38.707fc942.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAhElEQVR42mP4//rc82tHti2bcubQtuuXTj24c+3Ls+v/n59i+P/m/I3T+/ISIles27jj4LG5KzfcvHj8/5tzDP/fXdy9bq6qpXNxCRAWOvkEHNi0+P/bCyCJtfN6GUBAgoFRGkgtndr0//0lBqDkyR2LWipzJ7WVT24rb67MAXL/v70AADeFTDcUP4y7AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 38893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/39.9234ca00.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAdklEQVR42jWMyw6CMBBF+/+/ZYOpdWGCRkjFGKNQHgEG0s60ZUEDYXnvyTnsZJzAoHStodf/7F3cEuu48SwCSeGX58NHTUp0LynQx5Nx487WgzUjjF0/AS1x8gj2VFY06b2U12+q2guFw0D/qOdnBS1iRZRsxgpEeGvloJtxwgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 74105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/4.bdeb7def.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAYklEQVR42hXMwQ0CMRADQK/Xl1OE4EX/bdEDb1Ag5NaANO+J25gNKBiIAJikMVy61uqfWXX8SDqdLwg+KgQSUs+s9YaPMZ5qvVKinTZtlCOT267MCege3NX+/bYhCJDLL9QX4l0sH1vpCHAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 51721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/40.bf4c21ac.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAaklEQVR42iXLMQrCQBCG0W92d0xIBLEIFuL9L+MpBNHGSogYd+cXkvrxLB5Xs/gs/es3pPk+DeH7g6IVAElp962l6470FTWwgkGojON5OuV8KfOT943s6zDMkrtnQxGgdWyiSl2UEzQsgf4nlycptF3uBwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 50046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/41.d0733c56.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/ALPM4JKMcNnQhO7qk87NqsnIq56in63D1QCvxthaRADLuFHUxFrEsErk1FfAtVuhtckA2uz66Ofm6ejk5+fo8O/r8vHr+vjx4u/6AODy//r5+Pb29/z8+/////v7/fz7++j1/wDc7/72+fz0+fz0+Pvz9/rz9/v09/ni8f1i92QPYJihrQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 29473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/42.93ca25aa.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AMT967XSv4ueiZ6zo87St8jBkbHUxsX96wDH/+2IpJFMNQBRV0ByajxNAAB/opPI/+4Awfvoz+Pc09LS19nX0dXT19fa1eriwPrnAL755u/++f/+///////////9+u/99b355wDA+ufg+vHu+fbq+PTs+vbt9e/e+O3A+uhTHV86FYdIJQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 21065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/43.5d45c04d.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAdklEQVR42mP49fjE9wdHfzw4CiIfHgOhR8d/PznJMG9Ca0ZCanFGVnFGdlFWdmFGZpBHwLJpnQwNJQUMDFYCovYMDJYMDBYMLFYMDMp9DRUMs3saw3xDMmLjU6NigSgzLiHMNxSk49eTEz8egcyFIIg1v5+cAABq0kLsB36qqgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 12593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/44.b2b6d628.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/ANbx/6G3zmBmgYaNn7i7wlxliaG30dbx/wDY8/+Op8VzcpCcna3U0dFSVIuLpcrY8/8A0e3/xtbnsrPDvL/P1NXeuLrNx9fr0O3/AMzp/+by/fr49/7+/P7+/f///+z3/8ro/gDR7f/O4Pa4wePu8fX2+fz7/P7k8v7M6f8LsmGGgz0pKAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 40959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/45.ecc014b6.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAf0lEQVR42g3HsQrCMBAG4P8usTUSs4uurs4+gIsvLe7iVvEJCipIoGKtMbmz3/ZRE/V4aK9N9N5xet9vz812tduvrQK1qRZzx1WGzRymXDIAOj90WaeZDj+BiBjSZH37nVgmlCJ9KiE4Y2h8l60OYMOILzld+u6jQhamKkqA/gHBDzhK9nEEjAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 90337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/5.bd2bee33.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/APi/o/myf/fmuv/knuTFe9CRe+Svgv3ZrQD4pY74r0yL7tqo4MuFwadSjoaZdFD1wpYA/Ojc7uLg4O7u2vL62+zy4ufl7uzr/ezeAP305/Hx7vvz7v/27/317vv28ff7/v316QD/793/8eD+8N/98N/+8N7+8OD79/P+8OA/5mVRydiIFgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 48652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/6.0ed344f8.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAaUlEQVR42i2NWw6DMAwEc/+DUW7R8oMqS6QkNmvHSSgPIe3fzmjCC/4RTInfSWYtS+uztwEljFpj5m395YWU07+3uu8nHUZ43OAG42hWvDbt13EZGZDERPlcWvUxBvgE+0JJhSBk5W74AYKJcMqUU6rAAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 91145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/7.8509fe9e.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAY0lEQVR42g3IQRKCQAwEwJkkG/DO/z/lB/yAN7RANhOp6lPzeb63M6sn0DlyXReTXtpjMdvwE5uk92UXCplm0UBDtypJDHfm6EIQrI47SNHcI3XsHIgJwY9qkazG51ukz/H4A5ObMeAJO2/GAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 84055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/8.bb8750e1.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AMT96rvs23eOgIOci77EsLa9o7nt3MX86gDF/uy46NVdUhpbYkahjFaJaACy5tfG/usAw/zpwO/fuLu4uby2srexsra1wO/ewvvpAL755tH77f////Dw9fHw9f///9H87r745QDA+efM+er4//vP3erQ3ev4//vM+evA+ee6n19M60hN4gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 33673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/9.68f88011.png","height":320,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAeklEQVR42i2MvQqDMBhFff+X6Na5a6FLx0KImDab0IK02iRKTCT+4XeN4ng595wkVfQyOF+ZyKS83U+XN6so00h4BDU+RVlpVZTm+/NCI7438DSwrfPODX0Y5ylO/qfDaBrbWgtaFoLQxNWekjUeeWB558PQTRCGUkUrC/Zsl9NiViYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 93151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b1.c4b8fbec.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAYklEQVR42iXDOw7CMBRE0TvPtsJHULP/XdFRUCBBgVIRO/EQJUc6ur9rSWHTexcbsyjy61nbWK/n3BtD4XSMz6MdboO+P18KcwfICYHEOBHCIZfkefHUvIK1swQCk4MIELs/Ko4rgkDWs6EAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 51958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b2.8e636d28.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAZ0lEQVR42h3DsQrCMBSG0e9PclMo2M3Fyfd/Ep+g4CA4OzoYjc29hR44WturJhvh4Q7i6InyuK219eU0p7FNo50vVz3vtsx6999E9gCwjEQKPmzFSjYy4tv5O7VAgogCIRERgiwOAnZB7SZ0aYYjCQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 59298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b3.8b950e3d.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAY0lEQVR42h3BIRbCQAxF0fczKa3A4GH/a6rB4TAICu1MEs7hXr0fq/msDHIYlDuVTeH3dff+uix17t+ljrje9Hly2lRxpE1ZFLgQf9k9IwuaatsZYp5AUgw3gVGFN5ohUQLpB47mLpJDXbmIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 6376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b4.9918f166.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAYUlEQVR42iWHWwoCMRAEuyeTLPi4/8UUPIV+KEs2MtMOWHRDFR/P1zALITIF1lDu7nG/rTnXOB3wr2hj+8we1wvfqTMRQuHEn70cmSAbsR9YxNZhRKScBI0p9QZrYGUd+gGe1ipq1pYGewAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b5.53a86fae.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAa0lEQVR42hXJMQrCQBRF0fs+g06hIFoJrsD9L0UsxUoLsRBiEnHyn+Z2l6N8nL1YS2qtgcAoyvQu1A2rvcHNoX9GorsVm0ycKRRyaAZwCSkCIsbGZJYhmFfX++nSD4fxtR0+tf+6I5/U4+4HxhEudrjTIe4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 95842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b6.59c0a1b8.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAb0lEQVR42iWJywrCMBQFz7kJli6qSNT//xw3gh8gLn3gqiLSmuQeCR0GZjE8fW/rygx4k6KBNgXFzf1xOJ6faTf2w6fr5yG9urTdGy55rMXnXKdfzdWLu6RreRsJM66iSSwFRINAhFpdCoYQsBwBfxbPMw7u3G0iAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 61472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b7.a5de4fdf.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAYklEQVR42g3HQQ6DMBADQHtZQksv/f+remn/UQkRghIb5jb81WOZckiWQMImMMh8f75zU83noTwdKut+Lu314L+2FeimwQhEkOZmZJQSxAxIGMKUuFvsJBQkgGH07rwTlH0BGOswjWlGkvMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 46064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/b8.07613f17.png","height":480,"width":786,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAXUlEQVR42gWAMRYBQRBEf/X0vOUKEve/EQKBWCTA2u0uT/W8KJfudjcIjBR0ro/7/pNi1rorD3E6b7drzlZ9Xj2ObgMjiJAN2zsZqUxBNd9iERqImYER4DI0AAj7D49tLGwA+sxkAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 53057:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://static-cny.howxm.com/_next/static/media/blank-link.5a3a7a90.png","height":1240,"width":2090,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42mP465j2OqD9dsTK87Gnd2Q9bmp6Yjf7McOONwwf7BJizB1sDK3t9Rwt9F211C0MHEI41z9geGcbr8XAx6Co6BOd6hebrigvzMAgw7TuHsN7m3gLPhkGBgZrHT1bIxN2NgYxNQvmdfcZ3tnEm3NJMDAwBOpqBxvoMbAwiKuYMq+7DwBgFyZjOg+woAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 70624:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://static-cny.howxm.com/_next/static/media/entriesEmpty.c408f5f9.png","height":144,"width":144,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEXB+efB+ebB+efB+ebB+ObF++nE++nB+ebB+ObF++nB+ebB+ObE+ujD+uia4seU38PH/OvF++rC+efH/evG/OvE+um99uO69eG69OG59OC28t2v7tis7NWj6M9/1LNHwJVFwJStE/iDAAAAE3RSTlMAACkpKcHBwcHCwsLu7vn5+vr6M441+QAAAEZJREFUeNoNxscBgCAMAMAgERu9RKm6/5RyrwPgwjnBAbiiUkgtsAczhgkX+PR87538TO49z5xRt6bjBiipVpIIDFdrD2Q/kEwEBPR9jwkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 87731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-dark.563a0896.png","height":2572,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAdklEQVR42jXMWw7CIBCFYRYi6ZCISssMtykjmGji/hcl1PT15Du/+iSfKXD/pswe48N59byC0xeMxWNglnVDJdZssFBiCqmwTPW+QwKdaytcc6luHUcLQ40jUeRTman2xrscClW3ho7WyI/WnF43wEWzdJH2Vz+wJhnjnFfyYgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 51500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-light.249043c5.png","height":2572,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAM1BMVEX+/f3+/fz+/Pz9+/r7+/v9+vr9+vn9+fn6+vr5+fn4+fn6+Pf4+Pj39/f29/f29vb09ff6e/SvAAAAMklEQVR42h2JyREAIAjEAM9VQPuvVvCVSUIbVwFqhKmVGi8EurgGCv84xCyfrLTOfrQ+Ke8BeXYbrGkAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 35180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-dark.7b505451.png","height":2572,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAIAAAC6ZnJRAAAAfElEQVR42jWNYQrCMBSD89KuroIn8ZcX8P7HEXVI+7YX18E+8iOEhNjzcf9onq63try6b+5eSsnt/f1ty4Ydq7VKASjDjCkZaQEdAOCFmqB9RRIQDnIPuEytmSKlpCNnoWWL8ZCyJNJGuoYC7L376mYGDHEYRZ3nvX6+6Q8LBEK1hrAt9gAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 92337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-light.1ceeca03.png","height":2572,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAASFBMVEX+/f3+/Pz9/Pz8/Pz9+/r++vr7+/z7+/v9+vr9+vn6+/v6+vv6+vr5+vr5+fn4+fn6+Pf4+Pn4+Pj39/f29vf29vb19fb09fcq2rAYAAAAPUlEQVR42g3ISQKAIAwDwFjUAtVU4/b/n8pxBgc/RhEquMkds53U6mj2KD2GkyodbbpF76iWu8Yv9l7p8QNN/gJpSMiH/AAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 96399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-dark.eaed3cac.png","height":2572,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAh0lEQVR42lXMSw6EIBBFUVaiiVIKKNRPaLVDev+7akx04LBy6zxTaWHO5fjFiM6vFtw0h5jYlKFzw5hIiJRYZ7f4EEWzKWMfYELZmDdEae8+rEhiKnQJIO9fkXf4NGEhkV6CWvBtCvES/S00t3t2jzhsvwIkViJFUueXO5y2a2E/q27lERFJ/kgkIg+SMT4nAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 2623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-light.c81f2379.png","height":2572,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEX9/Pz9/Pv8/Pz++/r7/Pz9+/r7+/z++vn7+/v9+vn5+fn6+Pf4+Pn4+Pj39/f29vb19fX09fe1DsbyAAAAOElEQVR42i3JUQ6AIBDE0HEVHSuo3P+yhA1/zaue2nH4VRFgN5WocBhd29c4TS7C6J7iJRm7/pQBTHkCGJ015iYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 86700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-dark.f7820f1f.png","height":2572,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAIAAABxZ0isAAAAaUlEQVR42kWLwQ3CQAwEd9eJo/zoggcd0H9HIcCFOxsLCWVeo5GG99v1uVwktPfrOD5mIrltj6nte+vydXVfxhiSSeq9ktHnaXbPjEwAGREgFYlROoJgVQAkColQKauVCH/0+2kyAImTL0tkLIUeXhg7AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 30274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-light.a474bf18.png","height":2572,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGBAMAAAAMK8LIAAAAMFBMVEX////9/f3++/v++/r7/Pz8+/v7+/v6+/v7+vr6+vr7+fn5+fn4+Pn4+Pj39/j39/fzyqN8AAAAI0lEQVR42mNY89KtkEF1T/oEBsvfaRMYzG4DCQsQofk7fQIAu5cMeuqwb44AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 44484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-dark.827fc2a3.png","height":2538,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAqElEQVR42g2LSW4CMRAAy54GxpmQ5ZCAkkuUSHwiyYX/vwE4ITiwSCzDjNtufCippFK5/9+/vF6t+GpgGwesW+WxbhBv5l4nU9SUqs/M3ho6VWR/aRdRM5s+UlkiPL9ABjf7/tHUtVTOQSHFHi8DpHKchyGQDQBkVBe3Eh7q82G3RPsrKYP3MAoT5NQ9fYb3Oc4LlhNmiRwv5RxP98PxByICJWjZ9HbkDg7KS2tsFHkyAAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 39767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-light.235ce0f8.png","height":2538,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAfUlEQVR42jWLQQ4CMQwD7aRQ/v9AnsABFbq7bRLSSljywRoPe+9eawXGCZBAucPMwdZaUAQKILLmAcldVMtzgV2keBxwd9DmHCIURAQyi0ZaJXw0n7buC2xOSgLqR2vd13/MDXy3K/rpUOVGZoFHTeMa/mrfCdlCwBwgb/gBCTxFQlbLQrEAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 76603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-dark.43ae6c9a.png","height":2538,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAtUlEQVR42g3OwUrDQBRA0fvevImTEhTRLoobFfEDXEn//zcUBaE7zSIx7UxnXrO4ywtH9u/7Nv588Xgd+J6Fw8npTbFug5mqDNsd/14YUseLdZSSqfWMjfPyeSyFjyWzu4kMFlmmGRWQ16fnc81Hgiqt1rX1iB2iAQsqU0wJRwBAAIfmjmmfpvHvQMkj7g4SEYSrdI9NeXhIt2/0ocO94a0CTiszq3j7a5s7RI0YhFwyIkpZRi78p00xsj9jYwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 45917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-light.64ff441f.png","height":2538,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAh0lEQVR42kWLUQ7CMAxDX9oMuP8BOQIfaEjdljhUGxKWohfLto0xdFsWODbwye5QRaTwiDBJNAptO6qd1to8w1v352l6RxHoCHz+qsJyTmcLpsG4VGVSydGxKpMrKeCEYSaX9dWX+y/8K5XY+7PXthe9gZ0DiCwe94bHUa8xktZBWZNGxqQ5XwAhUlqE0kc4AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 58176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-dark.daeb999c.png","height":2538,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAuElEQVR4nCWOzU5CQQxGT2eGoERFX4DEmGAUdeFKIg/g+29cklz2hN/by9zMlAZWbXq+nK+y+Jlb06z4eIxoDfzvCiKQYiINbpDF/DfvW2VEIRfjdjymEujaA5p75PXts1FVTqUSgaeHO8xA2yPBLTKdTGwQnLjXzZRyrQghusnPs9n78njYUnrFJHqoYiRH1X8YIc/Tb6vmIA6pJSMhYT59cV2HvHz9bdLw/hIIUl0f6XN36e91zRlDKEncklPOuwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 69287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-light.502dccec.png","height":2538,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAhklEQVR4nF1OQQ7DMAzCTrpq/3/gtB9UWrUmTmMP5zguGATI0q4rHvsOWEeoQuqGRAQwfULO8zTVAgEdEYxx54WtVkgWzMZbSxF6C3OyRdaivD3E7x4SviYTHFmINChkWHtVplP8gwuQbxsM8wMWVJNjcT6iGpDjY0c3hztF+gwULqZ+7gU/QnNOIu9aQAIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 43005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-dark.50de255c.png","height":2538,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAjUlEQVR42hXN2wpBURSG0e+fayFbwoXyDu4p7/8kyqG0S6J9WntOXI+LodPhGJfbnf0q8S7i3BkSCJBNyMV5Vss1V6BnZLfbMPpI8/nwM3JdPxJloEUkibp5QzgAMiNPs/URKKIQGOBgBgASubdq0WlGKBFewDL4AAjDyZ63Pq8qlGaIEek/tliaULoXX2RHO1ENmJ+cAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 28949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-light.6a79df6d.png","height":2538,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAa0lEQVR42j2MQQrDMBADR/YmPfT//yw9NMXerArGVAjBwCB9r8vHeeI5oHXoHWxAlIu4yy/PBIQM43MhiYgAQHfmW2LHq3+yCSqHZCGBDWJLCx3D/dloYJDEdvaYGMM1Mykb7dve2+LH0fgBDf0/rAnV2eUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 5622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-dark.0fae49d7.png","height":2572,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAIAAABVpBlvAAAAfElEQVR42iXLWw7CIBBAUbahgoVaKG+GoRgIpvtflqT9vbmHmII2IpafcvDtZ86FLHx7PFmCopTpfcBM4qMo45CPXTvrgvORcCEpE84ntZsxzowH4at80SVjnddUPgARq7yhNv666oQbfQvrolS6tZEAibhgqc3YMGGI8AdDABhSAcjcgQAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 61009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-light.57402a51.png","height":2572,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAARVBMVEX///7+/v78/P38/Pz7/Pz7+/v6+/v6+vv6+vr5+fr5+fn4+fr4+fn4+Pj39/j29/j29/f29vb19vb19fb09fb09fX09PW5Mad2AAAAN0lEQVR42g3HyREAIQgEwGFRcfE+8w9VXl2NlKrsCUblqXDUfBAwZXeL0b1Go4VT8NHPQ21LcnwvXgGhAnXiOgAAAABJRU5ErkJggg==","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 70475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-dark.36c6506b.png","height":2572,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAXVBMVEU4OTs2Nzk1Njg0NjkyMzYyMzUxMjUvMDgvMDMpMzEvLzIrMDYuLzMuLzIuLzEsLzUtLjItLjAsLTAsLS8rLC4qKy4qKy0oKSwnKCsgISUgISQfICQfICMfHyIdHiL9ihfAAAAAP0lEQVR42mPg5GfnZhYWZ5CTFRJkZBVhkJLkERdnFWOQlhLnYgDSMlIconxgvgAHAwuILyHIxAbis4jwsogBAHM9A50YoAF9AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 57045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-light.e2eff27c.png","height":2572,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAATlBMVEX7+/v6+/v6+vr5+fn9/f38/f38/P38/Pz7+/v6+/v6+vv6+vr5+vr4+vr5+fr5+fn4+fr4+Pn4+Pj3+Pj39/j39/f29vf29vb19vf19fZRCN9zAAAABHRSTlP+/v7+ukpK/AAAADtJREFUeNodx1sSgCAIAEAsKhMVxff9Lyrj185CSDkNvuHFTF0u+LBYK0bveQmo9Y/nhZf6oKN2nMRiNlIDAn1bOixfAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 83351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-dark.feef6f72.png","height":2572,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEU2Nzk0NTgzNDczNDYyMzUvMzkxMjUxMjQuMDYvMDIpMzEuLzIuLzEtLjErLTUsLTAsLS8rLC8qKy4qKy0qKi0pKi0oKSwoKSsnKCsmJyokJSgjJCciIyYiIyUfICMeHyMeHyIcHSFZsKbRAAAASElEQVR42h3I2xZAIBAF0EOjcReZign5/5+0lv240bdzQ6KC91q5Itlw6xQ8JcGTkwGHHUUHN/6jSw0bPUo+2HAUlNO6jpL/AJfSBEDY1hvSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 48923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-light.a882450f.png","height":2572,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEX9/f38/f38/P38/Pz7+/v6+/v6+vv6+vr4+vr5+fn4+fn4+Pn4+Pj3+Pn3+Pj39/f29/f29vf29va0h4POAAAAPElEQVR42iXJQQ6AIAwEwNWWInSxyv8fSwm3SQbP8BFVOiCNQTXc4lqoikuMf09AvDYexMxNFL6nvl22AERWAdbVOrinAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 27959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-dark.648c4293.png","height":2572,"width":3156,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAIAAAC6O5sJAAAAc0lEQVR42iXNURLDIAgEUFhR40n6197/YE0aq2zRvmGWGT5YfbyeVQ8nj5rv6/25O8nWWjqsAQ5lUknJVIWUUjJgUF0zxqTQncGnQ2JtpVYRlU0BkGJmOducQ/c9ElhPtPdvTClFKOGfID2qwnlelG318wcfrD3XkOGi0QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 57188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-light.4c491ef3.png","height":2572,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAM1BMVEX9/f79/f37+/z7+/v6+/v5+/v6+vv6+vr5+vr5+fr5+fn4+fr4+fn4+Pn4+Pj29vf29vZ21InaAAAAMElEQVR42hXIyQ0AIAwDsEA4Q1vYf1rUn2X0s69qDaBt+aRQuMKZGJbwnBcJDMlJ+yZpAWs8mL6yAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 31027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-dark.eb551476.png","height":896,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAfElEQVR4nBWMMQvCQBSDv3f27uqiKNLNoeDi5qLg4i/w/49uOolDLbQ9vXs+Q0JCApHj6azdu2ccE6UUcs78EUIweaRpNoX0xM1Aiy3OpEbLfr5Gdoer1quWKi6s/CKuIqfe3DO8bki7vzzicmv3Sh0Doplh+tijZ+ru/ADOCCzeUNSTzQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 11619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-light.d41ffd7a.png","height":896,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAZUlEQVR4nD2LOw7CMBQEZ/0pyCGouP+daKBAokE4Fvbzw4mibDWr3VEpxXPOSCKEwJaNezd+rSGzMWbHj2HiGfeBXu/q92clRZGSGMP34+fbuV0XtNb2KKuhIMxsahBjmDYsl8gf1RYrfDecudUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 97201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-dark.2571e916.png","height":896,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAWklEQVR42gWAQQ6CMBBF35+2GkFjYlwaL6Dc/0psCIENpdCBqPv/fJ56tnWgOugALCA5t/uXOOaH0vNDc2nxWjBL+L6AAjWPxGvzGlL7liwSTEiirBkLiYIfJ0i4HbMc3yjUAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 75010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-light.7a48532d.png","height":896,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAATklEQVR4nFWKMQ6AMAwD7bRdAPH/RzKgqqoggYSsWPItdzRVr60CYP4/MwX70JiXQwQQEpFCslVzbEsFz34fY74UYUR4AihFwh7nvrb4AOvII5lcCwQmAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 15164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-dark.dcd3cbaf.png","height":896,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAYUlEQVR4nA3LQQqDMBRF0fvyiUVpN1DoqHRQBBfgDtz/MhRBHUiiJmZ8OGrbf1qXkTNMZCogghrIB/XzjT6/PpuvMd+QroCsKraDM1Lc0LcbJnu8JOcxlexEDKG459jnfAMgSx5jB+XE8QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 83444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-light.d92ed746.png","height":896,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAR0lEQVR4nFWKwQqAMAxDE7uh//+dXmR4cC2N1YNgQhIIj+4zW2sAWPkrwsFxujyETMGM30JA7wSPMffLk6oDVY/NlhfcVtMNojYlo0ZajikAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 18282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-dark.aff5b1b8.png","height":896,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQ0lEQVR4nA3IsRGAIBBFwffhJLEII8cxsAj7L4cEFD0u2pnVflze+ouT8X+AMniIWExoO+9qZY0vUR9KxngaKYe9MgGjEhLrAAfZ+wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 49480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-light.14842191.png","height":896,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOElEQVR4nCXJORIAIQwDQdm78P+vUhBwWhhQoA5GahtUVZyJAOTTH2YLkkrPYxI03uDg/zy6MSg2/u8WxVZd6j8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 48113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-dark.f30ce90e.png","height":2182,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAsElEQVR42k3Bu4rCQBiA0W92/2TZi7DVWqRbrC0ECyFo4dPZaudL+BDWgpcgWGghiigKiaImk3HGSvEcFdbKq5tlYezPOokPnlLK+d9fSk5SCdJLEswGPR6KBEjht8ioP6HbadMI6+j0yDxNkN24tQSYRlXeM0OeJQz1HlULm9tTvCOKJrySq/z/naVAqZThex7OWt4+fMToM+66QWuNzm845/hEIblODzaLeVJgjOEOCLlPVPsd+zEAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 79420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1200px-light.841cdd1e.png","height":2182,"width":1772,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAAiUlEQVR42iXJyw3CMBAFQPffBwcog1KMBJLlhCTYu/H+HpAc5jSJmZ68852ILwjc3P1KzLc0vRmtKyICagbzgAxFerwatiaAKax1eFtQaUYCIv+5SA6iHH3LtU85tdaLqJYADv4TjpLKRFg2gajDLA5DFGled/DuUIvTEYa0fkYd4tU8qtpJ1OoXmym4n9uTBvUAAAAASUVORK5CYII=","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 78629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-dark.ffe7c309.png","height":2182,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA4UlEQVR42k3DsUrDQACA4f+SizE1tF20ULq06NBXEKmgT6DgAwlO4rs4ObsouBV8AMVUMFJtbCTN5XK5a8d+8InJ6dmnUWmy/Es/StMLrKlcrWv8wCNqt4U4HA2cvz/BmYr5+z0ZPdCKVtThqNtBLoqQ8bjP88MTtzfXXF1cossSF2he0i9kNxZJ+noHwHQ6QJqGplRo75/HfIE4Pjn/zrI5RZ6RzGZsiwG5kqMDE/fxmjeGw4BwJwJnsZv+boi0RmOLFKt+wMFKKQCcc7R8iazr6rfRS5zJEf4eYAEBgDENa5d9arlXWDjcAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 82872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1440px-light.bddce712.png","height":2182,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAApElEQVR42lXOSwrCMBgE4Nz/Hi7qQTxIBIWYatG8/ueYCi66+JjFMDChlHojHheicVLVs7svABYzW2pr5yCiyK8BFsMsIaqwmWoGYUGoXXG9f0BiwF6WAi8V8nng1lYEd4uAT4gmEr33iNaj1i2m+oxhfkjEnAAkd08O/NgEQwppbdjePEcKUYdO/6T9w7oN9KFg2YsjYkXY3pSJLat5Fj1i0fwFTVr2obFRVQ4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-dark.ca1e99fd.png","height":2182,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAqElEQVR42l3CTasBYRiA4fs5Zo46c5AVKRvjL5CPpWRhbeVfWtvbWFMSRaRIPmfGO2/zsHZ1SaPZ2IZBsAlD+1wsZj98kbJf04LfYjoeMRzU6XW72NgiErM3EY4rz3N0mCjJmux/h2I+j30ZVAK2YYzU2/3L8XQU4jvr1Zwv6kSpUs7JeJjriopfxfvzQPUzQVwXx5rHzVyWJNEOTWW43u6AoKqk07+8AZ2NTCXJyGJ0AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 66425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1680px-light.e0967264.png","height":2182,"width":2728,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAe0lEQVR42kXBQQrCQBBE0V/do+NW8P53cykBQYXEJDMpdRF8T+M0DRlxzcxXRKTBkvhp84rW1j3cZy7nyiGhLw0J7MYoUGv95q9SEvcOy4wMfXszhNHzNd5rPVIyQIDETt2UedXZmFM1EQLMbts2yqHE41RDmcIG+JPwB47JPlMMgaMDAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 92893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-dark.637cab18.png","height":2182,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAmUlEQVR4nGM0MbN+++Mv17PPb+78fvjwPiMDGmCU1XD4LyYuz3D24EKG6f0TGDTV1Rh+/fjJwMD0g+HOn58MjHr6ho8/vbv7/9Hb/wyhbi4M4sLCDH9//Wb4x/id4fa/XwyMBvZJ/798/sjw78tDhnu3zgANRQAxIGTUtIz5/P39fYa/354wsLKwMzAxAZ3xH4T+MTCxsjIAANwMPR1UqqlvAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 13904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/1920px-light.e5a014bd.png","height":2182,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAcUlEQVR4nF2MzQ7CMAyDndGt3Qnx/q8HN/4EYl3XpSaBnfYpcazIskx5vpFyGVNfCYiPmDqtKqQU5SdXnI4RrBVcV4+gcca9M1eW5Tz0gbQnVAFzvoRisivXR2aKAXE4bNU/+eOB56u8xxTQWd0esuEL96s6NOtwS7EAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 48532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-dark.cfcf51d1.png","height":1280,"width":1120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAh0lEQVR42nXNQQ6CQBQD0P4/A2iIegc04Qh6dI/lQhMC/FYYYljZVZOXpuhuveFPCnTX/kLyPs1jJLqd2jOigvKKwXhIenImUtsg2oTx9YavKGpxQnNMdsgRx8zxM7AszWCAADfHGAnDBGRDQWm7t+SmBcQBual/SJCB0gGYOyqvt8892puEL37FQvmpqPavAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 84876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-light.78e21333.png","height":1280,"width":1120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAbUlEQVR42n3JQQ7CMBBD0XIB7pTC/U9TmmRsjxlSiR18yfLibQBv279A3kk9bDdJ7TjO9uqjLST5BGmnTcnnGI6AFwLYWVgBojpCUuqLlFzp8yPCqr+Q3Ek5M1V5zjDACyXtBa4W9jHXfuKYkW8OIp+NMbuSlwAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 11403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-end-dark.21803e17.png","height":104,"width":273,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADBAMAAABc5lN7AAAAGFBMVEU3O0IlJywgISYbHCAaGx8ZGx8ZGh4YGRyrGVzVAAAAFUlEQVR42mMQTgkNZWAqARLCKaGhABhKA2NIbhgbAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 32636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-end-light.41d453b6.png","height":104,"width":273,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADBAMAAABc5lN7AAAAFVBMVEX////+/v79/f38/f36+vr5+fnw8PCTIX0XAAAAFUlEQVR42mNwZBQUZEhiAIJgJSUlAAq7AYANyVZ/AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 57914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-repeat-dark.32974a93.png","height":104,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFAgMAAAAF/0XGAAAACVBMVEU4O0IyNToZGh1igCcZAAAAFElEQVR42mNYtYohNJQBCIDkqlUAHfED/R04RzwAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 76422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-repeat-light.9cf789ac.png","height":104,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAAAAABd+vKJAAAAGklEQVR42mP4DwUMn6GA4T0UMHyBAoY/UAAAZLYmibEXm1EAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 88581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-start-dark.10d4a1ef.png","height":104,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAIUlEQVR42mPwUlMN9tbk1lSQEZOTkVPQ0TPWMzDVNTAFADNjBA1cjWuAAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});

/***/ }),

/***/ 88353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"https://static-cny.howxm.com/_next/static/media/browser-start-light.746b7a0f.png","height":104,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAKElEQVR4nA3DQQ4AEAxE0V8kVu5/VB0Jo4sXN7fPS8Zc9GjYRhIGonwemg3jmkvTygAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});

/***/ }),

/***/ 31167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCheckHideBranding; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59845);
/* harmony import */ var components_business__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91404);
/* harmony import */ var react_abac__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8470);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22108);






function useCheckHideBranding() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("permission").t;
    var checkFeature = (0,components_business__WEBPACK_IMPORTED_MODULE_3__/* .useCheckFeature */ .xu)();
    var userHasPermissions = (0,react_abac__WEBPACK_IMPORTED_MODULE_4__/* .useAbac */ .nn)().userHasPermissions;
    var editable = userHasPermissions(types_domain__WEBPACK_IMPORTED_MODULE_2__/* .Permission.AccountAccountManage */ .y3$.AccountAccountManage);
    var canUseHideBranding = checkFeature(types_domain__WEBPACK_IMPORTED_MODULE_2__/* .Feature.HideBranding */ .L0B.HideBranding);
    if (!editable) {
        return {
            disabled: true,
            disabledTip: t("actions.disabledModificationByPermission")
        };
    }
    var disabled = !canUseHideBranding;
    var disabledTip = disabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_business__WEBPACK_IMPORTED_MODULE_3__/* .FeatureTip */ .i0, {
        feature: types_domain__WEBPACK_IMPORTED_MODULE_2__/* .Feature.HideBranding */ .L0B.HideBranding
    }) : undefined;
    return {
        disabled: disabled,
        disabledTip: disabledTip
    };
}


/***/ }),

/***/ 99766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56674);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77292);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51529);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39144);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74078);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(51846);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(21314);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96747);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(51066);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(58382);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55075);
/* harmony import */ var components_business__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91404);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33892);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22108);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29718);
/* harmony import */ var components_business_Campaign_hooks_useCampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84818);
/* harmony import */ var components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51945);
/* harmony import */ var utils_applicationUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13090);
/* harmony import */ var components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88392);
/* harmony import */ var config_constants_campaignPathMapping__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68749);















var ActionMenus = function(props) {
    var ref;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .useMantineTheme */ .rZ)();
    var campaign = props.campaign, onRefresh = props.onRefresh, onDelete = props.onDelete, onChange = props.onChange;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("componentCampaignList").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var appId = router.query.appId;
    var ref1 = (0,components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(campaign.id), cachedCampaign = ref1.campaign;
    var ref2 = (0,components_business__WEBPACK_IMPORTED_MODULE_4__/* .useCampaignPermission */ .L9)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.id), editable = ref2.editable, deletable = ref2.deletable, groupManageable = ref2.groupManageable;
    var ref3 = (0,components_business__WEBPACK_IMPORTED_MODULE_4__/* .useCampaignStatusSwitch */ .wf)(campaign), toggleCampaignStatus = ref3.toggle;
    var ref4 = (0,components_business_Campaign_hooks_useCampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(campaign.id), toggleCampaignFormStatus = ref4.toggle;
    var application = (0,components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().application;
    var isLinkApplication = (0,utils_applicationUtils__WEBPACK_IMPORTED_MODULE_10__/* .isLinkDistribution */ .dQ)(application);
    var openDuplicationModal = (0,components_business__WEBPACK_IMPORTED_MODULE_4__/* .useDuplicateCampaignModal */ .EC)(campaign);
    var openEditGroupsModal = (0,components_business__WEBPACK_IMPORTED_MODULE_4__/* .useEditCampaignGroupsModal */ .YJ)(campaign);
    var deleteCampaign = (0,components_business__WEBPACK_IMPORTED_MODULE_4__/* .useDeleteCampaign */ .zT)(appId, campaign, function() {
        onDelete === null || onDelete === void 0 ? void 0 : onDelete();
    }).deleteCampaign;
    var campaignTypeName = t("common:campaignTypeName.".concat(campaign.type));
    var openModal = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useDeleteModal */ .m6)("".concat(t("common:actions.delete")).concat(campaignTypeName), "".concat(t("componentCampaignList:delete.confirmContent", {
        campaignType: campaignTypeName
    })), deleteCampaign).openModal;
    var handleEdit = function() {
        router.push({
            pathname: config_constants_campaignPathMapping__WEBPACK_IMPORTED_MODULE_12__/* .editPathMapping */ .$[campaign.type],
            query: {
                appId: appId,
                campaignId: campaign.id
            }
        });
    };
    var handleSwitch = function() {
        isLinkApplication ? toggleCampaignFormStatus(onChange) : toggleCampaignStatus(onChange);
    };
    var handleDelete = openModal;
    var handleDuplication = function() {
        openDuplicationModal(function(targetAppId) {
            return targetAppId == appId && (onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh());
        });
    };
    var handleCopyId = function() {
        components_ui__WEBPACK_IMPORTED_MODULE_7__/* .message.successMsg */ .yw.successMsg(t("list.action.copyId.success", {
            campaignTypeName: t(campaign.type)
        }));
    };
    var handleEditGroup = function() {
        openEditGroupsModal(function() {
            return onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
        });
    };
    var statusActionMenuEnabled = isLinkApplication ? cachedCampaign === null || cachedCampaign === void 0 ? void 0 : cachedCampaign.urlEnabled : cachedCampaign === null || cachedCampaign === void 0 ? void 0 : cachedCampaign.enabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            editable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    size: 14,
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                }),
                onClick: handleEdit,
                children: [
                    t("common:actions.edit"),
                    campaignTypeName
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    size: 14,
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                }),
                component: components_ui__WEBPACK_IMPORTED_MODULE_7__/* .NextLink */ .pt,
                href: {
                    pathname: config_constants_campaignPathMapping__WEBPACK_IMPORTED_MODULE_12__/* .entriesPathMapping */ .Z[campaign.type],
                    query: {
                        appId: appId,
                        campaignId: campaign.id
                    }
                },
                children: t("list.action.view")
            }),
            editable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    size: 14,
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                }),
                onClick: handleDuplication,
                closeMenuOnClick: true,
                children: [
                    t("common:actions.duplicate"),
                    campaignTypeName
                ]
            }),
            groupManageable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    size: 14,
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                }),
                onClick: handleEditGroup,
                closeMenuOnClick: true,
                children: t("list.action.editGroup")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .CopyButton */ .q, {
                value: campaign.id,
                children: function(param) {
                    var copy = param.copy;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            size: 14,
                            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                        }),
                        onClick: function() {
                            copy();
                            handleCopyId();
                        },
                        closeMenuOnClick: true,
                        children: t("list.action.copyId.title", {
                            campaignTypeName: campaignTypeName
                        })
                    });
                }
            }),
            editable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Divider */ .v.Divider, {
                        my: "xs",
                        mx: "-xs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                        icon: statusActionMenuEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            size: 14,
                            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            size: 14,
                            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme)
                        }),
                        onClick: handleSwitch,
                        children: t("list.action.switch.".concat(statusActionMenuEnabled ? "turnOff" : "turnOn"))
                    })
                ]
            }),
            deletable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Divider */ .v.Divider, {
                        my: "xs",
                        mx: "-xs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Menu.Item */ .v.Item, {
                        color: "red",
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            size: 14,
                            color: "red"
                        }),
                        onClick: handleDelete,
                        children: t("common:actions.delete")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActionMenus);


/***/ }),

/***/ 27443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17474);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73268);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14661);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31463);
/* harmony import */ var components_business_Layouts_ApplicationLayout_ApplicationContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89863);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54594);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59845);
/* harmony import */ var utils_applicationUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13090);








var _obj;
var VideoLink = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_4__/* .CampaignType.Survey */ .mL.Survey, "https://static.howxm.com/survey.mp4"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_4__/* .CampaignType.Feedback */ .mL.Feedback, "https://static.howxm.com/feedback.mp4"), _obj);
var BlankDesktopCampaigns = function(props) {
    var ref;
    var type = props.type, title = props.title, description = props.description;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .useMantineTheme */ .rZ)();
    var application = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(components_business_Layouts_ApplicationLayout_ApplicationContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).application;
    var isLinkApplication = (0,utils_applicationUtils__WEBPACK_IMPORTED_MODULE_5__/* .isLinkDistribution */ .dQ)(application);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .K, {
        pt: 136,
        spacing: 0,
        align: "center",
        className: "flex-1",
        justify: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Title */ .D, {
                order: 2,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .K, {
                spacing: "xs",
                mt: "md",
                children: description.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.7", theme),
                        ta: "left",
                        className: "w-[520px] text-center",
                        children: item
                    }, index);
                })
            }),
            isLinkApplication && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                mt: "xl",
                mb: "xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Image */ .E, {
                    src: (ref = (__webpack_require__(53057)/* ["default"] */ .Z)) === null || ref === void 0 ? void 0 : ref.src,
                    width: 520,
                    height: 320
                })
            }),
            !isLinkApplication && type !== types_domain__WEBPACK_IMPORTED_MODULE_4__/* .CampaignType.Notification */ .mL.Notification && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                mt: "xl",
                mb: "xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                    width: 520,
                    height: 320,
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    src: VideoLink[type],
                    className: "rounded-md"
                })
            }),
            props.children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlankDesktopCampaigns);


/***/ }),

/***/ 39624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eu": function() { return /* reexport */ CampaignProvider; },
  "yQ": function() { return /* reexport */ useCampaign; }
});

// UNUSED EXPORTS: useCampaignActions

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/noop.js
var noop = __webpack_require__(77047);
;// CONCATENATED MODULE: ./src/components/business/Campaign/CampaignContext/CampaignContext.ts


var CampaignContext = (0,react.createContext)({
    campaign: null,
    campaignTypeName: ""
});
var CampaignContext_CampaignActionContext = (0,react.createContext)({
    setEntriesCount: noop/* default */.Z,
    setEnabled: noop/* default */.Z
});

;// CONCATENATED MODULE: ./src/components/business/Campaign/CampaignContext/useCampagin.ts


function useCampaign() {
    var context = (0,react.useContext)(CampaignContext);
    if (context === undefined) {
        throw new Error("useCampaign must be used within a CampaignProvider");
    }
    return context;
}
function useCampaignActions() {
    var context = useContext(CampaignActionContext);
    if (context === undefined) {
        throw new Error("useCampaignActions must be used within a CampaignProvider");
    }
    return context;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
;// CONCATENATED MODULE: ./src/components/business/Campaign/CampaignContext/CampaignProvider.tsx



function CampaignProvider(props) {
    var defaultValue = props.defaultValue, actions = props.actions, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignContext_CampaignActionContext.Provider, {
        value: actions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignContext.Provider, {
            value: defaultValue,
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/CampaignContext/index.ts




/***/ }),

/***/ 20395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var react_abac__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8470);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59845);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77759);
/* harmony import */ var components_business_hooks_useApplicationRoleCache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86851);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54574);
/* harmony import */ var components_ui_StatusBadge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39891);
/* harmony import */ var components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88392);
/* harmony import */ var components_business_Campaign_hooks_useCampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84818);











var CampaignFormStatusSwitch = function(param) {
    var id = param.id;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("componentCampaignList").t;
    var user = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().user;
    var userHasPermissions = (0,react_abac__WEBPACK_IMPORTED_MODULE_3__/* .useAbac */ .nn)().userHasPermissions;
    var applicationRole = (0,components_business_hooks_useApplicationRoleCache__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().applicationRole;
    var toggle = (0,components_business_Campaign_hooks_useCampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(id).toggle;
    var campaign = (0,components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(id).campaign;
    if (!campaign) {
        return null;
    }
    var editable = (campaign.creator.id === (user === null || user === void 0 ? void 0 : user.id) || userHasPermissions(types_domain__WEBPACK_IMPORTED_MODULE_4__/* .ApplicationPermission.CampaignUpdate */ .eC6.CampaignUpdate)) && (applicationRole === null || applicationRole === void 0 ? void 0 : applicationRole.type) !== types_domain__WEBPACK_IMPORTED_MODULE_4__/* .ApplicationRoleType.ApplicationReader */ .rrC.ApplicationReader;
    var handleChange = function() {
        toggle().then();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: editable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Switch */ .r, {
            id: campaign.id,
            className: "form-status-switch",
            checked: campaign.urlEnabled,
            onLabel: t("deliveryUrl.on"),
            offLabel: t("deliveryUrl.off"),
            size: "lg",
            display: "flex",
            color: "teal.6",
            onChange: handleChange
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui_StatusBadge__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            value: campaign.urlEnabled,
            onText: t("deliveryUrl.on"),
            offText: t("deliveryUrl.off")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CampaignFormStatusSwitch);


/***/ }),

/***/ 96780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81533);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73268);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14661);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97684);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(79965);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(77292);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(34054);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(36507);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68885);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18451);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24346);
/* harmony import */ var react_abac__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8470);
/* harmony import */ var utils_getXFormUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6371);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29718);
/* harmony import */ var _hooks_useCampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84818);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77759);
/* harmony import */ var components_business_hooks_useApplicationRoleCache__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86851);
/* harmony import */ var components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88392);
/* harmony import */ var components_business_Campaign_CampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20395);

















var sanitizeFileName = function(name) {
    return name.replace(/[\\/:*?"<>|]/g, "_").slice(0, 80) || "问卷";
};
var downloadQrCodeAsPng = function(url, fileName) {
    var container = document.createElement("div");
    var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_5__.createRoot)(container);
    (0,react_dom__WEBPACK_IMPORTED_MODULE_4__.flushSync)(function() {
        root.render(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_3__/* .QRCodeCanvas */ .Qd, {
            value: url,
            size: 1024,
            bgColor: "#FFFFFF",
            fgColor: "#000000",
            level: "M",
            includeMargin: true
        }));
    });
    var canvas = container.querySelector("canvas");
    if (!canvas) {
        root.unmount();
        return;
    }
    canvas.toBlob(function(blob) {
        if (blob) {
            var objectUrl = URL.createObjectURL(blob);
            var link = document.createElement("a");
            link.download = fileName;
            link.href = objectUrl;
            link.click();
            URL.revokeObjectURL(objectUrl);
        }
        root.unmount();
    }, "image/png");
};
var Content = function(param) {
    var id = param.id, close = param.close;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("componentCampaignList").t;
    var user = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().user;
    var userHasPermissions = (0,react_abac__WEBPACK_IMPORTED_MODULE_6__/* .useAbac */ .nn)().userHasPermissions;
    var applicationRole = (0,components_business_hooks_useApplicationRoleCache__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().applicationRole;
    var ref = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_14__/* .useClickOutside */ .O)(function() {
        return close === null || close === void 0 ? void 0 : close();
    });
    var toggle = (0,_hooks_useCampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(id).toggle;
    var campaign = (0,components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(id).campaign;
    if (!campaign) {
        return null;
    }
    var url = (0,utils_getXFormUrl__WEBPACK_IMPORTED_MODULE_7__/* .getXFormUrl */ .t)(campaign.token, campaign.type, true);
    var handleOpen = function() {
        window.open(url, "_blank");
    };
    var handleCopied = function() {
        components_ui__WEBPACK_IMPORTED_MODULE_8__/* .message.successMsg */ .yw.successMsg(t("common:message.linkCopySuccess"));
    };
    var handleDownload = function() {
        downloadQrCodeAsPng(url, "".concat(sanitizeFileName(campaign.name), "-二维码.png"));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Group */ .Z, {
                position: "apart",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Title */ .D, {
                        order: 4,
                        children: t("deliveryUrl.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_business_Campaign_CampaignFormStatusSwitch__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        id: campaign.id
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .Text */ .x, {
                children: t("deliveryUrl.desc")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Group */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Box */ .x, {
                        onClick: handleDownload,
                        sx: {
                            position: "relative",
                            cursor: "pointer",
                            "& .qr-download-overlay": {
                                opacity: 0,
                                transition: "opacity 150ms"
                            },
                            "&:hover .qr-download-overlay": {
                                opacity: 1
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_20__/* .Paper */ .X, {
                                p: "xs",
                                withBorder: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_3__/* .QRCodeSVG */ .tv, {
                                    value: url,
                                    size: 100,
                                    display: "block"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                                className: "qr-download-overlay",
                                spacing: 4,
                                align: "center",
                                justify: "center",
                                sx: function(theme) {
                                    return {
                                        position: "absolute",
                                        inset: 0,
                                        background: "rgba(0, 0, 0, 0.5)",
                                        borderRadius: theme.radius.sm,
                                        color: theme.white
                                    };
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        size: 20,
                                        stroke: 1.5
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_18__/* .Text */ .x, {
                                        size: "xs",
                                        weight: 500,
                                        color: "white",
                                        children: t("deliveryUrl.download")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Stack */ .K, {
                        className: "grow",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_22__/* .TextInput */ .o, {
                                value: url,
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Group */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_23__/* .CopyButton */ .q, {
                                        value: url,
                                        children: function(param) {
                                            var copy = param.copy;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_24__/* .Button */ .z, {
                                                onClick: function() {
                                                    copy();
                                                    handleCopied();
                                                },
                                                children: t("deliveryUrl.copy")
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_24__/* .Button */ .z, {
                                        variant: "default",
                                        onClick: handleOpen,
                                        children: t("deliveryUrl.open")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content);


/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25328);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36078);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12667);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4502);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57155);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34054);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68711);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62844);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55075);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92295);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);









var Content = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96780));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96780)
            ];
        }
    }
});
var DeliveryUrl = function(param) {
    var id = param.id, _size = param.size, size = _size === void 0 ? 18 : _size, _showText = param.showText, showText = _showText === void 0 ? false : _showText, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("componentCampaignList").t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useDisclosure */ .q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useDisclosure */ .q)(false), 2), tooltipOpened = ref2[0], ref3 = ref2[1], tooltipClose = ref3.close, tooltipOpen = ref3.open;
    (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useWindowEvent */ .s)("resize", close);
    var handleClick = function(event) {
        event.stopPropagation();
        open();
        tooltipClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Popover */ .J, {
        width: 400,
        position: "bottom-end",
        shadow: "md",
        withinPortal: true,
        opened: opened,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Popover.Target */ .J.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Tooltip */ .u, {
                    label: t("deliveryUrl.title"),
                    opened: tooltipOpened,
                    withArrow: true,
                    withinPortal: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                        compact: compact,
                        c: "dimmed",
                        onClick: handleClick,
                        onMouseEnter: tooltipOpen,
                        onMouseLeave: tooltipClose,
                        variant: "subtle",
                        sx: function(theme) {
                            return {
                                "&:hover": {
                                    backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getBackgroundColor */ .dF)("gray.1", theme)
                                }
                            };
                        },
                        leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            size: size,
                            stroke: 1.5
                        }),
                        px: compact ? 0 : "sm",
                        children: showText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .x, {
                            children: t("deliveryUrl.shortname")
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Popover.Dropdown */ .J.Dropdown, {
                p: "lg",
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {
                    id: id,
                    close: close
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DeliveryUrl);


/***/ }),

/***/ 89421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25328);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4502);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57155);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34054);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68711);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36078);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12667);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29718);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55075);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92295);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);









var ReviewContent = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8067), __webpack_require__.e(4664)]).then(__webpack_require__.bind(__webpack_require__, 93906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93906)
            ];
        }
    }
});
var DistributionReview = function(param) {
    var id = param.id, _showText = param.showText, showText = _showText === void 0 ? false : _showText, _compact = param.compact, compact = _compact === void 0 ? false : _compact;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("componentCampaignDistribution").t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useDisclosure */ .q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useDisclosure */ .q)(false), 2), tooltipOpened = ref2[0], ref3 = ref2[1], tooltipClose = ref3.close, tooltipOpen = ref3.open;
    (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useWindowEvent */ .s)("resize", close);
    var handleClick = function(event) {
        event.stopPropagation();
        open();
        tooltipClose();
    };
    var handleContentClick = function(event) {
        event.stopPropagation();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Popover */ .J, {
        width: 400,
        position: "bottom-end",
        shadow: "md",
        withinPortal: true,
        opened: opened,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Popover.Target */ .J.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Tooltip */ .u, {
                    label: t("name"),
                    opened: tooltipOpened,
                    withArrow: true,
                    withinPortal: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .z, {
                        c: "dimmed",
                        compact: compact,
                        onClick: handleClick,
                        onMouseEnter: tooltipOpen,
                        onMouseLeave: tooltipClose,
                        variant: "subtle",
                        sx: function(theme) {
                            return {
                                "&:hover": {
                                    backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBackgroundColor */ .dF)("gray.1", theme)
                                }
                            };
                        },
                        leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                            name: "cursorBox",
                            className: "mr-0"
                        }),
                        px: compact ? 0 : "sm",
                        children: showText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .x, {
                            children: t("shortname")
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Popover.Dropdown */ .J.Dropdown, {
                p: 0,
                pb: "sm",
                onClick: handleContentClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewContent, {
                    id: id,
                    close: close
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DistributionReview);


/***/ }),

/***/ 16426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qj": function() { return /* reexport */ EntriesProvider; },
  "Di": function() { return /* reexport */ useEntries; },
  "fz": function() { return /* reexport */ useEntriesActions; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/noop.js
var noop = __webpack_require__(77047);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/EntriesContext/EntriesContext.ts


var EntriesContext = (0,react.createContext)({
    hiddenColumns: [],
    columnVisibility: {},
    columnOrder: [],
    formFields: [],
    columns: [],
    rowSelection: {},
    selectedRowsCount: 0
});
var EntriesActionContext = (0,react.createContext)({
    onHiddenColumnChange: noop/* default */.Z,
    onColumnOrderChange: noop/* default */.Z,
    onRowSelectionChange: noop/* default */.Z
});

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/EntriesContext/useEntries.ts


function useEntries() {
    var context = (0,react.useContext)(EntriesContext);
    if (context === undefined) {
        throw new Error("useEntries must be used within a EntriesProvider");
    }
    return context;
}
function useEntriesActions() {
    var context = (0,react.useContext)(EntriesActionContext);
    if (context === undefined) {
        throw new Error("useEntriesActions must be used within a EntriesProvider");
    }
    return context;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/EntriesContext/EntriesProvider.tsx



function EntriesProvider(props) {
    var defaultValue = props.defaultValue, actions = props.actions, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EntriesActionContext.Provider, {
        value: actions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntriesContext.Provider, {
            value: defaultValue,
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/EntriesContext/index.ts




/***/ }),

/***/ 7507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25328);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31463);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68711);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95660);





var CsatFieldCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    if (!renderedCellValue) return null;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.split(config_constants__WEBPACK_IMPORTED_MODULE_2__/* .splitCharCode */ .Hr), 2), score = ref[0], label = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
        spacing: "xs",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                width: 20,
                height: 20,
                src: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .csatImages */ .Ni[score - 1].src,
                alt: label !== null && label !== void 0 ? label : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CsatFieldCell);


/***/ }),

/***/ 84157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91004);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68711);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47852);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);





var NumericCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(renderedCellValue)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Center */ .M, {
        sx: function(theme) {
            return {
                width: 24,
                height: 24,
                background: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBackgroundColor */ .dF)("gray.1", theme),
                borderRadius: theme.radius.sm
            };
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
            children: renderedCellValue
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NumericCell);


/***/ }),

/***/ 45718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33148);


var RatingCell = function(props) {
    var max = props.max, renderedCellValue = props.renderedCellValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .Rating */ .i, {
        count: max !== null && max !== void 0 ? max : 5,
        value: renderedCellValue
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RatingCell);


/***/ }),

/***/ 82293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55075);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91004);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68711);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95660);





var SelectableFieldCell = function(props) {
    var ref, ref1;
    var renderedCellValue = props.renderedCellValue, allowWrap = props.allowWrap, _choiceHeight = props.choiceHeight, choiceHeight = _choiceHeight === void 0 ? 24 : _choiceHeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
        noWrap: !allowWrap,
        spacing: "xs",
        children: (ref1 = (ref = renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.split(config_constants__WEBPACK_IMPORTED_MODULE_3__/* .splitCharCode */ .Hr)) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return item;
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M, {
                sx: function(theme) {
                    return {
                        height: choiceHeight,
                        background: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__/* .getBackgroundColor */ .dF)("gray.1", theme),
                        borderRadius: theme.radius.sm,
                        paddingLeft: theme.spacing.sm,
                        paddingRight: theme.spacing.sm
                    };
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                    children: item
                })
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectableFieldCell);


/***/ }),

/***/ 1134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ entryResolver; },
  "l": function() { return /* binding */ formFieldResolver; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/forIn.js
var forIn = __webpack_require__(11919);
// EXTERNAL MODULE: ./src/utils/dateUtils.ts + 38 modules
var dateUtils = __webpack_require__(84468);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/dateTimeField.ts

var ref;
var output = {
    format: function(value) {
        return (ref = (0,dateUtils/* formatISOTimeOrNull */.y7)(value)) !== null && ref !== void 0 ? ref : "";
    }
};
/* harmony default export */ var dateTimeField = (output);

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(68844);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObject.js
var isObject = __webpack_require__(8237);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/checkBox.tsx




var format = function(value, field) {
    var values = convertValue(value, field);
    if ((0,isArray/* default */.Z)(values)) {
        return values.join(constants/* splitCharCode */.Hr);
    }
    return values;
};
var formatDetail = function(value, field) {
    var values = convertValue(value, field);
    if ((0,isArray/* default */.Z)(values)) {
        return values.map(function(v) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-0",
                children: v
            }, v);
        });
    }
    return values;
};
var formatAsText = function(value, field) {
    return convertValue(value, field);
};
var convertValue = function(value, field) {
    if ((0,isEmpty/* default */.Z)(value)) {
        return "";
    }
    if (!(0,isObject/* default */.Z)(value)) {
        // @ts-ignore
        return formatValue(value, field.choices);
    }
    return field.choices.filter(function(choice) {
        var ref;
        return value === null || value === void 0 ? void 0 : (ref = value.value) === null || ref === void 0 ? void 0 : ref.some(function(v) {
            return v === choice.value;
        });
    }).map(function(choice) {
        var ref;
        if (choice.type === "OtherChoice") {
            return (value === null || value === void 0 ? void 0 : value.other) ? "".concat(choice === null || choice === void 0 ? void 0 : choice.label, ": ").concat(value === null || value === void 0 ? void 0 : value.other) : "".concat(choice === null || choice === void 0 ? void 0 : choice.label);
        }
        var extendedText = value === null || value === void 0 ? void 0 : (ref = value.extended_text) === null || ref === void 0 ? void 0 : ref[choice.value];
        return extendedText ? "".concat(choice.label, ": ").concat(extendedText) : choice.label;
    });
};
function formatValue(value, choices) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (choices || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var choice = _step.value;
            if (choice.value === value) {
                return choice.label;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "";
}
var checkBox_output = {
    format: format,
    formatDetail: formatDetail,
    formatAsText: formatAsText
};
/* harmony default export */ var checkBox = (checkBox_output);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/radioButton.ts

var radioButton = {
    format: format
};
/* harmony default export */ var fields_radioButton = (radioButton);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/dropDown.ts

var dropDown = {
    format: format
};
/* harmony default export */ var fields_dropDown = (dropDown);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/ratingField.ts
var ratingField_format = function(value) {
    return value;
};
var ratingField = {
    format: ratingField_format
};
/* harmony default export */ var fields_ratingField = (ratingField);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/mobileField.tsx
var mobileField_format = function(value) {
    var countryCode = (value === null || value === void 0 ? void 0 : value.country_code) ? "+".concat(value === null || value === void 0 ? void 0 : value.country_code) : "";
    return "".concat(countryCode).concat((value === null || value === void 0 ? void 0 : value.value) || "");
};
var mobileField = {
    format: mobileField_format
};
/* harmony default export */ var fields_mobileField = (mobileField);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/csatField.tsx




var csatField_format = function(value, field) {
    var label = field.ratingDescriptions[value - 1];
    return "".concat(value).concat(constants/* splitCharCode */.Hr).concat(label);
};
var csatField_formatDetail = function(value, field) {
    var label = field.ratingDescriptions[value - 1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                width: 20,
                height: 20,
                src: constants/* csatImages */.Ni[value - 1].src,
                alt: label !== null && label !== void 0 ? label : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                children: label
            })
        ]
    });
};
var csatField = {
    format: csatField_format,
    formatDetail: csatField_formatDetail
};
/* harmony default export */ var fields_csatField = (csatField);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/fields/index.ts







var Fields = {
    DateTimeField: dateTimeField,
    RadioButton: fields_radioButton,
    CheckBox: checkBox,
    DropDown: fields_dropDown,
    RatingField: fields_ratingField,
    MobileField: fields_mobileField,
    CsatField: fields_csatField,
    CtaField: fields_radioButton
};
/* harmony default export */ var fields = (Fields);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/utils/formFieldResolver.ts






var cellRender = function(params, field) {
    var _type;
    var format = ((_type = fields[field.type]) !== null && _type !== void 0 ? _type : {
        format: function(value) {
            return value;
        }
    }).format;
    return format(params.value, field);
};
function entryResolver(entry, fieldCodeMap) {
    var entryData = (0,_object_spread/* default */.Z)({}, entry.fieldValues);
    (0,forIn/* default */.Z)(entryData, function(value, key) {
        if (fieldCodeMap[key] != null) {
            entryData[key] = cellRender({
                value: value
            }, fieldCodeMap[key]);
        }
    });
    var customer = entry.customerSnapshot;
    var ref = customer !== null && customer !== void 0 ? customer : {}, uid = ref.uid, name = ref.name, mobile = ref.mobile, email = ref.email;
    var _obj;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: entry.id,
        customer: customer
    }, entryData), (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* CUSTOMER_UID */.tv, uid || "匿名用户"), (0,_define_property/* default */.Z)(_obj, constants/* CUSTOMER_NAME */.rl, name), (0,_define_property/* default */.Z)(_obj, constants/* CUSTOMER_MOBILE */.L, mobile), (0,_define_property/* default */.Z)(_obj, constants/* CUSTOMER_EMAIL */.n, email), (0,_define_property/* default */.Z)(_obj, "entry", entry), _obj));
}
function formFieldResolver(entries, fieldCodeMap) {
    var ref;
    return (ref = entries.map(function(entry) {
        return entryResolver(entry, fieldCodeMap);
    })) !== null && ref !== void 0 ? ref : [];
}


/***/ }),

/***/ 10122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "As": function() { return /* binding */ SERIAL_NUMBER_CODE; },
/* harmony export */   "B0": function() { return /* binding */ HIDDEN_FIELD_TYPES; },
/* harmony export */   "Ee": function() { return /* binding */ MOBILE_HIDDEN_FIELDS; },
/* harmony export */   "Vt": function() { return /* binding */ REPLY_CODE; },
/* harmony export */   "Wm": function() { return /* binding */ LINK_HIDDEN_FIELDS; },
/* harmony export */   "cO": function() { return /* binding */ UNFILTERABLE_FIELD_TYPES; },
/* harmony export */   "f4": function() { return /* binding */ COMMENTS_COUNT_CODE; }
/* harmony export */ });
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95660);


var MOBILE_HIDDEN_FIELDS = [
    "entry.browser",
    "entry.reply"
];
var LINK_HIDDEN_FIELDS = [
    "entry.reply",
    "entry.deliveryMethod",
    config_constants__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOMER_MOBILE */ .L,
    config_constants__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOMER_NAME */ .rl,
    config_constants__WEBPACK_IMPORTED_MODULE_1__/* .CUSTOMER_EMAIL */ .n, 
];
var HIDDEN_FIELD_TYPES = [
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.DescriptionField */ .EIl.DescriptionField
];
var UNFILTERABLE_FIELD_TYPES = [
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.DescriptionField */ .EIl.DescriptionField,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.ScreenshotField */ .EIl.ScreenshotField
];
var SERIAL_NUMBER_CODE = "entry.serialNumber";
var COMMENTS_COUNT_CODE = "entry.commentsCount";
var REPLY_CODE = "entry.reply";


/***/ }),

/***/ 18390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25328);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88998);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31463);
/* harmony import */ var yet_another_react_lightbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(461);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36078);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);








var ImageGroup = function(param) {
    var images = param.images, size = param.size;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useDisclosure */ .q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), currentImage = ref2[0], setCurrentImage = ref2[1];
    var handleClick = function(image, e) {
        e.stopPropagation();
        setCurrentImage(image);
        open();
    };
    var handleCloseClick = function(event) {
        event.stopPropagation();
        close();
    };
    if (!images) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            images.map(function(image) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                    styles: function(theme) {
                        return {
                            image: {
                                cursor: "pointer",
                                border: "1px solid ".concat((0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBorderColor */ .kJ)("gray.2", theme)),
                                borderRadius: theme.radius.xs
                            }
                        };
                    },
                    width: size,
                    height: size,
                    src: image,
                    alt: "",
                    onClick: function(e) {
                        return handleClick(image, e);
                    }
                }, image);
            }),
            currentImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(yet_another_react_lightbox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                open: opened,
                close: close,
                slides: [
                    {
                        src: currentImage
                    }
                ],
                carousel: {
                    finite: true
                },
                render: {
                    iconClose: function() {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            onClick: handleCloseClick
                        });
                    }
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageGroup);


/***/ }),

/***/ 9366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$G": function() { return /* reexport */ AsideType; },
  "fb": function() { return /* reexport */ EntryModal_Modal; },
  "DM": function() { return /* reexport */ useEntryModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/LoadingOverlay/LoadingOverlay.js + 1 modules
var LoadingOverlay = __webpack_require__(93787);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/plugins/apollo/cacheUtils.ts
var cacheUtils = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tooltip/Tooltip.js + 7 modules
var Tooltip = __webpack_require__(57155);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tabs/Tabs.js + 10 modules
var Tabs = __webpack_require__(15708);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(65067);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./src/components/business/hooks/useApplicationInfoBaseInfoCache.ts
var useApplicationInfoBaseInfoCache = __webpack_require__(51945);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/components/business/CustomerCard/index.tsx
var CustomerCard = __webpack_require__(94028);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/components/business/Customer/CustomerDetail/index.ts + 9 modules
var CustomerDetail = __webpack_require__(53699);
// EXTERNAL MODULE: ./src/utils/applicationUtils.ts
var applicationUtils = __webpack_require__(13090);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/type.ts
var AsideType;
(function(AsideType) {
    AsideType["BaseInfo"] = "BaseInfo";
    AsideType["Reply"] = "Reply";
    AsideType["Comments"] = "Comments";
})(AsideType || (AsideType = {}));

// EXTERNAL MODULE: ./src/plugins/apollo/cache.ts + 10 modules
var cache = __webpack_require__(84032);
// EXTERNAL MODULE: ./src/plugins/apollo/index.tsx
var apollo = __webpack_require__(3745);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(70426);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/throttle.js
var throttle = __webpack_require__(37820);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(81533);
// EXTERNAL MODULE: ./src/components/ui/Textarea/index.tsx
var Textarea = __webpack_require__(62417);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/components/MessageAdder/MessageInput.tsx




var MessageInput = function(props) {
    var placeholder = props.placeholder, value = props.value, onSave = props.onSave, onChange = props.onChange, styles = props.styles, minRows = props.minRows;
    var textareaRef = (0,react.useRef)(null);
    var handleSave = function() {
        if ((0,utils/* isBlank */.fp)(value)) return;
        onSave();
    };
    var handleKeyDown = function(event) {
        var ref;
        if (event.key === "Enter" && !event.shiftKey && !((ref = textareaRef.current) === null || ref === void 0 ? void 0 : ref.inCompositionRef.current)) {
            if (event.metaKey || event.ctrlKey) {
                var ref1;
                (ref1 = textareaRef.current) === null || ref1 === void 0 ? void 0 : ref1.handleOnChange(value + "\n");
            } else {
                event.preventDefault();
                handleSave();
            }
        }
        if ([
            "ArrowUp",
            "ArrowLeft",
            "ArrowDown",
            "ArrowRight"
        ].includes(event.key)) {
            event.stopPropagation();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* default */.Z, {
        placeholder: placeholder,
        onChange: onChange,
        maxLength: 1000,
        styles: styles,
        autosize: true,
        maxRows: 8,
        minRows: minRows !== null && minRows !== void 0 ? minRows : 1,
        autoFocus: true,
        w: "100%",
        onKeyDown: handleKeyDown,
        value: value,
        ref: textareaRef
    });
};
/* harmony default export */ var MessageAdder_MessageInput = (MessageInput);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/components/MessageAdder/index.tsx









var MessageAdder = function(props, ref) {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var disabled = props.disabled, disabledTooltip = props.disabledTooltip, _enterSaveEnabled = props.enterSaveEnabled, enterSaveEnabled = _enterSaveEnabled === void 0 ? true : _enterSaveEnabled, placeholder = props.placeholder, onSave = props.onSave, onFocus = props.onFocus, minRows = props.minRows;
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = _$ref[0], _$ref1 = _$ref[1], open = _$ref1.open, close = _$ref1.close;
    var _$ref2 = (0,react.useState)(), value = _$ref2[0], setValue = _$ref2[1];
    var wrapperRef = (0,use_click_outside/* useClickOutside */.O)(function() {
        if ((0,utils/* isBlank */.fp)(value)) {
            close();
        }
    });
    var reset = function() {
        setValue(undefined);
        close();
    };
    (0,react.useImperativeHandle)(ref, function() {
        return {
            reset: reset
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: opened ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            ref: wrapperRef,
            spacing: 0,
            align: "end",
            sx: function(theme) {
                return {
                    border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.3", theme)),
                    borderRadius: theme.radius.sm,
                    "&:focus-within": {
                        border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("brandBlue.7", theme, "brandBlue.8"))
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageAdder_MessageInput, {
                    minRows: minRows,
                    placeholder: placeholder,
                    value: value,
                    onSave: function() {
                        return enterSaveEnabled && onSave(value, reset);
                    },
                    onChange: function(value) {
                        return setValue(value);
                    },
                    styles: function(theme) {
                        return {
                            input: {
                                border: 0,
                                padding: "".concat(theme.spacing.sm, " !important"),
                                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("white", theme, "dark.7")
                            }
                        };
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                    withinPortal: true,
                    disabled: !disabled || !disabledTooltip,
                    width: 400,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    disabled: disabled || (0,utils/* isBlank */.fp)(value),
                                    onClick: function() {
                                        return onSave(value, reset);
                                    },
                                    mx: "sm",
                                    mb: "sm",
                                    size: "xs",
                                    children: t("common:actions.send")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                            children: disabledTooltip
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            p: "sm",
            sx: function(theme) {
                return {
                    border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.3", theme)),
                    borderRadius: theme.radius.sm,
                    cursor: "text"
                };
            },
            onClick: function() {
                open();
                onFocus === null || onFocus === void 0 ? void 0 : onFocus();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: (0,getColor/* getTextColor */.uu)("gray.5", theme),
                children: placeholder
            })
        })
    });
};
/* harmony default export */ var components_MessageAdder = (/*#__PURE__*/(0,react.forwardRef)(MessageAdder));

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Comments/CommentAdder.tsx













var CommentAdder = function(param) {
    var entryId = param.entryId, onSave = param.onSave, onFocus = param.onFocus;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useCreateEntryCommentMutation */.p_j)(), 1), createEntryCommentMutation = ref[0];
    var handleSave = (0,react.useRef)((0,throttle/* default */.Z)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(entryId, value, afterSave) {
            var data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            createEntryCommentMutation({
                                variables: {
                                    input: {
                                        entryId: entryId,
                                        content: value === null || value === void 0 ? void 0 : value.trim()
                                    }
                                },
                                update: function(cache, param) {
                                    var data = param.data;
                                    var ref;
                                    if (!(data === null || data === void 0 ? void 0 : (ref = data.createEntryComment) === null || ref === void 0 ? void 0 : ref.entryComment)) {
                                        return;
                                    }
                                    cache.modify({
                                        id: cache.identify({
                                            __typename: "Entry",
                                            id: entryId
                                        }),
                                        fields: {
                                            comments: function(existingCommentsRef) {
                                                var ref;
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, existingCommentsRef), {
                                                    nodes: (0,_to_consumable_array/* default */.Z)(existingCommentsRef.nodes).concat([
                                                        data === null || data === void 0 ? void 0 : (ref = data.createEntryComment) === null || ref === void 0 ? void 0 : ref.entryComment
                                                    ]),
                                                    totalCount: existingCommentsRef.totalCount + 1
                                                });
                                            },
                                            commentsCount: function commentsCount(existingCommentCountRef) {
                                                return existingCommentCountRef + 1;
                                            }
                                        }
                                    });
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.createEntryComment) {
                            onSave();
                            afterSave();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        ui/* message.error */.yw.error(t("common:message.createError"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(entryId, value, afterSave) {
            return _ref.apply(this, arguments);
        };
    }(), 1000)).current;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MessageAdder, {
        placeholder: t("entryModal.comments.placeholder"),
        onSave: function(value, afterSave) {
            return handleSave(entryId, value, afterSave);
        },
        onFocus: onFocus
    });
};
/* harmony default export */ var Comments_CommentAdder = (CommentAdder);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Comments/BlankComments.tsx






var BlankComments = function() {
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
        mt: "3xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "sm",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                    name: "comments",
                    className: "mb-sm",
                    style: {
                        color: (0,getColor/* getTextColor */.uu)("red", theme)
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    order: 6,
                    children: t("entryModal.comments.emptyTitle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    color: "dimmed",
                    children: t("entryModal.comments.emptyDescription")
                })
            ]
        })
    });
};
/* harmony default export */ var Comments_BlankComments = (BlankComments);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Avatar/Avatar.js + 5 modules
var Avatar = __webpack_require__(56169);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/differenceInSeconds/index.js + 1 modules
var differenceInSeconds = __webpack_require__(70747);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(47142);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/TypographyStylesProvider/TypographyStylesProvider.js + 2 modules
var TypographyStylesProvider = __webpack_require__(56697);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Comments/CommentContent.tsx












var CommentContent = function(param) {
    var comment = param.comment, isEditing = param.isEditing, onSave = param.onSave, onCancel = param.onCancel;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var ref = (0,react.useState)(comment.content), value = ref[0], setValue = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateEntryCommentMutation */.cCU)(), 1), updateEntryCommentMutation = ref1[0];
    var handleSave = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            updateEntryCommentMutation({
                                variables: {
                                    input: {
                                        id: comment.id,
                                        content: value === null || value === void 0 ? void 0 : value.trim()
                                    }
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.updateEntryComment) {
                            onSave();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        ui/* message.error */.yw.error(t("common:message.updateError"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!isEditing) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            p: "sm",
            sx: function(theme) {
                return {
                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme),
                    borderBottomLeftRadius: theme.radius.md,
                    borderBottomRightRadius: theme.radius.md,
                    borderTopRightRadius: theme.radius.md
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyStylesProvider/* TypographyStylesProvider */.l, {
                sx: function(theme) {
                    return {
                        fontSize: theme.fontSizes.sm,
                        wordBreak: "break-all"
                    };
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: (0,utils/* htmlEncodeByRegExp */.m9)(comment.content)
                    }
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: "sm",
        align: "end",
        w: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageAdder_MessageInput, {
                placeholder: t("entryModal.comments.placeholder"),
                value: value,
                onSave: handleSave,
                onChange: setValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "default",
                        onClick: onCancel,
                        size: "xs",
                        children: t("common:actions.cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        disabled: (0,utils/* isBlank */.fp)(value),
                        onClick: handleSave,
                        size: "xs",
                        children: t("common:actions.save")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Comments_CommentContent = (CommentContent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconDots.js
var IconDots = __webpack_require__(69523);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconEdit.js
var IconEdit = __webpack_require__(51529);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconTrash.js
var IconTrash = __webpack_require__(58382);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Menu/Menu.js + 13 modules
var Menu = __webpack_require__(56674);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Comments/Actions.tsx













var Actions = function(param) {
    var entryId = param.entryId, onClickEdit = param.onClickEdit, comment = param.comment;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useDeleteEntryCommentMutation */.ihx)(), 1), deleteEntryCommentMutation = ref[0];
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            deleteEntryCommentMutation({
                                variables: {
                                    id: comment.id
                                },
                                update: function(cache, param) {
                                    var data = param.data;
                                    if (!(data === null || data === void 0 ? void 0 : data.deleteEntryComment)) {
                                        return;
                                    }
                                    cache.modify({
                                        id: cache.identify({
                                            __typename: "Entry",
                                            id: entryId
                                        }),
                                        fields: {
                                            comments: function comments(existingCommentsRef, param) {
                                                var readField = param.readField;
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, existingCommentsRef), {
                                                    nodes: existingCommentsRef.nodes.filter(function(ref) {
                                                        return comment.id !== readField("id", ref);
                                                    }),
                                                    totalCount: existingCommentsRef.totalCount - 1
                                                });
                                            },
                                            commentsCount: function commentsCount(existingCommentCountRef) {
                                                return existingCommentCountRef - 1;
                                            }
                                        }
                                    });
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        ui/* message.error */.yw.error(t("common:message.deleteError"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickDelete = function() {
        (0,ui/* openAlertModal */.NC)({
            title: t("entryModal.comments.delete.title"),
            content: t("entryModal.comments.delete.content"),
            onConfirm: handleDelete,
            labels: {
                confirm: t("common:actions.delete"),
                cancel: t("common:actions.cancel")
            },
            confirmProps: {
                color: "red"
            },
            zIndex: 1000
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        shadow: "md",
        position: "bottom-end",
        withinPortal: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                    color: "gray.0",
                    size: 22,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDots/* default */.Z, {
                        stroke: 1.5,
                        size: 14,
                        color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu.Dropdown */.v.Dropdown, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEdit/* default */.Z, {
                            size: 14
                        }),
                        onClick: onClickEdit,
                        children: t("common:actions.edit")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* default */.Z, {
                            size: 14
                        }),
                        onClick: onClickDelete,
                        color: "red",
                        children: t("common:actions.delete")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Comments_Actions = (Actions);

// EXTERNAL MODULE: ./src/components/business/hooks/useCurrentUserCache.ts
var useCurrentUserCache = __webpack_require__(77759);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Comments/Comment.tsx










var Comment = function(param) {
    var entryId = param.entryId, comment = param.comment, onEdit = param.onEdit, isEditing = param.isEditing, onSave = param.onSave, onCancel = param.onCancel;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var user = (0,useCurrentUserCache/* default */.Z)().user;
    var isCurrentUser = comment.creator.id === (user === null || user === void 0 ? void 0 : user.id);
    var getCreatedAt = function() {
        var createdAt = (0,utils/* formatTimeByThisYear */.lO)(comment.createdAt);
        var isUpdated = (0,differenceInSeconds/* default */.Z)((0,parseISO/* default */.Z)(comment.updatedAt), (0,parseISO/* default */.Z)(comment.createdAt)) > 1;
        return isUpdated ? t("entryModal.comments.createdAt", {
            createdAt: createdAt
        }) : createdAt;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        align: "start",
        noWrap: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                size: 28,
                radius: 14,
                src: (0,utils/* getAvatarUrlByUser */.TD)(comment.creator)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                className: "grow",
                spacing: "sm",
                align: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        position: "apart",
                        w: "100%",
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                                className: "shrink",
                                lineClamp: 1,
                                children: isCurrentUser ? t("entryModal.comments.creatorName", {
                                    name: comment.creator.name
                                }) : comment.creator.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                spacing: "xs",
                                className: "shrink-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        color: "dimmed",
                                        size: "xs",
                                        children: getCreatedAt()
                                    }),
                                    isCurrentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_Actions, {
                                        entryId: entryId,
                                        onClickEdit: onEdit,
                                        comment: comment
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_CommentContent, {
                        comment: comment,
                        isEditing: isEditing,
                        onSave: onSave,
                        onCancel: onCancel
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Comments_Comment = (Comment);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Comments/index.tsx











var client = (0,apollo/* initializeApollo */["in"])();
var Comments = function(param) {
    var entryId = param.entryId;
    var ref = (0,react.useState)(null), editingId = ref[0], setEditingId = ref[1];
    var viewport = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setEditingId(null);
    }, [
        entryId
    ]);
    var updateCommentsCount = function(commentsCount) {
        client.cache.modify({
            id: cache/* default.identify */.Z.identify({
                __typename: "Entry",
                id: entryId
            }),
            fields: {
                commentsCount: function commentsCount1() {
                    return commentsCount;
                }
            }
        });
    };
    var ref1 = (0,domain/* useEntryCommentsQuery */.y78)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: entryId,
            pageArguments: {
                first: constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        },
        onCompleted: function onCompleted(data) {
            var ref, ref1;
            updateCommentsCount((ref = data.entry) === null || ref === void 0 ? void 0 : (ref1 = ref.comments) === null || ref1 === void 0 ? void 0 : ref1.totalCount);
        }
    }), data = ref1.data, loading = ref1.loading, variables = ref1.variables;
    if (loading && !(0,cacheUtils/* isCacheHit */.b)(variables, domain/* EntryCommentsDocument */.n6k)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOverlay/* LoadingOverlay */.f, {
            visible: true,
            overlayBlur: 2
        });
    }
    if (!(data === null || data === void 0 ? void 0 : data.entry)) {
        return null;
    }
    var comments = data.entry.comments;
    var handleSave = function() {
        setTimeout(function() {
            var ref, ref1;
            (ref = viewport.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                top: (ref1 = viewport.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight
            });
        }, 100);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        pb: "sm",
        pt: 20,
        h: "100%",
        spacing: "sm",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: "grow shrink contents",
                children: comments.totalCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_BlankComments, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                    px: "lg",
                    viewportRef: viewport,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                        spacing: "xl",
                        children: comments.nodes.map(function(comment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_Comment, {
                                entryId: entryId,
                                comment: comment,
                                isEditing: editingId === comment.id,
                                onSave: function() {
                                    return setEditingId(null);
                                },
                                onCancel: function() {
                                    return setEditingId(null);
                                },
                                onEdit: function() {
                                    return setEditingId(comment.id);
                                }
                            }, comment.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                px: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Comments_CommentAdder, {
                    entryId: entryId,
                    onSave: handleSave,
                    onFocus: function() {
                        setEditingId(null);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Aside_Comments = (Comments);

// EXTERNAL MODULE: ./src/components/business/Customer/CustomerSegments/index.tsx
var CustomerSegments = __webpack_require__(50257);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(58262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(92212);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronsDown.js
var IconChevronsDown = __webpack_require__(6997);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/components/UserInfo.tsx







var reservedCustomerFields = [
    "uid",
    "name",
    "mobile",
    "email"
];
var UserInfo = function(param) {
    var customer = param.customer, customerFields = param.customerFields, _gridCols = param.gridCols, gridCols = _gridCols === void 0 ? 1 : _gridCols;
    var t = (0,useTranslation/* default */.Z)().t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var ref = (0,react.useState)(false), customerFieldsOpened = ref[0], setCustomerFieldsOpened = ref[1];
    var formatLabelValue = function(field) {
        var ref;
        var fieldValue = customer === null || customer === void 0 ? void 0 : (ref = customer.attrValues) === null || ref === void 0 ? void 0 : ref[field.code];
        if (field.type === "DateTimeField") {
            return (0,utils/* formatISOTimeOrNull */.y7)(fieldValue);
        }
        if ((0,utils/* isUrl */.CB)(fieldValue)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UrlWithTooltip */.wr, {
                url: fieldValue,
                includeProtocolAndHost: true
            });
        }
        return fieldValue;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 6,
                mb: "md",
                children: t("entry:entryModal.baseInfo.customerInfoTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                cols: gridCols,
                verticalSpacing: 12,
                children: reservedCustomerFields.map(function(field) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        labelClassName: "min-w-[28px]",
                        label: t("customer:customer_".concat(field)),
                        value: customer && (customer === null || customer === void 0 ? void 0 : customer[field])
                    }, field);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                cols: gridCols,
                verticalSpacing: 12,
                mt: 12,
                children: customerFields.map(function(field, index) {
                    if (index >= 2) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: field.label,
                        labelClassName: "min-w-[56px]",
                        value: formatLabelValue(field)
                    }, field.code);
                })
            }),
            !customerFieldsOpened && customerFields.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                pt: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 0,
                    onClick: function() {
                        return setCustomerFieldsOpened(true);
                    },
                    className: "px-sm py-xs rounded cursor-pointer hover:bg-brandBlue-1 select-none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "brandBlue.7",
                            size: 12,
                            children: t("entry:entryModal.baseInfo.collapse")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronsDown/* default */.Z, {
                            size: 16,
                            stroke: 1.5,
                            color: theme.colors.brandBlue[7]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                in: customerFieldsOpened,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                    cols: gridCols,
                    verticalSpacing: 12,
                    mt: 12,
                    children: customerFields.map(function(field, index) {
                        if (index < 2) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                            label: field.label,
                            labelClassName: "min-w-[56px]",
                            value: formatLabelValue(field)
                        }, field.code);
                    })
                })
            }),
            customerFieldsOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                pt: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 0,
                    onClick: function() {
                        return setCustomerFieldsOpened(false);
                    },
                    className: "px-sm py-xs rounded cursor-pointer hover:bg-brandBlue-1 select-none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "brandBlue.7",
                            size: 12,
                            children: t("entry:entryModal.baseInfo.putAway")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronsDown/* default */.Z, {
                            size: 16,
                            stroke: 1.5,
                            color: theme.colors.brandBlue[7],
                            className: "transition-transform rotate-180"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_UserInfo = (UserInfo);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/components/DeviceInfo.tsx









var DeviceInfo = function(param) {
    var entry = param.entry, customEvents = param.customEvents, campaignType = param.campaignType, _gridCols = param.gridCols, gridCols = _gridCols === void 0 ? 1 : _gridCols;
    var t = (0,useTranslation/* default */.Z)().t;
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    var isWebChannel = (0,applicationUtils/* isWebDistribution */.RV)(application);
    var isLinkChannel = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    var campaignTypeName = t("common:campaignTypeName.".concat(campaignType));
    var triggeredEvent = customEvents === null || customEvents === void 0 ? void 0 : customEvents.find(function(event) {
        return event.code === entry.eventCode;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 6,
                mb: "md",
                children: t("entry:entryModal.baseInfo.deviceInfoTitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleGrid/* SimpleGrid */.M, {
                cols: gridCols,
                verticalSpacing: 12,
                children: [
                    !isLinkChannel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.triggeredEvent", {
                            campaignTypeName: campaignTypeName
                        }),
                        value: (triggeredEvent === null || triggeredEvent === void 0 ? void 0 : triggeredEvent.displayName) || (triggeredEvent === null || triggeredEvent === void 0 ? void 0 : triggeredEvent.code) || ""
                    }),
                    entry.referer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.referer"),
                        labelClassName: "min-w-[56px]",
                        value: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UrlWithTooltip */.wr, {
                            url: entry.referer
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.createdAt"),
                        value: (0,utils/* formatISOTime */.cx)(entry.createdAt)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.fillingDuration"),
                        value: (0,utils/* formatTimeDuration */.J_)(t, entry.fillingDuration)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.os"),
                        value: entry.os
                    }),
                    isWebChannel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.browser"),
                        labelClassName: "min-w-[56px]",
                        value: entry.browser
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.screenResolution"),
                        value: entry.screenResolution
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.submittedOn"),
                        value: entry.submittedOn === domain/* EntrySubmittedOn.Completed */.L6A.Completed ? t("entry:list.submittedOnValue.COMPLETE") : t("entry:list.submittedOnValue.EXPIRED")
                    }),
                    !isLinkChannel && entry.deliveryMethod && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.deliveryMethod"),
                        value: t("entry:list.deliveryMethodValue.".concat(entry.deliveryMethod))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.ip"),
                        value: entry.ip
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.region"),
                        value: (0,utils/* getDisplayRegion */.M$)(entry.region)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DeviceInfo = (DeviceInfo);

// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/SurveyBaseInfo.tsx







var SurveyBaseInfo = function(props) {
    var ref, ref1;
    var campaignType = props.campaignType, entry = props.entry, customerFields = props.customerFields, customEvents = props.customEvents, manageable = props.manageable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        children: [
            ((ref = entry.customerSnapshot) === null || ref === void 0 ? void 0 : ref.customerId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                        customer: entry.customerSnapshot,
                        customerFields: customerFields
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        mt: "xl",
                        pb: "lg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSegments/* default */.Z, {
                        id: (ref1 = entry.customerSnapshot) === null || ref1 === void 0 ? void 0 : ref1.customerId,
                        manageable: manageable
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        mt: "xl",
                        pb: "lg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DeviceInfo, {
                entry: entry,
                campaignType: campaignType,
                customEvents: customEvents
            })
        ]
    });
};
/* harmony default export */ var Aside_SurveyBaseInfo = (SurveyBaseInfo);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ThemeIcon/ThemeIcon.js + 1 modules
var ThemeIcon = __webpack_require__(53196);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconMoodCry.js
var IconMoodCry = __webpack_require__(12956);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/NotSupport.tsx






var NotSupport = function() {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("entry").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
        mt: "3xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "md",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    radius: "xl",
                    color: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme),
                    size: 48,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMoodCry/* default */.Z, {
                        size: 36,
                        strokeWidth: 1.5,
                        color: (0,getColor/* getTextColor */.uu)("gray.5", theme)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    mt: "xl",
                    color: "dimmed",
                    maw: 304,
                    ta: "center",
                    children: t("entryModal.reply.disabled")
                })
            ]
        })
    });
};
/* harmony default export */ var Reply_NotSupport = (NotSupport);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/reply.gif
/* harmony default export */ var reply = ({"src":"https://static-cny.howxm.com/_next/static/media/reply.c6e774ed.gif","height":608,"width":1080});
// EXTERNAL MODULE: ./src/components/business/HelpDoc/index.tsx
var HelpDoc = __webpack_require__(75801);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/Blank.tsx










var BlankReply = function() {
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
        mt: "3xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "md",
            align: "center",
            mx: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    radius: "xl",
                    color: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme),
                    size: 48,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "reply",
                        size: 32,
                        style: {
                            color: (0,getColor/* getTextColor */.uu)("gray.5", theme),
                            // @ts-ignore
                            "--filled-color": "var(--mantine-color-gray-2)"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 6,
                            children: t("entryModal.reply.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpDoc/* default */.Z, {
                            content: t("entryModal.reply.help"),
                            width: 280,
                            moreLink: config/* replyHelpLink */.zq
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    ta: "center",
                    color: "dimmed",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                        i18nKey: "entry:entryModal.reply.description",
                        components: {
                            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                href: config/* replyHelpLink */.zq,
                                target: "_blank"
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: reply.src
                })
            ]
        })
    });
};
/* harmony default export */ var Blank = (BlankReply);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Timeline/Timeline.js + 3 modules
var Timeline = __webpack_require__(10222);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconEyeFilled.js
var IconEyeFilled = __webpack_require__(58290);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(4588);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/Content/MessageContent.tsx





var MessageContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyStylesProvider/* TypographyStylesProvider */.l, {
        sx: function(theme) {
            return {
                fontSize: theme.fontSizes.sm,
                color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                wordBreak: "break-all"
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: (0,utils/* htmlEncodeByRegExp */.m9)(content)
            }
        })
    });
};
/* harmony default export */ var Content_MessageContent = (MessageContent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/Content/styles.ts

var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        item: {
            "&::before": {
                left: "4px"
            },
            "&:not(:first-of-type)": {
                marginTop: theme.spacing.md
            }
        },
        itemBullet: {
            left: "-4px"
        },
        itemTitle: {
            fontWeight: 400
        }
    };
});
var itemCommonProps = {
    lineWidth: 1,
    pl: 24,
    bulletSize: 16
};

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/Content/Withdraw.tsx








var Withdraw = function(param) {
    var reply = param.reply, entryId = param.entryId, updateReplyCallBack = param.updateReplyCallBack;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var id = reply.id, readAt = reply.readAt;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useDeleteEntryReplyMutation */.i3D)(), 1), deleteEntryReply = ref[0];
    var openConfirmModal = function() {
        (0,ui/* openAlertModal */.NC)({
            title: t("entryModal.reply.sent.withdrawConfirm"),
            onConfirm: function onConfirm() {
                deleteEntryReply({
                    variables: {
                        id: id
                    },
                    update: function(cache, param) {
                        var data = param.data;
                        if (!(data === null || data === void 0 ? void 0 : data.deleteEntryReply)) {
                            return;
                        }
                        cache.modify({
                            id: cache.identify({
                                __typename: "Entry",
                                id: entryId
                            }),
                            fields: {
                                replies: function(existingRepliesRef, param) {
                                    var readField = param.readField;
                                    return existingRepliesRef.filter(function(ref) {
                                        return id !== readField("id", ref);
                                    });
                                }
                            }
                        });
                    }
                }).then(function() {
                    updateReplyCallBack === null || updateReplyCallBack === void 0 ? void 0 : updateReplyCallBack();
                    ui/* message.successMsg */.yw.successMsg("".concat(t("entryModal.reply.sent.withdraw")).concat(t("common:message.success")));
                });
            }
        });
    };
    if (!(0,isNil/* default */.Z)(readAt)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* Anchor */.e, {
        onClick: openConfirmModal,
        children: [
            t("entryModal.reply.sent.withdraw"),
            " "
        ]
    });
};
/* harmony default export */ var Content_Withdraw = (Withdraw);

// EXTERNAL MODULE: ./src/components/business/Customer/Avatar/index.tsx + 1 modules
var Customer_Avatar = __webpack_require__(24319);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/Content/ReplyItem.tsx
















var ReplyItem = function(param) {
    var reply = param.reply, entryId = param.entryId, updateReplyCallBack = param.updateReplyCallBack;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var classes = useStyles().classes;
    var user = (0,useCurrentUserCache/* default */.Z)().user;
    var sentContent = reply.sentContent, sentAt = reply.sentAt, sender = reply.sender, readAt = reply.readAt, thumb = reply.thumb, receivedContent = reply.receivedContent, receivedAt = reply.receivedAt;
    var itemClasses = {
        item: classes.item,
        itemBullet: classes.itemBullet,
        itemTitle: classes.itemTitle
    };
    var displayReceivedContent = thumb ? "".concat(thumb, "；").concat(receivedContent !== null && receivedContent !== void 0 ? receivedContent : "") : receivedContent !== null && receivedContent !== void 0 ? receivedContent : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline/* Timeline.Item */.T.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemCommonProps), {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "sm",
                    align: "self-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                            size: 16,
                            radius: "xl",
                            src: (0,utils/* getAvatarUrlByUser */.TD)(sender)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            lh: "16px",
                            className: "truncate",
                            maw: 258,
                            children: [
                                (user === null || user === void 0 ? void 0 : user.id) === sender.id ? "".concat(t("entryModal.reply.sent.me", {
                                    name: sender.name
                                })) : sender.name,
                                t("entryModal.reply.sent.title")
                            ]
                        })
                    ]
                }),
                bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    size: 16,
                    color: "brandBlue.7",
                    radius: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "chatFill"
                    })
                }),
                classNames: itemClasses,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                        bg: (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme),
                        px: "lg",
                        py: "sm",
                        mt: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_MessageContent, {
                            content: sentContent
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        size: "xs",
                        children: (0,utils/* formatISOTime */.cx)(sentAt)
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline.Item */.T.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            children: [
                                t("entryModal.reply.sent.createdAt"),
                                " ",
                                (0,isNil/* default */.Z)(readAt) && t("entryModal.reply.sent.notRead")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Withdraw, {
                            reply: reply,
                            entryId: entryId,
                            updateReplyCallBack: updateReplyCallBack
                        })
                    ]
                })
            }, itemCommonProps), {
                classNames: itemClasses,
                bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    size: 16,
                    color: "lime.7",
                    radius: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        size: 12,
                        name: "sendFill",
                        style: {
                            color: (0,getColor/* getTextColor */.uu)("white", theme),
                            // @ts-ignore
                            "--filled-color": (0,getColor/* getTextColor */.uu)("lime.7", theme)
                        }
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    color: "dimmed",
                    size: "xs",
                    children: (0,utils/* formatISOTime */.cx)(sentAt)
                })
            })),
            !(0,isNil/* default */.Z)(readAt) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline.Item */.T.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemCommonProps), {
                classNames: itemClasses,
                title: t("entryModal.reply.sent.readAt"),
                bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    size: 16,
                    color: "yellow.7",
                    radius: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEyeFilled/* default */.Z, {
                        size: 12
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    color: "dimmed",
                    size: "xs",
                    children: (0,utils/* formatISOTime */.cx)(readAt)
                })
            })),
            receivedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline/* Timeline.Item */.T.Item, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemCommonProps), {
                classNames: itemClasses,
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "sm",
                    align: "self-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer_Avatar/* default */.Z, {
                            size: 16
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            lh: "16px",
                            children: t("entryModal.reply.received.title")
                        })
                    ]
                }),
                bulletSize: 16,
                bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    size: 16,
                    color: "orange.7",
                    radius: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "chatFill"
                    })
                }),
                styles: {
                    item: {
                        "&:not(:first-of-type)": {
                            marginTop: theme.spacing.lg
                        }
                    }
                },
                children: [
                    displayReceivedContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                        bg: (0,getColor/* getBackgroundColor */.dF)("orange.0", theme),
                        px: "lg",
                        py: "sm",
                        mt: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_MessageContent, {
                            content: displayReceivedContent
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        size: "xs",
                        children: (0,utils/* formatISOTime */.cx)(receivedAt)
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var Content_ReplyItem = (ReplyItem);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/Content/index.tsx





var Content = function(param) {
    var replies = param.replies, entryId = param.entryId, updateReplyCallBack = param.updateReplyCallBack;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        spacing: "xl",
        children: replies === null || replies === void 0 ? void 0 : replies.map(function(reply, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline */.T, {
                bg: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme),
                p: "sm",
                radius: "sm",
                className: "rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_ReplyItem, {
                    reply: reply,
                    entryId: entryId,
                    updateReplyCallBack: updateReplyCallBack
                }, reply.id)
            }, index);
        })
    });
};
/* harmony default export */ var Reply_Content = (Content);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/ReplyAdder.tsx














var ReplyAdder = function(param) {
    var entryId = param.entryId, disabled = param.disabled, onSave = param.onSave;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useCreateEntryReplyMutation */.i81)(), 1), senEntryReplyMutation = ref[0];
    var messageAdderRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        messageAdderRef === null || messageAdderRef === void 0 ? void 0 : (ref = messageAdderRef.current) === null || ref === void 0 ? void 0 : ref.reset();
    }, [
        entryId
    ]);
    var handleSave = (0,throttle/* default */.Z)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(entryId, value, afterSave) {
            var data, e, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            senEntryReplyMutation({
                                variables: {
                                    input: {
                                        entryId: entryId,
                                        content: value === null || value === void 0 ? void 0 : value.trim()
                                    }
                                },
                                update: function(cache, param) {
                                    var data = param.data;
                                    if (!(data === null || data === void 0 ? void 0 : data.createEntryReply)) {
                                        return;
                                    }
                                    cache.modify({
                                        id: cache.identify({
                                            __typename: "Entry",
                                            id: entryId
                                        }),
                                        fields: {
                                            replies: function(existingRepliesRef) {
                                                return (0,_to_consumable_array/* default */.Z)(existingRepliesRef).concat([
                                                    data === null || data === void 0 ? void 0 : data.createEntryReply
                                                ]);
                                            }
                                        }
                                    });
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.createEntryReply) {
                            onSave();
                            afterSave();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        graphQLErrors = e.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            mapping: new Map([
                                [
                                    "error.create_conflict",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                        i18nKey: "entry:entryModal.reply.sent.existed",
                                        components: {
                                            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                                href: config/* replyHelpLink */.zq,
                                                target: "_blank"
                                            })
                                        }
                                    }, "entry:entryModal.reply.sent.existed")
                                ]
                            ]),
                            defaultMessage: "".concat(t("common:actions.send")).concat(t("common:message.failed"))
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(entryId, value, afterSave) {
            return _ref.apply(this, arguments);
        };
    }(), 1000);
    var handleConfirmSend = function(entryId, value, afterSave) {
        (0,ui/* openAlertModal */.NC)({
            hideIcon: true,
            title: t("entryModal.reply.confirm.title"),
            content: t("entryModal.reply.confirm.content"),
            labels: {
                confirm: t("common:actions.send"),
                cancel: t("common:actions.cancel")
            },
            onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                handleSave(entryId, value, afterSave)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MessageAdder, {
        minRows: 3,
        ref: messageAdderRef,
        disabled: disabled,
        enterSaveEnabled: false,
        disabledTooltip: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            i18nKey: "entry:entryModal.reply.sent.existed",
            components: {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                    href: config/* replyHelpLink */.zq,
                    target: "_blank"
                })
            }
        }),
        placeholder: t("entryModal.reply.placeholder"),
        onSave: function(value, afterSave) {
            return handleConfirmSend(entryId, value, afterSave);
        }
    });
};
/* harmony default export */ var Reply_ReplyAdder = (ReplyAdder);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/Reply/index.tsx









var Reply = function(param) {
    var entryId = param.entryId, disabled = param.disabled, updateReplyCallBack = param.updateReplyCallBack;
    var ref;
    var viewport = (0,react.useRef)(null);
    var ref1 = (0,domain/* useEntryRepliesQuery */.bVV)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: entryId
        },
        skip: disabled
    }), data = ref1.data, refetch = ref1.refetch;
    var ref2;
    var replies = (ref2 = data === null || data === void 0 ? void 0 : (ref = data.entry) === null || ref === void 0 ? void 0 : ref.replies) !== null && ref2 !== void 0 ? ref2 : [];
    var sendBtnDisabled = (0,react.useMemo)(function() {
        return !!(replies === null || replies === void 0 ? void 0 : replies.some(function(reply) {
            return (0,isNil/* default */.Z)(reply.readAt);
        }));
    }, [
        replies
    ]);
    (0,react.useEffect)(function() {
        refetch();
    // eslint-disable-next-line
    }, [
        entryId
    ]);
    var handleSave = function() {
        updateReplyCallBack === null || updateReplyCallBack === void 0 ? void 0 : updateReplyCallBack();
        setTimeout(function() {
            var ref, ref1;
            (ref = viewport.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                top: (ref1 = viewport.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight
            });
        }, 200);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        pb: "sm",
        pt: 20,
        h: "100%",
        spacing: "sm",
        justify: "space-between",
        children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Reply_NotSupport, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    className: "grow shrink contents",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                        px: "lg",
                        viewportRef: viewport,
                        children: (0,isEmpty/* default */.Z)(replies) && !(0,isNil/* default */.Z)(replies) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Blank, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                            spacing: "xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reply_Content, {
                                entryId: entryId,
                                replies: replies,
                                updateReplyCallBack: updateReplyCallBack
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    px: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reply_ReplyAdder, {
                        disabled: sendBtnDisabled,
                        entryId: entryId,
                        onSave: handleSave
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Aside_Reply = (Reply);

// EXTERNAL MODULE: ./node_modules/.pnpm/howxm-js@0.0.7_react@18.2.0/node_modules/howxm-js/dist/index.es.js
var index_es = __webpack_require__(13528);
;// CONCATENATED MODULE: ./src/service/howxmEvents.ts


function useHowxmEvent() {
    var clickToPay = function(feature, otherAttrs, callback) {
        (0,index_es/* eventHowxm */.ZU)("click_to_pay", feature ? (0,_object_spread/* default */.Z)({
            feature: feature
        }, otherAttrs) : otherAttrs, callback);
    };
    var actionEvent = function(param) {
        var code = param.code, attrs = param.attrs;
        (0,index_es/* eventHowxm */.ZU)(code, attrs);
    };
    return {
        clickToPay: clickToPay,
        actionEvent: actionEvent
    };
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Aside/index.tsx



















var Aside = function(props) {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var canAddToSegment = props.canAddToSegment, entry = props.entry, targetAside = props.targetAside, customerFields = props.customerFields, customEvents = props.customEvents, updateReplyCallBack = props.updateReplyCallBack, isDisplayedSurveyForm = props.isDisplayedSurveyForm, campaignType = props.campaignType;
    var customer = entry === null || entry === void 0 ? void 0 : entry.customerSnapshot;
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    var actionEvent = useHowxmEvent().actionEvent;
    var canReply = (0,applicationUtils/* isWebDistribution */.RV)(application);
    var defaultAsideType = (0,react.useMemo)(function() {
        return targetAside ? targetAside : isDisplayedSurveyForm ? AsideType.BaseInfo : canReply ? AsideType.Reply : AsideType.Comments;
    }, [
        isDisplayedSurveyForm,
        targetAside,
        canReply
    ]);
    var openCustomerDetail = (0,CustomerDetail/* useCustomerDetailModal */.Y)(canAddToSegment);
    var customerAttributes = (0,business/* useGetApplicationCustomerAttributes */.Mt)();
    var handleViewCustomerClick = function() {
        if (customer === null || customer === void 0 ? void 0 : customer.customerId) {
            openCustomerDetail({
                id: customer === null || customer === void 0 ? void 0 : customer.customerId,
                customerAttributes: customerAttributes,
                manageable: canAddToSegment
            });
        }
    };
    var userCardClasses = classnames_default()("mx-xl my-lg ", {
        "hover:cursor-pointer": customer === null || customer === void 0 ? void 0 : customer.customerId,
        "hover:brightness-90": customer === null || customer === void 0 ? void 0 : customer.customerId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        h: "100%",
        className: "overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomerCard/* default */.Z, {
                UID: customer === null || customer === void 0 ? void 0 : customer.uid,
                className: userCardClasses,
                onClick: handleViewCustomerClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        spacing: 0,
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                                children: t("entry:list.region")
                            }),
                            "：",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                withArrow: true,
                                label: (0,utils/* getDisplayRegion */.M$)(entry.region),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    className: "truncate max-w-[150px]",
                                    children: (0,utils/* getDisplayRegion */.M$)(entry.region)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        label: t("entry:list.createdAt"),
                        value: (0,utils/* formatISOTime */.cx)(entry.createdAt)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                keepMounted: false,
                styles: function(theme) {
                    return {
                        root: {
                            // header height 45px, user card height 103px
                            height: "calc(100% - 148px)"
                        },
                        tabsList: {
                            paddingLeft: "24px"
                        },
                        panel: {
                            position: "relative",
                            height: "calc(100% - ".concat(theme.spacing.xl, ")")
                        }
                    };
                },
                defaultValue: defaultAsideType,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs.List */.m.List, {
                        children: [
                            isDisplayedSurveyForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                value: AsideType.BaseInfo,
                                children: t("entryModal.baseInfo.tabLabel")
                            }),
                            canReply && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                value: AsideType.Reply,
                                onClick: function() {
                                    return actionEvent({
                                        code: "click_reply_tab"
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    noWrap: true,
                                    spacing: "xs",
                                    children: [
                                        t("entryModal.reply.tabLabel"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                            name: "newFeature",
                                            className: "h-[22px] items-center"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                value: AsideType.Comments,
                                children: t("entryModal.comments.tabLabel")
                            })
                        ]
                    }),
                    isDisplayedSurveyForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                        value: AsideType.BaseInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                            p: "xl",
                            pb: "sm",
                            h: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside_SurveyBaseInfo, {
                                entry: entry,
                                campaignType: campaignType,
                                customerFields: customerFields,
                                customEvents: customEvents,
                                manageable: canAddToSegment
                            })
                        })
                    }),
                    canReply && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                        value: AsideType.Reply,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside_Reply, {
                            entryId: entry.id,
                            disabled: entry.deliveryMethod === domain/* DeliveryMethod.Url */.GlQ.Url,
                            updateReplyCallBack: updateReplyCallBack
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                        value: AsideType.Comments,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Aside_Comments, {
                            entryId: entry.id
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Content_Aside = (Aside);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Rating/Rating.js + 6 modules
var Rating = __webpack_require__(33148);
// EXTERNAL MODULE: ./src/components/business/Campaign/EntryModal/Content/components/ImageGroup.tsx
var ImageGroup = __webpack_require__(18390);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Feedback/Fields.tsx







var Fields = function(props) {
    var ref;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var entry = props.entry, formFields = props.formFields;
    var ratingField = formFields.find(function(field) {
        return field.type === domain/* FormFieldType.RatingField */.EIl.RatingField;
    });
    var ratingFieldCode = ratingField.code;
    var moreSuggestionFieldCode = (ref = formFields.find(function(field) {
        return field.type === domain/* FormFieldType.TextArea */.EIl.TextArea;
    })) === null || ref === void 0 ? void 0 : ref.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea.Autosize */.x.Autosize, {
        scrollbarSize: "8px",
        mah: "360px",
        className: "rounded-sm w-full",
        sx: {
            backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme),
            border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.2", theme))
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            className: "p-xl",
            spacing: "sm",
            align: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                            size: "md",
                            count: ratingField.ratingMax,
                            value: entry.fieldValues[ratingFieldCode]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            ml: "sm",
                            size: 20,
                            weight: "bold",
                            children: t("entryModal.feedbackScore", {
                                score: entry.fieldValues[ratingFieldCode]
                            })
                        })
                    ]
                }),
                moreSuggestionFieldCode && entry.fieldValues[moreSuggestionFieldCode] && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: "break-all",
                    size: 14,
                    children: entry.fieldValues[moreSuggestionFieldCode].text
                }),
                moreSuggestionFieldCode && entry.fieldValues[moreSuggestionFieldCode] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGroup/* default */.Z, {
                    images: entry.fieldValues[moreSuggestionFieldCode].screenshots,
                    size: 178
                })
            ]
        })
    });
};
/* harmony default export */ var Feedback_Fields = (Fields);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Feedback/index.tsx







var FeedbackMain = function(props) {
    var entry = props.entry, customerFields = props.customerFields, formFields = props.formFields, customEvents = props.customEvents, campaignType = props.campaignType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
        p: "3xl",
        pb: "lg",
        h: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "40px",
            children: [
                campaignType === domain/* CampaignType.Feedback */.mL.Feedback && /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback_Fields, {
                    entry: entry,
                    formFields: formFields
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                    customer: entry.customerSnapshot,
                    customerFields: customerFields,
                    gridCols: 2
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DeviceInfo, {
                    entry: entry,
                    gridCols: 2,
                    campaignType: campaignType,
                    customEvents: customEvents
                })
            ]
        })
    });
};
/* harmony default export */ var Feedback = (FeedbackMain);

// EXTERNAL MODULE: ./src/utils/fieldUtils.ts
var fieldUtils = __webpack_require__(55242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/NumericCell.tsx
var NumericCell = __webpack_require__(84157);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/SelectableFieldCell.tsx
var SelectableFieldCell = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/RatingCell.tsx
var RatingCell = __webpack_require__(45718);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/CsatFieldCell.tsx
var CsatFieldCell = __webpack_require__(7507);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Survey/TextAreaFieldRenderer.tsx





var TextAreaFieldRenderer = function(param) {
    var value = param.value;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "break-all",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: (0,utils/* htmlEncodeByRegExp */.m9)((ref = value === null || value === void 0 ? void 0 : value.text) !== null && ref !== void 0 ? ref : "")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGroup/* default */.Z, {
                images: value === null || value === void 0 ? void 0 : value.screenshots,
                size: 40
            })
        ]
    });
};
/* harmony default export */ var Survey_TextAreaFieldRenderer = (TextAreaFieldRenderer);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Survey/getFieldRender.tsx











var getFieldComponent = function(field, data) {
    var _obj;
    var mapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.NpsField */.EIl.NpsField, /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericCell/* default */.Z, {
        renderedCellValue: data[field.code]
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CheckBox */.EIl.CheckBox, /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectableFieldCell/* default */.Z, {
        renderedCellValue: data[field.code],
        allowWrap: true,
        choiceHeight: "auto"
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.RadioButton */.EIl.RadioButton, /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectableFieldCell/* default */.Z, {
        renderedCellValue: data[field.code],
        choiceHeight: "auto"
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CtaField */.EIl.CtaField, /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectableFieldCell/* default */.Z, {
        renderedCellValue: data[field.code],
        choiceHeight: "auto"
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.RatingField */.EIl.RatingField, /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingCell/* default */.Z, {
        renderedCellValue: data[field.code],
        max: field.ratingMax
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CsatField */.EIl.CsatField, /*#__PURE__*/ (0,jsx_runtime.jsx)(CsatFieldCell/* default */.Z, {
        renderedCellValue: data[field.code]
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CesField */.EIl.CesField, /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericCell/* default */.Z, {
        renderedCellValue: data[field.code]
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.TextArea */.EIl.TextArea, /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_TextAreaFieldRenderer, {
        value: data[field.code]
    })), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.TextField */.EIl.TextField, /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        className: "break-all",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: (0,utils/* htmlEncodeByRegExp */.m9)(data[field.code])
            }
        })
    })), _obj);
    return mapping[field.type];
};
var getFieldRender = function(param) {
    var data = param.data, field = param.field;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
        withBorder: true,
        p: "sm",
        mih: "40px",
        mah: "320px",
        className: "overflow-y-auto",
        children: getFieldComponent(field, data)
    });
};
/* harmony default export */ var Survey_getFieldRender = (getFieldRender);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/Survey/index.tsx







var SurveyMain = function(param) {
    var data = param.data, formFields = param.formFields;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("entry").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
        py: "lg",
        px: "3xl",
        h: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: 32,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    order: 5,
                    mb: "calc(".concat(theme.spacing.xl, "-").concat(theme.spacing.lg, ") * -1"),
                    children: t("entryModal.formEntry")
                }),
                formFields.map(function(field, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: "sm",
                            className: "grow",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    align: "flex-start",
                                    noWrap: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* FieldIcon */.fw, {
                                            className: "p-[2px] !h-[20px]",
                                            type: field.type
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            className: "break-all",
                                            children: t("entryModal.fieldIndexWithLabel", {
                                                fieldIndex: (0,fieldUtils/* shouldShowFieldInEntryModal */.Tx)(field) ? undefined : index + 1,
                                                fieldLabel: field.label
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    ml: 36,
                                    children: Survey_getFieldRender({
                                        data: data,
                                        field: field
                                    })
                                })
                            ]
                        })
                    }, field.code);
                })
            ]
        })
    });
};
/* harmony default export */ var Survey = (SurveyMain);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Content/index.tsx












function getIsDisplayedLikeSurveyForm(type, widgetType) {
    return type === domain/* CampaignType.Survey */.mL.Survey || type === domain/* CampaignType.Notification */.mL.Notification && widgetType !== domain/* CampaignWidgetType.Banner */.YMh.Banner;
}
var EntryModalContent = function(props) {
    var ref, ref1;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var canAddToSegment = props.canAddToSegment, data = props.data, targetAside = props.targetAside, fields = props.fields, campaignType = props.campaignType, widgetType = props.widgetType, updateReplyCallBack = props.updateReplyCallBack;
    var appId = (router_default()).query.appId;
    var isDisplayedSurveyForm = getIsDisplayedLikeSurveyForm(campaignType, widgetType);
    var ref2 = (0,react.useMemo)(function() {
        return (0,utils/* groupFields */.wm)(fields);
    }, [
        fields
    ]), formFields = ref2.formFields, customerFields = ref2.customerFields;
    var ref3 = (0,domain/* useCustomApplicationEventsQuery */.hvr)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: appId,
            pageArguments: {
                first: constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        }
    }), eventsData = ref3.data, loading = ref3.loading, variables = ref3.variables;
    var events = (0,react.useMemo)(function() {
        var ref, ref1;
        return (eventsData === null || eventsData === void 0 ? void 0 : (ref = eventsData.application) === null || ref === void 0 ? void 0 : (ref1 = ref.customApplicationEvents) === null || ref1 === void 0 ? void 0 : ref1.nodes) || [];
    }, [
        eventsData === null || eventsData === void 0 ? void 0 : (ref = eventsData.application) === null || ref === void 0 ? void 0 : (ref1 = ref.customApplicationEvents) === null || ref1 === void 0 ? void 0 : ref1.nodes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        spacing: 0,
        align: "self-start",
        w: 1000,
        h: "calc(100vh - ".concat(constants/* outsideModalBodyHeight */.nr, "px)"),
        children: loading && !(0,cacheUtils/* isCacheHit */.b)(variables, domain/* CustomApplicationEventsDocument */.tzi) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOverlay/* LoadingOverlay */.f, {
            visible: true
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    w: "64%",
                    h: "100%",
                    children: isDisplayedSurveyForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {
                        data: data,
                        formFields: formFields
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback, {
                        entry: data.entry,
                        formFields: formFields,
                        customerFields: customerFields,
                        customEvents: events,
                        campaignType: campaignType
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    w: "36%",
                    sx: {
                        borderLeft: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.2", theme))
                    },
                    h: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Aside, {
                        campaignType: campaignType,
                        entry: data.entry,
                        targetAside: targetAside,
                        isDisplayedSurveyForm: isDisplayedSurveyForm,
                        customerFields: customerFields,
                        customEvents: events,
                        canAddToSegment: canAddToSegment,
                        updateReplyCallBack: updateReplyCallBack
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var EntryModal_Content = (EntryModalContent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./src/components/ui/ItemNavigator/index.tsx
var ItemNavigator = __webpack_require__(43016);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/CopyButton/CopyButton.js
var CopyButton = __webpack_require__(77292);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconLink.js
var IconLink = __webpack_require__(27600);
// EXTERNAL MODULE: ./src/components/ui/message/index.tsx
var message = __webpack_require__(92309);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Header/CopyShareUrl.tsx











var _obj;
var entriesPathMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* CampaignType.Survey */.mL.Survey, constants/* ApplicationSurveyEntry */.__), (0,_define_property/* default */.Z)(_obj, domain/* CampaignType.Feedback */.mL.Feedback, constants/* ApplicationFeedbackEntry */.HE), (0,_define_property/* default */.Z)(_obj, domain/* CampaignType.Notification */.mL.Notification, constants/* ApplicationNotificationEntry */.E), _obj);
var CopyShareUrl = function(param) {
    var serialNumber = param.serialNumber, campaignId = param.campaignId, campaignType = param.campaignType;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var router = (0,next_router.useRouter)();
    var handleCopy = function() {
        message/* default.successMsg */.Z.successMsg(t("entryModal.shareDescription"), t("common:message.linkCopySuccess"));
    };
    var getShareLink = function() {
        var path = entriesPathMap[campaignType].replace("[appId]", router.query.appId).replace("[campaignId]", campaignId).replace("[serialNumber]", serialNumber.toString());
        return "https://app-cny.howxm.com" + path;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
        value: getShareLink(),
        children: function(param) {
            var copy = param.copy;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                withArrow: true,
                label: t("entryModal.shareDescription"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                    onClick: function() {
                        copy();
                        handleCopy();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink/* default */.Z, {
                        size: 18,
                        color: (0,getColor/* getTextColor */.uu)("gray.7", theme)
                    })
                })
            });
        }
    });
};
/* harmony default export */ var Header_CopyShareUrl = (CopyShareUrl);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Popover/Popover.js + 7 modules
var Popover = __webpack_require__(4502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-event/use-window-event.js
var use_window_event = __webpack_require__(12667);
// EXTERNAL MODULE: ./src/components/business/Campaign/CampaignContext/index.ts + 3 modules
var CampaignContext = __webpack_require__(39624);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Header/DeleteEntry.tsx













var DeleteEntry = function(param) {
    var entryId = param.entryId, onOk = param.onOk;
    var ref;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var id = campaign === null || campaign === void 0 ? void 0 : campaign.id;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,domain/* useDeleteEntriesMutation */.EvW)(), 1), deleteEntriesMutation = ref1[0];
    var deletable = (0,business/* useCampaignPermission */.L9)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.id).deletable;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref2[0], ref3 = ref2[1], close = ref3.close, open = ref3.open;
    var ref4 = (0,use_click_outside/* useClickOutside */.O)(function() {
        return close();
    });
    (0,use_window_event/* useWindowEvent */.s)("resize", close);
    if (!deletable) {
        return null;
    }
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            deleteEntriesMutation({
                                variables: {
                                    input: {
                                        campaignId: id,
                                        entryIds: [
                                            entryId
                                        ]
                                    }
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.deleteEntries) {
                            onOk === null || onOk === void 0 ? void 0 : onOk();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        ui/* message.error */.yw.error(t("common:message.deleteError"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        opened: opened,
        position: "bottom-end",
        width: 280,
        shadow: "xl",
        offset: 18,
        styles: {
            dropdown: {
                transform: "translateX(-6px)"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                    withArrow: true,
                    label: t("common:actions.deleteData"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                        onClick: open,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* default */.Z, {
                            size: 18,
                            color: "red"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "lg",
                    ref: ref4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            children: t("delete.content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "sm",
                            position: "right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    size: "xs",
                                    variant: "default",
                                    onClick: close,
                                    children: t("common:actions.cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    size: "xs",
                                    color: "red",
                                    onClick: handleDelete,
                                    children: t("common:actions.delete")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Header_DeleteEntry = (DeleteEntry);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Header/index.tsx









var EntryModalHeader = function(props) {
    var campaignId = props.campaignId, campaignType = props.campaignType, _enableSwitchEntry = props.enableSwitchEntry, enableSwitchEntry = _enableSwitchEntry === void 0 ? true : _enableSwitchEntry, entry = props.entry, _enableRemoveEntry = props.enableRemoveEntry, enableRemoveEntry = _enableRemoveEntry === void 0 ? true : _enableRemoveEntry, onRemoveEntry = props.onRemoveEntry, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "campaignId",
        "campaignType",
        "enableSwitchEntry",
        "entry",
        "enableRemoveEntry",
        "onRemoveEntry"
    ]);
    var t = (0,useTranslation/* default */.Z)("entry").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 5,
                children: t("entryModal.serialNumber", {
                    serialNumber: entry.serialNumber
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_CopyShareUrl, {
                        campaignId: campaignId,
                        campaignType: campaignType,
                        serialNumber: entry === null || entry === void 0 ? void 0 : entry.serialNumber
                    }),
                    enableRemoveEntry && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_DeleteEntry, {
                        entryId: entry.id,
                        onOk: onRemoveEntry
                    }),
                    enableSwitchEntry && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNavigator/* ItemNavigator */.x, (0,_object_spread/* default */.Z)({}, restProps))
                ]
            })
        ]
    });
};
/* harmony default export */ var Header = (EntryModalHeader);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/useEntryModal.tsx









function useEntryModal(canAddToSegment) {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var open = function(props) {
        var data = props.data, fields = props.fields, onClose = props.onClose, campaignId = props.campaignId, campaignType = props.campaignType, widgetType = props.widgetType, targetAside = props.targetAside, updateReplyCallBack = props.updateReplyCallBack;
        (0,events/* openModal */.h7)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,constants/* modalConfig */.NQ)(theme)), {
            modalId: "entryModal",
            onClose: onClose,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                campaignId: campaignId,
                campaignType: campaignType,
                enableSwitchEntry: false,
                enableRemoveEntry: false,
                entry: data.entry
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryModal_Content, {
                canAddToSegment: canAddToSegment,
                widgetType: widgetType,
                campaignType: campaignType,
                data: data,
                fields: fields,
                targetAside: targetAside,
                updateReplyCallBack: updateReplyCallBack
            })
        }));
    };
    return {
        open: open
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/noop.js
var noop = __webpack_require__(77047);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(61843);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/EntriesContext/index.ts + 3 modules
var EntriesContext = __webpack_require__(16426);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-abac@0.1.10_react@18.2.0/node_modules/react-abac/dist/index.es.js
var dist_index_es = __webpack_require__(8470);
;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/Modal.tsx













var EntryModal = function(props) {
    var opened = props.opened, onClose = props.onClose, previousDisabled = props.previousDisabled, nextDisabled = props.nextDisabled, onPrevious = props.onPrevious, onNext = props.onNext, data = props.data, onRemove = props.onRemove, targetAside = props.targetAside;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var formFields = (0,EntriesContext/* useEntries */.Di)().formFields;
    var ref = (0,react.useState)(false), keyboardDisabled = ref[0], setKeyboardDisabled = ref[1];
    var userHasPermissions = (0,dist_index_es/* useAbac */.nn)().userHasPermissions;
    var canAddToSegment = userHasPermissions(domain/* ApplicationPermission.CustomerSegmentManage */.eC6.CustomerSegmentManage);
    var handleKeyDown = function(e) {
        if (keyboardDisabled) {
            return;
        }
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
            e.preventDefault();
            if (!previousDisabled) {
                onPrevious === null || onPrevious === void 0 ? void 0 : onPrevious();
            }
        }
        if (e.key === "ArrowDown" || e.key === "ArrowRight") {
            e.preventDefault();
            if (!nextDisabled) {
                onNext === null || onNext === void 0 ? void 0 : onNext();
            }
        }
    };
    var handleRemoveEntry = function() {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,constants/* modalConfig */.NQ)(theme)), {
        opened: opened,
        onClose: onClose !== null && onClose !== void 0 ? onClose : noop/* default */.Z,
        onKeyDown: handleKeyDown,
        closeOnEscape: !keyboardDisabled,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
            entry: data === null || data === void 0 ? void 0 : data.entry,
            campaignId: campaign === null || campaign === void 0 ? void 0 : campaign.id,
            campaignType: campaign === null || campaign === void 0 ? void 0 : campaign.type,
            previousDisabled: previousDisabled,
            nextDisabled: nextDisabled,
            onPrevious: onPrevious,
            onNext: onNext,
            onRemoveEntry: handleRemoveEntry
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryModal_Content, {
            canAddToSegment: canAddToSegment,
            campaignType: campaign === null || campaign === void 0 ? void 0 : campaign.type,
            widgetType: campaign === null || campaign === void 0 ? void 0 : campaign.widget.type,
            data: data,
            fields: formFields,
            targetAside: targetAside,
            onLightboxToggle: setKeyboardDisabled
        })
    }));
};
/* harmony default export */ var EntryModal_Modal = (EntryModal);

;// CONCATENATED MODULE: ./src/components/business/Campaign/EntryModal/index.ts





/***/ }),

/***/ 76626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ FeatureUnavailable_Alert; },
  "A": function() { return /* reexport */ Icon; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Alert/Alert.js + 1 modules
var Alert = __webpack_require__(64405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconAlertCircle.js
var IconAlertCircle = __webpack_require__(39747);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./src/components/business/ProductsModal/index.ts + 13 modules
var ProductsModal = __webpack_require__(7921);
;// CONCATENATED MODULE: ./src/components/business/Campaign/FeatureUnavailable/Message.tsx








var Message = function(param) {
    var feature = param.feature, anchor = param.anchor;
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        i18nKey: "componentCampaignList:featureUnavailable",
        components: {
            upgrade: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, anchor), {
                onClick: function() {
                    return (0,ProductsModal/* openProductsModal */.$P)(t("product:feature.".concat(feature, ".eventAttr")));
                }
            }))
        }
    });
};
/* harmony default export */ var FeatureUnavailable_Message = (Message);

;// CONCATENATED MODULE: ./src/components/business/Campaign/FeatureUnavailable/Alert.tsx








var FeatureUnavailableAlert = function(_param) /*#__PURE__*/ {
    var feature = _param.feature, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "feature"
    ]);
    return (0,jsx_runtime.jsx)(Alert/* Alert */.b, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlertCircle/* default */.Z, {
            size: 16
        }),
        color: "red"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureUnavailable_Message, {
            feature: feature
        })
    }));
};
/* harmony default export */ var FeatureUnavailable_Alert = (FeatureUnavailableAlert);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
;// CONCATENATED MODULE: ./src/components/business/Campaign/FeatureUnavailable/Icon.tsx





var FeatureUnavailableIcon = function(param) {
    var feature = param.feature;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
        withArrow: true,
        withinPortal: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    lh: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlertCircle/* default */.Z, {
                        size: 16,
                        color: theme.colors.red[6],
                        stroke: 1.5
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureUnavailable_Message, {
                    feature: feature,
                    anchor: {
                        underline: true
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Icon = (FeatureUnavailableIcon);

;// CONCATENATED MODULE: ./src/components/business/Campaign/FeatureUnavailable/index.tsx





/***/ }),

/***/ 47593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "El": function() { return /* reexport */ CampaignFilterProvider; },
  "aB": function() { return /* reexport */ useCampaignFilter; },
  "zl": function() { return /* reexport */ useCampaignFilterActions; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/noop.js
var noop = __webpack_require__(77047);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/CampaignFilterContext/CampaignFilterContext.ts


var CampaignFilterContext = (0,react.createContext)({
    filter: null
});
var CampaignFilterActionContext = (0,react.createContext)({
    onFieldsChange: noop/* default */.Z,
    onExplicitlyFieldChange: noop/* default */.Z
});

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/CampaignFilterContext/useCampaignFilter.ts


function useCampaignFilter() {
    var context = (0,react.useContext)(CampaignFilterContext);
    if (context === undefined) {
        throw new Error("useCampaignFilter must be used within a CampaignFilterProvider");
    }
    return context;
}
function useCampaignFilterActions() {
    var context = (0,react.useContext)(CampaignFilterActionContext);
    if (context === undefined) {
        throw new Error("useCampaignFilterActions must be used within a CampaignFilterActionsProvider");
    }
    return context;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./src/config/constants/fieldType.ts
var fieldType = __webpack_require__(68123);
// EXTERNAL MODULE: ./node_modules/.pnpm/immutability-helper@3.1.1/node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(89887);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/concat.js
var concat = __webpack_require__(35030);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(21577);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(96634);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/omit-deep-lodash@1.1.7/node_modules/omit-deep-lodash/lib/index.js
var lib = __webpack_require__(76190);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/CampaignFilterContext/CampaignFilterProvider.tsx











var defaultFilter = {
    operator: domain/* ConditionGroupOperator.And */.ZOu.And,
    conditions: []
};
var findConditionIndexByCode = function(conditions, code) {
    return conditions === null || conditions === void 0 ? void 0 : conditions.findIndex(function(param) {
        var firstNode = param.firstNode;
        return firstNode.value === code;
    });
};
function CampaignFilterProvider(props) {
    var defaultValue = props.defaultValue, children = props.children;
    var campaignId = (0,router.useRouter)().query.campaignId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpsertCampaignSettingMutation */.Gm1)(), 1), updateCampaignSettingMutation = ref[0];
    var ref1;
    var ref2 = (0,react.useState)((ref1 = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.filter) !== null && ref1 !== void 0 ? ref1 : defaultFilter), filter = ref2[0], setFilter = ref2[1];
    var onExplicitlyFieldChange = function(code, condition) {
        var index = findConditionIndexByCode(filter === null || filter === void 0 ? void 0 : filter.conditions, code);
        var updatedFilter = filter;
        if (index > -1) {
            if ((0,isNil/* default */.Z)(condition)) {
                updatedFilter = immutability_helper_default()(filter, {
                    conditions: {
                        $splice: [
                            [
                                index,
                                1
                            ]
                        ]
                    }
                });
            } else {
                updatedFilter = immutability_helper_default()(filter, {
                    conditions: {
                        $splice: [
                            [
                                index,
                                1,
                                condition
                            ]
                        ]
                    }
                });
            }
        } else if (!(0,isNil/* default */.Z)(condition)) {
            updatedFilter = immutability_helper_default()(filter, {
                conditions: {
                    $push: [
                        condition
                    ]
                }
            });
        }
        setFilter(updatedFilter);
        if (code !== fieldType/* keywordCode */.__) {
            updateUserCampaignSetting(updatedFilter);
        }
    };
    var onFieldsChange = function(explicitlyFieldCodes, conditions) {
        var otherConditions = filter.conditions.filter(function(param) {
            var firstNode = param.firstNode;
            return explicitlyFieldCodes.includes(firstNode.value);
        });
        var newConditions = lib_default()((0,concat/* default */.Z)(otherConditions, conditions), [
            "firstNode.type"
        ]);
        var updatedFilter = immutability_helper_default()(filter, {
            conditions: {
                $set: newConditions
            }
        });
        setFilter(updatedFilter);
        updateUserCampaignSetting(updatedFilter);
    };
    var debouncedUpdateFilter = (0,debounce/* default */.Z)(onFieldsChange, 500);
    var updateUserCampaignSetting = function(updatedFilter) {
        var finalFilter = (0,isEqual/* default */.Z)(lib_default()(updatedFilter, "__typename"), lib_default()(defaultFilter, "__typename")) ? null : updatedFilter;
        updateCampaignSettingMutation({
            variables: {
                input: (0,_define_property/* default */.Z)({
                    campaignId: campaignId
                }, defaultValue.key, finalFilter)
            }
        }).then();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignFilterActionContext.Provider, {
        value: {
            onFieldsChange: debouncedUpdateFilter,
            onExplicitlyFieldChange: onExplicitlyFieldChange
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignFilterContext.Provider, {
            value: {
                filter: filter
            },
            children: children
        })
    });
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/CampaignFilterContext/index.ts




/***/ }),

/***/ 99241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CreatedAtSelector; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./src/components/business/Campaign/Filter/CampaignFilterContext/index.ts + 3 modules
var CampaignFilterContext = __webpack_require__(47593);
// EXTERNAL MODULE: ./src/config/constants/fieldType.ts
var fieldType = __webpack_require__(68123);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(47142);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(96634);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Popover/Popover.js + 7 modules
var Popover = __webpack_require__(4502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(97684);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(81533);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconCalendar.js
var IconCalendar = __webpack_require__(58420);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/formatISO/index.js
var formatISO = __webpack_require__(91095);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+dates@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_dayjs@1.11.6_react@18.2.0/node_modules/@mantine/dates/esm/components/DatePicker/DatePicker.js + 2 modules
var DatePicker = __webpack_require__(10730);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconX.js
var IconX = __webpack_require__(88998);
// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/components/CreatedAtSelector/CustomizeDatePicker.tsx












var CustomizeDatePicker = function(param) {
    var onChange = param.onChange, onClose = param.onClose, value = param.value;
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var defaultValue = (value === null || value === void 0 ? void 0 : value.type) === domain/* ConditionNodeType.CustomizedPeriod */.BAL.CustomizedPeriod ? value.value : [
        null,
        null
    ];
    var ref = (0,react.useState)(defaultValue), dateValue = ref[0], setDateValue = ref[1];
    var onOk = function(value) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    var label = (0,utils/* formatRangeDates */.z5)(dateValue);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: "sm",
        pt: "md",
        pb: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                p: "sm",
                mx: "md",
                sx: function(theme) {
                    return {
                        border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.2", theme)),
                        borderRadius: theme.radius.sm
                    };
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: (0,getColor/* getTextColor */.uu)(label ? "gray.9" : "gray.5", theme),
                            children: label || t("datePeriodPlaceholder")
                        }),
                        label && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconX/* default */.Z, {
                            size: 14,
                            color: (0,getColor/* getTextColor */.uu)("gray.6", theme),
                            onClick: function() {
                                return setDateValue([
                                    null,
                                    null
                                ]);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* DatePicker */.M, {
                type: "range",
                value: dateValue,
                onChange: function(value) {
                    var _value = (0,_sliced_to_array/* default */.Z)(value, 2), start = _value[0], end = _value[1];
                    var endDate = end ? (0,utils/* endOfDate */.zp)(end) : null;
                    setDateValue([
                        start,
                        endDate
                    ]);
                },
                mx: "md",
                monthLabelFormat: "YYYY/MM",
                locale: "zh-CN",
                allowSingleDateInRange: true,
                firstDayOfWeek: 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "sm",
                mr: "md",
                position: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "default",
                        size: "xs",
                        onClick: onClose,
                        children: t("common:actions.cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        size: "xs",
                        disabled: !dateValue[0] || !dateValue[1],
                        onClick: function() {
                            onOk({
                                value: [
                                    (0,formatISO/* default */.Z)(dateValue[0]),
                                    (0,formatISO/* default */.Z)(dateValue[1])
                                ],
                                type: domain/* ConditionNodeType.CustomizedPeriod */.BAL.CustomizedPeriod
                            });
                        },
                        children: t("common:actions.save")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CreatedAtSelector_CustomizeDatePicker = (CustomizeDatePicker);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/components/CreatedAtSelector/SelectItems.tsx







var EntryCreatedAt;
(function(EntryCreatedAt) {
    EntryCreatedAt["lastTwentyFourHours"] = "LAST_TWENTY_FOUR_HOURS";
    EntryCreatedAt["lastSevenDays"] = "LAST_SEVEN_DAYS";
    EntryCreatedAt["lastFourteenDays"] = "LAST_FOURTEEN_DAYS";
    EntryCreatedAt["lastThirtyDays"] = "LAST_THIRTY_DAYS";
    EntryCreatedAt["customizedPeriod"] = "CUSTOMIZED_PERIOD";
})(EntryCreatedAt || (EntryCreatedAt = {}));
var SelectItems = function(param, ref) {
    var onChange = param.onChange, onClose = param.onClose, value = param.value;
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var onOk = function(value) {
        onChange(value);
    };
    var options = (0,react.useMemo)(function() {
        return [
            "ALL",
            EntryCreatedAt.lastTwentyFourHours,
            EntryCreatedAt.lastSevenDays,
            EntryCreatedAt.lastFourteenDays,
            EntryCreatedAt.lastThirtyDays,
            EntryCreatedAt.customizedPeriod, 
        ].map(function(code) {
            return {
                label: t("createdAtOption.".concat(code)),
                value: code
            };
        });
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        spacing: 0,
        ref: ref,
        children: options.map(function(option) {
            var isCustomizedPeriod = option.value === EntryCreatedAt.customizedPeriod;
            var isCurrentOption = option.value === value.value || isCustomizedPeriod && value.type === domain/* ConditionNodeType.CustomizedPeriod */.BAL.CustomizedPeriod;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                px: "sm",
                py: "5.4px",
                sx: {
                    backgroundColor: isCurrentOption ? (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme) : "transparent",
                    borderRadius: theme.radius.xs,
                    "&:hover": {
                        backgroundColor: (0,getColor/* getBackgroundColor */.dF)(isCurrentOption ? "brandBlue.0" : "gray.1", theme)
                    },
                    cursor: "pointer"
                },
                children: isCustomizedPeriod ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                    shadow: "md",
                    position: "right",
                    offset: 16,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: option.label
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                            p: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatedAtSelector_CustomizeDatePicker, {
                                value: value,
                                onChange: onChange,
                                onClose: onClose
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    onClick: function() {
                        return onOk({
                            value: option.value,
                            type: domain/* ConditionNodeType.Period */.BAL.Period
                        });
                    },
                    children: option.label
                })
            }, option.value);
        })
    });
};
/* harmony default export */ var CreatedAtSelector_SelectItems = (/*#__PURE__*/(0,react.forwardRef)(SelectItems));

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/components/CreatedAtSelector/index.tsx


















var defaultValue = {
    type: domain/* ConditionNodeType.Period */.BAL.Period,
    value: "ALL"
};
var CreatedAtSelector = function(props) {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var _withPaper = props.withPaper, withPaper = _withPaper === void 0 ? false : _withPaper;
    var filter = (0,CampaignFilterContext/* useCampaignFilter */.aB)().filter;
    var onExplicitlyFieldChange = (0,CampaignFilterContext/* useCampaignFilterActions */.zl)().onExplicitlyFieldChange;
    var value = (0,react.useMemo)(function() {
        var ref, ref1;
        var secondNode = (ref1 = (ref = filter === null || filter === void 0 ? void 0 : filter.conditions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var firstNode = param.firstNode;
            return firstNode.value === fieldType/* createdAtCode */.h1;
        })) === null || ref1 === void 0 ? void 0 : ref1.secondNode;
        if ((0,isNil/* default */.Z)(secondNode)) {
            return defaultValue;
        }
        if ((secondNode === null || secondNode === void 0 ? void 0 : secondNode.type) == domain/* ConditionNodeType.CustomizedPeriod */.BAL.CustomizedPeriod) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, secondNode), {
                value: [
                    (0,parseISO/* default */.Z)(secondNode === null || secondNode === void 0 ? void 0 : secondNode.value[0]),
                    (0,parseISO/* default */.Z)(secondNode === null || secondNode === void 0 ? void 0 : secondNode.value[1])
                ]
            });
        }
        return secondNode;
    }, [
        filter
    ]);
    var ref2 = (0,use_click_outside/* useClickOutside */.O)(function() {
        close();
    });
    var handleClose = function() {
        close();
    };
    var handleChange = function(value) {
        if ((0,isEqual/* default */.Z)(value, defaultValue)) {
            onExplicitlyFieldChange(fieldType/* createdAtCode */.h1, null);
        } else {
            onExplicitlyFieldChange(fieldType/* createdAtCode */.h1, {
                operator: domain/* ConditionOperator.DateBetween */.N0$.DateBetween,
                firstNode: {
                    value: fieldType/* createdAtCode */.h1
                },
                secondNode: value
            });
        }
        close();
    };
    var label = value.type === domain/* ConditionNodeType.Period */.BAL.Period ? t("createdAtOption.".concat(value.value)) : (0,utils/* formatRangeDates */.z5)(value.value);
    var paperProps = withPaper ? {
        withBorder: true,
        p: "xs"
    } : {
        sx: {
            backgroundColor: "transparent"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        offset: 4,
        width: 178,
        opened: opened,
        withinPortal: true,
        position: "bottom-start",
        shadow: "md",
        radius: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, paperProps), {
                    radius: "sm",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        h: 30,
                        spacing: "xs",
                        px: "sm",
                        onClick: open,
                        noWrap: true,
                        sx: function(theme) {
                            return {
                                borderRadius: theme.radius.xs,
                                cursor: "pointer",
                                "&:hover": {
                                    background: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                                },
                                "&:active": {
                                    transform: "translateY(1px)"
                                }
                            };
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCalendar/* default */.Z, {
                                stroke: 1.5,
                                size: 18,
                                color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                className: "select-none",
                                children: label
                            })
                        ]
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                p: "xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatedAtSelector_SelectItems, {
                    value: value,
                    onChange: handleChange,
                    onClose: handleClose,
                    ref: ref2
                })
            })
        ]
    });
};
/* harmony default export */ var components_CreatedAtSelector = (CreatedAtSelector);


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEntryFilterableFields; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70426);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22108);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59845);
/* harmony import */ var config_constants_fieldType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68123);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95660);
/* harmony import */ var _Entries_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10122);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34262);
/* harmony import */ var components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51945);











var baseCodes = [
    config_constants_fieldType__WEBPACK_IMPORTED_MODULE_3__/* .submitOnCode */ .Gg,
    config_constants_fieldType__WEBPACK_IMPORTED_MODULE_3__/* .deliveryMethodCode */ .jC,
    config_constants_fieldType__WEBPACK_IMPORTED_MODULE_3__/* .commentedCode */ .pn,
    config_constants_fieldType__WEBPACK_IMPORTED_MODULE_3__/* .refererCode */ .a9
];
var customerCodes = [
    config_constants__WEBPACK_IMPORTED_MODULE_4__/* .CUSTOMER_UID */ .tv,
    config_constants__WEBPACK_IMPORTED_MODULE_4__/* .CUSTOMER_MOBILE */ .L,
    config_constants__WEBPACK_IMPORTED_MODULE_4__/* .CUSTOMER_EMAIL */ .n,
    config_constants__WEBPACK_IMPORTED_MODULE_4__/* .CUSTOMER_NAME */ .rl
];
function useEntryFilterableFields() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("componentEntryFilter").t;
    var channel = (0,components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().channel;
    var systemFields = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return baseCodes.filter(function(code) {
            return channel !== types_domain__WEBPACK_IMPORTED_MODULE_2__/* .CampaignDistributionChannel.Link */ .wQf.Link || ![
                config_constants_fieldType__WEBPACK_IMPORTED_MODULE_3__/* .deliveryMethodCode */ .jC
            ].includes(code);
        }).map(function(code) {
            return {
                label: t("componentEntryFilter:systemFields.entry.".concat(code)),
                type: "entry.".concat(code),
                code: code
            };
        });
    // eslint-disable-next-line
    }, []);
    var customerField = customerCodes.map(function(code) {
        return {
            label: t("customer:".concat(code)),
            type: code,
            code: code
        };
    });
    return function(fields, customerAttributes, excludeCodes) {
        var fieldsWithAlias = fields.map(function(f) {
            var ref;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, f), {
                // 为了用户属性的alias支持搜索
                alias: (0,lodash_es__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((ref = customerAttributes.find(function(attributeItem) {
                    return attributeItem.code === f.code;
                })) === null || ref === void 0 ? void 0 : ref.aliases)
            });
        });
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(fieldsWithAlias).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(customerField), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(systemFields)).filter(function(field) {
            return !_Entries_constants__WEBPACK_IMPORTED_MODULE_5__/* .UNFILTERABLE_FIELD_TYPES.includes */ .cO.includes(field.type);
        }).filter(function(field) {
            return !(excludeCodes === null || excludeCodes === void 0 ? void 0 : excludeCodes.includes(field.code));
        });
    };
}


/***/ }),

/***/ 61577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ convertToValidConditionGroup; },
/* harmony export */   "b": function() { return /* binding */ convertToFieldFilterPopoverValue; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46550);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89887);
/* harmony import */ var immutability_helper__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(immutability_helper__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14418);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71557);
/* harmony import */ var config_constants_fieldType__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68123);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95660);








var customerCodes = [
    config_constants__WEBPACK_IMPORTED_MODULE_5__/* .CUSTOMER_UID */ .tv,
    config_constants__WEBPACK_IMPORTED_MODULE_5__/* .CUSTOMER_MOBILE */ .L,
    config_constants__WEBPACK_IMPORTED_MODULE_5__/* .CUSTOMER_EMAIL */ .n,
    config_constants__WEBPACK_IMPORTED_MODULE_5__/* .CUSTOMER_NAME */ .rl
];
var dateOperator = [
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.DateEq */ .N0$.DateEq,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.DateNe */ .N0$.DateNe,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.Before */ .N0$.Before,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.After */ .N0$.After,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.DateBetween */ .N0$.DateBetween,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.DateNotBetween */ .N0$.DateNotBetween, 
];
var isNonDatetimeCustomerOrSceneCondition = function(condition) {
    return !customerCodes.includes(condition.firstNode.value) && (condition.firstNode.value.startsWith(config__WEBPACK_IMPORTED_MODULE_3__/* .codePrefix.scene */ .T.scene) || condition.firstNode.value.startsWith(config__WEBPACK_IMPORTED_MODULE_3__/* .codePrefix.customer */ .T.customer)) && !dateOperator.includes(condition.operator);
};
// 这个函数是将 report、entries 中的FilterPopover组件的值转换成请求后端需要的conditionGroup
function convertToValidConditionGroup(conditionGroup) {
    return immutability_helper__WEBPACK_IMPORTED_MODULE_1___default()(conditionGroup, {
        conditions: {
            $set: conditionGroup.conditions.map(function(condition) {
                if (condition.operator === components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_2__/* .Mine */ .zn) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, condition), {
                        operator: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.Eq */ .N0$.Eq,
                        secondNode: {
                            value: components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_2__/* .Mine */ .zn
                        }
                    });
                }
                if (isNonDatetimeCustomerOrSceneCondition(condition) && condition.operator !== types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.NumberBetween */ .N0$.NumberBetween) {
                    var ref, ref1, ref2;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, condition), {
                        secondNode: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, condition.secondNode), {
                            value: Array.isArray((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) ? (ref1 = condition.secondNode) === null || ref1 === void 0 ? void 0 : ref1.value[0] : (ref2 = condition.secondNode) === null || ref2 === void 0 ? void 0 : ref2.value
                        })
                    });
                }
                return condition;
            })
        }
    });
}
// 这个函数是将后端保存conditionGroup转换成FilterPopover需要的值，与上面的函数作用刚好相反
function convertToFieldFilterPopoverValue(value) {
    if (!value) {
        return undefined;
    }
    return immutability_helper__WEBPACK_IMPORTED_MODULE_1___default()(value, {
        conditions: {
            $set: value.conditions.map(function(condition) {
                var ref;
                if (condition.firstNode.value === config_constants_fieldType__WEBPACK_IMPORTED_MODULE_4__/* .commentedCode */ .pn && ((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) === components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_2__/* .Mine */ .zn) {
                    return {
                        firstNode: {
                            value: config_constants_fieldType__WEBPACK_IMPORTED_MODULE_4__/* .commentedCode */ .pn
                        },
                        operator: components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_2__/* .Mine */ .zn,
                        secondNode: {
                            value: ""
                        }
                    };
                }
                if (isNonDatetimeCustomerOrSceneCondition(condition) && condition.operator !== types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.NumberBetween */ .N0$.NumberBetween) {
                    var ref1, ref2, ref3;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, condition), {
                        secondNode: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, condition.secondNode), {
                            value: Array.isArray((ref1 = condition.secondNode) === null || ref1 === void 0 ? void 0 : ref1.value) ? (ref2 = condition.secondNode) === null || ref2 === void 0 ? void 0 : ref2.value : [
                                (ref3 = condition.secondNode) === null || ref3 === void 0 ? void 0 : ref3.value
                            ]
                        })
                    });
                }
                return condition;
            })
        }
    });
}


/***/ }),

/***/ 95429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25328);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56674);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95202);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14661);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36078);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81533);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12667);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69523);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);
/* harmony import */ var components_business_Campaign_ActionMenus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99766);








var Actions = function(props) {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .useMantineTheme */ .rZ)();
    var campaign = props.campaign, onRefresh = props.onRefresh, onItemChange = props.onItemChange;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useDisclosure */ .q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var ref2 = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useClickOutside */ .O)(function() {
        return close();
    });
    (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useWindowEvent */ .s)("resize", close);
    var handleClickEventPropagation = function(event) {
        close();
        event.stopPropagation();
    };
    var handleDotsClick = function(event) {
        handleClickEventPropagation(event);
        open();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Menu */ .v, {
        width: 160,
        withinPortal: true,
        shadow: "xl",
        offset: 4,
        closeOnItemClick: true,
        position: "bottom-end",
        opened: opened,
        styles: function(theme) {
            return {
                itemIcon: {
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.7", theme)
                }
            };
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Menu.Target */ .v.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .ActionIcon */ .A, {
                    color: "dimmed",
                    onClick: handleDotsClick,
                    sx: function(theme) {
                        return {
                            "&:hover": {
                                backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBackgroundColor */ .dF)("gray.1", theme)
                            }
                        };
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        size: 18,
                        stroke: 2,
                        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.6", theme)
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Menu.Dropdown */ .v.Dropdown, {
                onClick: handleClickEventPropagation,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .x, {
                    ref: ref2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_business_Campaign_ActionMenus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        campaign: campaign,
                        onRefresh: onRefresh,
                        onDelete: onRefresh,
                        onChange: onItemChange
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Actions);


/***/ }),

/***/ 79845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L9": function() { return /* reexport */ useCampaignPermission; },
  "wf": function() { return /* reexport */ hooks_useCampaignStatusSwitch; },
  "r$": function() { return /* reexport */ useCheckCampaignPermission; },
  "KX": function() { return /* reexport */ useCheckCreateCampaign; },
  "RN": function() { return /* reexport */ useCheckCreateSurveyByAi; },
  "zT": function() { return /* reexport */ useDeleteCampaign; },
  "EC": function() { return /* reexport */ useDuplicateCampaignModal; },
  "YJ": function() { return /* reexport */ useEditCampaignGroupsModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react-abac@0.1.10_react@18.2.0/node_modules/react-abac/dist/index.es.js
var index_es = __webpack_require__(8470);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/components/business/hooks/useCurrentUserCache.ts
var useCurrentUserCache = __webpack_require__(77759);
// EXTERNAL MODULE: ./src/components/business/hooks/useApplicationRoleCache.ts
var useApplicationRoleCache = __webpack_require__(86851);
;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCampaignPermission.ts




function useCampaignPermission(creatorId) {
    var user = (0,useCurrentUserCache/* default */.Z)().user;
    var userHasPermissions = (0,index_es/* useAbac */.nn)().userHasPermissions;
    var applicationRole = (0,useApplicationRoleCache/* default */.Z)().applicationRole;
    var isCreator = creatorId === (user === null || user === void 0 ? void 0 : user.id);
    var isReader = (applicationRole === null || applicationRole === void 0 ? void 0 : applicationRole.type) === domain/* ApplicationRoleType.ApplicationReader */.rrC.ApplicationReader;
    var editable = (isCreator || userHasPermissions(domain/* ApplicationPermission.CampaignUpdate */.eC6.CampaignUpdate)) && !isReader;
    var deletable = (isCreator || userHasPermissions(domain/* ApplicationPermission.CampaignDelete */.eC6.CampaignDelete)) && !isReader;
    var creatable = userHasPermissions(domain/* ApplicationPermission.CampaignCreate */.eC6.CampaignCreate);
    var groupManageable = userHasPermissions(domain/* ApplicationPermission.CampaignGroupManage */.eC6.CampaignGroupManage);
    return {
        creatable: creatable,
        editable: editable,
        deletable: deletable,
        groupManageable: groupManageable
    };
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCheckCampaignPermission.ts




function useCheckCampaignPermission() {
    var user = (0,useCurrentUserCache/* default */.Z)().user;
    var applicationRole = (0,useApplicationRoleCache/* default */.Z)().applicationRole;
    var userHasPermissions = (0,index_es/* useAbac */.nn)().userHasPermissions;
    return function(creatorId, permission) {
        var isCreator = creatorId === (user === null || user === void 0 ? void 0 : user.id);
        var isReader = (applicationRole === null || applicationRole === void 0 ? void 0 : applicationRole.type) === domain/* ApplicationRoleType.ApplicationReader */.rrC.ApplicationReader;
        return (isCreator || userHasPermissions(permission)) && !isReader;
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/components/business/hooks/useCampaignsCountCache.ts
var useCampaignsCountCache = __webpack_require__(47820);
;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useDeleteCampaign.ts








function useDeleteCampaign(appId, campaign, onSuccess) {
    var id = campaign.id, type = campaign.type;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useDeleteCampaignMutation */.WdO)(), 1), deleteCampaignMutation = ref[0];
    var t = (0,useTranslation/* default */.Z)().t;
    var decrease = (0,useCampaignsCountCache/* default */.Z)(type).decrease;
    var deleteCampaign = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            deleteCampaignMutation({
                                variables: {
                                    id: id
                                },
                                onCompleted: function() {
                                    decrease();
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.deleteCampaign) {
                            ui/* message.successMsg */.yw.successMsg(t("common:message.deleteSuccess"));
                            onSuccess && onSuccess();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        graphQLErrors = e.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            defaultMessage: t("common:message.deleteError")
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function deleteCampaign() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        deleteCampaign: deleteCampaign
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/use-form.js + 17 modules
var use_form = __webpack_require__(68329);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+notifications@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/notifications/esm/events.js
var esm_events = __webpack_require__(35804);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(79965);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Select/Select.js + 2 modules
var Select = __webpack_require__(41754);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MultiSelect/MultiSelect.js + 4 modules
var MultiSelect = __webpack_require__(54253);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keyBy.js
var keyBy = __webpack_require__(60968);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/head.js
var head = __webpack_require__(34262);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./src/config/constants/campaignPathMapping.ts
var campaignPathMapping = __webpack_require__(68749);
// EXTERNAL MODULE: ./src/components/business/Layouts/ApplicationLayout/AppManager/AppInfo.tsx
var AppInfo = __webpack_require__(6525);
// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./src/components/business/hooks/useAccountSubscriptionCache.ts
var useAccountSubscriptionCache = __webpack_require__(19190);
;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCampaignsQuota.ts


function useCampaignsQuota() {
    var ref, ref1;
    var subscription = (0,useAccountSubscriptionCache/* default */.Z)().subscription;
    var ref2;
    var vas = (ref2 = subscription === null || subscription === void 0 ? void 0 : (ref = subscription.product) === null || ref === void 0 ? void 0 : ref.vas) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    return (ref3 = (ref1 = vas.find(function(param) {
        var type = param.type;
        return type === domain/* Feature.CampaignsCountPerApplication */.L0B.CampaignsCountPerApplication;
    })) === null || ref1 === void 0 ? void 0 : ref1.quota) !== null && ref3 !== void 0 ? ref3 : 0;
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useDuplicateCampaignModal.tsx

























var duplicateCampaignModalId = "duplicateCampaignModal";
var nameMaxLength = 40;
var ModalContent = function(param) {
    var _campaign = param.campaign, id = _campaign.id, type = _campaign.type, name = _campaign.name, groupIds = _campaign.groupIds, groupManageable = param.groupManageable, onSuccess = param.onSuccess;
    var ref;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,domain/* useDuplicateCampaignMutation */.Gid)(), 2), duplicateCampaignMutation = ref1[0], ref2 = ref1[1], duplicating = ref2.loading;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var campaignsQuota = useCampaignsQuota();
    var increase = (0,useCampaignsCountCache/* default */.Z)(type).increase;
    var ref3 = (0,react.useState)([]), applications = ref3[0], setApplications = ref3[1];
    var campaignTypeName = t("common:campaignTypeName.".concat(type));
    (0,domain/* useApplicationsQuery */.p$c)({
        onCompleted: function(resp) {
            var _applications;
            var apps = (_applications = resp.applications) !== null && _applications !== void 0 ? _applications : [];
            if (type === domain/* CampaignType.Notification */.mL.Notification) {
                setApplications(apps.filter(function(param) {
                    var distribution = param.distribution;
                    return distribution.channel === domain/* CampaignDistributionChannel.Web */.wQf.Web;
                }));
            } else {
                setApplications(apps);
            }
        }
    });
    var ref4 = (0,domain/* useApplicationsCampaignsCountQuery */.x7q)({
        fetchPolicy: "cache-and-network",
        variables: {
            type: type
        }
    }), data = ref4.data, loading = ref4.loading;
    var campaignsCountMap = (0,keyBy/* default */.Z)(data === null || data === void 0 ? void 0 : data.applications, "id");
    var ref5;
    var campaignCreatable = function(application) {
        var ref, ref1;
        return (ref5 = (ref = application.role) === null || ref === void 0 ? void 0 : (ref1 = ref.permissions) === null || ref1 === void 0 ? void 0 : ref1.includes(domain/* ApplicationPermission.CampaignCreate */.eC6.CampaignCreate)) !== null && ref5 !== void 0 ? ref5 : false;
    };
    var availableApplicationIds = applications === null || applications === void 0 ? void 0 : applications.filter(function(application) {
        return application.id in campaignsCountMap && campaignsCountMap[application.id].campaignsCount < campaignsQuota && campaignCreatable(application);
    }).map(function(param) {
        var id = param.id;
        return id;
    });
    var defaultApplicationId = (availableApplicationIds === null || availableApplicationIds === void 0 ? void 0 : availableApplicationIds.includes(appId)) ? appId : (0,head/* default */.Z)(availableApplicationIds);
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            name: t("list.action.duplicate.newName", {
                name: name
            }),
            applicationId: defaultApplicationId,
            groupIds: groupIds !== null && groupIds !== void 0 ? groupIds : []
        },
        validateInputOnBlur: true,
        validate: {
            name: function(val) {
                var value = val.trim();
                if (value.length === 0) {
                    return t("common:message.required", {
                        value: t("list.action.duplicate.name", {
                            campaignTypeName: campaignTypeName
                        })
                    });
                }
                if ((0,utils/* length */.kE)(value) > nameMaxLength) {
                    return t("common:message.charTooLong", {
                        size: nameMaxLength / 2
                    });
                }
                return null;
            }
        }
    });
    (0,react.useEffect)(function() {
        form.setFieldValue("applicationId", defaultApplicationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultApplicationId
    ]);
    var targetApplicationId = form.values.applicationId;
    var isSameApplication = targetApplicationId === appId;
    (0,react.useEffect)(function() {
        form.setFieldValue("groupIds", isSameApplication ? groupIds !== null && groupIds !== void 0 ? groupIds : [] : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        targetApplicationId
    ]);
    var ref6 = (0,domain/* useApplicationCampaignGroupsQuery */.TT_)({
        variables: {
            id: targetApplicationId,
            type: type
        },
        skip: (0,isNil/* default */.Z)(targetApplicationId) || !groupManageable
    }), campaignGroupsData = ref6.data;
    var ref7;
    var groupOptions = ((ref7 = campaignGroupsData === null || campaignGroupsData === void 0 ? void 0 : (ref = campaignGroupsData.application) === null || ref === void 0 ? void 0 : ref.campaignGroups) !== null && ref7 !== void 0 ? ref7 : []).map(function(group) {
        return {
            value: group.id,
            label: group.name
        };
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var targetAppId, _values, newName, applicationId, selectedGroupIds, data, newCampaignId, messageId, e, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        targetAppId = form.values.applicationId;
                        if (duplicating || (0,isNil/* default */.Z)(targetAppId)) {
                            return [
                                2
                            ];
                        }
                        _values = form.values, newName = _values.name, applicationId = _values.applicationId, selectedGroupIds = _values.groupIds;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            duplicateCampaignMutation({
                                variables: {
                                    input: (0,_object_spread/* default */.Z)({
                                        id: id,
                                        name: newName,
                                        applicationId: applicationId
                                    }, groupManageable && {
                                        groupIds: selectedGroupIds
                                    })
                                },
                                onCompleted: function() {
                                    increase();
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.duplicateCampaign) {
                            (0,events/* closeModal */.Mr)(duplicateCampaignModalId);
                            newCampaignId = data.duplicateCampaign.id;
                            messageId = "duplicateCampaignSuccessMessage:".concat(newCampaignId);
                            ui/* message.success */.yw.success({
                                id: messageId,
                                title: "".concat(campaignTypeName).concat(t("common:message.duplicateSuccess")),
                                message: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                    i18nKey: "componentCampaignList:list.action.duplicate.description",
                                    components: {
                                        edit: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                            href: {
                                                pathname: campaignPathMapping/* editPathMapping */.$[type],
                                                query: {
                                                    appId: targetAppId,
                                                    campaignId: newCampaignId,
                                                    isDuplicated: true
                                                }
                                            },
                                            onClick: function() {
                                                return (0,esm_events/* hideNotification */.yK)(messageId);
                                            }
                                        })
                                    }
                                }),
                                autoClose: 5000
                            });
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(targetAppId);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        graphQLErrors = e.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            defaultMessage: "".concat(campaignTypeName).concat(t("common:actions.duplicate")).concat(t("common:message.failed"))
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var quotaExceededTip = /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* FeatureTip */.i0, {
        feature: domain/* Feature.CampaignsCountPerApplication */.L0B.CampaignsCountPerApplication,
        transQuery: {
            count: campaignsQuota,
            campaignType: t(type)
        }
    });
    var noPermissionTip = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        size: "sm",
        children: t("list.action.duplicate.noPermissionTip", {
            campaignTypeName: campaignTypeName
        })
    });
    var applicationOptions = applications.filter(function(param) {
        var id = param.id, distribution = param.distribution;
        return id in campaignsCountMap && (type != domain/* CampaignType.Feedback */.mL.Feedback || ![
            domain/* CampaignDistributionChannel.WechatMiniapp */.wQf.WechatMiniapp,
            domain/* CampaignDistributionChannel.Link */.wQf.Link
        ].includes(distribution.channel));
    }).map(function(application) {
        var creatable = campaignCreatable(application);
        var disabled = !availableApplicationIds.includes(application.id);
        return {
            value: application.id,
            label: application.name,
            application: application,
            disabled: disabled,
            disabledTip: !creatable ? noPermissionTip : disabled ? quotaExceededTip : undefined
        };
    });
    var ApplicationSelectItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
        var application = _param.application, disabled = _param.disabled, disabledTip = _param.disabledTip, rest = (0,_object_without_properties/* default */.Z)(_param, [
            "application",
            "disabled",
            "disabledTip"
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                disabled: !disabled,
                withArrow: true,
                withinPortal: true,
                offset: 0,
                closeDelay: 500,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppInfo/* default */.Z, {
                                application: application,
                                tooltipDisabled: disabled
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                        children: disabledTip
                    })
                ]
            })
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: form.onSubmit(handleSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread/* default */.Z)({
                    label: t("list.action.duplicate.name", {
                        campaignTypeName: campaignTypeName
                    })
                }, form.getInputProps("name"))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
                    withinPortal: true,
                    data: applicationOptions,
                    itemComponent: ApplicationSelectItem,
                    label: t("list.action.duplicate.targetApplication"),
                    placeholder: t("common:placeholders.pleaseSelect")
                }, form.getInputProps("applicationId"))),
                groupManageable && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, (0,_object_spread/* default */.Z)({
                    withinPortal: true,
                    data: groupOptions,
                    label: t("list.action.duplicate.group"),
                    placeholder: groupOptions.length > 0 ? t("common:placeholders.pleaseSelect") : t("campaignGroup.empty")
                }, form.getInputProps("groupIds"))),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "default",
                            onClick: function() {
                                return (0,events/* closeModal */.Mr)(duplicateCampaignModalId);
                            },
                            children: t("common:actions.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            loading: loading || duplicating,
                            disabled: (0,isNil/* default */.Z)(form.values.applicationId),
                            children: t("common:actions.confirm")
                        })
                    ]
                })
            ]
        })
    });
};
function useDuplicateCampaignModal(campaign) {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var groupManageable = useCampaignPermission("").groupManageable;
    return function(onSuccess) {
        (0,events/* openModal */.h7)({
            modalId: duplicateCampaignModalId,
            withinPortal: true,
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                weight: 600,
                size: "md",
                children: [
                    t("common:actions.duplicate"),
                    t("common:campaignTypeName.".concat(campaign.type))
                ]
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {
                onSuccess: onSuccess,
                campaign: campaign,
                groupManageable: groupManageable
            })
        });
    };
}

// EXTERNAL MODULE: ./src/components/business/hooks/useApplicationInfoBaseInfoCache.ts
var useApplicationInfoBaseInfoCache = __webpack_require__(51945);
// EXTERNAL MODULE: ./src/utils/applicationUtils.ts
var applicationUtils = __webpack_require__(13090);
;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCheckCreateCampaign.tsx










function useCheckCreateCampaign(campaignType) {
    var t = (0,useTranslation/* default */.Z)("permission").t;
    var user = (0,useCurrentUserCache/* default */.Z)().user;
    var creatable = (0,business/* useCampaignPermission */.L9)(user === null || user === void 0 ? void 0 : user.id).creatable;
    var count = (0,useCampaignsCountCache/* default */.Z)(campaignType).count;
    var campaignsQuota = useCampaignsQuota();
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    if (!(0,applicationUtils/* isWebDistribution */.RV)(application) && campaignType === domain/* CampaignType.Notification */.mL.Notification) {
        return {
            disabled: true,
            disabledTip: t("actions.disabledCreationByNotification")
        };
    }
    if (!creatable) {
        return {
            disabled: true,
            disabledTip: t("actions.disabledCreationByPermission")
        };
    }
    var disabled = count !== undefined ? count >= campaignsQuota : true;
    var disabledTip = disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* FeatureTip */.i0, {
        feature: domain/* Feature.CampaignsCountPerApplication */.L0B.CampaignsCountPerApplication,
        transQuery: {
            count: campaignsQuota,
            campaignType: t("common:campaignTypeName.".concat(campaignType))
        }
    }) : undefined;
    return {
        disabled: disabled,
        disabledTip: disabledTip
    };
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useAiFormsCountQuota.ts


function useAiFormsCountQuota() {
    var ref, ref1;
    var subscription = (0,useAccountSubscriptionCache/* default */.Z)().subscription;
    var ref2;
    var vas = (ref2 = subscription === null || subscription === void 0 ? void 0 : (ref = subscription.product) === null || ref === void 0 ? void 0 : ref.vas) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3;
    return (ref3 = (ref1 = vas.find(function(param) {
        var type = param.type;
        return type === domain/* Feature.AiFormsCount */.L0B.AiFormsCount;
    })) === null || ref1 === void 0 ? void 0 : ref1.quota) !== null && ref3 !== void 0 ? ref3 : 0;
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCheckCreateSurveyByAi.tsx






function useCheckCreateSurveyByAi() {
    var ref;
    var vasBalance = (0,useAccountSubscriptionCache/* default */.Z)().vasBalance;
    var quota = useAiFormsCountQuota();
    var balance = vasBalance === null || vasBalance === void 0 ? void 0 : (ref = vasBalance[domain/* Feature.AiFormsCount */.L0B.AiFormsCount]) === null || ref === void 0 ? void 0 : ref.balance;
    if (balance === undefined) {
        return {
            disabled: false
        };
    }
    var disabled = balance <= 0;
    var disabledTip = disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* FeatureTip */.i0, {
        feature: domain/* Feature.AiFormsCount */.L0B.AiFormsCount,
        transQuery: {
            count: quota
        }
    }) : undefined;
    return {
        disabled: disabled,
        disabledTip: disabledTip
    };
}

// EXTERNAL MODULE: ./src/components/business/Campaign/hooks/useCampaignStatusAlert.ts
var useCampaignStatusAlert = __webpack_require__(89971);
;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCampaignStatusSwitch.ts











var useCampaignStatusSwitch = function(campaign) {
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateCampaignMutation */.WBT)(), 1), updateMutation = ref[0];
    var ref1 = (0,useCampaignStatusAlert/* default */.Z)(campaign.type), openAlertModal = ref1.open;
    var sendRequest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            var input, ref, data, enabled, e, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        input = {
                            id: campaign.id,
                            enabled: !campaign.enabled
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            updateMutation({
                                variables: {
                                    input: input
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        enabled = data === null || data === void 0 ? void 0 : (ref = data.updateCampaign) === null || ref === void 0 ? void 0 : ref.enabled;
                        callback === null || callback === void 0 ? void 0 : callback((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, campaign), {
                            enabled: enabled
                        }));
                        if (!(0,isNil/* default */.Z)(enabled)) {
                            ui/* message.successMsg */.yw.successMsg(t("statusSwitcher.message.".concat(enabled ? "enabled" : "disabled"), {
                                campaignType: t("common:campaignTypeName.".concat(campaign.type))
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        graphQLErrors = e.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            defaultMessage: t("common:message.updateError")
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendRequest(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(callback) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!campaign.enabled) return [
                            3,
                            1
                        ];
                        openAlertModal(function() {
                            return sendRequest(callback);
                        });
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            sendRequest(callback)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggle(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        toggle: toggle
    };
};
/* harmony default export */ var hooks_useCampaignStatusSwitch = (useCampaignStatusSwitch);

;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useEditCampaignGroupModal.tsx














var editCampaignGroupModalId = "editCampaignGroupModal";
var useEditCampaignGroupModal_ModalContent = function(param) {
    var _campaign = param.campaign, id = _campaign.id, type = _campaign.type, groupIds = _campaign.groupIds, onSuccess = param.onSuccess;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateCampaignGroupsMutation */.aJH)(), 2), updateCampaignGroups = ref[0], ref1 = ref[1], editing = ref1.loading;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var ref2 = (0,react.useState)([]), campaignGroups = ref2[0], setCampaignGroups = ref2[1];
    (0,domain/* useApplicationCampaignGroupsQuery */.TT_)({
        variables: {
            id: appId,
            type: type
        },
        onCompleted: function(resp) {
            var ref;
            var ref1;
            setCampaignGroups((ref1 = (ref = resp.application) === null || ref === void 0 ? void 0 : ref.campaignGroups) !== null && ref1 !== void 0 ? ref1 : []);
        }
    });
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            groupIds: groupIds
        }
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (editing) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            updateCampaignGroups({
                                variables: {
                                    id: id,
                                    groupIds: form.values.groupIds
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.updateCampaignGroups) {
                            (0,events/* closeModal */.Mr)(editCampaignGroupModalId);
                            ui/* message.successMsg */.yw.successMsg(t("common:message.updateSuccess"));
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        graphQLErrors = e.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            defaultMessage: t("common:message.updateError")
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var options = campaignGroups.map(function(group) {
        return {
            value: group.id,
            label: group.name
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: form.onSubmit(handleSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, (0,_object_spread/* default */.Z)({
                    withinPortal: true,
                    data: options,
                    placeholder: options.length > 0 ? t("common:placeholders.pleaseSelect") : t("campaignGroup.empty")
                }, form.getInputProps("groupIds"))),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "default",
                            onClick: function() {
                                return (0,events/* closeModal */.Mr)(editCampaignGroupModalId);
                            },
                            children: t("common:actions.cancel")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            type: "submit",
                            disabled: editing,
                            children: t("common:actions.confirm")
                        })
                    ]
                })
            ]
        })
    });
};
function useEditCampaignGroupsModal(campaign) {
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    return function(onSuccess) {
        (0,events/* openModal */.h7)({
            modalId: editCampaignGroupModalId,
            withinPortal: true,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                weight: 600,
                size: "md",
                children: t("list.action.editGroup")
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useEditCampaignGroupModal_ModalContent, {
                campaign: campaign,
                onSuccess: onSuccess
            })
        });
    };
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/index.ts










/***/ }),

/***/ 84818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17192);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25328);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33481);
/* harmony import */ var components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88392);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29718);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59845);









var useCampaignFormStatusSwitch = function(id) {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var campaign = (0,components_business_hooks_useCampaignBaseInfoCache__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(id).campaign;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,types_domain__WEBPACK_IMPORTED_MODULE_3__/* .useUpdateCampaignMutation */ .WBT)(), 1), updateMutation = ref[0];
    var urlEnabled = campaign === null || campaign === void 0 ? void 0 : campaign.urlEnabled;
    var sendRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(callback) {
            var input;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                input = {
                    id: id,
                    urlEnabled: !urlEnabled
                };
                updateMutation({
                    variables: {
                        input: input
                    }
                }).then(function() {
                    components_ui__WEBPACK_IMPORTED_MODULE_1__/* .message.successMsg */ .yw.successMsg(t("message.updateSuccess"));
                    callback === null || callback === void 0 ? void 0 : callback((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, campaign), {
                        urlEnabled: !urlEnabled
                    }));
                });
                return [
                    2
                ];
            });
        });
        return function sendRequest(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggle = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(callback) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!urlEnabled) return [
                            3,
                            1
                        ];
                        (0,components_ui__WEBPACK_IMPORTED_MODULE_1__/* .openAlertModal */ .NC)({
                            title: t("common:tip.title"),
                            content: t("componentCampaignList:statusSwitcher.confirmContent.link"),
                            onConfirm: function() {
                                return sendRequest(callback);
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            sendRequest(callback)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggle(callback) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        toggle: toggle
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCampaignFormStatusSwitch);


/***/ }),

/***/ 89971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51945);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29718);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var utils_applicationUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13090);




var useCampaignStatusAlert = function(campaignType) {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("componentCampaignList").t;
    var ref = (0,components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), application = ref.application, distribution = ref.distribution, channelGroup = ref.channelGroup;
    var open = function(onConfirm) {
        (0,components_ui__WEBPACK_IMPORTED_MODULE_1__/* .openAlertModal */ .NC)({
            title: t("common:tip.title"),
            content: t("componentCampaignList:statusSwitcher.confirmContent.".concat((0,utils_applicationUtils__WEBPACK_IMPORTED_MODULE_3__/* .isApplicationStatusNormal */ .ll)(distribution === null || distribution === void 0 ? void 0 : distribution.pingedAt) ? "normal" : "abnormal"), {
                channel: t("common:channel.".concat(channelGroup)),
                applicationName: application === null || application === void 0 ? void 0 : application.name,
                campaignType: t("common:campaignTypeName.".concat(campaignType))
            }),
            onConfirm: onConfirm
        });
    };
    return {
        open: open
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCampaignStatusAlert);


/***/ }),

/***/ 56941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGroupCache; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17474);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46550);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73046);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var components_business_Layouts_ApplicationLayout_ApplicationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89863);






function useGroupCache() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(components_business_Layouts_ApplicationLayout_ApplicationContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), me = ref.me, application = ref.application;
    var getDefaultGroup = function(campaignType) {
        var ref;
        var groupDict = (ref = utils__WEBPACK_IMPORTED_MODULE_0__/* .Storage.getItem */ .Ke.getItem(getKey())) !== null && ref !== void 0 ? ref : {};
        var _campaignType;
        return (_campaignType = groupDict[campaignType]) !== null && _campaignType !== void 0 ? _campaignType : null;
    };
    var setDefaultGroup = function(campaignType, groupId) {
        var key = getKey();
        var ref;
        var old = (ref = utils__WEBPACK_IMPORTED_MODULE_0__/* .Storage.getItem */ .Ke.getItem(key)) !== null && ref !== void 0 ? ref : {};
        utils__WEBPACK_IMPORTED_MODULE_0__/* .Storage.setItem */ .Ke.setItem(key, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, old), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, campaignType, groupId)));
    };
    var deleteGroup = function(campaignType, groupId) {
        var defaultGroup = getDefaultGroup(campaignType);
        if (defaultGroup === groupId) {
            utils__WEBPACK_IMPORTED_MODULE_0__/* .Storage.setItem */ .Ke.setItem(getKey(), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, defaultGroup), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, campaignType, null)));
        }
    };
    var getKey = function() {
        return "hx_user_".concat(me === null || me === void 0 ? void 0 : me.id, "_application_").concat(application === null || application === void 0 ? void 0 : application.id, "_groups");
    };
    return {
        getDefaultGroup: getDefaultGroup,
        setDefaultGroup: setDefaultGroup,
        deleteGroup: deleteGroup
    };
}


/***/ }),

/***/ 59255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": function() { return /* binding */ BuilderShareProvider; },
/* harmony export */   "MF": function() { return /* binding */ useBuilderSharedDataContext; },
/* harmony export */   "i7": function() { return /* binding */ BuilderSharedDataContext; },
/* harmony export */   "yl": function() { return /* binding */ useBuilderShareActions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77047);



var BuilderShareActionsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    setEditingFieldIndex: lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    setUrlEnabled: lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
});
var BuilderSharedDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    editingFieldIndex: 0,
    campaignType: null,
    urlEnabled: false,
    campaignTypeName: ""
});
var BuilderShareProvider = function(props) {
    var value = props.value, actions = props.actions, children = props.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuilderShareActionsContext.Provider, {
        value: actions,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuilderSharedDataContext.Provider, {
            value: value,
            children: children
        })
    });
};
var useBuilderSharedDataContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuilderSharedDataContext);
};
var useBuilderShareActions = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(BuilderShareActionsContext);
};


/***/ }),

/***/ 7859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ getNextFieldIndex; }
});

// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/getJumpRuleByValue.ts

function match(operator, secondNodeValue, value) {
    var matchValue = function(v) {
        return secondNodeValue.includes(v) || secondNodeValue.includes("".concat(v));
    };
    switch(operator){
        case domain/* ConditionOperator.Lt */.N0$.Lt:
            return value && value < secondNodeValue;
        case domain/* ConditionOperator.Lte */.N0$.Lte:
            return value && secondNodeValue >= value;
        case domain/* ConditionOperator.Eq */.N0$.Eq:
            return value === secondNodeValue;
        case domain/* ConditionOperator.Ne */.N0$.Ne:
            return value !== secondNodeValue;
        case domain/* ConditionOperator.Gt */.N0$.Gt:
            return value && value > secondNodeValue;
        case domain/* ConditionOperator.Gte */.N0$.Gte:
            return value && value >= secondNodeValue;
        case domain/* ConditionOperator.Promoter */.N0$.Promoter:
            return value && value > 8;
        case domain/* ConditionOperator.Passive */.N0$.Passive:
            return value === 7 || value === 8;
        case domain/* ConditionOperator.Detractor */.N0$.Detractor:
            return value && value < 7;
        case domain/* ConditionOperator.Include */.N0$.Include:
            if (Array.isArray(value === null || value === void 0 ? void 0 : value.value)) {
                var ref;
                return value === null || value === void 0 ? void 0 : (ref = value.value) === null || ref === void 0 ? void 0 : ref.some(matchValue);
            }
            return matchValue(value);
        default:
            return false;
    }
}
function getJumpRuleByValue(currentField, currentFieldValue) {
    var ref, ref1;
    var field = currentField;
    return field === null || field === void 0 ? void 0 : (ref = field.jumpRule) === null || ref === void 0 ? void 0 : (ref1 = ref.subRules) === null || ref1 === void 0 ? void 0 : ref1.find(function(jumpRule) {
        var ref;
        var condition = jumpRule === null || jumpRule === void 0 ? void 0 : (ref = jumpRule.conditionGroup) === null || ref === void 0 ? void 0 : ref.conditions[0];
        var operator = condition.operator, secondNode = condition.secondNode;
        if (match(operator, secondNode === null || secondNode === void 0 ? void 0 : secondNode.value, currentFieldValue)) {
            return jumpRule;
        }
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/last.js
var last = __webpack_require__(98467);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/getNextField.ts



function findIndexByCode(code, formFields) {
    return formFields.findIndex(function(field) {
        return field.code === code;
    });
}
function getIndexByJumpRule(params, jumpRule) {
    var formFields = params.formFields, currentFieldIndex = params.currentFieldIndex, currentFieldValue = params.currentFieldValue;
    var hasDefaultJumpRule = (jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.targetType) === domain/* FieldJumpRuleTargetType.SpecificField */.Bcr.SpecificField;
    var hasConditionalJumRule = !(0,isEmpty/* default */.Z)(jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.subRules);
    if (hasConditionalJumRule && !(0,isNil/* default */.Z)(currentFieldValue)) {
        var currentJumpRule = getJumpRuleByValue(formFields[currentFieldIndex], currentFieldValue);
        if (currentJumpRule) {
            return getIndexByJumpRule(params, currentJumpRule);
        } else if (hasDefaultJumpRule) {
            return findIndexByCode(jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.target, formFields);
        }
    }
    if (hasDefaultJumpRule) {
        return findIndexByCode(jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.target, formFields);
    }
    return null;
}
function getNextFieldIndex(params) {
    var formFields = params.formFields, currentPageValues = params.currentPageValues;
    var nextFieldIndex = getDefaultNextFieldIndex(formFields, currentPageValues);
    var resultIndex = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var value = _step.value;
            var currentFieldIndex = formFields.findIndex(function(f) {
                return f.code === value.code;
            });
            var currentField = formFields[currentFieldIndex];
            if (currentField === null || currentField === void 0 ? void 0 : currentField.jumpRule) {
                resultIndex = getIndexByJumpRule({
                    formFields: formFields,
                    currentFieldIndex: currentFieldIndex,
                    currentFieldValue: value.value
                }, currentField === null || currentField === void 0 ? void 0 : currentField.jumpRule);
                if (resultIndex !== null) {
                    return "break";
                }
            }
        };
        for(var _iterator = currentPageValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return resultIndex !== null && resultIndex !== void 0 ? resultIndex : nextFieldIndex;
}
function getDefaultNextFieldIndex(formFields, currentPageValues) {
    var ref;
    var currentPage = ((ref = formFields.find(function(f) {
        var ref;
        return f.code === ((ref = (0,last/* default */.Z)(currentPageValues)) === null || ref === void 0 ? void 0 : ref.code);
    })) === null || ref === void 0 ? void 0 : ref.page) || 0;
    return formFields.findIndex(function(field) {
        return field.page === currentPage + 1;
    });
}


/***/ }),

/***/ 94225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getStartIndex; }
/* harmony export */ });
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65149);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34262);

function getStartIndex(allFields, pageFields) {
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(pageFields)) {
        return null;
    }
    var startIndex = allFields.findIndex(function(param) {
        var code = param.code;
        var ref;
        return code === ((ref = (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(pageFields)) === null || ref === void 0 ? void 0 : ref.code);
    });
    return startIndex === -1 ? null : startIndex;
}


/***/ }),

/***/ 50643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLastPage; }
/* harmony export */ });
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88966);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14030);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var _getNextField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7859);



function isLastPage(currentPageFields, formFields) {
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(currentPageFields) || currentPageFields.some(function(param) {
        var type = param.type;
        return type === types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.EndingField */ .EIl.EndingField;
    })) {
        return true;
    }
    var currentPageValues = (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(currentPageFields, function(values, param) {
        var code = param.code;
        values.push({
            code: code,
            value: null
        });
        return values;
    }, []);
    var nextFieldIndex = (0,_getNextField__WEBPACK_IMPORTED_MODULE_1__/* .getNextFieldIndex */ .h)({
        formFields: formFields,
        currentPageValues: currentPageValues
    });
    return (0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(nextFieldIndex) || (0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(formFields[nextFieldIndex]) || formFields[nextFieldIndex].type === types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.EndingField */ .EIl.EndingField;
}


/***/ }),

/***/ 62030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72068);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74166);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var _isLastPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50643);
/* harmony import */ var _updateWithRealJumpRuleTargetType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48115);
/* harmony import */ var components_business_CampaignBuilder_CampaignPreview_utils_getStartIndex__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94225);





var parseFieldsToFieldsPages = function(fields) {
    var groups = (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(fields, function(field) {
        var _page;
        return (_page = field.page) !== null && _page !== void 0 ? _page : 0;
    });
    var fieldsWithoutEnding = fields.filter(function(param) {
        var type = param.type;
        return type !== types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.EndingField */ .EIl.EndingField;
    });
    return (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(groups).map(function(pageFields) {
        return {
            nodes: (0,_updateWithRealJumpRuleTargetType__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(pageFields, fields),
            totalCount: fieldsWithoutEnding.length,
            startIndex: (0,components_business_CampaignBuilder_CampaignPreview_utils_getStartIndex__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(fieldsWithoutEnding, pageFields),
            isLastPage: (0,_isLastPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(pageFields, fields)
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (parseFieldsToFieldsPages);


/***/ }),

/***/ 48115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ updateWithRealJumpRuleTargetType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29848);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88966);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59774);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57226);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);





function updateJumpRule(jumpRule, allFieldsTypeMap) {
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(jumpRule)) {
        return undefined;
    }
    var target = jumpRule.target, targetType = jumpRule.targetType, subRules = jumpRule.subRules, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(jumpRule, [
        "target",
        "targetType",
        "subRules"
    ]);
    var realTargetType = targetType;
    if (targetType === types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FieldJumpRuleTargetType.SpecificField */ .Bcr.SpecificField) {
        if (target) {
            if (allFieldsTypeMap[target] === types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FormFieldType.EndingField */ .EIl.EndingField) {
                realTargetType = types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FieldJumpRuleTargetType.Ending */ .Bcr.Ending;
            }
        } else {
            realTargetType = types_domain__WEBPACK_IMPORTED_MODULE_0__/* .FieldJumpRuleTargetType.NextField */ .Bcr.NextField;
        }
    }
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        target: target,
        targetType: realTargetType,
        subRules: (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(subRules === null || subRules === void 0 ? void 0 : subRules.map(function(subRule) {
            return updateJumpRule(subRule, allFieldsTypeMap);
        }))
    }, rest);
}
function updateWithRealJumpRuleTargetType(pageFields, allFields) {
    var allFieldsTypeMap = (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(allFields, function(memo, param) {
        var code = param.code, type = param.type;
        return memo[code] = type;
    }, {});
    return pageFields === null || pageFields === void 0 ? void 0 : pageFields.map(function(field) {
        var jumpRule = field.jumpRule, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(field, [
            "jumpRule"
        ]);
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
            jumpRule: updateJumpRule(jumpRule, allFieldsTypeMap)
        });
    });
}


/***/ }),

/***/ 13625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ Mode; },
/* harmony export */   "Q5": function() { return /* binding */ defaultNonActiveTriggerCondition; },
/* harmony export */   "VD": function() { return /* binding */ defaultActiveTriggerCondition; },
/* harmony export */   "pO": function() { return /* binding */ delayTriggerCondition; },
/* harmony export */   "zH": function() { return /* binding */ defaultTriggerOperator; }
/* harmony export */ });
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);

var Mode;
(function(Mode) {
    Mode["NON_ACTIVE_POPUP"] = "nonActivePopup";
    Mode["ACTIVE_POPUP"] = "activePopup";
    Mode["DELAY_POPUP"] = "delayPopup";
})(Mode || (Mode = {}));
var defaultTriggerOperator = types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionGroupOperator.Or */ .ZOu.Or;
var defaultNonActiveTriggerCondition = null;
var defaultActiveTriggerCondition = {
    event: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignTriggerEvent.PageVisit */ .Yeg.PageVisit
};
var delayTriggerCondition = function(duration) {
    return {
        delay: duration,
        event: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignTriggerEvent.PageVisit */ .Yeg.PageVisit
    };
};


/***/ }),

/***/ 71870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ Mode; },
/* harmony export */   "DK": function() { return /* binding */ userSegmentCode; },
/* harmony export */   "lD": function() { return /* binding */ customerFilterConditionsPath; }
/* harmony export */ });
/* unused harmony exports defaultCustomerAttributesCodes, allAttributeCodes */
var Mode;
(function(Mode) {
    Mode["ALL"] = "all";
    Mode["SPECIALITY"] = "speciality";
})(Mode || (Mode = {}));
var customerFilterConditionsPath = "targeting.customerFilter.conditions";
var defaultCustomerAttributesCodes = [
    "mobile",
    "name",
    "uid",
    "email"
];
var userSegmentCode = "$customerSegments";
var allAttributeCodes = defaultCustomerAttributesCodes.concat(userSegmentCode);


/***/ }),

/***/ 79759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PlatformPreview_MobilePreview; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
;// CONCATENATED MODULE: ./src/components/ui/MobileSimulator/images/bg.png
/* harmony default export */ var bg = ({"src":"https://static-cny.howxm.com/_next/static/media/bg.a3beedf5.png","height":1600,"width":720,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAf0lEQVR42gWAQQqCQBRA3/+OY2gH6ADdpDt2hc7QHdq0qEWQEBQYuVApFUfnh+xO9aLeq6IgRGUKavMMAmZRXRwGbInYWniVLc73Pz5VQ3Ar6luP22bQjB3nS0mRz8jh+rA8Szg+K/ZpitzbzjZFxjsE+iki32lcUifqJQGS+Ad9jToIjZXlAgAAAABJRU5ErkJggg==","blurWidth":4,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/ui/MobileSimulator/index.tsx






var MAX_SIMULATOR_WIDTH = 375;
var MAX_SIMULATOR_HEIGHT = 826;
var MobileSimulator = function(props, ref) {
    var sx = props.sx, children = props.children;
    var outerRadius = 34;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        ref: ref,
        sx: (0,_object_spread/* default */.Z)({
            overflow: "hidden",
            position: "relative",
            width: MAX_SIMULATOR_WIDTH,
            maxHeight: MAX_SIMULATOR_HEIGHT,
            backgroundImage: "url(".concat(bg.src, ")"),
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50% -2px",
            border: "12px solid #000000",
            borderRadius: outerRadius
        }, sx || {}),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: classnames_default()("absolute left-1/2 -translate-x-1/2 bg-black rounded-full")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: "absolute top-0 right-0 bottom-0 left-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    sx: {
                        overflow: "hidden",
                        height: "100%"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: classnames_default()("absolute left-1/2 -translate-x-1/2 bg-black rounded-full bottom-[8px] w-[134px] h-[5px]")
            })
        ]
    });
};
/* harmony default export */ var ui_MobileSimulator = (/*#__PURE__*/(0,react.forwardRef)(MobileSimulator));

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/PlatformPreview/MobilePreview/index.tsx




var MobilePreview = function(param) {
    var children = param.children;
    var simulatorRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            simulatorRef.current && (simulatorRef.current.style.opacity = "1");
        }, 150);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        pos: "relative",
        h: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MobileSimulator, {
            ref: simulatorRef,
            sx: {
                height: "100%"
            },
            children: children
        })
    });
};
/* harmony default export */ var PlatformPreview_MobilePreview = (MobilePreview);


/***/ }),

/***/ 38759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74969);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68711);
/* harmony import */ var _utils_useSecondaryTextColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92453);




var StyleItem = function(props) {
    var label = props.label, _align = props.align, align = _align === void 0 ? "center" : _align, children = props.children;
    var secondaryTextColor = (0,_utils_useSecondaryTextColor__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Grid */ .r, {
        align: align,
        children: [
            !!label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Grid.Col */ .r.Col, {
                span: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    color: secondaryTextColor,
                    children: label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Grid.Col */ .r.Col, {
                span: label ? 8 : 11,
                offset: 1,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StyleItem);


/***/ }),

/***/ 37959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91470);
/* harmony import */ var _swatch_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57506);




var Swatch = function(param) {
    var color = param.color, checked = param.checked, onClick = param.onClick;
    var classes = (0,_swatch_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        checked: checked
    }).classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .AspectRatio */ .o, {
        ratio: 1,
        className: classes.root,
        sx: {
            background: color
        },
        onClick: onClick
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Swatch);


/***/ }),

/***/ 57506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42112);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55075);


var useSwatchStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .createStyles */ .k)(function(theme, param) {
    var checked = param.checked;
    var innerShadow = "0 0 0 2px ".concat((0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_0__/* .pickSchemeColor */ .pl)("white", theme, theme.colors.dark[7]));
    return {
        root: {
            borderRadius: theme.radius.sm,
            boxShadow: checked ? "".concat(innerShadow, ", 0 0 0 4px ").concat(theme.colors.indigo[6]) : innerShadow,
            cursor: "pointer"
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useSwatchStyles);


/***/ }),

/***/ 63802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDefaultLocaleWords; },
/* harmony export */   "h": function() { return /* binding */ localeMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17474);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21409);



var _obj;
/**
 * 这里以后会支持自定义，目前是先写死
 */ var localeMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Locale.ZhCn */ .gor.ZhCn, {
    branding: "浩客提供技术支持",
    submitButton: "提交",
    nextButton: "下一页",
    ratingDescription: {
        hate: "非常不满意",
        dislike: "不满意",
        neutral: "一般",
        like: "满意",
        love: "非常满意"
    },
    screenshotDescription: {
        screenshot: "截图",
        captured: "已截图",
        inProgress: "截图中"
    },
    otherChoicePlaceholder: "请输入补充信息"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Locale.En */ .gor.En, {
    branding: "Powered by HowXM",
    submitButton: "Submit",
    nextButton: "Next",
    ratingDescription: {
        hate: "Hate",
        dislike: "Dislike",
        neutral: "Neutral",
        like: "Like",
        love: "Love"
    },
    screenshotDescription: {
        screenshot: "Screenshot",
        captured: "Captured"
    },
    otherChoicePlaceholder: "Please type here..."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Locale.Tw */ .gor.Tw, {
    branding: "浩客提供技术支持",
    submitButton: "提交",
    nextButton: "下一页",
    ratingDescription: {
        hate: "非常不满意",
        dislike: "不满意",
        neutral: "一般",
        like: "满意",
        love: "非常满意"
    },
    screenshotDescription: {
        screenshot: "截图",
        captured: "已截图"
    },
    otherChoicePlaceholder: "请输入补充信息"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Locale.Other */ .gor.Other, {
    branding: "Powered by HowXM",
    submitButton: "Submit",
    nextButton: "Next",
    ratingDescription: {
        hate: "Hate",
        dislike: "Dislike",
        neutral: "Neutral",
        like: "Like",
        love: "Love"
    },
    screenshotDescription: {
        screenshot: "Screenshot",
        captured: "Captured"
    },
    otherChoicePlaceholder: "Please type here..."
}), _obj);
function getDefaultLocaleWords(locale) {
    var dupLocaleMap = (0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(localeMap);
    return locale ? dupLocaleMap[locale] : dupLocaleMap[types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Locale.ZhCn */ .gor.ZhCn];
}


/***/ }),

/***/ 2056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ MAX_FIELDS_COUNT; },
/* harmony export */   "CC": function() { return /* binding */ defaultLocaleSetting; },
/* harmony export */   "hU": function() { return /* binding */ defaultWidgetWidth; },
/* harmony export */   "jp": function() { return /* binding */ defaultTargeting; },
/* harmony export */   "r4": function() { return /* binding */ defaultSchedule; },
/* harmony export */   "uP": function() { return /* binding */ defaultOpenStrategy; },
/* harmony export */   "wH": function() { return /* binding */ defaultFormSetting; },
/* harmony export */   "yi": function() { return /* binding */ defaultColorScheme; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17474);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var duration_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52808);
/* harmony import */ var duration_fns__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(duration_fns__WEBPACK_IMPORTED_MODULE_1__);



var defaultButtonStyle = {
    variant: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ButtonVariant.Filled */ .Wu3.Filled,
    borderRadius: 20
};
var defaultTextStyle = {
    align: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .TextAlign.Start */ .PHM.Start,
    direction: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Direction.Ltr */ .Nmp.Ltr
};
var defaultColorScheme = {
    accent: "#1D55C4",
    background: "#FFFFFF"
};
var defaultFormSetting = {
    hideBranding: false,
    backNavigation: false,
    showProgressBar: false,
    colorScheme: defaultColorScheme,
    buttonStyle: defaultButtonStyle,
    textStyle: defaultTextStyle
};
var defaultOpenStrategy = {
    enabled: true,
    distributionLimit: 7,
    interval: (0,duration_fns__WEBPACK_IMPORTED_MODULE_1__.parse)({
        days: 3
    })
};
var defaultTargeting = {
    device: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignTargetingDevice.All */ .JZL.All,
    urlFilter: null,
    customerFilter: null
};
var defaultLocaleSetting = {
    locale: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Locale.ZhCn */ .gor.ZhCn
};
var _obj;
var defaultWidgetWidth = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignType.Feedback */ .mL.Feedback, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignWidgetWidth.Small */ ._tm.Small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignType.Survey */ .mL.Survey, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignWidgetWidth.Normal */ ._tm.Normal), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignType.Notification */ .mL.Notification, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignWidgetWidth.Xlarge */ ._tm.Xlarge), _obj);
var defaultSchedule = {
    enable: false
};
var MAX_FIELDS_COUNT = 50;


/***/ }),

/***/ 89433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cd": function() { return /* reexport */ StyleSetting_Branding; },
  "D8": function() { return /* reexport */ BuilderSharedDataContext/* BuilderShareProvider */.D8; },
  "i7": function() { return /* reexport */ BuilderSharedDataContext/* BuilderSharedDataContext */.i7; },
  "ZJ": function() { return /* reexport */ StyleSetting_ButtonStyle; },
  "yR": function() { return /* reexport */ CampaignBuilder_CampaignBuilder; },
  "vA": function() { return /* reexport */ CampaignBuilder_CampaignPreview; },
  "eL": function() { return /* reexport */ StyleSetting_ColorScheme; },
  "dy": function() { return /* reexport */ StyleSetting_Emoji; },
  "BX": function() { return /* reexport */ CampaignBuilder_constant/* MAX_FIELDS_COUNT */.BX; },
  "NE": function() { return /* reexport */ CampaignBuilder_PanelWithPreview; },
  "ko": function() { return /* reexport */ StyleSetting_ProgressBar; },
  "PH": function() { return /* reexport */ TextAlign; },
  "sF": function() { return /* reexport */ ButtonIcon; },
  "ei": function() { return /* reexport */ ButtonLabel; },
  "jf": function() { return /* reexport */ Locale; },
  "Qd": function() { return /* reexport */ Position; },
  "l9": function() { return /* reexport */ StyleSetting_WidgetType; },
  "yi": function() { return /* reexport */ CampaignBuilder_constant/* defaultColorScheme */.yi; },
  "wH": function() { return /* reexport */ CampaignBuilder_constant/* defaultFormSetting */.wH; },
  "CC": function() { return /* reexport */ CampaignBuilder_constant/* defaultLocaleSetting */.CC; },
  "uP": function() { return /* reexport */ CampaignBuilder_constant/* defaultOpenStrategy */.uP; },
  "r4": function() { return /* reexport */ CampaignBuilder_constant/* defaultSchedule */.r4; },
  "jp": function() { return /* reexport */ CampaignBuilder_constant/* defaultTargeting */.jp; },
  "hU": function() { return /* reexport */ CampaignBuilder_constant/* defaultWidgetWidth */.hU; },
  "On": function() { return /* reexport */ useBuilderFormContext; },
  "yl": function() { return /* reexport */ BuilderSharedDataContext/* useBuilderShareActions */.yl; },
  "MF": function() { return /* reexport */ BuilderSharedDataContext/* useBuilderSharedDataContext */.MF; }
});

// UNUSED EXPORTS: BuilderFormProvider, useBuilderForm

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-resize-observer/use-resize-observer.js
var use_resize_observer = __webpack_require__(56718);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/merge.js + 6 modules
var merge = __webpack_require__(31817);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/getNextField.ts + 1 modules
var getNextField = __webpack_require__(7859);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/parseFieldsToFieldsPages.ts
var parseFieldsToFieldsPages = __webpack_require__(62030);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/isLastPage.ts
var isLastPage = __webpack_require__(50643);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/updateWithRealJumpRuleTargetType.ts
var updateWithRealJumpRuleTargetType = __webpack_require__(48115);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/getStartIndex.ts
var getStartIndex = __webpack_require__(94225);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/groupBy.js
var groupBy = __webpack_require__(72068);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/hooks/useEditingPageState.ts



function useEditingPageState(formFields, readOnly) {
    var editingFieldIndex = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().editingFieldIndex;
    return (0,react.useMemo)(function() {
        if (editingFieldIndex >= 0) {
            var ref;
            var currentField = formFields[editingFieldIndex];
            var formFieldsGroupByPage = (0,groupBy/* default */.Z)(formFields, "page");
            var ref1;
            var currentPageFormFields = (ref = formFieldsGroupByPage[(ref1 = currentField === null || currentField === void 0 ? void 0 : currentField.page) !== null && ref1 !== void 0 ? ref1 : 0]) === null || ref === void 0 ? void 0 : ref.map(function(field) {
                // when readOnly delete showRules and show all fields
                if (readOnly && field.showRules) {
                    field.showRules = [];
                }
                return field;
            });
            return {
                currentPageFormFields: currentPageFormFields
            };
        }
        return {};
    }, [
        editingFieldIndex,
        formFields,
        readOnly
    ]);
}

// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./src/config/constants/fieldType.ts
var fieldType = __webpack_require__(68123);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/hooks/usePublishedFields.ts






function usePublishedFields(fields) {
    var checkFeature = (0,business/* useCheckFeature */.xu)();
    var canUseScreenshot = checkFeature(domain/* Feature.ScreenshotField */.L0B.ScreenshotField);
    return (0,react.useMemo)(function() {
        return fields.map(function(field) {
            if (fieldType/* SELECTABLE_FIELDS.includes */.gi.includes(field.type)) {
                var ref;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                    choices: field === null || field === void 0 ? void 0 : (ref = field.choices) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                        var hidden = param.hidden;
                        return !hidden;
                    })
                });
            }
            if (field.type === domain/* FormFieldType.TextArea */.EIl.TextArea) {
                var textAreaField = field;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                    screenshotsEnabled: !!canUseScreenshot && textAreaField.screenshotsEnabled
                });
            } else {
                return field;
            }
        });
    }, [
        canUseScreenshot,
        fields
    ]);
}

// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Locale/utils/getDefaultLocaleWords.ts
var getDefaultLocaleWords = __webpack_require__(63802);
// EXTERNAL MODULE: ./src/components/business/hooks/useAccountSettingCache.ts
var useAccountSettingCache = __webpack_require__(91634);
// EXTERNAL MODULE: ./src/utils/applicationUtils.ts
var applicationUtils = __webpack_require__(13090);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/index.tsx



















var defaultBrandingUrl = "https://howxm.com";
var CampaignPreview = function(props) {
    var _interactive = props.interactive, interactive = _interactive === void 0 ? true : _interactive, widgetType = props.widgetType, position = props.position, showProgressBar = props.showProgressBar, forcePlatformAs = props.forcePlatformAs, campaignPreviewRef = props.campaignPreviewRef;
    var previewContainerRef = (0,react.useRef)(null);
    var form = useBuilderFormContext();
    var _values = form.values, token = _values.token, rawFormFields = _values.formFields, formSetting = _values.formSetting, widget = _values.widget, type = _values.type, targeting = _values.targeting, localeSetting = _values.localeSetting, schedule = _values.schedule;
    var formFields = usePublishedFields(rawFormFields);
    var ref = (0,react.useState)(0), activePageIndex = ref[0], setActivePageIndex = ref[1];
    var ref1 = (0,react.useState)(formFields[0]), field = ref1[0], setField = ref1[1];
    var currentWidget = (0,react.useRef)(null);
    var ref2 = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)(), autoOpen = ref2.autoOpen, editingFieldIndex = ref2.editingFieldIndex;
    var ref3 = (0,BuilderSharedDataContext/* useBuilderShareActions */.yl)(), setEditingFieldIndex = ref3.setEditingFieldIndex, setAutoOpen = ref3.setAutoOpen;
    var currentPageFormFields = useEditingPageState(formFields).currentPageFormFields;
    var ref4 = (0,use_resize_observer/* useElementSize */.h)(), ref5 = ref4.ref, height = ref4.height;
    var application = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().application;
    var isLinkApplication = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    var fieldsPages = (0,react.useMemo)(function() {
        if (!interactive) {
            var fieldsWithoutEnding = formFields.filter(function(param) {
                var type = param.type;
                return type !== domain/* FormFieldType.EndingField */.EIl.EndingField;
            });
            return [
                {
                    nodes: (0,updateWithRealJumpRuleTargetType/* default */.Z)(currentPageFormFields, formFields),
                    totalCount: fieldsWithoutEnding.length,
                    startIndex: (0,getStartIndex/* default */.Z)(fieldsWithoutEnding, currentPageFormFields),
                    isLastPage: (0,isLastPage/* default */.Z)(currentPageFormFields, formFields)
                }, 
            ];
        }
        return (0,parseFieldsToFieldsPages/* default */.Z)(formFields);
    }, [
        interactive,
        formFields,
        currentPageFormFields
    ]);
    var ref6 = (0,useAccountSettingCache/* default */.Z)(), hideBranding = ref6.hideBranding, canHideBranding = ref6.canHideBranding;
    var handleFieldChange = (0,react.useCallback)(function(data) {
        if (type === domain/* CampaignType.Feedback */.mL.Feedback) {
            setEditingFieldIndex(data);
        } else {
            var ref;
            var ref1;
            var nextActivePageIndex = (ref1 = (ref = formFields[(0,getNextField/* getNextFieldIndex */.h)({
                currentPageValues: data,
                formFields: formFields
            })]) === null || ref === void 0 ? void 0 : ref.page) !== null && ref1 !== void 0 ? ref1 : -1;
            setEditingFieldIndex((0,getNextField/* getNextFieldIndex */.h)({
                currentPageValues: data,
                formFields: formFields
            }));
            setActivePageIndex(nextActivePageIndex);
        }
    }, [
        formFields,
        setEditingFieldIndex,
        type
    ]);
    var brandingUrl = hideBranding && canHideBranding ? null : defaultBrandingUrl;
    var previewProps = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            activePageIndex: activePageIndex,
            editingFieldIndex: editingFieldIndex,
            token: token,
            formSetting: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formSetting), {
                showProgressBar: (0,isNil/* default */.Z)(showProgressBar) ? formSetting.showProgressBar : showProgressBar,
                colorScheme: widget.colorScheme,
                brandingUrl: brandingUrl,
                localeSetting: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localeSetting), {
                    wordings: (0,merge/* default */.Z)((0,getDefaultLocaleWords/* default */.Z)(localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.locale), localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.wordings)
                }),
                schedule: schedule
            }),
            widget: (0,_object_spread/* default */.Z)({}, widget, (0,isNil/* default */.Z)(position) ? {} : {
                position: position
            }, (0,isNil/* default */.Z)(widgetType) ? {} : {
                type: widgetType
            }),
            editingCode: interactive ? undefined : field === null || field === void 0 ? void 0 : field.code
        }, type === domain/* CampaignType.Feedback */.mL.Feedback ? {
            field: field,
            fields: formFields,
            startIndex: formFields.findIndex(function(field) {
                var ref;
                return field.code === (currentPageFormFields === null || currentPageFormFields === void 0 ? void 0 : (ref = currentPageFormFields[0]) === null || ref === void 0 ? void 0 : ref.code);
            }),
            totalCount: formFields.length
        } : {
            pages: fieldsPages
        }), {
            onFieldChange: handleFieldChange,
            type: type,
            forcePlatformAs: forcePlatformAs,
            interactive: interactive,
            isUrlVisit: isLinkApplication,
            autoOpen: autoOpen,
            onClose: function() {
                if (widget.type === domain/* CampaignWidgetType.Button */.YMh.Button) {
                    setAutoOpen === null || setAutoOpen === void 0 ? void 0 : setAutoOpen(false);
                    setEditingFieldIndex(0);
                }
                setActivePageIndex(0);
            },
            // 在survey的题目tab，一页多题field点击切换的时候，左侧对应选中的field需要更新
            onFieldClick: function(code) {
                var clickedFieldIndex = formFields.findIndex(function(field) {
                    return field.code === code;
                });
                var clickedField = formFields[clickedFieldIndex];
                if (clickedField) {
                    setField(clickedField);
                    setEditingFieldIndex(clickedFieldIndex);
                }
            },
            maxHeight: "".concat(Math.ceil(height * 0.8), "px")
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formSetting,
        widget,
        position,
        field,
        formFields,
        type,
        forcePlatformAs,
        interactive,
        autoOpen,
        brandingUrl,
        localeSetting,
        height,
        schedule, 
    ]);
    (0,react.useEffect)(function() {
        var currentField = formFields[editingFieldIndex];
        setField(currentField);
    }, [
        editingFieldIndex,
        formFields
    ]);
    (0,react.useEffect)(function() {
        resetToFirstField();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        widget.type,
        widget.position,
        widget.width
    ]);
    (0,react.useEffect)(function() {
        if (editingFieldIndex === -1) {
            resetToFirstField();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        widget.colorScheme
    ]);
    (0,react.useEffect)(function() {
        if ((0,isNil/* default */.Z)(currentWidget.current) && widget.type === domain/* CampaignWidgetType.Banner */.YMh.Banner) {
            var createWidgetProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previewProps), {
                container: ref5.current,
                maxHeight: "".concat(Math.ceil(ref5.current.clientHeight * 0.8), "px")
            });
            __webpack_require__.e(/* import() */ 408).then(__webpack_require__.bind(__webpack_require__, 40408)).then(function(module) {
                var XSdk = module.default;
                currentWidget.current = new XSdk(createWidgetProps);
            });
            return;
        }
        if ((0,isNil/* default */.Z)(currentWidget.current) && !(0,isEmpty/* default */.Z)(formFields) && widget.type !== domain/* CampaignWidgetType.Banner */.YMh.Banner) {
            var createWidgetProps1 = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previewProps), {
                container: ref5.current,
                maxHeight: "".concat(Math.ceil(ref5.current.clientHeight * 0.8), "px")
            });
            __webpack_require__.e(/* import() */ 408).then(__webpack_require__.bind(__webpack_require__, 40408)).then(function(module) {
                if (isLinkApplication) {
                    currentWidget.current = new module.FormPreview((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previewProps), {
                        container: previewContainerRef.current
                    }));
                    currentWidget.current.render();
                } else {
                    var XSdk = module.default;
                    currentWidget.current = new XSdk(createWidgetProps1);
                }
            });
        }
        return function() {
            var ref, ref1;
            (ref = currentWidget.current) === null || ref === void 0 ? void 0 : (ref1 = ref.destroyWidget) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        (ref = currentWidget.current) === null || ref === void 0 ? void 0 : ref.update((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previewProps), {
            container: previewContainerRef.current
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(previewProps),
        targeting
    ]);
    var resetToFirstField = function() {
        var ref;
        setEditingFieldIndex(0);
        setActivePageIndex(0);
        (ref = currentWidget.current) === null || ref === void 0 ? void 0 : ref.refresh();
    };
    if (campaignPreviewRef) {
        campaignPreviewRef.current = {
            refresh: resetToFirstField
        };
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: "campaign-preview h-full relative overflow-hidden translate-x-0 translate-y-0",
        ref: previewContainerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            ref: ref5,
            h: "100%"
        })
    });
};
/* harmony default export */ var CampaignBuilder_CampaignPreview = (CampaignPreview);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./src/components/business/PlatformPreview/DesktopPreview/index.tsx + 2 modules
var DesktopPreview = __webpack_require__(98555);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/PlatformPreview/MobilePreview/index.tsx + 2 modules
var MobilePreview = __webpack_require__(79759);
// EXTERNAL MODULE: ./src/components/business/PlatformPreview/PreviewActions/index.tsx
var PreviewActions = __webpack_require__(24309);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/PlatformPreview/HybridPreview/index.tsx








var TOP_BAR_HEIGHT = 56;
var PADDING = 24;
var HybridPreview = function(param) {
    var defaultPlatform = param.defaultPlatform, platformChangeable = param.platformChangeable;
    var campaignPreviewRef = (0,react.useRef)();
    var form = useBuilderFormContext();
    var ref = (0,react.useState)(defaultPlatform !== null && defaultPlatform !== void 0 ? defaultPlatform : "web"), platform = ref[0], setPlatform = ref[1];
    var widget = form.values.widget;
    var handleRefresh = function() {
        var ref;
        campaignPreviewRef === null || campaignPreviewRef === void 0 ? void 0 : (ref = campaignPreviewRef.current) === null || ref === void 0 ? void 0 : ref.refresh();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        pos: "relative",
        align: "center",
        style: {
            height: "calc(100vh - ".concat(TOP_BAR_HEIGHT, "px - ").concat(PADDING * 2, "px)"),
            width: "".concat(platform === "web" ? "80%" : "")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewActions/* default */.Z, {
                platformChangeable: platformChangeable,
                widgetType: widget.type,
                onPlatformClick: setPlatform,
                onRefresh: handleRefresh,
                className: "top-0 left-[-50px]"
            }),
            platform === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePreview/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBuilder_CampaignPreview, {
                    forcePlatformAs: "mobile",
                    campaignPreviewRef: campaignPreviewRef
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPreview/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBuilder_CampaignPreview, {
                    forcePlatformAs: "desktop",
                    campaignPreviewRef: campaignPreviewRef
                })
            })
        ]
    });
};
/* harmony default export */ var PlatformPreview_HybridPreview = (HybridPreview);

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/ui/ContainerWithDotBg/index.tsx
var ContainerWithDotBg = __webpack_require__(51222);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/PlatformPreview/index.tsx







var Container = function(param) {
    var left = param.left, right = param.right, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerWithDotBg/* default */.Z, {
        className: "h-full max-w-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            pos: "absolute",
            top: "0",
            bottom: "0",
            left: left || 0,
            right: right || 0,
            className: classnames_default()(className, "overflow-hidden"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: "h-full w-full relative overflow-hidden",
                py: "xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    position: "center",
                    align: "top",
                    className: "h-full",
                    children: children
                })
            })
        })
    });
};
var PlatformPreview = function(param) {
    var left = param.left, right = param.right;
    var application = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().application;
    var shouldShowHybridPreview = (0,applicationUtils/* isLinkDistribution */.dQ)(application) || (0,applicationUtils/* isWebDistribution */.RV)(application);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        left: left,
        right: right,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformPreview_HybridPreview, {
            platformChangeable: shouldShowHybridPreview,
            defaultPlatform: (0,applicationUtils/* isWebDistribution */.RV)(application) ? "web" : "mobile"
        })
    });
};
/* harmony default export */ var CampaignBuilder_PlatformPreview = (PlatformPreview);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/PanelWithPreview/index.tsx






var defaultPanelWidth = 520;
var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        panel: {
            width: defaultPanelWidth,
            backgroundColor: (0,getColor/* getBackgroundColor */.dF)("white", theme),
            scrollbarGutter: "stable"
        }
    };
});
var PanelWithPreview = function(props) {
    var panelTitle = props.panelTitle, children = props.children;
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        w: "100%",
        h: "100%",
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Panel */.s_, {
                className: cx("absolute h-full overflow-y-auto top-0 left-0 bottom-0", classes.panel),
                title: panelTitle,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBuilder_PlatformPreview, {
                left: defaultPanelWidth,
                right: 0
            })
        ]
    });
};
/* harmony default export */ var CampaignBuilder_PanelWithPreview = (PanelWithPreview);

// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/compact.js
var compact = __webpack_require__(59774);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/WidgetType/getDefaultPositionByWidgetType.ts

function getDefaultPositionByWidgetType(widgetType, widgetButtonType) {
    if (widgetType === domain/* CampaignWidgetType.Button */.YMh.Button) {
        return widgetButtonType == domain/* CampaignWidgetButtonType.Aside */.UUk.Aside ? domain/* CampaignWidgetPosition.MiddleRight */.kNk.MiddleRight : domain/* CampaignWidgetPosition.BottomRight */.kNk.BottomRight;
    } else if (widgetType === domain/* CampaignWidgetType.Popup */.YMh.Popup) {
        return domain/* CampaignWidgetPosition.BottomRight */.kNk.BottomRight;
    }
    return domain/* CampaignWidgetPosition.BottomRight */.kNk.BottomRight;
}

// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/Distribution/When/constant.ts
var constant = __webpack_require__(13625);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/utils/useCampaignTriggerCondition.ts
var useCampaignTriggerCondition = __webpack_require__(58867);
// EXTERNAL MODULE: ./src/components/business/SurveyBuilder/constants.ts
var constants = __webpack_require__(73348);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/WidgetType/index.tsx











var supportButtonWidgetType = [
    domain/* CampaignType.Survey */.mL.Survey,
    domain/* CampaignType.Notification */.mL.Notification
];
var WidgetType = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var getEventTriggerCondition = (0,useCampaignTriggerCondition/* default */.Z)().getEventTriggerCondition;
    var ref = form === null || form === void 0 ? void 0 : form.getInputProps("widget.type"), widgetTypeValue = ref.value, widgetTypeOnChange = ref.onChange;
    var ref1 = form === null || form === void 0 ? void 0 : form.getInputProps("widget.setting"), widgetSettingValue = ref1.value, widgetSettingOnChange = ref1.onChange;
    var ref2 = form.getInputProps("widget.position"), positionOnChange = ref2.onChange;
    var ref3 = form.getInputProps("trigger"), triggerOnChange = ref3.onChange;
    var widgetTypes = (0,react.useMemo)(function() {
        return [
            {
                value: domain/* CampaignWidgetType.Button */.YMh.Button,
                label: t("styles.widgetType.asideButton")
            },
            {
                value: domain/* CampaignWidgetType.Popup */.YMh.Popup,
                label: t("styles.widgetType.popup")
            }, 
        ];
    }, [
        t
    ]);
    var getUpdatedTrigger = function(pageTriggerCondition) {
        return {
            operator: constant/* defaultTriggerOperator */.zH,
            conditions: (0,compact/* default */.Z)([
                pageTriggerCondition,
                getEventTriggerCondition()
            ])
        };
    };
    var handleChange = function(widgetType) {
        var value = widgetType;
        if (value === domain/* CampaignWidgetType.Popup */.YMh.Popup || value === domain/* CampaignWidgetType.Banner */.YMh.Banner) {
            widgetTypeOnChange(value);
            positionOnChange(getDefaultPositionByWidgetType(value));
            triggerOnChange(getUpdatedTrigger(constant/* defaultActiveTriggerCondition */.VD));
        } else {
            triggerOnChange(getUpdatedTrigger(constant/* defaultNonActiveTriggerCondition */.Q5));
            widgetTypeOnChange(domain/* CampaignWidgetType.Button */.YMh.Button);
            positionOnChange(getDefaultPositionByWidgetType(domain/* CampaignWidgetType.Button */.YMh.Button, domain/* CampaignWidgetButtonType.Aside */.UUk.Aside));
            if (supportButtonWidgetType.includes(form.values.type) && !widgetSettingValue) {
                widgetSettingOnChange((0,constants/* getDefaultSurveyButtonWidgetSetting */.V0)(t));
            }
            form.getInputProps("widget.setting.buttonType").onChange(domain/* CampaignWidgetButtonType.Aside */.UUk.Aside);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* RadioGroup */.Ee, {
        data: widgetTypes,
        value: widgetTypeValue,
        onChange: handleChange
    });
};
/* harmony default export */ var StyleSetting_WidgetType = (WidgetType);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Select/Select.js + 2 modules
var Select = __webpack_require__(41754);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Position/positionConfig.ts


var _obj;
var positionConfig = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* CampaignWidgetType.Popup */.YMh.Popup, [
    domain/* CampaignWidgetPosition.BottomRight */.kNk.BottomRight,
    domain/* CampaignWidgetPosition.MiddleRight */.kNk.MiddleRight,
    domain/* CampaignWidgetPosition.Center */.kNk.Center,
    domain/* CampaignWidgetPosition.BottomLeft */.kNk.BottomLeft,
    domain/* CampaignWidgetPosition.MiddleLeft */.kNk.MiddleLeft, 
]), (0,_define_property/* default */.Z)(_obj, domain/* CampaignWidgetType.Button */.YMh.Button, [
    domain/* CampaignWidgetPosition.BottomRight */.kNk.BottomRight,
    domain/* CampaignWidgetPosition.MiddleRight */.kNk.MiddleRight,
    domain/* CampaignWidgetPosition.BottomLeft */.kNk.BottomLeft,
    domain/* CampaignWidgetPosition.MiddleLeft */.kNk.MiddleLeft,
    domain/* CampaignWidgetPosition.Customized */.kNk.Customized, 
]), (0,_define_property/* default */.Z)(_obj, domain/* CampaignWidgetType.Banner */.YMh.Banner, [
    domain/* CampaignWidgetPosition.Top */.kNk.Top,
    domain/* CampaignWidgetPosition.Bottom */.kNk.Bottom
]), _obj);
/* harmony default export */ var Position_positionConfig = (positionConfig);

// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/StyleItem/index.tsx
var StyleItem = __webpack_require__(38759);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/NumberInput/NumberInput.js + 4 modules
var NumberInput = __webpack_require__(4602);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Position/CustomizedPosition/index.tsx








var CustomizedWidgetPosition = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var options = [
        domain/* Align.Left */.xMy.Left,
        domain/* Align.Right */.xMy.Right
    ].map(function(align) {
        return {
            value: align,
            label: t("styles.customizedPosition.align.".concat(align))
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        spacing: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                defaultValue: domain/* Align.Right */.xMy.Right,
                data: options
            }, form.getInputProps("widget.customizedPosition.align")), {
                styles: {
                    input: {
                        paddingRight: 0
                    },
                    rightSection: {
                        width: "24px"
                    }
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "flex-shrink-0",
                children: t("styles.customizedPosition.percentageToTop")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                min: 0,
                max: 100,
                step: 5,
                defaultValue: 60
            }, form.getInputProps("widget.customizedPosition.percentageToTop")), {
                parser: function(value) {
                    return value === null || value === void 0 ? void 0 : value.replace("%", "");
                },
                formatter: function(value) {
                    return "".concat(value, "%");
                },
                styles: {
                    rightSection: {
                        width: "24px"
                    },
                    control: {
                        width: "22px"
                    }
                }
            }))
        ]
    });
};
/* harmony default export */ var CustomizedPosition = (CustomizedWidgetPosition);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Position/index.tsx










var WidgetPosition = function() {
    var ref;
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var widget = form === null || form === void 0 ? void 0 : (ref = form.values) === null || ref === void 0 ? void 0 : ref.widget;
    var ref1;
    var widgetType = (ref1 = widget === null || widget === void 0 ? void 0 : widget.type) !== null && ref1 !== void 0 ? ref1 : domain/* CampaignWidgetType.Button */.YMh.Button;
    var positions = (0,react.useMemo)(function() {
        var positionKeys = Position_positionConfig[widgetType];
        return positionKeys.map(function(item) {
            return {
                value: item,
                label: t("styles.position.".concat(item))
            };
        });
    }, [
        t,
        widgetType
    ]);
    var isCustomizedPosition = form.getInputProps("widget.position").value === domain/* CampaignWidgetPosition.Customized */.kNk.Customized;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
        label: t("styles.position.title"),
        align: isCustomizedPosition ? "top" : "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
                    data: positions
                }, form.getInputProps("widget.position"))),
                isCustomizedPosition && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizedPosition, {})
            ]
        })
    });
};
/* harmony default export */ var Position = (WidgetPosition);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ButtonIcon/index.tsx










var ButtonIcon_obj;
var selectorMap = (ButtonIcon_obj = {}, (0,_define_property/* default */.Z)(ButtonIcon_obj, domain/* CampaignWidgetIcon.Comment */.YQl.Comment, "widgetComment"), (0,_define_property/* default */.Z)(ButtonIcon_obj, domain/* CampaignWidgetIcon.Smile */.YQl.Smile, "widgetSmile"), (0,_define_property/* default */.Z)(ButtonIcon_obj, domain/* CampaignWidgetIcon.Star */.YQl.Star, "widgetStar"), ButtonIcon_obj);
var getIconName = function(key) {
    return selectorMap[key];
};
var WidgetButtonIcon = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var ref = form.getInputProps("widget.setting.icon"), value = ref.value, onChange = ref.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
        label: t("styles.button.icon"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            spacing: "sm",
            children: Object.keys(selectorMap).map(function(key, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                    variant: "outline",
                    size: 32,
                    radius: 4,
                    onClick: function() {
                        onChange(key);
                    },
                    sx: function(theme) {
                        return {
                            background: key === value ? (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme, "dark.5") : (0,getColor/* getBackgroundColor */.dF)("white", theme, "dark.5"),
                            borderColor: key === value ? (0,getColor/* getBorderColor */.kJ)("brandBlue.7", theme, "brandBlue.7") : (0,getColor/* getBorderColor */.kJ)("gray.5", theme, "dark.4"),
                            color: key === value ? (0,getColor/* getTextColor */.uu)("brandBlue.7", theme, "brandBlue.7") : (0,getColor/* getTextColor */.uu)("gray.5", theme),
                            "&:hover": {
                                background: key === value ? (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme) : (0,getColor/* getBackgroundColor */.dF)("gray.1", theme, "dark.7")
                            }
                        };
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        style: {
                            width: 20,
                            height: 20
                        },
                        name: getIconName(key)
                    })
                }, i);
            })
        })
    });
};
/* harmony default export */ var ButtonIcon = (WidgetButtonIcon);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ButtonLabel/index.tsx







var WidgetButtonLabel = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
        label: t("styles.button.label"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* InlineInput */.ZQ, (0,_object_spread/* default */.Z)({
            autoRestore: true,
            autoComplete: "off",
            radius: 4,
            maxLength: 20
        }, form.getInputProps("widget.setting.label")))
    });
};
/* harmony default export */ var ButtonLabel = (WidgetButtonLabel);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(58262);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ColorScheme/Swatch.tsx
var Swatch = __webpack_require__(37959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Popover/Popover.js + 7 modules
var Popover = __webpack_require__(4502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AspectRatio/AspectRatio.js + 1 modules
var AspectRatio = __webpack_require__(91470);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ColorPicker/ColorPicker.js + 11 modules
var ColorPicker = __webpack_require__(73784);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(79965);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ColorScheme/swatch.styles.ts
var swatch_styles = __webpack_require__(57506);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ColorScheme/CustomSwatch/img.png
/* harmony default export */ var img = ({"src":"https://static-cny.howxm.com/_next/static/media/img.0562f42e.png","height":72,"width":72,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA2ElEQVR42hXJQU7CQBiG4fdvpx1kQgkLY9yx8wTujEvP6lFceQEjkqgEaBAbWopO20/ZPcljz68Pb7XG870KbSlso4LNMFFJsB1+6QLNXKAfyy1TIMpR48+pqvNzN7OtvBUmGaUKanN8KLBrg/Wtl5v8rmycfFEka7rE89jc8v59Sdbm9F1qLv2ckfY54bTg5uWeRX3H/rphmkf6dMAl65GoR8Yqw54u0PSKMh7w0xqNopyVzqic2HrDBtQ7hn0gDv8eR0usSpdWYRwScQLFFNpM/dHTHfPlH7pFa40bxUDDAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ColorScheme/CustomSwatch/index.tsx






var CustomSwatch = function(param) {
    var color = param.color, checked = param.checked, onChange = param.onChange, onClick = param.onClick, error = param.error;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var ref1 = (0,react.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    var classes = (0,swatch_styles/* default */.Z)({
        checked: checked
    }).classes;
    (0,react.useEffect)(function() {
        color && setInputValue(color);
    }, [
        color
    ]);
    var handleClick = function() {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        setOpened(true);
    };
    var handleChange = function(color) {
        onChange === null || onChange === void 0 ? void 0 : onChange(color);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        opened: opened,
        onChange: setOpened,
        position: "bottom-end",
        shadow: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectRatio/* AspectRatio */.o, {
                    ratio: 1,
                    className: classes.root,
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: img.src,
                        alt: "Custom Color"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover.Dropdown */.J.Dropdown, {
                p: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPicker */.z, {
                        format: "hex",
                        onChange: setInputValue,
                        onChangeEnd: handleChange,
                        defaultValue: color,
                        styles: function(theme) {
                            return {
                                body: {
                                    paddingTop: theme.spacing.sm,
                                    gap: 12,
                                    alignItems: "center",
                                    "&::after": {
                                        width: 32,
                                        height: 32,
                                        content: '""',
                                        borderRadius: theme.radius.sm,
                                        backgroundColor: error ? undefined : inputValue,
                                        border: error ? "1px solid ".concat((0,getColor/* getDefaultBorderColor */.mK)(theme)) : undefined
                                    }
                                }
                            };
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                        mt: "sm",
                        value: inputValue,
                        onChange: function(e) {
                            return handleChange(e.currentTarget.value);
                        },
                        error: error
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ColorScheme_CustomSwatch = (CustomSwatch);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ColorScheme/index.tsx






var colorSchemePath = "widget.colorScheme";
var accentPath = "".concat(colorSchemePath, ".accent");
var ColorScheme = function(props) {
    var _cols = props.cols, cols = _cols === void 0 ? 7 : _cols;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var defaultAccentColors = (0,react.useMemo)(function() {
        return [
            theme.colors.brandBlue[7],
            theme.colors.blue[6],
            theme.colors.pink[6],
            theme.colors.grape[6],
            theme.colors.violet[6],
            theme.colors.indigo[6],
            theme.colors.cyan[6],
            theme.colors.teal[6],
            theme.colors.green[6],
            theme.colors.lime[6],
            theme.colors.yellow[6],
            theme.colors.orange[6],
            theme.colors.red[6], 
        ];
    }, [
        theme.colors.blue,
        theme.colors.brandBlue,
        theme.colors.cyan,
        theme.colors.grape,
        theme.colors.green,
        theme.colors.indigo,
        theme.colors.lime,
        theme.colors.orange,
        theme.colors.pink,
        theme.colors.red,
        theme.colors.teal,
        theme.colors.violet,
        theme.colors.yellow, 
    ]);
    var customSwatchIndex = defaultAccentColors.length;
    var form = useBuilderFormContext();
    var ref = form === null || form === void 0 ? void 0 : form.getInputProps(accentPath), value = ref.value, onChange = ref.onChange, error = ref.error;
    var ref1 = (0,react.useState)(null), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    (0,react.useEffect)(function() {
        if (value) {
            var index = defaultAccentColors.indexOf(value);
            setSelectedIndex(index === -1 ? customSwatchIndex : index);
        }
    }, [
        customSwatchIndex,
        defaultAccentColors,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleGrid/* SimpleGrid */.M, {
        cols: cols,
        spacing: 10,
        children: [
            defaultAccentColors.map(function(color, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Swatch/* default */.Z, {
                    color: color,
                    checked: selectedIndex === index,
                    onClick: function() {
                        return onChange(color);
                    }
                }, color);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorScheme_CustomSwatch, {
                checked: selectedIndex === customSwatchIndex,
                color: value,
                onChange: onChange,
                onClick: function() {
                    return setSelectedIndex(customSwatchIndex);
                },
                error: error
            })
        ]
    });
};
/* harmony default export */ var StyleSetting_ColorScheme = (ColorScheme);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Slider/Slider/Slider.js
var Slider = __webpack_require__(42534);
// EXTERNAL MODULE: ./src/components/business/HelpDoc/index.tsx
var HelpDoc = __webpack_require__(75801);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ButtonStyle/index.tsx










var buttonStylePath = "formSetting.buttonStyle";
var variantPath = "".concat(buttonStylePath, ".variant");
var borderRadiusPath = "".concat(buttonStylePath, ".borderRadius");
var radiusMin = 0;
var radiusMax = 20;
var ButtonStyle = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var ref = form.getInputProps(borderRadiusPath), borderRadiusValue = ref.value, borderRadiusOnChange = ref.onChange;
    var ref1 = (0,react.useState)(borderRadiusValue !== null && borderRadiusValue !== void 0 ? borderRadiusValue : 0), borderRadiusInputValue = ref1[0], setBorderRadiusInputValue = ref1[1];
    (0,react.useEffect)(function() {
        setBorderRadiusInputValue(borderRadiusValue);
    }, [
        borderRadiusValue
    ]);
    var variantOptions = Object.values(domain/* ButtonVariant */.Wu3).map(function(variant) {
        return {
            label: t("styles.buttonStyle.variant.".concat(variant)),
            value: variant
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 6,
                        children: t("styles.buttonStyle.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpDoc/* default */.Z, {
                        content: t("styles.buttonStyle.submitButtonTip")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
                label: t("styles.buttonStyle.variant.title"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* RadioGroup */.Ee, (0,_object_spread/* default */.Z)({
                    data: variantOptions
                }, form.getInputProps(variantPath)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
                label: t("styles.buttonStyle.borderRadius.title"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                            min: radiusMin,
                            max: radiusMax,
                            size: "xs",
                            thumbSize: 10,
                            label: function(value) {
                                return "".concat(value, "px");
                            },
                            value: borderRadiusInputValue,
                            onChange: setBorderRadiusInputValue,
                            onChangeEnd: borderRadiusOnChange,
                            styles: {
                                root: {
                                    flexGrow: 1
                                },
                                thumb: {
                                    borderWidth: 3
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
                            min: radiusMin,
                            max: radiusMax,
                            precision: 0,
                            autoComplete: "off",
                            formatter: function(value) {
                                return "".concat(value || 0, "px");
                            },
                            parser: function(value) {
                                return value === null || value === void 0 ? void 0 : value.replaceAll(/\D/g, "");
                            },
                            value: borderRadiusInputValue,
                            onChange: borderRadiusOnChange,
                            styles: {
                                wrapper: {
                                    width: 80
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var StyleSetting_ButtonStyle = (ButtonStyle);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/TextAlign/index.tsx







var textAlignPath = "formSetting.textStyle.align";
var TextAlignSetting = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var options = [
        domain/* TextAlign.Start */.PHM.Start,
        domain/* TextAlign.Center */.PHM.Center,
        domain/* TextAlign.End */.PHM.End
    ].map(function(value) {
        return {
            label: t("styles.textStyle.align.".concat(value)),
            value: value
        };
    });
    var ref = form.getInputProps(textAlignPath), value = ref.value, onChange = ref.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
        label: t("styles.textStyle.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* RadioGroup */.Ee, {
            data: options,
            value: value !== null && value !== void 0 ? value : domain/* TextAlign.Start */.PHM.Start,
            onChange: onChange
        })
    });
};
/* harmony default export */ var TextAlign = (TextAlignSetting);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Switch/Switch.js + 3 modules
var Switch = __webpack_require__(54574);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Branding/utils/openConfirmModal.ts

function openConfirmModal(t, accountName, onConfirm) {
    (0,ui/* openAlertModal */.NC)({
        title: t("componentCampaignBuilder:styles.branding.alert.title"),
        content: t("componentCampaignBuilder:styles.branding.alert.desc", {
            accountName: accountName
        }),
        hideIcon: true,
        zIndex: 300,
        onConfirm: onConfirm
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./src/components/business/Account/hooks/useCheckHideBranding.tsx
var useCheckHideBranding = __webpack_require__(31167);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Branding/index.tsx















var Branding = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(true), 2), hideBranding = ref[0], handlers = ref[1];
    var currentUser = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().currentUser;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateAccountMutation */.yq6)(), 1), updateMutation = ref1[0];
    var ref2 = (0,useCheckHideBranding/* default */.Z)(), disabled = ref2.disabled, disabledTip = ref2.disabledTip;
    var ref3 = (0,useAccountSettingCache/* default */.Z)(), hideBrandingState = ref3.hideBranding, loading = ref3.loading;
    (0,react.useEffect)(function() {
        (0,isNil/* default */.Z)(hideBrandingState) || hideBrandingState ? handlers.open() : handlers.close();
    // eslint-disable-next-line
    }, [
        hideBrandingState
    ]);
    var onSet = function() {
        var ref, ref1;
        var ref2;
        openConfirmModal(t, (ref2 = currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.accountUser) === null || ref === void 0 ? void 0 : (ref1 = ref.account) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : "", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        setting: {
                            hideBranding: true
                        }
                    }
                };
                updateMutation({
                    variables: variables
                }).then(function() {
                    handlers.open();
                    ui/* message.successMsg */.yw.successMsg(t("styles.branding.opened"));
                }).catch(function() {
                    ui/* message.error */.yw.error(t("common:message.updateError"));
                });
                return [
                    2
                ];
            });
        }));
    };
    if (hideBranding || loading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HelpDocBlock */.cd, {
        className: "m-0",
        textProps: {
            ml: "xs"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            justify: "space-between",
            align: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: t("styles.branding.".concat(disabled ? "disableTip" : "tip"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                    withArrow: true,
                    disabled: !disabled,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* Switch */.r, {
                                    disabled: true
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                    onClick: onSet,
                                    children: t("common:actions.set")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                            children: disabledTip
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var StyleSetting_Branding = (Branding);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(63332);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/use-form.js + 17 modules
var use_form = __webpack_require__(68329);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/validators/is-not-empty/is-not-empty.js
var is_not_empty = __webpack_require__(95824);
// EXTERNAL MODULE: ./src/components/ui/HelpDocTooltip/index.tsx
var HelpDocTooltip = __webpack_require__(84139);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Locale/utils/wordingInputAvailable.ts


var hideNextButton = function(campaignType) {
    return campaignType === domain/* CampaignType.Feedback */.mL.Feedback;
};
var hideScreenshot = function(application) {
    return (0,applicationUtils/* isMiniappDistribution */.kA)(application) || (0,applicationUtils/* isMobileDistribution */._Z)(application);
};
var hideOtherChoicePlaceholder = function(campaignType) {
    return campaignType === domain/* CampaignType.Feedback */.mL.Feedback;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/omit-deep-lodash@1.1.7/node_modules/omit-deep-lodash/lib/index.js
var lib = __webpack_require__(76190);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(96634);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pick.js + 1 modules
var pick = __webpack_require__(98458);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeep.js
var cloneDeep = __webpack_require__(21409);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Locale/utils/calculateInitialValues.ts




var calculateInitialValues = function(defaultLocaleWords, localeSetting) {
    var ref;
    var wordingsValue = lib_default()((ref = localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.wordings) !== null && ref !== void 0 ? ref : {}, [
        "__typename"
    ]);
    var wordingsNotChanged = (0,isEqual/* default */.Z)(wordingsValue, (0,pick/* default */.Z)(getDefaultLocaleWords/* localeMap */.h[domain/* Locale.ZhCn */.gor.ZhCn], Object.keys(wordingsValue))) || (0,isEqual/* default */.Z)(wordingsValue, (0,pick/* default */.Z)(getDefaultLocaleWords/* localeMap */.h[domain/* Locale.En */.gor.En], Object.keys(wordingsValue)));
    if (wordingsNotChanged) {
        return defaultLocaleWords;
    }
    return (0,merge/* default */.Z)((0,cloneDeep/* default */.Z)(defaultLocaleWords), localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.wordings);
};

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Locale/useWordingsModal.tsx


















var wordingModalId = "wordingModalId";
var FormTextInput = function(props) {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var label = props.label, others = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                sx: {
                    whiteSpace: "nowrap"
                },
                w: 120,
                weight: 600,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, others), {
                size: "sm",
                className: "w-full"
            }))
        ]
    });
};
var ModalContent = function(param) {
    var localeSetting = param.localeSetting, initialDirection = param.direction, application = param.application, campaignType = param.campaignType, onConfirm = param.onConfirm, onDirectionChange = param.onDirectionChange;
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var ref = (0,react.useState)(initialDirection), direction = ref[0], setDirection = ref[1];
    var defaultLocaleWords = (0,react.useMemo)(function() {
        return (0,getDefaultLocaleWords/* default */.Z)(localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.locale);
    }, [
        localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.locale
    ]);
    var initialValues = (0,react.useMemo)(function() {
        return calculateInitialValues(defaultLocaleWords, localeSetting);
    }, [
        defaultLocaleWords,
        localeSetting
    ]);
    var form = (0,use_form/* useForm */.c)({
        initialValues: initialValues,
        validateInputOnBlur: true,
        validate: {
            nextButton: (0,is_not_empty/* isNotEmpty */.U)(t("common:message.valueRequired")),
            submitButton: (0,is_not_empty/* isNotEmpty */.U)(t("common:message.valueRequired")),
            otherChoicePlaceholder: (0,is_not_empty/* isNotEmpty */.U)(t("common:message.valueRequired")),
            screenshotDescription: {
                screenshot: (0,is_not_empty/* isNotEmpty */.U)(t("common:message.valueRequired")),
                captured: (0,is_not_empty/* isNotEmpty */.U)(t("common:message.valueRequired"))
            }
        }
    });
    var handleDirectionChange = function(checked) {
        var dir = checked ? domain/* Direction.Rtl */.Nmp.Rtl : domain/* Direction.Ltr */.Nmp.Ltr;
        setDirection(dir);
        onDirectionChange(dir);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                onConfirm(form.getTransformedValues(), direction);
                (0,events/* closeModal */.Mr)(wordingModalId);
                return [
                    2
                ];
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetToDefault = function() {
        form.setValues(defaultLocaleWords);
    };
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: form.onSubmit(handleSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    size: "sm",
                    color: "dimmed",
                    children: t("styles.locale.form.desc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "sm",
                    children: [
                        (localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.locale) === domain/* Locale.Other */.gor.Other && (0,applicationUtils/* isWebDistribution */.RV)(application) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    noWrap: true,
                                    position: "apart",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                            noWrap: true,
                                            spacing: 0,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                                                    weight: 600,
                                                    sx: {
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: t("styles.locale.form.directionRtl")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpDocTooltip/* default */.Z, {
                                                    withinPortal: true,
                                                    zIndex: 1001,
                                                    children: t("styles.locale.form.directionTip")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* Switch */.r, {
                                            checked: direction === domain/* Direction.Rtl */.Nmp.Rtl,
                                            onChange: function(e) {
                                                return handleDirectionChange(e.currentTarget.checked);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {})
                            ]
                        }),
                        !hideNextButton(campaignType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread/* default */.Z)({
                            label: t("styles.locale.form.nextButton")
                        }, form.getInputProps("nextButton"))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread/* default */.Z)({
                            label: t("styles.locale.form.submitButton")
                        }, form.getInputProps("submitButton"))),
                        !hideOtherChoicePlaceholder(campaignType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread/* default */.Z)({
                            label: t("styles.locale.form.otherChoicePlaceholder")
                        }, form.getInputProps("otherChoicePlaceholder"))),
                        !hideScreenshot(application) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread/* default */.Z)({
                                    label: t("styles.locale.form.screenshotDescription.screenshot")
                                }, form.getInputProps("screenshotDescription.screenshot"))),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTextInput, (0,_object_spread/* default */.Z)({
                                    label: t("styles.locale.form.screenshotDescription.captured")
                                }, form.getInputProps("screenshotDescription.captured")))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                    onClick: function() {
                                        return resetToDefault();
                                    },
                                    children: "恢复默认"
                                }),
                                "|",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                    onClick: function() {
                                        return form.reset();
                                    },
                                    children: "重置修改"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            position: "right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    variant: "default",
                                    onClick: function() {
                                        return (0,events/* closeModal */.Mr)(wordingModalId);
                                    },
                                    children: t("common:actions.cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    type: "submit",
                                    children: t("common:actions.confirm")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
function useWordingsModal(param) {
    var localeSetting = param.localeSetting, direction = param.direction, application = param.application, campaignType = param.campaignType, onConfirm = param.onConfirm, onDirectionChange = param.onDirectionChange;
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    return function() {
        (0,events/* openModal */.h7)({
            modalId: wordingModalId,
            closeOnClickOutside: false,
            closeOnEscape: false,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "md",
                weight: 600,
                children: t("styles.locale.form.title")
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {
                localeSetting: localeSetting,
                direction: direction,
                application: application,
                campaignType: campaignType,
                onConfirm: onConfirm,
                onDirectionChange: onDirectionChange
            }),
            zIndex: 1000,
            centered: true,
            styles: {
                header: {
                    marginBottom: 0
                }
            }
        });
    };
}

// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var config_constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./src/components/business/hooks/useCurrentUserCache.ts
var useCurrentUserCache = __webpack_require__(77759);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Locale/index.tsx













var WidgetLocale = function() {
    var ref, ref1;
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var ref2 = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)(), application = ref2.application, campaignType = ref2.campaignType;
    var account = (0,useCurrentUserCache/* default */.Z)().account;
    var ref3 = (0,domain/* useCheckToggleQuery */.KJ)({
        fetchPolicy: "cache-and-network",
        variables: {
            input: {
                identifier: account === null || account === void 0 ? void 0 : account.id,
                name: config_constants/* FeatureToggle.MultilangDirection */.eh.MultilangDirection
            }
        },
        skip: !(account === null || account === void 0 ? void 0 : account.id)
    }), toggleData = ref3.data;
    var ref4;
    var multilangEnabled = (ref4 = toggleData === null || toggleData === void 0 ? void 0 : toggleData.checkToggle) !== null && ref4 !== void 0 ? ref4 : false;
    var availableLocales = multilangEnabled ? [
        domain/* Locale.ZhCn */.gor.ZhCn,
        domain/* Locale.En */.gor.En,
        domain/* Locale.Other */.gor.Other
    ] : [
        domain/* Locale.ZhCn */.gor.ZhCn,
        domain/* Locale.En */.gor.En
    ];
    var handleDirectionChange = function(direction) {
        form.setFieldValue("formSetting.textStyle.direction", direction);
    };
    var handleConfirm = function(wordings, direction) {
        var locale = form.values.localeSetting.locale;
        form.setFieldValue("localeSetting", {
            locale: locale,
            wordings: wordings
        });
        form.setFieldValue("formSetting.textStyle.direction", direction);
    };
    var ref5;
    var openModal = useWordingsModal({
        localeSetting: form.values.localeSetting,
        direction: (ref5 = (ref = form.values.formSetting) === null || ref === void 0 ? void 0 : (ref1 = ref.textStyle) === null || ref1 === void 0 ? void 0 : ref1.direction) !== null && ref5 !== void 0 ? ref5 : domain/* Direction.Ltr */.Nmp.Ltr,
        campaignType: campaignType,
        application: application,
        onConfirm: handleConfirm,
        onDirectionChange: handleDirectionChange
    });
    var localeOptions = (0,react.useMemo)(function() {
        return availableLocales.map(function(value) {
            return {
                label: t("styles.locale.options." + value),
                value: value
            };
        });
    }, [
        t,
        multilangEnabled
    ]);
    var handleLocalChange = function(value) {
        var ref;
        if (((ref = form.values.localeSetting) === null || ref === void 0 ? void 0 : ref.locale) !== value) {
            form.setFieldValue("localeSetting.locale", value);
            form.setFieldValue("localeSetting.wordings", (0,getDefaultLocaleWords/* default */.Z)(value));
            if (value !== domain/* Locale.Other */.gor.Other) {
                form.setFieldValue("formSetting.textStyle.direction", domain/* Direction.Ltr */.Nmp.Ltr);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
        label: t("styles.locale.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            noWrap: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    data: localeOptions
                }, form.getInputProps("localeSetting.locale")), {
                    onChange: handleLocalChange
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "subtle",
                    size: "xs",
                    onClick: openModal,
                    children: t("styles.locale.edit")
                })
            ]
        })
    });
};
/* harmony default export */ var Locale = (WidgetLocale);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/ProgressBar/index.tsx






var Mode;
(function(Mode) {
    Mode["OFF"] = "off";
    Mode["ON"] = "on";
})(Mode || (Mode = {}));
var ProgressBar = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var options = Object.values(Mode).map(function(value) {
        return {
            label: t("styles.progressBar.".concat(value)),
            value: value
        };
    });
    var ref = form.getInputProps("formSetting.showProgressBar"), value = ref.value, onChange = ref.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
        label: t("styles.progressBar.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* RadioGroup */.Ee, {
            data: options,
            value: value ? Mode.ON : Mode.OFF,
            onChange: function(value) {
                onChange(value === Mode.ON);
            }
        })
    });
};
/* harmony default export */ var StyleSetting_ProgressBar = (ProgressBar);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-event/use-window-event.js
var use_window_event = __webpack_require__(12667);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/AppShell.js + 1 modules
var AppShell = __webpack_require__(12439);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/BuilderSharedDataContext.tsx
var BuilderSharedDataContext = __webpack_require__(59255);
// EXTERNAL MODULE: ./src/plugins/howxm/useHowxmSDK.ts
var useHowxmSDK = __webpack_require__(25474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/FormProvider/FormProvider.js
var FormProvider = __webpack_require__(33313);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/formContext.ts


var ref = (0,_sliced_to_array/* default */.Z)((0,FormProvider/* createFormContext */.W)(), 3);
var BuilderFormProvider = ref[0], useBuilderFormContext = ref[1], useBuilderForm = ref[2];

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/Header/Header.js + 2 modules
var Header = __webpack_require__(34048);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/config/constants/campaignPathMapping.ts
var campaignPathMapping = __webpack_require__(68749);
// EXTERNAL MODULE: ./src/components/ui/Button/index.ts + 3 modules
var ui_Button = __webpack_require__(83347);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/utils/formDataUtils.ts


var initialFormData = {};
var setInitialFormData = function(values) {
    initialFormData = values;
};
var isFormDataChanged = function(value) {
    return !(0,isEqual/* default */.Z)(lib_default()(value, [
        "__typename"
    ]), lib_default()(initialFormData, [
        "__typename"
    ]));
};

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/Header/PageBack.tsx









var PageBack = function() {
    var router = (0,next_router.useRouter)();
    var form = useBuilderFormContext();
    var campaignType = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().campaignType;
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var appId = router.query.appId;
    var campaignId = router.query.campaignId;
    var handleClick = function() {
        if (isFormDataChanged(form.values)) {
            return (0,ui/* openAlertModal */.NC)({
                title: t("common:tip.title"),
                content: t("confirm.message.unSavedChanges"),
                onConfirm: handleJump,
                labels: {
                    confirm: t("confirm.actions.return"),
                    cancel: t("confirm.actions.continue")
                }
            });
        }
        handleJump();
    };
    var handleJump = function() {
        router.push({
            pathname: campaignPathMapping/* entriesPathMapping */.Z[campaignType],
            query: {
                appId: appId,
                campaignId: campaignId
            }
        }).then();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Button/* BackButton */.xE, {
        onClick: handleClick
    });
};
/* harmony default export */ var Header_PageBack = (/*#__PURE__*/(0,react.memo)(PageBack));

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/Header/NameInput.tsx





var NameInput = function() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var form = useBuilderFormContext();
    var ref = form === null || form === void 0 ? void 0 : form.getInputProps("name"), value = ref.value, onChange = ref.onChange;
    var router = (0,next_router.useRouter)();
    var isDuplicated = router.query.isDuplicated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* InlineInput */.ZQ, {
        value: value,
        onChange: onChange,
        width: 300,
        maxLength: 20,
        placeholder: t("titlePlaceholder"),
        radius: "sm",
        autoFocus: isDuplicated === "true",
        autoRestore: true,
        showEmoji: true,
        rightSectionStyle: {
            top: 0
        },
        styles: function(theme) {
            return {
                input: {
                    fontWeight: 600,
                    fontSize: 14
                }
            };
        }
    });
};
/* harmony default export */ var Header_NameInput = (NameInput);

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/Header/HeaderLeft.tsx




var HeaderLeft = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        spacing: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_PageBack, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NameInput, {})
        ]
    });
};
/* harmony default export */ var Header_HeaderLeft = (HeaderLeft);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tooltip/Tooltip.js + 7 modules
var Tooltip = __webpack_require__(57155);
// EXTERNAL MODULE: ./src/components/business/Campaign/DeliveryUrl/index.tsx
var DeliveryUrl = __webpack_require__(69119);
// EXTERNAL MODULE: ./src/components/business/Campaign/hooks/useCampaignStatusAlert.ts
var useCampaignStatusAlert = __webpack_require__(89971);
// EXTERNAL MODULE: ./src/components/ui/LinkWithAction/index.tsx
var LinkWithAction = __webpack_require__(76076);
// EXTERNAL MODULE: ./src/components/business/Campaign/CampaignFormStatusSwitch/index.tsx
var CampaignFormStatusSwitch = __webpack_require__(20395);
// EXTERNAL MODULE: ./src/utils/getXFormUrl.ts
var getXFormUrl = __webpack_require__(6371);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/Header/HeaderRight.tsx

















var HeaderRight = function() {
    var t = (0,useTranslation/* default */.Z)().t;
    var form = useBuilderFormContext();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,useCampaignStatusAlert/* default */.Z)(form.values.type), openAlertModal = ref1.open;
    var onSave = (0,BuilderSharedDataContext/* useBuilderShareActions */.yl)().onSave;
    var _values = form.values, campaignId = _values.id, token = _values.token, type = _values.type, widget = _values.widget;
    var url = (0,getXFormUrl/* getXFormUrl */.t)(token, type, true);
    var application = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().application;
    var isLinkApplication = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    var handleSave = function() {
        setLoading(true);
        onSave === null || onSave === void 0 ? void 0 : onSave(form.values).finally(function() {
            setLoading(false);
        });
    };
    var handleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!form.values.enabled) return [
                            3,
                            1
                        ];
                        openAlertModal(function() {
                            return handleSaveWithStatus(true);
                        });
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            handleSaveWithStatus(false)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleChange() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSaveWithStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(enabled) {
            var successMsg, errorMsg;
            return (0,tslib_es6.__generator)(this, function(_state) {
                successMsg = t("componentCampaignList:statusSwitcher.message.".concat(enabled ? "enabled" : "disabled"), {
                    campaignType: t("componentCampaignList:".concat(form.values.type))
                });
                errorMsg = t("common:message.updateError");
                onSave === null || onSave === void 0 ? void 0 : onSave((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form.values), {
                    enabled: enabled
                }), successMsg, errorMsg).then(function() {
                    return form.setFieldValue("enabled", enabled);
                });
                return [
                    2
                ];
            });
        });
        return function handleSaveWithStatus(enabled) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "lg",
        children: [
            isLinkApplication ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWithAction/* Copy */.CK, {
                        url: url,
                        iconContainerSize: "lg",
                        iconSize: 22
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWithAction/* QrCode */.UH, {
                        url: url,
                        iconContainerSize: "lg",
                        iconSize: 22
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWithAction/* OpenInNewTab */.c5, {
                        url: url,
                        iconContainerSize: "lg",
                        iconSize: 22
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignFormStatusSwitch/* default */.Z, {
                        id: campaignId
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    widget.type !== domain/* CampaignWidgetType.Banner */.YMh.Banner && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryUrl/* default */.Z, {
                        id: form.values.id,
                        size: 22
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        disabled: (0,isEmpty/* default */.Z)(form.errors),
                        withArrow: true,
                        label: t("componentCampaignList:form.invalid.tooltip"),
                        withinPortal: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* Switch */.r, {
                                checked: form.values.enabled,
                                onLabel: t("componentCampaignList:statusSwitcher.opened"),
                                offLabel: t("componentCampaignList:statusSwitcher.closed"),
                                size: "lg",
                                display: "flex",
                                color: "teal.6",
                                onChange: handleChange,
                                disabled: !(0,isEmpty/* default */.Z)(form.errors)
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                disabled: (0,isEmpty/* default */.Z)(form.errors),
                withArrow: true,
                label: t("componentCampaignList:form.invalid.tooltip"),
                withinPortal: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: handleSave,
                        loading: loading,
                        disabled: !(0,isEmpty/* default */.Z)(form.errors),
                        children: t("common:actions.save")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Header_HeaderRight = (HeaderRight);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(70426);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SegmentedControl/SegmentedControl.js + 1 modules
var SegmentedControl = __webpack_require__(80400);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/Header/HeaderCenter.tsx











var Step = function(param) {
    var icon = param.icon, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "xs",
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                children: text
            })
        ]
    });
};
var HeaderCenter = function() {
    var ref;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var _query = router.query, appId = _query.appId, campaignId = _query.campaignId;
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var ref1 = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)(), application = ref1.application, campaignType = ref1.campaignType;
    var isCurrentLinkDistribution = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    var ref2 = (0,BuilderSharedDataContext/* useBuilderShareActions */.yl)(), setEditingFieldIndex = ref2.setEditingFieldIndex, setAutoOpen = ref2.setAutoOpen;
    var ref3;
    var currentStepName = (ref3 = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.step) !== null && ref3 !== void 0 ? ref3 : "fields";
    var steps = (0,react.useMemo)(function() {
        var commonSteps = [
            {
                value: "fields",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                    icon: "fields" === currentStepName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "paperFill"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "paper"
                    }),
                    text: t("steps.fields")
                })
            },
            {
                value: "styles",
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                    icon: "styles" === currentStepName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "paletteFill"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "palette"
                    }),
                    text: t("steps.styles")
                })
            }, 
        ];
        var distributionStep = {
            value: "distribution",
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
                icon: "distribution" === currentStepName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                    size: 20,
                    name: "sendFill",
                    style: {
                        color: (0,getColor/* getTextColor */.uu)("brandBlue.7", theme),
                        // @ts-ignore
                        "--filled-color": "#D1E5FF"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                    name: "send"
                }),
                text: t("steps.distribution")
            })
        };
        return isCurrentLinkDistribution ? commonSteps : (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
            distributionStep
        ]);
    }, [
        currentStepName,
        t,
        theme,
        isCurrentLinkDistribution
    ]);
    var handleOnChange = function(value) {
        router.push({
            pathname: router.pathname,
            query: {
                appId: appId,
                campaignId: campaignId,
                step: value
            }
        }, undefined, {
            shallow: true
        });
        setEditingFieldIndex(0);
        setAutoOpen === null || setAutoOpen === void 0 ? void 0 : setAutoOpen(value === "fields" && campaignType === domain/* CampaignType.Feedback */.mL.Feedback);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentedControl/* SegmentedControl */.s, {
            value: currentStepName,
            data: steps,
            onChange: handleOnChange,
            styles: function(theme) {
                return {
                    root: {
                        backgroundColor: "transparent"
                    },
                    controlActive: {
                        backgroundColor: (0,getColor/* getBackgroundColor */.dF)("brandBlue.1", theme)
                    },
                    indicator: {
                        boxShadow: "none"
                    },
                    label: {
                        fontWeight: "normal",
                        padding: "8px 16px",
                        "&[data-active]": {
                            color: "".concat((0,getColor/* getTextColor */.uu)("brandBlue.7", theme), " !important")
                        }
                    },
                    control: {
                        borderWidth: "0 !important",
                        marginRight: theme.spacing.xs
                    }
                };
            }
        })
    });
};
/* harmony default export */ var Header_HeaderCenter = (/*#__PURE__*/(0,react.memo)(HeaderCenter));

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/Header/index.tsx





var CampaignBuilderHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
        height: 56,
        py: "xs",
        px: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            className: "relative h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    className: "h-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderLeft, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderRight, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCenter, {})
            ]
        })
    });
};
/* harmony default export */ var CampaignBuilder_Header = (CampaignBuilderHeader);

// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/CampaignBuilder.tsx













var CampaignBuilder = function(props) {
    var initialValues = props.initialValues, children = props.children;
    var application = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().application;
    var isWebPlatform = (0,applicationUtils/* isWebDistribution */.RV)(application);
    (0,useHowxmSDK/* default */.Z)(config/* HowXMAppId */.KD);
    var form = useBuilderForm({
        validateInputOnChange: true,
        initialValues: initialValues
    });
    // 在更新完survey或feedback的字段后，从服务端取到最新的字段，重新设置formFields的状态
    (0,react.useEffect)(function() {
        form.setValues({
            formFields: initialValues.formFields
        });
        setInitialFormData(initialValues);
    // eslint-disable-next-line
    }, [
        initialValues.formFields
    ]);
    (0,use_window_event/* useWindowEvent */.s)("beforeunload", function(event) {
        if (!isFormDataChanged(form.values)) return;
        event.preventDefault();
        event.returnValue = "";
    });
    (0,react.useEffect)(function() {
        // 为了在点击返回的时候比较form data是否有改变
        // 为什么不直接用initialValues进行比较？因为除了initialValues外，还会自动增加screenshotField（如果开启了Toggle， 同时当前没有screenshotField）
        setInitialFormData(initialValues);
    // eslint-disable-next-line
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuilderFormProvider, {
        form: form,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: form.onSubmit(function() {
                    return false;
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppShell/* AppShell */.V, {
                    padding: 0,
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBuilder_Header, {}),
                    styles: function(theme) {
                        return {
                            main: {
                                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme, "dark.8")
                            }
                        };
                    },
                    children: children
                })
            }),
            isWebPlatform && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPreview/* default.PreLoadBg */.Z.PreLoadBg, {})
        ]
    });
};
/* harmony default export */ var CampaignBuilder_CampaignBuilder = (CampaignBuilder);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(61843);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/dynamic.js
var dynamic = __webpack_require__(92295);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Emoji/index.tsx












var Emoji_ModalContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 886).then(__webpack_require__.bind(__webpack_require__, 40886));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40886)
            ];
        }
    }
});
var Emoji = function() {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentCampaignBuilder").t;
    var ref = (0,react.useState)(false), opened = ref[0], setOpened = ref[1];
    var currentUser = (0,BuilderSharedDataContext/* useBuilderSharedDataContext */.MF)().currentUser;
    var ref1 = (0,domain/* useCheckToggleQuery */.KJ)({
        fetchPolicy: "cache-and-network",
        variables: {
            input: {
                identifier: currentUser === null || currentUser === void 0 ? void 0 : currentUser.mobile,
                name: config_constants/* FeatureToggle.AIEmoji */.eh.AIEmoji
            }
        }
    }), toggleData = ref1.data;
    var ref2 = (0,business/* useCheckCreateSurveyByAi */.RN)(), disabled = ref2.disabled, disabledTip = ref2.disabledTip;
    if (!(toggleData === null || toggleData === void 0 ? void 0 : toggleData.checkToggle)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleItem/* default */.Z, {
                label: t("styles.emoji.title"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AIButton */.mw, {
                    onClick: function() {
                        setOpened(true);
                    },
                    label: t("styles.emoji.buttonLabel"),
                    disabled: disabled,
                    disabledTip: disabledTip,
                    w: 203
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    weight: 600,
                    size: "md",
                    children: t("styles.emoji.buttonLabel")
                }),
                closeOnClickOutside: false,
                closeOnEscape: false,
                opened: opened,
                onClose: function() {
                    setOpened(false);
                },
                size: 1000,
                transitionProps: {
                    transition: "fade",
                    duration: 200,
                    timingFunction: "linear"
                },
                overlayProps: {
                    color: (0,getColor/* getTextColor */.uu)("gray.2", theme),
                    opacity: 0.55,
                    blur: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji_ModalContent, {
                    onClose: function() {
                        setOpened(false);
                    },
                    opened: opened
                })
            })
        ]
    });
};
/* harmony default export */ var StyleSetting_Emoji = (Emoji);

// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/constant.ts
var CampaignBuilder_constant = __webpack_require__(2056);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/index.ts



















/***/ }),

/***/ 60129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getCampaignInput; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./src/components/business/SurveyBuilder/Field/FieldEditor/RulesSetting/utils/getRule.ts
var getRule = __webpack_require__(29184);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/trim.js + 2 modules
var trim = __webpack_require__(4745);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(68844);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeep.js
var cloneDeep = __webpack_require__(21409);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/omit.js + 1 modules
var omit = __webpack_require__(81737);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/utils/tempCode.ts + 1 modules
var tempCode = __webpack_require__(78360);
// EXTERNAL MODULE: ./src/config/constants/fieldType.ts
var fieldType = __webpack_require__(68123);
;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/utils/getImage.ts

function getImage(field) {
    if (!field.image) {
        return null;
    }
    return (0,omit/* default */.Z)(field === null || field === void 0 ? void 0 : field.image, [
        "url"
    ]);
}

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/utils/getFormFieldInputSetting.ts







function getFormFieldInputSetting(field) {
    var labelHidden = field.labelHidden;
    var commonSetting = {
        labelHidden: labelHidden,
        image: getImage(field)
    };
    if (field.type === domain/* FormFieldType.TextArea */.EIl.TextArea) {
        var textAreaField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            placeholder: textAreaField === null || textAreaField === void 0 ? void 0 : textAreaField.placeholder,
            screenshotsEnabled: textAreaField === null || textAreaField === void 0 ? void 0 : textAreaField.screenshotsEnabled,
            labelHidden: labelHidden
        });
    }
    if (field.type === domain/* FormFieldType.TextField */.EIl.TextField) {
        var textField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            placeholder: textField === null || textField === void 0 ? void 0 : textField.placeholder
        });
    }
    if (field.type === domain/* FormFieldType.NpsField */.EIl.NpsField) {
        var npsField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            ratingMax: npsField === null || npsField === void 0 ? void 0 : npsField.ratingMax,
            ratingMinDescription: npsField === null || npsField === void 0 ? void 0 : npsField.ratingMinDescription,
            ratingMaxDescription: npsField === null || npsField === void 0 ? void 0 : npsField.ratingMaxDescription
        });
    }
    if (field.type === domain/* FormFieldType.RatingField */.EIl.RatingField) {
        var ratingField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            ratingType: ratingField === null || ratingField === void 0 ? void 0 : ratingField.ratingType,
            ratingMax: ratingField === null || ratingField === void 0 ? void 0 : ratingField.ratingMax,
            ratingMinDescription: ratingField === null || ratingField === void 0 ? void 0 : ratingField.ratingMinDescription,
            ratingMaxDescription: ratingField === null || ratingField === void 0 ? void 0 : ratingField.ratingMaxDescription,
            ratingDescriptions: ratingField === null || ratingField === void 0 ? void 0 : ratingField.ratingDescriptions,
            layout: ratingField === null || ratingField === void 0 ? void 0 : ratingField.layout
        });
    }
    if (field.type === domain/* FormFieldType.CsatField */.EIl.CsatField) {
        var csatField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            ratingDescriptions: csatField === null || csatField === void 0 ? void 0 : csatField.ratingDescriptions
        });
    }
    if (field.type === domain/* FormFieldType.CesField */.EIl.CesField) {
        var cesField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            ratingMax: cesField === null || cesField === void 0 ? void 0 : cesField.ratingMax,
            ratingMinDescription: cesField === null || cesField === void 0 ? void 0 : cesField.ratingMinDescription,
            ratingMaxDescription: cesField === null || cesField === void 0 ? void 0 : cesField.ratingMaxDescription
        });
    }
    if (fieldType/* SELECTABLE_FIELDS.includes */.gi.includes(field.type)) {
        var ref;
        var result = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            choices: (field === null || field === void 0 ? void 0 : (ref = field.choices) === null || ref === void 0 ? void 0 : ref.filter(function(choice) {
                return choice.label;
            }).map(function(choice) {
                var ref;
                choice.value = (0,tempCode/* clearPreCode */.L3)(choice.value);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,omit/* default */.Z)(choice, "__typename")), {
                    label: (ref = choice.label) === null || ref === void 0 ? void 0 : ref.trim()
                });
            })) || [],
            choicesRandom: field.choicesRandom,
            choicesStyle: field.choicesStyle,
            choicesSize: field.choicesSize,
            rowChoiceCount: field.rowChoiceCount
        });
        if (field.type == domain/* FormFieldType.CheckBox */.EIl.CheckBox) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                minChoices: field.minChoices,
                maxChoices: field.maxChoices
            });
        }
        if (field.type == domain/* FormFieldType.CtaField */.EIl.CtaField) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
                ctaPrimaryButtonLink: field.primaryButtonLink,
                ctaSecondaryButtonLink: field.secondaryButtonLink,
                ctaButtonAlign: field.buttonAlign,
                image: getImage(field)
            });
        }
        return result;
    }
    if (field.type === domain/* FormFieldType.WelcomeField */.EIl.WelcomeField) {
        var welcomeField = field;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            welcomeContent: welcomeField === null || welcomeField === void 0 ? void 0 : welcomeField.content,
            welcomeButtonText: welcomeField === null || welcomeField === void 0 ? void 0 : welcomeField.buttonText
        });
    }
    if (field.type === domain/* FormFieldType.EndingField */.EIl.EndingField) {
        var ref1;
        var endingField = field;
        var ref2;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonSetting), {
            endingContent: endingField === null || endingField === void 0 ? void 0 : (ref1 = endingField.content) === null || ref1 === void 0 ? void 0 : ref1.trim(),
            endingAutoCloseEnabled: endingField === null || endingField === void 0 ? void 0 : endingField.autoCloseEnabled,
            endingAutoCloseDuration: (ref2 = endingField === null || endingField === void 0 ? void 0 : endingField.autoCloseDuration) !== null && ref2 !== void 0 ? ref2 : 2800
        });
    }
    if (field.type === domain/* FormFieldType.DescriptionField */.EIl.DescriptionField) {
        return (0,_object_spread/* default */.Z)({}, commonSetting);
    }
    return {};
}

;// CONCATENATED MODULE: ./src/components/business/CampaignBuilder/utils/getCampaignInput.ts








function getFormFields(formFields) {
    return formFields.map(function(field) {
        var label = field.label, type = field.type, page = field.page, validators = field.validators, code = field.code, apiCode = field.apiCode, hidden = field.hidden, description = field.description;
        var jumpRule = (0,getRule/* getJumpRule */.k)(field);
        var showRules = (0,getRule/* getShowRules */.u)(field);
        return {
            label: (0,trim/* default */.Z)(label),
            type: type,
            page: page,
            code: (0,tempCode/* clearPreCode */.L3)(code),
            apiCode: apiCode,
            description: (0,trim/* default */.Z)(description),
            validators: validators,
            setting: getFormFieldInputSetting(field),
            hidden: hidden,
            jumpRule: getFormFieldJumpRule(jumpRule),
            showRules: getFormFieldShowRules(showRules)
        };
    });
}
function getFormFieldJumpRule(jumpRule) {
    var ref;
    if (!(jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.target) && !(jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.subRules)) {
        return jumpRule;
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, jumpRule), {
        target: (jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.target) ? (0,tempCode/* clearPreCode */.L3)(jumpRule === null || jumpRule === void 0 ? void 0 : jumpRule.target) : null,
        subRules: jumpRule === null || jumpRule === void 0 ? void 0 : (ref = jumpRule.subRules) === null || ref === void 0 ? void 0 : ref.map(function(subRule) {
            var ref;
            return (ref = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, subRule), {
                key: (0,tempCode/* clearPreCode */.L3)(subRule === null || subRule === void 0 ? void 0 : subRule.key),
                target: (0,tempCode/* clearPreCode */.L3)(subRule === null || subRule === void 0 ? void 0 : subRule.target),
                conditionGroup: formatConditionGroup(subRule.conditionGroup)
            })) !== null && ref !== void 0 ? ref : null;
        })
    });
}
function getFormFieldShowRules(showRules) {
    if (showRules) {
        return showRules.map(function(rule) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rule), {
                targets: rule === null || rule === void 0 ? void 0 : (ref = rule.targets) === null || ref === void 0 ? void 0 : ref.map(tempCode/* clearPreCode */.L3),
                conditionGroup: formatConditionGroup(rule.conditionGroup)
            });
        });
    }
    return [];
}
function clearConditionNodeType(nodeType) {
    return nodeType && Object.values(domain/* ConditionNodeType */.BAL).includes(nodeType) ? nodeType : undefined;
}
function formatConditionGroup(conditionGroup) {
    if (conditionGroup) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, conditionGroup), {
            conditions: conditionGroup === null || conditionGroup === void 0 ? void 0 : conditionGroup.conditions.map(function(condition) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, condition), {
                    firstNode: {
                        type: clearConditionNodeType(condition.firstNode.type),
                        value: (0,tempCode/* clearPreCode */.L3)(condition.firstNode.value)
                    },
                    secondNode: condition.secondNode ? {
                        type: clearConditionNodeType(condition.secondNode.type),
                        value: (0,isArray/* default */.Z)(condition.secondNode.value) ? condition.secondNode.value.map(tempCode/* clearPreCode */.L3) : (0,tempCode/* clearPreCode */.L3)(condition.secondNode.value)
                    } : null
                });
            })
        });
    }
    return null;
}
function cleanAndFormatConditionGroup(conditionGroup) {
    if (conditionGroup && conditionGroup.conditions.length > 0) {
        return formatConditionGroup(conditionGroup);
    }
    return null;
}
function formatEventTriggerCondition(_param) {
    var eventConditions = _param.eventConditions, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "eventConditions"
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        eventConditions: eventConditions.map(function(param) {
            var code = param.code, attributeFilter = param.attributeFilter, countThreshold = param.countThreshold, countWindow = param.countWindow;
            return {
                code: code,
                attributeFilter: cleanAndFormatConditionGroup(attributeFilter),
                countThreshold: countThreshold !== null && countThreshold !== void 0 ? countThreshold : null,
                countWindow: countWindow !== null && countWindow !== void 0 ? countWindow : null
            };
        })
    });
}
function filterTriggerConditions(conditions, widgetType) {
    if (widgetType === domain/* CampaignWidgetType.Popup */.YMh.Popup) {
        return conditions.map(function(condition) {
            return condition.event === domain/* CampaignTriggerEvent.EventReceived */.Yeg.EventReceived ? formatEventTriggerCondition(condition) : condition;
        });
    }
    return conditions.filter(function(param) {
        var event = param.event;
        return event !== domain/* CampaignTriggerEvent.EventReceived */.Yeg.EventReceived;
    });
}
function formatUrlFilter(filter) {
    return (0,isNil/* default */.Z)(filter) || (0,isEmpty/* default */.Z)(filter.conditions) ? null : filter;
}
function getCampaignInput(state) {
    var ref, ref1;
    var ref2 = (0,cloneDeep/* default */.Z)(state), name = ref2.name, enabled = ref2.enabled, type = ref2.type, widget = ref2.widget, formFields = ref2.formFields, formSetting = ref2.formSetting, targeting = ref2.targeting, openStrategy = ref2.openStrategy, trigger = ref2.trigger, localeSetting = ref2.localeSetting, schedule = ref2.schedule;
    return {
        name: name,
        enabled: enabled,
        type: type,
        form: {
            fields: getFormFields(formFields),
            setting: (0,_object_spread/* default */.Z)({}, (0,omit/* default */.Z)(formSetting || {}, "colorScheme"))
        },
        widget: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, widget), {
            colorScheme: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, widget.colorScheme), {
                background: ((ref = widget.colorScheme) === null || ref === void 0 ? void 0 : ref.background) ? (ref1 = widget.colorScheme) === null || ref1 === void 0 ? void 0 : ref1.background : "#1D55C4"
            })
        }),
        targeting: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, targeting), {
            urlFilter: formatUrlFilter(targeting.urlFilter),
            excludeUrlFilter: formatUrlFilter(targeting.excludeUrlFilter),
            customerFilter: cleanAndFormatConditionGroup(targeting.customerFilter)
        }),
        openStrategy: openStrategy,
        trigger: {
            operator: trigger.operator,
            conditions: filterTriggerConditions(trigger.conditions, widget.type)
        },
        localeSetting: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localeSetting), {
            wordings: (0,omit/* default */.Z)(localeSetting === null || localeSetting === void 0 ? void 0 : localeSetting.wordings, [
                "branding",
                "ratingDescription"
            ])
        }),
        schedule: schedule
    };
}


/***/ }),

/***/ 7695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);

var getWidgetPosition = function(channel) {
    switch(channel){
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Android */ .wQf.Android:
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift:
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp:
            return types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignWidgetPosition.BottomCenter */ .kNk.BottomCenter;
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Web */ .wQf.Web:
            return types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignWidgetPosition.MiddleRight */ .kNk.MiddleRight;
        default:
            return types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignWidgetPosition.MiddleRight */ .kNk.MiddleRight;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getWidgetPosition);


/***/ }),

/***/ 58867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCampaignTriggerCondition; }
/* harmony export */ });
/* harmony import */ var components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89433);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59845);


function useCampaignTriggerCondition() {
    var form = (0,components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .useBuilderFormContext */ .On)();
    var trigger = form.values.trigger;
    var getTriggerCondition = function(event) {
        return trigger.conditions.find(function(condition) {
            return condition.event === event;
        });
    };
    var getPageTriggerCondition = function() {
        return getTriggerCondition(types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignTriggerEvent.PageVisit */ .Yeg.PageVisit);
    };
    var getEventTriggerCondition = function() {
        return getTriggerCondition(types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignTriggerEvent.EventReceived */ .Yeg.EventReceived);
    };
    var getEventConditions = function() {
        var ref;
        return (ref = getEventTriggerCondition()) === null || ref === void 0 ? void 0 : ref.eventConditions;
    };
    return {
        getPageTriggerCondition: getPageTriggerCondition,
        getEventTriggerCondition: getEventTriggerCondition,
        getEventConditions: getEventConditions
    };
}


/***/ }),

/***/ 92453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSecondaryTextColor; }
/* harmony export */ });
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69777);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55075);


function useSecondaryTextColor() {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .useMantineTheme */ .rZ)();
    return (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_0__/* .getTextColor */ .uu)("gray.7", theme);
}


/***/ }),

/***/ 60778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ChannelPreview_Mobile; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
;// CONCATENATED MODULE: ./src/components/business/ChannelPreview/images/miniappNav.png
/* harmony default export */ var miniappNav = ({"src":"https://static-cny.howxm.com/_next/static/media/miniappNav.7258b7e7.png","height":88,"width":750,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJ0lEQVR4nA3DwQ0AIAwDsUvZf07EiwGgSmPJ2ucaEU5hmyqx8v1mAL5mCr3eeLzIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/PlatformPreview/MobilePreview/index.tsx + 2 modules
var MobilePreview = __webpack_require__(79759);
;// CONCATENATED MODULE: ./src/components/business/ChannelPreview/Mobile.tsx







var Mobile = function(param) {
    var template = param.template, channel = param.channel, previewRef = param.previewRef;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobilePreview/* default */.Z, {
        children: [
            channel === "miniapp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                src: miniappNav.src,
                width: "100%",
                h: 44,
                alt: "miniapp nav"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: classnames_default()("overflow-hidden absolute left-1/2 -translate-x-1/2 bg-white rounded-full")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: "overflow-hidden absolute top-0 right-0 bottom-0 left-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    className: "overflow-hidden h-full rounded-[6px]",
                    children: template && /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* SurveyTemplatePreview */.St, {
                        channel: channel,
                        platform: "mobile",
                        token: template.code,
                        fields: template === null || template === void 0 ? void 0 : (ref = template.form) === null || ref === void 0 ? void 0 : ref.fields,
                        formSetting: (ref1 = template.form) === null || ref1 === void 0 ? void 0 : ref1.setting,
                        widget: template === null || template === void 0 ? void 0 : template.widget,
                        ref: previewRef
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                className: classnames_default()("absolute left-1/2 -translate-x-1/2 bg-[#CED4DA] rounded-full", "bottom-[8px] w-[134px] h-[5px]")
            })
        ]
    });
};
/* harmony default export */ var ChannelPreview_Mobile = (Mobile);


/***/ }),

/***/ 42987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14661);
/* harmony import */ var components_business__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91404);
/* harmony import */ var _PlatformPreview_DesktopPreview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98555);





var Web = function(param) {
    var template = param.template, channel = param.channel, previewRef = param.previewRef;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        className: "rounded-[12px] w-full h-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PlatformPreview_DesktopPreview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: template && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_business__WEBPACK_IMPORTED_MODULE_2__/* .SurveyTemplatePreview */ .St, {
                channel: channel,
                platform: "desktop",
                token: template.code,
                fields: template === null || template === void 0 ? void 0 : (ref = template.form) === null || ref === void 0 ? void 0 : ref.fields,
                formSetting: (ref1 = template.form) === null || ref1 === void 0 ? void 0 : ref1.setting,
                widget: template === null || template === void 0 ? void 0 : template.widget,
                ref: previewRef
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Web);


/***/ }),

/***/ 24023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _Web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42987);
/* harmony import */ var _Mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60778);






var PreviewMap = {
    web: _Web__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    mobileApp: _Mobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    miniapp: _Mobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    link: _Web__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
var ChannelPreview = function(_param) {
    var channel = _param.channel, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "channel"
    ]);
    var Component = PreviewMap[channel];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        channel: channel
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (ChannelPreview);


/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ closeAddToSegmentModal; },
  "Z": function() { return /* binding */ useAddToSegments; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var router = __webpack_require__(73654);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/components/ui/message/index.tsx
var message = __webpack_require__(92309);
// EXTERNAL MODULE: ./src/components/business/Customer/CustomerSegmentSelector/index.tsx
var CustomerSegmentSelector = __webpack_require__(83629);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
;// CONCATENATED MODULE: ./src/components/business/Customer/AddToSegments/Content.tsx
















var Content = function(props) {
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var customerIds = props.customerIds, existedSegmentIds = props.existedSegmentIds, onClose = props.onClose, onSuccess = props.onSuccess;
    var ref = (0,react.useState)([]), selectedIds = ref[0], setSelectedIds = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), disabled = ref1[0], toggle = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,domain/* useCustomerSegmentsCustomerCountByIdsLazyQuery */.e_c)({
        fetchPolicy: "cache-and-network"
    }), 1), queryCustomerSegmentsCustomerCount = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,domain/* useAddToCustomerSegmentsMutation */.umI)(), 1), mutation = ref3[0];
    var handleSuccess = function() {
        onClose();
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        message/* default.successMsg */.Z.successMsg("".concat(t("customersActions.addToSegment")).concat(t("common:message.success")));
    };
    var handleSave = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ((0,isEmpty/* default */.Z)(customerIds) || (0,isEmpty/* default */.Z)(selectedIds)) {
                            handleSuccess();
                            return [
                                2
                            ];
                        }
                        toggle.open();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            mutation({
                                variables: {
                                    input: {
                                        applicationId: (router_default()).query.appId,
                                        customerIds: customerIds,
                                        segmentIds: selectedIds
                                    }
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        return [
                            4,
                            queryCustomerSegmentsCustomerCount({
                                variables: {
                                    ids: selectedIds
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        if (data === null || data === void 0 ? void 0 : data.addToCustomerSegments) {
                            handleSuccess();
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        message/* default.error */.Z.error("".concat(t("customersActions.addToSegment")).concat(t("common:message.failed")));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        toggle.close();
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "pageCustomerSegment:addToSegment.description",
                    components: {
                        link: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                            target: "__blank",
                            href: "https://howxm.com/help/articles/customer-segment"
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSegmentSelector/* default */.Z, {
                disabledSegmentIds: existedSegmentIds,
                value: selectedIds,
                onChange: setSelectedIds
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                position: "right",
                mt: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "default",
                        onClick: onClose,
                        children: t("common:actions.cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        disabled: disabled,
                        onClick: handleSave,
                        children: t("common:actions.save")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AddToSegments_Content = (Content);

;// CONCATENATED MODULE: ./src/components/business/Customer/AddToSegments/index.tsx








var modalId = "addToSegment";
var closeAddToSegmentModal = function() {
    (0,events/* closeModal */.Mr)(modalId);
};
function useAddToSegments() {
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    var open = function(props) {
        (0,events/* openModal */.h7)({
            modalId: modalId,
            closeOnEscape: false,
            closeOnClickOutside: false,
            size: 500,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                weight: 600,
                size: "md",
                children: t("addToSegment.title")
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToSegments_Content, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                onClose: closeAddToSegmentModal
            }))
        });
    };
    return {
        open: open
    };
}


/***/ }),

/***/ 24319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Customer_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Avatar/Avatar.js + 5 modules
var Avatar = __webpack_require__(56169);
;// CONCATENATED MODULE: ./src/components/business/Customer/Avatar/avatar.png
/* harmony default export */ var avatar = ({"src":"https://static-cny.howxm.com/_next/static/media/avatar.8effb1dd.png","height":160,"width":160,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9klEQVR42g3KvUrDUBiA4fc7aSP9CwZMQYu4FDGDLg62BFwVwU0cCoKb3oT30e4ObuLiKoil3aRQLIpQBHFRiIKJ6ZHDadaHRwDs/VGImB7WbWEVYAd4V+fAROzDYZj9bvRHH9v+V1Ij/XfRpsD0pxZfjBpRAVPtXo/3/c7tlqY+c1ECGZoF428Gf708VNov8SIEqXvcMLzGlpW6crWB8TcthdIEpRloRaGo6ERlmstF3hOoOJCHbLhUTkGLVgIHux57O2X9lFhKjgzEPhNe3tz1Tx6b/pqjefu0UBHWPYlFJBKA1dNpWBXbzaFdcsBahqnhDJjMAa2IWM7ryNGfAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/business/Customer/Avatar/index.tsx




var CustomerAvatar = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
        size: size,
        src: avatar.src,
        radius: "xl",
        alt: "user avatar"
    });
};
/* harmony default export */ var Customer_Avatar = (CustomerAvatar);


/***/ }),

/***/ 53699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ CustomerDetail_Modal; },
  "Y": function() { return /* reexport */ useCustomerDetailModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(65067);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/LoadingOverlay/LoadingOverlay.js + 1 modules
var LoadingOverlay = __webpack_require__(93787);
// EXTERNAL MODULE: ./src/plugins/apollo/index.tsx
var apollo = __webpack_require__(3745);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/components/business/Customer/CustomerSegments/index.tsx
var CustomerSegments = __webpack_require__(50257);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./src/components/business/CustomerCard/index.tsx
var CustomerCard = __webpack_require__(94028);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/constant.ts

var modalId = "customerDetail";
// marginY(24*2) + title height(25) + spacing(24)
var filledRecordsSpacing = 48 + 25 + 24;
var submittedRecordsHeight = constants/* outsideModalBodyHeight */.nr + filledRecordsSpacing;
// body paddingBottom(24)
var basicInfoSpacing = 40;
var basicInfoHeight = constants/* outsideModalBodyHeight */.nr + basicInfoSpacing;

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(58262);
;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/BasicInfo/CustomerAttributes.tsx







var reservedCustomerFields = [
    "uid",
    "name",
    "mobile",
    "email"
];
var CustomerAttributes = function(props) {
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    var customer = props.customer, customerAttributes = props.customerAttributes;
    var customizedAttributes = (0,react.useMemo)(function() {
        return customerAttributes.filter(function(attr) {
            return !reservedCustomerFields.includes(attr.code);
        });
    }, [
        customerAttributes
    ]);
    var formatValue = function(attr) {
        var ref, ref1;
        var value = customer === null || customer === void 0 ? void 0 : (ref = customer.attrValues) === null || ref === void 0 ? void 0 : ref[attr.code];
        if ((0,isNil/* default */.Z)(value)) {
            return "";
        }
        if ((0,utils/* isDatetimeField */.lM)(attr === null || attr === void 0 ? void 0 : (ref1 = attr.aliases) === null || ref1 === void 0 ? void 0 : ref1[0])) {
            return (0,utils/* formatISOTimeOrNull */.y7)(customer === null || customer === void 0 ? void 0 : customer.attrValues[attr.code]);
        }
        if ((0,utils/* isUrl */.CB)(value)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UrlWithTooltip */.wr, {
                url: value,
                includeProtocolAndHost: true
            });
        }
        return value;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 6,
                children: t("customerDetail.attribute")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleGrid/* SimpleGrid */.M, {
                cols: 2,
                verticalSpacing: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        labelClassName: "min-w-[28px]",
                        label: t("customer:customer_name"),
                        value: customer === null || customer === void 0 ? void 0 : customer.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        labelClassName: "min-w-[28px]",
                        label: t("customer:customer_email"),
                        value: customer === null || customer === void 0 ? void 0 : customer.email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                        labelClassName: "min-w-[28px]",
                        label: t("customer:customer_mobile"),
                        value: customer === null || customer === void 0 ? void 0 : customer.mobile
                    }),
                    customizedAttributes.map(function(attr, index) {
                        var ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                            labelClassName: "min-w-[56px]",
                            label: attr.displayName || (attr === null || attr === void 0 ? void 0 : (ref = attr.aliases) === null || ref === void 0 ? void 0 : ref[0]) || "",
                            value: formatValue(attr)
                        }, "".concat(attr.id, "-").concat(index));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BasicInfo_CustomerAttributes = (CustomerAttributes);

;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/BasicInfo/index.tsx













var BasicInfo = function(props) {
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    var id = props.id, customerAttributes = props.customerAttributes, manageable = props.manageable;
    var data = (0,domain/* useCustomerQuery */.k1N)({
        skip: !id,
        variables: {
            id: id
        }
    }).data;
    var ref;
    var customer = (ref = (0,apollo/* initializeApollo */["in"])().readFragment({
        id: "Customer:".concat(id),
        fragment: domain/* CustomerFragmentDoc */.hk_
    })) !== null && ref !== void 0 ? ref : data === null || data === void 0 ? void 0 : data.customer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea.Autosize */.x.Autosize, {
        scrollbarSize: 5,
        mah: "calc(100vh - ".concat(basicInfoHeight, "px)"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
            spacing: "3xl",
            w: 640,
            m: "3xl",
            children: (0,isNil/* default */.Z)(customer) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOverlay/* LoadingOverlay */.f, {
                visible: true
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomerCard/* default */.Z, {
                        UID: customer === null || customer === void 0 ? void 0 : customer.uid,
                        size: "md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                                label: t("field.lastSubmittedAt"),
                                value: (0,utils/* formatISOTime */.cx)(customer === null || customer === void 0 ? void 0 : customer.lastSubmittedAt)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                                label: t("field.lastSubmittedRegion"),
                                value: (0,utils/* getDisplayRegion */.M$)(customer === null || customer === void 0 ? void 0 : customer.lastSubmittedRegion)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* LabelWithValue */.O_, {
                                label: t("field.lastSubmittedIp"),
                                value: customer === null || customer === void 0 ? void 0 : customer.lastSubmittedIp
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSegments/* default */.Z, {
                        id: id,
                        manageable: manageable
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicInfo_CustomerAttributes, {
                        customer: customer,
                        customerAttributes: customerAttributes
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CustomerDetail_BasicInfo = (BasicInfo);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keyBy.js
var keyBy = __webpack_require__(60968);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Timeline/Timeline.js + 3 modules
var Timeline = __webpack_require__(10222);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tooltip/Tooltip.js + 7 modules
var Tooltip = __webpack_require__(57155);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/utils/formFieldResolver.ts + 8 modules
var formFieldResolver = __webpack_require__(1134);
// EXTERNAL MODULE: ./src/components/business/Campaign/EntryModal/index.ts + 35 modules
var EntryModal = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/plugins/apollo/cacheUtils.ts
var cacheUtils = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/components/ui/Loading/index.tsx
var Loading = __webpack_require__(12189);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ThemeIcon/ThemeIcon.js + 1 modules
var ThemeIcon = __webpack_require__(53196);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconNote.js
var IconNote = __webpack_require__(19850);
;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/SubmittedRecords/Blank.tsx






var Blank = function() {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
        mt: "3xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "sm",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    radius: "xl",
                    color: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme),
                    size: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNote/* default */.Z, {
                        color: (0,getColor/* getTextColor */.uu)("gray.5", theme)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    color: "dimmed",
                    children: t("customerDetail.submittedRecords.blank")
                })
            ]
        })
    });
};
/* harmony default export */ var SubmittedRecords_Blank = (Blank);

;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/SubmittedRecords/index.tsx





















var _obj;
var overviewPath = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* CampaignType.Feedback */.mL.Feedback, constants/* ApplicationFeedbackShow */.PD), (0,_define_property/* default */.Z)(_obj, domain/* CampaignType.Survey */.mL.Survey, constants/* ApplicationSurveyShow */.Ky), (0,_define_property/* default */.Z)(_obj, domain/* CampaignType.Notification */.mL.Notification, constants/* ApplicationNotificationShow */.s3), _obj);
var SubmittedRecords = function(props) {
    var ref, ref1;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    var appId = (0,router.useRouter)().query.appId;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,domain/* useCampaignEntryComponentLazyQuery */.mLD)(), 1), queryCampaignEntry = ref2[0];
    var id = props.id, manageable = props.manageable;
    var open = (0,EntryModal/* useEntryModal */.DM)(manageable).open;
    var ref3 = (0,domain/* useCustomerSubmittedEntriesQuery */.KcD)({
        fetchPolicy: "cache-and-network",
        skip: !id,
        variables: {
            id: id,
            pageArguments: {
                first: constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        }
    }), data = ref3.data, loading = ref3.loading, variables = ref3.variables;
    var ref4;
    var submittedEntries = (ref4 = data === null || data === void 0 ? void 0 : (ref = data.customer) === null || ref === void 0 ? void 0 : (ref1 = ref.submittedEntries) === null || ref1 === void 0 ? void 0 : ref1.nodes) !== null && ref4 !== void 0 ? ref4 : [];
    var handleEntryDetailClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(campaignId, serialNumber) {
            var ref, ref1, ref2, ref3, ref4, data, ref5, formFields, fieldCodeMap;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            queryCampaignEntry({
                                variables: {
                                    campaignId: campaignId,
                                    serialNumber: serialNumber,
                                    skipBrowserInfo: false
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        formFields = (ref5 = data === null || data === void 0 ? void 0 : (ref = data.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.form) === null || ref1 === void 0 ? void 0 : ref1.fields) !== null && ref5 !== void 0 ? ref5 : [];
                        fieldCodeMap = (0,keyBy/* default */.Z)(formFields, function(field) {
                            return field.code;
                        });
                        open({
                            data: (0,formFieldResolver/* entryResolver */.K)(data === null || data === void 0 ? void 0 : data.campaignEntry, fieldCodeMap),
                            fields: formFields,
                            campaignId: data === null || data === void 0 ? void 0 : (ref2 = data.campaign) === null || ref2 === void 0 ? void 0 : ref2.id,
                            campaignType: data === null || data === void 0 ? void 0 : (ref3 = data.campaign) === null || ref3 === void 0 ? void 0 : ref3.type,
                            widgetType: data === null || data === void 0 ? void 0 : (ref4 = data.campaign) === null || ref4 === void 0 ? void 0 : ref4.widget.type
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleEntryDetailClick(campaignId, serialNumber) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        my: "xl",
        className: "flex-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "md",
                px: "lg",
                weight: 600,
                color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                children: t("customerDetail.submittedRecords.title")
            }),
            loading && !(0,cacheUtils/* isCacheHit */.b)(variables, domain/* CustomerSubmittedEntriesDocument */.RB_) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: (0,isEmpty/* default */.Z)(submittedEntries) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmittedRecords_Blank, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea.Autosize */.x.Autosize, {
                    mt: "lg",
                    pl: "lg",
                    mah: "calc(100vh - ".concat(submittedRecordsHeight, "px)"),
                    scrollbarSize: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline */.T, {
                        color: "gray.4",
                        active: -1,
                        lineWidth: 1,
                        bulletSize: 6,
                        className: "mr-lg",
                        styles: function(theme) {
                            return {
                                item: {
                                    ":not(:first-of-type)": {
                                        marginTop: "".concat(theme.spacing.lg)
                                    },
                                    paddingLeft: "".concat(theme.spacing.lg),
                                    ":before": {
                                        top: "8px"
                                    }
                                },
                                itemBullet: {
                                    top: "8px"
                                }
                            };
                        },
                        children: submittedEntries.map(function(entry) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline/* Timeline.Item */.T.Item, {
                                bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "rounded-full"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                        spacing: "xs",
                                        noWrap: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                            label: entry.campaign.name,
                                            withArrow: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                lineClamp: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                    i18nKey: "pageCustomerSegment:customerDetail.submittedRecords.campaign",
                                                    values: {
                                                        type: t("common:campaignTypeName.".concat(entry.campaign.type))
                                                    },
                                                    components: {
                                                        campaign: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                                            target: "_blank",
                                                            href: "".concat(overviewPath[entry.campaign.type].replace("[appId]", appId).replace("[campaignId]", entry.campaign.id)),
                                                            children: entry.campaign.name
                                                        })
                                                    }
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                        spacing: 0,
                                        my: "xs",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            lineClamp: 1,
                                            onClick: function() {
                                                return handleEntryDetailClick(entry.campaign.id, entry.serialNumber);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                i18nKey: "pageCustomerSegment:customerDetail.submittedRecords.viewClick",
                                                components: {
                                                    detail: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                                        component: "button",
                                                        type: "button",
                                                        onClick: function() {
                                                            return handleEntryDetailClick(entry.campaign.id, entry.serialNumber);
                                                        }
                                                    })
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: "xs",
                                        c: "dimmed",
                                        children: (0,utils/* formatISOTime */.cx)(entry.createdAt)
                                    })
                                ]
                            }, entry.id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var CustomerDetail_SubmittedRecords = (SubmittedRecords);

// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/DetailContent.tsx








var DetailContent = function(props) {
    var id = props.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        w: "100%",
        align: "self-start",
        spacing: 0,
        noWrap: true,
        h: "calc(100vh - ".concat(constants/* outsideModalBodyHeight */.nr, "px)"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetail_BasicInfo, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                mx: 0,
                orientation: "vertical"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetail_SubmittedRecords, {
                id: id,
                manageable: props.manageable
            })
        ]
    });
};
/* harmony default export */ var CustomerDetail_DetailContent = (DetailContent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./src/components/ui/ItemNavigator/index.tsx
var ItemNavigator = __webpack_require__(43016);
;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/Header.tsx







var Header = function(props) {
    var t = (0,useTranslation/* default */.Z)("pageCustomerSegment").t;
    var _showNavigator = props.showNavigator, showNavigator = _showNavigator === void 0 ? true : _showNavigator, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "showNavigator"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 5,
                children: t("customerDetail.title")
            }),
            showNavigator && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemNavigator/* ItemNavigator */.x, (0,_object_spread/* default */.Z)({}, restProps))
        ]
    });
};
/* harmony default export */ var CustomerDetail_Header = (Header);

;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/useCustomerDetailModal.tsx










function useCustomerDetailModal(canAddToSegment) {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return function(props) {
        (0,events/* openModal */.h7)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,constants/* modalConfig */.NQ)(theme)), {
            modalId: modalId,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetail_Header, {
                showNavigator: false
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetail_DetailContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                manageable: canAddToSegment
            }))
        }));
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(61843);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-abac@0.1.10_react@18.2.0/node_modules/react-abac/dist/index.es.js
var index_es = __webpack_require__(8470);
;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/Modal.tsx










var CustomerDetailModal = function(props) {
    var id = props.id, customerAttributes = props.customerAttributes, opened = props.opened, close = props.close, previousDisabled = props.previousDisabled, nextDisabled = props.nextDisabled, onPrevious = props.onPrevious, onNext = props.onNext;
    var userHasPermissions = (0,index_es/* useAbac */.nn)().userHasPermissions;
    var manageable = userHasPermissions(domain/* ApplicationPermission.CustomerSegmentManage */.eC6.CustomerSegmentManage);
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var handleKeyDown = function(e) {
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
            e.preventDefault();
            if (!previousDisabled) {
                onPrevious();
            }
        }
        if (e.key === "ArrowDown" || e.key === "ArrowRight") {
            e.preventDefault();
            if (!nextDisabled) {
                onNext();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,constants/* modalConfig */.NQ)(theme)), {
        opened: opened,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetail_Header, {
            previousDisabled: previousDisabled,
            nextDisabled: nextDisabled,
            onPrevious: onPrevious,
            onNext: onNext
        }),
        onClose: close,
        onKeyDown: handleKeyDown,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetail_DetailContent, {
            id: id,
            customerAttributes: customerAttributes,
            manageable: manageable
        })
    }));
};
/* harmony default export */ var CustomerDetail_Modal = (CustomerDetailModal);

;// CONCATENATED MODULE: ./src/components/business/Customer/CustomerDetail/index.ts





/***/ }),

/***/ 83629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65149);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54253);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93103);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55075);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73046);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59845);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_business_Customer_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50454);














var Item = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var label = _param.label, count = _param.count, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "label",
        "count"
    ]);
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        ref: ref
    }, others), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Group */ .Z, {
            position: "apart",
            noWrap: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    children: label
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Group */ .Z, {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            size: 14,
                            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.6", theme)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                            c: "dimmed",
                            children: (0,utils__WEBPACK_IMPORTED_MODULE_4__/* .formatNumberToThousands */ .NZ)(count)
                        })
                    ]
                })
            ]
        })
    }));
});
var CustomerSegmentSelector = function(props) {
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("pageCustomerSegment").t;
    var disabledSegmentIds = props.disabledSegmentIds, value = props.value, onChange = props.onChange;
    var appId = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().query.appId;
    var data = (0,types_domain__WEBPACK_IMPORTED_MODULE_5__/* .useCustomerSegmentsQuery */ .fUP)({
        variables: {
            id: appId
        }
    }).data;
    var options = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        var ref1;
        return (ref1 = data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.customerSegments.filter(function(segment) {
            return !(0,components_business_Customer_constant__WEBPACK_IMPORTED_MODULE_7__/* .isSystemSegment */ .f)(segment.type);
        }).map(function(segment) {
            return {
                label: segment.name,
                value: segment.id,
                count: segment.customerCount,
                disabled: disabledSegmentIds === null || disabledSegmentIds === void 0 ? void 0 : disabledSegmentIds.includes(segment.id)
            };
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.customerSegments,
        disabledSegmentIds
    ]);
    var disabled = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .MultiSelect */ .NU, {
        withinPortal: true,
        clearable: true,
        searchable: true,
        data: options,
        disabled: disabled,
        itemComponent: Item,
        value: value,
        onChange: onChange,
        placeholder: disabled ? t("addToSegment.noCustomizedSegmentTip") : t("common:placeholders.pleaseSelect")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerSegmentSelector);


/***/ }),

/***/ 50257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73268);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98558);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60148);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14661);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59845);
/* harmony import */ var plugins_apollo_cacheUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16312);
/* harmony import */ var components_business_Customer_AddToSegments__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9419);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55075);








var CustomerSegments = function(param) {
    var id = param.id, manageable = param.manageable;
    var ref;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .useMantineTheme */ .rZ)();
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("pageCustomerSegment").t;
    var open = (0,components_business_Customer_AddToSegments__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().open;
    var ref1 = (0,types_domain__WEBPACK_IMPORTED_MODULE_3__/* .useSegmentsByIdQuery */ .QYt)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: id
        }
    }), data = ref1.data, loading = ref1.loading, variables = ref1.variables;
    var ref2;
    var segments = (ref2 = data === null || data === void 0 ? void 0 : (ref = data.customer) === null || ref === void 0 ? void 0 : ref.segments) !== null && ref2 !== void 0 ? ref2 : [];
    var handleAddClick = function() {
        open({
            customerIds: [
                id
            ],
            existedSegmentIds: segments.map(function(segment) {
                return segment.id;
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .K, {
        spacing: "md",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Group */ .Z, {
                position: "apart",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Title */ .D, {
                        order: 6,
                        children: t("pageTitle")
                    }),
                    manageable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Anchor */ .e, {
                        underline: false,
                        onClick: handleAddClick,
                        children: t("customersActions.addToSegment")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Group */ .Z, {
                spacing: "md",
                children: loading && !(0,plugins_apollo_cacheUtils__WEBPACK_IMPORTED_MODULE_4__/* .isCacheHit */ .b)(variables, types_domain__WEBPACK_IMPORTED_MODULE_3__/* .SegmentsByIdDocument */ .K9t || true) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Skeleton */ .O, {
                    height: 26,
                    radius: "xl",
                    width: "50%"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: segments === null || segments === void 0 ? void 0 : segments.map(function(segment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                            sx: {
                                padding: "2px 4px",
                                background: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_6__/* .getBackgroundColor */ .dF)("gray.1", theme),
                                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_6__/* .getTextColor */ .uu)("gray.9", theme),
                                fontSize: theme.fontSizes.sm,
                                borderRadius: theme.radius.xs
                            },
                            children: segment.name
                        }, segment.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerSegments);


/***/ }),

/***/ 50454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ isSystemSegment; },
/* harmony export */   "z": function() { return /* binding */ CustomerSegmentType; }
/* harmony export */ });
var CustomerSegmentType;
(function(CustomerSegmentType) {
    CustomerSegmentType["SYSTEM_SUBMITTED"] = "SYSTEM:SUBMITTED";
    CustomerSegmentType["SYSTEM_ALL"] = "SYSTEM:ALL";
    CustomerSegmentType["USER_CREATED"] = "USER:CREATED";
})(CustomerSegmentType || (CustomerSegmentType = {}));
var isSystemSegment = function(type) {
    return type === null || type === void 0 ? void 0 : type.startsWith("SYSTEM:");
};


/***/ }),

/***/ 94028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4588);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57155);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68711);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90773);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_business_Customer_Avatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24319);
/* harmony import */ var components_ui_Chart_useDarkMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7137);







var sizeMap = {
    sm: {
        padding: 16,
        avatar: 40,
        gap: 12,
        maw: 200
    },
    md: {
        padding: 24,
        avatar: 80,
        gap: 24,
        maw: 480
    }
};
var UserCard = function(props) {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("customer").t;
    var UID = props.UID, _size = props.size, size = _size === void 0 ? "sm" : _size, _className = props.className, className = _className === void 0 ? "" : _className, onClick = props.onClick, children = props.children;
    var darkMode = (0,components_ui_Chart_useDarkMode__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var shownUID = UID !== null && UID !== void 0 ? UID : t("anonymous");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Card */ .Z, {
        padding: sizeMap[size].padding,
        bg: darkMode ? "dark.5" : "linear-gradient(95deg, #FEFAFA 0%, #FFECEF 51.56%, #FFE6CB 100%)",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("flex-shrink-0", className),
        styles: {
            "&:hover": {
                backgroundColor: "red"
            }
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Group */ .Z, {
            spacing: sizeMap[size].gap,
            align: "flex-start",
            noWrap: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_business_Customer_Avatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: sizeMap[size].avatar
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .K, {
                    spacing: 0,
                    w: "100%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Tooltip */ .u, {
                            label: shownUID,
                            withinPortal: true,
                            withArrow: true,
                            position: "top-start",
                            color: "dark",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Group */ .Z, {
                                spacing: 0,
                                noWrap: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        weight: "bold",
                                        children: [
                                            t("customer_uid"),
                                            "："
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                        weight: "bold",
                                        className: "truncate",
                                        style: {
                                            maxWidth: "".concat(sizeMap[size].maw, "px")
                                        },
                                        children: shownUID
                                    })
                                ]
                            })
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserCard);


/***/ }),

/***/ 90037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91004);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90773);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12538);
/* harmony import */ var utils_fieldIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45559);
/* harmony import */ var utils_fieldUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55242);







var EntryIcon = function(param) {
    var type = param.type, fieldCode = param.fieldCode, className = param.className, useDefault = param.useDefault;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .useMantineTheme */ .rZ)();
    var mapping = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var formFieldIcon = (0,utils_fieldIcon__WEBPACK_IMPORTED_MODULE_4__/* .formFieldIconMapping */ .o4)(theme);
        var reservedFieldIcon = (0,utils_fieldIcon__WEBPACK_IMPORTED_MODULE_4__/* .reservedFieldIconMapping */ .gN)(theme);
        var typeMapping = (0,utils_fieldIcon__WEBPACK_IMPORTED_MODULE_4__/* .typeIconMapping */ .JV)(theme);
        if (type && (0,utils_fieldUtils__WEBPACK_IMPORTED_MODULE_5__/* .isFormField */ .sw)(fieldCode)) {
            return formFieldIcon[type];
        }
        var _type, ref, ref1;
        return (ref1 = (ref = (_type = typeMapping[type]) !== null && _type !== void 0 ? _type : reservedFieldIcon[type]) !== null && ref !== void 0 ? ref : reservedFieldIcon[fieldCode]) !== null && ref1 !== void 0 ? ref1 : useDefault ? {
            iconName: "info",
            bg: theme.colors.cyan[3],
            iconColor: theme.colors.cyan[9]
        } : {};
    }, [
        theme,
        type,
        fieldCode,
        useDefault
    ]);
    if (!mapping) {
        return null;
    }
    var iconName = mapping.iconName, bg = mapping.bg, iconColor = mapping.iconColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: iconName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Center */ .M, {
            w: 20,
            h: 20,
            bg: bg,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("rounded-sm flex-shrink-0", className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                name: iconName,
                style: {
                    color: iconColor
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EntryIcon);


/***/ }),

/***/ 96900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33021);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98558);
/* harmony import */ var components_business_ProductsModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7921);
/* harmony import */ var components_business_hooks_useAccountSubscriptionCache__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19190);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55075);








var FeatureTip = function(param) {
    var feature = param.feature, transQuery = param.transQuery;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("account").t;
    var subscription = (0,components_business_hooks_useAccountSubscriptionCache__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().subscription;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                children: t("featureTip.".concat(feature), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    productName: subscription === null || subscription === void 0 ? void 0 : subscription.productName
                }, transQuery))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Anchor */ .e, {
                className: "underline",
                onClick: function() {
                    return (0,components_business_ProductsModal__WEBPACK_IMPORTED_MODULE_3__/* .openProductsModal */ .$P)(t("product:feature.".concat(feature, ".eventAttr"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transQuery)));
                },
                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_5__/* .getTextColor */ .uu)("blue", theme),
                children: t("contactUpgrade")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureTip);


/***/ }),

/***/ 24171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);

var ConditionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    index: 0,
    condition: {
        firstNode: {
            value: undefined,
            type: undefined
        },
        operator: undefined,
        secondNode: undefined
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (ConditionContext);


/***/ }),

/***/ 14418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useOptions; },
/* harmony export */   "zn": function() { return /* binding */ Mine; }
/* harmony export */ });
/* unused harmony export getOperatorOptions */
/* harmony import */ var components_business_CampaignBuilder_Distribution_Who_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71870);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59845);
/* harmony import */ var _DataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56436);
/* harmony import */ var _ConditionContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24171);






var Include = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Include */ .N0$.Include, Exclude = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Exclude */ .N0$.Exclude, Contains = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Contains */ .N0$.Contains, NotContains = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.NotContains */ .N0$.NotContains, DateEq = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.DateEq */ .N0$.DateEq, DateNe = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.DateNe */ .N0$.DateNe, Before = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Before */ .N0$.Before, After = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.After */ .N0$.After, Gt = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Gt */ .N0$.Gt, Lt = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Lt */ .N0$.Lt, Gte = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Gte */ .N0$.Gte, Lte = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.Lte */ .N0$.Lte, NumberBetween = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.NumberBetween */ .N0$.NumberBetween, IsNull = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.IsNull */ .N0$.IsNull, IsNotNull = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .ConditionOperator.IsNotNull */ .N0$.IsNotNull;
var Mine = "MINE";
var Equal = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .UrlConditionOperator.Equal */ .xgK.Equal, StartWith = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .UrlConditionOperator.StartWith */ .xgK.StartWith, Wildcard = types_domain__WEBPACK_IMPORTED_MODULE_2__/* .UrlConditionOperator.Wildcard */ .xgK.Wildcard;
var urlOptions = [
    Equal,
    StartWith,
    Wildcard
];
var OPERATOR_CONFIG = {
    Url: urlOptions
};
function getOperatorOptions(type) {
    return OPERATOR_CONFIG[type];
}
function getFirstNodeType(fields, value) {
    var ref;
    return (ref = (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(fields, {
        code: value
    })) === null || ref === void 0 ? void 0 : ref.type;
}
function getOperatorsByFirstNodeType(fields, condition) {
    var ref, ref1, ref2;
    var type = (condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.type) ? condition === null || condition === void 0 ? void 0 : (ref1 = condition.firstNode) === null || ref1 === void 0 ? void 0 : ref1.type : getFirstNodeType(fields, (ref2 = condition.firstNode) === null || ref2 === void 0 ? void 0 : ref2.value);
    return getOperatorOptions(type);
}
function getDynamicOperator(condition) {
    var _firstNode = condition.firstNode, firstNodeType = _firstNode.type, firstNodeValue = _firstNode.value;
    if (firstNodeType === types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FieldType.DateTime */ .fSu.DateTime) {
        return [
            DateEq,
            DateNe,
            Before,
            After,
            IsNull,
            IsNotNull
        ];
    }
    if (firstNodeValue === components_business_CampaignBuilder_Distribution_Who_constant__WEBPACK_IMPORTED_MODULE_0__/* .userSegmentCode */ .DK) {
        return [
            Include,
            Exclude
        ];
    }
    return [
        Include,
        Exclude,
        Contains,
        NotContains,
        Gt,
        Lt,
        Gte,
        Lte,
        NumberBetween,
        IsNull,
        IsNotNull
    ];
}
function useOptions() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_DataContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), fields = ref.fields, dynamic = ref.dynamic;
    var condition = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_ConditionContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).condition;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return dynamic ? getDynamicOperator(condition) : getOperatorsByFirstNodeType(fields, condition);
    }, [
        condition,
        dynamic,
        fields
    ]);
}


/***/ }),

/***/ 56436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83960);


var DataContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    fields: [],
    dynamic: false,
    firstNode: _constants__WEBPACK_IMPORTED_MODULE_1__/* .defaultFirstNode */ .YS,
    secondNode: _constants__WEBPACK_IMPORTED_MODULE_1__/* .defaultSecondNode */ .VV,
    maxLength: 1,
    defaultCondition: _constants__WEBPACK_IMPORTED_MODULE_1__/* .defaultCondition */ .R
});
/* harmony default export */ __webpack_exports__["Z"] = (DataContext);


/***/ }),

/***/ 83960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ defaultValue; },
/* harmony export */   "R": function() { return /* binding */ defaultCondition; },
/* harmony export */   "VV": function() { return /* binding */ defaultSecondNode; },
/* harmony export */   "YS": function() { return /* binding */ defaultFirstNode; },
/* harmony export */   "o7": function() { return /* binding */ defaultConditions; }
/* harmony export */ });
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77047);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);


var defaultCondition = {
    firstNode: {
        value: null
    },
    operator: null,
    secondNode: {
        value: null
    }
};
var defaultConditions = [
    defaultCondition
];
var defaultValue = {
    operator: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionGroupOperator.And */ .ZOu.And,
    conditions: defaultConditions
};
var defaultFirstNode = {
    fields: [],
    getCreateLabel: lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    getFieldType: undefined,
    onFirstNodeChange: lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    rules: [],
    hidden: false
};
var defaultSecondNode = {
    getCreateLabel: lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    validator: lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    onFirstNodeChange: lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    autoFocus: false
};


/***/ }),

/***/ 41854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePeriodTypes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17474);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70426);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22108);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59845);




var PeriodType;
(function(PeriodType) {
    PeriodType["Today"] = "DAY";
    PeriodType["Yesterday"] = "YESTERDAY";
    PeriodType["ThisWeek"] = "WEEK";
    PeriodType["LastWeek"] = "PREVIOUS_WEEK";
    PeriodType["ThisMonth"] = "MONTH";
    PeriodType["LastMonth"] = "PREVIOUS_MONTH";
})(PeriodType || (PeriodType = {}));
function usePeriodTypes() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("componentConditionGroup").t;
    var _obj;
    var map = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, PeriodType.Today, t("dateTime.today")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, PeriodType.Yesterday, t("dateTime.yesterday")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, PeriodType.ThisWeek, t("dateTime.thisWeek")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, PeriodType.LastWeek, t("dateTime.lastWeek")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, PeriodType.ThisMonth, t("dateTime.thisMonth")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, PeriodType.LastMonth, t("dateTime.lastMonth")), _obj);
    var getPeriodLabel = function(value) {
        return map[value];
    };
    var getPeriodOptions = function() {
        return [
            {
                label: t("componentConditionGroup:conditionOperator.CUSTOMIZED_DATE"),
                value: types_domain__WEBPACK_IMPORTED_MODULE_1__/* .ConditionNodeType.CustomizedDate */ .BAL.CustomizedDate
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Object.values(PeriodType).map(function(value) {
            return {
                value: value,
                label: getPeriodLabel(value)
            };
        })));
    };
    return {
        getPeriodOptions: getPeriodOptions,
        getPeriodLabel: getPeriodLabel
    };
}


/***/ }),

/***/ 10872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NG": function() { return /* binding */ debouncedWaitTime; },
/* harmony export */   "XE": function() { return /* binding */ filterSelectComponentDropDownStyle; },
/* harmony export */   "iC": function() { return /* binding */ defaultConditionGroup; }
/* harmony export */ });
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);

var debouncedWaitTime = 400;
var defaultConditionGroup = {
    operator: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionGroupOperator.And */ .ZOu.And,
    conditions: []
};
var filterSelectComponentDropDownStyle = {
    maxDropdownHeight: "calc(50vh - 60px)"
};


/***/ }),

/***/ 80510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FieldFilterPopover_Filter; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(65067);
// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/constants.ts
var constants = __webpack_require__(83960);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./src/components/ui/Button/index.ts + 3 modules
var Button = __webpack_require__(83347);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/ConditionAdder/index.tsx





var ConditionAdder = function(param) {
    var className = param.className, onAdd = param.onAdd;
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* AddButton */.HS, {
            onClick: onAdd,
            text: t("add")
        })
    });
};
/* harmony default export */ var Filter_ConditionAdder = (ConditionAdder);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Header/index.tsx





var Header = function(param) {
    var className = param.className;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "apart",
        className: classnames_default()("w-full", className),
        mb: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
            order: 5,
            color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
            children: t("title")
        })
    });
};
/* harmony default export */ var Filter_Header = (Header);

// EXTERNAL MODULE: ./node_modules/.pnpm/immutability-helper@3.1.1/node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(89887);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(96634);
// EXTERNAL MODULE: ./src/utils/condition.ts
var utils_condition = __webpack_require__(22857);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./src/config/constants/fieldType.ts
var fieldType = __webpack_require__(68123);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(74969);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/CloseButton/CloseButton.js + 1 modules
var CloseButton = __webpack_require__(11706);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Select/Select.js + 2 modules
var Select = __webpack_require__(41754);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-resize-observer/use-resize-observer.js
var use_resize_observer = __webpack_require__(56718);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tooltip/Tooltip.js + 7 modules
var Tooltip = __webpack_require__(57155);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/components/business/EntryIcon/index.tsx
var EntryIcon = __webpack_require__(90037);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/FirstNode/SelectItem.tsx







var SelectItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var label = _param.label, type = _param.type, value = _param.value, others = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "type",
        "value"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, others), {
        align: "center",
        w: 262,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryIcon/* default */.Z, {
                type: type,
                fieldCode: value,
                useDefault: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                label: label,
                position: "top",
                withinPortal: true,
                withArrow: true,
                width: 260,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    ml: "sm",
                    className: "flex-1 min-w-0",
                    lineClamp: 1,
                    children: label
                })
            })
        ]
    }));
});
/* harmony default export */ var FirstNode_SelectItem = (SelectItem);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/merge.js + 6 modules
var merge = __webpack_require__(31817);
// EXTERNAL MODULE: ./src/utils/fieldUtils.ts
var fieldUtils = __webpack_require__(55242);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/FirstNode/utils/getFieldGroupName.ts


var systemFieldCodes = Object.values(fieldType/* SystemFilterableField */.cn);
function getFieldGroupName(fieldCode, t) {
    if ((0,fieldUtils/* isFormField */.sw)(fieldCode)) {
        return t("componentEntryFilter:fieldType.default");
    }
    if ((0,fieldUtils/* isCustomerField */.SH)(fieldCode)) {
        return t("componentEntryFilter:fieldType.customerField");
    }
    if ((0,fieldUtils/* isSceneField */.kZ)(fieldCode)) {
        return t("componentEntryFilter:fieldType.sceneField");
    }
    if (systemFieldCodes.includes("entry.".concat(fieldCode))) {
        return t("componentEntryFilter:fieldType.systemField");
    }
}

// EXTERNAL MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/constants.ts
var Filter_constants = __webpack_require__(10872);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/FirstNode/index.tsx












var dropdownWidthPx = 272;
var FirstNode = function(_param) {
    var _fields = _param.fields, fields = _fields === void 0 ? [] : _fields, _styles = _param.styles, styles = _styles === void 0 ? {} : _styles, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "fields",
        "styles"
    ]);
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref = (0,use_resize_observer/* useElementSize */.h)(), ref1 = ref.ref, width = ref.width;
    var options = fields.map(function(field) {
        return {
            label: field.label,
            value: field.code,
            type: field.type,
            group: getFieldGroupName(field.code, t),
            alias: field.alias
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
            placeholder: t("placeholders.pleaseSelect"),
            itemComponent: FirstNode_SelectItem,
            data: options,
            searchable: true,
            withinPortal: true,
            styles: (0,merge/* default */.Z)({
                dropdown: {
                    width: "".concat(dropdownWidthPx, "px !important"),
                    marginLeft: width ? (dropdownWidthPx - width) / 2 : undefined
                }
            }, styles),
            nothingFound: t("empty.firstNodeEmpty"),
            filter: function(value, item) {
                var ref, ref1, ref2;
                var searchValue = value.toLowerCase().trim();
                return ((ref = item.label) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(searchValue)) || ((ref1 = item.value) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(searchValue)) || ((ref2 = item.alias) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase().includes(searchValue));
            }
        }), Filter_constants/* filterSelectComponentDropDownStyle */.XE))
    });
};
/* harmony default export */ var Conditions_FirstNode = (FirstNode);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/find.js + 2 modules
var find = __webpack_require__(91955);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var config_constants = __webpack_require__(95660);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/Operator/getOperatorOptions.ts






var Include = domain/* ConditionOperator.Include */.N0$.Include, Exclude = domain/* ConditionOperator.Exclude */.N0$.Exclude, Contains = domain/* ConditionOperator.Contains */.N0$.Contains, NotContains = domain/* ConditionOperator.NotContains */.N0$.NotContains, DateEq = domain/* ConditionOperator.DateEq */.N0$.DateEq, DateNe = domain/* ConditionOperator.DateNe */.N0$.DateNe, Before = domain/* ConditionOperator.Before */.N0$.Before, After = domain/* ConditionOperator.After */.N0$.After, Gt = domain/* ConditionOperator.Gt */.N0$.Gt, Lt = domain/* ConditionOperator.Lt */.N0$.Lt, Gte = domain/* ConditionOperator.Gte */.N0$.Gte, Lte = domain/* ConditionOperator.Lte */.N0$.Lte, NumberBetween = domain/* ConditionOperator.NumberBetween */.N0$.NumberBetween, Eq = domain/* ConditionOperator.Eq */.N0$.Eq, Ne = domain/* ConditionOperator.Ne */.N0$.Ne, IsNull = domain/* ConditionOperator.IsNull */.N0$.IsNull, IsNotNull = domain/* ConditionOperator.IsNotNull */.N0$.IsNotNull;
var Mine = "MINE";
var Equal = domain/* UrlConditionOperator.Equal */.xgK.Equal, StartWith = domain/* UrlConditionOperator.StartWith */.xgK.StartWith, Wildcard = domain/* UrlConditionOperator.Wildcard */.xgK.Wildcard;
var urlOptions = [
    Equal,
    StartWith,
    Wildcard
];
var numberFieldOperator = [
    Eq,
    Ne,
    Gt,
    Gte,
    Lt,
    Lte,
    NumberBetween,
    IsNull,
    IsNotNull
];
var choiceFieldOperator = [
    Eq,
    Ne,
    Include,
    Exclude,
    IsNull,
    IsNotNull
];
var stringFieldOperator = [
    Eq,
    Ne,
    Contains,
    NotContains,
    IsNull,
    IsNotNull
];
var customerStringFieldOperator = [
    Eq,
    Ne,
    Contains,
    NotContains,
    Gt,
    Gte,
    Lt,
    Lte,
    NumberBetween,
    IsNull,
    IsNotNull
];
var customerDateFieldOperator = [
    DateEq,
    DateNe,
    Before,
    After
];
var submittedOnFieldOperator = [
    Eq
];
var refererFieldOperator = [
    Eq,
    Contains,
    NotContains
];
var commentedFieldOperator = [
    IsNull,
    IsNotNull,
    Mine
];
var _obj;
var FORM_FIELD_CONFIG = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.NpsField */.EIl.NpsField, numberFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CsatField */.EIl.CsatField, numberFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CesField */.EIl.CesField, numberFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.RatingField */.EIl.RatingField, numberFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CheckBox */.EIl.CheckBox, choiceFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.RadioButton */.EIl.RadioButton, choiceFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.TextArea */.EIl.TextArea, stringFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.TextField */.EIl.TextField, stringFieldOperator), (0,_define_property/* default */.Z)(_obj, domain/* FormFieldType.CtaField */.EIl.CtaField, choiceFieldOperator), _obj);
var _obj1;
var RESERVED_FIELD_CONFIG = (_obj1 = {
    Url: urlOptions
}, (0,_define_property/* default */.Z)(_obj1, fieldType/* TEXT_FIELD */.uj, customerStringFieldOperator), (0,_define_property/* default */.Z)(_obj1, fieldType/* DATETIME_FIELD */.yV, customerDateFieldOperator), (0,_define_property/* default */.Z)(_obj1, fieldType/* SystemFilterableField.SubmittedOn */.cn.SubmittedOn, submittedOnFieldOperator), (0,_define_property/* default */.Z)(_obj1, fieldType/* SystemFilterableField.Referer */.cn.Referer, refererFieldOperator), (0,_define_property/* default */.Z)(_obj1, fieldType/* SystemFilterableField.Commented */.cn.Commented, commentedFieldOperator), (0,_define_property/* default */.Z)(_obj1, fieldType/* SystemFilterableField.DeliveryMethod */.cn.DeliveryMethod, choiceFieldOperator), (0,_define_property/* default */.Z)(_obj1, config_constants/* CUSTOMER_EMAIL */.n, stringFieldOperator), (0,_define_property/* default */.Z)(_obj1, config_constants/* CUSTOMER_MOBILE */.L, stringFieldOperator), (0,_define_property/* default */.Z)(_obj1, config_constants/* CUSTOMER_NAME */.rl, stringFieldOperator), (0,_define_property/* default */.Z)(_obj1, config_constants/* CUSTOMER_UID */.tv, stringFieldOperator), _obj1);
function getFirstNodeType(fields, value) {
    var ref;
    return (ref = (0,find/* default */.Z)(fields, {
        code: value
    })) === null || ref === void 0 ? void 0 : ref.type;
}
function getOperatorsByFirstNodeCode(fields, code) {
    var type = getFirstNodeType(fields, code);
    return code && (0,fieldUtils/* isFormField */.sw)(code) ? FORM_FIELD_CONFIG[type] : RESERVED_FIELD_CONFIG[type];
}

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/Operator/index.tsx







var Operator = function(param) {
    var value = param.value, fieldCode = param.fieldCode, onChange = param.onChange, _fields = param.fields, fields = _fields === void 0 ? [] : _fields, readOnly = param.readOnly;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    var options = ((ref = getOperatorsByFirstNodeCode(fields, fieldCode)) === null || ref === void 0 ? void 0 : ref.map(function(option) {
        return {
            value: option,
            label: t("componentConditionGroup:conditionOperator.".concat(option))
        };
    })) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
        withinPortal: true,
        data: options,
        value: value,
        onChange: onChange,
        placeholder: t("common:placeholders.pleaseSelect"),
        readOnly: readOnly
    }, Filter_constants/* filterSelectComponentDropDownStyle */.XE));
};
/* harmony default export */ var Conditions_Operator = (Operator);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/range.js + 2 modules
var range = __webpack_require__(57936);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconMinus.js
var IconMinus = __webpack_require__(52528);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-debounced-value/use-debounced-value.js
var use_debounced_value = __webpack_require__(96387);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNumber.js
var isNumber = __webpack_require__(47852);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/hooks/useBetweenState.ts






function useBetweenState(condition, onChange) {
    var ref;
    var isBetween = [
        domain/* ConditionOperator.NumberBetween */.N0$.NumberBetween,
        domain/* ConditionOperator.DateBetween */.N0$.DateBetween
    ].includes(condition.operator);
    var ref1 = (0,react.useState)(isBetween ? ((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) || [] : []), betweenValue = ref1[0], setBetweenValue = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(betweenValue, Filter_constants/* debouncedWaitTime */.NG), 1), debouncedValue = ref2[0];
    var mountedRef = (0,react.useRef)(false);
    var _betweenValue = (0,_sliced_to_array/* default */.Z)(betweenValue, 2), minValue = _betweenValue[0], maxValue = _betweenValue[1];
    (0,react.useEffect)(function() {
        if (mountedRef.current && isBetween) {
            var completed = betweenValue.length === 2 && betweenValue.every((0,isNumber/* default */.Z)(minValue) ? isNumber/* default */.Z : Boolean);
            if (completed) {
                onChange === null || onChange === void 0 ? void 0 : onChange(betweenValue);
            } else {
                onChange === null || onChange === void 0 ? void 0 : onChange("");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        betweenValue,
        debouncedValue,
        isBetween,
        minValue
    ]);
    (0,react.useEffect)(function() {
        mountedRef.current = true;
    }, []);
    return {
        isBetween: isBetween,
        minValue: minValue,
        maxValue: maxValue,
        setBetweenValue: setBetweenValue
    };
}

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/NumberSelector.tsx










var getOptions = function(field) {
    switch(field.__typename){
        case "NpsField":
            return (0,range/* default */.Z)(0, field.ratingMax + 1).map(String);
        case "CsatField":
            return (0,range/* default */.Z)(1, field.ratingDescriptions.length + 1).map(String);
        default:
            return (0,range/* default */.Z)(1, field.ratingMax + 1).map(String);
    }
};
var NumberSelector = function(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields, condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("common").t;
    var firstNodeField = fields.find(function(field) {
        return field.code === condition.firstNode.value;
    });
    var options = getOptions(firstNodeField);
    var ref1 = useBetweenState(condition, onChange), isBetween = ref1.isBetween, maxValue = ref1.maxValue, minValue = ref1.minValue, setBetweenValue = ref1.setBetweenValue;
    if (isBetween) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            noWrap: true,
            spacing: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
                    withinPortal: true,
                    value: "".concat(minValue),
                    data: options,
                    placeholder: t("placeholders.pleaseSelect"),
                    onChange: function(value) {
                        return setBetweenValue([
                            Number(value),
                            maxValue
                        ]);
                    },
                    readOnly: readOnly
                }, Filter_constants/* filterSelectComponentDropDownStyle */.XE)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMinus/* default */.Z, {
                    size: 16,
                    stroke: 1.5,
                    color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
                    withinPortal: true,
                    value: "".concat(maxValue),
                    data: options,
                    placeholder: t("placeholders.pleaseSelect"),
                    onChange: function(value) {
                        return setBetweenValue([
                            minValue,
                            Number(value)
                        ]);
                    },
                    readOnly: readOnly
                }, Filter_constants/* filterSelectComponentDropDownStyle */.XE))
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,_object_spread/* default */.Z)({
        withinPortal: true,
        searchable: true,
        data: options,
        placeholder: t("placeholders.pleaseSelect"),
        onChange: function(value) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(Number(value));
        },
        value: String((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value),
        readOnly: readOnly
    }, Filter_constants/* filterSelectComponentDropDownStyle */.XE));
};
/* harmony default export */ var SecondNode_NumberSelector = (NumberSelector);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MultiSelect/MultiSelect.js + 4 modules
var MultiSelect = __webpack_require__(54253);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/pick.js + 1 modules
var pick = __webpack_require__(98458);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/utils/keepConditionIntoView.ts
var conditionDataNamePrefix = "filterRow";
function keepConditionIntoView(conditionIndex) {
    setTimeout(function() {
        var ref;
        (ref = document.querySelector("[data-name=".concat(conditionDataNamePrefix).concat(conditionIndex, "]"))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "end"
        });
    }, 0);
}

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/ChoiceSelector.tsx






var ChoiceSelector = function(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields, condition = param.condition, onChange = param.onChange, index = param.index, readOnly = param.readOnly;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var firstNodeField = fields.find(function(field) {
        return field.code === condition.firstNode.value;
    });
    var options = firstNodeField.choices.map(function(c) {
        return (0,pick/* default */.Z)(c, [
            "label",
            "value"
        ]);
    }) || [];
    var handleOnChange = function(value) {
        var validValue = (0,isEmpty/* default */.Z)(value) ? undefined : value;
        onChange === null || onChange === void 0 ? void 0 : onChange(validValue);
        keepConditionIntoView(index);
    };
    var onDropdownOpen = function() {
        return keepConditionIntoView(index);
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, {
        withinPortal: true,
        data: options,
        placeholder: t("placeholders.pleaseSelect"),
        value: (ref1 = (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : [],
        onChange: handleOnChange,
        onDropdownOpen: onDropdownOpen,
        dropdownPosition: "flip",
        styles: {
            value: {
                margin: "3px 5px"
            }
        },
        readOnly: readOnly
    });
};
/* harmony default export */ var SecondNode_ChoiceSelector = (ChoiceSelector);

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/SingleChoiceSelector.tsx









var SingleChoiceSelector = function(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields, condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var firstNodeField = fields.find(function(field) {
        return field.code === condition.firstNode.value;
    });
    var options = firstNodeField.choices.map(function(c) {
        return (0,pick/* default */.Z)(c, [
            "label",
            "value"
        ]);
    }) || [];
    var handleOnChange = function(value) {
        var validValue = (0,isEmpty/* default */.Z)(value) ? undefined : value;
        onChange === null || onChange === void 0 ? void 0 : onChange(validValue);
    };
    var onlyOneSelected = ![
        domain/* ConditionOperator.Include */.N0$.Include,
        domain/* ConditionOperator.Exclude */.N0$.Exclude
    ].includes(condition.operator);
    var maxSelectedProps = onlyOneSelected ? {
        maxSelectedValues: 1
    } : {};
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        withinPortal: true,
        data: options,
        placeholder: t("placeholders.pleaseSelect"),
        value: (ref1 = (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : [],
        onChange: handleOnChange
    }, maxSelectedProps, Filter_constants/* filterSelectComponentDropDownStyle */.XE), {
        readOnly: readOnly
    }));
};
/* harmony default export */ var SecondNode_SingleChoiceSelector = (SingleChoiceSelector);

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/SubmittedOnSelector.tsx





var SubmittedOnSelector = function(param) {
    var condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref;
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var options = [
        domain/* EntrySubmittedOn.Completed */.L6A.Completed,
        domain/* EntrySubmittedOn.Expired */.L6A.Expired
    ].map(function(code) {
        return {
            label: t("submitOnType.".concat(code)),
            value: code
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
        withinPortal: true,
        data: options,
        placeholder: t("common:placeholders.pleaseSelect"),
        onChange: function(value) {
            return onChange === null || onChange === void 0 ? void 0 : onChange(value);
        },
        value: (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value,
        readOnly: readOnly
    });
};
/* harmony default export */ var SecondNode_SubmittedOnSelector = (SubmittedOnSelector);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(79965);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/RefererSelector.tsx









var RefererSelector = function(param) {
    var condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref;
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var ref2;
    var ref3 = (0,react.useState)((ref2 = (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) !== null && ref2 !== void 0 ? ref2 : ""), value = ref3[0], setValue = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(value, Filter_constants/* debouncedWaitTime */.NG), 1), debouncedValue = ref4[0];
    (0,react.useEffect)(function() {
        onChange === null || onChange === void 0 ? void 0 : onChange(debouncedValue.trim());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedValue
    ]);
    var _obj;
    var operatorInputMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* ConditionOperator.Eq */.N0$.Eq, {
        placeholder: t("referer.eqPlaceholder"),
        getError: function(value) {
            return !value ? t("common:message.valueRequired") : null;
        }
    }), (0,_define_property/* default */.Z)(_obj, domain/* ConditionOperator.Contains */.N0$.Contains, {
        placeholder: t("referer.containsOrNotContainsPlaceholder"),
        getError: function(value) {
            return !value ? t("common:message.valueRequired") : null;
        }
    }), (0,_define_property/* default */.Z)(_obj, domain/* ConditionOperator.NotContains */.N0$.NotContains, {
        placeholder: t("referer.containsOrNotContainsPlaceholder"),
        getError: function(value) {
            return !value ? t("common:message.valueRequired") : null;
        }
    }), _obj);
    var _operator = operatorInputMap[condition.operator], placeholder = _operator.placeholder, getError = _operator.getError;
    var handleInputValue = function(value) {
        var inputError = getError(value);
        if (inputError) {
            setValue("");
            setError(inputError);
        } else {
            setValue(value);
            setError("");
        }
    };
    var handleOnChange = function(event) {
        var ref;
        handleInputValue((ref = event.target) === null || ref === void 0 ? void 0 : ref.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        error: error,
        placeholder: placeholder,
        value: value || "",
        onChange: handleOnChange,
        readOnly: readOnly
    });
};
/* harmony default export */ var SecondNode_RefererSelector = (RefererSelector);

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/DeliveryMethodSelector.tsx






var DeliveryMethodSelector = function(props) {
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var fields = props.fields, condition = props.condition;
    var firstNodeField = fields.find(function(field) {
        return field.code === condition.firstNode.value;
    });
    firstNodeField.choices = Object.values(domain/* DeliveryMethod */.GlQ).map(function(value) {
        return {
            label: t("deliveryMethodOption.".concat(value)),
            value: value,
            type: "TextChoice"
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNode_SingleChoiceSelector, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var SecondNode_DeliveryMethodSelector = (DeliveryMethodSelector);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toString.js
var lodash_es_toString = __webpack_require__(88202);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/FormStringInput.tsx








var FormStringInput = function(param) {
    var condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref1 = (0,react.useState)((0,lodash_es_toString/* default */.Z)((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value)), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(value, Filter_constants/* debouncedWaitTime */.NG), 1), debouncedValue = ref2[0];
    var handleOnChange = function(e) {
        var ref;
        var ref1;
        setValue((ref1 = (ref = e.target) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : "");
    };
    (0,react.useEffect)(function() {
        onChange === null || onChange === void 0 ? void 0 : onChange(debouncedValue.trim());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        placeholder: t("placeholders.pleaseInput"),
        value: value || "",
        onChange: handleOnChange,
        readOnly: readOnly
    });
};
/* harmony default export */ var SecondNode_FormStringInput = (FormStringInput);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/NumberInput/NumberInput.js + 4 modules
var NumberInput = __webpack_require__(4602);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/castArray.js
var castArray = __webpack_require__(4239);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isString.js
var isString = __webpack_require__(75720);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/hooks/useCustomerOrSceneOptions.ts







function useCustomerOrSceneOptions(condition) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var isSceneCondition = (ref = condition.firstNode.value) === null || ref === void 0 ? void 0 : (ref1 = ref.startsWith) === null || ref1 === void 0 ? void 0 : ref1.call(ref, config/* codePrefix.scene */.T.scene);
    var isCustomerCondition = (ref2 = condition.firstNode.value) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.startsWith) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, config/* codePrefix.customer */.T.customer);
    var queryOptions = {
        variables: {
            idOrAliasOrCode: condition === null || condition === void 0 ? void 0 : (ref4 = condition.firstNode) === null || ref4 === void 0 ? void 0 : ref4.value,
            applicationId: appId,
            pageArguments: {
                first: config_constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        },
        onError: function onError(error) {
            ui/* message.error */.yw.error(error.message);
        }
    };
    var ref8 = (0,domain/* useApplicationCustomerAttributeValuesQuery */.gd4)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        skip: !isCustomerCondition
    })), customerAttrData = ref8.data;
    var ref9 = (0,domain/* useApplicationSceneAttributeValuesQuery */.DqO)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryOptions), {
        skip: !isSceneCondition
    })), sceneAttrData = ref9.data;
    return (customerAttrData === null || customerAttrData === void 0 ? void 0 : (ref5 = customerAttrData.applicationCustomerAttribute) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.values) === null || ref6 === void 0 ? void 0 : ref6.nodes) || (sceneAttrData === null || sceneAttrData === void 0 ? void 0 : (ref7 = sceneAttrData.applicationSceneAttribute) === null || ref7 === void 0 ? void 0 : ref7.values.nodes) || [];
}

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/CustomerString.tsx















var CustomerString = function(param) {
    var condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("common").t;
    var operator = condition.operator;
    var isNumberCompareOperator = [
        domain/* ConditionOperator.Gt */.N0$.Gt,
        domain/* ConditionOperator.Gte */.N0$.Gte,
        domain/* ConditionOperator.Lt */.N0$.Lt,
        domain/* ConditionOperator.Lte */.N0$.Lte, 
    ].includes(operator);
    var isEquivalentOperator = [
        domain/* ConditionOperator.Ne */.N0$.Ne,
        domain/* ConditionOperator.Eq */.N0$.Eq
    ].includes(operator);
    var isContainOperator = [
        domain/* ConditionOperator.Contains */.N0$.Contains,
        domain/* ConditionOperator.NotContains */.N0$.NotContains
    ].includes(operator);
    var defaultValue = isNumberCompareOperator ? undefined : "";
    var ref1 = (0,react.useState)(((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) || defaultValue), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(value, Filter_constants/* debouncedWaitTime */.NG), 1), debouncedValue = ref2[0];
    var ref3 = useBetweenState(condition, onChange), isBetween = ref3.isBetween, maxValue = ref3.maxValue, minValue = ref3.minValue, setBetweenValue = ref3.setBetweenValue;
    var optionValues = useCustomerOrSceneOptions(condition);
    (0,react.useEffect)(function() {
        onChange === null || onChange === void 0 ? void 0 : onChange(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedValue
    ]);
    var handleOnChange = function(values) {
        setValue((0,isEmpty/* default */.Z)(values) ? undefined : values);
    };
    var handleTextOnChange = function(e) {
        setValue(e.target.value);
    };
    var handleNumberOnChange = function(value) {
        setValue((0,isNumber/* default */.Z)(value) ? "".concat(value) : undefined);
    };
    if (isBetween) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            noWrap: true,
            spacing: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
                    value: minValue,
                    placeholder: t("placeholders.pleaseInput"),
                    onChange: function(value) {
                        return setBetweenValue([
                            value,
                            maxValue
                        ]);
                    },
                    readOnly: readOnly,
                    precision: 2,
                    removeTrailingZeros: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMinus/* default */.Z, {
                    size: 16,
                    stroke: 1.5,
                    color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
                    value: maxValue,
                    placeholder: t("placeholders.pleaseInput"),
                    onChange: function(value) {
                        return setBetweenValue([
                            minValue,
                            value
                        ]);
                    },
                    readOnly: readOnly,
                    precision: 2,
                    removeTrailingZeros: true
                })
            ]
        });
    }
    if (isNumberCompareOperator) {
        var firstValue = (0,castArray/* default */.Z)(value)[0];
        var numberValue = (0,isNumber/* default */.Z)(firstValue) ? firstValue : (0,isString/* default */.Z)(firstValue) ? Number(firstValue) : undefined;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
            placeholder: t("placeholders.pleaseInput"),
            value: numberValue,
            onChange: handleNumberOnChange,
            readOnly: readOnly,
            precision: 2,
            removeTrailingZeros: true
        });
    }
    if (!!(optionValues === null || optionValues === void 0 ? void 0 : optionValues.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            withinPortal: true,
            searchable: true,
            placeholder: t("placeholders.pleaseSelect"),
            data: optionValues,
            // value={value ? (isArray(value) ? value : [value]) : []}
            value: value !== null && value !== void 0 ? value : [],
            onChange: handleOnChange,
            maxSelectedValues: isEquivalentOperator || isContainOperator ? 1 : undefined
        }, Filter_constants/* filterSelectComponentDropDownStyle */.XE), {
            readOnly: readOnly
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        placeholder: t("placeholders.pleaseInput"),
        value: value || "",
        onChange: handleTextOnChange,
        readOnly: readOnly
    });
};
/* harmony default export */ var SecondNode_CustomerString = (CustomerString);

// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(47142);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+dates@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_dayjs@1.11.6_react@18.2.0/node_modules/@mantine/dates/esm/components/DatePickerInput/DatePickerInput.js + 3 modules
var DatePickerInput = __webpack_require__(47355);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-set-state/use-set-state.js
var use_set_state = __webpack_require__(34058);
// EXTERNAL MODULE: ./src/components/business/Filter/FieldFilterPopover/hooks/usePropCloseOnClickOutside.ts
var usePropCloseOnClickOutside = __webpack_require__(50910);
// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/hooks/usePeriodTypes.ts
var usePeriodTypes = __webpack_require__(41854);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/CustomDate.tsx













var CustomDate = function(param) {
    var condition = param.condition, onChange = param.onChange, readOnly = param.readOnly;
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)({
        type: ((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.type) || domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate,
        value: (ref1 = condition.secondNode) === null || ref1 === void 0 ? void 0 : ref1.value
    }), 2), ref4 = ref3[0], type = ref4.type, value = ref4.value, setValue = ref3[1];
    var t = (0,useTranslation/* default */.Z)("common").t;
    var getPeriodOptions = (0,usePeriodTypes/* default */.Z)().getPeriodOptions;
    var isCustomDate = type === domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate;
    var currentDateValue = isCustomDate && value ? (0,parseISO/* default */.Z)(value) : null;
    (0,react.useEffect)(function() {
        if (!isCustomDate) {
            var ref;
            setValue({
                type: (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (ref2 = condition.secondNode) === null || ref2 === void 0 ? void 0 : ref2.value,
        isCustomDate
    ]);
    var onSelectChange = function(value) {
        setValue({
            type: value
        });
        if (value === domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate) {
            setValue({
                value: ""
            });
        } else {
            onChange === null || onChange === void 0 ? void 0 : onChange({
                value: value,
                type: domain/* ConditionNodeType.Period */.BAL.Period
            });
        }
    };
    var onDateChange = function(date) {
        var freshValue = {
            value: date ? (0,utils/* formatISODATE */.ZV)(date) : "",
            type: domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate
        };
        setValue(freshValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(freshValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        spacing: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
                withinPortal: true,
                data: getPeriodOptions(),
                className: "flex-1",
                placeholder: t("placeholders.pleaseSelect"),
                onChange: onSelectChange,
                value: type,
                readOnly: readOnly
            }),
            isCustomDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerInput/* DatePickerInput */.a, {
                valueFormat: config_constants/* DATE_FORMAT_FOR_DAYJS */.yl,
                placeholder: t("placeholders.pleaseSelect"),
                className: "flex-1",
                locale: "zh-cn",
                onChange: onDateChange,
                value: currentDateValue,
                clearable: false,
                readOnly: readOnly,
                popoverProps: {
                    withinPortal: true,
                    onOpen: usePropCloseOnClickOutside/* toggleParentPopoverCloseState */.U,
                    onClose: usePropCloseOnClickOutside/* toggleParentPopoverCloseState */.U
                }
            })
        ]
    });
};
/* harmony default export */ var SecondNode_CustomDate = (CustomDate);

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/SecondNode/index.tsx














var SecondNode_obj;
var componentMapping = (SecondNode_obj = {}, (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* NPS_FIELD */.Rq, SecondNode_NumberSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* CSAT_FIELD */.v9, SecondNode_NumberSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* CES_FIELD */.Dm, SecondNode_NumberSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* RATING_FIELD */.PI, SecondNode_NumberSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* CHECK_BOX */.cL, SecondNode_ChoiceSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* RADIO_BUTTON */.H0, SecondNode_SingleChoiceSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* CTA_FIELD */.PW, SecondNode_SingleChoiceSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* TEXT_AREA */.mM, SecondNode_FormStringInput), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* TEXT_FIELD */.uj, SecondNode_CustomerString), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* DATETIME_FIELD */.yV, SecondNode_CustomDate), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* SystemFilterableField.SubmittedOn */.cn.SubmittedOn, SecondNode_SubmittedOnSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* SystemFilterableField.Referer */.cn.Referer, SecondNode_RefererSelector), (0,_define_property/* default */.Z)(SecondNode_obj, fieldType/* SystemFilterableField.DeliveryMethod */.cn.DeliveryMethod, SecondNode_DeliveryMethodSelector), SecondNode_obj);
var SecondNode = function(props) {
    var ref, ref1;
    var condition = props.condition, fields = props.fields;
    var fieldType = (0,react.useMemo)(function() {
        var ref;
        return (ref = fields.find(function(field) {
            return field.code === condition.firstNode.value;
        })) === null || ref === void 0 ? void 0 : ref.type;
    }, [
        fields,
        condition
    ]);
    // For rerender SecondNode components
    var secondNodeKey = "".concat(condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.type, "-").concat(condition === null || condition === void 0 ? void 0 : (ref1 = condition.firstNode) === null || ref1 === void 0 ? void 0 : ref1.value, "-").concat(condition.operator);
    var Component = fieldType ? componentMapping[fieldType] || SecondNode_FormStringInput : SecondNode_FormStringInput;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props), secondNodeKey);
};
/* harmony default export */ var Conditions_SecondNode = (SecondNode);

// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/Operator/getOperatorOptions.ts
var getOperatorOptions = __webpack_require__(14418);
;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/Condition.tsx










var Condition = function(param) {
    var index = param.index, condition = param.condition, fields = param.fields, onFirstNodeChange = param.onFirstNodeChange, onOperatorChange = param.onOperatorChange, onSecondNodeChange = param.onSecondNodeChange, onDelete = param.onDelete, readOnly = param.readOnly;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var valueNodeHidden = [
        domain/* ConditionOperator.IsNull */.N0$.IsNull,
        domain/* ConditionOperator.IsNotNull */.N0$.IsNotNull,
        getOperatorOptions/* Mine */.zn
    ].includes(condition.operator);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        spacing: 0,
        "data-name": conditionDataNamePrefix + index,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                    gutter: "sm",
                    my: 0,
                    p: 0,
                    columns: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            span: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_FirstNode, {
                                fields: fields,
                                defaultValue: condition.firstNode.value,
                                onChange: onFirstNodeChange(index),
                                readOnly: readOnly
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            span: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_Operator, {
                                fieldCode: condition.firstNode.value,
                                fields: fields,
                                value: condition.operator,
                                onChange: onOperatorChange(index),
                                readOnly: readOnly
                            })
                        }),
                        !valueNodeHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            span: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_SecondNode, {
                                condition: condition,
                                fields: fields,
                                onChange: onSecondNodeChange(index),
                                index: index,
                                readOnly: readOnly
                            })
                        })
                    ]
                })
            }),
            !readOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                    size: 24,
                    iconSize: 16,
                    onClick: function() {
                        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(index);
                    },
                    sx: {
                        color: (0,getColor/* getTextColor */.uu)("gray.7", theme)
                    }
                })
            })
        ]
    }, condition.firstNode.value + "".concat(index));
};
/* harmony default export */ var Conditions_Condition = (Condition);

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/Conditions/index.tsx







var Conditions = function(param) {
    var _fields = param.fields, fields = _fields === void 0 ? [] : _fields, _conditions = param.conditions, conditions = _conditions === void 0 ? [] : _conditions, onDelete = param.onDelete, onChange = param.onChange, readOnly = param.readOnly;
    var onFirstNodeChange = function(conditionIndex) {
        return function(value) {
            var defaultOperator = getOperatorsByFirstNodeCode(fields, value)[0];
            onChange === null || onChange === void 0 ? void 0 : onChange(immutability_helper_default()(conditions, (0,_define_property/* default */.Z)({}, conditionIndex, {
                firstNode: {
                    value: {
                        $set: value
                    }
                },
                operator: {
                    $set: defaultOperator
                },
                secondNode: {
                    $set: {
                        value: ""
                    }
                }
            })));
        };
    };
    var onOperatorNodeChange = function(conditionIndex) {
        return function(value) {
            onChange === null || onChange === void 0 ? void 0 : onChange(immutability_helper_default()(conditions, (0,_define_property/* default */.Z)({}, conditionIndex, {
                operator: {
                    $set: value
                },
                secondNode: {
                    $set: {
                        value: ""
                    }
                }
            })));
        };
    };
    var onSecondNodeChange = function(conditionIndex) {
        return function(value) {
            var ref;
            var isDateCondition = ((ref = fields.find(function(field) {
                return field.code === conditions[conditionIndex].firstNode.value;
            })) === null || ref === void 0 ? void 0 : ref.type) === fieldType/* DATETIME_FIELD */.yV;
            var freshValue = immutability_helper_default()(conditions, (0,_define_property/* default */.Z)({}, conditionIndex, {
                secondNode: isDateCondition ? {
                    $set: value
                } : {
                    value: {
                        $set: value
                    }
                }
            }));
            onChange === null || onChange === void 0 ? void 0 : onChange(freshValue);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: conditions.map(function(condition, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_Condition, {
                condition: condition,
                fields: fields,
                onFirstNodeChange: onFirstNodeChange,
                onSecondNodeChange: onSecondNodeChange,
                index: idx,
                onDelete: onDelete,
                onOperatorChange: onOperatorNodeChange,
                readOnly: readOnly
            }, condition.firstNode.value + "".concat(idx));
        })
    });
};
/* harmony default export */ var Filter_Conditions = (Conditions);

;// CONCATENATED MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/index.tsx














var Filter = function(_param) {
    var _value = _param.value, value = _value === void 0 ? Filter_constants/* defaultConditionGroup */.iC : _value, onChange = _param.onChange, campaignFields = _param.campaignFields, _showHeader = _param.showHeader, showHeader = _showHeader === void 0 ? true : _showHeader, withDefault = _param.withDefault, readOnly = _param.readOnly, styleProps = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "campaignFields",
        "showHeader",
        "withDefault",
        "readOnly"
    ]);
    var ref;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var conditionsScrollViewRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(function() {
        if (withDefault && value.conditions.length === 0) {
            return immutability_helper_default()(value, {
                conditions: {
                    $push: [
                        constants/* defaultCondition */.R
                    ]
                }
            });
        }
        return value;
    }), values = ref1[0], setValues = ref1[1];
    var showConditions = (values === null || values === void 0 ? void 0 : (ref = values.conditions) === null || ref === void 0 ? void 0 : ref.length) > 0;
    var handleOnChange = function(newValues) {
        var validValues = immutability_helper_default()(newValues, {
            conditions: {
                $set: newValues.conditions.filter(function(condition) {
                    return (0,utils_condition/* getConditionValid */.j)(condition);
                })
            }
        });
        var isDifference = !(0,isEqual/* default */.Z)(value, validValues);
        isDifference && (onChange === null || onChange === void 0 ? void 0 : onChange(validValues));
    };
    var conditionsScrollViewScrollToBottom = function() {
        setTimeout(function() {
            var ref;
            (ref = conditionsScrollViewRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                top: conditionsScrollViewRef.current.scrollHeight,
                behavior: "smooth"
            });
        });
    };
    var onAdd = function() {
        var newValues = immutability_helper_default()(values, {
            conditions: {
                $push: [
                    constants/* defaultCondition */.R
                ]
            }
        });
        setValues(newValues);
        conditionsScrollViewScrollToBottom();
    };
    var onDelete = function(index) {
        var newValues = immutability_helper_default()(values, {
            conditions: {
                $set: values.conditions.filter(function(_, idx) {
                    return idx !== index;
                })
            }
        });
        setValues(newValues);
        handleOnChange(newValues);
    };
    var onConditionsChange = function(freshConditions) {
        var newValues = immutability_helper_default()(values, {
            conditions: {
                $set: freshConditions
            }
        });
        setValues(newValues);
        handleOnChange(newValues);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        w: "100%",
        align: "flex-start"
    }, styleProps), {
        children: [
            showHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_Header, {}),
            showConditions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea */.x, {
                className: "flex-1 w-full",
                mb: theme.spacing.sm,
                viewportRef: conditionsScrollViewRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_Conditions, {
                    conditions: values.conditions,
                    onDelete: onDelete,
                    fields: campaignFields,
                    onChange: onConditionsChange,
                    readOnly: readOnly
                })
            }),
            !readOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_ConditionAdder, {
                onAdd: onAdd
            })
        ]
    }));
};
/* harmony default export */ var FieldFilterPopover_Filter = (Filter);


/***/ }),

/***/ 50910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ toggleParentPopoverCloseState; },
/* harmony export */   "Z": function() { return /* binding */ usePropCloseOnClickOutside; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25328);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36078);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);



var TOGGLE_FIELD_FILTER_POPOVER_CLOSE_ON_CLICK_OUTSIDE = "toggle_fieldFilter_popover_close_on_click_outside";
function usePropCloseOnClickOutside() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useDisclosure */ .q)(true), 2), opened = ref[0], toggle = ref[1].toggle;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener(TOGGLE_FIELD_FILTER_POPOVER_CLOSE_ON_CLICK_OUTSIDE, toggle);
        return function() {
            return window.removeEventListener(TOGGLE_FIELD_FILTER_POPOVER_CLOSE_ON_CLICK_OUTSIDE, toggle);
        };
    }, [
        toggle
    ]);
    return opened;
}
var toggleParentPopoverCloseState = function() {
    window.dispatchEvent(new Event(TOGGLE_FIELD_FILTER_POPOVER_CLOSE_ON_CLICK_OUTSIDE));
};


/***/ }),

/***/ 35145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29848);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4502);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97684);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34054);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5328);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55075);
/* harmony import */ var utils_condition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22857);
/* harmony import */ var _hooks_usePropCloseOnClickOutside__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50910);
/* harmony import */ var _Filter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80510);













var FieldFilterPopover = function(_param) {
    var _position = _param.position, position = _position === void 0 ? "bottom-start" : _position, _width = _param.width, width = _width === void 0 ? 610 : _width, _withPaper = _param.withPaper, withPaper = _withPaper === void 0 ? false : _withPaper, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "position",
        "width",
        "withPaper"
    ]);
    var ref, ref1;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .useMantineTheme */ .rZ)();
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentConditionsTotalCount = ref2[0], setCurrentConditionsTotalCount = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        setCurrentConditionsTotalCount((rest === null || rest === void 0 ? void 0 : (ref = rest.value) === null || ref === void 0 ? void 0 : (ref1 = ref.conditions) === null || ref1 === void 0 ? void 0 : ref1.length) || 0);
    }, [
        rest === null || rest === void 0 ? void 0 : (ref = rest.value) === null || ref === void 0 ? void 0 : (ref1 = ref.conditions) === null || ref1 === void 0 ? void 0 : ref1.length
    ]);
    var propCloseOnClickOutside = (0,_hooks_usePropCloseOnClickOutside__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var onChange = function(conditionGroup) {
        var ref;
        (ref = rest.onChange) === null || ref === void 0 ? void 0 : ref.call(rest, conditionGroup);
        var validConditionsCount = conditionGroup.conditions.filter(function(condition) {
            return (0,utils_condition__WEBPACK_IMPORTED_MODULE_4__/* .getConditionValid */ .j)(condition);
        }).length;
        setCurrentConditionsTotalCount(validConditionsCount);
    };
    var paperProps = withPaper ? {
        withBorder: true,
        p: "xs"
    } : {
        sx: {
            backgroundColor: "transparent"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Popover */ .J, {
        position: position,
        width: width,
        closeOnClickOutside: propCloseOnClickOutside,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Popover.Target */ .J.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Paper */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, paperProps), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                        variant: "subtle",
                        color: "gray.9",
                        compact: true,
                        h: 30,
                        leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            stroke: 1.5,
                            size: 18,
                            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.9", theme)
                        }),
                        sx: function(theme) {
                            return !!currentConditionsTotalCount ? {
                                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.9", theme),
                                backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getBackgroundColor */ .dF)("blue.0", theme),
                                borderRadius: theme.radius.xs,
                                fontSize: 14,
                                "&:hover": {
                                    backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getBackgroundColor */ .dF)("gray.1", theme)
                                }
                            } : {
                                borderRadius: theme.radius.xs,
                                fontSize: 14,
                                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.9", theme),
                                "&:hover": {
                                    backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getBackgroundColor */ .dF)("gray.1", theme)
                                }
                            };
                        },
                        children: [
                            t("actions.filter"),
                            !!currentConditionsTotalCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    "(",
                                    currentConditionsTotalCount,
                                    ")"
                                ]
                            })
                        ]
                    })
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Popover.Dropdown */ .J.Dropdown, {
                sx: {
                    maxHeight: "50vh",
                    display: "flex"
                },
                p: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Filter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, rest), {
                    onChange: onChange,
                    p: "lg"
                }))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FieldFilterPopover);


/***/ }),

/***/ 83598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_HiddenColumns; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Popover/Popover.js + 7 modules
var Popover = __webpack_require__(4502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(81533);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-window-event/use-window-event.js
var use_window_event = __webpack_require__(12667);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconContainer.js
var IconContainer = __webpack_require__(42631);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(70426);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(65067);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconEyeOff.js
var IconEyeOff = __webpack_require__(69447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconEye.js
var IconEye = __webpack_require__(57709);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(21577);
;// CONCATENATED MODULE: ./src/components/business/HiddenColumns/HiddenColumnContent.tsx








var HiddenColumnContent = function(props, ref) {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var value = props.value, columns = props.columns, onChange = props.onChange;
    var updateToggle = (0,react.useRef)((0,debounce/* default */.Z)(function(field, hiddenFields) {
        var newHiddenFields = hiddenFields.includes(field) ? hiddenFields.filter(function(f) {
            return f !== field;
        }) : (0,_to_consumable_array/* default */.Z)(hiddenFields).concat([
            field
        ]);
        onChange(newHiddenFields);
    }, 100)).current;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollArea/* ScrollArea.Autosize */.x.Autosize, {
        mah: "calc(50vh - 50px)",
        ref: ref,
        scrollbarSize: 8,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
            spacing: 0,
            p: "xs",
            children: columns.map(function(column) {
                // @ts-ignore
                var id = column.id, header = column.header, type = column.type;
                var hidden = value.includes(id);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    p: "sm",
                    noWrap: true,
                    sx: {
                        "&:hover": {
                            backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme),
                            borderRadius: theme.radius.xs
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "xs",
                            noWrap: true,
                            sx: {
                                filter: hidden ? "grayscale(1)" : "none"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(business/* EntryIcon */.T2, {
                                    type: type,
                                    fieldCode: id,
                                    useDefault: true,
                                    className: hidden ? "opacity-30" : "opacity-100"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    className: "shrink break-all",
                                    lineClamp: 1,
                                    color: (0,getColor/* getTextColor */.uu)(hidden ? "gray.5" : "gray.9", theme),
                                    children: header
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                            size: "md",
                            onClick: function() {
                                return updateToggle(id, value);
                            },
                            children: hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEyeOff/* default */.Z, {
                                size: 18,
                                stroke: 1.5,
                                color: (0,getColor/* getTextColor */.uu)("gray.7", theme)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEye/* default */.Z, {
                                size: 18,
                                stroke: 1.5,
                                color: (0,getColor/* getTextColor */.uu)("gray.7", theme)
                            })
                        })
                    ]
                }, id);
            })
        })
    });
};
/* harmony default export */ var HiddenColumns_HiddenColumnContent = (/*#__PURE__*/(0,react.forwardRef)(HiddenColumnContent));

;// CONCATENATED MODULE: ./src/components/business/HiddenColumns/index.tsx










var HiddenColumns = function(props) {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var ref2 = (0,use_click_outside/* useClickOutside */.O)(function() {
        return close();
    });
    (0,use_window_event/* useWindowEvent */.s)("resize", close);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        width: 280,
        withinPortal: true,
        position: "bottom-start",
        opened: opened,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    h: 30,
                    spacing: "xs",
                    px: "sm",
                    onClick: open,
                    noWrap: true,
                    sx: function(theme) {
                        return {
                            borderRadius: theme.radius.xs,
                            cursor: "pointer",
                            "&:hover": {
                                background: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                            },
                            "&:active": {
                                transform: "translateY(1px)"
                            }
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer/* default */.Z, {
                            size: 18,
                            stroke: 1.5,
                            color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: "select-none",
                            children: t("actions.hideField")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                p: 0,
                sx: function(theme) {
                    return {
                        boxShadow: theme.shadows.md
                    };
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenColumns_HiddenColumnContent, (0,_object_spread/* default */.Z)({
                    ref: ref2
                }, props))
            })
        ]
    });
};
/* harmony default export */ var business_HiddenColumns = (HiddenColumns);


/***/ }),

/***/ 80347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);

var WebhookContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    appId: "",
    customerAttributes: [],
    isAppScope: false
});
/* harmony default export */ __webpack_exports__["Z"] = (WebhookContext);


/***/ }),

/***/ 4896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebhookEditable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var components_business__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91404);
/* harmony import */ var components_business_Integration_WebhookContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80347);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59845);




function useWebhookEditable(campaignCreatorId) {
    var ref, ref1, ref2;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(components_business_Integration_WebhookContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), campaign = ref3.campaign, webhook = ref3.webhook;
    var checkPermission = (0,components_business__WEBPACK_IMPORTED_MODULE_1__/* .useCheckCampaignPermission */ .r$)();
    var ref4;
    var finalCampaignCreatorId = (ref4 = campaignCreatorId !== null && campaignCreatorId !== void 0 ? campaignCreatorId : webhook === null || webhook === void 0 ? void 0 : (ref = webhook.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.creator) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref4 !== void 0 ? ref4 : campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.creator) === null || ref2 === void 0 ? void 0 : ref2.id;
    return checkPermission(finalCampaignCreatorId !== null && finalCampaignCreatorId !== void 0 ? finalCampaignCreatorId : "", types_domain__WEBPACK_IMPORTED_MODULE_3__/* .ApplicationPermission.CampaignUpdate */ .eC6.CampaignUpdate);
}


/***/ }),

/***/ 80134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42112);

var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_0__/* .createStyles */ .k)(function() {
    return {
        code: {
            backgroundColor: "transparent",
            padding: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-all"
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useStyles);


/***/ }),

/***/ 6525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29718);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57155);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95660);





var AppInfo = function(param) {
    var application = param.application, tooltipDisabled = param.tooltipDisabled;
    var ref, ref1;
    var name = application.name, distribution = application.distribution;
    var channel = distribution.channel;
    var websiteUrl = (ref = distribution.setting) === null || ref === void 0 ? void 0 : ref.websiteUrl;
    var appId = (ref1 = distribution.setting) === null || ref1 === void 0 ? void 0 : ref1.appId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
        spacing: "sm",
        noWrap: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                name: config_constants__WEBPACK_IMPORTED_MODULE_3__/* .channelIconMap */ .XW[channel],
                size: 28
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Stack */ .K, {
                spacing: 0,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                        className: "break-all truncate max-w-[210px]",
                        children: name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u, {
                        label: websiteUrl !== null && websiteUrl !== void 0 ? websiteUrl : appId,
                        openDelay: 500,
                        disabled: tooltipDisabled,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                            c: "dimmed",
                            size: "xs",
                            lineClamp: 1,
                            className: "break-all",
                            children: websiteUrl !== null && websiteUrl !== void 0 ? websiteUrl : appId
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppInfo);


/***/ }),

/***/ 89863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);

var ApplicationContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    application: null,
    account: null,
    me: null
});
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationContext);


/***/ }),

/***/ 59157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46550);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65067);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14661);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(91004);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57155);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7861);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(13644);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95660);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55075);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29718);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33892);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77759);
/* harmony import */ var utils_accountUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45102);














var AccountSwitcher = function() {
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .useMantineTheme */ .rZ)();
    var ref2 = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), user = ref2.user, account = ref2.account;
    var currentAccountUserId = user === null || user === void 0 ? void 0 : (ref = user.accountUser) === null || ref === void 0 ? void 0 : ref.id;
    var createdAccount = (0,utils_accountUtils__WEBPACK_IMPORTED_MODULE_9__/* .getCreatedAccount */ .i)(user);
    var switchAccount = (0,hooks__WEBPACK_IMPORTED_MODULE_7__/* .useAccountSwitcher */ .tB)();
    var handleClick = function(accountId) {
        if (accountId === (account === null || account === void 0 ? void 0 : account.id)) {
            return;
        }
        var path = router.asPath;
        var redirection = path.startsWith(config_constants__WEBPACK_IMPORTED_MODULE_3__/* .SystemPrefix */ .P$) ? path : config_constants__WEBPACK_IMPORTED_MODULE_3__/* .ApplicationDefault */ .HO;
        switchAccount(accountId, redirection).then();
    };
    var handleNewAccount = function() {
        if (createdAccount) {
            return;
        }
        router.push({
            pathname: config_constants__WEBPACK_IMPORTED_MODULE_3__/* .AccountComplete */ .wx,
            query: {
                back: true,
                onboarding: true
            }
        });
    };
    var itemBaseStyle = {
        borderRadius: theme.radius.sm,
        border: "1px solid ".concat((0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBorderColor */ .kJ)("gray.2", theme)),
        "&:hover": {
            backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBackgroundColor */ .dF)("gray.0", theme)
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .ScrollArea.Autosize */ .x.Autosize, {
        scrollbarSize: "8px",
        mah: "512px",
        offsetScrollbars: true,
        mr: "calc(".concat(theme.spacing.lg, " * -1)"),
        styles: function(theme) {
            return {
                viewport: {
                    paddingRight: theme.spacing.lg
                }
            };
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Stack */ .K, {
            children: [
                user === null || user === void 0 ? void 0 : user.accountUsers.map(function(param) {
                    var id = param.id, account = param.account;
                    var selected = id === currentAccountUserId;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                        p: "md",
                        className: "cursor-pointer",
                        sx: function(theme) {
                            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, itemBaseStyle, selected ? {
                                backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBackgroundColor */ .dF)("brandBlue.0", theme),
                                borderColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBorderColor */ .kJ)("brandBlue.7", theme)
                            } : {});
                        },
                        onClick: function() {
                            return handleClick(account.id);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Group */ .Z, {
                            spacing: 0,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Center */ .M, {
                                    className: "w-[28px] mr-[4px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                        name: selected ? "buildingFill" : "building"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .x, {
                                    lineClamp: 1,
                                    weight: "bold",
                                    w: "240px",
                                    className: "flex-1",
                                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getTextColor */ .uu)(selected ? "gray.9" : "gray.7", theme),
                                    children: account.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Center */ .M, {
                                    miw: "20px",
                                    children: selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        size: 20,
                                        stroke: 2,
                                        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getTextColor */ .uu)("brandBlue.7", theme, "brandBlue.2")
                                    })
                                })
                            ]
                        })
                    }, id);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_19__/* .Tooltip */ .u, {
                    label: t("notAllowedAccountCountTip", {
                        accountName: (ref1 = (0,utils_accountUtils__WEBPACK_IMPORTED_MODULE_9__/* .getCreatedAccount */ .i)(user)) === null || ref1 === void 0 ? void 0 : ref1.name
                    }),
                    withArrow: true,
                    withinPortal: true,
                    position: "top",
                    disabled: !createdAccount,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                        p: "md",
                        className: "cursor-pointer",
                        sx: itemBaseStyle,
                        onClick: handleNewAccount,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Group */ .Z, {
                            spacing: 0,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Center */ .M, {
                                    style: {
                                        width: "28px"
                                    },
                                    className: "mr-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_16__/* .Center */ .M, {
                                        sx: function(theme) {
                                            return {
                                                width: "28px",
                                                height: "28px",
                                                borderRadius: theme.radius.md,
                                                border: "1px solid ".concat((0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBorderColor */ .kJ)("gray.2", theme))
                                            };
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                            size: 18
                                        }, createdAccount ? {
                                            style: {
                                                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getTextColor */ .uu)("gray.5", theme)
                                            }
                                        } : {}))
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_17__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                    lineClamp: 1,
                                    className: "flex-1"
                                }, createdAccount ? {
                                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getTextColor */ .uu)("gray.5", theme)
                                } : {}), {
                                    children: t("actions.createEnterprise")
                                }))
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountSwitcher);


/***/ }),

/***/ 29864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19032);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7160);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91004);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55075);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29718);








var MainLink = function(props) {
    var pathname = props.pathname, icon = props.icon, iconActive = props.iconActive, label = props.label, activePathnames = props.activePathnames, _className = props.className, className = _className === void 0 ? "" : _className, isNewFeature = props.isNewFeature;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), currentPath = ref.pathname, appId = ref.query.appId;
    var active = currentPath === pathname || (activePathnames === null || activePathnames === void 0 ? void 0 : activePathnames.includes(currentPath));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: {
            pathname: pathname,
            query: appId ? {
                appId: appId
            } : {}
        },
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .NavLink */ .O, {
            component: "a",
            px: "md",
            py: "xs",
            mb: "xs",
            variant: "light",
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Group */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: label
                    }),
                    isNewFeature && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                        name: "newFeature",
                        className: "h-[22px] items-center"
                    })
                ]
            }),
            active: active,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M, {
                pr: "xs",
                children: active ? iconActive : icon
            }),
            className: className,
            styles: function(theme) {
                return {
                    root: {
                        borderRadius: theme.radius.sm,
                        "&:hover": {
                            backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_4__/* .getBackgroundColor */ .dF)("gray.1", theme)
                        }
                    }
                };
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MainLink);


/***/ }),

/***/ 9774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31817);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56674);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34054);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);





var MenuWrapper = function(props) {
    var buttonChildren = props.buttonChildren, dropdownChildren = props.dropdownChildren, dropdownStyle = props.dropdownStyle;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .v, {
        withinPortal: true,
        offset: 12,
        shadow: "xl",
        position: "right-end",
        closeOnItemClick: true,
        // @ts-ignore
        styles: function(theme) {
            return {
                itemIcon: {
                    marginRight: theme.spacing.md
                },
                dropdown: (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    width: "236px !important",
                    borderColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBorderColor */ .kJ)("gray.2", theme)
                }, dropdownStyle),
                item: {
                    "&[data-hovered]": {
                        backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBackgroundColor */ .dF)("gray.1", theme)
                    }
                }
            };
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Target */ .v.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Stack */ .K, {
                    spacing: 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                        fullWidth: true,
                        h: 44,
                        px: 10,
                        py: "xs",
                        variant: "subtle",
                        styles: {
                            root: {
                                border: 0,
                                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.9", theme),
                                "&:hover": {
                                    backgroundColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBackgroundColor */ .dF)("gray.1", theme)
                                }
                            },
                            inner: {
                                justifyContent: "flex-start"
                            }
                        },
                        children: buttonChildren
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Dropdown */ .v.Dropdown, {
                children: dropdownChildren
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MenuWrapper);


/***/ }),

/***/ 34383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/AppShell.js + 1 modules
var AppShell = __webpack_require__(12439);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/plugins/logrocket/useLogRocket.ts
var useLogRocket = __webpack_require__(98926);
// EXTERNAL MODULE: ./src/plugins/howxm/useHowxmSDK.ts
var useHowxmSDK = __webpack_require__(25474);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/Navbar/Navbar.js
var Navbar = __webpack_require__(68909);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Menu/Menu.js + 13 modules
var Menu = __webpack_require__(56674);
// EXTERNAL MODULE: ./node_modules/.pnpm/howxm-js@0.0.7_react@18.2.0/node_modules/howxm-js/dist/index.es.js
var index_es = __webpack_require__(13528);
// EXTERNAL MODULE: ./src/plugins/crisp/index.ts
var crisp = __webpack_require__(7897);
// EXTERNAL MODULE: ./src/components/business/Layouts/MainLayout/components/MenuWrapper/index.tsx
var MenuWrapper = __webpack_require__(9774);
;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/components/HelpCenter/index.tsx









var HelpCenter = function() {
    var t = (0,useTranslation/* default */.Z)("account").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper/* default */.Z, {
        buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                    name: "tabHelp"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    ml: 22,
                    children: t("assistance.title")
                })
            ]
        }),
        dropdownChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                    px: "lg",
                    py: "sm",
                    target: "_blank",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "helpCenter"
                    }),
                    component: "a",
                    href: config/* helpCenterUrl */.Xp,
                    children: t("assistance.helpCenter")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                    px: "lg",
                    py: "sm",
                    target: "_blank",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "blog"
                    }),
                    component: "a",
                    href: config/* blogUrl */.OV,
                    children: t("assistance.blog")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                    px: "lg",
                    py: "sm",
                    target: "_blank",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "newFunction"
                    }),
                    component: "a",
                    href: config/* newFeatureUrl */.sv,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: t("assistance.newFunction")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                                name: "newFeature",
                                className: "h-[22px] items-center"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {
                    my: "xs"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                    px: "lg",
                    py: "sm",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "one2oneServe"
                    }),
                    onClick: function() {
                        return (0,index_es/* eventHowxm */.ZU)("mkt_consult");
                    },
                    children: t("assistance.one2oneServe")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                    px: "lg",
                    py: "sm",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "onlineCustomers"
                    }),
                    onClick: crisp/* openCrisp */.C,
                    children: t("assistance.onlineCustomers")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                    px: "lg",
                    py: "sm",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: "followUs"
                    }),
                    onClick: function() {
                        return (0,index_es/* eventHowxm */.ZU)("mkt_subscribe");
                    },
                    children: t("assistance.followUs")
                })
            ]
        })
    });
};
/* harmony default export */ var components_HelpCenter = (HelpCenter);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Avatar/Avatar.js + 5 modules
var Avatar = __webpack_require__(56169);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
// EXTERNAL MODULE: ./src/components/business/hooks/useCurrentUserCache.ts
var useCurrentUserCache = __webpack_require__(77759);
;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/MainContext.ts

var MainContext = (0,react.createContext)({
    me: null,
    account: null,
    nav: null
});
/* harmony default export */ var MainLayout_MainContext = (MainContext);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconUserCircle.js
var IconUserCircle = __webpack_require__(86866);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconBuilding.js
var IconBuilding = __webpack_require__(30071);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconSwitchHorizontal.js
var IconSwitchHorizontal = __webpack_require__(48561);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconLogout.js
var IconLogout = __webpack_require__(78965);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/components/business/Layouts/MainLayout/components/AccountSwitcher.tsx
var AccountSwitcher = __webpack_require__(59157);
// EXTERNAL MODULE: ./src/service/index.ts
var service = __webpack_require__(90309);
// EXTERNAL MODULE: ./src/components/business/hooks/usePersistorClient.ts + 19 modules
var usePersistorClient = __webpack_require__(99447);
// EXTERNAL MODULE: ./src/hooks/useApollo.ts
var useApollo = __webpack_require__(37788);
// EXTERNAL MODULE: ./src/config/constants/localStorage.ts
var localStorage = __webpack_require__(12834);
;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/components/AvatarMenu/MenuContent.tsx

















var MenuContent = function() {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useLogoutMutation */._y5)(), 1), logout = ref[0];
    var ref1 = (0,useCurrentUserCache/* default */.Z)(), user = ref1.user, account = ref1.account;
    var client = (0,useApollo/* default */.Z)({});
    var clearCache = (0,usePersistorClient/* default */.Z)({
        client: client,
        key: localStorage/* XM_DATA */.s9,
        restoreOnInit: false
    }).clearCache;
    var handleOpenSwitcherModal = function() {
        (0,events/* openModal */.h7)({
            modalId: "accountSwitcherModal",
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "md",
                weight: 600,
                children: t("switchAccount")
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountSwitcher/* default */.Z, {}),
            centered: true,
            size: 380
        });
    };
    var handleLogout = function() {
        logout().then(function() {
            window.location.href = constants/* Login */.m3;
        });
        clearCache();
        service/* default.reset */.Z.reset();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                align: "center",
                spacing: "sm",
                py: "md",
                px: "md",
                noWrap: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                        size: 28,
                        radius: "xl",
                        src: (0,utils/* getAvatarUrlByUser */.TD)(user)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        spacing: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                weight: "600",
                                lineClamp: 1,
                                className: "break-all",
                                children: user === null || user === void 0 ? void 0 : user.name
                            }),
                            !!account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                size: "xs",
                                color: "dimmed",
                                lineClamp: 1,
                                className: "break-all",
                                children: account.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {
                my: "xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                px: "lg",
                py: "sm",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconUserCircle/* default */.Z, {
                    size: 20,
                    stroke: 1.5
                }),
                component: ui/* NextLink */.pt,
                href: constants/* SystemProfile */.ft,
                children: t("userInfo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                px: "lg",
                py: "sm",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBuilding/* default */.Z, {
                    size: 20,
                    stroke: 1.5
                }),
                component: ui/* NextLink */.pt,
                href: constants/* SystemAccount */.js,
                children: t("accountInfo")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                px: "lg",
                py: "sm",
                closeMenuOnClick: false,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSwitchHorizontal/* default */.Z, {
                    size: 20,
                    stroke: 1.5
                }),
                onClick: handleOpenSwitcherModal,
                children: t("switchAccount")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {
                my: "xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                px: "lg",
                py: "sm",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLogout/* default */.Z, {
                    size: 20,
                    stroke: 1.5
                }),
                color: "red",
                onClick: handleLogout,
                children: t("logout")
            })
        ]
    });
};
/* harmony default export */ var AvatarMenu_MenuContent = (MenuContent);

;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/components/AvatarMenu/index.tsx








var AvatarMenu = function() {
    var user = (0,useCurrentUserCache/* default */.Z)().user;
    var me = (0,react.useContext)(MainLayout_MainContext).me;
    var currentUser = user !== null && user !== void 0 ? user : me;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper/* default */.Z, {
        buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                    size: 28,
                    radius: "xl",
                    src: (0,utils/* getAvatarUrlByUser */.TD)(currentUser),
                    mr: "md"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    lineClamp: 1,
                    className: "truncate block",
                    children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name
                })
            ]
        }),
        dropdownChildren: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarMenu_MenuContent, {})
    });
};
/* harmony default export */ var components_AvatarMenu = (AvatarMenu);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/ColorSchemeProvider.js
var ColorSchemeProvider = __webpack_require__(68523);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconSun.js
var IconSun = __webpack_require__(22855);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconMoonStars.js
var IconMoonStars = __webpack_require__(5842);
;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/components/ThemeSwitcher.tsx




var ThemeSwitcher = function() {
    var ref = (0,ColorSchemeProvider/* useMantineColorScheme */.X)(), colorScheme = ref.colorScheme, toggleColorScheme = ref.toggleColorScheme;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var dark = colorScheme === "dark";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
        variant: "outline",
        color: dark ? "dark.2" : "brandBlue.3",
        onClick: function() {
            return toggleColorScheme();
        },
        children: dark ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSun/* default */.Z, {
            size: 14,
            color: theme.colors.dark[1]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMoonStars/* default */.Z, {
            size: 14,
            color: theme.colors.brandBlue[5]
        })
    });
};
/* harmony default export */ var components_ThemeSwitcher = (ThemeSwitcher);

// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/Nav.tsx









var Nav = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* Navbar */.w, {
        pb: "sm",
        width: {
            base: 252
        },
        height: "100vh",
        styles: {
            root: {
                position: "absolute",
                bottom: "unset",
                overflow: "auto"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
                px: "sm",
                pt: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Logo */.TR, {
                            href: constants/* ApplicationDefault */.HO
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThemeSwitcher, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                mt: "md",
                mb: "md"
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
                px: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HelpCenter, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                my: "sm"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
                px: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AvatarMenu, {})
            })
        ]
    });
};
/* harmony default export */ var MainLayout_Nav = (Nav);

;// CONCATENATED MODULE: ./src/components/business/Layouts/MainLayout/index.tsx










var MainLayout = function(param) {
    var children = param.children, nav = param.nav, me = param.me, account = param.account;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    (0,useLogRocket/* default */.Z)();
    (0,useHowxmSDK/* default */.Z)(config/* HowXMAppId */.KD);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        className: "h-full",
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: "\n              html body {\n                background-color: ".concat((0,getColor/* getBackgroundColor */.dF)("gray.0", theme), ";\n                overflow: overlay;\n              }\n            ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_MainContext.Provider, {
                value: {
                    me: me,
                    account: account
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppShell/* AppShell */.V, {
                    padding: 32,
                    navbarOffsetBreakpoint: "sm",
                    asideOffsetBreakpoint: "sm",
                    navbar: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_Nav, {
                        children: nav
                    }),
                    styles: function(theme) {
                        return {
                            main: {
                                maxHeight: "100vh",
                                overflow: "auto",
                                paddingTop: theme.spacing.lg,
                                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme)
                            }
                        };
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        pos: "relative",
                        h: "100%",
                        children: children
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Layouts_MainLayout = (MainLayout);


/***/ }),

/***/ 17873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M5": function() { return /* binding */ useOnboardingLayoutForm; },
/* harmony export */   "bv": function() { return /* binding */ useOnboardingLayoutContext; },
/* harmony export */   "uM": function() { return /* binding */ OnboardingLayoutProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25328);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33313);


var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_mantine_form__WEBPACK_IMPORTED_MODULE_1__/* .createFormContext */ .W)(), 3);
var OnboardingLayoutProvider = ref[0], useOnboardingLayoutContext = ref[1], useOnboardingLayoutForm = ref[2];


/***/ }),

/***/ 19932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_OnboardingLayout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./src/components/business/Layouts/OnboardingLayout/context.ts
var context = __webpack_require__(17873);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(74969);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Steps/styles.ts

var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        step: {
            height: 26,
            minWidth: 26,
            borderRadius: "18px",
            backgroundColor: theme.colors.gray[0],
            border: "1px solid ".concat(theme.colors.gray[2]),
            color: theme.colors.gray[6],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: theme.fontSizes.xs,
            padding: "0 ".concat(theme.spacing.sm)
        },
        selected: {
            backgroundColor: theme.colors.brandBlue[1],
            border: "1px solid ".concat(theme.colors.brandBlue[2]),
            color: theme.colors.brandBlue[7]
        }
    };
});

;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Steps/index.tsx






var OnboardingSteps = function(param) {
    var _stepCount = param.stepCount, stepCount = _stepCount === void 0 ? 2 : _stepCount, onStepClick = param.onStepClick;
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var step = (0,context/* useOnboardingLayoutContext */.bv)().values.step;
    var stepElements = (0,react.useMemo)(function() {
        return Array.from({
            length: stepCount
        }).map(function(_, i) {
            var selected = step === i;
            var label = selected ? "".concat(t("actions.step")).concat(i + 1) : "".concat(i + 1);
            var clickable = i === 0;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                className: cx(classes.step, selected && classes.selected, clickable && "cursor-pointer"),
                onClick: function() {
                    return clickable && (onStepClick === null || onStepClick === void 0 ? void 0 : onStepClick(i));
                },
                size: "sm",
                children: label
            }, label);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        classes.selected,
        classes.step,
        step,
        cx,
        stepCount,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        p: 0,
        mb: "lg",
        spacing: "sm",
        children: stepElements
    });
};
/* harmony default export */ var Steps = (OnboardingSteps);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(97684);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(60148);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Preview/AppSkeletonItem.tsx





var AppSkeletonItem = function(param) {
    var channel = param.channel, appName = param.appName, appId = param.appId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        mih: 52,
        align: "center",
        children: [
            channel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: constants/* channelIconMap */.XW[channel],
                className: "shrink-0",
                size: 28
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                animate: false,
                w: 28,
                height: 28,
                radius: "md"
            }),
            appName || appId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                ml: "md",
                direction: "column",
                children: [
                    appName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: "md",
                        lh: 1.5,
                        className: "break-all",
                        children: appName
                    }),
                    appId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        c: "gray.6",
                        size: "xs",
                        lh: 1.5,
                        className: "break-all",
                        children: appId
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                animate: false,
                w: 81,
                height: 12,
                radius: 10,
                ml: "md"
            })
        ]
    });
};
/* harmony default export */ var Preview_AppSkeletonItem = (AppSkeletonItem);

;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Preview/images/bg.png
/* harmony default export */ var bg = ({"src":"https://static-cny.howxm.com/_next/static/media/bg.9f7fa90e.png","height":1280,"width":1120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAyklEQVR42nXIMU7DMBQG4N8vdkhKKmBBNAgpEhviDByKmzCyITFwHMSAxMxARCFtkqZu7Pj5tRfoN37q6eUzz2UqiaU03lPh2vbC1X9n/r/VD/y2aFDd23heiZhwwuNvHoYi482PvpGPuwzDbSeL0sdiR0zIeZNkbKOeS3MFkErFdYNcbkOc2Yy3MeWRtMGIOZZLUtxHSde7kEw6ek5kWmkF+TZwzalq6p6vBz8xJTHQ4R0J8A6FLw1bV4/P/Qy+M5C10sZCXiuFI/bpq2zUDuEOnAAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Preview/styles.ts


var styles_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    var ref;
    var browserImg = (ref = __webpack_require__(13813)("./browser-".concat(theme.colorScheme, ".png")).default) === null || ref === void 0 ? void 0 : ref.src;
    return {
        wrapper: {
            background: "url(".concat(bg.src, ") top no-repeat"),
            backgroundSize: "100% auto",
            position: "relative"
        },
        fakeBrowser: {
            position: "absolute"
        },
        fakeBrowserBg: {
            background: "url(".concat(browserImg, ") bottom right no-repeat"),
            backgroundSize: "560px 640px",
            position: "absolute",
            width: "100%",
            height: "100%",
            transition: "all .5s"
        },
        fakeBrowserDropdown: {
            position: "relative",
            transition: "all .5s",
            transformOrigin: "top left",
            opacity: 0,
            transform: "scale(0.7)"
        },
        fakeBrowserDropdownOpen: {
            opacity: 1,
            transform: "scale(1)"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Preview/index.tsx






var Preview = function() {
    var ref = styles_useStyles(), classes = ref.classes, cx = ref.cx;
    var _values = (0,context/* useOnboardingLayoutContext */.bv)().values, accountName = _values.accountName, appName = _values.appName, channel = _values.channel, appId = _values.appId, openDropdown = _values.openDropdown;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: classes.wrapper,
        w: "100%",
        h: "100%",
        mih: 638,
        p: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            className: classes.fakeBrowser,
            p: 0,
            w: 420,
            h: 500,
            bottom: 0,
            right: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    className: classes.fakeBrowserBg,
                    p: 0,
                    opacity: openDropdown ? 0.8 : 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
                    className: cx(classes.fakeBrowserDropdown, openDropdown && classes.fakeBrowserDropdownOpen),
                    ml: 24,
                    mt: 105,
                    w: 280,
                    p: "md",
                    shadow: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            align: "center",
                            mih: 20,
                            mb: "sm",
                            className: "flex-1",
                            children: accountName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                c: "gray.6",
                                lh: "20px",
                                className: "break-all",
                                children: accountName
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                animate: false,
                                w: 81,
                                height: 12,
                                radius: "xl"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_AppSkeletonItem, {
                            appId: appId,
                            appName: appName,
                            channel: channel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_AppSkeletonItem, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var OnboardingLayout_Preview = (Preview);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(70563);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronLeft.js
var IconChevronLeft = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
;// CONCATENATED MODULE: ./src/components/ui/Button/Back/index.tsx







var Back = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("common").t;
    var onBack = function() {
        window.history.back();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
        variant: "subtle",
        c: (0,getColor/* getTextColor */.uu)("gray.7", theme),
        sx: {
            "&:hover": {
                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.2", theme, "dark.6")
            }
        },
        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronLeft/* default */.Z, {
            size: 18,
            stroke: 1.5,
            color: (0,getColor/* getTextColor */.uu)("gray.7", theme)
        }),
        pos: "absolute",
        top: theme.spacing.lg,
        left: theme.spacing.xl,
        onClick: onBack,
        children: t("actions.back")
    });
};
/* harmony default export */ var Button_Back = (Back);

// EXTERNAL MODULE: ./src/components/business/Layouts/OnboardingLayout/constant.ts
var constant = __webpack_require__(33895);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(55150);
;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/Content.tsx












var stepRoutes = [
    constants/* AccountComplete */.wx,
    constants/* ApplicationNew */.bC
];
var Content = function(param) {
    var back = param.back, children = param.children;
    var ref;
    var router = (0,next_router.useRouter)();
    var matches = (0,use_media_query/* useMediaQuery */.a)("(min-width: 890px)", true, {
        getInitialValueInEffect: false
    });
    var onboarding = (0,context/* useOnboardingLayoutContext */.bv)().values.onboarding;
    var showStep = onboarding || ((ref = router.query) === null || ref === void 0 ? void 0 : ref[constant/* showStepQueryKey */.d]);
    var onStepClick = function(step) {
        router.replace({
            pathname: stepRoutes[step],
            query: getStepJumpQuery()
        });
    };
    var getStepJumpQuery = function() {
        var ref, ref1;
        var query = {};
        var showStepQuery = (ref = router.query) === null || ref === void 0 ? void 0 : ref[constant/* showStepQueryKey */.d];
        var showBackBtnQuery = (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1[constant/* showBackBtnQueryKey */.Q];
        if (showStepQuery) {
            query[constant/* showStepQueryKey */.d] = "1";
        }
        if (showBackBtnQuery) {
            query[constant/* showBackBtnQueryKey */.Q] = "1";
        }
        return query;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* ContainerWithDotBg */.kH, {
        className: "max-w-none",
        children: [
            back && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Back, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                className: "min-h-screen",
                py: "2xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "2xl",
                    w: "100%",
                    maw: 1120,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Logo */.TR, {
                                width: 112,
                                height: 44
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* SessionPaper */.vD, {
                            minHeight: 640,
                            radius: "lg",
                            p: 0,
                            height: "auto",
                            width: "100%",
                            py: "0!important",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                m: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        p: 0,
                                        span: matches ? 6 : 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                            maw: 420,
                                            mx: "auto",
                                            py: 64,
                                            children: [
                                                showStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {
                                                    onStepClick: onStepClick,
                                                    stepCount: stepRoutes.length
                                                }),
                                                children
                                            ]
                                        })
                                    }),
                                    matches && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        p: 0,
                                        span: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingLayout_Preview, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var OnboardingLayout_Content = (Content);

// EXTERNAL MODULE: ./src/components/business/Layouts/OnboardingLayout/validate.ts
var validate = __webpack_require__(55887);
;// CONCATENATED MODULE: ./src/components/business/Layouts/OnboardingLayout/index.tsx











var OnboardingLayout = function(param) {
    var openDropdown = param.openDropdown, children = param.children;
    var ref;
    var t = (0,useTranslation/* default */.Z)("pageAppNew").t;
    var router = (0,next_router.useRouter)();
    var form = (0,context/* useOnboardingLayoutForm */.M5)({
        clearInputErrorOnChange: true,
        initialValues: {
            openDropdown: openDropdown
        },
        validate: {
            accountName: function(val) {
                return (0,validate/* validateName */.Ol)(t, val);
            }
        },
        transformValues: function(values) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                appId: (0,validate/* isEmptyUrl */.Ul)(values.appId) ? "" : values.appId
            });
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ResponsiveHead */.eG, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* OnboardingLayoutProvider */.uM, {
                    form: form,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingLayout_Content, {
                        back: !!((ref = router.query) === null || ref === void 0 ? void 0 : ref[constant/* showBackBtnQueryKey */.Q]),
                        children: children
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Layouts_OnboardingLayout = (OnboardingLayout);


/***/ }),

/***/ 55887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ol": function() { return /* binding */ validateName; },
/* harmony export */   "Ul": function() { return /* binding */ isEmptyUrl; },
/* harmony export */   "mQ": function() { return /* binding */ validateUrl; }
/* harmony export */ });
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95660);
/* harmony import */ var config_constants_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4639);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88966);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73046);




function validateName(t, value) {
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(value)) {
        return null;
    }
    if (value.trim().length === 0) {
        return t("pageAppNew:name.emptyError");
    }
    if ((0,utils__WEBPACK_IMPORTED_MODULE_2__/* .length */ .kE)(value.trim()) > config_constants__WEBPACK_IMPORTED_MODULE_0__/* .appNameMaxlength */ .QC * 2) {
        return t("pageAppNew:name.maxLengthError");
    }
}
function validateUrl(value, t) {
    var isProtocol = isEmptyUrl(value);
    if (isProtocol) {
        return t("pageAppNew:websiteUrl.emptyError");
    }
    if (!(0,utils__WEBPACK_IMPORTED_MODULE_2__/* .isUrl */ .CB)(value === null || value === void 0 ? void 0 : value.trim())) {
        return t("pageAppNew:websiteUrl.patternError");
    }
    return null;
}
function isEmptyUrl(value) {
    if (!value) {
        return true;
    }
    return Object.values(config_constants_link__WEBPACK_IMPORTED_MODULE_1__/* .Protocol */ .b).includes(value.trim());
}


/***/ }),

/***/ 98555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PlatformPreview_DesktopPreview; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
;// CONCATENATED MODULE: ./src/components/business/PlatformPreview/DesktopPreview/getImage.ts
var getImage = function(name, theme, suffix) {
    var ref;
    var _colorScheme;
    return (ref = __webpack_require__(93098)("./".concat(name, "-").concat((_colorScheme = theme.colorScheme) !== null && _colorScheme !== void 0 ? _colorScheme : "light", ".").concat(suffix !== null && suffix !== void 0 ? suffix : "png"))) === null || ref === void 0 ? void 0 : ref.default.src;
};

// EXTERNAL MODULE: ./src/components/business/PlatformPreview/DesktopPreview/FakeBrowser/index.module.scss
var index_module = __webpack_require__(9557);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
;// CONCATENATED MODULE: ./src/components/business/PlatformPreview/DesktopPreview/FakeBrowser/index.tsx






var FakeBrowser = function(param) {
    var children = param.children;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).browser,
        style: {
            border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.3", theme, "dark.9")),
            borderRadius: theme.radius.md,
            minHeight: "300px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "h-[50px]",
                style: {
                    backgroundImage: "url(".concat(getImage("browser-end", theme), "), url(").concat(getImage("browser-start", theme), "), url(").concat(getImage("browser-repeat", theme), "), url(").concat(getImage("browser-end", theme), ")")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                style: {
                    overflow: "auto"
                },
                children: children
            })
        ]
    });
};
/* harmony default export */ var DesktopPreview_FakeBrowser = (FakeBrowser);

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/business/PlatformPreview/DesktopPreview/index.tsx









var DesktopPreview = function(_param) {
    var children = _param.children, className = _param.className, pos = _param.pos, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "pos"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        className: classnames_default()("w-full h-full", className),
        pos: pos !== null && pos !== void 0 ? pos : "relative",
        maw: 1200,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopPreview_FakeBrowser, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            children: children
        }))
    });
};
/* eslint-disable */ DesktopPreview.PreLoadBg = function() {
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[0px] h-[0px] overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: getImage("browser-start", theme),
                alt: "preload"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: getImage("browser-end", theme),
                alt: "preload"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: getImage("browser-repeat", theme),
                alt: "preload"
            })
        ]
    });
};
/* eslint-enable */ /* harmony default export */ var PlatformPreview_DesktopPreview = (DesktopPreview);


/***/ }),

/***/ 24309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17474);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95202);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13192);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54117);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93372);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36618);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55075);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54594);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59845);







var _obj;
var iconMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "web", _tabler_icons_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "mobile", _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "refresh", _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z), _obj);
var PreviewActionIcon = function(param) {
    var onClick = param.onClick, type = param.type;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .useMantineTheme */ .rZ)();
    var Component = iconMap[type];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .ActionIcon */ .A, {
        variant: "default",
        onClick: onClick,
        size: "lg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__/* .getTextColor */ .uu)("gray.6", theme),
            size: 20,
            stroke: 1.5
        })
    });
};
var PreviewActions = function(param) {
    var widgetType = param.widgetType, onRefresh = param.onRefresh, platformChangeable = param.platformChangeable, onPlatformClick = param.onPlatformClick, className = param.className;
    var refreshButtonVisible = widgetType !== types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetType.Button */ .YMh.Button;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Stack */ .K, {
        pos: "absolute",
        className: className,
        children: [
            platformChangeable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PreviewActionIcon, {
                        type: "web",
                        onClick: function() {
                            return onPlatformClick && onPlatformClick("web");
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PreviewActionIcon, {
                        type: "mobile",
                        onClick: function() {
                            return onPlatformClick && onPlatformClick("mobile");
                        }
                    })
                ]
            }),
            refreshButtonVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PreviewActionIcon, {
                type: "refresh",
                onClick: function() {
                    return onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PreviewActions);


/***/ }),

/***/ 43350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68711);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73046);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);




var Price = function(param) {
    var price = param.price;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("product").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Group */ .Z, {
        spacing: 0,
        position: "center",
        align: "flex-end",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                fz: 24,
                fw: 600,
                lh: "30px",
                children: (0,utils__WEBPACK_IMPORTED_MODULE_1__/* .formatNumberToThousands */ .NZ)(price.unitAmount / 100, {
                    style: "currency",
                    currency: "CNY",
                    point: 0,
                    currencyDisplay: "narrowSymbol"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                lh: "26px",
                children: t("price.interval.".concat(price.interval, ".unit"))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Price);


/***/ }),

/***/ 7921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ul": function() { return /* reexport */ ProductsModal_ProductsModalContent; },
  "$P": function() { return /* reexport */ openProductsModal; }
});

// UNUSED EXPORTS: CustomizedFeature, productsModalId, recommendBadgeOverflowSize, recommendProduct

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/get-default-z-index/get-default-z-index.js
var get_default_z_index = __webpack_require__(847);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./src/config/constants/products.ts
var products = __webpack_require__(52762);
;// CONCATENATED MODULE: ./src/components/business/ProductsModal/constant.ts

var recommendBadgeOverflowSize = 4;
var recommendProduct = products/* ProductCode.Pro */.G.Pro;
var productsModalId = "productsModal";
var CustomizedFeature;
(function(CustomizedFeature) {
    CustomizedFeature["EntriesCount"] = "ENTRIES_COUNT";
    CustomizedFeature["ApplicationsCount"] = "APPLICATIONS_COUNT";
    CustomizedFeature["CampaignsCountPerApplication"] = "CAMPAIGNS_COUNT_PER_APPLICATION";
    CustomizedFeature["AppApplication"] = "APP_APPLICATION";
    CustomizedFeature["Teamwork"] = "TEAMWORK";
    CustomizedFeature["WebSupport"] = "WEB_SUPPORT";
    CustomizedFeature["Webhook"] = "WEBHOOK";
    CustomizedFeature["ImPush"] = "IM_PUSH";
    CustomizedFeature["Customer"] = "CUSTOMER";
    CustomizedFeature["CampaignTargetingCustomer"] = "CAMPAIGN_TARGETING_CUSTOMER";
    CustomizedFeature["CampaignSchedule"] = "CAMPAIGN_SCHEDULE";
    CustomizedFeature["CampaignTriggerByEvent"] = "CAMPAIGN_TRIGGER_BY_EVENT";
    CustomizedFeature["HideBranding"] = "HIDE_BRANDING";
})(CustomizedFeature || (CustomizedFeature = {}));

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/px/px.js
var px = __webpack_require__(33983);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(58262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Switch/Switch.js + 3 modules
var Switch = __webpack_require__(54574);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
;// CONCATENATED MODULE: ./src/components/business/ProductsModal/PriceIntervalToggle.tsx




var Label = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        color: props.active ? undefined : "dimmed",
        fw: props.active ? 600 : undefined,
        onClick: props.onClick,
        className: "cursor-pointer",
        children: props.text
    });
};
var RightTip = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        ml: "md",
        px: "md",
        py: 5,
        pos: "relative",
        bg: "orange.0",
        sx: function(theme) {
            return {
                border: "1px solid ".concat(theme.colors.orange[6]),
                borderRadius: theme.radius.xs
            };
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: "orange.6",
                lh: "20px",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                w: 7,
                h: 7,
                top: 11.5,
                left: -4.5,
                pos: "absolute",
                bg: "inherit",
                sx: function(theme) {
                    return {
                        transform: "rotate(45deg)",
                        border: "1px solid ".concat(theme.colors.orange[6]),
                        borderRight: 0,
                        borderTop: 0,
                        borderBottomLeftRadius: 1
                    };
                }
            })
        ]
    });
};
var PriceIntervalToggle = function(param) {
    var value = param.value, onChange = param.onChange;
    var t = (0,useTranslation/* default */.Z)("product").t;
    var checked = value === domain/* PriceInterval.Year */.pjJ.Year;
    var handleChange = function(event) {
        event.currentTarget.checked ? onChange(domain/* PriceInterval.Year */.pjJ.Year) : onChange(domain/* PriceInterval.Month */.pjJ.Month);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                text: t("price.interval.MONTH.label"),
                active: !checked,
                onClick: function() {
                    return onChange(domain/* PriceInterval.Month */.pjJ.Month);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* Switch */.r, {
                className: "flex",
                checked: checked,
                onChange: handleChange,
                styles: function(theme) {
                    return {
                        track: {
                            backgroundColor: theme.colors.brandBlue[7],
                            borderColor: theme.colors.brandBlue[7]
                        }
                    };
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                text: t("price.interval.YEAR.label"),
                active: checked,
                onClick: function() {
                    return onChange(domain/* PriceInterval.Year */.pjJ.Year);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightTip, {
                label: t("price.interval.YEAR.tip")
            })
        ]
    });
};
/* harmony default export */ var ProductsModal_PriceIntervalToggle = (PriceIntervalToggle);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(97684);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(31463);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(79705);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(4720);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./src/components/business/ProductsModal/Price.tsx
var Price = __webpack_require__(43350);
;// CONCATENATED MODULE: ./src/components/business/ProductsModal/ProductIntro.tsx













var ProductIntro = function(props) {
    var t = (0,useTranslation/* default */.Z)("product").t;
    var router = (0,next_router.useRouter)();
    var getProductColor = (0,business/* useVipColor */.W5)();
    var product = props.product, priceInterval = props.priceInterval, currentCode = props.currentCode, disablePurchase = props.disablePurchase, feature = props.feature, fromSite = props.fromSite;
    var code = product.code, name = product.name, prices = product.prices;
    var price = prices.find(function(price) {
        return price.interval === priceInterval;
    });
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,domain/* useCreateProductPurchaseUrlMutation */.eOQ)(), 1), createPurchaseUrl = ref1[0];
    var descriptions = t("product:".concat(code, ".descriptions"), {}, {
        returnObjects: true
    });
    var isPaid = code !== products/* ProductCode.Free */.G.Free;
    var isActiveTrialing = currentCode === products/* ProductCode.Trial */.G.Trial && code === products/* ProductCode.Basic */.G.Basic;
    var isActive = currentCode === code || isActiveTrialing;
    var disablePurchaseBtn = disablePurchase || (0,isNil/* default */.Z)(price) || loading || currentCode && products/* paidProductCodes.includes */.$.includes(currentCode) && currentCode !== code;
    var handleClick = function() {
        setLoading(true);
        if (fromSite) {
            jumpToSignUp();
        } else {
            createPurchaseUrl({
                variables: {
                    input: {
                        priceCode: price.code,
                        feature: feature
                    }
                },
                onCompleted: function onCompleted(param) {
                    var createProductPurchaseUrl = param.createProductPurchaseUrl;
                    createProductPurchaseUrl && router.push(createProductPurchaseUrl);
                }
            });
        }
    };
    var jumpToSignUp = function() {
        var query = isPaid ? {
            productCode: code
        } : {};
        router.push({
            pathname: constants/* Signup */.Al,
            query: query
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        m: "sm",
        sx: function(theme) {
            return {
                background: "linear-gradient(309.58deg, rgba(235, 239, 250, 0.5) 20.01%, rgba(237, 242, 252, 0) 81.4%)",
                borderRadius: theme.radius.md
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            px: "2xl",
            py: "xl",
            mih: 310,
            spacing: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "center",
                    spacing: "sm",
                    children: [
                        isPaid && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                            name: "vip",
                            style: {
                                color: getProductColor(code)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 2,
                            lh: "36px",
                            children: name
                        }),
                        isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                            variant: "filled",
                            color: "brandBlue.4",
                            radius: "xs",
                            px: "sm",
                            fw: 400,
                            h: 24,
                            children: isActiveTrialing ? t("product:trialing") : t("product:current")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                    center: true,
                    spacing: "sm",
                    size: "sm",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        bg: "brandBlue.7",
                        w: 5,
                        h: 5,
                        sx: {
                            transform: "rotate(135deg)",
                            borderRadius: 1
                        }
                    }),
                    children: descriptions.map(function(desc, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                            children: desc
                        }, index);
                    })
                }),
                isPaid ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    mt: "auto",
                    spacing: "lg",
                    children: [
                        price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                            price: price
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            fz: 16,
                            fw: 600,
                            ta: "center",
                            children: t("product:price.intervalUnsupported.".concat(priceInterval))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            fullWidth: true,
                            size: "md",
                            disabled: disablePurchaseBtn,
                            onClick: handleClick,
                            children: isActive ? t("product:renewNow") : t("product:purchaseNow")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: fromSite && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        mt: "auto",
                        fullWidth: true,
                        variant: "default",
                        size: "md",
                        onClick: jumpToSignUp,
                        children: t("product:tryFree")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductsModal_ProductIntro = (ProductIntro);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconCheck.js
var IconCheck = __webpack_require__(7861);
;// CONCATENATED MODULE: ./src/components/business/ProductsModal/components/Feature.tsx





var FeatureText = function(param) {
    var titleKey = param.titleKey, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
        titleKey: titleKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            children: value
        })
    });
};
var FeatureCheck = function(param) {
    var titleKey = param.titleKey;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
        titleKey: titleKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
            color: theme.colors.brandBlue[7],
            size: 24
        })
    });
};
var Feature = function(param) {
    var titleKey = param.titleKey, children = param.children;
    var t = (0,useTranslation/* default */.Z)("product").t;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                c: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                children: t("feature.".concat(titleKey, ".name"))
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/FreeFeature.tsx



var FreeFeature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.EntriesCount,
                value: "3000条/年"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.ApplicationsCount,
                value: "2个"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.CampaignsCountPerApplication,
                value: "3份/应用"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.WebSupport
            })
        ]
    });
};
/* harmony default export */ var ProductsModal_FreeFeature = (FreeFeature);

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/BasicFeature.tsx



var BasicFeatures = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.EntriesCount,
                value: "10万条/年"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.ApplicationsCount,
                value: "5个"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.CampaignsCountPerApplication,
                value: "不限量"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.WebSupport
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.AppApplication
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.Teamwork,
                value: "10个/应用"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignTargetingCustomer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignSchedule
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignTriggerByEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.Customer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.ImPush
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.Webhook
            })
        ]
    });
};
/* harmony default export */ var BasicFeature = (BasicFeatures);

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/ProFeature.tsx



var ProFeature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.EntriesCount,
                value: "50万条/年"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.ApplicationsCount,
                value: "10个"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.CampaignsCountPerApplication,
                value: "不限量"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.WebSupport
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.AppApplication
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.Teamwork,
                value: "20个/应用"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignTargetingCustomer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignSchedule
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignTriggerByEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.Customer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.ImPush
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.Webhook
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.HideBranding
            })
        ]
    });
};
/* harmony default export */ var ProductsModal_ProFeature = (ProFeature);

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/UltimateFeature.tsx



var UltimateFeature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.EntriesCount,
                value: "100万条/年"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.ApplicationsCount,
                value: "20个"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.CampaignsCountPerApplication,
                value: "不限量"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.WebSupport
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.AppApplication
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureText, {
                titleKey: CustomizedFeature.Teamwork,
                value: "50个/应用"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignTargetingCustomer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignSchedule
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.CampaignTriggerByEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.Customer
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.ImPush
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.Webhook
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCheck, {
                titleKey: CustomizedFeature.HideBranding
            })
        ]
    });
};
/* harmony default export */ var ProductsModal_UltimateFeature = (UltimateFeature);

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/ProductFeatures.tsx







var ProductFeatures = function(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        pt: "lg",
        px: 40,
        pb: 40,
        spacing: 12,
        children: [
            product.code === products/* ProductCode.Free */.G.Free && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_FreeFeature, {}),
            product.code === products/* ProductCode.Basic */.G.Basic && /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFeature, {}),
            product.code === products/* ProductCode.Pro */.G.Pro && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_ProFeature, {}),
            product.code === products/* ProductCode.Ultimate */.G.Ultimate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_UltimateFeature, {})
        ]
    });
};
/* harmony default export */ var ProductsModal_ProductFeatures = (ProductFeatures);

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/recommend.png
/* harmony default export */ var ProductsModal_recommend = ({"src":"https://static-cny.howxm.com/_next/static/media/recommend.23d73ef1.png","height":204,"width":204,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAtElEQVR42mP46Cno+D+M5+6/KNH///wZTv1jYOBiYGBg+BfLwMIAA/8SdJX/hzG8+N9f+v9fY9xxuKI0ZhaGn5FybGCOFoPcv578p/+XTfj/rz7s4j8GBl6ECXF8rGCagUH+X1fGk/9rp///1516/p8PgyhCUboKQtG0sqf/59T+/1eif5MBGfwrMIIoCmWQ+19h+eJfo/d/BnTwr9wGoqg9TPl/i/89Bmzgd60T2OFf66ztARR5TaffFoDJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/business/ProductsModal/Product.tsx









var Product = function(_param) {
    var product = _param.product, fromSite = _param.fromSite, recommend = _param.recommend, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "fromSite",
        "recommend"
    ]);
    var t = (0,useTranslation/* default */.Z)("product").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
        withBorder: true,
        radius: "lg",
        pos: "relative",
        sx: {
            boxShadow: "0px 8px 8px -8px rgba(0, 0, 0, 0.1)",
            "&:hover": {
                boxShadow: "0px 17px 17px -7px rgba(0, 0, 0, 0.04), 0px 36px 28px -7px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.05)"
            }
        },
        children: [
            recommend && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                src: ProductsModal_recommend.src,
                alt: t("recommend"),
                width: 96,
                pos: "absolute",
                top: -recommendBadgeOverflowSize,
                right: -recommendBadgeOverflowSize
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_ProductIntro, (0,_object_spread/* default */.Z)({
                fromSite: fromSite,
                product: product
            }, rest)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_ProductFeatures, {
                product: product
            })
        ]
    });
};
/* harmony default export */ var ProductsModal_Product = (Product);

// EXTERNAL MODULE: ./src/components/business/hooks/useAccountSubscriptionCache.ts
var useAccountSubscriptionCache = __webpack_require__(19190);
;// CONCATENATED MODULE: ./src/components/business/ProductsModal/ProductsModalContent.tsx








var minProductItemWidth = 288;
var maxProductItemWidth = 300;
var ProductsModalContent = function(param) {
    var feature = param.feature, serverSideProducts = param.products, _fromSite = param.fromSite, fromSite = _fromSite === void 0 ? false : _fromSite;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    var subscription = (0,useAccountSubscriptionCache/* default */.Z)().subscription;
    var productCode = (subscription !== null && subscription !== void 0 ? subscription : {}).productCode;
    var ref = (0,react.useState)(domain/* PriceInterval.Year */.pjJ.Year), interval = ref[0], setInterval = ref[1];
    var data = (0,domain/* useProductsQuery */.kNl)({
        fetchPolicy: "cache-and-network",
        skip: !!(serverSideProducts === null || serverSideProducts === void 0 ? void 0 : serverSideProducts.length)
    }).data;
    var ref1, ref2;
    var products = (ref2 = (ref1 = data === null || data === void 0 ? void 0 : data.products) !== null && ref1 !== void 0 ? ref1 : serverSideProducts) !== null && ref2 !== void 0 ? ref2 : [];
    var currentIndex = products.findIndex(function(param) {
        var code = param.code;
        return code === productCode;
    });
    var productsCount = products.length;
    var minWidth = productsCount * minProductItemWidth + (productsCount - 1) * (0,px.px)(theme.spacing.lg);
    var maxWidth = productsCount * maxProductItemWidth + (productsCount - 1) * (0,px.px)(theme.spacing.lg);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                mih: "100%",
                pb: "md",
                className: "max-xs:w-full sm:min-w-[".concat(minWidth, "px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    className: "max-xs:w-full items-center gap-4xl sm:px-[0] sm:gap-2xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_PriceIntervalToggle, {
                            value: interval,
                            onChange: setInterval
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                            cols: productsCount,
                            pt: recommendBadgeOverflowSize,
                            className: "max-xs:w-full sm:!max-w-[".concat(maxWidth, "px]"),
                            breakpoints: [
                                {
                                    maxWidth: 576,
                                    cols: 1,
                                    spacing: theme.spacing.lg
                                },
                                {
                                    minWidth: 576,
                                    cols: productsCount,
                                    spacing: theme.spacing.lg
                                }, 
                            ],
                            children: products.map(function(product, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_Product, {
                                    product: product,
                                    priceInterval: interval,
                                    currentCode: productCode,
                                    recommend: product.code === recommendProduct,
                                    disablePurchase: index < currentIndex,
                                    feature: feature,
                                    fromSite: fromSite
                                }, product.code);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: "red",
                pb: "3xl",
                children: "* 浩客也支持私有化部署，具体内容，可咨询在线客服或客户顾问"
            })
        ]
    });
};
/* harmony default export */ var ProductsModal_ProductsModalContent = (ProductsModalContent);

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/openProductsModal.tsx






function openProductsModal(feature) {
    (0,events/* openModal */.h7)({
        modalId: productsModalId,
        withinPortal: true,
        size: 1300,
        zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("popover") + 1,
        transitionProps: {
            transition: {
                in: {
                    opacity: 1,
                    transform: "scale(1)"
                },
                out: {
                    opacity: 0,
                    transform: "scale(1.2)"
                },
                common: {
                    transformOrigin: "center"
                },
                transitionProperty: "transform, opacity"
            },
            timingFunction: "cubic-bezier(0.6, 0.85, 0.32, 1.28)",
            exitDuration: 250
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsModal_ProductsModalContent, {
            feature: feature
        }),
        styles: function(theme) {
            return {
                inner: {
                    overflow: "hidden"
                },
                modal: {
                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme)
                }
            };
        }
    });
}

;// CONCATENATED MODULE: ./src/components/business/ProductsModal/index.ts





/***/ }),

/***/ 29184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ getJumpRule; },
/* harmony export */   "u": function() { return /* binding */ getShowRules; }
/* harmony export */ });
function getJumpRule(field) {
    return field === null || field === void 0 ? void 0 : field.jumpRule;
}
function getShowRules(field) {
    return field === null || field === void 0 ? void 0 : field.showRules;
}


/***/ }),

/***/ 73348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ getDefaultWidgetSetting; },
/* harmony export */   "L7": function() { return /* binding */ defaultFormData; },
/* harmony export */   "Nf": function() { return /* binding */ otherChoiceCode; },
/* harmony export */   "V0": function() { return /* binding */ getDefaultSurveyButtonWidgetSetting; },
/* harmony export */   "lf": function() { return /* binding */ otherChoiceType; }
/* harmony export */ });
/* harmony import */ var components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89433);
/* harmony import */ var components_business_CampaignBuilder_Distribution_When_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13625);
/* harmony import */ var components_business_CampaignBuilder_utils_getWidgetPosition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7695);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59845);
/* harmony import */ var utils_tempCode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78360);





var getDefaultTriggerConditions = function(channel) {
    switch(channel){
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Android */ .wQf.Android:
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift:
            return [];
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp:
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web:
            return [
                {
                    event: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignTriggerEvent.PageVisit */ .Yeg.PageVisit
                }
            ];
        default:
            return [
                {
                    event: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignTriggerEvent.PageVisit */ .Yeg.PageVisit
                }
            ];
    }
};
function getDefaultWidgetSetting() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web, campaignType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignType.Survey */ .mL.Survey;
    return {
        position: (0,components_business_CampaignBuilder_utils_getWidgetPosition__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(channel),
        type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetType.Popup */ .YMh.Popup,
        colorScheme: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultColorScheme */ .yi,
        customizedPosition: {
            align: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .Align.Right */ .xMy.Right,
            percentageToTop: 60
        },
        width: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultWidgetWidth */ .hU[campaignType]
    };
}
var defaultFormData = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web;
    return {
        name: "未命名问卷",
        type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignType.Survey */ .mL.Survey,
        token: "",
        enabled: false,
        formFields: [
            {
                code: (0,utils_tempCode__WEBPACK_IMPORTED_MODULE_4__/* .getTempCode */ .jg)(),
                page: 0,
                type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FormFieldType.NpsField */ .EIl.NpsField,
                label: "您是否愿意把我们推荐给身边的人？",
                ratingMax: 10,
                ratingMinDescription: "肯定不推荐",
                ratingMaxDescription: "肯定会推荐",
                validators: [
                    {
                        type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FieldValidatorType.Presence */ .GT9.Presence
                    }
                ],
                hidden: false,
                labelHidden: false
            },
            {
                code: (0,utils_tempCode__WEBPACK_IMPORTED_MODULE_4__/* .getTempCode */ .jg)(),
                label: "感谢您的反馈️",
                description: "<p>每一条反馈，都在帮助我们进步！</p>",
                page: 1,
                type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FormFieldType.EndingField */ .EIl.EndingField,
                content: "感谢您的反馈️",
                setting: {
                    endingContent: "感谢您的反馈️"
                },
                hidden: false,
                labelHidden: false
            }, 
        ],
        formSetting: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultFormSetting */ .wH,
        widget: getDefaultWidgetSetting(channel, types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignType.Survey */ .mL.Survey),
        targeting: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultTargeting */ .jp,
        trigger: {
            conditions: getDefaultTriggerConditions(channel),
            operator: components_business_CampaignBuilder_Distribution_When_constant__WEBPACK_IMPORTED_MODULE_1__/* .defaultTriggerOperator */ .zH
        },
        openStrategy: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultOpenStrategy */ .uP,
        localeSetting: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultLocaleSetting */ .CC,
        schedule: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultSchedule */ .r4
    };
};
var getDefaultSurveyButtonWidgetSetting = function(t) {
    return {
        autoOpen: false,
        buttonType: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetButtonType.Aside */ .UUk.Aside,
        icon: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetIcon.Comment */ .YQl.Comment,
        label: t("componentCampaignBuilder:styles.button.surveyDefaultLabel")
    };
};
var otherChoiceCode = "choiceOther";
var otherChoiceType = "OtherChoice";


/***/ }),

/***/ 22974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69777);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29718);





var VipIcon = function() {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
        name: "vip",
        style: {
            color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.5", theme)
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VipIcon);


/***/ }),

/***/ 91634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);

var useAccountSettingCache = function() {
    var ref, ref1, ref2;
    var ref3 = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useAccountBrandingConfigQuery */ .iSI)(), data = ref3.data, loading = ref3.loading;
    return {
        hideBranding: data === null || data === void 0 ? void 0 : (ref = data.account) === null || ref === void 0 ? void 0 : ref.setting.hideBranding,
        canHideBranding: data === null || data === void 0 ? void 0 : (ref1 = data.account) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.features) === null || ref2 === void 0 ? void 0 : ref2.includes(types_domain__WEBPACK_IMPORTED_MODULE_0__/* .Feature.HideBranding */ .L0B.HideBranding),
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAccountSettingCache);


/***/ }),

/***/ 19190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90309);
/* harmony import */ var utils_isServer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83845);



var useAccountSubscriptionCache = function() {
    var ref, ref1, ref2;
    var ref3 = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useAccountSubscriptionQuery */ .fgK)({
        skip: !utils_isServer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && !service__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSystemToken */ .Z.getSystemToken()
    }), data = ref3.data, loading = ref3.loading;
    return {
        account: data === null || data === void 0 ? void 0 : data.account,
        subscription: data === null || data === void 0 ? void 0 : (ref = data.account) === null || ref === void 0 ? void 0 : ref.subscription,
        vasBalance: data === null || data === void 0 ? void 0 : (ref1 = data.account) === null || ref1 === void 0 ? void 0 : ref1.vasBalance,
        features: data === null || data === void 0 ? void 0 : (ref2 = data.account) === null || ref2 === void 0 ? void 0 : ref2.features,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAccountSubscriptionCache);


/***/ }),

/***/ 51945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54594);



var useApplicationInfoBaseInfoCache = function() {
    var id = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query.appId;
    var data = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useApplicationBasicInfoQuery */ .if_)({
        skip: !id,
        variables: {
            id: id
        }
    }).data;
    var application = data === null || data === void 0 ? void 0 : data.application;
    var distribution = application === null || application === void 0 ? void 0 : application.distribution;
    var channel = distribution === null || distribution === void 0 ? void 0 : distribution.channel;
    var channelGroup = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        switch(channel){
            case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Web */ .wQf.Web:
                return "web";
            case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift:
            case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Android */ .wQf.Android:
                return "mobileApp";
            case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp:
                return "miniapp";
        }
    }, [
        channel
    ]);
    return {
        application: application,
        channel: channel,
        channelGroup: channelGroup,
        distribution: distribution
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useApplicationInfoBaseInfoCache);


/***/ }),

/***/ 86851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useApplicationRoleCache; }
/* harmony export */ });
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


function useApplicationRoleCache() {
    var ref;
    var id = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query.appId;
    var data = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useApplicationRoleQuery */ .nCR)({
        variables: {
            id: id
        },
        skip: !id
    }).data;
    return {
        applicationRole: data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.role
    };
}


/***/ }),

/***/ 88392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);

var useCampaignBaseInfoCache = function(id) {
    var data = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useCampaignBasicInfoQuery */ .HGp)({
        variables: {
            id: id
        }
    }).data;
    var campaign = data === null || data === void 0 ? void 0 : data.campaign;
    return {
        campaign: campaign
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCampaignBaseInfoCache);


/***/ }),

/***/ 47820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCampaignsCountCache; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46550);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95660);
/* harmony import */ var plugins_apollo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3745);






function useCampaignsCountCache(campaignType) {
    var ref, ref1;
    var appId = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query.appId;
    var ref2 = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useCampaignsCountQuery */ .Kx$)({
        variables: {
            id: appId,
            pageArguments: {
                first: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .PAGE_SIZE.NONE */ .IV.NONE
            },
            filter: {
                type: campaignType
            }
        }
    }), data = ref2.data, variables = ref2.variables;
    var client = (0,plugins_apollo__WEBPACK_IMPORTED_MODULE_3__/* .initializeApollo */ ["in"])();
    var updateFn = function(callbackFn) {
        client.cache.updateQuery({
            query: types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignsCountDocument */ .jum,
            variables: variables
        }, function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                application: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev.application), {
                    campaigns: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev.application.campaigns), {
                        totalCount: prev.application.campaigns.totalCount + callbackFn()
                    })
                })
            });
        });
    };
    var increase = function() {
        var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        updateFn(function() {
            return count;
        });
    };
    var decrease = function() {
        var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        updateFn(function() {
            return -count;
        });
    };
    return {
        count: data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : (ref1 = ref.campaigns) === null || ref1 === void 0 ? void 0 : ref1.totalCount,
        increase: increase,
        decrease: decrease
    };
}


/***/ }),

/***/ 35221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOnboardingCache; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17474);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46550);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_abac__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8470);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54594);
/* harmony import */ var plugins_apollo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3745);








function useOnboardingCache() {
    var ref;
    var appId = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query.appId;
    var userHasPermissions = (0,react_abac__WEBPACK_IMPORTED_MODULE_2__/* .useAbac */ .nn)().userHasPermissions;
    var hasOnboarding = userHasPermissions(types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationPermission.ApplicationDelete */ .eC6.ApplicationDelete);
    var client = (0,plugins_apollo__WEBPACK_IMPORTED_MODULE_4__/* .initializeApollo */ ["in"])();
    var data = (0,types_domain__WEBPACK_IMPORTED_MODULE_0__/* .useApplicationOnboardingQuery */ .JKf)({
        fetchPolicy: "cache-and-network",
        variables: {
            appId: (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().query.appId
        },
        skip: !hasOnboarding
    }).data;
    var onboarding = data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.onboarding;
    var pendingTasks = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!onboarding) {
            return [];
        }
        var campaignCreated = onboarding.campaignCreated, entryCollected = onboarding.entryCollected, memberInvited = onboarding.memberInvited, sdkSettingCompleted = onboarding.sdkSettingCompleted, sdkConnected = onboarding.sdkConnected;
        var mergedObj = {
            campaignCreated: campaignCreated,
            sdkCompleted: sdkSettingCompleted && sdkConnected,
            entryCollected: entryCollected,
            memberInvited: memberInvited
        };
        return Object.keys(mergedObj).filter(function(key) {
            return !mergedObj[key];
        });
    }, [
        data
    ]);
    var markTaskItemCompleted = function(item) {
        if (!onboarding) {
            return;
        }
        client.cache.modify({
            id: client.cache.identify({
                __typename: "Application",
                id: appId
            }),
            fields: {
                onboarding: function onboarding(prev) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item, true));
                }
            }
        });
    };
    return {
        onboarding: onboarding,
        pendingTasks: pendingTasks,
        markTaskItemCompleted: markTaskItemCompleted
    };
}


/***/ }),

/***/ 91404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xe": function() { return /* reexport */ AT_ALL_VALUE; },
  "gb": function() { return /* reexport */ Layouts_ApplicationLayout; },
  "xH": function() { return /* reexport */ Layouts_ApplicationSettingLayout; },
  "G4": function() { return /* reexport */ Campaign_BlankCampaigns; },
  "bi": function() { return /* reexport */ Entries; },
  "Cq": function() { return /* reexport */ Layout; },
  "Ir": function() { return /* reexport */ Campaign_List; },
  "lk": function() { return /* reexport */ CampaigTemplate_Categories; },
  "dQ": function() { return /* reexport */ CategoryTab; },
  "wk": function() { return /* reexport */ components_CaptchaCodeSendAndInput; },
  "_k": function() { return /* reexport */ components_CaptchaSender; },
  "JX": function() { return /* reexport */ ChannelPreview/* default */.Z; },
  "gH": function() { return /* reexport */ DEMO_WEBHOOK_ENTRY_ID; },
  "tS": function() { return /* reexport */ Filter_DefaultFilter; },
  "aG": function() { return /* reexport */ DeliveryUrl/* default */.Z; },
  "bL": function() { return /* reexport */ Content["default"]; },
  "qO": function() { return /* reexport */ Campaign_DistributionAffectionIndicator; },
  "lL": function() { return /* reexport */ DistributionReview/* default */.Z; },
  "T2": function() { return /* reexport */ EntryIcon/* default */.Z; },
  "i0": function() { return /* reexport */ FeatureTip/* default */.Z; },
  "nl": function() { return /* reexport */ FeatureUnavailable/* FeatureUnavailableAlert */.n; },
  "Av": function() { return /* reexport */ FeatureUnavailable/* FeatureUnavailableIcon */.A; },
  "fw": function() { return /* reexport */ business_FieldIcon; },
  "h4": function() { return /* reexport */ Campaign_Header; },
  "xz": function() { return /* reexport */ HelpDoc/* default */.Z; },
  "Ud": function() { return /* reexport */ components_IdentifierInput; },
  "wA": function() { return /* reexport */ business_ImageUploader; },
  "pK": function() { return /* reexport */ business_MTextarea; },
  "zv": function() { return /* reexport */ OnboardingLayout/* default */.Z; },
  "H9": function() { return /* reexport */ components_PasswordInputStep; },
  "X2": function() { return /* reexport */ business_SdkOnboarding; },
  "XP": function() { return /* reexport */ Layouts_SimpleLayout; },
  "Eg": function() { return /* reexport */ Campaign_StatusIndicator; },
  "St": function() { return /* reexport */ business_SurveyTemplatePreview; },
  "lZ": function() { return /* reexport */ business_UrlFilter; },
  "ZN": function() { return /* reexport */ VipIcon/* default */.Z; },
  "Me": function() { return /* reexport */ AddButton; },
  "Pv": function() { return /* reexport */ Integration_BuilderModal; },
  "HP": function() { return /* reexport */ Integration_ChannelIcon; },
  "Ez": function() { return /* reexport */ areConditionGroupsEqual; },
  "Ql": function() { return /* reexport */ categoriesIcons; },
  "Ue": function() { return /* reexport */ filterEmptyCondition; },
  "D$": function() { return /* reexport */ orderedWebhookChannels; },
  "$d": function() { return /* reexport */ useApplicationSceneAttributes; },
  "L9": function() { return /* reexport */ Campaign_hooks/* useCampaignPermission */.L9; },
  "wf": function() { return /* reexport */ Campaign_hooks/* useCampaignStatusSwitch */.wf; },
  "r$": function() { return /* reexport */ Campaign_hooks/* useCheckCampaignPermission */.r$; },
  "KX": function() { return /* reexport */ Campaign_hooks/* useCheckCreateCampaign */.KX; },
  "RN": function() { return /* reexport */ Campaign_hooks/* useCheckCreateSurveyByAi */.RN; },
  "xu": function() { return /* reexport */ useCheckFeature; },
  "zT": function() { return /* reexport */ Campaign_hooks/* useDeleteCampaign */.zT; },
  "EC": function() { return /* reexport */ Campaign_hooks/* useDuplicateCampaignModal */.EC; },
  "YJ": function() { return /* reexport */ Campaign_hooks/* useEditCampaignGroupsModal */.YJ; },
  "sY": function() { return /* reexport */ hooks_useEnterBlurSelect; },
  "$5": function() { return /* reexport */ useFormValidations; },
  "K1": function() { return /* reexport */ useFormatCondition; },
  "Mt": function() { return /* reexport */ useGetApplicationCustomerAttributes; },
  "LI": function() { return /* reexport */ useGetApplicationSceneAttributeValues; },
  "zy": function() { return /* reexport */ GlobalErrorBoundary/* useGlobalError */.zy; },
  "qD": function() { return /* reexport */ usePeriodTypes/* default */.Z; },
  "lf": function() { return /* reexport */ useSendWebhookDemo; },
  "W5": function() { return /* reexport */ useVipColor; },
  "hB": function() { return /* reexport */ useWebhookHistoriesModal; },
  "PQ": function() { return /* reexport */ useWebhookSuspendedDetailModal; }
});

// UNUSED EXPORTS: DEMO_WEBHOOK_CAMPAIGN_ID, DateOperator, FieldFilterPopover, TestProvider, TimePeriod, orderedCategories, useEnterBlurMultiSelect, webhookNameMaxLength

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(65149);
// EXTERNAL MODULE: ./node_modules/.pnpm/immutability-helper@3.1.1/node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(89887);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(68844);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNumber.js
var isNumber = __webpack_require__(47852);
// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/Operator/operatorUtils.ts

function isPresentOperator(operator) {
    return [
        domain/* ConditionOperator.IsNull */.N0$.IsNull,
        domain/* ConditionOperator.IsNotNull */.N0$.IsNotNull
    ].includes(operator);
}
function getOperatorLabel(operator, t) {
    var isOptionIncludedOrExcluded = [
        domain/* ConditionOperator.Include */.N0$.Include,
        domain/* ConditionOperator.Exclude */.N0$.Exclude
    ].includes(operator);
    return t(isOptionIncludedOrExcluded ? "componentConditionGroup:conditionOperatorPatch.".concat(operator) : "componentConditionGroup:conditionOperator.".concat(operator));
}

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/scripts/filterEmptyCondition.ts



function filterEmptyCondition(result) {
    var ref;
    var validateSecondNodeValue = function(value, operator) {
        if (isPresentOperator(operator)) {
            return true;
        }
        if ((0,isArray/* default */.Z)(value)) {
            if ((0,isEmpty/* default */.Z)(value)) {
                return false;
            }
            return value.every(function(item) {
                return isValid(item);
            });
        }
        return isValid(value);
    };
    return immutability_helper_default()(result, {
        conditions: {
            $set: (ref = result.conditions) === null || ref === void 0 ? void 0 : ref.filter(function(condition) {
                var ref, ref1;
                return condition && validateSecondNodeValue((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value, condition.operator) && !(0,isEmpty/* default */.Z)((ref1 = condition.firstNode) === null || ref1 === void 0 ? void 0 : ref1.value) && !(0,isEmpty/* default */.Z)(condition.operator);
            })
        }
    });
}
var isValid = function(value) {
    return !(0,isEmpty/* default */.Z)(value) || (0,isNumber/* default */.Z)(value);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/range.js + 2 modules
var range = __webpack_require__(57936);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/scripts/formatFields.ts

function genNumberOptions(numbers) {
    return numbers.map(function(item) {
        return {
            label: item,
            value: item
        };
    });
}
function calcChoices(field) {
    var type = field.type, ratingMax = field.ratingMax, choices = field.choices;
    if ([
        "RatingField",
        "CsatField"
    ].includes(type) && (0,isNil/* default */.Z)(choices)) {
        return genNumberOptions((0,range/* default */.Z)(1, ratingMax + 1));
    }
    if (type === "NpsField" && (0,isNil/* default */.Z)(choices)) {
        return genNumberOptions((0,range/* default */.Z)(ratingMax + 1));
    }
    return choices !== null && choices !== void 0 ? choices : [];
}
function formatFields(fields) {
    return fields === null || fields === void 0 ? void 0 : fields.map(function(field) {
        var code = field.code, label = field.label, type = field.type, statements = field.statements;
        return {
            code: code,
            label: label,
            type: type,
            choices: calcChoices(field),
            statements: statements
        };
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/omit-deep-lodash@1.1.7/node_modules/omit-deep-lodash/lib/index.js
var lib = __webpack_require__(76190);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(96634);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17474);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/constants.ts
var constants = __webpack_require__(83960);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/ConditionGroup/conditionGroupReducer.ts





function conditionGroupReducer(state, action) {
    switch(action.type){
        case "addCondition":
            {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    conditions: immutability_helper_default()(state.conditions, {
                        $push: action.condition ? [
                            action.condition
                        ] : constants/* defaultConditions */.o7
                    })
                });
            }
        case "removeCondition":
            {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    conditions: immutability_helper_default()(state.conditions, {
                        $splice: [
                            [
                                action.index,
                                1
                            ]
                        ]
                    })
                });
            }
        case "conditionGroupOperatorChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                operator: action.value
            });
        case "firstNodeChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                conditions: immutability_helper_default()(state.conditions, (0,_define_property/* default */.Z)({}, action.index, {
                    $set: {
                        firstNode: action.firstNode,
                        operator: undefined,
                        secondNode: undefined
                    }
                }))
            });
        case "firstNodeErrorChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                conditions: immutability_helper_default()(state.conditions, (0,_define_property/* default */.Z)({}, action.index, {
                    $set: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.conditions[action.index]), {
                        firstNode: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.conditions[action.index].firstNode), {
                            error: action.error
                        })
                    })
                }))
            });
        case "conditionOperatorChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                conditions: immutability_helper_default()(state.conditions, (0,_define_property/* default */.Z)({}, action.index, {
                    $set: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.conditions[action.index]), {
                        operator: action.value,
                        secondNode: undefined
                    })
                }))
            });
        case "secondNodeChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                conditions: immutability_helper_default()(state.conditions, (0,_define_property/* default */.Z)({}, action.index, {
                    $set: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.conditions[action.index]), {
                        secondNode: action.secondNode
                    })
                }))
            });
        default:
            return state;
    }
}

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/ConditionGroup/ConditionGroupContext.tsx





var ConditionGroupContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var compareIgnoreKeys = [
    "__typename",
    "error"
];
function ConditionGroupProvider(param) {
    var defaultValue = param.defaultValue, onChange = param.onChange, children = param.children;
    var ref = (0,react.useReducer)(conditionGroupReducer, {
        operator: defaultValue.operator,
        conditions: defaultValue.conditions
    }), state = ref[0], dispatch = ref[1];
    (0,react.useEffect)(function() {
        if (!(0,isEqual/* default */.Z)(lib_default()(state, compareIgnoreKeys), lib_default()(defaultValue, compareIgnoreKeys))) {
            onChange(state);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state
    ]);
    var value = {
        state: state,
        dispatch: dispatch
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionGroupContext.Provider, {
        value: value,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/ConditionGroup/useConditionGroup.ts


function useConditionGroup() {
    var context = (0,react.useContext)(ConditionGroupContext);
    if (context === undefined) {
        throw new Error("useConditionGroup must be used within a ConditionGroupProvider");
    }
    return context;
}

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/ConditionGroup/index.ts



// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(68711);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(22108);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Select/Select.js + 2 modules
var Select = __webpack_require__(41754);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/ConditionGroupOperator/ConditionGroupOperatorSelector.tsx






var ConditionGroupOperatorSelector = function(props) {
    var t = (0,useTranslation/* default */.Z)("componentConditionGroup").t;
    var data = [
        {
            value: domain/* ConditionGroupOperator.And */.ZOu.And,
            label: t("conditionGroupOperator.andOptionLabel")
        },
        {
            value: domain/* ConditionGroupOperator.Or */.ZOu.Or,
            label: t("conditionGroupOperator.orOptionLabel")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        data: data,
        styles: function() {
            return {
                root: {
                    display: "inline-block"
                },
                input: {
                    display: "inline-block",
                    width: "60px",
                    height: "24px",
                    minHeight: "24px",
                    padding: "0px 8px",
                    borderRadius: "4px",
                    lineHeight: "24px"
                },
                rightSection: {
                    width: "24px"
                },
                dropdown: {
                    borderRadius: "4px"
                }
            };
        }
    }));
};
/* harmony default export */ var ConditionGroupOperator_ConditionGroupOperatorSelector = (ConditionGroupOperatorSelector);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/ConditionGroupOperator/index.tsx






var ConditionGroupOperator = function() {
    var t = (0,useTranslation/* default */.Z)("componentConditionGroup").t;
    var ref = useConditionGroup(), operator = ref.state.operator, dispatch = ref.dispatch;
    var handleChange = function(value) {
        dispatch({
            type: "conditionGroupOperatorChange",
            value: value
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-[18px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mt: "md",
                color: "dimmed",
                span: true,
                className: "mr-xs",
                children: t("conditionGroupOperator.prefix")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionGroupOperator_ConditionGroupOperatorSelector, {
                value: operator,
                onChange: handleChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mt: "md",
                color: "dimmed",
                span: true,
                className: "ml-xs",
                children: t("conditionGroupOperator.suffix")
            })
        ]
    });
};
/* harmony default export */ var DefaultFilter_ConditionGroupOperator = (ConditionGroupOperator);

// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/DataContext.ts
var DataContext = __webpack_require__(56436);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(13192);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Grid/Grid.js + 4 modules
var Grid = __webpack_require__(74969);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Input/Input.js + 11 modules
var Input = __webpack_require__(2000);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconTrash.js
var IconTrash = __webpack_require__(58382);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/RemoveCondition/index.tsx





var RemoveCondition = function(param) {
    var index = param.index;
    var dispatch = useConditionGroup().dispatch;
    var handleRemoveClick = function() {
        dispatch({
            type: "removeCondition",
            index: index
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
        onClick: handleRemoveClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* default */.Z, {
            size: 16
        })
    });
};
/* harmony default export */ var DefaultFilter_RemoveCondition = (RemoveCondition);

// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/ConditionContext.tsx
var ConditionContext = __webpack_require__(24171);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(70426);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var theme_MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/clone.js
var clone = __webpack_require__(45093);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/find.js + 2 modules
var find = __webpack_require__(91955);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/FirstNode/getOptions.ts


function getStaticOptions(fields) {
    return fields.map(function(item) {
        return {
            value: item.code,
            label: item.label,
            type: item.type,
            group: item.group
        };
    });
}
function getDynamicOptions(firstNodeFields) {
    return firstNodeFields.map(function(field) {
        return {
            id: field === null || field === void 0 ? void 0 : field.id,
            value: field.code,
            label: field.label,
            group: field.group
        };
    });
}
function useOptions(shadowFirstNodeFields) {
    var ref = (0,react.useContext)(DataContext/* default */.Z), fields = ref.fields, dynamic = ref.dynamic;
    return (0,react.useMemo)(function() {
        return dynamic ? getDynamicOptions(shadowFirstNodeFields) : getStaticOptions(fields);
    }, [
        dynamic,
        fields,
        shadowFirstNodeFields
    ]);
}

// EXTERNAL MODULE: ./src/config/constants/index.ts + 9 modules
var config_constants = __webpack_require__(95660);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/concat.js
var concat = __webpack_require__(35030);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/router.js
var next_router = __webpack_require__(73654);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./src/components/business/hooks/useGetApplicationCustomerAttributes.ts





function useGetApplicationCustomerAttributes() {
    var ref, ref1;
    var t = (0,useTranslation/* default */.Z)("customer").t;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var ref2 = (0,domain/* useApplicationCustomerAttributesQuery */.veP)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: appId,
            pageArguments: {
                first: config_constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        }
    }), data = ref2.data, loading = ref2.loading;
    var ref3;
    var attributes = (ref3 = data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : (ref1 = ref.applicationCustomerAttributes) === null || ref1 === void 0 ? void 0 : ref1.nodes) !== null && ref3 !== void 0 ? ref3 : [];
    var defaultCustomerAttributes = getDefaultCustomerAttributes(t);
    return loading ? [] : (0,concat/* default */.Z)(defaultCustomerAttributes, attributes);
}
var getDefaultCustomerAttributes = function(t) {
    return [
        {
            displayName: t("customer:customer_uid"),
            aliases: [
                "uid"
            ],
            code: "uid",
            readonly: true
        },
        {
            displayName: t("customer:customer_name"),
            aliases: [
                "name"
            ],
            code: "name",
            readonly: true
        },
        {
            displayName: t("customer:customer_mobile"),
            aliases: [
                "mobile"
            ],
            code: "mobile",
            readonly: true
        },
        {
            displayName: t("customer:customer_email"),
            aliases: [
                "email"
            ],
            code: "email",
            readonly: true
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/components/business/hooks/useApplicationSceneAttributes.ts



function useApplicationSceneAttributes() {
    var ref;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var data = (0,domain/* useApplicationSceneAttributesQuery */.v9t)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: appId,
            pageArguments: {
                first: config_constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        }
    }).data;
    var _nodes;
    return (_nodes = data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.applicationSceneAttributes.nodes) !== null && _nodes !== void 0 ? _nodes : [];
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(17192);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.0/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(33481);
// EXTERNAL MODULE: ./src/plugins/apollo/index.tsx
var apollo = __webpack_require__(3745);
;// CONCATENATED MODULE: ./src/components/business/hooks/useGetApplicationSceneAttributeValues.ts






function useGetApplicationSceneAttributeValues() {
    var router = (0,next_router.useRouter)();
    var applicationId = router.query.appId;
    return function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(idOrAliasOrCode, keyword) {
            var data, _nodes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,apollo/* initializeApollo */["in"])().query({
                                query: domain/* ApplicationSceneAttributeValuesDocument */.qNy,
                                fetchPolicy: "network-only",
                                variables: {
                                    idOrAliasOrCode: idOrAliasOrCode,
                                    applicationId: applicationId,
                                    keyword: keyword,
                                    pageArguments: {
                                        first: config_constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
                                    }
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            (_nodes = data === null || data === void 0 ? void 0 : data.applicationSceneAttribute.values.nodes) !== null && _nodes !== void 0 ? _nodes : []
                        ];
                }
            });
        });
        return function(idOrAliasOrCode, keyword) {
            return _ref.apply(this, arguments);
        };
    }();
}

// EXTERNAL MODULE: ./src/config/constants/products.ts
var products = __webpack_require__(52762);
;// CONCATENATED MODULE: ./src/components/business/hooks/useVipColor.ts



function useVipColor() {
    var colors = (0,theme_MantineProvider/* useMantineTheme */.rZ)().colors;
    var _obj;
    var vipColorMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* ProductCode.Free */.G.Free, colors.gray[5]), (0,_define_property/* default */.Z)(_obj, products/* ProductCode.Basic */.G.Basic, colors.blue[6]), (0,_define_property/* default */.Z)(_obj, products/* ProductCode.Pro */.G.Pro, colors.yellow[6]), (0,_define_property/* default */.Z)(_obj, products/* ProductCode.Ultimate */.G.Ultimate, colors.orange[6]), (0,_define_property/* default */.Z)(_obj, products/* ProductCode.Trial */.G.Trial, colors.blue[6]), _obj);
    return function(productCode) {
        return vipColorMap[productCode];
    };
}

// EXTERNAL MODULE: ./src/components/business/hooks/useAccountSubscriptionCache.ts
var useAccountSubscriptionCache = __webpack_require__(19190);
;// CONCATENATED MODULE: ./src/components/business/hooks/useCheckFeature.ts


function useCheckFeature(defaultForLoading) {
    var ref = (0,useAccountSubscriptionCache/* default */.Z)(), features = ref.features, loading = ref.loading;
    var cacheFeatures = features !== null && features !== void 0 ? features : [];
    return function(feature, features) {
        if (!(0,isNil/* default */.Z)(defaultForLoading) && loading) {
            return defaultForLoading;
        }
        return (features !== null && features !== void 0 ? features : cacheFeatures).includes(feature);
    };
}

// EXTERNAL MODULE: ./src/utils/keyboardUtils.ts
var keyboardUtils = __webpack_require__(17975);
// EXTERNAL MODULE: ./src/utils/index.ts + 8 modules
var utils = __webpack_require__(73046);
;// CONCATENATED MODULE: ./src/components/business/hooks/useEnterBlurSelect.ts



var useEnterBlurSelect = function(onCallback) {
    var ref = (0,react.useRef)(null);
    var handleKeyDown = function(event) {
        if (!(0,keyboardUtils/* isEnter */.t)(event)) {
            return;
        }
        updateCreateValue();
    };
    var updateCreateValue = function() {
        var ref1;
        var value = (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.value;
        if ((0,utils/* isBlank */.fp)(value)) {
            return;
        }
        onCallback && onCallback(value.trim());
    };
    return {
        ref: ref,
        handleKeyDown: handleKeyDown,
        handleBlur: updateCreateValue
    };
};
/* harmony default export */ var hooks_useEnterBlurSelect = (useEnterBlurSelect);

;// CONCATENATED MODULE: ./src/components/business/hooks/useEnterBlurMultiSelect.ts



var useEnterBlurMultiSelect = function(onCallback) {
    var ref = (0,react.useState)(undefined), searchValue = ref[0], onSearchChange = ref[1];
    var handleKeyDown = function(event) {
        if (!(0,keyboardUtils/* isEnter */.t)(event)) {
            return;
        }
        updateCreateValue();
    };
    var updateCreateValue = function() {
        if ((0,utils/* isBlank */.fp)(searchValue)) {
            return;
        }
        onCallback && onCallback(searchValue.trim());
        onSearchChange("");
    };
    return {
        searchValue: searchValue,
        onSearchChange: onSearchChange,
        handleKeyDown: handleKeyDown,
        handleBlur: updateCreateValue
    };
};
/* harmony default export */ var hooks_useEnterBlurMultiSelect = (useEnterBlurMultiSelect);

;// CONCATENATED MODULE: ./src/components/business/hooks/index.ts








;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/FirstNode/index.tsx












var FirstNode = function(param) {
    var hideErrorMsg = param.hideErrorMsg;
    var ref, ref1, ref2, ref3;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref4 = (0,react.useContext)(ConditionContext/* default */.Z), index = ref4.index, condition = ref4.condition;
    var ref5 = (0,react.useContext)(DataContext/* default */.Z), dynamic = ref5.dynamic, firstNode = ref5.firstNode;
    var ref6 = hooks_useEnterBlurSelect(function(createValue) {
        if (!condition.firstNode.error) {
            var matchedOptionValue = options.find(function(param) {
                var label = param.label;
                return label === createValue;
            });
            if (matchedOptionValue) {
                handleChange(matchedOptionValue.value);
            } else {
                handleChange(createValue);
            }
        }
    }), ref7 = ref6.ref, handleKeyDown = ref6.handleKeyDown, handleBlur = ref6.handleBlur;
    var firstNodeFields = firstNode.fields, labelIsExists = firstNode.labelIsExists, getCreateLabel = firstNode.getCreateLabel, getFieldType = firstNode.getFieldType, onFirstNodeChange = firstNode.onFirstNodeChange, rules = firstNode.rules;
    var ref8 = (0,react.useState)(firstNodeFields !== null && firstNodeFields !== void 0 ? firstNodeFields : []), shadowFirstNodeFields = ref8[0], setShadowFirstNodeFields = ref8[1];
    var dispatch = useConditionGroup().dispatch;
    (0,react.useEffect)(function() {
        var ref;
        var copyFields = (0,clone/* default */.Z)(firstNodeFields);
        if (!(0,isNil/* default */.Z)(condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.value)) {
            var ref1;
            var selectValue = condition === null || condition === void 0 ? void 0 : (ref1 = condition.firstNode) === null || ref1 === void 0 ? void 0 : ref1.value;
            var isExisted = copyFields === null || copyFields === void 0 ? void 0 : copyFields.some(function(field) {
                return field.code === selectValue;
            });
            if (!isExisted) {
                var item = {
                    code: selectValue,
                    label: selectValue
                };
                copyFields === null || copyFields === void 0 ? void 0 : copyFields.unshift(item);
            }
        }
        setShadowFirstNodeFields(copyFields !== null && copyFields !== void 0 ? copyFields : []);
    }, [
        condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.value,
        firstNodeFields
    ]);
    var options = useOptions(shadowFirstNodeFields !== null && shadowFirstNodeFields !== void 0 ? shadowFirstNodeFields : []);
    var calcFieldType = function(value) {
        return (0,isEmpty/* default */.Z)(value) ? undefined : getFieldType === null || getFieldType === void 0 ? void 0 : getFieldType(value);
    };
    var handleChange = (0,react.useCallback)(function(value) {
        var ref;
        if ((condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.value) !== value) {
            var selected = (0,find/* default */.Z)(shadowFirstNodeFields, {
                code: value
            });
            var ref1;
            dispatch({
                type: "firstNodeChange",
                index: index,
                firstNode: {
                    value: value,
                    label: (ref1 = selected === null || selected === void 0 ? void 0 : selected.label) !== null && ref1 !== void 0 ? ref1 : value,
                    type: selected ? selected.type : calcFieldType(value),
                    error: undefined
                }
            });
            if (dynamic) {
                onFirstNodeChange === null || onFirstNodeChange === void 0 ? void 0 : onFirstNodeChange(selected);
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        condition === null || condition === void 0 ? void 0 : (ref1 = condition.firstNode) === null || ref1 === void 0 ? void 0 : ref1.value,
        shadowFirstNodeFields,
        index,
        dynamic,
        calcFieldType
    ]);
    var handleCreate = function(search) {
        var query = search.trim();
        setShadowFirstNodeFields(function(current) {
            return (0,_to_consumable_array/* default */.Z)(current).concat([
                {
                    code: query,
                    label: query,
                    type: calcFieldType(query)
                }
            ]);
        });
        return {
            value: query,
            label: query
        };
    };
    var shouldCreate = (0,react.useCallback)(function(search, data) {
        var query = search.trim();
        var isExisted = labelIsExists ? labelIsExists(query, data) : data === null || data === void 0 ? void 0 : data.some(function(param) {
            var label = param.label;
            return label === query;
        });
        if (!(0,isEmpty/* default */.Z)(rules) && !(0,isEmpty/* default */.Z)(query)) {
            var firstItemError = rules === null || rules === void 0 ? void 0 : rules.find(function(param) {
                var regex = param.regex;
                return !(regex === null || regex === void 0 ? void 0 : regex.test(query));
            });
            var error = firstItemError && !isExisted ? firstItemError === null || firstItemError === void 0 ? void 0 : firstItemError.message : undefined;
            if (error !== condition.firstNode.error) {
                setTimeout(function() {
                    dispatch({
                        type: "firstNodeErrorChange",
                        index: index,
                        error: error
                    });
                }, 300);
            }
            return (0,isNil/* default */.Z)(firstItemError) && !isExisted;
        }
        return !isExisted && !(0,isEmpty/* default */.Z)(query);
    }, [
        condition.firstNode.error,
        index,
        rules
    ]);
    var error = condition === null || condition === void 0 ? void 0 : (ref2 = condition.firstNode) === null || ref2 === void 0 ? void 0 : ref2.error;
    var ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
        ref: ref7,
        allowDeselect: false,
        creatable: !!getCreateLabel,
        searchable: true,
        clearable: true,
        data: options,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        defaultValue: (ref9 = condition === null || condition === void 0 ? void 0 : (ref3 = condition.firstNode) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref9 !== void 0 ? ref9 : null,
        placeholder: t("placeholders.pleaseSelect"),
        onChange: handleChange,
        shouldCreate: shouldCreate,
        // @ts-ignore
        getCreateLabel: getCreateLabel,
        onCreate: handleCreate,
        error: error && hideErrorMsg ? " " : error,
        filter: function(value, item) {
            return !!item.value && item.value.toLowerCase().includes(value.toLowerCase().trim()) || !!item.label && item.label.toLowerCase().includes(value.toLowerCase().trim());
        },
        styles: {
            separatorLabel: {
                color: "".concat((0,getColor/* getTextColor */.uu)("gray.6", theme), " !important")
            }
        }
    });
};
/* harmony default export */ var Conditions_FirstNode = (/*#__PURE__*/(0,react.memo)(FirstNode));

// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/Operator/getOperatorOptions.ts
var getOperatorOptions = __webpack_require__(14418);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/Operator/index.tsx









var Operator = function() {
    var ref;
    var ref1 = (0,react.useContext)(ConditionContext/* default */.Z), index = ref1.index, condition = ref1.condition;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var dispatch = useConditionGroup().dispatch;
    var options = (0,getOperatorOptions/* default */.ZP)();
    var selectOptions = (0,react.useMemo)(function() {
        return (options === null || options === void 0 ? void 0 : options.map(function(option) {
            return {
                value: option,
                label: getOperatorLabel(option, t)
            };
        })) || [];
    }, [
        options,
        t
    ]);
    var defaultOperator = (0,react.useMemo)(function() {
        var ref;
        return (condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.value) ? selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions[0].value : null;
    }, [
        condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.value,
        selectOptions
    ]);
    var handleChange = (0,react.useCallback)(function(value) {
        dispatch({
            type: "conditionOperatorChange",
            index: index,
            value: value
        });
    }, [
        dispatch,
        index
    ]);
    (0,react.useEffect)(function() {
        if (!(0,isNil/* default */.Z)(defaultOperator) && (0,isNil/* default */.Z)(condition === null || condition === void 0 ? void 0 : condition.operator)) {
            handleChange(defaultOperator);
        }
    }, [
        condition === null || condition === void 0 ? void 0 : condition.operator,
        defaultOperator,
        handleChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
        placeholder: t("placeholders.pleaseSelect"),
        data: selectOptions,
        value: condition === null || condition === void 0 ? void 0 : condition.operator,
        onChange: handleChange
    });
};
/* harmony default export */ var Conditions_Operator = (/*#__PURE__*/(0,react.memo)(Operator));

// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/Distribution/Who/constant.ts
var constant = __webpack_require__(71870);
// EXTERNAL MODULE: ./src/components/business/Customer/CustomerSegmentSelector/index.tsx
var CustomerSegmentSelector = __webpack_require__(83629);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/CustomerSegmentNode.tsx





var CustomerSegmentNode = function(props) {
    var ref;
    var onChange = props.onChange;
    var condition = (0,react.useContext)(ConditionContext/* default */.Z).condition;
    var secondNodeValue = condition === null || condition === void 0 ? void 0 : (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value;
    var currentValue = (0,react.useMemo)(function() {
        return secondNodeValue ? (0,isArray/* default */.Z)(secondNodeValue) ? secondNodeValue : [
            secondNodeValue
        ] : [];
    }, [
        secondNodeValue
    ]);
    var handleChange = function(value) {
        var _secondNode;
        var ref = (_secondNode = condition.secondNode) !== null && _secondNode !== void 0 ? _secondNode : {}, originValue = ref.value;
        if (value !== originValue) {
            onChange({
                value: value,
                error: undefined
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerSegmentSelector/* default */.Z, {
        value: currentValue,
        onChange: handleChange
    });
};
/* harmony default export */ var SecondNode_CustomerSegmentNode = (/*#__PURE__*/(0,react.memo)(CustomerSegmentNode));

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(76452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+dates@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_dayjs@1.11.6_react@18.2.0/node_modules/@mantine/dates/esm/components/DatePickerInput/DatePickerInput.js + 3 modules
var DatePickerInput = __webpack_require__(47355);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(47142);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.11.6/node_modules/dayjs/locale/zh-cn.js
var zh_cn = __webpack_require__(41661);
// EXTERNAL MODULE: ./src/components/business/Filter/DefaultFilter/hooks/usePeriodTypes.ts
var usePeriodTypes = __webpack_require__(41854);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/DateSelector.tsx













var DateSelector = function(props) {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var onChange = props.onChange;
    var ref = (0,react.useContext)(ConditionContext/* default */.Z), secondNode = ref.condition.secondNode;
    var getPeriodOptions = (0,usePeriodTypes/* default */.Z)().getPeriodOptions;
    var isCustomizedDate = (0,isNil/* default */.Z)(secondNode === null || secondNode === void 0 ? void 0 : secondNode.type) || (0,isNil/* default */.Z)(secondNode === null || secondNode === void 0 ? void 0 : secondNode.value) || (secondNode === null || secondNode === void 0 ? void 0 : secondNode.type) === domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate;
    var currentType = isCustomizedDate ? domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate : secondNode === null || secondNode === void 0 ? void 0 : secondNode.value;
    var currentValue = isCustomizedDate && (secondNode === null || secondNode === void 0 ? void 0 : secondNode.value) ? (0,parseISO/* default */.Z)(secondNode.value) : null;
    var handleTypeChange = function(type) {
        if (type === domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate) {
            onChange({
                value: "",
                type: type
            });
        } else {
            onChange({
                value: type,
                type: domain/* ConditionNodeType.Period */.BAL.Period
            });
        }
    };
    var handleDateChange = function(date) {
        onChange({
            value: date ? (0,utils/* formatISODATE */.ZV)(date) : "",
            type: currentType !== null && currentType !== void 0 ? currentType : domain/* ConditionNodeType.CustomizedDate */.BAL.CustomizedDate
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        grow: true,
        spacing: 8,
        align: "top",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
                placeholder: t("placeholders.pleaseSelect"),
                data: getPeriodOptions(),
                value: currentType,
                onChange: handleTypeChange
            }),
            isCustomizedDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerInput/* DatePickerInput */.a, {
                clearable: true,
                valueFormat: config_constants/* DATE_FORMAT_FOR_DAYJS */.yl,
                placeholder: t("placeholders.pleaseSelect"),
                onChange: handleDateChange,
                locale: "zh-cn",
                value: currentValue,
                error: secondNode === null || secondNode === void 0 ? void 0 : secondNode.error
            })
        ]
    });
};
/* harmony default export */ var SecondNode_DateSelector = (DateSelector);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(25328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/MultiSelect/MultiSelect.js + 4 modules
var MultiSelect = __webpack_require__(54253);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(98558);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/uniq.js
var uniq = __webpack_require__(83776);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/size.js
var size = __webpack_require__(33370);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/includes.js
var includes = __webpack_require__(24062);
// EXTERNAL MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/constants.ts
var Filter_constants = __webpack_require__(10872);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-debounced-value/use-debounced-value.js
var use_debounced_value = __webpack_require__(96387);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(61843);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(73268);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Space/Space.js
var Space = __webpack_require__(7339);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Textarea/Textarea.js + 5 modules
var Textarea = __webpack_require__(7880);
;// CONCATENATED MODULE: ./src/components/business/MTextarea/index.tsx







var MTextarea = function(props) {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var value = props.value, onChange = props.onChange, maxRows = props.maxRows, minRows = props.minRows, placeholder = props.placeholder, _maxsize = props.maxsize, maxsize = _maxsize === void 0 ? 1000 : _maxsize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        sx: function(theme) {
            return {
                border: "1px solid ".concat(theme.colors.gray[3]),
                borderRadius: "".concat(theme.radius.sm)
            };
        },
        pb: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* Textarea */.g, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                variant: "unstyled"
            }, props), {
                value: value.join("\n"),
                placeholder: placeholder,
                maxRows: maxRows,
                minRows: minRows,
                error: (0,size/* default */.Z)(value) > maxsize ? t("common:batchEdit.maxsizeError", {
                    maxsize: maxsize
                }) : null,
                onChange: function(e) {
                    return onChange === null || onChange === void 0 ? void 0 : onChange(e.currentTarget.value.split("\n"));
                },
                styles: function(theme) {
                    return {
                        input: {
                            padding: "".concat(theme.spacing.sm, " !important")
                        }
                    };
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "xs",
                color: "dimmed",
                className: "self-end",
                mr: "sm",
                children: t("common:batchEdit.sizeTips", {
                    size: (0,size/* default */.Z)(value),
                    maxsize: maxsize
                })
            })
        ]
    });
};
/* harmony default export */ var business_MTextarea = (MTextarea);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/compact.js
var compact = __webpack_require__(59774);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/trim.js + 2 modules
var trim = __webpack_require__(4745);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/BatchEditor.tsx








var MAXSIZE = 30000;
var BatchEditor = function(param) {
    var value = param.value, onSave = param.onSave, onClose = param.onClose;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref1 = (0,react.useState)(value), currentValue = ref1[0], setCurrentValue = ref1[1];
    var condition = (0,react.useContext)(ConditionContext/* default */.Z).condition;
    var secondNodeValue = condition === null || condition === void 0 ? void 0 : (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value;
    (0,react.useEffect)(function() {
        setCurrentValue(secondNodeValue ? (0,isArray/* default */.Z)(secondNodeValue) ? secondNodeValue : [
            secondNodeValue
        ] : []);
    }, [
        secondNodeValue
    ]);
    var handleSave = function() {
        onClose();
        onSave((0,uniq/* default */.Z)((0,compact/* default */.Z)(currentValue.map(function(item) {
            return (0,trim/* default */.Z)(item);
        }))));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
            size: "lg",
            opened: true,
            onClose: onClose,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 4,
                children: t("common:batchEdit.title")
            }),
            closeOnClickOutside: false,
            closeOnEscape: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    c: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                    children: t("common:batchEdit.desc", {
                        maxsize: MAXSIZE
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Space/* Space */.T, {
                    h: "sm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_MTextarea, {
                    maxsize: MAXSIZE,
                    minRows: 10,
                    maxRows: 10,
                    value: currentValue,
                    onChange: setCurrentValue,
                    placeholder: t("common:batchEdit.placeholder")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Space/* Space */.T, {
                    h: "xl"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: handleSave,
                            disabled: (0,size/* default */.Z)(currentValue) > MAXSIZE,
                            color: "brandBlue.6",
                            children: t("common:actions.confirm")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "default",
                            onClick: onClose,
                            children: t("common:actions.cancel")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SecondNode_BatchEditor = (BatchEditor);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/MultiSelector.tsx
















var BATCH_THRESHOLD_VALUE = 50;
var MultiSelector = function(props) {
    var ref, ref1;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var onChange = props.onChange, batchEdit = props.batchEdit;
    var ref2 = hooks_useEnterBlurMultiSelect(function(createValue) {
        return handleChange((0,uniq/* default */.Z)((0,_to_consumable_array/* default */.Z)(currentValue).concat([
            createValue
        ])));
    }), searchValue = ref2.searchValue, onSearchChange = ref2.onSearchChange, handleBlur = ref2.handleBlur, handleKeyDown = ref2.handleKeyDown;
    var condition = (0,react.useContext)(ConditionContext/* default */.Z).condition;
    var ref3 = (0,react.useContext)(DataContext/* default */.Z), fields = ref3.firstNode.fields, _secondNode = ref3.secondNode, getCreateLabel = _secondNode.getCreateLabel, getFields = _secondNode.getFields;
    var secondNodeValue = condition === null || condition === void 0 ? void 0 : (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(searchValue, Filter_constants/* debouncedWaitTime */.NG), 1), debounceSearchValue = ref4[0];
    var firstNodeFieldCodes = (0,react.useMemo)(function() {
        return fields === null || fields === void 0 ? void 0 : fields.map(function(field) {
            return field.code;
        });
    }, [
        fields
    ]);
    var currentValue = (0,react.useMemo)(function() {
        return secondNodeValue ? (0,isArray/* default */.Z)(secondNodeValue) ? secondNodeValue : [
            secondNodeValue
        ] : [];
    }, [
        secondNodeValue
    ]);
    var ref5 = (0,react.useState)([]), secondNodeFields = ref5[0], setSecondNodeFields = ref5[1];
    var ref6 = (0,react.useState)(false), batched = ref6[0], setBatched = ref6[1];
    var ref7 = (0,react.useState)(false), batchEditorVisible = ref7[0], setBatchEditorVisible = ref7[1];
    (0,react.useEffect)(function() {
        setSecondNodeFields((0,uniq/* default */.Z)(secondNodeFields.concat(currentValue)));
        setBatched(batchEdit == true && (0,size/* default */.Z)(currentValue) > BATCH_THRESHOLD_VALUE);
    // eslint-disable-next-line
    }, [
        currentValue
    ]);
    (0,react.useEffect)(function() {
        var getSecondNodeFields = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!getFields || !condition.firstNode.value || !(0,includes/* default */.Z)(firstNodeFieldCodes, condition.firstNode.value)) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            return [
                                4,
                                getFields(condition.firstNode.value, debounceSearchValue)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function getSecondNodeFields() {
                return _ref.apply(this, arguments);
            };
        }();
        getSecondNodeFields().then(function(data) {
            return setSecondNodeFields((0,uniq/* default */.Z)(data.concat(currentValue)));
        });
    // eslint-disable-next-line
    }, [
        condition.firstNode.value,
        fields,
        debounceSearchValue
    ]);
    var handleCreate = function(search) {
        var query = search.trim();
        setSecondNodeFields(function(current) {
            return (0,_to_consumable_array/* default */.Z)(current).concat([
                query
            ]);
        });
        return {
            value: query,
            label: query
        };
    };
    var handleChange = function(value) {
        var error = "";
        var _secondNode;
        var ref = (_secondNode = condition.secondNode) !== null && _secondNode !== void 0 ? _secondNode : {}, originValue = ref.value, originError = ref.error;
        if (value !== originValue || error !== originError) {
            onChange({
                value: value,
                error: error
            });
        }
    };
    var shouldCreate = function(search, data) {
        var query = search.trim();
        var isExisted = data === null || data === void 0 ? void 0 : data.some(function(param) {
            var label = param.label;
            return label === query;
        });
        return !isExisted && !(0,isEmpty/* default */.Z)(query);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
        gutter: "sm",
        justify: "flex-end",
        align: "flex-start",
        sx: {
            flexWrap: "nowrap"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                span: "auto",
                className: "w-[310px]",
                children: [
                    !batched && /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, {
                        creatable: !!getCreateLabel,
                        searchable: true,
                        clearable: true,
                        searchValue: searchValue,
                        data: secondNodeFields,
                        value: currentValue,
                        onSearchChange: onSearchChange,
                        placeholder: t("placeholders.pleaseSelect"),
                        onChange: handleChange,
                        // @ts-ignore
                        getCreateLabel: getCreateLabel,
                        shouldCreate: shouldCreate,
                        onCreate: handleCreate,
                        onKeyDown: handleKeyDown,
                        onBlur: handleBlur,
                        error: condition === null || condition === void 0 ? void 0 : (ref1 = condition.secondNode) === null || ref1 === void 0 ? void 0 : ref1.error,
                        styles: {
                            value: {
                                margin: "3px 5px"
                            },
                            input: {
                                paddingLeft: "12px",
                                paddingRight: "30px"
                            },
                            values: {
                                "&[data-clearable]": {
                                    marginRight: 0
                                }
                            }
                        }
                    }),
                    batched && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        spacing: 0,
                        sx: function(theme) {
                            return {
                                textAlign: "left",
                                padding: theme.spacing.sm,
                                borderRadius: theme.radius.sm,
                                fontSize: theme.fontSizes.sm,
                                border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.3", theme)),
                                cursor: "pointer"
                            };
                        },
                        onClick: function() {
                            return setBatchEditorVisible(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "gray.7",
                                className: "truncate w-[200px]",
                                style: {
                                    flex: "1 0 auto"
                                },
                                children: currentValue.join(", ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                align: "right",
                                lineClamp: 1,
                                style: {
                                    flex: "0 0 auto"
                                },
                                color: "gray.7",
                                children: t("common:batchEdit.totalSize", {
                                    size: (0,size/* default */.Z)(currentValue)
                                })
                            })
                        ]
                    })
                ]
            }),
            batchEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                span: "content",
                mt: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                        onClick: function() {
                            return setBatchEditorVisible(true);
                        },
                        type: "button",
                        children: t("common:actions.batchEdit")
                    }),
                    batchEditorVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNode_BatchEditor, {
                        value: currentValue,
                        onSave: handleChange,
                        onClose: function() {
                            return setBatchEditorVisible(false);
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SecondNode_MultiSelector = (MultiSelector);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/NumberInput/NumberInput.js + 4 modules
var NumberInput = __webpack_require__(4602);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconMinus.js
var IconMinus = __webpack_require__(52528);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/NumberBetweenInput.tsx








var NumberBetweenInput = function(props) {
    var ref = (0,react.useContext)(ConditionContext/* default */.Z), secondNode = ref.condition.secondNode;
    var onChange = props.onChange;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((secondNode === null || secondNode === void 0 ? void 0 : secondNode.value) || [], 2), min = ref1[0], max = ref1[1];
    var handleMinChange = function(value) {
        if (value !== min) {
            onChange({
                value: [
                    value,
                    max
                ]
            });
        }
    };
    var handleMaxChange = function(value) {
        if (value !== max) {
            onChange({
                value: [
                    min,
                    value
                ]
            });
        }
    };
    var getNumberInputComponent = function(value, onChange, min, max) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
            value: value,
            placeholder: t("placeholders.pleaseInput"),
            onChange: onChange,
            removeTrailingZeros: true,
            precision: 2,
            min: min,
            max: max
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        spacing: "sm",
        children: [
            getNumberInputComponent(min, handleMinChange, undefined, max),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMinus/* default */.Z, {
                size: 16,
                stroke: 1.5,
                color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
            }),
            getNumberInputComponent(max, handleMaxChange, min, undefined)
        ]
    });
};
/* harmony default export */ var SecondNode_NumberBetweenInput = (NumberBetweenInput);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/NumberInput.tsx





var NumberInput_NumberInput = function(props) {
    var ref = (0,react.useContext)(ConditionContext/* default */.Z), secondNode = ref.condition.secondNode;
    var onChange = props.onChange;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var secondNodeValue = secondNode === null || secondNode === void 0 ? void 0 : secondNode.value;
    var handleChange = function(value) {
        if (value !== secondNodeValue) {
            onChange({
                value: value
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
        value: secondNodeValue,
        placeholder: t("placeholders.pleaseInput"),
        onChange: handleChange,
        removeTrailingZeros: true,
        precision: 2
    });
};
/* harmony default export */ var SecondNode_NumberInput = (NumberInput_NumberInput);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(79965);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/TextInput.tsx






var TextInput_TextInput = function(props) {
    var ref;
    var condition = (0,react.useContext)(ConditionContext/* default */.Z).condition;
    var ref1 = (0,react.useContext)(DataContext/* default */.Z), autoFocus = ref1.secondNode.autoFocus;
    var onChange = props.onChange;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var inputRef = null;
    var handleChange = function(value) {
        var ref;
        var newValue = value.trim();
        if (newValue !== ((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value)) {
            onChange({
                value: newValue
            });
        }
    };
    (0,react.useEffect)(function() {
        if (autoFocus) {
            inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
        }
    }, [
        autoFocus,
        inputRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        ref: function(input) {
            inputRef = input;
        },
        value: ((ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value) || "",
        placeholder: t("common:placeholders.pleaseInput"),
        onChange: function(e) {
            return handleChange(e.currentTarget.value);
        }
    });
};
/* harmony default export */ var SecondNode_TextInput = (TextInput_TextInput);

// EXTERNAL MODULE: ./src/components/ui/index.ts + 24 modules
var ui = __webpack_require__(29718);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/UrlInput.tsx





var UrlInput = function(param) {
    var onChange = param.onChange;
    var ref;
    var condition = (0,react.useContext)(ConditionContext/* default */.Z).condition;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var inputRef = null;
    var handleChange = function(value, error) {
        var _secondNode;
        var ref = (_secondNode = condition.secondNode) !== null && _secondNode !== void 0 ? _secondNode : {}, originValue = ref.value, originError = ref.error;
        if (value !== originValue || error !== originError) {
            onChange({
                value: value,
                label: value,
                error: error
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UrlInput */.mh, {
        ref: function(input) {
            inputRef = input;
        },
        value: (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value,
        placeholder: t("common:placeholders.pleaseInput"),
        onChange: handleChange,
        allowBlank: true,
        validateFirst: true
    });
};
/* harmony default export */ var SecondNode_UrlInput = (UrlInput);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/constant.ts








var SECOND_NODE_TYPE;
(function(SECOND_NODE_TYPE) {
    SECOND_NODE_TYPE["TEXT"] = "text";
    SECOND_NODE_TYPE["URL"] = "urlInput";
    SECOND_NODE_TYPE["MULTIPLE_SELECT"] = "multiSelect";
    SECOND_NODE_TYPE["DATE"] = "date";
    SECOND_NODE_TYPE["NUMBER"] = "number";
    SECOND_NODE_TYPE["NUMBER_BETWEEN"] = "numberBetween";
    SECOND_NODE_TYPE["USER_SEGMENT"] = "userSegment";
})(SECOND_NODE_TYPE || (SECOND_NODE_TYPE = {}));
var _obj;
var secondsNodes = (_obj = {}, (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.URL, SecondNode_UrlInput), (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.TEXT, SecondNode_TextInput), (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.MULTIPLE_SELECT, SecondNode_MultiSelector), (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.DATE, SecondNode_DateSelector), (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.NUMBER, SecondNode_NumberInput), (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.NUMBER_BETWEEN, SecondNode_NumberBetweenInput), (0,_define_property/* default */.Z)(_obj, SECOND_NODE_TYPE.USER_SEGMENT, SecondNode_CustomerSegmentNode), _obj);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/useSecondNodeType.ts








function isUrl(type, operator) {
    return type === "Url" && (operator === domain/* UrlConditionOperator.Equal */.xgK.Equal || operator === domain/* UrlConditionOperator.StartWith */.xgK.StartWith);
}
function isText(type, operator) {
    return type === "Url" && operator === domain/* UrlConditionOperator.Wildcard */.xgK.Wildcard;
}
function useSecondNodeType_isNumber(operator) {
    return [
        domain/* ConditionOperator.Lt */.N0$.Lt,
        domain/* ConditionOperator.Lte */.N0$.Lte,
        domain/* ConditionOperator.Gt */.N0$.Gt,
        domain/* ConditionOperator.Gte */.N0$.Gte
    ].includes(operator);
}
function getFirstNodeType(fields, value) {
    var ref;
    return (ref = (0,find/* default */.Z)(fields, {
        code: value
    })) === null || ref === void 0 ? void 0 : ref.type;
}
function getSecondNodeType(fields, condition) {
    var ref, ref1, ref2;
    var type = (condition === null || condition === void 0 ? void 0 : (ref = condition.firstNode) === null || ref === void 0 ? void 0 : ref.type) ? condition === null || condition === void 0 ? void 0 : (ref1 = condition.firstNode) === null || ref1 === void 0 ? void 0 : ref1.type : getFirstNodeType(fields, (ref2 = condition.firstNode) === null || ref2 === void 0 ? void 0 : ref2.value);
    var operator = condition === null || condition === void 0 ? void 0 : condition.operator;
    if (isUrl(type, operator)) {
        return SECOND_NODE_TYPE.URL;
    }
    if (isText(type, operator)) {
        return SECOND_NODE_TYPE.TEXT;
    }
    return SECOND_NODE_TYPE.TEXT;
}
function getDynamicSecondType(condition) {
    var _firstNode = condition.firstNode, firstNodeType = _firstNode.type, firstNodeValue = _firstNode.value, operator = condition.operator;
    if (isPresentOperator(operator)) {
        return;
    }
    if (firstNodeType === domain/* FieldType.DateTime */.fSu.DateTime) {
        return SECOND_NODE_TYPE.DATE;
    }
    if (firstNodeValue === constant/* userSegmentCode */.DK) {
        return SECOND_NODE_TYPE.USER_SEGMENT;
    }
    if (useSecondNodeType_isNumber(operator)) {
        return SECOND_NODE_TYPE.NUMBER;
    }
    if (operator === domain/* ConditionOperator.NumberBetween */.N0$.NumberBetween) {
        return SECOND_NODE_TYPE.NUMBER_BETWEEN;
    }
    var notIsEnOrNe = ![
        domain/* ConditionOperator.Eq */.N0$.Eq,
        domain/* ConditionOperator.Ne */.N0$.Ne
    ].includes(operator);
    if (notIsEnOrNe) {
        return SECOND_NODE_TYPE.MULTIPLE_SELECT;
    }
    return SECOND_NODE_TYPE.TEXT;
}
function useSecondNodeType() {
    var ref = (0,react.useContext)(DataContext/* default */.Z), fields = ref.fields, dynamic = ref.dynamic;
    var condition = (0,react.useContext)(ConditionContext/* default */.Z).condition;
    return (0,react.useMemo)(function() {
        return dynamic ? getDynamicSecondType(condition) : getSecondNodeType(fields, condition);
    }, [
        condition,
        dynamic,
        fields
    ]);
}

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/SecondNode/index.tsx








var SecondNode = function(param) {
    var _batchEdit = param.batchEdit, batchEdit = _batchEdit === void 0 ? false : _batchEdit;
    var ref = (0,react.useContext)(ConditionContext/* default */.Z), index = ref.index, condition = ref.condition;
    var dispatch = useConditionGroup().dispatch;
    var ref1 = (0,react.useContext)(DataContext/* default */.Z), rules = ref1.secondNode.rules;
    var secondNodeType = useSecondNodeType();
    var SecondNodeComponent = secondNodeType && secondsNodes[secondNodeType];
    var getError = function(value) {
        var firstError = rules === null || rules === void 0 ? void 0 : rules.find(function(param) {
            var regex = param.regex, required = param.required;
            if (required) {
                return (0,isEmpty/* default */.Z)(value);
            }
            return (0,isArray/* default */.Z)(value) ? value.some(function(item) {
                return !(regex === null || regex === void 0 ? void 0 : regex.test(item.toString()));
            }) : !(regex === null || regex === void 0 ? void 0 : regex.test(value.toString()));
        });
        return firstError ? firstError === null || firstError === void 0 ? void 0 : firstError.message : undefined;
    };
    var handleChange = (0,react.useCallback)(function(param) {
        var value = param.value, label = param.label, error = param.error, type = param.type;
        var errorMessage = error ? error : getError(value);
        dispatch({
            type: "secondNodeChange",
            index: index,
            secondNode: {
                value: value,
                label: label,
                error: errorMessage,
                type: type
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dispatch,
        index
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: SecondNodeComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNodeComponent, {
            condition: condition,
            onChange: handleChange,
            batchEdit: batchEdit
        }) : null
    });
};
/* harmony default export */ var Conditions_SecondNode = (SecondNode);

// EXTERNAL MODULE: ./src/components/ui/Divider/index.tsx
var Divider = __webpack_require__(45006);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Conditions/index.tsx














var Conditions = function(param) {
    var _collapseCondition = param.collapseCondition, collapseCondition = _collapseCondition === void 0 ? false : _collapseCondition, _batchEdit = param.batchEdit, batchEdit = _batchEdit === void 0 ? false : _batchEdit;
    var t = (0,useTranslation/* default */.Z)("componentConditionGroup").t;
    var ref = useConditionGroup(), _state = ref.state, conditions = _state.conditions, operator = _state.operator;
    var ref1 = (0,react.useContext)(DataContext/* default */.Z), hidden = ref1.firstNode.hidden;
    if ((0,isEmpty/* default */.Z)(conditions)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        spacing: "sm",
        children: conditions.map(function(condition, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionContext/* default.Provider */.Z.Provider, {
                value: {
                    index: index,
                    condition: condition
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                    gutter: "sm",
                    columns: 24,
                    align: "center",
                    children: [
                        collapseCondition ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid.Col */.r.Col, {
                            span: "auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                    gutter: "xs",
                                    columns: 24,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                            span: 7,
                                            hidden: hidden,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_FirstNode, {
                                                hideErrorMsg: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                            span: 5,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_Operator, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                            span: conditions.length > 1 ? 11 : 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_SecondNode, {
                                                batchEdit: batchEdit
                                            })
                                        }),
                                        conditions.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                            span: 1,
                                            mt: "xs",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFilter_RemoveCondition, {
                                                index: index
                                            })
                                        })
                                    ]
                                }),
                                condition.firstNode.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input.Error */.I.Error, {
                                    children: condition.firstNode.error
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            span: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                gutter: "sm",
                                columns: conditions.length > 1 ? 21 : 20,
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        span: 12,
                                        hidden: hidden,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_FirstNode, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        span: 8,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_Operator, {})
                                    }),
                                    conditions.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        span: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFilter_RemoveCondition, {
                                            index: index
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        span: 20,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_SecondNode, {
                                            batchEdit: batchEdit
                                        })
                                    })
                                ]
                            })
                        }),
                        conditions.length > 1 && index !== conditions.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                            span: 23,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    c: "dimmed",
                                    mx: "lg",
                                    children: operator == domain/* ConditionGroupOperator.And */.ZOu.And ? t("conditionGroupOperator.AND") : t("conditionGroupOperator.OR")
                                }),
                                labelPosition: "center"
                            })
                        })
                    ]
                })
            }, "".concat(condition.firstNode.value, "-").concat(index));
        })
    });
};
/* harmony default export */ var DefaultFilter_Conditions = (/*#__PURE__*/(0,react.memo)(Conditions));

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tooltip/Tooltip.js + 7 modules
var Tooltip = __webpack_require__(57155);
// EXTERNAL MODULE: ./src/components/ui/Button/index.ts + 3 modules
var ui_Button = __webpack_require__(83347);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(75686);
// EXTERNAL MODULE: ./src/components/business/VipIcon/index.tsx
var VipIcon = __webpack_require__(22974);
;// CONCATENATED MODULE: ./src/components/business/VipIconWithPopover/index.tsx





var VipIconWithPopover = function(param) {
    var feature = param.feature, transQuery = param.transQuery;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VipIcon/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureTip/* default */.Z, {
                    feature: feature,
                    transQuery: transQuery
                })
            })
        ]
    });
};
/* harmony default export */ var business_VipIconWithPopover = (VipIconWithPopover);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/Adder/index.tsx








var ConditionAdder = function(param) {
    var feature = param.feature, disabled = param.disabled;
    var t = (0,useTranslation/* default */.Z)("componentConditionGroup").t;
    var ref = (0,react.useContext)(DataContext/* default */.Z), maxLength = ref.maxLength, defaultCondition = ref.defaultCondition;
    var ref1 = useConditionGroup(), conditions = ref1.state.conditions, dispatch = ref1.dispatch;
    var handleAddClick = function() {
        dispatch({
            type: "addCondition",
            condition: defaultCondition
        });
    };
    var exceedMaxLength = maxLength <= conditions.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        mt: "md",
        spacing: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                withArrow: true,
                disabled: !exceedMaxLength,
                position: "top-start",
                label: t("maxConditionCount", {
                    count: maxLength
                }),
                offset: -8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Button/* AddButton */.HS, {
                        disabled: disabled || exceedMaxLength,
                        onClick: handleAddClick,
                        text: t("common:actions.add")
                    })
                })
            }),
            feature && /*#__PURE__*/ (0,jsx_runtime.jsx)(business_VipIconWithPopover, {
                feature: feature
            })
        ]
    });
};
/* harmony default export */ var Adder = (ConditionAdder);

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/index.tsx













var DefaultFilter = function(props) {
    var fields = props.fields, value = props.value, onChange = props.onChange, _dynamic = props.dynamic, dynamic = _dynamic === void 0 ? false : _dynamic, _firstNode = props.firstNode, firstNode = _firstNode === void 0 ? constants/* defaultFirstNode */.YS : _firstNode, _secondNode = props.secondNode, secondNode = _secondNode === void 0 ? constants/* defaultSecondNode */.VV : _secondNode, _keepInvalidCondition = props.keepInvalidCondition, keepInvalidCondition = _keepInvalidCondition === void 0 ? false : _keepInvalidCondition, _maxLength = props.maxLength, maxLength = _maxLength === void 0 ? 1 : _maxLength, defaultCondition = props.defaultCondition, _collapseCondition = props.collapseCondition, collapseCondition = _collapseCondition === void 0 ? false : _collapseCondition, _batchEdit = props.batchEdit, batchEdit = _batchEdit === void 0 ? false : _batchEdit, adder = props.adder;
    var resultFields = formatFields(fields);
    var initialValue = (0,react.useMemo)(function() {
        var ref;
        if (value === null || value === void 0 ? void 0 : (ref = value.conditions) === null || ref === void 0 ? void 0 : ref.length) {
            var group = lib_default()(value, [
                "firstNode.type"
            ]);
            if (firstNode.getFieldType) {
                group.conditions.forEach(function(condition) {
                    if (condition.firstNode.value) {
                        condition.firstNode.type = firstNode.getFieldType(condition.firstNode.value);
                    }
                });
            }
            return group;
        }
        return constants/* defaultValue */.LS;
    }, [
        firstNode.getFieldType,
        value
    ]);
    var ref = (0,react.useState)(initialValue.conditions.length > 1), showConditionGroupOperator = ref[0], setShowConditionGroupOperator = ref[1];
    var handleChange = (0,react.useCallback)(function(data) {
        try {
            var conditions = !(0,isEmpty/* default */.Z)(data.conditions) ? data.conditions : [];
            var result = {
                operator: data.operator,
                conditions: conditions
            };
            if (conditions.length > 0 || conditions.length === data.conditions.length) {
                if (keepInvalidCondition) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(result, conditions.length < data.conditions.length);
                } else {
                    onChange === null || onChange === void 0 ? void 0 : onChange(filterEmptyCondition(result), conditions.length < data.conditions.length);
                }
                setShowConditionGroupOperator(conditions.length > 1);
            }
        } catch (e) {
            onChange === null || onChange === void 0 ? void 0 : onChange(initialValue);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fields
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DataContext/* default.Provider */.Z.Provider, {
        value: {
            fields: resultFields,
            dynamic: dynamic,
            firstNode: firstNode,
            secondNode: secondNode,
            maxLength: maxLength,
            defaultCondition: defaultCondition
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionGroupProvider, {
            defaultValue: initialValue,
            onChange: handleChange,
            children: [
                showConditionGroupOperator && /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFilter_ConditionGroupOperator, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultFilter_Conditions, {
                    collapseCondition: collapseCondition,
                    batchEdit: batchEdit
                }),
                maxLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Adder, (0,src_object_spread/* default */.Z)({}, adder))
            ]
        })
    });
};
/* harmony default export */ var Filter_DefaultFilter = (/*#__PURE__*/(0,react.memo)(DefaultFilter));

// EXTERNAL MODULE: ./src/components/business/Filter/FieldFilterPopover/index.tsx
var FieldFilterPopover = __webpack_require__(35145);
;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/scripts/compare.ts

function formatConditionsToCompare(conditions) {
    var _value, ref;
    return conditions.map(function(param) {
        var firstNode = param.firstNode, operator = param.operator, secondNode = param.secondNode;
        return "".concat((_value = firstNode.value) !== null && _value !== void 0 ? _value : "", ":").concat(operator !== null && operator !== void 0 ? operator : "", ":").concat((ref = secondNode === null || secondNode === void 0 ? void 0 : secondNode.value) !== null && ref !== void 0 ? ref : "");
    });
}
function areConditionGroupsEqual(group1, group2) {
    var group1Nil = (0,isNil/* default */.Z)(group1);
    var group2Nil = (0,isNil/* default */.Z)(group2);
    if (group1Nil || group2Nil) {
        return group1Nil && group2Nil;
    }
    return group1.operator === group2.operator && group1.conditions.length === group2.conditions.length && (0,isEqual/* default */.Z)(formatConditionsToCompare(group1.conditions).sort(), formatConditionsToCompare(group2.conditions).sort());
}

;// CONCATENATED MODULE: ./src/components/business/Filter/DefaultFilter/hooks/useFormatCondition.ts








function useFormatCondition() {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var getPeriodLabel = (0,usePeriodTypes/* default */.Z)().getPeriodLabel;
    var data = (0,domain/* useCustomerSegmentsBaseInfoQuery */.ig_)({
        variables: {
            id: (0,next_router.useRouter)().query.appId
        }
    }).data;
    var getSecondNodeText = function(node, operator) {
        var ref = node !== null && node !== void 0 ? node : {}, type = ref.type, value = ref.value;
        if (value && type === domain/* ConditionNodeType.Period */.BAL.Period) {
            return getPeriodLabel(value);
        }
        if (operator === domain/* ConditionOperator.NumberBetween */.N0$.NumberBetween) {
            return (0,isArray/* default */.Z)(value) ? (0,utils/* getRangeLabel */.OR)(value, t) : "";
        }
        if ((0,isArray/* default */.Z)(value)) {
            return value.join(", ");
        }
        return value !== null && value !== void 0 ? value : "";
    };
    var getUserSegments = function(node) {
        var ref, ref1;
        var value = (node !== null && node !== void 0 ? node : {}).value;
        return data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : (ref1 = ref.customerSegments) === null || ref1 === void 0 ? void 0 : ref1.filter(function(segment) {
            return value.includes(segment.id);
        }).map(function(value) {
            return value.name;
        }).join(", ");
    };
    return function(condition, firstNodeMapper) {
        var _firstNode = condition.firstNode, firstNodeValue = _firstNode.value, operator = condition.operator, secondNode = condition.secondNode;
        if ((0,isNil/* default */.Z)(firstNodeValue) || (0,isNil/* default */.Z)(operator)) {
            return "";
        }
        var firstNodeText = (firstNodeMapper === null || firstNodeMapper === void 0 ? void 0 : firstNodeMapper(firstNodeValue)) || firstNodeValue;
        var operatorText = getOperatorLabel(operator, t);
        var secondNodeText = firstNodeValue === constant/* userSegmentCode */.DK ? getUserSegments(secondNode) : getSecondNodeText(secondNode, operator);
        return "".concat(firstNodeText, " ").concat(operatorText, " ").concat(secondNodeText);
    };
}

;// CONCATENATED MODULE: ./src/components/business/Filter/type.ts
var TimePeriod = "TimePeriod";
var DateOperator;
(function(DateOperator) {
    DateOperator["WEEK"] = "WEEK";
    DateOperator["PREVIOUS_WEEK"] = "PREVIOUS_WEEK";
    DateOperator["MONTH"] = "MONTH";
    DateOperator["PREVIOUS_MONTH"] = "PREVIOUS_MONTH";
    DateOperator["QUARTERLY"] = "QUARTERLY";
    DateOperator["PREVIOUS_QUARTERLY"] = "PREVIOUS_QUARTERLY";
    DateOperator["YEAR"] = "YEAR";
    DateOperator["PREVIOUS_YEAR"] = "PREVIOUS_YEAR";
    DateOperator["BETWEEN"] = "BETWEEN";
})(DateOperator || (DateOperator = {}));

;// CONCATENATED MODULE: ./src/components/business/Filter/index.ts









// EXTERNAL MODULE: ./src/components/business/GlobalErrorBoundary/index.tsx + 7 modules
var GlobalErrorBoundary = __webpack_require__(69333);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var classnames = __webpack_require__(90773);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14661);
// EXTERNAL MODULE: ./src/utils/fieldIcon.ts
var fieldIcon = __webpack_require__(45559);
;// CONCATENATED MODULE: ./src/components/business/FieldIcon/index.tsx








var FieldIcon = function(param) {
    var type = param.type, index = param.index, _compact = param.compact, compact = _compact === void 0 ? false : _compact, className = param.className;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref = (0,react.useMemo)(function() {
        return (0,fieldIcon/* formFieldIconMapping */.o4)(theme)[type];
    }, [
        type
    ]), iconName = ref.iconName, bg = ref.bg, iconColor = ref.iconColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        className: classnames_default()("p-xs flex items-center h-xl rounded-sm flex-shrink-0 ", {
            "min-w-2xl": !compact
        }, className),
        "data-testid": type,
        style: {
            background: bg
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: iconName,
                style: {
                    color: iconColor
                }
            }),
            !(0,isNil/* default */.Z)(index) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "ml-[6px]",
                size: "xs",
                color: (0,getColor/* getTextColor */.uu)("gray.9", theme, "dark.5"),
                children: index
            })
        ]
    });
};
/* harmony default export */ var business_FieldIcon = (FieldIcon);

// EXTERNAL MODULE: ./src/components/business/EntryIcon/index.tsx
var EntryIcon = __webpack_require__(90037);
;// CONCATENATED MODULE: ./src/components/business/UrlFilter/constants.ts

var defaultCondition = {
    operator: domain/* UrlConditionOperator.Equal */.xgK.Equal,
    node: {
        value: null
    }
};
var defaultConditions = [
    defaultCondition
];
var defaultValue = {
    operator: domain/* ConditionGroupOperator.And */.ZOu.And,
    conditions: defaultConditions
};
var maxLength = 10;

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/ConditionGroup/conditionGroupReducer.ts





function conditionGroupReducer_conditionGroupReducer(state, action) {
    switch(action.type){
        case "addCondition":
            {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    conditions: immutability_helper_default()(state.conditions, {
                        $push: action.condition ? [
                            action.condition
                        ] : defaultConditions
                    })
                });
            }
        case "removeCondition":
            {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    conditions: immutability_helper_default()(state.conditions, {
                        $splice: [
                            [
                                action.index,
                                1
                            ]
                        ]
                    })
                });
            }
        case "conditionOperatorChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                conditions: immutability_helper_default()(state.conditions, (0,_define_property/* default */.Z)({}, action.index, {
                    $set: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.conditions[action.index]), {
                        operator: action.value,
                        node: {
                            value: undefined
                        }
                    })
                }))
            });
        case "nodeChange":
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                conditions: immutability_helper_default()(state.conditions, (0,_define_property/* default */.Z)({}, action.index, {
                    $set: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state.conditions[action.index]), {
                        node: action.node
                    })
                }))
            });
        default:
            return state;
    }
}

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/ConditionGroup/ConditionGroupContext.tsx





var ConditionGroupContext_ConditionGroupContext = /*#__PURE__*/ (0,react.createContext)(undefined);
function ConditionGroupContext_ConditionGroupProvider(param) {
    var defaultValue = param.defaultValue, onChange = param.onChange, children = param.children;
    var ref = (0,react.useReducer)(conditionGroupReducer_conditionGroupReducer, {
        operator: domain/* ConditionGroupOperator.Or */.ZOu.Or,
        conditions: defaultValue.conditions
    }), state = ref[0], dispatch = ref[1];
    (0,react.useEffect)(function() {
        if (!(0,isEqual/* default */.Z)(state, defaultValue)) {
            onChange(state);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state
    ]);
    var value = {
        state: state,
        dispatch: dispatch
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionGroupContext_ConditionGroupContext.Provider, {
        value: value,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/ConditionGroup/useConditionGroup.ts


function useConditionGroup_useConditionGroup() {
    var context = (0,react.useContext)(ConditionGroupContext_ConditionGroupContext);
    if (context === undefined) {
        throw new Error("useConditionGroup must be used within a ConditionGroupProvider");
    }
    return context;
}

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/ConditionGroup/index.ts



;// CONCATENATED MODULE: ./src/components/business/UrlFilter/RemoveCondition/index.tsx





var RemoveCondition_RemoveCondition = function(param) {
    var index = param.index;
    var dispatch = useConditionGroup_useConditionGroup().dispatch;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var handleRemoveClick = function() {
        dispatch({
            type: "removeCondition",
            index: index
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
        onClick: handleRemoveClick,
        sx: function(theme) {
            return {
                "&:hover": {
                    background: theme.colors.gray[1]
                }
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* default */.Z, {
            size: 16,
            stroke: 1,
            color: theme.colors.gray[7]
        })
    });
};
/* harmony default export */ var UrlFilter_RemoveCondition = (RemoveCondition_RemoveCondition);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/ConditionContext.tsx

var ConditionContext_ConditionContext = /*#__PURE__*/ (0,react.createContext)({
    index: 0,
    condition: {
        operator: null,
        node: {
            value: undefined
        }
    },
    checkUrl: true
});
/* harmony default export */ var Conditions_ConditionContext = (ConditionContext_ConditionContext);

// EXTERNAL MODULE: ./src/components/business/UrlFilter/Conditions/index.module.scss
var index_module = __webpack_require__(61915);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/Operator/index.tsx









var Operator_Operator = function() {
    var ref = (0,react.useContext)(Conditions_ConditionContext), index = ref.index, condition = ref.condition;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var dispatch = useConditionGroup_useConditionGroup().dispatch;
    var Equal = domain/* UrlConditionOperator.Equal */.xgK.Equal, StartWith = domain/* UrlConditionOperator.StartWith */.xgK.StartWith, Wildcard = domain/* UrlConditionOperator.Wildcard */.xgK.Wildcard;
    var selectOptions = (0,react.useMemo)(function() {
        var ref;
        return (ref = [
            Equal,
            StartWith,
            Wildcard
        ]) === null || ref === void 0 ? void 0 : ref.map(function(option) {
            return {
                value: option,
                label: t("componentConditionGroup:conditionOperator.".concat(option))
            };
        });
    }, [
        Equal,
        StartWith,
        Wildcard,
        t
    ]);
    var handleChange = (0,react.useCallback)(function(value) {
        dispatch({
            type: "conditionOperatorChange",
            index: index,
            value: value
        });
    }, [
        dispatch,
        index
    ]);
    var widthMap = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* UrlConditionOperator.Equal */.xgK.Equal, {
            width: 76,
            ml: 26
        }), (0,_define_property/* default */.Z)(_obj, domain/* UrlConditionOperator.StartWith */.xgK.StartWith, {
            width: 90,
            ml: 18
        }), (0,_define_property/* default */.Z)(_obj, domain/* UrlConditionOperator.Wildcard */.xgK.Wildcard, {
            width: 118,
            ml: 4
        }), _obj;
    }, []);
    return (0,react.useMemo)(function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
            placeholder: t("placeholders.pleaseSelect"),
            data: selectOptions,
            value: condition === null || condition === void 0 ? void 0 : condition.operator,
            onChange: handleChange,
            className: (index_module_default()).operator,
            styles: {
                root: {
                    width: (ref = widthMap[condition === null || condition === void 0 ? void 0 : condition.operator]) === null || ref === void 0 ? void 0 : ref.width,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                },
                dropdown: {
                    width: "128px!important",
                    marginLeft: (ref1 = widthMap[condition === null || condition === void 0 ? void 0 : condition.operator]) === null || ref1 === void 0 ? void 0 : ref1.ml,
                    marginTop: -4
                }
            }
        });
    }, [
        condition === null || condition === void 0 ? void 0 : condition.operator,
        handleChange,
        selectOptions,
        t,
        widthMap
    ]);
};
/* harmony default export */ var UrlFilter_Conditions_Operator = (Operator_Operator);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/Node/UrlInput.tsx





var UrlInput_UrlInput = function(param) {
    var onChange = param.onChange, className = param.className;
    var ref;
    var ref1 = (0,react.useContext)(Conditions_ConditionContext), condition = ref1.condition, checkUrl = ref1.checkUrl;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var handleChange = function(value, error) {
        var _node;
        var ref = (_node = condition.node) !== null && _node !== void 0 ? _node : {}, originValue = ref.value, originError = ref.error;
        if (value !== originValue || error !== originError) {
            onChange({
                value: value,
                error: error
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UrlInput */.mh, {
        value: (ref = condition.node) === null || ref === void 0 ? void 0 : ref.value,
        placeholder: t("common:placeholders.pleaseInput"),
        onChange: handleChange,
        allowBlank: true,
        validateFirst: true,
        checkUrl: checkUrl,
        className: className
    });
};
/* harmony default export */ var Node_UrlInput = (UrlInput_UrlInput);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/Node/TextInput.tsx





var Node_TextInput_TextInput = function(props) {
    var ref;
    var condition = (0,react.useContext)(Conditions_ConditionContext).condition;
    var onChange = props.onChange, className = props.className;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var handleChange = function(value) {
        var ref;
        var newValue = value.trim();
        if (newValue !== ((ref = condition.node) === null || ref === void 0 ? void 0 : ref.value)) {
            onChange({
                value: newValue
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        value: ((ref = condition.node) === null || ref === void 0 ? void 0 : ref.value) || "",
        placeholder: t("common:placeholders.pleaseInput"),
        onChange: function(e) {
            return handleChange(e.currentTarget.value);
        },
        className: className
    });
};
/* harmony default export */ var Node_TextInput = (Node_TextInput_TextInput);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/Node/constant.ts



var NODE_TYPE;
(function(NODE_TYPE) {
    NODE_TYPE["TEXT"] = "text";
    NODE_TYPE["URL"] = "urlInput";
})(NODE_TYPE || (NODE_TYPE = {}));
var constant_obj;
var nodes = (constant_obj = {}, (0,_define_property/* default */.Z)(constant_obj, NODE_TYPE.URL, Node_UrlInput), (0,_define_property/* default */.Z)(constant_obj, NODE_TYPE.TEXT, Node_TextInput), constant_obj);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/Node/getNodeType.ts




function getNodeType_isUrl(operator) {
    return operator === domain/* UrlConditionOperator.Equal */.xgK.Equal || operator === domain/* UrlConditionOperator.StartWith */.xgK.StartWith;
}
function getNodeType(condition) {
    var operator = condition === null || condition === void 0 ? void 0 : condition.operator;
    if (getNodeType_isUrl(operator)) {
        return NODE_TYPE.URL;
    }
    return NODE_TYPE.TEXT;
}
function useNodeType() {
    var condition = (0,react.useContext)(Conditions_ConditionContext).condition;
    return (0,react.useMemo)(function() {
        return getNodeType(condition);
    }, [
        condition
    ]);
}

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/Node/index.tsx









var Node = function() {
    var index = (0,react.useContext)(Conditions_ConditionContext).index;
    var dispatch = useConditionGroup_useConditionGroup().dispatch;
    var ref = (0,react.useContext)(DataContext/* default */.Z), rules = ref.secondNode.rules;
    var nodeType = useNodeType();
    var NodeComponent = nodes[nodeType];
    var getError = function(value) {
        var firstError = rules === null || rules === void 0 ? void 0 : rules.find(function(param) {
            var regex = param.regex, required = param.required;
            if (required) {
                return (0,isEmpty/* default */.Z)(value);
            }
            return (0,isArray/* default */.Z)(value) ? value.some(function(item) {
                return !(regex === null || regex === void 0 ? void 0 : regex.test(item));
            }) : !(regex === null || regex === void 0 ? void 0 : regex.test(value));
        });
        return firstError ? firstError === null || firstError === void 0 ? void 0 : firstError.message : undefined;
    };
    var handleChange = (0,react.useCallback)(function(param) {
        var value = param.value, error = param.error;
        var errorMessage = error ? error : getError(value);
        dispatch({
            type: "nodeChange",
            index: index,
            node: {
                value: value,
                error: errorMessage
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dispatch,
        index
    ]);
    return (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NodeComponent, {
            onChange: handleChange,
            className: (index_module_default()).node
        });
    }, [
        NodeComponent,
        handleChange
    ]);
};
/* harmony default export */ var Conditions_Node = (Node);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Conditions/index.tsx










var Conditions_Conditions = function(param) {
    var _minLength = param.minLength, minLength = _minLength === void 0 ? 1 : _minLength, _checkUrl = param.checkUrl, checkUrl = _checkUrl === void 0 ? true : _checkUrl;
    var ref = useConditionGroup_useConditionGroup(), conditions = ref.state.conditions;
    return (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !(0,isEmpty/* default */.Z)(conditions) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                spacing: "sm",
                children: conditions.map(function(condition, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_ConditionContext.Provider, {
                        value: {
                            index: index,
                            condition: condition,
                            checkUrl: checkUrl
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (index_module_default()).condition,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UrlFilter_Conditions_Operator, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_Node, {})
                                    ]
                                }),
                                conditions.length > minLength && /*#__PURE__*/ (0,jsx_runtime.jsx)(UrlFilter_RemoveCondition, {
                                    index: index
                                })
                            ]
                        })
                    }, index);
                })
            }) : null
        });
    }, [
        conditions,
        checkUrl,
        minLength
    ]);
};
/* harmony default export */ var UrlFilter_Conditions = (Conditions_Conditions);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/Adder/index.tsx







var Adder_ConditionAdder = function() {
    var t = (0,useTranslation/* default */.Z)("componentConditionGroup").t;
    var ref = useConditionGroup_useConditionGroup(), conditions = ref.state.conditions, dispatch = ref.dispatch;
    var disabled = (0,react.useMemo)(function() {
        return maxLength <= conditions.length;
    }, [
        conditions.length
    ]);
    var handleAddClick = function() {
        dispatch({
            type: "addCondition",
            condition: defaultCondition
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        withArrow: true,
        disabled: !disabled,
        position: "top-start",
        label: t("maxConditionCount", {
            count: maxLength
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Button/* AddButton */.HS, {
                disabled: disabled,
                mt: "sm",
                onClick: handleAddClick,
                text: t("addCondition")
            })
        })
    });
};
/* harmony default export */ var UrlFilter_Adder = (Adder_ConditionAdder);

;// CONCATENATED MODULE: ./src/components/business/UrlFilter/index.tsx








var UrlFilter = function(props) {
    var value = props.value, onChange = props.onChange, checkUrl = props.checkUrl;
    var initialValue = (0,react.useMemo)(function() {
        var ref;
        if (value === null || value === void 0 ? void 0 : (ref = value.conditions) === null || ref === void 0 ? void 0 : ref.length) {
            var ref1;
            var conditions = value === null || value === void 0 ? void 0 : (ref1 = value.conditions) === null || ref1 === void 0 ? void 0 : ref1.map(function(c) {
                return {
                    operator: c.operator,
                    node: {
                        value: c.value
                    }
                };
            });
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, value), {
                conditions: conditions
            });
        }
        var _defaultValue;
        return (_defaultValue = props.defaultValue) !== null && _defaultValue !== void 0 ? _defaultValue : defaultValue;
    }, [
        props.defaultValue,
        value
    ]);
    var handleChange = (0,react.useCallback)(function(data) {
        onChange === null || onChange === void 0 ? void 0 : onChange(data);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionGroupContext_ConditionGroupProvider, {
            defaultValue: initialValue,
            onChange: handleChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UrlFilter_Conditions, {
                    minLength: props.minLength,
                    checkUrl: checkUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UrlFilter_Adder, {})
            ]
        });
    }, [
        initialValue,
        handleChange,
        props.minLength,
        checkUrl
    ]);
};
/* harmony default export */ var business_UrlFilter = (UrlFilter);

// EXTERNAL MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankDesktopCampaigns/index.tsx
var BlankDesktopCampaigns = __webpack_require__(27443);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image_Image = __webpack_require__(31463);
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/images/ios-feedback.png
/* harmony default export */ var ios_feedback = ({"src":"https://static-cny.howxm.com/_next/static/media/ios-feedback.bd772d2b.png","height":640,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AOru+O/n3eLe2pan0XuXzZap4crJ8uHk9wDq7/nt6e2OyNcAxeQAy+pgvuHY1PHm6vkA6e757/H83u320Or10+754vD36+z46Oz5AOnt+fL0+f/75f/33//44P/++PD0/Ont+ADq7vnv8fnJ2uCxzNiru86/ydPv8vvp7vmrQmfFps6NOgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/images/ios-survey.png
/* harmony default export */ var ios_survey = ({"src":"https://static-cny.howxm.com/_next/static/media/ios-survey.202d1ab9.png","height":640,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AOnu+eTm+LDE5nacz2eSzZSo4cvJ8uHk9wDt8fr19frM4erF4enE6PBxweHV0vDl6vkA7vL6+vr5//37//38+Pr7u9jo7u/67PD6AOvw+vLz+bvU4eju8Pf19Pz28fv48/H0+wDq7/rs7viBuM+qytu6xdbGztbz9Pjt8fpZ2GmSAiiaiAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/images/android-feedback.png
/* harmony default export */ var android_feedback = ({"src":"https://static-cny.howxm.com/_next/static/media/android-feedback.a88657d7.png","height":640,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAhElEQVR42hXLsQ6CMBAA0LteS9Q4SIgGBoKTOLj5bf6cn+Dm4OLgLNGgBjRpe70K88vDprXs4vnaXB7eOLcytKnyZZEoRDRKjrY/VNlkP1vXzyxl0oTDSDR2wb+cCJmFgrkgQ9QAQCqW03fJHhSAyT8/EssjhACnm7t31rbfIu132xoQ/7vpNp3N9m6CAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/images/android-survey.png
/* harmony default export */ var android_survey = ({"src":"https://static-cny.howxm.com/_next/static/media/android-survey.f20b1b8e.png","height":640,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AOnt+eTm+Ku+33io22mf2ZKl3svK8uHk9wDt8fr19frK3ubG6PLF7vl2vd3W0/Hl6vkA7vH6+vr5//78//z7+Pj5v9jn7+/66+/6AOvv+vLz+bvT4Oju8ff29fz28fr48/H0+wDq7vrs7viCt82qy9y5xtnJz9jz9Pjt8PpsrGnIUAhXVwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/images/wechat-miniapp-feedback.png
/* harmony default export */ var wechat_miniapp_feedback = ({"src":"https://static-cny.howxm.com/_next/static/media/wechat-miniapp-feedback.a6b7e2a2.png","height":640,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42g3LuwrCMBQA0PvzLv6Au26KgpOLSEFBUKFgVazE1kKU5tmGRvMgEHv2A7TxFdaTpBjM8+H0Ml7kp6OqsAGhQl5yWCNI1ehRba/7AnFMPPSDNQaJ35nqlNuntJTZmjuoheu+PoZ3NK9oyxhtqwMRFljrP6xbZWh5uM+S22aXSeWIdH+0DWfVb1r6UgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/images/wechat-miniapp-survey.png
/* harmony default export */ var wechat_miniapp_survey = ({"src":"https://static-cny.howxm.com/_next/static/media/wechat-miniapp-survey.7814c243.png","height":640,"width":1040,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/AOrv+t7h85S73XKp2V6i2Iyn3cvJ8eHk9wDu8vvv8fa/4OrI6fPF7/prwN/U0u/m6vkA7vH5/Pz7//77//z6+Pj5utjo7e757PD6AO7x++js8qfO3+vv8vb19Pz38fv48/D0+wDt8fzb4u0vp8etyt25y+DFytby8/bt8fo4KGjBlctoawAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/BlankMobileCampaigns/index.tsx












var BlankMobileCampaigns_obj, _obj1, _obj2;
var ImageLink = {
    IOS_SWIFT: (BlankMobileCampaigns_obj = {}, (0,_define_property/* default */.Z)(BlankMobileCampaigns_obj, domain/* CampaignType.Survey */.mL.Survey, ios_survey.src), (0,_define_property/* default */.Z)(BlankMobileCampaigns_obj, domain/* CampaignType.Feedback */.mL.Feedback, ios_feedback.src), (0,_define_property/* default */.Z)(BlankMobileCampaigns_obj, domain/* CampaignType.Notification */.mL.Notification, ios_feedback.src), BlankMobileCampaigns_obj),
    ANDROID: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, domain/* CampaignType.Survey */.mL.Survey, android_survey.src), (0,_define_property/* default */.Z)(_obj1, domain/* CampaignType.Feedback */.mL.Feedback, android_feedback.src), (0,_define_property/* default */.Z)(_obj1, domain/* CampaignType.Notification */.mL.Notification, android_feedback.src), _obj1),
    WECHAT_MINIAPP: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, domain/* CampaignType.Survey */.mL.Survey, wechat_miniapp_survey.src), (0,_define_property/* default */.Z)(_obj2, domain/* CampaignType.Feedback */.mL.Feedback, wechat_miniapp_feedback.src), (0,_define_property/* default */.Z)(_obj2, domain/* CampaignType.Notification */.mL.Notification, wechat_miniapp_feedback.src), _obj2)
};
var BlankMobileCampaigns = function(props) {
    var type = props.type, channel = props.channel, title = props.title, description = props.description;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        pt: 136,
        spacing: 0,
        align: "center",
        className: "flex-1",
        justify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 2,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                spacing: 0,
                mt: "md",
                children: description.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                        className: "w-[456px] text-center",
                        children: item
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                mt: "xl",
                mb: "xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                    width: 520,
                    height: 320,
                    alt: "",
                    src: ImageLink[channel][type],
                    className: "rounded-md overflow-hidden"
                })
            }),
            props.children
        ]
    });
};
/* harmony default export */ var BlankCampaigns_BlankMobileCampaigns = (BlankMobileCampaigns);

// EXTERNAL MODULE: ./src/components/business/hooks/useApplicationInfoBaseInfoCache.ts
var useApplicationInfoBaseInfoCache = __webpack_require__(51945);
// EXTERNAL MODULE: ./src/utils/applicationUtils.ts
var applicationUtils = __webpack_require__(13090);
;// CONCATENATED MODULE: ./src/components/business/Campaign/BlankCampaigns/index.tsx








var BlankCampaigns = function(props) {
    var ref = (0,useApplicationInfoBaseInfoCache/* default */.Z)(), application = ref.application, channel = ref.channel;
    var isCurrentMobileDistribution = (0,applicationUtils/* isMobileDistribution */._Z)(application);
    if (!channel) {
        return null;
    }
    if (isCurrentMobileDistribution) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlankCampaigns_BlankMobileCampaigns, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            channel: channel
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlankDesktopCampaigns/* default */.Z, (0,src_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var Campaign_BlankCampaigns = (BlankCampaigns);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(97684);
// EXTERNAL MODULE: ./src/components/business/Campaign/Filter/CampaignFilterContext/index.ts + 3 modules
var CampaignFilterContext = __webpack_require__(47593);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/EntriesContext/index.ts + 3 modules
var EntriesContext = __webpack_require__(16426);
// EXTERNAL MODULE: ./src/components/business/Campaign/CampaignContext/index.ts + 3 modules
var CampaignContext = __webpack_require__(39624);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Center/Center.js + 1 modules
var Center = __webpack_require__(91004);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/ReplyCell.tsx







var ReplyCell = function(param) {
    var hasReply = param.renderedCellValue;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var wrapperClasses = classnames_default()("cursor-pointer group-hover:visible", {
        visible: hasReply,
        invisible: !hasReply
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        label: t("list.replyTooltip"),
        withArrow: true,
        withinPortal: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
            w: 18,
            h: 18,
            className: wrapperClasses,
            sx: function(theme) {
                return {
                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)(hasReply ? "orange.0" : "brandBlue.0", theme),
                    borderRadius: "".concat(theme.radius.xs, " 0 0 ").concat(theme.radius.xs)
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: "reply",
                size: 12,
                style: {
                    color: (0,getColor/* getTextColor */.uu)(hasReply ? "orange.6" : "brandBlue.9", theme)
                }
            })
        })
    });
};
/* harmony default export */ var Cells_ReplyCell = (ReplyCell);

// EXTERNAL MODULE: ./src/components/ui/TableCell/index.tsx
var TableCell = __webpack_require__(24645);
// EXTERNAL MODULE: ./src/config/constants/fieldType.ts
var constants_fieldType = __webpack_require__(68123);
// EXTERNAL MODULE: ./src/utils/fieldUtils.ts
var fieldUtils = __webpack_require__(55242);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/constants.ts
var Entries_constants = __webpack_require__(10122);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/CommentCountCell.tsx








var CommentsCountCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var noComment = (0,isNil/* default */.Z)(renderedCellValue) || renderedCellValue === 0;
    var wrapperClasses = classnames_default()("group-hover:visible", {
        visible: !noComment,
        invisible: noComment
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        label: noComment ? t("list.commentsCount.noComment") : t("list.commentsCount.hasComment"),
        withArrow: true,
        withinPortal: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
            className: wrapperClasses,
            sx: function(theme) {
                return {
                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme),
                    borderRadius: "0 ".concat(theme.radius.xs, " ").concat(theme.radius.xs, " 0"),
                    textAlign: "center",
                    minWidth: "20px",
                    height: "18px",
                    cursor: "pointer"
                };
            },
            children: noComment ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: "wechat",
                size: 12,
                style: {
                    color: (0,getColor/* getTextColor */.uu)("brandBlue.9", theme)
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                size: "xs",
                color: (0,getColor/* getTextColor */.uu)("brandBlue.9", theme),
                children: renderedCellValue > 99 ? "99+" : renderedCellValue
            })
        })
    });
};
/* harmony default export */ var CommentCountCell = (CommentsCountCell);

// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/CsatFieldCell.tsx
var CsatFieldCell = __webpack_require__(7507);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/DateCell.tsx




var DateCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    if (!renderedCellValue) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        children: (0,utils/* formatISOTimeOrNull */.y7)(renderedCellValue)
    });
};
/* harmony default export */ var Cells_DateCell = (DateCell);

// EXTERNAL MODULE: ./src/components/business/HelpDoc/index.tsx
var HelpDoc = __webpack_require__(75801);
// EXTERNAL MODULE: ./src/components/ui/TableHeaderCell/index.tsx
var TableHeaderCell = __webpack_require__(17559);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/HeaderComponent.tsx







var submitOnCode = "entry.submittedOn";
var hideIconCodes = [
    "entry.serialNumber"
];
var HeaderComponent = function(param) {
    var column = param.column;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var type = column.columnDef.type;
    var fieldCode = column.columnDef.id;
    var isSubmitOnField = type === submitOnCode;
    var isIconHidden = hideIconCodes.includes(type);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "xs",
        noWrap: true,
        children: [
            !isIconHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryIcon/* default */.Z, {
                type: type,
                fieldCode: fieldCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderCell/* default */.Z, {
                children: column.columnDef.header
            }),
            isSubmitOnField && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpDoc/* default */.Z, {
                content: t("entrySubmittedOnTip"),
                width: 400
            })
        ]
    });
};
/* harmony default export */ var Cells_HeaderComponent = (HeaderComponent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(36078);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-intersection/use-intersection.js
var use_intersection = __webpack_require__(80818);
// EXTERNAL MODULE: ./node_modules/.pnpm/yet-another-react-lightbox@2.4.3_patch_hash=jifarsun7c2slwvyc2z5p5mpxa_react-dom@18.2.0_react@18.2.0/node_modules/yet-another-react-lightbox/dist/index.js + 33 modules
var dist = __webpack_require__(461);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/ImageCell.tsx






var ImageCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], ref1 = ref[1], close = ref1.close, open = ref1.open;
    var ref2 = (0,use_intersection/* useIntersection */.s)(), ref3 = ref2.ref, entry = ref2.entry;
    var handleClick = function(event) {
        event.stopPropagation();
        open();
    };
    if (!renderedCellValue) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                width: "auto",
                height: 32,
                miw: 32,
                src: (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) ? renderedCellValue : "",
                alt: "",
                onClick: handleClick,
                imageProps: {
                    className: "preventCellClick"
                },
                className: "cursor-pointer",
                ref: ref3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                open: opened,
                close: close,
                slides: [
                    {
                        src: renderedCellValue
                    }
                ],
                carousel: {
                    finite: true
                }
            })
        ]
    });
};
/* harmony default export */ var Cells_ImageCell = (ImageCell);

// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/NumericCell.tsx
var NumericCell = __webpack_require__(84157);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/RatingCell.tsx
var RatingCell = __webpack_require__(45718);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/RefererCell.tsx


var RefererCell = function(props) {
    var renderedCellValue = props.renderedCellValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* UrlWithTooltip */.wr, {
        url: renderedCellValue
    });
};
/* harmony default export */ var Cells_RefererCell = (RefererCell);

// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/SelectableFieldCell.tsx
var SelectableFieldCell = __webpack_require__(82293);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(27681);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/SerialNumberBodyCell.tsx






var SerialNumberBodyCell = function(props) {
    var ref;
    var row = props.row, renderedCellValue = props.renderedCellValue;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var deletable = (0,Campaign_hooks/* useCampaignPermission */.L9)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.id).deletable;
    var toggleChecked = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        row.toggleSelected();
    }, [
        row
    ]);
    var isRowSelected = row.getIsSelected();
    var textClasses = classnames_default()("", {
        "group-hover:invisible": deletable,
        visible: !isRowSelected,
        invisible: isRowSelected
    });
    var checkboxClasses = classnames_default()("absolute left-0 group-hover:visible", {
        invisible: !isRowSelected,
        visible: isRowSelected
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Center/* Center */.M, {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: textClasses,
                children: renderedCellValue
            }),
            deletable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                className: checkboxClasses,
                checked: isRowSelected,
                onChange: toggleChecked,
                size: "xs"
            })
        ]
    });
};
/* harmony default export */ var Cells_SerialNumberBodyCell = (SerialNumberBodyCell);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/SerialNumberHeaderCell.tsx








var SerialNumberHeaderCell = function(props) {
    var ref;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var table = props.table;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var deletable = (0,Campaign_hooks/* useCampaignPermission */.L9)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.id).deletable;
    var toggleChecked = (0,react.useCallback)(function() {
        table.toggleAllPageRowsSelected();
    }, [
        table
    ]);
    var isAllRowsSelected = table.getIsAllRowsSelected();
    var isSomeRowsSelected = table.getIsSomePageRowsSelected();
    var textClasses = classnames_default()("", {
        "group-hover:invisible": deletable,
        visible: !isAllRowsSelected && !isSomeRowsSelected,
        invisible: isAllRowsSelected || isSomeRowsSelected
    });
    var checkboxClasses = classnames_default()("absolute left-0 group-hover:visible", {
        invisible: !isAllRowsSelected && !isSomeRowsSelected,
        visible: isAllRowsSelected || isSomeRowsSelected
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Center/* Center */.M, {
        className: "group relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderCell/* default */.Z, {
                className: textClasses,
                children: t("entry:list.serialNumber")
            }),
            deletable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                className: checkboxClasses,
                checked: isAllRowsSelected,
                onChange: toggleChecked,
                indeterminate: isSomeRowsSelected,
                size: "xs"
            })
        ]
    });
};
/* harmony default export */ var Cells_SerialNumberHeaderCell = (SerialNumberHeaderCell);

// EXTERNAL MODULE: ./src/components/business/Campaign/EntryModal/Content/components/ImageGroup.tsx
var ImageGroup = __webpack_require__(18390);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/Cells/TextAreaFieldCell.tsx




var TextAreaFieldCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        noWrap: true,
        position: "apart",
        w: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    lineClamp: 10,
                    className: "max-w-[448px] whitespace-pre-line",
                    children: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.text
                }),
                withinPortal: true,
                multiline: true,
                position: "bottom-start",
                openDelay: 1500,
                offset: -10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: "truncate",
                    children: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.text
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGroup/* default */.Z, {
                images: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.screenshots,
                size: 32
            })
        ]
    });
};
/* harmony default export */ var Cells_TextAreaFieldCell = (TextAreaFieldCell);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/utils/getColumns.ts
























function calcShownFields(fields) {
    return fields.filter(function(filed) {
        return !Entries_constants/* HIDDEN_FIELD_TYPES.includes */.B0.includes(filed.type);
    });
}
function getBasicDef(field) {
    return {
        header: field.label,
        accessorFn: function(row) {
            return row === null || row === void 0 ? void 0 : row[field.code];
        },
        id: field.code,
        type: field.type,
        minSize: 120,
        size: 300,
        Cell: TableCell/* DefaultCell */.G,
        Header: Cells_HeaderComponent
    };
}
function getCustomCellByFieldType(fieldType) {
    var Cell;
    switch(fieldType){
        case constants_fieldType/* AttributeFieldType.DateTimeField */.XH.DateTimeField:
            Cell = Cells_DateCell;
            break;
        case domain/* FormFieldType.NpsField */.EIl.NpsField:
        case domain/* FormFieldType.CesField */.EIl.CesField:
            Cell = NumericCell/* default */.Z;
            break;
        case constants_fieldType/* CHECK_BOX */.cL:
        case constants_fieldType/* RADIO_BUTTON */.H0:
        case constants_fieldType/* DROP_DOWN */.BQ:
        case constants_fieldType/* CTA_FIELD */.PW:
            Cell = SelectableFieldCell/* default */.Z;
            break;
        case domain/* FormFieldType.TextArea */.EIl.TextArea:
            Cell = Cells_TextAreaFieldCell;
            break;
        case domain/* FormFieldType.RatingField */.EIl.RatingField:
            Cell = RatingCell/* default */.Z;
            break;
        case domain/* FormFieldType.CsatField */.EIl.CsatField:
            Cell = CsatFieldCell/* default */.Z;
            break;
        case domain/* FormFieldType.ScreenshotField */.EIl.ScreenshotField:
            Cell = Cells_ImageCell;
            break;
        default:
            return undefined;
    }
    return Cell;
}
function fieldsToColumnDefs(fields) {
    return calcShownFields(fields).map(function(field) {
        var customCell = getCustomCellByFieldType(field.type);
        if (!(0,isNil/* default */.Z)(customCell)) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getBasicDef(field)), {
                Cell: customCell
            });
        }
        return getBasicDef(field);
    });
}
var customerId = function(t) {
    return {
        header: t("customer:customer_uid"),
        id: config_constants/* CUSTOMER_UID */.tv,
        accessorKey: config_constants/* CUSTOMER_UID */.tv,
        type: config_constants/* CUSTOMER_UID */.tv,
        minSize: 100,
        Header: Cells_HeaderComponent
    };
};
var customerName = function(t) {
    return {
        header: t("customer:customer_name"),
        id: config_constants/* CUSTOMER_NAME */.rl,
        accessorKey: config_constants/* CUSTOMER_NAME */.rl,
        type: config_constants/* CUSTOMER_NAME */.rl,
        minSize: 60,
        Header: Cells_HeaderComponent
    };
};
var customerMobile = function(t) {
    return {
        header: t("customer:customer_mobile"),
        id: config_constants/* CUSTOMER_MOBILE */.L,
        accessorKey: config_constants/* CUSTOMER_MOBILE */.L,
        type: config_constants/* CUSTOMER_MOBILE */.L,
        minSize: 60,
        Header: Cells_HeaderComponent
    };
};
var customerEmail = function(t) {
    return {
        header: t("customer:customer_email"),
        id: config_constants/* CUSTOMER_EMAIL */.n,
        accessorKey: config_constants/* CUSTOMER_EMAIL */.n,
        type: config_constants/* CUSTOMER_EMAIL */.n,
        minSize: 60,
        Header: Cells_HeaderComponent
    };
};
var createdAt = function(t, widgetType) {
    return {
        header: widgetType === domain/* CampaignWidgetType.Banner */.YMh.Banner ? t("entry:list.clickedAt") : t("entry:list.createdAt"),
        id: "entry.createdAt",
        accessorKey: "entry.createdAt",
        type: "entry.createdAt",
        Header: Cells_HeaderComponent
    };
};
var submittedOn = function(t) {
    return {
        header: t("entry:list.submittedOn"),
        id: "entry.submittedOn",
        accessorKey: "entry.submittedOn",
        type: "entry.submittedOn",
        size: 160,
        Header: Cells_HeaderComponent
    };
};
var deliveryMethod = function(t) {
    return {
        header: t("entry:list.deliveryMethod"),
        id: "entry.deliveryMethod",
        accessorKey: "entry.deliveryMethod",
        type: "entry.deliveryMethod",
        size: 130,
        Header: Cells_HeaderComponent
    };
};
var region = function(t) {
    return {
        header: t("entry:list.region"),
        id: "entry.region",
        accessorKey: "entry.region",
        field: "entry.region",
        size: 200,
        Header: Cells_HeaderComponent
    };
};
var browser = function(t) {
    return {
        header: t("entry:list.browser"),
        id: "entry.browser",
        accessorKey: "entry.browser",
        type: "entry.browser",
        size: 160,
        Header: Cells_HeaderComponent
    };
};
var os = function(t) {
    return {
        header: t("entry:list.os"),
        id: "entry.os",
        accessorKey: "entry.os",
        type: "entry.os",
        size: 160,
        Header: Cells_HeaderComponent
    };
};
var ip = function(t) {
    return {
        header: t("entry:list.ip"),
        id: "entry.ip",
        accessorKey: "entry.ip",
        type: "entry.ip",
        size: 160,
        Header: Cells_HeaderComponent
    };
};
var screenResolution = function(t) {
    return {
        header: t("entry:list.screenResolution"),
        id: "entry.screenResolution",
        accessorKey: "entry.screenResolution",
        type: "entry.screenResolution",
        size: 110,
        Header: Cells_HeaderComponent
    };
};
var referer = function(t) {
    return {
        header: t("entry:list.referer"),
        id: "entry.referer",
        type: "entry.referer",
        Cell: Cells_RefererCell,
        Header: Cells_HeaderComponent,
        size: 200
    };
};
var fillingDuration = function(t) {
    return {
        header: t("entry:list.fillingDuration"),
        id: "entry.fillingDuration",
        type: "entry.fillingDuration",
        Header: Cells_HeaderComponent,
        size: 130
    };
};
var commonDisabledColumnConfig = {
    enableColumnDragging: false,
    enableColumnOrdering: false,
    enableResizing: false
};
function getColumns(params) {
    var _columns, _columns1, _columns2;
    var t = params.t, fields = params.fields, removedFields = params.removedFields, widgetType = params.widgetType;
    var ref = (0,fieldUtils/* groupFields */.wm)(fields), formFields = ref.formFields, customerFields = ref.customerFields, sceneFields = ref.sceneFields;
    var columns = [
        (0,src_object_spread/* default */.Z)({
            id: Entries_constants/* SERIAL_NUMBER_CODE */.As,
            accessorFn: function(param) {
                var entry = param.entry;
                return entry === null || entry === void 0 ? void 0 : entry[config_constants/* SERIAL_NUMBER */.A2];
            },
            header: t("entry:list.serialNumber"),
            size: 66,
            Cell: Cells_SerialNumberBodyCell,
            Header: Cells_SerialNumberHeaderCell,
            mantineTableBodyCellProps: {
                sx: {
                    borderRight: "none !important"
                }
            },
            mantineTableHeadCellProps: {
                sx: {
                    borderRight: "none !important"
                }
            }
        }, commonDisabledColumnConfig),
        (0,src_object_spread/* default */.Z)({
            id: Entries_constants/* REPLY_CODE */.Vt,
            accessorFn: function(param) {
                var entry = param.entry;
                return entry === null || entry === void 0 ? void 0 : entry[config_constants/* HAS_REPLY */.fN];
            },
            header: "",
            size: 30,
            minSize: 30,
            Cell: Cells_ReplyCell,
            mantineTableBodyCellProps: {
                sx: {
                    borderRight: "none !important",
                    paddingRight: "2px !important"
                }
            },
            mantineTableHeadCellProps: {
                sx: {
                    borderRight: "none !important",
                    paddingRight: "2px !important"
                }
            }
        }, commonDisabledColumnConfig),
        (0,src_object_spread/* default */.Z)({
            id: Entries_constants/* COMMENTS_COUNT_CODE */.f4,
            accessorFn: function(param) {
                var entry = param.entry;
                return entry === null || entry === void 0 ? void 0 : entry[config_constants/* COMMENTS_COUNT */.q];
            },
            header: "",
            size: 40,
            Cell: CommentCountCell,
            mantineTableBodyCellProps: {
                sx: {
                    borderRight: "none !important",
                    paddingLeft: "0 !important"
                }
            },
            mantineTableHeadCellProps: {
                sx: {
                    borderRight: "none !important",
                    paddingLeft: "0 !important"
                }
            }
        }, commonDisabledColumnConfig), 
    ];
    (_columns = columns).push.apply(_columns, (0,_to_consumable_array/* default */.Z)(fieldsToColumnDefs(formFields)));
    columns.push(customerId(t));
    columns.push(customerName(t));
    columns.push(customerMobile(t));
    columns.push(customerEmail(t));
    (_columns1 = columns).push.apply(_columns1, (0,_to_consumable_array/* default */.Z)(fieldsToColumnDefs(customerFields)));
    (_columns2 = columns).push.apply(_columns2, (0,_to_consumable_array/* default */.Z)(fieldsToColumnDefs(sceneFields)));
    columns.push((0,src_object_spread/* default */.Z)({
        accessorFn: function(param) {
            var entry = param.entry;
            return (0,utils/* formatISOTime */.cx)(entry === null || entry === void 0 ? void 0 : entry.createdAt);
        }
    }, createdAt(t, widgetType)));
    columns.push((0,src_object_spread/* default */.Z)({
        accessorFn: function(param) {
            var entry = param.entry;
            return (entry === null || entry === void 0 ? void 0 : entry.submittedOn) === domain/* EntrySubmittedOn.Completed */.L6A.Completed ? t("entry:list.submittedOnValue.COMPLETE") : t("entry:list.submittedOnValue.EXPIRED");
        }
    }, submittedOn(t)));
    columns.push((0,src_object_spread/* default */.Z)({
        accessorFn: function(param) {
            var entry = param.entry;
            return (entry === null || entry === void 0 ? void 0 : entry.deliveryMethod) ? t("entry:list.deliveryMethodValue.".concat(entry === null || entry === void 0 ? void 0 : entry.deliveryMethod)) : "";
        }
    }, deliveryMethod(t)));
    columns.push((0,src_object_spread/* default */.Z)({
        accessorFn: function(param) {
            var entry = param.entry;
            return (0,utils/* formatTimeDuration */.J_)(t, entry === null || entry === void 0 ? void 0 : entry.fillingDuration);
        }
    }, fillingDuration(t)));
    columns.push((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, referer(t)), {
        accessorFn: function(param) {
            var entry = param.entry;
            return entry === null || entry === void 0 ? void 0 : entry[config_constants/* REFERER */.zZ];
        }
    }));
    columns.push((0,src_object_spread/* default */.Z)({
        accessorFn: function(param) {
            var entry = param.entry;
            return (0,utils/* getDisplayRegion */.M$)(entry === null || entry === void 0 ? void 0 : entry.region);
        }
    }, region(t)));
    columns.push(browser(t));
    columns.push(screenResolution(t));
    columns.push(os(t));
    columns.push(ip(t));
    return columns.filter(function(param) {
        var id = param.id;
        return !(removedFields === null || removedFields === void 0 ? void 0 : removedFields.includes(id));
    });
}

// EXTERNAL MODULE: ./src/components/business/Layouts/ApplicationLayout/ApplicationContext.ts
var ApplicationContext = __webpack_require__(89863);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/hooks/useColumns.ts







function useColumns(formFields) {
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var application = (0,react.useContext)(ApplicationContext/* default */.Z).application;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var shouldRemoveFields = (0,react.useMemo)(function() {
        if ((0,applicationUtils/* isMobileDistribution */._Z)(application)) {
            return Entries_constants/* MOBILE_HIDDEN_FIELDS */.Ee;
        } else if ((0,applicationUtils/* isLinkDistribution */.dQ)(application)) {
            return Entries_constants/* LINK_HIDDEN_FIELDS */.Wm;
        }
        return [];
    }, [
        application
    ]);
    return (0,react.useMemo)(function() {
        return getColumns({
            fields: formFields,
            t: t,
            removedFields: shouldRemoveFields,
            widgetType: campaign === null || campaign === void 0 ? void 0 : campaign.widget.type
        });
    }, [
        campaign === null || campaign === void 0 ? void 0 : campaign.widget.type,
        formFields,
        shouldRemoveFields,
        t
    ]);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/fromPairs.js
var fromPairs = __webpack_require__(14151);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/map.js
var map = __webpack_require__(26344);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/hooks/useHiddenColumns.ts








var defaultHiddenColumns = [
    config_constants/* CUSTOMER_NAME */.rl,
    config_constants/* CUSTOMER_MOBILE */.L,
    config_constants/* CUSTOMER_EMAIL */.n
];
function useHiddenColumns(initialHiddenColumn, allColumns) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpsertCampaignSettingMutation */.Gm1)(), 1), updateCampaignSettingMutation = ref[0];
    var campaignId = (0,next_router.useRouter)().query.campaignId;
    var ref1 = (0,react.useState)(initialHiddenColumn !== null && initialHiddenColumn !== void 0 ? initialHiddenColumn : defaultHiddenColumns), hiddenColumns = ref1[0], setHiddenColumns = ref1[1];
    var columnVisibility = (0,react.useMemo)(function() {
        return (0,fromPairs/* default */.Z)((0,map/* default */.Z)(hiddenColumns, function(field) {
            return [
                field,
                false
            ];
        }));
    }, [
        hiddenColumns
    ]);
    var handleHiddenColumnChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            updateCampaignSettingMutation({
                                variables: {
                                    input: {
                                        campaignId: campaignId,
                                        hiddenFields: value
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        setHiddenColumns(value);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleHiddenColumnChange(value) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!initialHiddenColumn) {
            handleHiddenColumnChange(defaultHiddenColumns).then();
        }
    // eslint-disable-next-line
    }, []);
    return {
        hiddenColumns: hiddenColumns,
        columnVisibility: columnVisibility,
        onHiddenColumnChange: handleHiddenColumnChange
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/difference.js
var difference = __webpack_require__(80551);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/hooks/useOrderedColumns.ts








function getInitialOrderFields(columns, orderedFields) {
    var allColumnIds = (0,map/* default */.Z)(columns, "id");
    var ref;
    var finalOrderedFields = (0,isEmpty/* default */.Z)(orderedFields) ? allColumnIds : (ref = orderedFields === null || orderedFields === void 0 ? void 0 : orderedFields.filter(function(field) {
        return field !== "mrt-row-select";
    })) !== null && ref !== void 0 ? ref : [];
    var notExistedInOrderedFields = (0,difference/* default */.Z)(allColumnIds, orderedFields !== null && orderedFields !== void 0 ? orderedFields : []);
    var otherNewFields = notExistedInOrderedFields === null || notExistedInOrderedFields === void 0 ? void 0 : notExistedInOrderedFields.filter(function(id) {
        var ref;
        return !((ref = [
            Entries_constants/* REPLY_CODE */.Vt,
            Entries_constants/* COMMENTS_COUNT_CODE */.f4
        ]) === null || ref === void 0 ? void 0 : ref.includes(id));
    });
    if (notExistedInOrderedFields.includes(Entries_constants/* REPLY_CODE */.Vt)) {
        finalOrderedFields === null || finalOrderedFields === void 0 ? void 0 : finalOrderedFields.splice(1, 0, Entries_constants/* REPLY_CODE */.Vt);
    }
    if (notExistedInOrderedFields.includes(Entries_constants/* COMMENTS_COUNT_CODE */.f4)) {
        finalOrderedFields === null || finalOrderedFields === void 0 ? void 0 : finalOrderedFields.splice(2, 0, Entries_constants/* COMMENTS_COUNT_CODE */.f4);
    }
    return finalOrderedFields.concat(otherNewFields);
}
function useOrderedColumns(columns, orderedFields) {
    var campaignId = (0,next_router.useRouter)().query.campaignId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpsertCampaignSettingMutation */.Gm1)(), 1), updateCampaignSettingMutation = ref[0];
    var ref1 = (0,react.useState)(function() {
        return getInitialOrderFields(columns, orderedFields);
    }), columnOrder = ref1[0], setColumnOrder = ref1[1];
    var handleColumnOrderChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            updateCampaignSettingMutation({
                                variables: {
                                    input: {
                                        campaignId: campaignId,
                                        orderedFields: value
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        setColumnOrder(value);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleColumnOrderChange(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        columnOrder: columnOrder,
        onColumnOrderChange: handleColumnOrderChange
    };
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/hooks/useRowSelection.ts


function useRowSelection() {
    var ref = (0,react.useState)({}), rowSelection = ref[0], setRowSelection = ref[1];
    var selectedRowsCount = (0,react.useMemo)(function() {
        return (0,size/* default */.Z)(rowSelection);
    }, [
        rowSelection
    ]);
    return {
        rowSelection: rowSelection,
        selectedRowsCount: selectedRowsCount,
        onRowSelectionChange: setRowSelection
    };
}

// EXTERNAL MODULE: ./src/components/business/Campaign/Filter/components/CreatedAtSelector/index.tsx + 2 modules
var CreatedAtSelector = __webpack_require__(99241);
// EXTERNAL MODULE: ./src/components/business/Campaign/Filter/utils/convertToValidConditionGroup.ts
var convertToValidConditionGroup = __webpack_require__(61577);
// EXTERNAL MODULE: ./src/components/business/Campaign/Filter/hooks/useEntryFilterableFields.tsx
var useEntryFilterableFields = __webpack_require__(6553);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconDatabase.js
var IconDatabase = __webpack_require__(59248);
;// CONCATENATED MODULE: ./src/utils/mantineStyles.ts

var subtleSelectStyle = function(theme) {
    return {
        wrapper: {
            "&:active": {
                transform: "translateY(1px)"
            }
        },
        icon: {
            paddingLeft: theme.spacing.sm,
            width: "26px"
        },
        input: {
            border: 0,
            borderRadius: theme.radius.xs,
            paddingLeft: "30px !important",
            paddingRight: theme.spacing.sm,
            height: 30,
            minHeight: 30,
            "&:hover": {
                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
            }
        },
        rightSection: {
            display: "none"
        },
        item: {
            borderRadius: theme.radius.xs
        }
    };
};

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/EntriesFilter/InputContentSelector/index.tsx













var filterAll = "ALL";
var InputContentSelector = function() {
    var ref, ref1;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var filter = (0,CampaignFilterContext/* useCampaignFilter */.aB)().filter;
    var onExplicitlyFieldChange = (0,CampaignFilterContext/* useCampaignFilterActions */.zl)().onExplicitlyFieldChange;
    var value = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2;
        return (ref2 = (ref1 = (ref = filter === null || filter === void 0 ? void 0 : filter.conditions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var firstNode = param.firstNode;
            return firstNode.value === constants_fieldType/* textareaCode */.wz;
        })) === null || ref1 === void 0 ? void 0 : ref1.operator) !== null && ref2 !== void 0 ? ref2 : filterAll;
    }, [
        filter
    ]);
    var options = (0,react.useMemo)(function() {
        return [
            filterAll,
            domain/* ConditionOperator.IsNotNull */.N0$.IsNotNull
        ].map(function(code) {
            return {
                label: t("entryContentInputType.".concat(code)),
                value: code
            };
        });
    }, [
        t
    ]);
    var widthMap = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* ConditionOperator.IsNotNull */.N0$.IsNotNull, {
            width: 168,
            ml: 6
        }), (0,_define_property/* default */.Z)(_obj, filterAll, {
            width: 98,
            ml: 42
        }), _obj;
    }, []);
    var onSelectChange = function(freshValue) {
        if (freshValue === domain/* ConditionOperator.IsNotNull */.N0$.IsNotNull) {
            onExplicitlyFieldChange(constants_fieldType/* textareaCode */.wz, {
                firstNode: {
                    value: constants_fieldType/* textareaCode */.wz
                },
                operator: freshValue,
                secondNode: {
                    value: ""
                }
            });
        } else {
            onExplicitlyFieldChange(constants_fieldType/* textareaCode */.wz, null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
        data: options,
        value: value,
        rightSectionWidth: 0,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDatabase/* default */.Z, {
            stroke: 1.5,
            size: 18,
            color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
        }),
        styles: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subtleSelectStyle(theme)), {
            root: {
                width: ((ref = widthMap[value]) === null || ref === void 0 ? void 0 : ref.width) || "auto"
            },
            dropdown: {
                width: "180px !important",
                marginLeft: (ref1 = widthMap[value]) === null || ref1 === void 0 ? void 0 : ref1.ml,
                borderRadius: 6
            }
        }),
        onChange: onSelectChange
    });
};
/* harmony default export */ var EntriesFilter_InputContentSelector = (InputContentSelector);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconStar.js
var IconStar = __webpack_require__(32011);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Rating/Rating.js + 6 modules
var Rating = __webpack_require__(33148);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/noop.js
var noop = __webpack_require__(77047);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/EntriesFilter/RatingSelector/DropDownComponent.tsx






var starData = (0,range/* default */.Z)(1, 6).reverse().map(String);
var DropDownComponent = function(param) {
    var closeDropDown = param.closeDropDown, propsValue = param.value;
    var t = (0,useTranslation/* default */.Z)().t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref = (0,react.useState)(propsValue), value = ref[0], setValue = ref[1];
    var selectedAll = value.length === 5;
    var noSelected = value.length === 0;
    var onClick = function(num) {
        return function() {
            if (value.includes(num)) {
                setValue(value.filter(function(n) {
                    return n !== num;
                }));
            } else {
                setValue(value.concat(num));
            }
        };
    };
    var onSelectAllClick = function() {
        setValue(selectedAll ? [] : starData);
    };
    var onConfirm = function() {
        if (noSelected) {
            return;
        }
        closeDropDown((0,_to_consumable_array/* default */.Z)(value).sort());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                justify: "flex-start",
                spacing: "lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center cursor-pointer",
                        onClick: onSelectAllClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                checked: selectedAll,
                                onChange: noop/* default */.Z,
                                classNames: {
                                    root: "flex"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: theme.colorScheme === "dark" ? "#C1C2C5" : "#333",
                                mb: -2,
                                className: "cursor-pointer",
                                ml: 10,
                                children: t("common:actions.checkAll")
                            })
                        ]
                    }),
                    starData.map(function(num) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            onClick: onClick(num),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                                    checked: value.includes(num),
                                    onChange: noop/* default */.Z,
                                    classNames: {
                                        root: "flex"
                                    }
                                }, num),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center cursor-pointer ml-[10px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                            value: parseInt(num, 10),
                                            size: "xs"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            color: theme.colorScheme === "dark" ? "#C1C2C5" : "#333",
                                            ml: "sm",
                                            children: t("componentEntryFilter:star", {
                                                num: parseInt(num, 10)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, num);
                    })
                ]
            }),
            noSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: "red",
                mt: "xs",
                size: 12,
                children: t("componentEntryFilter:chooseAtLeastOneItem")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                onClick: onConfirm,
                mt: 16,
                children: t("common:actions.confirm")
            })
        ]
    });
};
var getDropDownComponent = function(closeDropDown, value) {
    return /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            ref: ref,
            p: 12,
            className: "w-full",
            component: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownComponent, {
                closeDropDown: closeDropDown,
                value: value
            })
        });
    });
};

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/EntriesFilter/RatingSelector/ValueComponent.tsx




var ValueComponent = function(param) {
    var value = param.value, values = param.values;
    var t = (0,useTranslation/* default */.Z)("componentEntryFilter").t;
    var isSelectedAll = values.length === 5;
    if (isSelectedAll) {
        return value === "1" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            children: t("allStar")
        }) : null;
    }
    var isLast = values.slice(-1)[0] === value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
        children: [
            t("star", {
                num: value
            }),
            isLast ? "" : ","
        ]
    });
};
var getValueComponent = function(values) {
    return function(param) {
        var value = param.value;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueComponent, {
            value: value,
            values: values
        });
    };
};
/* harmony default export */ var RatingSelector_ValueComponent = ((/* unused pure expression or super */ null && (ValueComponent)));

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/EntriesFilter/RatingSelector/index.tsx














var RatingSelector_defaultValue = [
    "1",
    "2",
    "3",
    "4",
    "5"
];
var options = (0,range/* default */.Z)(1, 7).map(String);
var RatingSelector = function() {
    var selectRef = (0,react.useRef)(null);
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var filter = (0,CampaignFilterContext/* useCampaignFilter */.aB)().filter;
    var onExplicitlyFieldChange = (0,CampaignFilterContext/* useCampaignFilterActions */.zl)().onExplicitlyFieldChange;
    var value = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var ref3;
        return (ref3 = (ref1 = (ref = filter === null || filter === void 0 ? void 0 : filter.conditions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var firstNode = param.firstNode;
            return firstNode.value === constants_fieldType/* ratingCode */.KU;
        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.secondNode) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref3 !== void 0 ? ref3 : RatingSelector_defaultValue;
    }, [
        filter
    ]);
    var handleCloseDropDown = function(freshValue) {
        var ref;
        if ((0,isEqual/* default */.Z)(freshValue, RatingSelector_defaultValue)) {
            onExplicitlyFieldChange(constants_fieldType/* ratingCode */.KU, null);
        } else {
            onExplicitlyFieldChange(constants_fieldType/* ratingCode */.KU, {
                operator: domain/* ConditionOperator.Include */.N0$.Include,
                firstNode: {
                    value: constants_fieldType/* ratingCode */.KU
                },
                secondNode: {
                    value: freshValue
                }
            });
        }
        (ref = selectRef.current) === null || ref === void 0 ? void 0 : ref.blur();
    };
    // todo: so magic
    var dropDownMarginLeftSet = [
        70,
        57,
        45,
        0,
        53
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect/* MultiSelect */.NU, {
        radius: "xs",
        data: options,
        value: value,
        dropdownComponent: getDropDownComponent(handleCloseDropDown, value),
        valueComponent: getValueComponent(value),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStar/* default */.Z, {
            stroke: 1.5,
            size: 18,
            color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
        }),
        styles: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, subtleSelectStyle(theme)), {
            searchInput: {
                minWidth: 0
            },
            dropdown: {
                width: "200px!important",
                marginLeft: dropDownMarginLeftSet[value.length - 1] || "32px"
            },
            values: {
                minHeight: 30
            }
        }),
        ref: selectRef,
        maxDropdownHeight: 500
    });
};
/* harmony default export */ var EntriesFilter_RatingSelector = (RatingSelector);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Filter/EntriesFilter/index.tsx















var EntriesFilter = function(props) {
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var fields = props.fields;
    var customerAttributes = useGetApplicationCustomerAttributes();
    var getFilterableFields = (0,useEntryFilterableFields/* default */.Z)();
    var filter = (0,CampaignFilterContext/* useCampaignFilter */.aB)().filter;
    var onFieldsChange = (0,CampaignFilterContext/* useCampaignFilterActions */.zl)().onFieldsChange;
    var isFeedback = (campaign === null || campaign === void 0 ? void 0 : campaign.type) === domain/* CampaignType.Feedback */.mL.Feedback;
    var explicitlyFieldCodes = (0,react.useMemo)(function() {
        return isFeedback ? [
            constants_fieldType/* createdAtCode */.h1,
            constants_fieldType/* textareaCode */.wz,
            constants_fieldType/* ratingCode */.KU,
            constants_fieldType/* keywordCode */.__
        ] : [
            constants_fieldType/* createdAtCode */.h1,
            constants_fieldType/* keywordCode */.__
        ];
    }, [
        isFeedback
    ]);
    var fieldsFilterValue = (0,react.useMemo)(function() {
        var ref;
        var conditions = (ref = filter === null || filter === void 0 ? void 0 : filter.conditions) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
            var firstNode = param.firstNode;
            return !explicitlyFieldCodes.includes(firstNode.value);
        });
        return (0,convertToValidConditionGroup/* convertToFieldFilterPopoverValue */.b)({
            operator: domain/* ConditionGroupOperator.And */.ZOu.And,
            conditions: conditions
        });
    }, [
        explicitlyFieldCodes,
        filter === null || filter === void 0 ? void 0 : filter.conditions
    ]);
    var onFieldFilterPopoverChange = function(conditionGroup) {
        onFieldsChange(explicitlyFieldCodes, (0,convertToValidConditionGroup/* default */.Z)(conditionGroup).conditions);
    };
    // feedback: hidden all form field;  survey: show all (form field、customer、scene)
    var filterableFields = getFilterableFields(fields.filter(function(f) {
        return isFeedback ? !(0,fieldUtils/* isFormField */.sw)(f.code) : true;
    }), customerAttributes);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "xs",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatedAtSelector/* default */.Z, {}),
            isFeedback && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EntriesFilter_RatingSelector, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EntriesFilter_InputContentSelector, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldFilterPopover/* default */.Z, {
                value: fieldsFilterValue,
                campaignFields: filterableFields,
                onChange: onFieldFilterPopoverChange
            })
        ]
    });
};
/* harmony default export */ var Filter_EntriesFilter = (EntriesFilter);

// EXTERNAL MODULE: ./src/components/business/HiddenColumns/index.tsx + 1 modules
var HiddenColumns = __webpack_require__(83598);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-input-state/use-input-state.js
var use_input_state = __webpack_require__(85181);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-previous/use-previous.js
var use_previous = __webpack_require__(1318);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconSearch.js
var IconSearch = __webpack_require__(23526);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/KeywordSearch/index.tsx










var KeywordSearch = function() {
    var t = (0,useTranslation/* default */.Z)("common").t;
    var filter = (0,CampaignFilterContext/* useCampaignFilter */.aB)().filter;
    var onExplicitlyFieldChange = (0,CampaignFilterContext/* useCampaignFilterActions */.zl)().onExplicitlyFieldChange;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_input_state/* useInputState */.U)(""), 2), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(keyword, 400), 1), debounced = ref1[0];
    var previousValue = (0,use_previous/* usePrevious */.D)(debounced);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var ref3;
        setKeyword((ref3 = (ref1 = (ref = filter === null || filter === void 0 ? void 0 : filter.conditions) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var firstNode = param.firstNode;
            return firstNode.value === constants_fieldType/* keywordCode */.__;
        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.secondNode) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref3 !== void 0 ? ref3 : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter === null || filter === void 0 ? void 0 : filter.conditions
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = previousValue === null || previousValue === void 0 ? void 0 : previousValue.trim()) !== null && ref !== void 0 ? ref : "") === debounced.trim()) {
            return;
        }
        if (debounced.trim() == "") {
            onExplicitlyFieldChange(constants_fieldType/* keywordCode */.__, null);
        } else {
            onExplicitlyFieldChange(constants_fieldType/* keywordCode */.__, {
                operator: domain/* ConditionOperator.Contains */.N0$.Contains,
                firstNode: {
                    value: constants_fieldType/* keywordCode */.__
                },
                secondNode: {
                    value: debounced.trim()
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debounced
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
        size: "xs",
        w: 160,
        placeholder: t("placeholders.search"),
        "data-autofocus": true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* default */.Z, {
            size: 16
        }),
        value: keyword,
        onChange: setKeyword
    });
};
/* harmony default export */ var HandleBar_KeywordSearch = (KeywordSearch);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Popover/Popover.js + 7 modules
var Popover = __webpack_require__(4502);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(80197);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.js
var use_click_outside = __webpack_require__(81533);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/differenceInMilliseconds/index.js
var differenceInMilliseconds = __webpack_require__(54807);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconDownload.js
var IconDownload = __webpack_require__(36507);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/Export/components/BaseButton.tsx








var BaseButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, others = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref
    }, others), {
        variant: "subtle",
        compact: true,
        h: 30,
        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDownload/* default */.Z, {
            size: 18,
            stroke: 1.5
        }),
        sx: function(theme) {
            return {
                borderRadius: theme.radius.xs,
                color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                "&:hover": {
                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                }
            };
        },
        children: children
    }));
});
/* harmony default export */ var components_BaseButton = (BaseButton);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/Export/components/ExportButton.tsx
















var shortestTime = 2000;
var ExportButton = function(param) {
    var onDownload = param.onDownload;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useExportMutation */.I$n)(), 1), exportMutation = ref[0];
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var campaignId = router.query.campaignId;
    var ref1 = (0,CampaignFilterContext/* useCampaignFilter */.aB)(), filterInput = ref1.filter;
    var target = {
        targetId: campaignId,
        targetType: domain/* ExportTargetType.CampaignEntries */.JTb.CampaignEntries
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref2[0], ref3 = ref2[1], close = ref3.close, toggle = ref3.toggle;
    var progressRef = (0,react.useRef)(0);
    var ref4 = (0,react.useState)("idle"), status = ref4[0], setStatus = ref4[1];
    var ref5 = (0,react.useState)(domain/* SelectableFieldSplitter.SplitByColumn */.tTt.SplitByColumn), fieldSplitter = ref5[0], setFieldSplitter = ref5[1];
    var ref6 = (0,use_click_outside/* useClickOutside */.O)(function() {
        return close();
    });
    (0,domain/* useExportJobInfoSubscription */.p_x)({
        skip: status !== "exporting",
        variables: target,
        onData: function onData(data) {
            var ref, ref1;
            var downloadUrl = (ref = data.data.data) === null || ref === void 0 ? void 0 : ref.exportJobInfo.resUrl;
            progressRef.current = downloadUrl ? 100 : (ref1 = data.data.data) === null || ref1 === void 0 ? void 0 : ref1.exportJobInfo.progress;
            if (downloadUrl) {
                downloadImmediatelyOrDelay(downloadUrl);
            }
        }
    });
    var startTime = new Date();
    var downloadImmediatelyOrDelay = function(downloadUrl) {
        var differenceTime = (0,differenceInMilliseconds/* default */.Z)(new Date(), startTime) - shortestTime;
        if (differenceTime < 0) {
            // avoid download quickly make user experience is bad, so download process at least 2 seconds
            (0,utils/* delay */.gw)(Math.abs(differenceTime)).then(function() {
                onDownload(downloadUrl);
            });
        } else {
            onDownload(downloadUrl);
        }
        setStatus("idle");
        progressRef.current = 0;
    };
    var handleStartClick = function() {
        close();
        setStatus("exporting");
        exportMutation({
            variables: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                filter: filterInput
            }, target), {
                fieldSplitter: fieldSplitter
            })
        }).then();
    };
    var handleButtonClick = function() {
        if ((campaign === null || campaign === void 0 ? void 0 : campaign.type) === domain/* CampaignType.Feedback */.mL.Feedback) {
            handleStartClick();
        } else {
            toggle();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        withinPortal: true,
        opened: opened,
        position: "bottom-start",
        zIndex: 100,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BaseButton, {
                    disabled: status === "exporting",
                    loading: status === "exporting",
                    onClick: handleButtonClick,
                    children: status === "exporting" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                        children: t("export.downloading", {
                            progress: progressRef.current
                        })
                    }) : t("export.label")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                style: {
                    boxShadow: theme.shadows.md
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    p: 10,
                    align: "flex-start",
                    spacing: "sm",
                    ref: ref6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: "xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    fw: 600,
                                    children: t("export.setting.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    color: (0,getColor/* getTextColor */.uu)("gray.6", theme),
                                    children: t("export.setting.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* Radio.Group */.Y.Group, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    children: t("export.setting.radioGroupLabel")
                                }),
                                value: fieldSplitter,
                                onChange: function(v) {
                                    return setFieldSplitter(v);
                                },
                                sx: {
                                    label: {
                                        fontWeight: "normal"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    mt: "xs",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* Radio */.Y, {
                                            value: domain/* SelectableFieldSplitter.SplitByColumn */.tTt.SplitByColumn,
                                            label: t("export.setting.splitByColumn")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* Radio */.Y, {
                                            value: domain/* SelectableFieldSplitter.SplitByComma */.tTt.SplitByComma,
                                            label: t("export.setting.splitByComma")
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Space/* Space */.T, {
                            h: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: handleStartClick,
                            children: t("export.setting.startExport")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ExportButton = (ExportButton);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconCheck.js
var IconCheck = __webpack_require__(7861);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/Export/components/ButtonWithDownload.tsx











var ButtonWithDownload = function(param) {
    var downloadUrl = param.downloadUrl, onDownload = param.onDownload, onCancel = param.onCancel;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var campaignId = router.query.campaignId;
    var target = {
        targetId: campaignId,
        targetType: domain/* ExportTargetType.CampaignEntries */.JTb.CampaignEntries
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useCancelExportMutation */.N16)(), 1), cancelExportMutation = ref[0];
    var handleExportCancel = function() {
        cancelExportMutation({
            variables: target
        }).then();
        onCancel();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        withinPortal: true,
        opened: true,
        position: "bottom-start",
        zIndex: 100,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BaseButton, {
                    disabled: true,
                    children: t("export.label")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                style: {
                    boxShadow: theme.shadows.md
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    position: "apart",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                                    stroke: 2,
                                    size: 20,
                                    color: (0,getColor/* getTextColor */.uu)("green.6", theme)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    children: t("export.downloadTips")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                    onClick: function() {
                                        return onDownload(downloadUrl);
                                    },
                                    children: t("common:actions.download")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    orientation: "vertical",
                                    color: "brandBlue.1",
                                    my: 2
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    onClick: handleExportCancel,
                                    className: "cursor-pointer",
                                    children: t("common:actions.cancel")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ButtonWithDownload = (ButtonWithDownload);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/Export/index.tsx








var Export = function() {
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var router = (0,next_router.useRouter)();
    var campaignId = router.query.campaignId;
    var target = {
        targetId: campaignId,
        targetType: domain/* ExportTargetType.CampaignEntries */.JTb.CampaignEntries
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useCompleteExportMutation */.gZc)(), 1), completeExportMutation = ref[0];
    var ref1 = (0,react.useState)(null), downloadUrl = ref1[0], setDownloadUrl = ref1[1];
    (0,domain/* useExportUrlQuery */.aJR)({
        fetchPolicy: "no-cache",
        variables: target,
        onCompleted: function(res) {
            setDownloadUrl(res.exportUrl);
        }
    });
    var handleDownload = function(url) {
        var link = document.createElement("a");
        link.href = url;
        link.click();
        completeExportMutation({
            variables: target
        }).then(function() {
            return setDownloadUrl(undefined);
        });
    };
    var handleCancel = function() {
        setDownloadUrl(undefined);
    };
    return !!downloadUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ButtonWithDownload, {
        downloadUrl: downloadUrl,
        onDownload: handleDownload,
        onCancel: handleCancel
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExportButton, {
        onDownload: handleDownload
    });
};
/* harmony default export */ var HandleBar_Export = (Export);

// EXTERNAL MODULE: ./src/components/business/Customer/AddToSegments/index.tsx + 1 modules
var AddToSegments = __webpack_require__(9419);
// EXTERNAL MODULE: ./src/hooks/index.ts + 8 modules
var hooks = __webpack_require__(33892);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/BatchActions.tsx














var BatchActions = function(param) {
    var tableRef = param.tableRef;
    var t = (0,useTranslation/* default */.Z)("entry").t;
    var router = (0,next_router.useRouter)();
    var campaignId = router.query.campaignId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useDeleteEntriesMutation */.EvW)(), 1), deleteEntriesMutation = ref[0];
    var ref1 = (0,EntriesContext/* useEntries */.Di)(), selectedCount = ref1.selectedRowsCount;
    var open = (0,AddToSegments/* default */.Z)().open;
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, selectedRows, selectedEntryIds, data, ref2, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        selectedRows = tableRef === null || tableRef === void 0 ? void 0 : (ref = tableRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.tableInstance) === null || ref1 === void 0 ? void 0 : ref1.getSelectedRowModel().rows;
                        if ((0,isEmpty/* default */.Z)(selectedRows)) {
                            return [
                                2
                            ];
                        }
                        selectedEntryIds = selectedRows.map(function(row) {
                            return row.id;
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            deleteEntriesMutation({
                                variables: {
                                    input: {
                                        campaignId: campaignId,
                                        entryIds: selectedEntryIds
                                    }
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.deleteEntries) {
                            ;
                            ui/* message.successMsg */.yw.successMsg(t("common:message.deleteSuccess"));
                            tableRef === null || tableRef === void 0 ? void 0 : (ref2 = tableRef.current) === null || ref2 === void 0 ? void 0 : ref2.refetch();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        ui/* message.error */.yw.error(t("common:message.deleteError"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var openModal = (0,hooks/* useDeleteModal */.m6)(t("batchDelete.title"), t("batchDelete.content", {
        count: selectedCount
    }), handleDelete).openModal;
    var clearRowSelection = function() {
        var ref, ref1;
        tableRef === null || tableRef === void 0 ? void 0 : (ref = tableRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.tableInstance) === null || ref1 === void 0 ? void 0 : ref1.resetRowSelection();
    };
    var handleAddToCustomerSegmentClick = function() {
        var ref, ref1;
        var selectedRows = tableRef === null || tableRef === void 0 ? void 0 : (ref = tableRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.tableInstance) === null || ref1 === void 0 ? void 0 : ref1.getSelectedRowModel().rows;
        var selectedCustomerIds = (0,uniq/* default */.Z)(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map(function(row) {
            var ref, ref1;
            return (ref1 = row === null || row === void 0 ? void 0 : (ref = row.original) === null || ref === void 0 ? void 0 : ref.entry.customerSnapshot) === null || ref1 === void 0 ? void 0 : ref1.customerId;
        }).filter(function(cid) {
            return !(0,isNil/* default */.Z)(cid);
        }));
        open({
            customerIds: selectedCustomerIds,
            existedSegmentIds: [],
            onSuccess: clearRowSelection
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "md",
        pos: "absolute",
        className: "z-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                children: t("batchDelete.selected", {
                    count: selectedCount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                px: "sm",
                h: 30,
                onClick: clearRowSelection,
                variant: "default",
                styles: function() {
                    return {
                        root: {
                            fontWeight: "normal"
                        }
                    };
                },
                children: t("batchDelete.cancelSelect")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                px: "sm",
                h: 30,
                onClick: handleAddToCustomerSegmentClick,
                children: t("pageCustomerSegment:customersActions.addToSegment")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                px: "sm",
                h: 30,
                color: "red",
                onClick: openModal,
                children: t("batchDelete.delete")
            })
        ]
    });
};
/* harmony default export */ var HandleBar_BatchActions = (BatchActions);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/HandleBar/index.tsx












var notSupportHiddenColumns = [
    Entries_constants/* SERIAL_NUMBER_CODE */.As,
    Entries_constants/* COMMENTS_COUNT_CODE */.f4,
    Entries_constants/* REPLY_CODE */.Vt
];
var HandlerBar = function(props) {
    var ref;
    var tableRef = props.tableRef;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var ref1 = (0,EntriesContext/* useEntries */.Di)(), selectedRowsCount = ref1.selectedRowsCount, formFields = ref1.formFields, hiddenColumns = ref1.hiddenColumns, columns = ref1.columns;
    var onHiddenColumnChange = (0,EntriesContext/* useEntriesActions */.fz)().onHiddenColumnChange;
    var deletable = (0,Campaign_hooks/* useCampaignPermission */.L9)(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.id).deletable;
    var batchActivity = deletable && selectedRowsCount > 0;
    var canHiddenColumns = (0,react.useMemo)(function() {
        return columns === null || columns === void 0 ? void 0 : columns.filter(function(column) {
            return !notSupportHiddenColumns.includes(column.id);
        });
    }, [
        columns
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        pos: "relative",
        px: "md",
        py: "sm",
        align: "center",
        grow: true,
        children: [
            batchActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleBar_BatchActions, {
                tableRef: tableRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                position: "apart",
                opacity: batchActivity ? 0 : 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        spacing: "sm",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter_EntriesFilter, {
                                fields: formFields
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenColumns/* default */.Z, {
                                columns: canHiddenColumns,
                                value: hiddenColumns,
                                onChange: onHiddenColumnChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleBar_Export, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleBar_KeywordSearch, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var HandleBar = (HandlerBar);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keyBy.js
var keyBy = __webpack_require__(60968);
// EXTERNAL MODULE: ./node_modules/.pnpm/mantine-react-table@1.3.4_@emotion+react@11.10.5_@mantine+core@6.0.13_@mantine+dates@6.0.13_@_aijcxrmt65lg5a35anfrpvz4hi/node_modules/mantine-react-table/dist/esm/mantine-react-table.esm.js
var mantine_react_table_esm = __webpack_require__(86095);
// EXTERNAL MODULE: ./src/components/ui/TableEmpty/index.tsx
var TableEmpty = __webpack_require__(88828);
// EXTERNAL MODULE: ./src/components/ui/TableFooter/index.tsx
var TableFooter = __webpack_require__(79206);
// EXTERNAL MODULE: ./src/components/business/Campaign/EntryModal/index.ts + 35 modules
var EntryModal = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/utils/graphqlCursor.ts
var graphqlCursor = __webpack_require__(98457);
// EXTERNAL MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/utils/formFieldResolver.ts + 8 modules
var formFieldResolver = __webpack_require__(1134);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/merge.js + 6 modules
var merge = __webpack_require__(31817);
// EXTERNAL MODULE: ./src/utils/commonTableConfig.ts
var commonTableConfig = __webpack_require__(10806);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/utils/tableConfig.ts


var entriesTableConfig = {
    mantineTableProps: {
        withColumnBorders: true
    },
    mantineColumnDragHandleProps: {
        sx: {
            "> svg": {
                rotate: "90deg"
            }
        }
    },
    enableRowSelection: true,
    enableSelectAll: true,
    enableColumnResizing: true,
    enableColumnOrdering: true,
    enableColumnVirtualization: true,
    enableRowVirtualization: true,
    enableStickyHeader: true
};
function getEntriesTableConfig() {
    return (0,merge/* default */.Z)((0,commonTableConfig/* default */.Z)(), entriesTableConfig);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-set-state/use-set-state.js
var use_set_state = __webpack_require__(34058);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/components/EntryDetail/index.tsx







var initModalState = {
    index: 0,
    opened: false,
    data: null,
    isCommentColumn: false
};
var EntryDetail = function(props, ref) {
    var page = props.page, pageSize = props.pageSize, totalPages = props.totalPages, tableData = props.tableData, onPageChange = props.onPageChange, onRemove = props.onRemove;
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)(initModalState), 2), state = _$ref[0], setState = _$ref[1];
    var index = state.index, data = state.data, opened = state.opened, targetAside = state.targetAside;
    var previousDisabled = (0,react.useMemo)(function() {
        return page === 1 && index === 0;
    }, [
        index,
        page
    ]);
    var nextDisabled = (0,react.useMemo)(function() {
        return page === totalPages && tableData.length - 1 === index;
    }, [
        index,
        page,
        tableData.length,
        totalPages
    ]);
    (0,react.useEffect)(function() {
        if (!(0,isEmpty/* default */.Z)(tableData) && opened) {
            setState({
                data: tableData[index]
            });
        }
    }, [
        index,
        opened,
        setState,
        tableData
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            openModal: function(index, targetAside) {
                setState({
                    index: index,
                    data: tableData[index],
                    opened: true,
                    targetAside: targetAside
                });
            }
        };
    });
    var handlePrevious = function() {
        shouldLoadNewPage(index - 1);
    };
    var handleNext = function() {
        shouldLoadNewPage(index + 1);
    };
    var shouldLoadNewPage = function(newIndex) {
        if (newIndex < 0) {
            onPageChange(page - 1);
            setState({
                index: pageSize - 1
            });
        }
        if (newIndex >= pageSize) {
            onPageChange(page + 1);
            setState({
                index: 0
            });
        }
        if (newIndex > -1 && newIndex <= tableData.length - 1) {
            setState({
                index: newIndex,
                data: tableData[newIndex]
            });
        }
    };
    var handleClose = function() {
        setState(initModalState);
        (0,AddToSegments/* closeAddToSegmentModal */.d)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data && /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryModal/* EntryModal */.fb, {
            data: data,
            opened: opened,
            onClose: handleClose,
            previousDisabled: previousDisabled,
            nextDisabled: nextDisabled,
            onPrevious: handlePrevious,
            onNext: handleNext,
            targetAside: targetAside,
            onRemove: onRemove
        })
    });
};
/* harmony default export */ var components_EntryDetail = (/*#__PURE__*/(0,react.forwardRef)(EntryDetail));

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/components/EntriesTable/index.tsx

























var pageSize = config_constants/* PAGE_SIZE.SM */.IV.SM;
var EntriesTable_obj;
var targetAsideTab = (EntriesTable_obj = {}, (0,_define_property/* default */.Z)(EntriesTable_obj, Entries_constants/* COMMENTS_COUNT_CODE */.f4, EntryModal/* AsideType.Comments */.$G.Comments), (0,_define_property/* default */.Z)(EntriesTable_obj, Entries_constants/* REPLY_CODE */.Vt, EntryModal/* AsideType.Reply */.$G.Reply), EntriesTable_obj);
var EntriesTable = /*#__PURE__*/ (0,react.forwardRef)(function(_, ref) {
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4;
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    var isCurrentMobileDistribution = (0,applicationUtils/* isMobileDistribution */._Z)(application);
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var campaignId = campaign === null || campaign === void 0 ? void 0 : campaign.id;
    var _$ref5 = (0,EntriesContext/* useEntries */.Di)(), columnVisibility = _$ref5.columnVisibility, columnOrder = _$ref5.columnOrder, columns = _$ref5.columns, formFields = _$ref5.formFields, rowSelection = _$ref5.rowSelection;
    var fieldCodeMap = (0,react.useMemo)(function() {
        return (0,keyBy/* default */.Z)(formFields, function(field) {
            return field.code;
        });
    }, [
        formFields
    ]);
    var _$ref6 = (0,CampaignFilterContext/* useCampaignFilter */.aB)(), filterInput = _$ref6.filter;
    var previousFilterValue = (0,use_previous/* usePrevious */.D)(filterInput);
    var _$ref7 = (0,react.useState)(1), page = _$ref7[0], setPage = _$ref7[1];
    var modalRef = (0,react.useRef)(null);
    var _$ref8 = (0,EntriesContext/* useEntriesActions */.fz)(), onColumnOrderChange = _$ref8.onColumnOrderChange, onRowSelectionChange = _$ref8.onRowSelectionChange;
    (0,react.useEffect)(function() {
        if (!(0,isEqual/* default */.Z)(previousFilterValue, filterInput)) {
            setPage(1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterInput
    ]);
    var _$ref9 = (0,domain/* useCampaignEntriesQuery */.Tbj)({
        fetchPolicy: "cache-and-network",
        variables: {
            campaignId: campaignId,
            first: pageSize,
            after: (0,graphqlCursor/* getAfter */.xL)(page, pageSize).after,
            filter: filterInput,
            skipBrowserInfo: isCurrentMobileDistribution
        },
        onCompleted: function onCompleted(data) {
            var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5;
            var _$ref6;
            var totalCount = (_$ref6 = data === null || data === void 0 ? void 0 : (_$ref = data.campaign) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.form) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.entries) === null || _$ref2 === void 0 ? void 0 : _$ref2.totalCount) !== null && _$ref6 !== void 0 ? _$ref6 : 0;
            if (totalCount > 0 && (0,isEmpty/* default */.Z)(data === null || data === void 0 ? void 0 : (_$ref3 = data.campaign) === null || _$ref3 === void 0 ? void 0 : (_$ref4 = _$ref3.form) === null || _$ref4 === void 0 ? void 0 : (_$ref5 = _$ref4.entries) === null || _$ref5 === void 0 ? void 0 : _$ref5.nodes)) {
                handlePageChange(page - 1);
            }
        }
    }), variables = _$ref9.variables, loading = _$ref9.loading, refetch = _$ref9.refetch, data = _$ref9.data;
    var entries = data === null || data === void 0 ? void 0 : (_$ref = data.campaign) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.form) === null || _$ref1 === void 0 ? void 0 : _$ref1.entries;
    var totalCount = data === null || data === void 0 ? void 0 : (_$ref2 = data.campaign) === null || _$ref2 === void 0 ? void 0 : (_$ref3 = _$ref2.form) === null || _$ref3 === void 0 ? void 0 : (_$ref4 = _$ref3.entries) === null || _$ref4 === void 0 ? void 0 : _$ref4.totalCount;
    var totalPages = Math.ceil((totalCount !== null && totalCount !== void 0 ? totalCount : 0) / pageSize);
    var handlePageChange = function(newPage) {
        onRowSelectionChange({});
        setPage(newPage);
        var updateVariables = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, variables), {
            after: (0,graphqlCursor/* getAfter */.xL)(newPage, pageSize).after
        });
        refetch(updateVariables).then();
    };
    var _$ref10;
    // @ts-ignore
    var table = (0,mantine_react_table_esm/* useMantineReactTable */.Un)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getEntriesTableConfig()), {
        columns: columns,
        getRowId: function(row) {
            return row.id;
        },
        state: {
            isLoading: !entries,
            columnVisibility: columnVisibility,
            rowSelection: rowSelection,
            columnOrder: columnOrder,
            pagination: {
                pageSize: Math.min(totalCount !== null && totalCount !== void 0 ? totalCount : 0, pageSize),
                pageIndex: page
            }
        },
        data: (0,formFieldResolver/* formFieldResolver */.l)((_$ref10 = entries === null || entries === void 0 ? void 0 : entries.nodes) !== null && _$ref10 !== void 0 ? _$ref10 : [], fieldCodeMap),
        // @ts-ignore
        onColumnOrderChange: onColumnOrderChange,
        onRowSelectionChange: onRowSelectionChange,
        mantineTableBodyCellProps: function(param) {
            var cell = param.cell;
            return {
                onClick: function(event) {
                    var _$ref;
                    if (loading || Entries_constants/* SERIAL_NUMBER_CODE */.As === cell.column.id || // @ts-ignore
                    cell.column.columnDef.type === domain/* FormFieldType.ScreenshotField */.EIl.ScreenshotField || (0,utils/* isUrl */.CB)(cell.renderValue())) {
                        event.stopPropagation();
                        return;
                    }
                    onRowSelectionChange({});
                    var _id;
                    var targetAside = (_id = targetAsideTab[cell.column.id]) !== null && _id !== void 0 ? _id : undefined;
                    modalRef === null || modalRef === void 0 ? void 0 : (_$ref = modalRef.current) === null || _$ref === void 0 ? void 0 : _$ref.openModal(cell.row.index, targetAside);
                }
            };
        }
    }));
    (0,react.useImperativeHandle)(ref, function() {
        return {
            tableInstance: table,
            refetch: function() {
                refetch().then(function() {
                    return onRowSelectionChange({});
                });
            }
        };
    });
    var _$ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        pos: "relative",
        h: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            pos: "absolute",
            inset: 0,
            children: totalCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableEmpty/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        w: "100%",
                        h: "100%",
                        spacing: "sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(mantine_react_table_esm/* MantineReactTable */.ZO, {
                                table: table
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableFooter/* TableFooter */.y, {
                                totalCount: totalCount,
                                page: page,
                                totalPages: totalPages,
                                onPageChange: handlePageChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EntryDetail, {
                        ref: modalRef,
                        page: page,
                        pageSize: pageSize,
                        tableData: (0,formFieldResolver/* formFieldResolver */.l)((_$ref11 = entries === null || entries === void 0 ? void 0 : entries.nodes) !== null && _$ref11 !== void 0 ? _$ref11 : [], fieldCodeMap),
                        totalPages: totalPages,
                        onPageChange: handlePageChange,
                        onRemove: refetch
                    })
                ]
            })
        })
    });
});
/* harmony default export */ var components_EntriesTable = (EntriesTable);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Entries/index.tsx












var CampaignEntries = function(props) {
    var tableRef = (0,react.useRef)(null);
    var userCampaignSetting = props.userCampaignSetting, formFields = props.formFields;
    var columns = useColumns(formFields);
    var ref = useRowSelection(), rowSelection = ref.rowSelection, selectedRowsCount = ref.selectedRowsCount, onRowSelectionChange = ref.onRowSelectionChange;
    var ref1 = useOrderedColumns(columns, userCampaignSetting === null || userCampaignSetting === void 0 ? void 0 : userCampaignSetting.orderedFields), columnOrder = ref1.columnOrder, onColumnOrderChange = ref1.onColumnOrderChange;
    var ref2 = useHiddenColumns(userCampaignSetting === null || userCampaignSetting === void 0 ? void 0 : userCampaignSetting.hiddenFields, columns.map(function(column) {
        return column.id;
    })), hiddenColumns = ref2.hiddenColumns, columnVisibility = ref2.columnVisibility, onHiddenColumnChange = ref2.onHiddenColumnChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
        radius: 0,
        h: "100%",
        className: "rounded-t",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
            spacing: 0,
            h: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignFilterContext/* CampaignFilterProvider */.El, {
                defaultValue: {
                    filter: userCampaignSetting === null || userCampaignSetting === void 0 ? void 0 : userCampaignSetting.entriesFilter,
                    key: "entriesFilter"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EntriesContext/* EntriesProvider */.qj, {
                    defaultValue: {
                        hiddenColumns: hiddenColumns,
                        columnVisibility: columnVisibility,
                        columnOrder: columnOrder,
                        formFields: formFields,
                        columns: columns,
                        rowSelection: rowSelection,
                        selectedRowsCount: selectedRowsCount
                    },
                    actions: {
                        onHiddenColumnChange: onHiddenColumnChange,
                        onColumnOrderChange: onColumnOrderChange,
                        onRowSelectionChange: onRowSelectionChange
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleBar, {
                            tableRef: tableRef
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EntriesTable, {
                            ref: tableRef
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Entries = (CampaignEntries);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(23723);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/head.js
var head = __webpack_require__(89935);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Tabs/Tabs.js + 10 modules
var Tabs = __webpack_require__(15708);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconBolt.js
var IconBolt = __webpack_require__(66795);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/Tabs/index.tsx












var NotificationTabRouterMap = {
    entries: config_constants/* ApplicationNotificationEntries */.LS,
    reports: config_constants/* ApplicationNotificationReports */.uz,
    overview: config_constants/* ApplicationNotificationShow */.s3,
    integration: config_constants/* ApplicationNotificationIntegration */.bk
};
var SurveyTabRouterMap = {
    entries: config_constants/* ApplicationSurveyEntries */.Zl,
    reports: config_constants/* ApplicationSurveyReports */.qE,
    overview: config_constants/* ApplicationSurveyShow */.Ky,
    integration: config_constants/* ApplicationSurveyIntegration */.PW
};
var FeedbackTabRouterMap = {
    overview: config_constants/* ApplicationFeedbackShow */.PD,
    entries: config_constants/* ApplicationFeedbackEntries */.ry,
    integration: config_constants/* ApplicationFeedbackIntegration */.Ws
};
function getRouterPath(tab, type) {
    switch(type){
        case domain/* CampaignType.Notification */.mL.Notification:
            var _tab;
            return (_tab = NotificationTabRouterMap[tab]) !== null && _tab !== void 0 ? _tab : config_constants/* ApplicationNotificationShow */.s3;
        case domain/* CampaignType.Feedback */.mL.Feedback:
            var _tab1;
            return (_tab1 = FeedbackTabRouterMap[tab]) !== null && _tab1 !== void 0 ? _tab1 : config_constants/* ApplicationFeedbackShow */.PD;
        case domain/* CampaignType.Survey */.mL.Survey:
            var _tab2;
            return (_tab2 = SurveyTabRouterMap[tab]) !== null && _tab2 !== void 0 ? _tab2 : config_constants/* ApplicationSurveyShow */.Ky;
    }
}
function getIsShowReportTab(campaignType, widgetType) {
    return campaignType === domain/* CampaignType.Survey */.mL.Survey || campaignType === domain/* CampaignType.Notification */.mL.Notification && widgetType === domain/* CampaignWidgetType.Popup */.YMh.Popup;
}
var CampaignTabs = function(param) {
    var activeTab = param.activeTab;
    var t = (0,useTranslation/* default */.Z)("layoutCampaign").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var _query = router.query, appId = _query.appId, campaignId = _query.campaignId;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var type = campaign.type;
    var isShowReportTab = getIsShowReportTab(type, campaign === null || campaign === void 0 ? void 0 : campaign.widget.type);
    var onTabChange = function(value) {
        router.push({
            pathname: getRouterPath(value, type),
            query: {
                appId: appId,
                campaignId: campaignId
            }
        }).then();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs */.m, {
        value: activeTab,
        onTabChange: onTabChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs.List */.m.List, {
            style: {
                borderColor: (0,getColor/* getBackgroundColor */.dF)("gray.2", theme),
                borderBottomColor: (0,getColor/* getBorderColor */.kJ)("gray.3", theme)
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                    value: "overview",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: activeTab === "overview" ? "tabSummaryFill" : "tabSummary"
                    }),
                    children: t("tab.overview")
                }),
                isShowReportTab && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                    value: "reports",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: activeTab === "reports" ? "tabChartFill" : "tabChart"
                    }),
                    children: t("tab.reports")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                    value: "entries",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                        name: activeTab === "entries" ? "tabTableFill" : "tabTable"
                    }),
                    children: t("tab.entries")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                    value: "integration",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBolt/* default */.Z, {
                        color: activeTab === "integration" ? theme.colors.brandBlue[7] : theme.colors.gray[7],
                        size: 24,
                        stroke: 1.5
                    }),
                    children: t("tab.integration")
                })
            ]
        })
    });
};
/* harmony default export */ var Layout_Tabs = (CampaignTabs);

// EXTERNAL MODULE: ./src/components/ui/LinkWithAction/index.tsx
var LinkWithAction = __webpack_require__(76076);
// EXTERNAL MODULE: ./src/utils/getXFormUrl.ts
var getXFormUrl = __webpack_require__(6371);
// EXTERNAL MODULE: ./src/components/business/Campaign/CampaignFormStatusSwitch/index.tsx
var CampaignFormStatusSwitch = __webpack_require__(20395);
// EXTERNAL MODULE: ./src/components/ui/Button/ActionButton/index.tsx
var ActionButton = __webpack_require__(23866);
// EXTERNAL MODULE: ./src/components/business/Campaign/ActionMenus/index.tsx
var ActionMenus = __webpack_require__(99766);
// EXTERNAL MODULE: ./src/components/business/Campaign/hooks/useGroupCache.ts
var useGroupCache = __webpack_require__(56941);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/CloseButton/CloseButton.js + 1 modules
var CloseButton = __webpack_require__(11706);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-did-update/use-did-update.js
var use_did_update = __webpack_require__(47765);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+modals@6.0.13_@mantine+core@6.0.13_@mantine+hooks@6.0.13_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/modals/esm/events.js
var events = __webpack_require__(75764);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/use-form.js + 17 modules
var use_form = __webpack_require__(68329);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/validators/has-length/has-length.js
var has_length = __webpack_require__(24541);
;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Group/GroupForm.tsx








var initialValues = {
    name: ""
};
var GroupForm = function(props) {
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var group = props.group, onSave = props.onSave, onCancel = props.onCancel;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), disabled = ref[0], ref1 = ref[1], openDisabled = ref1.open, closeDisabled = ref1.close;
    var form = (0,use_form/* useForm */.c)({
        initialValues: group ? {
            name: group.name
        } : initialValues,
        validate: {
            name: (0,has_length/* hasLength */.d)({
                min: 2,
                max: 40
            }, t("campaignGroup.nameLengthTip"))
        }
    });
    var handleSubmit = function() {
        openDisabled();
        var values = form.values;
        onSave(values.name.trim(), closeDisabled);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: form.onSubmit(handleSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,src_object_spread/* default */.Z)({
                "data-autofocus": true,
                maxLength: 40,
                label: t("campaignGroup.name"),
                placeholder: t("common:placeholders.pleaseInput")
            }, form.getInputProps("name"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                position: "right",
                mt: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        variant: "default",
                        onClick: onCancel,
                        children: t("common:actions.cancel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        disabled: disabled,
                        children: group ? t("common:actions.save") : t("common:actions.create")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Group_GroupForm = (GroupForm);

;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Group/useCreateGroupModal.tsx














var modalId = "createCampaignGroupModal";
function useCreateCampaignGroupModal(type) {
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useCreateCampaignGroupMutation */.Ce)(), 1), createCampaignGroupMutation = ref[0];
    var handleSave = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name, callback, onSuccess) {
            var ref, data, error, mapping, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            createCampaignGroupMutation({
                                variables: {
                                    input: {
                                        name: name,
                                        type: type,
                                        applicationId: appId
                                    }
                                },
                                update: function update(cache, param) {
                                    var newData = param.data;
                                    var ref;
                                    if (newData === null || newData === void 0 ? void 0 : (ref = newData.createCampaignGroup) === null || ref === void 0 ? void 0 : ref.id) {
                                        var ref1;
                                        cache.modify({
                                            id: cache.identify({
                                                __typename: "Application",
                                                id: appId,
                                                type: type
                                            }),
                                            fields: {
                                                campaignGroups: function campaignGroups() {
                                                    var existingCampaignGroups = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                                                    return [
                                                        newData === null || newData === void 0 ? void 0 : newData.createCampaignGroup
                                                    ].concat((0,_to_consumable_array/* default */.Z)(existingCampaignGroups));
                                                }
                                            }
                                        });
                                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(newData === null || newData === void 0 ? void 0 : (ref1 = newData.createCampaignGroup) === null || ref1 === void 0 ? void 0 : ref1.id);
                                    }
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : (ref = data.createCampaignGroup) === null || ref === void 0 ? void 0 : ref.id) {
                            ui/* message.successMsg */.yw.successMsg("".concat(t("common:message.createSuccess")));
                            close();
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        mapping = new Map();
                        mapping.set("error.duplicate_key", t("campaignGroup.nameDuplicate"));
                        graphQLErrors = error.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            mapping: mapping,
                            defaultMessage: t("common:message.createError")
                        });
                        callback();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave(name, callback, onSuccess) {
            return _ref.apply(this, arguments);
        };
    }();
    var open = function(onSuccess) {
        (0,events/* openModal */.h7)({
            modalId: modalId,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                weight: "bold",
                size: "md",
                children: t("campaignGroup.create")
            }),
            size: 440,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group_GroupForm, {
                onSave: function(name, callback) {
                    return handleSave(name, callback, onSuccess);
                },
                onCancel: close
            })
        });
    };
    var close = function() {
        (0,events/* closeModal */.Mr)(modalId);
    };
    return {
        open: open,
        close: close
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconPlus.js
var IconPlus = __webpack_require__(13644);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconAlbum.js
var IconAlbum = __webpack_require__(51846);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconEdit.js
var IconEdit = __webpack_require__(51529);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconLayoutGrid.js
var IconLayoutGrid = __webpack_require__(7209);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconList.js
var IconList = __webpack_require__(32736);
// EXTERNAL MODULE: ./src/utils/graphqlErrorCatch.ts
var graphqlErrorCatch = __webpack_require__(94945);
;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Group/useEditCampaignGroupModal.tsx













var useEditCampaignGroupModal_modalId = "editCampaignGroupModal";
function useEditCampaignGroupModal() {
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateCampaignGroupMutation */.Lh2)(), 1), updateCampaignGroupMutation = ref[0];
    var handleSave = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values, callback) {
            var ref, data, error, mapping, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            updateCampaignGroupMutation({
                                variables: {
                                    input: (0,src_object_spread/* default */.Z)({}, values)
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : (ref = data.updateCampaignGroup) === null || ref === void 0 ? void 0 : ref.id) {
                            close();
                            ui/* message.successMsg */.yw.successMsg("".concat(t("common:message.updateSuccess")));
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        mapping = new Map();
                        mapping.set("error.duplicate_key", t("campaignGroup.nameDuplicate"));
                        graphQLErrors = error.graphQLErrors;
                        (0,graphqlErrorCatch/* default */.Z)({
                            graphQLErrors: graphQLErrors,
                            mapping: mapping,
                            defaultMessage: t("common:message.updateError")
                        });
                        callback();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave(values, callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var open = function(group) {
        (0,events/* openModal */.h7)({
            modalId: useEditCampaignGroupModal_modalId,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                weight: "bold",
                size: "md",
                children: t("common:actions.edit")
            }),
            size: 440,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group_GroupForm, {
                group: group,
                onSave: function(name, callback) {
                    return handleSave({
                        id: group === null || group === void 0 ? void 0 : group.id,
                        name: name
                    }, callback);
                },
                onCancel: close
            })
        });
    };
    var close = function() {
        (0,events/* closeModal */.Mr)(useEditCampaignGroupModal_modalId);
    };
    return {
        open: open,
        close: close
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-abac@0.1.10_react@18.2.0/node_modules/react-abac/dist/index.es.js
var index_es = __webpack_require__(8470);
;// CONCATENATED MODULE: ./src/components/business/Campaign/hooks/useCampaignLayoutCache.ts






var LayoutType;
(function(LayoutType) {
    LayoutType["LIST"] = "list";
    LayoutType["GRID"] = "grid";
})(LayoutType || (LayoutType = {}));
function useCampaignLayoutCache() {
    var ref = (0,react.useContext)(ApplicationContext/* default */.Z), me = ref.me, application = ref.application;
    var getDefaultLayout = function(campaignType) {
        var ref;
        var res = (ref = utils/* Storage.getItem */.Ke.getItem(getKey())) !== null && ref !== void 0 ? ref : {};
        var _campaignType;
        return (_campaignType = res[campaignType]) !== null && _campaignType !== void 0 ? _campaignType : LayoutType.LIST;
    };
    var setDefaultLayout = function(campaignType, layout) {
        var key = getKey();
        var ref;
        var old = (ref = utils/* Storage.getItem */.Ke.getItem(key)) !== null && ref !== void 0 ? ref : {};
        utils/* Storage.setItem */.Ke.setItem(key, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, old), (0,_define_property/* default */.Z)({}, campaignType, layout)));
    };
    var getKey = function() {
        return "hx_user_".concat(me === null || me === void 0 ? void 0 : me.id, "_application_").concat(application === null || application === void 0 ? void 0 : application.id, "_layouts");
    };
    return {
        getDefaultLayout: getDefaultLayout,
        setDefaultLayout: setDefaultLayout
    };
}

;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Header.tsx























var SYSTEM_GROUP;
(function(SYSTEM_GROUP) {
    SYSTEM_GROUP["ALL"] = "ALL";
    SYSTEM_GROUP["ENABLED"] = "ENABLED";
    SYSTEM_GROUP["DISABLED"] = "DISABLED";
})(SYSTEM_GROUP || (SYSTEM_GROUP = {}));
var isSystemGroup = function(value) {
    if (value) {
        return Object.values(SYSTEM_GROUP).includes(value);
    }
    return true;
};
var Header = function(props) {
    var ref;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var campaignType = props.campaignType, groupId = props.groupId, layout = props.layout, onGroupChange = props.onGroupChange, onKeywordChange = props.onKeywordChange, onLayoutChange = props.onLayoutChange, className = props.className;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var userHasPermissions = (0,index_es/* useAbac */.nn)().userHasPermissions;
    var manageable = userHasPermissions(domain/* ApplicationPermission.CampaignGroupManage */.eC6.CampaignGroupManage);
    var deleteGroup = (0,useGroupCache/* default */.Z)().deleteGroup;
    var ref1 = useCreateCampaignGroupModal(campaignType), openCreateModal = ref1.open;
    var ref2 = useEditCampaignGroupModal(), openEditModal = ref2.open;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,domain/* useDeleteCampaignGroupMutation */.z1g)(), 1), deleteCampaignGroupMutation = ref3[0];
    var ref4 = (0,react.useState)(""), searchValue = ref4[0], setSearchValue = ref4[1];
    var ref5 = (0,react.useState)(""), keyword = ref5[0], setKeyword = ref5[1];
    var composingRef = (0,react.useRef)(false);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,use_debounced_value/* useDebouncedValue */.c)(keyword.trim(), 400), 1), debouncedKeyword = ref6[0];
    var searchPlaceholder = t("search.placeholder", {
        campaignType: t(campaignType)
    });
    (0,use_did_update/* useDidUpdate */.l)(function() {
        onKeywordChange(debouncedKeyword);
    }, [
        debouncedKeyword
    ]);
    var handleSearchChange = function(value) {
        setSearchValue(value);
        if (!composingRef.current) {
            setKeyword(value);
        }
    };
    var ref7 = (0,domain/* useApplicationCampaignGroupsQuery */.TT_)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: appId,
            type: campaignType
        },
        onCompleted: function onCompleted(data) {
            var ref;
            if (!isSystemGroup(groupId) && !(data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.campaignGroups.find(function(g) {
                return g.id === groupId;
            }))) {
                onGroupChange(SYSTEM_GROUP.ALL);
            }
        }
    }), data = ref7.data, refetch = ref7.refetch;
    var groups = data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : ref.campaignGroups;
    var options = (0,react.useMemo)(function() {
        var options = [
            {
                value: SYSTEM_GROUP.ALL,
                label: "".concat(t("campaignGroup.filter.all")).concat(t(campaignType)),
                group: t("campaignGroup.filter.defaultGroup")
            },
            {
                value: SYSTEM_GROUP.ENABLED,
                label: "".concat(t("campaignGroup.filter.enabled")).concat(t(campaignType)),
                group: t("campaignGroup.filter.defaultGroup")
            },
            {
                value: SYSTEM_GROUP.DISABLED,
                label: "".concat(t("campaignGroup.filter.disabled")).concat(t(campaignType)),
                group: t("campaignGroup.filter.defaultGroup")
            }, 
        ];
        var ref;
        for(var i = 0; i < ((ref = groups === null || groups === void 0 ? void 0 : groups.length) !== null && ref !== void 0 ? ref : 0); i++){
            var group = groups === null || groups === void 0 ? void 0 : groups[i];
            options.push({
                value: group.id,
                label: group.name,
                group: t("campaignGroup.filter.customGroup")
            });
        }
        manageable && options.push({
            value: "NEW",
            label: t("campaignGroup.create"),
            group: ""
        });
        return options;
    }, [
        groups
    ]);
    var handleChange = function(selectValue) {
        if (selectValue === "NEW") {
            openCreateModal(function(groupId) {
                return onGroupChange(groupId);
            });
            return;
        }
        onGroupChange(selectValue);
    };
    var handleEdit = function(group) {
        openEditModal(group);
    };
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(group) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,events/* openConfirmModal */._5)({
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        spacing: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 5,
                            children: t("campaignGroup.delete.title")
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        size: "sm",
                        children: t("campaignGroup.delete.confirmContent", {
                            name: group.name,
                            campaignType: t(campaignType)
                        })
                    }),
                    labels: {
                        confirm: t("common:actions.delete"),
                        cancel: t("common:actions.cancel")
                    },
                    confirmProps: {
                        color: "red"
                    },
                    onConfirm: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var data, error, graphQLErrors;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        deleteCampaignGroupMutation({
                                            variables: {
                                                id: group.id
                                            }
                                        })
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    if (data === null || data === void 0 ? void 0 : data.deleteCampaignGroup) {
                                        close();
                                        deleteGroup(campaignType, group.id);
                                        group.id === groupId && onGroupChange(null);
                                        ui/* message.successMsg */.yw.successMsg("".concat(t("common:message.deleteSuccess")));
                                        refetch();
                                    }
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    error = _state.sent();
                                    graphQLErrors = error.graphQLErrors;
                                    (0,utils/* graphqlErrorCatch */.Qf)({
                                        graphQLErrors: graphQLErrors,
                                        defaultMessage: t("common:message.deleteError")
                                    });
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    radius: "sm"
                });
                return [
                    2
                ];
            });
        });
        return function handleDelete(group) {
            return _ref.apply(this, arguments);
        };
    }();
    var SelectItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
        var label = _param.label, value = _param.value, group = _param.group, others = (0,_object_without_properties/* default */.Z)(_param, [
            "label",
            "value",
            "group"
        ]);
        return (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            position: "apart",
            className: "group ".concat((0,getColor/* pickSchemeColor */.pl)("hover:bg-gray-1", theme, "hover:bg-dark-5")),
            noWrap: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    ref: ref
                }, others), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        noWrap: true,
                        children: [
                            group === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlus/* default */.Z, {
                                size: 14,
                                color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
                            }),
                            group === t("campaignGroup.filter.customGroup") && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlbum/* default */.Z, {
                                size: 14,
                                color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                size: "sm",
                                className: "truncate",
                                maw: 220,
                                children: label
                            })
                        ]
                    })
                })),
                manageable && group === t("campaignGroup.filter.customGroup") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "0",
                    w: 60,
                    className: "invisible group-hover:visible",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                            size: "sm",
                            onClick: function() {
                                return handleEdit({
                                    id: value,
                                    name: label
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEdit/* default */.Z, {
                                stroke: 1.5,
                                size: 16
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                            size: "sm",
                            onClick: function() {
                                return handleDelete({
                                    id: value,
                                    name: label
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* default */.Z, {
                                stroke: 1.5,
                                size: 16,
                                color: "red"
                            })
                        })
                    ]
                })
            ]
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, {
                w: 350,
                maxDropdownHeight: 400,
                value: groupId !== null && groupId !== void 0 ? groupId : SYSTEM_GROUP.ALL,
                onChange: handleChange,
                itemComponent: SelectItem,
                data: options,
                styles: function(theme) {
                    return {
                        item: {
                            "&[data-selected]": {
                                "&, &:hover": {
                                    backgroundColor: "unset",
                                    color: (0,getColor/* getTextColor */.uu)("brandBlue.7", theme, "brandBlue.3")
                                }
                            },
                            "&[data-hovered]": {
                                backgroundColor: "unset"
                            }
                        }
                    };
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                        w: 240,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* default */.Z, {
                            size: 16
                        }),
                        placeholder: searchPlaceholder,
                        "aria-label": searchPlaceholder,
                        value: searchValue,
                        onChange: function(event) {
                            return handleSearchChange(event.currentTarget.value);
                        },
                        onCompositionStart: function() {
                            composingRef.current = true;
                        },
                        onCompositionEnd: function(event) {
                            composingRef.current = false;
                            handleSearchChange(event.currentTarget.value);
                        },
                        rightSection: searchValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* CloseButton */.P, {
                            size: "sm",
                            "aria-label": t("search.clear"),
                            onClick: function() {
                                return handleSearchChange("");
                            }
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                        color: layout === LayoutType.GRID ? "brandBlue.6" : "gray.6",
                        onClick: function() {
                            return onLayoutChange(LayoutType.GRID);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLayoutGrid/* default */.Z, {
                            size: 20
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                        color: layout === LayoutType.LIST ? "brandBlue.6" : "gray.6",
                        onClick: function() {
                            return onLayoutChange(LayoutType.LIST);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconList/* default */.Z, {
                            size: 20
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var List_Header = (Header);

// EXTERNAL MODULE: ./src/components/business/hooks/useCampaignBaseInfoCache.ts
var useCampaignBaseInfoCache = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/Header/index.tsx






















var Header_obj;
var campaignPathMapping = (Header_obj = {}, (0,_define_property/* default */.Z)(Header_obj, domain/* CampaignType.Survey */.mL.Survey, config_constants/* ApplicationSurvey */.mf), (0,_define_property/* default */.Z)(Header_obj, domain/* CampaignType.Feedback */.mL.Feedback, config_constants/* ApplicationFeedback */.qN), (0,_define_property/* default */.Z)(Header_obj, domain/* CampaignType.Notification */.mL.Notification, config_constants/* ApplicationNotification */.Ks), Header_obj);
var Header_Header = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var channel = (0,useApplicationInfoBaseInfoCache/* default */.Z)().channel;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var ref2 = (0,useCampaignBaseInfoCache/* default */.Z)(campaign.id), cachedCampaign = ref2.campaign;
    var campaignId = campaign.id;
    var url = (0,getXFormUrl/* getXFormUrl */.t)(campaign.token, campaign.type, true);
    var campaignPath = campaignPathMapping[campaign.type].replace("[appId]", appId);
    var getDefaultGroup = (0,useGroupCache/* default */.Z)().getDefaultGroup;
    var ref3 = (0,react.useState)(null), groupId = ref3[0], setGroupId = ref3[1];
    (0,react.useEffect)(function() {
        var defaultGroupId = getDefaultGroup(campaign.type);
        if (!defaultGroupId || defaultGroupId === SYSTEM_GROUP.ALL || campaign.groupIds.includes(defaultGroupId)) {
            return;
        }
        if (defaultGroupId !== (campaign.enabled ? SYSTEM_GROUP.ENABLED : SYSTEM_GROUP.DISABLED)) {
            setGroupId(SYSTEM_GROUP.ALL);
        }
    }, [
        campaign.enabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Button/* BackButton */.xE, {
                        href: {
                            pathname: campaignPathMapping[campaign === null || campaign === void 0 ? void 0 : campaign.type],
                            query: {
                                appId: appId,
                                groupId: groupId
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        order: 5,
                        children: campaign === null || campaign === void 0 ? void 0 : campaign.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionMenus/* default */.Z, {
                            campaign: campaign,
                            onDelete: function() {
                                router.push(campaignPath).then();
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        children: "".concat(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.name, " ").concat(t("createdAt", {
                            dateTime: (0,utils/* formatISODate */.cz)(campaign === null || campaign === void 0 ? void 0 : campaign.createdAt)
                        }))
                    }),
                    channel === domain/* CampaignDistributionChannel.Link */.wQf.Link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWithAction/* default */.ZP, {
                                url: url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignFormStatusSwitch/* default */.Z, {
                                id: campaignId
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DistributionReview/* default */.Z, {
                                id: campaignId
                            }),
                            ((ref1 = campaign.widget) === null || ref1 === void 0 ? void 0 : ref1.type) !== domain/* CampaignWidgetType.Banner */.YMh.Banner && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryUrl/* default */.Z, {
                                id: campaignId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Campaign_StatusIndicator, {
                                enabled: campaign === null || campaign === void 0 ? void 0 : campaign.enabled
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Campaign_DistributionAffectionIndicator, {
                                id: campaignId
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Layout_Header = (Header_Header);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/Onboarding/DeliveryGuide/index.tsx





var DeliveryGuide = function(param) {
    var id = param.id;
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                c: "white",
                children: t("sdkOnboarding.deliveryGuide")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
                width: 400,
                position: "bottom-end",
                shadow: "md",
                offset: 35,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            c: "white",
                            underline: true,
                            className: "cursor-pointer",
                            children: t("sdkOnboarding.deliveryUrl")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                        p: "lg",
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content["default"], {
                            id: id
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Onboarding_DeliveryGuide = (DeliveryGuide);

// EXTERNAL MODULE: ./node_modules/.pnpm/next-translate@1.6.0_next@12.3.4_react@18.2.0/node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(65895);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/Onboarding/SdkGuide.tsx








var SdkGuide = function() {
    var appId = (0,next_router.useRouter)().query.appId;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        c: (0,getColor/* getTextColor */.uu)("white", theme, "white"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            i18nKey: "layoutApplication:sdkOnboarding.connectSdk",
            components: {
                install: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                    target: "_blank",
                    className: "text-[white] underline",
                    href: config_constants/* ApplicationSettingsCodeTracking.replace */._F.replace("[appId]", appId)
                })
            }
        })
    });
};
/* harmony default export */ var Onboarding_SdkGuide = (SdkGuide);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/Onboarding/index.tsx













var getImage = function(type, activeTab, size, colorScheme) {
    var ref, ref1;
    return (ref = __webpack_require__(71095)("./".concat(type, "/").concat(activeTab, "/").concat(size, "px-").concat(colorScheme, ".png"))) === null || ref === void 0 ? void 0 : (ref1 = ref.default) === null || ref1 === void 0 ? void 0 : ref1.src;
};
var Onboarding = function(param) {
    var activeTab = param.activeTab;
    var campaign = (0,CampaignContext/* useCampaign */.yQ)().campaign;
    var id = campaign.id, type = campaign.type;
    var colorScheme = (0,theme_MantineProvider/* useMantineTheme */.rZ)().colorScheme;
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        mt: 16,
        sx: {
            width: "100%",
            maxWidth: 1600
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(max-width: 1360px)",
                        srcSet: getImage(type, activeTab, config_constants/* onboardingBreakpoints.sm */.DI.sm, colorScheme)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(max-width: 1680px)",
                        srcSet: getImage(type, activeTab, config_constants/* onboardingBreakpoints.md */.DI.md, colorScheme)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(max-width: 1920px)",
                        srcSet: getImage(type, activeTab, config_constants/* onboardingBreakpoints.lg */.DI.lg, colorScheme)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        media: "(min-width: 1920px)",
                        srcSet: getImage(type, activeTab, config_constants/* onboardingBreakpoints.xl */.DI.xl, colorScheme)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        width: "100%",
                        src: getImage(type, activeTab, 1200, colorScheme),
                        alt: "".concat(type, " ").concat(activeTab, " sdk uninstall")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_SdkOnboarding, {
                children: (0,applicationUtils/* isLinkDistribution */.dQ)(application) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    c: "white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                        i18nKey: "layoutApplication:onboarding.content",
                        components: {
                            link: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                target: "_blank",
                                className: "text-[white] underline",
                                href: (0,getXFormUrl/* getXFormUrl */.t)(campaign === null || campaign === void 0 ? void 0 : campaign.token, campaign === null || campaign === void 0 ? void 0 : campaign.type, true)
                            })
                        }
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboarding_SdkGuide, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboarding_DeliveryGuide, {
                            id: id
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Layout_Onboarding = (Onboarding);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(4720);
// EXTERNAL MODULE: ./src/config/constants/campaignPathMapping.ts
var constants_campaignPathMapping = __webpack_require__(68749);
// EXTERNAL MODULE: ./src/components/business/Campaign/Layout/Blank/entriesEmpty.png
var entriesEmpty = __webpack_require__(70624);
;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/Blank/index.tsx













var Blank = function() {
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("layoutCampaign").t;
    var ref = (0,CampaignContext/* useCampaign */.yQ)(), campaignTypeName = ref.campaignTypeName, campaign = ref.campaign;
    var url = (0,getXFormUrl/* getXFormUrl */.t)(campaign === null || campaign === void 0 ? void 0 : campaign.token, campaign === null || campaign === void 0 ? void 0 : campaign.type, true);
    var router = (0,next_router.useRouter)();
    var _query = router.query, appId = _query.appId, campaignId = _query.campaignId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        align: "center",
        mt: 80,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                src: entriesEmpty/* default.src */.Z.src,
                width: 48,
                height: 48,
                alt: "no entries"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                mt: "md",
                order: 5,
                children: t("blank.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List */.a, {
                mt: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            ta: "left",
                            color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                i18nKey: "layoutCampaign:blank.description1",
                                values: {
                                    campaignTypeName: campaignTypeName
                                },
                                components: {
                                    distribution: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                        href: {
                                            pathname: constants_campaignPathMapping/* editPathMapping */.$[campaign === null || campaign === void 0 ? void 0 : campaign.type],
                                            query: {
                                                appId: appId,
                                                campaignId: campaignId,
                                                step: "distribution"
                                            }
                                        }
                                    })
                                }
                            })
                        })
                    }),
                    (campaign === null || campaign === void 0 ? void 0 : campaign.widget.type) !== domain/* CampaignWidgetType.Banner */.YMh.Banner && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            ta: "left",
                            color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                i18nKey: "layoutCampaign:blank.description2",
                                values: {
                                    campaignTypeName: campaignTypeName
                                },
                                components: {
                                    link: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                        target: "blank",
                                        href: url
                                    })
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            ta: "left",
                            color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                            children: t("blank.description3")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Layout_Blank = (Blank);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Layout/index.tsx












var CampaignLayout = function(props) {
    var children = props.children, campaignTypeName = props.campaignTypeName, activeTab = props.activeTab, showOnboarding = props.showOnboarding, _showEmpty = props.showEmpty, showEmpty = _showEmpty === void 0 ? false : _showEmpty, campaign = props.campaign;
    var ref = (0,react.useState)(campaign === null || campaign === void 0 ? void 0 : campaign.enabled), enabled = ref[0], setEnabled = ref[1];
    var ref1 = (0,react.useState)(campaign === null || campaign === void 0 ? void 0 : campaign.entriesCount), entriesCount = ref1[0], setEntriesCount = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: "\n          body {\n            overflow-y: hidden;\n          }\n        "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                size: config_constants/* containerMaxSize */.qr,
                p: 0,
                w: "100%",
                h: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                    h: "100%",
                    spacing: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CampaignContext/* CampaignProvider */.eu, {
                        defaultValue: {
                            campaign: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, campaign), {
                                enabled: enabled,
                                entriesCount: entriesCount
                            }),
                            campaignTypeName: campaignTypeName
                        },
                        actions: {
                            setEntriesCount: setEntriesCount,
                            setEnabled: setEnabled
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                spacing: "sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Header, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Tabs, {
                                        activeTab: activeTab
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                                className: "flex-1",
                                spacing: 0,
                                children: showOnboarding ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Onboarding, {
                                    activeTab: activeTab
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: showEmpty && entriesCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Blank, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        h: "100%",
                                        mt: "lg",
                                        children: children
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Layout = (CampaignLayout);

;// CONCATENATED MODULE: ./src/components/business/Campaign/Header.tsx




var Campaign_Header_Header = function(param) {
    var totalCount = param.totalCount, campaignType = param.campaignType, children = param.children;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                        children: t("".concat(campaignType))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        color: "dimmed",
                        children: [
                            t("list.total", {
                                count: totalCount
                            }),
                            t("".concat(campaignType))
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ var Campaign_Header = (Campaign_Header_Header);

// EXTERNAL MODULE: ./src/components/business/Campaign/DistributionReview/index.tsx
var DistributionReview = __webpack_require__(89421);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Flex/Flex.js + 1 modules
var Flex = __webpack_require__(26385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Pagination/Pagination.js + 12 modules
var Pagination = __webpack_require__(18919);
;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Footer.tsx



var Footer = function(props) {
    var page = props.page, pageSize = props.pageSize, totalCount = props.totalCount, onChange = props.onChange, className = props.className;
    var total = Math.ceil(totalCount / pageSize);
    if (total <= 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "center",
        className: className,
        pb: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
            size: "sm",
            value: page,
            onChange: onChange,
            total: total
        })
    });
};
/* harmony default export */ var List_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ScrollArea/ScrollArea.js + 12 modules
var ScrollArea = __webpack_require__(65067);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(4588);
// EXTERNAL MODULE: ./src/components/business/Campaign/List/Actions.tsx
var Actions = __webpack_require__(95429);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconFileDescription.js
var IconFileDescription = __webpack_require__(94752);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconLayoutNavbarExpand.js
var IconLayoutNavbarExpand = __webpack_require__(62833);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconAlignBoxCenterMiddle.js
var IconAlignBoxCenterMiddle = __webpack_require__(97380);
// EXTERNAL MODULE: ./src/components/business/Campaign/DeliveryUrl/index.tsx
var DeliveryUrl = __webpack_require__(69119);
;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Table/GridBody.tsx












var GridBody = function(param) {
    var data = param.data, onItemClick = param.onItemClick, itemStyle = param.itemStyle;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var getTag = function(campaign) {
        var color = (0,getColor/* getTextColor */.uu)("gray.6", theme);
        if (campaign.type === domain/* CampaignType.Feedback */.mL.Feedback) {
            var _score;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                value: (_score = campaign.stats.score) !== null && _score !== void 0 ? _score : 0
            });
        }
        if (campaign.type === domain/* CampaignType.Survey */.mL.Survey) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFileDescription/* default */.Z, {
                size: 14,
                color: color
            });
        }
        if (campaign.type === domain/* CampaignType.Notification */.mL.Notification) {
            if (campaign.widget.type === domain/* CampaignWidgetType.Banner */.YMh.Banner) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLayoutNavbarExpand/* default */.Z, {
                            size: 14,
                            color: color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            c: color,
                            size: "xs",
                            children: t("list.widgetType.compact.".concat(domain/* CampaignWidgetType.Banner */.YMh.Banner))
                        })
                    ]
                });
            }
            if (campaign.widget.type === domain/* CampaignWidgetType.Popup */.YMh.Popup) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlignBoxCenterMiddle/* default */.Z, {
                            size: 14,
                            color: (0,getColor/* getTextColor */.uu)("gray.6", theme)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            c: (0,getColor/* getTextColor */.uu)("gray.6", theme),
                            size: "xs",
                            children: t("list.widgetType.compact.".concat(domain/* CampaignWidgetType.Popup */.YMh.Popup))
                        })
                    ]
                });
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var _entriesCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
        columns: 25,
        children: data.map(function(i, idx) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                span: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
                    withBorder: true,
                    radius: "md",
                    className: "group",
                    onClick: function() {
                        return onItemClick(i.rawData);
                    },
                    sx: itemStyle === null || itemStyle === void 0 ? void 0 : itemStyle(i.rawData),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            inheritPadding: true,
                            py: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                position: "apart",
                                children: [
                                    getTag(i.rawData),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Campaign_StatusIndicator, {
                                        enabled: i.rawData.enabled
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            inheritPadding: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                h: 40,
                                lineClamp: 2,
                                children: i.rawData.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            inheritPadding: true,
                            py: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                spacing: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        size: "lg",
                                        children: (_entriesCount = i.rawData.entriesCount) !== null && _entriesCount !== void 0 ? _entriesCount : 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        c: (0,getColor/* getTextColor */.uu)("gray.6", theme),
                                        className: "ml-2",
                                        size: "xs",
                                        children: t("list.entriesCountSuffix")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                            inheritPadding: true,
                            py: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                position: "apart",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        c: (0,getColor/* getTextColor */.uu)("gray.6", theme),
                                        children: (0,utils/* formatSlashedISODATE */.Fy)(i.rawData.createdAt)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                        spacing: "0",
                                        children: [
                                            ((ref = i.rawData.widget) === null || ref === void 0 ? void 0 : ref.type) !== domain/* CampaignWidgetType.Banner */.YMh.Banner && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryUrl/* default */.Z, {
                                                id: i.rawData.id,
                                                compact: true,
                                                showText: false
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DistributionReview/* default */.Z, {
                                                id: i.rawData.id,
                                                compact: true,
                                                showText: false
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Actions/* default */.Z, {
                                                campaign: i.rawData,
                                                onRefresh: i.refetch,
                                                onItemChange: i.onItemChange
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, idx);
        })
    });
};
/* harmony default export */ var Table_GridBody = (GridBody);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js
var get = __webpack_require__(6935);
;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Table/ListBody.tsx





var ListBody = function(param) {
    var data = param.data, onItemClick = param.onItemClick, itemStyle = param.itemStyle, columns = param.columns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        spacing: "lg",
        children: data.map(function(dataItem, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                noWrap: true,
                position: "apart",
                sx: itemStyle === null || itemStyle === void 0 ? void 0 : itemStyle(dataItem),
                onClick: function() {
                    onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(dataItem.rawData);
                },
                children: columns.map(function(column) {
                    var dataPath = column.dataPath, minWidth = column.minWidth, maxWidth = column.maxWidth, width = column.width, flex = column.flex, cellStyle = column.cellStyle, cellRenderer = column.cellRenderer;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        style: (0,src_object_spread/* default */.Z)({
                            minWidth: minWidth,
                            maxWidth: maxWidth,
                            width: width,
                            flex: flex
                        }, cellStyle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            lineClamp: 1,
                            children: !!cellRenderer ? cellRenderer(dataItem, column) : (0,get/* default */.Z)(dataItem, dataPath !== null && dataPath !== void 0 ? dataPath : "")
                        })
                    }, "body-cell-".concat(dataPath));
                })
            }, index);
        })
    });
};
/* harmony default export */ var Table_ListBody = (ListBody);

;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Table/ListHedaer.tsx





var ListHeader = function(param) {
    var columns = param.columns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "apart",
        sx: {
            gap: 0
        },
        noWrap: true,
        children: columns.map(function(column) {
            var dataPath = column.dataPath, minWidth = column.minWidth, maxWidth = column.maxWidth, width = column.width, flex = column.flex, cellStyle = column.cellStyle, headerCellStyle = column.headerCellStyle;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                style: (0,src_object_spread/* default */.Z)({
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    width: width,
                    flex: flex
                }, cellStyle, headerCellStyle),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderCell/* default */.Z, {
                    children: column.title
                })
            }, "header-cell-".concat(dataPath));
        })
    });
};
/* harmony default export */ var ListHedaer = (ListHeader);

;// CONCATENATED MODULE: ./src/components/business/Campaign/List/Table/index.tsx










var Table = function(param) {
    var layout = param.layout, data = param.data, columns = param.columns, className = param.className, footer = param.footer;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var handleItemClick = function(campaign) {
        router.push({
            pathname: constants_campaignPathMapping/* entriesPathMapping */.Z[campaign.type],
            query: {
                appId: appId,
                campaignId: campaign.id
            }
        }).then();
    };
    var itemStyle = function(data) {
        return {
            cursor: "pointer",
            overflow: "hidden",
            borderRadius: "6px",
            backgroundColor: (0,getColor/* getBackgroundColor */.dF)("white", theme),
            border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.1", theme)),
            boxShadow: "0px 8px 8px -8px rgba(0, 0, 0, 0.1)",
            position: "relative",
            gap: 0,
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                width: 4,
                backgroundColor: (0,getColor/* getBackgroundColor */.dF)(data.enabled ? "teal.3" : "gray.3", theme)
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        h: "100%",
        spacing: 0,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                style: {
                    paddingRight: "24px"
                },
                children: layout === LayoutType.LIST && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListHedaer, {
                    columns: columns
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "flex-1 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    className: "absolute",
                    right: 0,
                    left: 0,
                    top: 0,
                    bottom: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollArea/* ScrollArea */.x, {
                        h: "calc(100% - ".concat(theme.spacing.lg, ")"),
                        styles: {
                            viewport: {
                                paddingRight: 24,
                                paddingBottom: 0
                            }
                        },
                        children: [
                            layout === LayoutType.GRID && /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_GridBody, {
                                data: data,
                                onItemClick: handleItemClick,
                                itemStyle: itemStyle
                            }),
                            layout === LayoutType.LIST && /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_ListBody, {
                                data: data,
                                onItemClick: handleItemClick,
                                itemStyle: itemStyle,
                                columns: columns
                            })
                        ]
                    })
                })
            }),
            footer
        ]
    });
};
/* harmony default export */ var List_Table = (Table);

;// CONCATENATED MODULE: ./src/components/business/Campaign/List/index.tsx




















var List_pageSize = config_constants/* PAGE_SIZE.LG */.IV.LG;
var scrollbarOffset = 24;
var CampaignList = function(param) {
    var campaignType = param.campaignType, entriesPath = param.entriesPath, tableColumns = param.tableColumns;
    var ref, ref1;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var application = (0,react.useContext)(ApplicationContext/* default */.Z).application;
    var isLinkApplication = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    var _query = router.query, appId = _query.appId, groupIdFromUrl = _query.groupId;
    var ref2 = (0,useGroupCache/* default */.Z)(), setDefaultGroup = ref2.setDefaultGroup, getDefaultGroup = ref2.getDefaultGroup;
    var ref3 = useCampaignLayoutCache(), setDefaultLayout = ref3.setDefaultLayout, getDefaultLayout = ref3.getDefaultLayout;
    var ref4 = (0,react.useState)(null), groupId = ref4[0], setGroupId = ref4[1];
    var ref5 = (0,react.useState)(""), keyword = ref5[0], setKeyword = ref5[1];
    var ref6 = (0,react.useState)(1), page = ref6[0], setPage = ref6[1];
    var ref7 = (0,react.useState)(null), layout = ref7[0], setLayout = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,domain/* useCampaignsLazyQuery */.aOk)({
        fetchPolicy: "cache-and-network"
    }), 2), fetch = ref8[0], ref9 = ref8[1], data = ref9.data, previousData = ref9.previousData, loading = ref9.loading, refetch = ref9.refetch;
    var fetchCampaigns = function(groupId, keyword) {
        var page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        setPage(page);
        return fetch({
            variables: {
                id: appId,
                pageArguments: {
                    first: List_pageSize,
                    after: (0,graphqlCursor/* getAfter */.xL)(page, List_pageSize).after
                },
                filter: {
                    type: campaignType,
                    groupId: isSystemGroup(groupId) ? null : groupId,
                    enabled: getEnabled(groupId),
                    keyword: keyword || undefined
                }
            }
        });
    };
    (0,react.useEffect)(function() {
        setLayout(getDefaultLayout(campaignType));
        var groupId = groupIdFromUrl === SYSTEM_GROUP.ALL ? null : getDefaultGroup(campaignType);
        setGroupId(groupId);
        setDefaultGroup(campaignType, groupId);
        fetchCampaigns(groupId, keyword);
    }, [
        appId,
        groupIdFromUrl
    ]);
    var handlePageChange = function(nextPage) {
        if (nextPage !== page) {
            fetchCampaigns(groupId, keyword, nextPage);
        }
    };
    var handleFilterChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(groupId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setGroupId(groupId);
                        setDefaultGroup(campaignType, groupId);
                        return [
                            4,
                            fetchCampaigns(groupId, keyword)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFilterChange(groupId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeywordChange = function(keyword) {
        setKeyword(keyword);
        fetchCampaigns(groupId, keyword);
    };
    var handleLayoutChange = function(layout) {
        setLayout(layout);
        setDefaultLayout(campaignType, layout);
    };
    var getEnabled = function(groupId) {
        if (groupId === SYSTEM_GROUP.ENABLED) {
            return true;
        }
        if (groupId === SYSTEM_GROUP.DISABLED) {
            return false;
        }
        return null;
    };
    var handleRowClick = function(data) {
        router.push({
            pathname: entriesPath,
            query: {
                appId: appId,
                campaignId: data.rawData.id
            }
        }).then();
    };
    var campaignRowStyle = function(data) {
        return {
            cursor: "pointer",
            overflow: "hidden",
            borderRadius: "6px",
            backgroundColor: (0,getColor/* getBackgroundColor */.dF)("white", theme),
            border: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.1", theme)),
            boxShadow: "0px 8px 8px -8px rgba(0, 0, 0, 0.1)",
            position: "relative",
            gap: 0,
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                width: 4,
                backgroundColor: (0,getColor/* getBackgroundColor */.dF)(data.enabled ? "teal.3" : "gray.3", theme)
            }
        };
    };
    var result = data !== null && data !== void 0 ? data : previousData;
    var campaigns = (result === null || result === void 0 ? void 0 : (ref = result.application) === null || ref === void 0 ? void 0 : ref.id) === application.id ? result.application.campaigns : undefined;
    var ref10;
    var tableData = (ref10 = campaigns === null || campaigns === void 0 ? void 0 : (ref1 = campaigns.nodes) === null || ref1 === void 0 ? void 0 : ref1.map(function(campaign) {
        var name = campaign.name, pv = campaign.pv, entriesCount = campaign.entriesCount, creator = campaign.creator, enabled = campaign.enabled, urlEnabled = campaign.urlEnabled, createdAt = campaign.createdAt;
        return {
            name: name,
            creator: creator,
            createdAt: createdAt,
            enabled: isLinkApplication ? urlEnabled : enabled,
            urlEnabled: urlEnabled,
            pv: (0,utils/* formatNumberToThousands */.NZ)(pv),
            entriesCount: (0,utils/* formatNumberToThousands */.NZ)(entriesCount),
            ratio: (0,utils/* calcPercent */.rV)(entriesCount, pv),
            rawData: campaign,
            refetch: refetch
        };
    })) !== null && ref10 !== void 0 ? ref10 : [];
    if (layout === null) {
        return null;
    }
    var ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: "lg",
        className: "flex-1",
        mr: -scrollbarOffset,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List_Header, {
                campaignType: campaignType,
                groupId: groupId,
                onGroupChange: handleFilterChange,
                onKeywordChange: handleKeywordChange,
                layout: layout,
                onLayoutChange: handleLayoutChange
            }),
            tableData.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(List_Table, {
                layout: layout,
                data: tableData,
                columns: tableColumns,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                    justify: "flex-start",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List_Footer, {
                        page: page,
                        pageSize: List_pageSize,
                        totalCount: (ref11 = campaigns === null || campaigns === void 0 ? void 0 : campaigns.totalCount) !== null && ref11 !== void 0 ? ref11 : 0,
                        onChange: handlePageChange
                    })
                })
            }) : campaigns && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableEmpty/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Campaign_List = (CampaignList);

;// CONCATENATED MODULE: ./src/components/business/Campaign/StatusIndicator/index.tsx



var StatusIndicator = function(param) {
    var enabled = param.enabled;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* StatusBadge */.OE, {
        value: enabled,
        onText: t("statusSwitcher.opened"),
        offText: t("statusSwitcher.closed")
    });
};
/* harmony default export */ var Campaign_StatusIndicator = (StatusIndicator);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconAlertCircle.js
var IconAlertCircle = __webpack_require__(39747);
// EXTERNAL MODULE: ./src/components/business/ProductsModal/index.ts + 13 modules
var ProductsModal = __webpack_require__(7921);
;// CONCATENATED MODULE: ./src/components/business/Campaign/DistributionAffectionIndicator/DistributionAffectionTooltipLabel.tsx









var DistributionAffectionTooltipLabel = function(param) {
    var campaignId = param.campaignId, campaignType = param.campaignType, reasons = param.reasons, terminated = param.terminated, affectedSteps = param.affectedSteps;
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var handleClickEventPropagation = function(event) {
        event.stopPropagation();
    };
    var onUpgrade = function() {
        return (0,ProductsModal/* openProductsModal */.$P)("CampaignDistributionAffection");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        onClick: handleClickEventPropagation,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                pb: "xs",
                className: "leading-[20px]",
                children: t("list.distributionAffectionTooltip.title.".concat(terminated ? "terminated" : "affected"), {
                    type: t(campaignType)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                size: "sm",
                spacing: "xs",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[4px] h-[4px] rounded-full bg-gray-5"
                }),
                styles: {
                    itemWrapper: {
                        alignItems: "center !important"
                    }
                },
                children: reasons.map(function(reason, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List.Item */.a.Item, {
                        className: "leading-[20px]",
                        h: 20,
                        children: reason
                    }, "".concat(campaignId, " - ").concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                pt: "md",
                className: "leading-[20px]",
                children: terminated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "componentCampaignList:list.distributionAffectionTooltip.tips.terminated",
                    components: {
                        upgrade: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                            onClick: onUpgrade
                        })
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "componentCampaignList:list.distributionAffectionTooltip.tips.affected",
                    components: {
                        steps: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: affectedSteps.map(function(step, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        index > 0 && "、",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                                            href: {
                                                pathname: constants_campaignPathMapping/* editPathMapping */.$[campaignType],
                                                query: {
                                                    appId: appId,
                                                    campaignId: campaignId,
                                                    step: step
                                                }
                                            },
                                            children: t("list.distributionAffectionTooltip.steps.".concat(step))
                                        }, step)
                                    ]
                                });
                            })
                        }),
                        upgrade: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                            onClick: onUpgrade
                        })
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var DistributionAffectionIndicator_DistributionAffectionTooltipLabel = (DistributionAffectionTooltipLabel);

;// CONCATENATED MODULE: ./src/components/business/Campaign/DistributionAffectionIndicator/index.tsx










var DistributionAffectionIndicator = function(param) {
    var id = param.id, campaign = param.campaign;
    var ref;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentCampaignList").t;
    var ref1 = (0,useAccountSubscriptionCache/* default */.Z)(), account = ref1.account, subscription = ref1.subscription;
    var checkFeature = useCheckFeature();
    var isFreeSubscription = (subscription === null || subscription === void 0 ? void 0 : subscription.productCode) === "free";
    var data = (0,domain/* useCampaignDistributionAffectionQuery */.I4e)({
        variables: {
            id: id
        }
    }).data;
    var currentCampaign = !(0,isNil/* default */.Z)(campaign) ? campaign : data === null || data === void 0 ? void 0 : data.campaign;
    if (!isFreeSubscription || !account || (0,isNil/* default */.Z)(currentCampaign)) {
        return null;
    }
    var type = currentCampaign.type, trigger = currentCampaign.trigger, targeting = currentCampaign.targeting, schedule = currentCampaign.schedule;
    var handleClickEventPropagation = function(event) {
        event.stopPropagation();
    };
    var distributionAffections = [];
    var affectedSteps = [];
    var entriesUsageCountOverLimit = (account === null || account === void 0 ? void 0 : account.vasBalance[domain/* Feature.EntriesCount */.L0B.EntriesCount].balance) <= 0;
    if (entriesUsageCountOverLimit) {
        distributionAffections.push(t("list.distributionAffectionTooltip.entriesUsageCountOverLimit"));
    }
    if (!checkFeature(domain/* Feature.CampaignTriggerByEvent */.L0B.CampaignTriggerByEvent) && (trigger === null || trigger === void 0 ? void 0 : trigger.conditions.some(function(param) {
        var event = param.event;
        return event === domain/* CampaignTriggerEvent.EventReceived */.Yeg.EventReceived;
    }))) {
        distributionAffections.push(t("list.distributionAffectionTooltip.triggerByEventUnavailable", {
            type: t(type)
        }));
        affectedSteps.push("distribution");
    }
    if ((schedule === null || schedule === void 0 ? void 0 : schedule.enable) && !checkFeature(domain/* Feature.CampaignSchedule */.L0B.CampaignSchedule)) {
        distributionAffections.push(t("list.distributionAffectionTooltip.scheduleUnavailable"));
        affectedSteps.push("distribution");
    }
    if (!checkFeature(domain/* Feature.CampaignTargetingCustomer */.L0B.CampaignTargetingCustomer) && (targeting === null || targeting === void 0 ? void 0 : targeting.customerFilter)) {
        distributionAffections.push(t("list.distributionAffectionTooltip.targetingCustomerUnavailable"));
        affectedSteps.push("distribution");
    }
    if (!checkFeature(domain/* Feature.ScreenshotField */.L0B.ScreenshotField) && ((ref = currentCampaign.form) === null || ref === void 0 ? void 0 : ref.hasVisibleScreenshotsEnabledField)) {
        distributionAffections.push(t("list.distributionAffectionTooltip.screenshotUnavailable"));
        affectedSteps.unshift("fields");
    }
    if (distributionAffections.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
        width: 400,
        offset: 10,
        withinPortal: true,
        openDelay: 0,
        closeDelay: 300,
        position: "bottom-end",
        shadow: theme.shadows.md,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                    onClick: handleClickEventPropagation,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlertCircle/* default */.Z, {
                        size: 18,
                        color: theme.colors.red[6],
                        stroke: 1.5
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DistributionAffectionIndicator_DistributionAffectionTooltipLabel, {
                    campaignId: id,
                    campaignType: type,
                    reasons: distributionAffections,
                    terminated: entriesUsageCountOverLimit,
                    affectedSteps: (0,uniq/* default */.Z)(affectedSteps)
                })
            })
        ]
    });
};
/* harmony default export */ var Campaign_DistributionAffectionIndicator = (DistributionAffectionIndicator);

// EXTERNAL MODULE: ./src/components/business/Campaign/DeliveryUrl/Content.tsx
var Content = __webpack_require__(96780);
// EXTERNAL MODULE: ./src/components/business/Campaign/FeatureUnavailable/index.tsx + 3 modules
var FeatureUnavailable = __webpack_require__(76626);
// EXTERNAL MODULE: ./src/components/business/Campaign/hooks/index.ts + 10 modules
var Campaign_hooks = __webpack_require__(79845);
;// CONCATENATED MODULE: ./src/components/business/Campaign/index.ts













;// CONCATENATED MODULE: ./src/components/business/Authentication/components/IdentifierInput.tsx






var IdentifierInput = function(_param) {
    var formContext = _param.formContext, props = (0,_object_without_properties/* default */.Z)(_param, [
        "formContext"
    ]);
    var t = (0,useTranslation/* default */.Z)("user").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,src_object_spread/* default */.Z)({
        placeholder: t("authentication.form.identifier"),
        "data-autofocus": true
    }, props, formContext === null || formContext === void 0 ? void 0 : formContext.getInputProps("identifier")));
};
/* harmony default export */ var components_IdentifierInput = (IdentifierInput);

// EXTERNAL MODULE: ./src/modules/Captcha/Sender.tsx
var Sender = __webpack_require__(19892);
;// CONCATENATED MODULE: ./src/components/business/Authentication/constants.ts
// 目前用于注册，忘记密码
var captchaDateId = "authenticationCodeSendAt";
var captchaCountDown = 60;

;// CONCATENATED MODULE: ./src/components/business/Authentication/components/CaptchaSender.tsx






var CaptchaSender = function(_param) {
    var captchaType = _param.captchaType, form = _param.form, identifierNotExistedErrorHandler = _param.identifierNotExistedErrorHandler, identifierExistedErrorHandler = _param.identifierExistedErrorHandler, guard = _param.guard, onSend = _param.onSend, getCountDownText = _param.getCountDownText, defaultText = _param.defaultText, displayType = _param.displayType, buttonProps = (0,_object_without_properties/* default */.Z)(_param, [
        "captchaType",
        "form",
        "identifierNotExistedErrorHandler",
        "identifierExistedErrorHandler",
        "guard",
        "onSend",
        "getCountDownText",
        "defaultText",
        "displayType"
    ]);
    var getValidIdentifier = function() {
        return new Promise(function(resolve, reject) {
            var hasError = form.validateField("identifier").hasError;
            hasError || guard && !guard() ? reject() : resolve(form.values.identifier.trim());
        });
    };
    var onCaptchaError = function(graphQLErrors, defaultHandler) {
        var ref, ref1;
        var errorCode = graphQLErrors === null || graphQLErrors === void 0 ? void 0 : (ref = graphQLErrors[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.extensions) === null || ref1 === void 0 ? void 0 : ref1.code;
        if (errorCode == "error.identifier_existed" && identifierExistedErrorHandler) {
            identifierExistedErrorHandler();
        } else if (errorCode == "error.not_registered" && identifierNotExistedErrorHandler) {
            identifierNotExistedErrorHandler();
        } else {
            defaultHandler();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Sender/* default */.Z, (0,src_object_spread/* default */.Z)({
        dateId: captchaDateId,
        countDown: captchaCountDown,
        getValidIdentifier: getValidIdentifier,
        captchaType: captchaType,
        onError: onCaptchaError,
        onSend: onSend,
        getCountDownText: getCountDownText,
        defaultText: defaultText,
        displayType: displayType
    }, buttonProps));
};
/* harmony default export */ var components_CaptchaSender = (CaptchaSender);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/PasswordInput/PasswordInput.js + 2 modules
var PasswordInput = __webpack_require__(13337);
;// CONCATENATED MODULE: ./src/components/business/Authentication/components/PasswordInputStep.tsx






var PasswordInputStep = function(param) {
    var form = param.form;
    var t = (0,useTranslation/* default */.Z)("user").t;
    var _ref = form.getInputProps("password"), onBlur = _ref.onBlur, passwordProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "onBlur"
    ]);
    var handlePasswordChange = function(event) {
        onBlur(event);
        form.isDirty("confirmPassword") && form.values.confirmPassword && form.validateField("confirmPassword");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,src_object_spread/* default */.Z)({
                size: "md",
                placeholder: t("authentication.form.passwordInput.password"),
                autoComplete: "new-password",
                onBlur: handlePasswordChange
            }, passwordProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,src_object_spread/* default */.Z)({
                size: "md",
                placeholder: t("authentication.form.passwordInput.confirmPassword")
            }, form.getInputProps("confirmPassword")))
        ]
    });
};
/* harmony default export */ var components_PasswordInputStep = (PasswordInputStep);

;// CONCATENATED MODULE: ./src/components/business/Authentication/hooks/useFormValidations.ts


function useFormValidations() {
    var t = (0,useTranslation/* default */.Z)("user").t;
    var validateIdentifier = function(value) {
        if (!value) {
            return t("authentication.form.errors.identifierRequired");
        }
        if (!(0,utils/* isMobile */.tq)(value.trim())) {
            return t("authentication.form.errors.mobileInvalid");
        }
        return null;
    };
    var validateEmail = function(value) {
        if (!value) {
            return t("authentication.form.errors.emailRequired");
        }
        if (!(0,utils/* isEmail */.Jh)(value.trim())) {
            return t("authentication.form.errors.emailInvalid");
        }
        return null;
    };
    var validatePassword = function(value) {
        if (!value) {
            return t("authentication.form.errors.passwordRequired");
        }
        if (value.trim().length == 0) {
            return t("authentication.form.errors.passwordAllBlank");
        }
        if (value.length < 6) {
            return t("authentication.form.errors.passwordStrengthInvalid");
        }
        return null;
    };
    var validateConfirmPassword = function(confirmPassword, password) {
        if (!confirmPassword) {
            return t("authentication.form.errors.passwordRequired");
        }
        return confirmPassword !== password ? t("authentication.form.errors.confirmPasswordMismatch") : null;
    };
    var validateCaptcha = function(value) {
        return !!value ? null : t("authentication.form.errors.captchaRequired");
    };
    var validateAccountName = function(value) {
        return value.trim().length == 0 ? t("authentication.form.errors.accountNameRequired") : null;
    };
    var resetFormValidate = function(values, form) {
        return {
            identifier: form.isDirty("identifier") ? validateIdentifier(values.identifier) : null,
            captcha: validateCaptcha(values.captcha),
            password: validatePassword(values.password),
            confirmPassword: validateConfirmPassword(values.confirmPassword, values.password)
        };
    };
    var signupFormValidate = function(values, form) {
        return {
            identifier: form.isDirty("identifier") ? validateIdentifier(values.identifier) : null,
            captcha: validateCaptcha(values.captcha),
            password: validatePassword(values.password)
        };
    };
    return {
        resetFormValidate: resetFormValidate,
        signupFormValidate: signupFormValidate,
        validateIdentifier: validateIdentifier,
        validateEmail: validateEmail,
        validatePassword: validatePassword,
        validateConfirmPassword: validateConfirmPassword,
        validateCaptcha: validateCaptcha,
        validateAccountName: validateAccountName
    };
}

;// CONCATENATED MODULE: ./src/components/business/Authentication/components/CaptchaCodeSendAndInput.tsx






var CaptchaCodeSendAndInput = function(param) {
    var identifierExistedErrorHandler = param.identifierExistedErrorHandler, captchaType = param.captchaType, identifierNotExistedErrorHandler = param.identifierNotExistedErrorHandler, form = param.form;
    var t = (0,useTranslation/* default */.Z)("user").t;
    var onCaptchaSend = function() {
        form.setFieldValue("captcha", "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,src_object_spread/* default */.Z)({
                placeholder: t("authentication.form.errors.captchaRequired"),
                className: "flex-1",
                size: "md"
            }, form.getInputProps("captcha"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CaptchaSender, {
                size: "md",
                identifierExistedErrorHandler: identifierExistedErrorHandler,
                identifierNotExistedErrorHandler: identifierNotExistedErrorHandler,
                onSend: onCaptchaSend,
                disabled: !form.values.identifier || !form.isValid("identifier"),
                form: form,
                captchaType: captchaType,
                ml: "sm",
                fullWidth: false
            })
        ]
    });
};
/* harmony default export */ var components_CaptchaCodeSendAndInput = (CaptchaCodeSendAndInput);

;// CONCATENATED MODULE: ./src/components/business/Authentication/index.ts






;// CONCATENATED MODULE: ./src/components/business/Integration/AddButton/index.tsx






var WebhookAddButton = function(param) {
    var onClick = param.onClick;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var canUseWebhook = useCheckFeature()(domain/* Feature.Webhook */.L0B.Webhook);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
        disabled: canUseWebhook,
        withinPortal: true,
        withArrow: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: onClick,
                        disabled: !canUseWebhook,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            children: [
                                t("webhook.actions.create"),
                                !canUseWebhook && /*#__PURE__*/ (0,jsx_runtime.jsx)(VipIcon/* default */.Z, {})
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureTip/* default */.Z, {
                    feature: domain/* Feature.Webhook */.L0B.Webhook
                })
            })
        ]
    });
};
/* harmony default export */ var AddButton = (WebhookAddButton);

// EXTERNAL MODULE: ./src/components/business/Integration/WebhookContext.ts
var WebhookContext = __webpack_require__(80347);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+form@6.0.13_react@18.2.0/node_modules/@mantine/form/esm/FormProvider/FormProvider.js
var FormProvider = __webpack_require__(33313);
;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/formContext.ts


var ref = (0,_sliced_to_array/* default */.Z)((0,FormProvider/* createFormContext */.W)(), 3);
var WebhookBuilderFormProvider = ref[0], useWebhookBuilderFormContext = ref[1], useWebhookBuilderForm = ref[2];

;// CONCATENATED MODULE: ./src/components/business/Integration/constants.tsx

var DEMO_WEBHOOK_ENTRY_ID = "DEMO_ENTRY_ID";
var DEMO_WEBHOOK_CAMPAIGN_ID = "DEMO_CAMPAIGN_ID";
var webhookNameMaxLength = 50;
var orderedWebhookChannels = [
    domain/* WebhookChannel.QiyeWx */.Osq.QiyeWx,
    domain/* WebhookChannel.Dingtalk */.Osq.Dingtalk,
    domain/* WebhookChannel.Feishu */.Osq.Feishu,
    domain/* WebhookChannel.Default */.Osq.Default, 
];
var AT_ALL_VALUE = "@all";

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/validate.ts



function validateName(value, t) {
    if ((0,utils/* isBlank */.fp)(value)) {
        return t("common:message.valueRequired");
    }
    if ((0,utils/* length */.kE)(value.trim()) > webhookNameMaxLength * 2) {
        return t("common:message.charTooLong", {
            size: webhookNameMaxLength
        });
    }
    return null;
}
function validateUrl(value, t) {
    if ((0,utils/* isBlank */.fp)(value)) {
        return t("common:message.urlRequired");
    }
    if (!(0,utils/* isUrl */.CB)(value === null || value === void 0 ? void 0 : value.trim())) {
        return t("common:message.urlInvalid");
    }
    return null;
}
function validateTargets(value, t) {
    if (!(0,isEmpty/* default */.Z)(value) && value.some(function(v) {
        return v !== AT_ALL_VALUE && !(0,utils/* isMobile */.tq)(v);
    })) {
        return t("common:message.mobileInvalid");
    }
    return null;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Switch/Switch.js + 3 modules
var Switch = __webpack_require__(54574);
// EXTERNAL MODULE: ./src/components/business/Integration/hooks/useWebhookEditable.ts
var useWebhookEditable = __webpack_require__(4896);
;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/hooks/useIsBuilderEditable.ts



function useIsBuilderEditable() {
    var form = useWebhookBuilderFormContext();
    return (0,useWebhookEditable/* default */.Z)() || (0,isNil/* default */.Z)(form.values.id);
}

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Header.tsx
















var BuilderModal_Header_Header = function(param) {
    var onUpdate = param.onUpdate;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateWebhookMutation */.IUj)(), 2), updateWebhook = ref[0], loading = ref[1].loading;
    var isAppScope = (0,react.useContext)(WebhookContext/* default */.Z).isAppScope;
    var editable = useIsBuilderEditable();
    var isNew = (0,isNil/* default */.Z)(form.values.id);
    var handleStatusSwitch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(enabled) {
            var prevEnabled, data, param, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        prevEnabled = form.values.enabled;
                        form.setFieldValue("enabled", enabled);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            updateWebhook({
                                variables: {
                                    input: {
                                        id: form.values.id,
                                        enabled: enabled
                                    },
                                    includeCampaign: isAppScope
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.updateCampaignWebhook) {
                            ui/* message.successMsg */.yw.successMsg(enabled ? t("webhook.builder.toggleSuccess.on") : t("webhook.builder.toggleSuccess.off"));
                            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(data.updateCampaignWebhook);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        param = _state.sent();
                        graphQLErrors = param.graphQLErrors;
                        form.setFieldValue("enabled", prevEnabled);
                        ui/* message.error */.yw.error(enabled ? t("webhook.builder.toggleFailed.on") : t("webhook.builder.toggleFailed.off"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStatusSwitch(enabled) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "apart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* InlineInput */.ZQ, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                maxLength: webhookNameMaxLength,
                maxWidth: 460,
                enterBlur: true,
                autoFocus: isNew,
                autoRestore: true,
                readOnly: !editable
            }, form.getInputProps("name")), {
                className: "grow",
                inputStyle: {
                    borderColor: "transparent",
                    backgroundColor: "transparent",
                    fontWeight: 600,
                    fontSize: 14,
                    paddingLeft: 8,
                    paddingRight: 8
                }
            })),
            !isNew && (editable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* Switch */.r, {
                checked: form.values.enabled,
                onLabel: t("webhook.status.on"),
                offLabel: t("webhook.status.off"),
                size: "lg",
                display: "flex",
                color: "teal.6",
                onChange: function(e) {
                    return handleStatusSwitch(e.currentTarget.checked);
                },
                styles: function(theme) {
                    return {
                        trackLabel: {
                            fontSize: theme.fontSizes.xs
                        }
                    };
                },
                disabled: loading
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* StatusBadge */.OE, {
                value: form.values.enabled,
                onText: t("webhook.status.on"),
                offText: t("webhook.status.off")
            }))
        ]
    });
};
/* harmony default export */ var BuilderModal_Header = (BuilderModal_Header_Header);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Alert/Alert.js + 1 modules
var Alert = __webpack_require__(64405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Timeline/Timeline.js + 3 modules
var Timeline = __webpack_require__(10222);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-resize-observer/use-resize-observer.js
var use_resize_observer = __webpack_require__(56718);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/utils/px/px.js
var px = __webpack_require__(33983);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/components/business/Filter/FieldFilterPopover/Filter/index.tsx + 22 modules
var Filter = __webpack_require__(80510);
;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Trigger/Filter.tsx













var Filter_Filter = function() {
    var ref, ref1;
    var form = useWebhookBuilderFormContext();
    var customerAttributes = (0,react.useContext)(WebhookContext/* default */.Z).customerAttributes;
    var editable = useIsBuilderEditable();
    var getEntryFilterableFields = (0,useEntryFilterableFields/* default */.Z)();
    var _ref = form.getInputProps("conditionGroup"), value = _ref.value, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "value"
    ]);
    var campaignId = form.values.campaignId;
    var ref2 = (0,domain/* useCampaignFieldsQuery */.RBZ)({
        variables: {
            campaignId: campaignId
        },
        skip: (0,isNil/* default */.Z)(campaignId) || !editable && (0,isNil/* default */.Z)(form.values.conditionGroup)
    }), data = ref2.data, loading = ref2.loading;
    if (loading) {
        return null;
    }
    var ref3;
    var fields = (ref3 = data === null || data === void 0 ? void 0 : (ref = data.campaign) === null || ref === void 0 ? void 0 : (ref1 = ref.form) === null || ref1 === void 0 ? void 0 : ref1.fields) !== null && ref3 !== void 0 ? ref3 : [];
    var filterableFields = getEntryFilterableFields(fields !== null && fields !== void 0 ? fields : [], customerAttributes, [
        constants_fieldType/* commentedCode */.pn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter/* default */.Z, (0,src_object_spread/* default */.Z)({
        showHeader: false,
        withDefault: true,
        campaignFields: filterableFields,
        value: (0,convertToValidConditionGroup/* convertToFieldFilterPopoverValue */.b)(value),
        readOnly: !editable,
        pl: 28
    }, rest));
};
/* harmony default export */ var Trigger_Filter = (Filter_Filter);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Trigger/CampaignSelect.tsx













var CampaignSelect = function() {
    var ref;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var checkPermission = (0,Campaign_hooks/* useCheckCampaignPermission */.r$)();
    var ref1 = (0,react.useContext)(WebhookContext/* default */.Z), appId = ref1.appId, webhook = ref1.webhook;
    var readonly = !!webhook;
    var data = (0,domain/* useApplicationCampaignsQuery */.d4r)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: appId,
            pageArguments: {
                first: config_constants/* PAGE_SIZE.UN_LIMIT */.IV.UN_LIMIT
            }
        },
        skip: readonly
    }).data;
    var buildCampaignOption = function(campaign) {
        var ref;
        return {
            value: campaign.id,
            label: campaign.name,
            group: t("webhook.builder.stepTrigger.campaignSelect.group", {
                campaignTypeName: t("common:campaignTypeName.".concat(campaign.type))
            }),
            createdAt: campaign.createdAt,
            creatorName: (ref = campaign.creator) === null || ref === void 0 ? void 0 : ref.name
        };
    };
    var getAvailableCampaigns = function() {
        var ref, ref1, ref2;
        return data === null || data === void 0 ? void 0 : (ref = data.application) === null || ref === void 0 ? void 0 : (ref1 = ref.campaigns) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nodes) === null || ref2 === void 0 ? void 0 : ref2.filter(function(campaign) {
            return checkPermission(campaign.creator.id, domain/* ApplicationPermission.CampaignUpdate */.eC6.CampaignUpdate);
        });
    };
    var options = readonly ? [
        buildCampaignOption(webhook.campaign)
    ] : (ref = getAvailableCampaigns()) === null || ref === void 0 ? void 0 : ref.map(function(node) {
        return buildCampaignOption(node);
    });
    var CampaignSelectItem = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
        var label = _param.label, creatorName = _param.creatorName, createdAt = _param.createdAt, others = (0,_object_without_properties/* default */.Z)(_param, [
            "label",
            "creatorName",
            "createdAt"
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            ref: ref
        }, others), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                noWrap: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        lineClamp: 1,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                lineClamp: 1,
                                children: creatorName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                className: "whitespace-nowrap",
                                children: t("common:createdAt", {
                                    dateTime: (0,utils/* formatISODate */.cz)(createdAt)
                                })
                            })
                        ]
                    })
                ]
            })
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.Ph, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        data: options !== null && options !== void 0 ? options : [],
        label: t("webhook.builder.stepTrigger.campaignSelect.label"),
        placeholder: t("common:placeholders.pleaseSelect")
    }, form.getInputProps("campaignId")), {
        mb: "xl",
        styles: {
            label: {
                fontWeight: 400
            }
        },
        readOnly: readonly,
        searchable: true,
        nothingFound: t("webhook.builder.stepTrigger.campaignSelect.empty"),
        itemComponent: CampaignSelectItem
    }));
};
/* harmony default export */ var Trigger_CampaignSelect = (CampaignSelect);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Trigger/index.tsx











var Mode;
(function(Mode) {
    Mode["All"] = "all";
    Mode["Conditional"] = "conditional";
})(Mode || (Mode = {}));
var Trigger = function(param) {
    var onHeightChange = param.onHeightChange;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var form = useWebhookBuilderFormContext();
    var isAppScope = (0,react.useContext)(WebhookContext/* default */.Z).isAppScope;
    var ref = (0,use_resize_observer/* useElementSize */.h)(), ref1 = ref.ref, height = ref.height;
    var previousHeight = (0,use_previous/* usePrevious */.D)(height);
    var ref2 = (0,react.useState)((0,isNil/* default */.Z)(form.values.conditionGroup) ? Mode.All : Mode.Conditional), mode = ref2[0], setMode = ref2[1];
    var editable = useIsBuilderEditable();
    var padding = theme.spacing.xl;
    (0,react.useEffect)(function() {
        previousHeight !== height && onHeightChange(height + (0,px.px)(padding) * 2 + 2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        height,
        previousHeight
    ]);
    var handleModeChange = function(value) {
        if (editable) {
            setMode(value);
            value === Mode.All && form.setFieldValue("conditionGroup", null);
        }
    };
    var events = form.values.eventTypes.map(function(eventType) {
        return t("webhook.eventType.".concat(eventType));
    }).join(t("common:punctuation.comma"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
        withBorder: true,
        p: padding,
        ref: ref1,
        children: [
            isAppScope && /*#__PURE__*/ (0,jsx_runtime.jsx)(Trigger_CampaignSelect, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* Radio.Group */.Y.Group, {
                value: mode,
                onChange: handleModeChange,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* Radio */.Y, {
                            value: Mode.All,
                            label: t("webhook.builder.stepTrigger.mode.all", {
                                events: events
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* Radio */.Y, {
                            value: Mode.Conditional,
                            label: t("webhook.builder.stepTrigger.mode.conditional", {
                                events: events
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                in: mode === Mode.Conditional,
                mt: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trigger_Filter, {})
            })
        ]
    });
};
/* harmony default export */ var Steps_Trigger = (Trigger);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/utils.ts




var targetsSupportChannels = [
    domain/* WebhookChannel.QiyeWx */.Osq.QiyeWx,
    domain/* WebhookChannel.Dingtalk */.Osq.Dingtalk,
    domain/* WebhookChannel.Feishu */.Osq.Feishu
];
function isChannelSupportTargets(channel) {
    return channel && targetsSupportChannels.includes(channel);
}
function getCreateWebhookInput(data) {
    var campaignId = data.campaignId, targets = data.targets, conditionGroup = data.conditionGroup, rest = (0,_object_without_properties/* default */.Z)(data, [
        "campaignId",
        "targets",
        "conditionGroup"
    ]);
    return (0,src_object_spread/* default */.Z)({
        campaignId: campaignId,
        targets: isChannelSupportTargets(data.channel) ? targets : undefined,
        conditionGroup: conditionGroup ? (0,convertToValidConditionGroup/* default */.Z)(conditionGroup) : undefined
    }, rest);
}
function getUpdateWebhookInput(data) {
    var id = data.id, targets = data.targets, campaignId = data.campaignId, conditionGroup = data.conditionGroup, rest = (0,_object_without_properties/* default */.Z)(data, [
        "id",
        "targets",
        "campaignId",
        "conditionGroup"
    ]);
    return (0,src_object_spread/* default */.Z)({
        id: id,
        targets: isChannelSupportTargets(data.channel) ? targets : null,
        conditionGroup: conditionGroup ? (0,convertToValidConditionGroup/* default */.Z)(conditionGroup) : null
    }, rest);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Menu/Menu.js + 13 modules
var Menu = __webpack_require__(56674);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronDown.js
var IconChevronDown = __webpack_require__(97547);
;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Action/ChannelSelect.tsx









var ChannelSelect = function() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var channel = form.values.channel;
    var editable = useIsBuilderEditable();
    if (!editable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            spacing: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration_ChannelIcon, {
                    channel: channel,
                    size: 18
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: t("webhook.builder.stepAction.".concat(channel, ".label"))
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        position: "bottom-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    variant: "subtle",
                    color: "dark",
                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration_ChannelIcon, {
                        channel: channel,
                        size: 18
                    }),
                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronDown/* default */.Z, {
                        size: 20,
                        stroke: 1.2
                    }),
                    styles: function(theme) {
                        return {
                            leftIcon: {
                                marginRight: theme.spacing.sm
                            },
                            root: {
                                ":hover": {
                                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                                }
                            }
                        };
                    },
                    children: t("webhook.builder.stepAction.".concat(channel, ".label"))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Dropdown */.v.Dropdown, {
                children: orderedWebhookChannels.map(function(c) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration_ChannelIcon, {
                            channel: c,
                            size: 18
                        }),
                        onClick: function() {
                            return form.setFieldValue("channel", c);
                        },
                        children: t("webhook.builder.stepAction.".concat(c, ".label"))
                    }, c);
                })
            })
        ]
    });
};
/* harmony default export */ var Action_ChannelSelect = (ChannelSelect);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Action/UrlInput.tsx











var Action_UrlInput_UrlInput = function() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var canUseWebhook = useCheckFeature()(domain/* Feature.Webhook */.L0B.Webhook);
    var ref = useSendWebhookDemo(), sendWebhookDemo = ref.sendWebhookDemo, loading = ref.loading;
    var editable = useIsBuilderEditable();
    var channel = form.values.channel;
    var urlIsValid = form.isValid("url");
    var handleSendDemo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _values, name, url, channel, campaignId, id, targets;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!canUseWebhook) {
                            return [
                                2
                            ];
                        }
                        _values = form.values, name = _values.name, url = _values.url, channel = _values.channel, campaignId = _values.campaignId, id = _values.id, targets = _values.targets;
                        return [
                            4,
                            sendWebhookDemo({
                                webhookUrl: url.trim(),
                                name: name,
                                channel: channel,
                                webhookId: id,
                                campaignId: campaignId,
                                mentionedTargets: targets
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendDemo() {
            return _ref.apply(this, arguments);
        };
    }();
    var sendDemoDisabled = !urlIsValid || !canUseWebhook;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,src_object_spread/* default */.Z)({
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            position: "apart",
            children: [
                t("webhook.builder.stepAction.".concat(channel, ".url")),
                editable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                    withArrow: true,
                    disabled: !sendDemoDisabled,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    compact: true,
                                    variant: "subtle",
                                    onClick: handleSendDemo,
                                    disabled: sendDemoDisabled,
                                    loading: loading,
                                    children: t("webhook.sendDemo.action")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                            children: urlIsValid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureTip/* default */.Z, {
                                feature: domain/* Feature.Webhook */.L0B.Webhook
                            }) : t("webhook.sendDemo.tip")
                        })
                    ]
                })
            ]
        }),
        placeholder: t("common:placeholders.pleaseInput"),
        className: "w-full",
        styles: {
            label: {
                fontWeight: 400,
                display: "block"
            }
        },
        readOnly: !editable
    }, form.getInputProps("url")));
};
/* harmony default export */ var Action_UrlInput = (Action_UrlInput_UrlInput);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/partition.js
var partition = __webpack_require__(77061);
;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Action/TargetsInput.tsx














var TargetsInput = function() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var editable = useIsBuilderEditable();
    var channel = form.values.channel;
    var _ref = form.getInputProps("targets"), value = _ref.value, onChange = _ref.onChange, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "value",
        "onChange"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,partition/* default */.Z)(value, function(elem) {
        return elem === AT_ALL_VALUE;
    }), 2), atAllValues = ref[0], mobileValues = ref[1];
    var ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_input_state/* useInputState */.U)((ref1 = mobileValues.join(",")) !== null && ref1 !== void 0 ? ref1 : ""), 2), mobilesString = ref2[0], setMobilesString = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_input_state/* useInputState */.U)(atAllValues.length > 0), 2), isAtAll = ref3[0], setIsAtAll = ref3[1];
    (0,react.useEffect)(function() {
        if (editable) {
            var newValue = (0,utils/* convertToNonEmptyArray */.QU)(mobilesString);
            isAtAll && newValue.push(AT_ALL_VALUE);
            onChange(newValue);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editable,
        mobilesString,
        isAtAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        w: "100%",
        spacing: "xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,src_object_spread/* default */.Z)({
                label: t("webhook.builder.stepAction.targetsLabel"),
                placeholder: t("webhook.builder.stepAction.targetsPlaceholder"),
                styles: {
                    label: {
                        fontWeight: 400
                    }
                },
                className: "w-full",
                value: mobilesString,
                onChange: setMobilesString,
                readOnly: !editable,
                inputWrapperOrder: channel === domain/* WebhookChannel.Feishu */.Osq.Feishu ? [
                    "label",
                    "error"
                ] : undefined
            }, rest)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                label: t("webhook.builder.stepAction.targetsAtAll"),
                checked: isAtAll,
                onChange: setIsAtAll,
                readOnly: !editable
            })
        ]
    });
};
/* harmony default export */ var Action_TargetsInput = (TargetsInput);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Action/Settings.tsx








var Settings = function() {
    var form = useWebhookBuilderFormContext();
    var channel = form.values.channel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        align: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action_ChannelSelect, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action_UrlInput, {}),
            isChannelSupportTargets(channel) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Action_TargetsInput, {})
        ]
    });
};
/* harmony default export */ var Action_Settings = (Settings);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Action/Channels.tsx






var Channels = function() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var borderColor = (0,getColor/* getDefaultBorderColor */.mK)(theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        align: "flex-start",
        spacing: "sm",
        children: orderedWebhookChannels.map(function(channel) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                variant: "default",
                radius: "xl",
                leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration_ChannelIcon, {
                    channel: channel,
                    size: 18
                }),
                styles: {
                    root: {
                        borderColor: borderColor,
                        fontWeight: 400,
                        height: 32
                    },
                    leftIcon: {
                        marginRight: theme.spacing.sm
                    }
                },
                onClick: function() {
                    return form.setFieldValue("channel", channel);
                },
                children: t("webhook.builder.stepAction.".concat(channel, ".label"))
            }, channel);
        })
    });
};
/* harmony default export */ var Action_Channels = (Channels);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/Action/index.tsx








var Action = function(param) {
    var onHeightChange = param.onHeightChange;
    var form = useWebhookBuilderFormContext();
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref = (0,use_resize_observer/* useElementSize */.h)(), ref1 = ref.ref, height = ref.height;
    var previousHeight = (0,use_previous/* usePrevious */.D)(height);
    var isEditing = !(0,isNil/* default */.Z)(form.values.channel);
    var padding = theme.spacing.xl;
    (0,react.useEffect)(function() {
        previousHeight !== height && onHeightChange(height + (0,px.px)(padding) * 2 + 2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        height,
        previousHeight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
        withBorder: true,
        p: padding,
        ref: ref1,
        children: isEditing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Action_Settings, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Action_Channels, {})
    });
};
/* harmony default export */ var Steps_Action = (Action);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/Steps/index.tsx









var stepTitleHeightPx = 16;
var Steps = function() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_set_state/* useSetState */.v)({
        trigger: 102,
        action: 122
    }), 2), heights = ref[0], setHeights = ref[1];
    var currentStep = form.values.channel ? 1 : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        align: "flex-start",
        spacing: "lg",
        noWrap: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Timeline/* Timeline */.T, {
                lineWidth: 1,
                active: currentStep,
                bulletSize: 6,
                align: "right",
                color: "brandBlue",
                styles: function(theme) {
                    return {
                        item: {
                            paddingRight: theme.spacing.lg,
                            ":before": {
                                top: 5,
                                bottom: -29
                            },
                            ":first-of-type": {
                                ":before": {
                                    top: 5
                                }
                            },
                            "&.last-placeholder": {
                                marginTop: 0,
                                ".mantine-Timeline-itemBullet": {
                                    visibility: "hidden"
                                }
                            }
                        },
                        itemBullet: {
                            top: 5
                        },
                        itemTitle: {
                            fontWeight: 400,
                            whiteSpace: "nowrap"
                        }
                    };
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline.Item */.T.Item, {
                        bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "rounded-full"
                        }),
                        title: t("webhook.builder.stepTrigger.title"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            h: heights.trigger - stepTitleHeightPx
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline.Item */.T.Item, {
                        bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "rounded-full"
                        }),
                        title: t("webhook.builder.stepAction.title"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            h: heights.action - stepTitleHeightPx - 28
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* Timeline.Item */.T.Item, {
                        className: "last-placeholder"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                className: "grow",
                spacing: "xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps_Trigger, {
                        onHeightChange: function(height) {
                            return setHeights({
                                trigger: height
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps_Action, {
                        onHeightChange: function(height) {
                            return setHeights({
                                action: height
                            });
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Content_Steps = (Steps);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/Content/index.tsx
















var Content_Content = function(param) {
    var onCancel = param.onCancel, onCreate = param.onCreate, onUpdate = param.onUpdate;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var form = useWebhookBuilderFormContext();
    var isAppScope = (0,react.useContext)(WebhookContext/* default */.Z).isAppScope;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useCreateWebhookMutation */.AgE)(), 2), createWebhook = ref[0], ref1 = ref[1], creating = ref1.loading;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,domain/* useUpdateWebhookMutation */.IUj)(), 2), updateWebhook = ref2[0], ref3 = ref2[1], updating = ref3.loading;
    var isNew = (0,isNil/* default */.Z)(form.values.id);
    var editable = useIsBuilderEditable();
    var handleCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            createWebhook({
                                variables: {
                                    input: getCreateWebhookInput(form.values),
                                    includeCampaign: isAppScope
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.createCampaignWebhook) {
                            form.setFieldValue("id", data.createCampaignWebhook.id);
                            ui/* message.successMsg */.yw.successMsg(t("webhook.builder.createSuccess"));
                            onCreate === null || onCreate === void 0 ? void 0 : onCreate(data.createCampaignWebhook);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        ui/* message.error */.yw.error(t("webhook.builder.createFailed"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUpdate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            updateWebhook({
                                variables: {
                                    input: getUpdateWebhookInput(form.values),
                                    includeCampaign: isAppScope
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.updateCampaignWebhook) {
                            ui/* message.successMsg */.yw.successMsg(t("webhook.builder.updateSuccess"));
                            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(data.updateCampaignWebhook);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        ui/* message.error */.yw.error(t("webhook.builder.updateFailed"));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleUpdate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!editable) return [
                            3,
                            5
                        ];
                        if (!isNew) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleCreate()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            handleUpdate()
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        _tmp;
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: form.onSubmit(handleSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            mx: 38,
            spacing: "xl",
            children: [
                !editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* Alert */.b, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAlertCircle/* default */.Z, {
                        size: 16
                    }),
                    children: t("webhook.builder.readonlyTip")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Steps, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    position: "right",
                    children: isNew ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "default",
                                onClick: onCancel,
                                children: t("common:actions.cancel")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "submit",
                                disabled: creating || !form.isValid(),
                                children: t("webhook.actions.create")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "default",
                                onClick: onCancel,
                                children: editable ? t("common:actions.cancel") : t("common:actions.close")
                            }),
                            editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "submit",
                                disabled: updating || !form.isValid(),
                                children: t("webhook.actions.update")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var BuilderModal_Content = (Content_Content);

;// CONCATENATED MODULE: ./src/components/business/Integration/BuilderModal/index.tsx















var BuilderModal = function(param) {
    var opened = param.opened, onClose = param.onClose, onCreated = param.onCreated, onUpdated = param.onUpdated;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var ref = (0,react.useContext)(WebhookContext/* default */.Z), appId = ref.appId, campaign = ref.campaign, webhook = ref.webhook;
    var campaignId = campaign === null || campaign === void 0 ? void 0 : campaign.id;
    var campaignName = campaign === null || campaign === void 0 ? void 0 : campaign.name;
    var initialValues = (0,react.useMemo)(function() {
        return {
            campaignId: campaignId,
            name: campaignName ? t("webhook.builder.name.default", {
                campaignName: campaignName
            }) : t("webhook.builder.name.untitled"),
            enabled: false,
            eventTypes: [
                domain/* WebhookEventType.EntrySubmitted */.Ru7.EntrySubmitted
            ],
            url: "",
            conditionGroup: null
        };
    }, [
        campaignId,
        campaignName,
        t
    ]);
    var _length;
    var form = useWebhookBuilderForm({
        validateInputOnBlur: true,
        initialValues: initialValues,
        transformValues: function(values) {
            var ref;
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                name: (0,trim/* default */.Z)(values.name),
                conditionGroup: ((_length = (ref = values.conditionGroup) === null || ref === void 0 ? void 0 : ref.conditions.length) !== null && _length !== void 0 ? _length : 0) > 0 ? values.conditionGroup : null
            });
        },
        validate: {
            name: function(value) {
                return validateName(value, t);
            },
            url: function(value) {
                return validateUrl(value, t);
            },
            channel: function(value) {
                return (0,isNil/* default */.Z)(value) ? t("common:message.valueRequired") : null;
            },
            campaignId: function(value) {
                return (0,utils/* isBlank */.fp)(value) ? t("common:message.valueRequired") : null;
            },
            targets: function(value) {
                return validateTargets(value, t);
            }
        }
    });
    (0,react.useEffect)(function() {
        if (webhook) {
            var id = webhook.id, name = webhook.name, enabled = webhook.enabled, campaign = webhook.campaign, channel = webhook.channel, url = webhook.url, targets = webhook.targets, eventTypes = webhook.eventTypes, conditionGroup = webhook.conditionGroup;
            var ref;
            form.setValues({
                id: id,
                name: name,
                enabled: enabled,
                channel: channel,
                url: url,
                targets: targets,
                eventTypes: eventTypes,
                campaignId: (ref = campaign === null || campaign === void 0 ? void 0 : campaign.id) !== null && ref !== void 0 ? ref : campaignId,
                conditionGroup: conditionGroup
            });
        } else {
            form.setValues(initialValues);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        webhook === null || webhook === void 0 ? void 0 : webhook.id
    ]);
    if ((0,utils/* isBlank */.fp)(appId)) {
        return null;
    }
    var handleCancel = function() {
        onClose();
        // rest wait until modal closed
        setTimeout(function() {
            return form.reset();
        }, 200);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WebhookBuilderFormProvider, {
        form: form,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            withinPortal: true,
            opened: opened,
            onClose: handleCancel,
            closeOnClickOutside: false,
            closeOnEscape: false,
            trapFocus: false,
            size: 1000,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderModal_Header, {
                onUpdate: onUpdated
            }),
            styles: function(theme) {
                var backgroundColor = (0,getColor/* getBackgroundColor */.dF)("gray.0", theme);
                return {
                    header: {
                        backgroundColor: backgroundColor
                    },
                    content: {
                        backgroundColor: backgroundColor
                    },
                    title: {
                        flexGrow: 1,
                        marginRight: 20
                    }
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderModal_Content, {
                onCancel: handleCancel,
                onCreate: onCreated,
                onUpdate: onUpdated
            })
        })
    });
};
/* harmony default export */ var Integration_BuilderModal = (BuilderModal);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconBell.js
var IconBell = __webpack_require__(4319);
;// CONCATENATED MODULE: ./src/components/business/Integration/ChannelIcon.tsx




var ChannelIcon = function(param) {
    var channel = param.channel, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            channel === domain/* WebhookChannel.Default */.Osq.Default && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBell/* default */.Z, {
                size: size !== null && size !== void 0 ? size : 16,
                stroke: 1.5,
                color: "orange"
            }),
            channel === domain/* WebhookChannel.QiyeWx */.Osq.QiyeWx && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: "brandWeCom",
                size: size
            }),
            channel === domain/* WebhookChannel.Dingtalk */.Osq.Dingtalk && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: "brandDingtalk",
                size: size
            }),
            channel === domain/* WebhookChannel.Feishu */.Osq.Feishu && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: "brandFeishu",
                size: size
            })
        ]
    });
};
/* harmony default export */ var Integration_ChannelIcon = (ChannelIcon);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(21408);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(42112);
;// CONCATENATED MODULE: ./src/components/ui/InfiniteScroll/index.tsx






var InfiniteScroll = function(_param) {
    var next = _param.next, hasMore = _param.hasMore, dataLength = _param.dataLength, _scrollThreshold = _param.scrollThreshold, scrollThreshold = _scrollThreshold === void 0 ? 0.8 : _scrollThreshold, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "next",
        "hasMore",
        "dataLength",
        "scrollThreshold",
        "children"
    ]);
    var innerRef = (0,react.useRef)(null);
    var loading = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // reset loading after loaded which changes dataLength
        loading.current = false;
    }, [
        dataLength
    ]);
    var handleScrollPositionChange = function(param) {
        var y = param.y;
        if (hasMore && !loading.current) {
            var _current = innerRef.current, scrollHeight = _current.scrollHeight, offsetHeight = _current.offsetHeight;
            if (offsetHeight * scrollThreshold > scrollHeight - y - offsetHeight) {
                loading.current = true;
                next();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollArea/* ScrollArea */.x, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        onScrollPositionChange: handleScrollPositionChange,
        viewportRef: innerRef,
        children: [
            children,
            hasMore && loading.current && /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    variant: "dots",
                    size: "sm"
                })
            })
        ]
    }));
};
/* harmony default export */ var ui_InfiniteScroll = (InfiniteScroll);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(79705);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/floor.js + 1 modules
var floor = __webpack_require__(93004);
;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryItem.tsx







function getBadgeColor(statusCode, status) {
    if ((0,isNil/* default */.Z)(statusCode) || status == domain/* WebhookHistoryStatus.Failure */.s6L.Failure) {
        return "red";
    }
    var series = (0,floor/* default */.Z)(statusCode / 100);
    if (series === 2) {
        return "teal";
    }
    if ([
        4,
        5
    ].includes(series)) {
        return "red";
    }
    return "yellow";
}
var HistoryItem = function(param) {
    var history = param.history, className = param.className, onClick = param.onClick;
    var ref;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var responseStatusCode = history.responseStatusCode, eventId = history.eventId, sentAt = history.sentAt, status = history.status;
    var isDemo = ((ref = history.target) === null || ref === void 0 ? void 0 : ref.id) === DEMO_WEBHOOK_ENTRY_ID || history.eventId.startsWith(DEMO_WEBHOOK_CAMPAIGN_ID);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        align: "start",
        noWrap: true,
        spacing: "sm",
        px: "sm",
        py: 12,
        className: className,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                color: getBadgeColor(responseStatusCode, status),
                styles: {
                    root: {
                        paddingLeft: 0,
                        paddingRight: 0,
                        width: "38px",
                        flexShrink: 0
                    }
                },
                children: !responseStatusCode || responseStatusCode == 200 && status == domain/* WebhookHistoryStatus.Failure */.s6L.Failure ? "ERR" : responseStatusCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: "xs",
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        position: "apart",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: (0,utils/* formatISOTime */.cx)(sentAt)
                            }),
                            isDemo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                size: "xs",
                                children: t("webhook.histories.list.demo")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        fz: "xs",
                        color: "dimmed",
                        lineClamp: 1,
                        children: eventId
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HistoriesModalContent_HistoryItem = (HistoryItem);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/SubTitle.tsx


var subTitleLineHeightPx = 20;
var SubTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
        order: 6,
        color: "gray.7",
        lh: "".concat(subTitleLineHeightPx, "px"),
        children: children
    });
};
/* harmony default export */ var HistoriesModalContent_SubTitle = (SubTitle);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryList.tsx









var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        root: {
            flexShrink: 0
        },
        item: {
            cursor: "pointer",
            "& + &": {
                borderTop: "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.1", theme))
            },
            "&:hover, &.active": {
                backgroundColor: (0,getColor/* getBorderColor */.kJ)("brandBlue.0", theme, "dark.5")
            }
        }
    };
});
var HistoryList = function(param) {
    var histories = param.histories, onLoadMore = param.onLoadMore, hasMore = param.hasMore, onItemClick = param.onItemClick;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var selected = (0,react.useRef)();
    var handleItemClick = (0,react.useCallback)(function(history) {
        selected.current = history;
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(history);
    }, [
        onItemClick
    ]);
    (0,react.useEffect)(function() {
        (0,isNil/* default */.Z)(selected.current) && histories.length > 0 && handleItemClick(histories[0]);
    }, [
        handleItemClick,
        histories
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        w: 330,
        h: "100%",
        spacing: "lg",
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoriesModalContent_SubTitle, {
                children: t("webhook.histories.list.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_InfiniteScroll, {
                next: onLoadMore,
                hasMore: hasMore,
                dataLength: histories.length,
                offsetScrollbars: true,
                h: "calc(100% - ".concat(subTitleLineHeightPx, " - ").concat(theme.spacing.lg, ")"),
                children: histories.map(function(history) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(HistoriesModalContent_HistoryItem, {
                        history: history,
                        className: cx(classes.item, {
                            active: history.id === ((ref = selected.current) === null || ref === void 0 ? void 0 : ref.id)
                        }),
                        onClick: function() {
                            return handleItemClick(history);
                        }
                    }, history.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HistoriesModalContent_HistoryList = (HistoryList);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Code/Code.js + 1 modules
var Code = __webpack_require__(26425);
// EXTERNAL MODULE: ./src/components/business/Integration/styles.ts
var styles = __webpack_require__(80134);
;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/DefaultRequestDetail.tsx



var DefaultRequestDetail = function(param) {
    var requestPayload = param.requestPayload;
    var classes = (0,styles/* default */.Z)().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Code/* Code */.E, {
        block: true,
        className: classes.code,
        children: JSON.stringify(requestPayload, null, 2)
    });
};
/* harmony default export */ var HistoryDetail_DefaultRequestDetail = (DefaultRequestDetail);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/MentionedTargets.tsx





var MentionedTargets = function(param) {
    var targets = param.targets;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    if (!targets || targets.length === 0) {
        return null;
    }
    var formattedTargets = targets.map(function(target) {
        return target.toLowerCase() === AT_ALL_VALUE ? t("webhook.histories.detail.targetsAll") : target;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        children: t("webhook.histories.detail.mentionedTargets", {
            targets: formattedTargets.join(t("common:punctuation.comma"))
        })
    });
};
/* harmony default export */ var HistoryDetail_MentionedTargets = (MentionedTargets);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/IMRequestDetail.tsx







var IMRequestDetail = function(param) {
    var requestPayload = param.requestPayload, contentKey = param.contentKey, targetsKey = param.targetsKey;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var content = requestPayload[contentKey || "content"];
    var targets = targetsKey ? requestPayload[targetsKey] : null;
    if (content) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            children: t("webhook.histories.detail.requestContent")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            ml: "xl",
                            className: "break-all",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0,utils/* htmlEncodeByRegExp */.m9)(content)
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryDetail_MentionedTargets, {
                    targets: targets
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryDetail_DefaultRequestDetail, {
        requestPayload: requestPayload
    });
};
/* harmony default export */ var HistoryDetail_IMRequestDetail = (IMRequestDetail);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/QiyeWXRequestDetail.tsx



var QiyeWXRequestDetail = function(param) {
    var requestPayload = param.requestPayload;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryDetail_IMRequestDetail, {
        requestPayload: requestPayload,
        targetsKey: "mentionedMobileList"
    });
};
/* harmony default export */ var HistoryDetail_QiyeWXRequestDetail = (QiyeWXRequestDetail);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/DingTalkRequestDetail.tsx



var DingTalkRequestDetail = function(param) {
    var requestPayload = param.requestPayload;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryDetail_IMRequestDetail, {
        requestPayload: requestPayload,
        targetsKey: "at"
    });
};
/* harmony default export */ var HistoryDetail_DingTalkRequestDetail = (DingTalkRequestDetail);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/FeishuRequestDetail.tsx



var FeishuRequestDetail = function(param) {
    var requestPayload = param.requestPayload;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryDetail_IMRequestDetail, {
        requestPayload: requestPayload,
        targetsKey: "at"
    });
};
/* harmony default export */ var HistoryDetail_FeishuRequestDetail = (FeishuRequestDetail);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/HistoryDetail/index.tsx













var HistoryDetail_obj;
var requestDetailComponentMap = (HistoryDetail_obj = {}, (0,_define_property/* default */.Z)(HistoryDetail_obj, domain/* WebhookChannel.Default */.Osq.Default, HistoryDetail_DefaultRequestDetail), (0,_define_property/* default */.Z)(HistoryDetail_obj, domain/* WebhookChannel.QiyeWx */.Osq.QiyeWx, HistoryDetail_QiyeWXRequestDetail), (0,_define_property/* default */.Z)(HistoryDetail_obj, domain/* WebhookChannel.Dingtalk */.Osq.Dingtalk, HistoryDetail_DingTalkRequestDetail), (0,_define_property/* default */.Z)(HistoryDetail_obj, domain/* WebhookChannel.Feishu */.Osq.Feishu, HistoryDetail_FeishuRequestDetail), HistoryDetail_obj);
var HistoryDetail = function(param) {
    var history = param.history;
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var classes = (0,styles/* default */.Z)().classes;
    var historyId = history === null || history === void 0 ? void 0 : history.id;
    var ref = (0,domain/* useWebhookHistoryQuery */.Nlt)({
        fetchPolicy: "cache-and-network",
        variables: {
            id: historyId !== null && historyId !== void 0 ? historyId : ""
        },
        skip: (0,isNil/* default */.Z)(historyId)
    }), data = ref.data, loading = ref.loading;
    var responseStatusCode = history === null || history === void 0 ? void 0 : history.responseStatusCode;
    var ref1;
    var ref2 = (ref1 = data === null || data === void 0 ? void 0 : data.webhookHistory) !== null && ref1 !== void 0 ? ref1 : {}, channel = ref2.channel, requestUrl = ref2.requestUrl, requestPayload = ref2.requestPayload, responseBody = ref2.responseBody, errMsg = ref2.errMsg;
    var RequestDetail = requestDetailComponentMap[channel !== null && channel !== void 0 ? channel : domain/* WebhookChannel.Default */.Osq.Default];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        h: "100%",
        className: "grow",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoriesModalContent_SubTitle, {
                children: t("webhook.histories.detail.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                withBorder: true,
                w: "100%",
                h: "calc(100% - ".concat(subTitleLineHeightPx, "px - ").concat(theme.spacing.lg, ")"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                    defaultValue: "request",
                    h: "100%",
                    styles: {
                        root: {
                            display: "flex",
                            flexDirection: "column"
                        },
                        panel: {
                            flexGrow: 1
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs.List */.m.List, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "request",
                                    children: t("webhook.histories.detail.request")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "response",
                                    children: t("webhook.histories.detail.response")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollArea/* ScrollArea */.x, {
                            h: "100%",
                            bg: (0,getColor/* getBackgroundColor */.dF)("gray.0", theme),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                                    value: "request",
                                    p: "sm",
                                    children: !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                                        spacing: "md",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                className: "break-all",
                                                children: t("webhook.histories.detail.requestUrl", {
                                                    url: requestUrl
                                                })
                                            }),
                                            requestPayload && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestDetail, {
                                                requestPayload: requestPayload
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                                    value: "response",
                                    p: "sm",
                                    children: !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            responseStatusCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                mb: "md",
                                                children: t("webhook.histories.detail.responseStatus", {
                                                    code: responseStatusCode
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Code/* Code */.E, {
                                                block: true,
                                                className: classes.code,
                                                children: responseBody !== null && responseBody !== void 0 ? responseBody : errMsg
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var HistoriesModalContent_HistoryDetail = (HistoryDetail);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/image.js
var next_image = __webpack_require__(66401);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/assets/images/empty.png
var empty = __webpack_require__(26625);
;// CONCATENATED MODULE: ./src/components/business/Integration/hooks/useSendWebhookDemo.ts











function useSendWebhookDemo() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var applicationId = (0,next_router.useRouter)().query.appId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,domain/* useSendWebhookMutation */.uXZ)(), 2), send = ref[0], loading = ref[1].loading;
    var sendWebhookDemo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var _channel, channel, rest, data, err, graphQLErrors;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _channel = _param.channel, channel = _channel === void 0 ? domain/* WebhookChannel.Default */.Osq.Default : _channel, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "channel"
                        ]);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            send({
                                variables: {
                                    input: (0,src_object_spread/* default */.Z)({
                                        applicationId: applicationId,
                                        channel: channel,
                                        content: DEMO_WEBHOOK_ENTRY_ID,
                                        eventType: domain/* WebhookEventType.EntrySubmitted */.Ru7.EntrySubmitted
                                    }, rest)
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.sendWebhook) {
                            ui/* message.successMsg */.yw.successMsg(t("webhook.sendDemo.successMessage"), t("webhook.sendDemo.successTitle"));
                        } else {
                            ui/* message.error */.yw.error(t("webhook.sendDemo.failed"));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        graphQLErrors = err.graphQLErrors;
                        (0,utils/* graphqlErrorCatch */.Qf)({
                            graphQLErrors: graphQLErrors,
                            defaultMessage: t("common:message.graphqlError", {
                                message: err.message
                            })
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendWebhookDemo(_param) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        sendWebhookDemo: sendWebhookDemo,
        loading: loading
    };
}

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/Empty.tsx













var Empty = function(_param) {
    var onDemoSent = _param.onDemoSent, campaignCreatorId = _param.campaignCreatorId, sendDemoProps = (0,_object_without_properties/* default */.Z)(_param, [
        "onDemoSent",
        "campaignCreatorId"
    ]);
    var t = (0,useTranslation/* default */.Z)("integration").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var ref = useSendWebhookDemo(), sendWebhookDemo = ref.sendWebhookDemo, loading = ref.loading;
    var canUseWebhook = useCheckFeature()(domain/* Feature.Webhook */.L0B.Webhook);
    var editable = (0,useWebhookEditable/* default */.Z)(campaignCreatorId);
    var webhookUrl = sendDemoProps.webhookUrl;
    var handleSendDemo = function() {
        webhookUrl && sendWebhookDemo((0,src_object_spread/* default */.Z)({
            webhookUrl: webhookUrl
        }, sendDemoProps)).then(onDemoSent);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        align: "center",
        spacing: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: empty/* default */.Z,
                width: 48,
                height: 48,
                alt: "No Webhook Histories"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 5,
                mt: "sm",
                children: t("webhook.histories.empty.title")
            }),
            editable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                        children: t("webhook.histories.empty.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        withArrow: true,
                        disabled: !!webhookUrl,
                        label: t("webhook.histories.empty.sendDemoTip"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                variant: "outline",
                                onClick: handleSendDemo,
                                disabled: !webhookUrl || !canUseWebhook,
                                loading: loading,
                                children: t("webhook.histories.sendDemo")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HistoriesModalContent_Empty = (Empty);

;// CONCATENATED MODULE: ./src/components/business/Integration/HistoriesModalContent/index.tsx













var ModalContent = function(param) {
    var applicationId = param.applicationId, webhookUrl = param.webhookUrl, webhook = param.webhook, h = param.h;
    var ref;
    var ref1 = (0,react.useState)(), history = ref1[0], setHistory = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), isDemoSent = ref2[0], ref3 = ref2[1], demoSent = ref3.open;
    var histories = (0,react.useRef)([]);
    var pageInfo = (0,react.useRef)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,domain/* useWebhookHistoriesLazyQuery */.nOe)({
        fetchPolicy: "cache-and-network"
    }), 2), fetch = ref4[0], loading = ref4[1].loading;
    var webhookId = webhook === null || webhook === void 0 ? void 0 : webhook.id;
    (0,react.useEffect)(function() {
        fetch({
            variables: {
                applicationId: applicationId,
                webhookId: webhookId,
                pageArguments: {
                    first: config_constants/* PAGE_SIZE.LG */.IV.LG
                }
            },
            onCompleted: function onCompleted(data) {
                var _nodes;
                histories.current = (_nodes = data.webhookHistories.nodes) !== null && _nodes !== void 0 ? _nodes : [];
                pageInfo.current = data.webhookHistories.pageInfo;
            }
        }).then(function() {
            var history = histories.current[0];
            history && setHistory(history);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDemoSent
    ]);
    var loadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch({
                                variables: {
                                    applicationId: applicationId,
                                    webhookId: webhookId,
                                    pageArguments: {
                                        after: (ref = pageInfo.current) === null || ref === void 0 ? void 0 : ref.endCursor,
                                        first: config_constants/* PAGE_SIZE.LG */.IV.LG
                                    },
                                    maxSentAt: histories.current[0].sentAt
                                },
                                onCompleted: function onCompleted(nextData) {
                                    var _current;
                                    var _nodes;
                                    (_current = histories.current).push.apply(_current, (0,_to_consumable_array/* default */.Z)((_nodes = nextData.webhookHistories.nodes) !== null && _nodes !== void 0 ? _nodes : []));
                                    pageInfo.current = nextData.webhookHistories.pageInfo;
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function loadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    if (histories.current.length === 0) {
        var ref5;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
            h: h,
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoriesModalContent_Empty, {
                webhookUrl: webhookUrl,
                webhookId: webhook === null || webhook === void 0 ? void 0 : webhook.id,
                channel: webhook === null || webhook === void 0 ? void 0 : webhook.channel,
                campaignCreatorId: webhook === null || webhook === void 0 ? void 0 : (ref5 = webhook.campaign) === null || ref5 === void 0 ? void 0 : ref5.creator.id,
                onDemoSent: demoSent
            })
        });
    }
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        align: "self-start",
        h: h,
        noWrap: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoriesModalContent_HistoryList, {
                onItemClick: setHistory,
                histories: histories.current,
                onLoadMore: loadMore,
                hasMore: (ref6 = (ref = pageInfo.current) === null || ref === void 0 ? void 0 : ref.hasNextPage) !== null && ref6 !== void 0 ? ref6 : false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoriesModalContent_HistoryDetail, {
                history: history
            })
        ]
    });
};
/* harmony default export */ var HistoriesModalContent = (ModalContent);

;// CONCATENATED MODULE: ./src/components/business/Integration/hooks/useWebhookHistoriesModal.tsx








var webhookHistoriesModalId = "webhookHistoriesModal";
var modalInnerPadding = 90;
var modalBodyPadding = 24;
var modalTitleHeight = 44;
var outsideModalBodyHeight = modalInnerPadding * 2 + modalBodyPadding * 2 + modalTitleHeight;
function useWebhookHistoriesModal() {
    var t = (0,useTranslation/* default */.Z)("integration").t;
    return function(props) {
        (0,events/* openModal */.h7)({
            modalId: webhookHistoriesModalId,
            withinPortal: true,
            closeOnClickOutside: false,
            trapFocus: false,
            size: 1000,
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                weight: 600,
                size: "md",
                children: t("webhook.histories.title")
            }),
            styles: {
                content: {
                    overflow: "hidden !important"
                },
                inner: {
                    paddingTop: "".concat(modalInnerPadding, "px"),
                    paddingBottom: "".concat(modalInnerPadding, "px")
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoriesModalContent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                h: "calc(100vh - ".concat(outsideModalBodyHeight, "px)")
            }))
        });
    };
}

;// CONCATENATED MODULE: ./src/components/business/Integration/hooks/useWebhookSuspendedDetailModal.tsx







var webhookSuspendedByModalId = "webhookSuspendedByModal";
function useWebhookSuspendedDetailModal() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        showCampaignName: false
    };
    var getErrMsg = function getErrMsg(webhookHistory) {
        if (webhookHistory.status == domain/* WebhookHistoryStatus.Timeout */.s6L.Timeout) {
            return t("error.timeout");
        }
        var responseStatusCode = webhookHistory.responseStatusCode, responseBody = webhookHistory.responseBody, errMsg = webhookHistory.errMsg;
        if (responseStatusCode) {
            return "".concat(responseStatusCode, " ").concat(responseBody);
        }
        return errMsg;
    };
    var t = (0,useTranslation/* default */.Z)("integration").t;
    return function(suspendedBy) {
        var ref;
        var errMsg = getErrMsg(suspendedBy);
        var _requestPayload;
        var ref1 = (_requestPayload = suspendedBy.requestPayload) !== null && _requestPayload !== void 0 ? _requestPayload : {}, campaign = ref1.campaign, entry = ref1.entry;
        var ref2;
        var entrySerialNumber = (ref2 = (ref = suspendedBy.target) === null || ref === void 0 ? void 0 : ref.serialNumber) !== null && ref2 !== void 0 ? ref2 : entry === null || entry === void 0 ? void 0 : entry.serial_number;
        (0,events/* openModal */.h7)({
            modalId: webhookSuspendedByModalId,
            closeOnClickOutside: false,
            trapFocus: false,
            withinPortal: true,
            title: t("webhook.suspended.modal.title"),
            styles: function(theme) {
                return {
                    title: {
                        fontWeight: 600,
                        fontSize: theme.fontSizes.md
                    },
                    body: {
                        dl: {
                            fontSize: theme.fontSizes.sm,
                            margin: 0
                        },
                        dt: {
                            color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                            marginBottom: theme.spacing.sm
                        },
                        dd: {
                            marginLeft: 0,
                            wordBreak: "break-all"
                        },
                        "dd + dt": {
                            marginTop: theme.spacing.xl
                        }
                    }
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                children: [
                    props.showCampaignName && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: t("webhook.suspended.modal.campaignName")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: campaign === null || campaign === void 0 ? void 0 : campaign.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: t("webhook.suspended.modal.serialNumber")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: entrySerialNumber
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: t("webhook.suspended.modal.errMsg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: errMsg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: t("webhook.suspended.modal.requestUrl")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: suspendedBy.requestUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: t("webhook.suspended.modal.requestedAt")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: (0,utils/* formatISOTime */.cx)(suspendedBy.sentAt)
                    })
                ]
            })
        });
    };
}

;// CONCATENATED MODULE: ./src/components/business/Integration/index.ts








// EXTERNAL MODULE: ./src/components/business/FeatureTip/index.tsx
var FeatureTip = __webpack_require__(96900);
// EXTERNAL MODULE: ./src/plugins/crisp/index.ts
var plugins_crisp = __webpack_require__(7897);
// EXTERNAL MODULE: ./src/components/business/subscription/SubscriptionAlert.tsx
var SubscriptionAlert = __webpack_require__(96536);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationSettingLayout/index.tsx










var ApplicationSettingLayout = function(param) {
    var activeTab = param.activeTab, children = param.children;
    (0,plugins_crisp/* useCrisp */.L)();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* default */.Z)("layoutAppSetting").t;
    var application = (0,react.useContext)(ApplicationContext/* default */.Z).application;
    var appId = router.query.appId;
    var currentChannelGroup = (0,applicationUtils/* getDistributionChannelGroup */.cN)(application === null || application === void 0 ? void 0 : application.distribution.channel);
    var applicationUpdate = (0,applicationUtils/* canUpdateApplication */.kS)(application);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        size: 1600,
        px: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
            h: "100%",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    order: 3,
                    mb: "sm",
                    children: t("title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionAlert/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                    keepMounted: false,
                    value: activeTab,
                    onTabChange: function(value) {
                        router.push(config_constants/* ApplicationSettings.replace */.dp.replace("[appId]", appId).replace("[settingName]", value));
                    },
                    styles: function() {
                        return {
                            tab: {
                                lineHeight: "22px"
                            },
                            root: {
                                display: "flex",
                                flexDirection: "column",
                                height: "100%"
                            },
                            panel: {
                                flex: 1
                            }
                        };
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs.List */.m.List, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "basic",
                                    children: currentChannelGroup ? t("basic.".concat(currentChannelGroup)) : ""
                                }),
                                currentChannelGroup !== "link" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                            value: "tracking",
                                            children: currentChannelGroup ? t("tracking.".concat(currentChannelGroup)) : ""
                                        }),
                                        applicationUpdate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                            value: "distribution",
                                            children: t("distribution")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                            value: "events",
                                            children: t("event")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                            value: "customer-attributes",
                                            children: t("customerAttribute")
                                        })
                                    ]
                                }),
                                applicationUpdate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "webhook",
                                    children: t("webhook")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "api",
                                    children: t("api")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                            value: activeTab,
                            pt: "lg",
                            pb: "2xl",
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Layouts_ApplicationSettingLayout = (ApplicationSettingLayout);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/fill.js + 2 modules
var fill = __webpack_require__(28484);
;// CONCATENATED MODULE: ./src/components/business/Layouts/SimpleLayout/StepProgress.tsx





var StepProgress = function(param) {
    var current = param.current, total = param.total;
    var items = (0,fill/* default */.Z)(Array(total), "a");
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        align: "center",
        mb: "xl",
        mt: "-md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
            spacing: "sm",
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    w: "40px",
                    h: "4px",
                    className: "rounded-[1px]",
                    bg: current > index ? (0,getColor/* getBackgroundColor */.dF)("brandBlue.7", theme) : (0,getColor/* getBackgroundColor */.dF)("gray.2", theme)
                }, index);
            })
        })
    });
};
/* harmony default export */ var SimpleLayout_StepProgress = (StepProgress);

;// CONCATENATED MODULE: ./src/components/business/Layouts/SimpleLayout/bg.png
/* harmony default export */ var bg = ({"src":"https://static-cny.howxm.com/_next/static/media/bg.149b75c4.png","height":1440,"width":2402,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAhklEQVR42mNAB3/nmLL/n2Mo+G+uIStY4FepN+Pb0gSupzXJbP/n8An8n62v/m+2kfH/2YayYAWfykI47leWqFzurjN+OjPW/udsa4v/sw3M/s0xgij4UBPAfLG2U/jQxOkmJ2e3Bb6cE2b2f7a81I+5ziwodi+YeYRr97x5cg/mJQkgiwMA26Ez/0Ozr3gAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/plugins/howxm/useHowxmSDK.ts
var useHowxmSDK = __webpack_require__(25474);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(71557);
;// CONCATENATED MODULE: ./src/components/business/Layouts/SimpleLayout/index.tsx








var SimpleLayout = function(param) {
    var children = param.children, left = param.left, right = param.right, _responsive = param.responsive, responsive = _responsive === void 0 ? true : _responsive, step = param.step;
    (0,useHowxmSDK/* default */.Z)(config/* HowXMAppId */.KD);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            responsive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ResponsiveHead */.eG, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                fluid: true,
                pb: "xl",
                sx: {
                    backgroundImage: "url(".concat(bg.src, ")"),
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        my: "2xl",
                        mx: "sm",
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Logo */.TR, {})
                            }),
                            left && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    position: "absolute",
                                    left: 0,
                                    top: 0
                                },
                                children: left
                            }),
                            right && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    position: "absolute",
                                    right: 0,
                                    top: 0
                                },
                                children: right
                            })
                        ]
                    }),
                    step && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleLayout_StepProgress, {
                        current: step.current,
                        total: step.total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                        align: "center",
                        children: children
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Layouts_SimpleLayout = (SimpleLayout);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/AppShell/Navbar/Navbar.js
var Navbar = __webpack_require__(68909);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/differenceInDays/index.js + 2 modules
var differenceInDays = __webpack_require__(89074);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Progress/Progress.js + 1 modules
var Progress = __webpack_require__(60837);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/CurrentSubscription/FreeSubscription.tsx





var FreeSubscription = function(param) {
    var vasBalance = param.vasBalance;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var entriesTotalCount = vasBalance["ENTRIES_COUNT"].total;
    var entriesUsageCount = entriesTotalCount - vasBalance["ENTRIES_COUNT"].balance;
    var usagePercentage = entriesUsageCount / entriesTotalCount * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: usagePercentage >= 90 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* Progress */.E, {
                    size: "sm",
                    value: usagePercentage,
                    color: (0,getColor/* getBackgroundColor */.dF)("red.6", theme)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    size: "xs",
                    color: "dimmed",
                    children: "".concat((0,utils/* formatNumberToThousands */.NZ)(entriesUsageCount), "/").concat(entriesTotalCount)
                })
            ]
        })
    });
};
/* harmony default export */ var CurrentSubscription_FreeSubscription = (FreeSubscription);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/CurrentSubscription/SubscriptionHoverDropDown.tsx












var SubscriptionHoverDropDown = function(param) {
    var productCode = param.productCode, unavailableFeature = param.unavailableFeature, endDate = param.endDate;
    var t = (0,useTranslation/* default */.Z)("account").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var upgrade = function(feature) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
            color: (0,getColor/* getTextColor */.uu)("blue", theme),
            onClick: function() {
                return (0,ProductsModal/* openProductsModal */.$P)(feature !== null && feature !== void 0 ? feature : t("account:subscription.".concat(productCode, ".upgradeFeature")));
            }
        });
    };
    var crisp = /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
        color: (0,getColor/* getTextColor */.uu)("blue", theme),
        onClick: plugins_crisp/* openCrisp */.C
    });
    var account = /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
        onClick: function() {
            return router_default().push(config_constants/* SystemAccount */.js);
        }
    });
    if (!productCode) {
        return null;
    }
    if (unavailableFeature) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                i18nKey: "account:subscription.free.tooltip.unavailable.".concat(unavailableFeature),
                components: {
                    upgrade: upgrade(unavailableFeature),
                    crisp: crisp,
                    account: account
                }
            })
        });
    }
    if (productCode === products/* ProductCode.Free */.G.Free) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                i18nKey: "account:subscription.free.tooltip.notOverLimitLabel",
                components: {
                    upgrade: upgrade(),
                    crisp: crisp
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
            i18nKey: "account:subscription.paid.tooltip.label",
            values: {
                date: (0,utils/* formatISODate */.cz)(endDate),
                product: t("account:subscription.".concat(productCode, ".name"))
            },
            components: {
                upgrade: upgrade()
            }
        })
    });
};
/* harmony default export */ var CurrentSubscription_SubscriptionHoverDropDown = (SubscriptionHoverDropDown);

// EXTERNAL MODULE: ./src/components/business/subscription/useCheckFeatureAlert.ts + 1 modules
var useCheckFeatureAlert = __webpack_require__(577);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/CurrentSubscription/index.tsx














var iconWidth = 24;
var CurrentSubscription = function() {
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var getVipColor = useVipColor();
    var t = (0,useTranslation/* default */.Z)("account").t;
    var account = (0,react.useContext)(ApplicationContext/* default */.Z).account;
    var subscription = account.subscription;
    var productCode = subscription.productCode;
    var vasBalance = account.vasBalance;
    var endDate = account.subscriptionLastEndDate;
    var unavailableFeature = (0,useCheckFeatureAlert/* default */.Z)();
    var colorScheme = (0,theme_MantineProvider/* useMantineTheme */.rZ)().colorScheme;
    var isDarkMode = colorScheme === "dark";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
        withinPortal: true,
        position: "top-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    p: "sm",
                    pr: "md",
                    mb: "sm",
                    spacing: "xl",
                    align: "start",
                    bg: !unavailableFeature ? productCode === products/* ProductCode.Trial */.G.Trial ? (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme, "dark.6") : (0,getColor/* getBackgroundColor */.dF)("gray.0", theme) : isDarkMode ? "rgba(224, 49, 49, 0.2)" : "rgba(255, 245, 245, 1)",
                    sx: {
                        borderRadius: theme.radius.md
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                            name: "vip",
                            style: {
                                color: getVipColor(productCode),
                                width: iconWidth
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                            spacing: 8,
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                    position: "apart",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            children: productCode ? t("subscription.".concat(productCode, ".name")) : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            size: "xs",
                                            className: "w-[54px] h-[25px]",
                                            onClick: function() {
                                                return (0,ProductsModal/* openProductsModal */.$P)(t("subscription.".concat(productCode, ".upgradeFeature")));
                                            },
                                            children: productCode === products/* ProductCode.Free */.G.Free ? t("actions.upgrade") : t("actions.renewal")
                                        })
                                    ]
                                }),
                                productCode === products/* ProductCode.Free */.G.Free && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSubscription_FreeSubscription, {
                                    vasBalance: vasBalance
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: productCode === products/* ProductCode.Trial */.G.Trial && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        mt: "xs",
                                        size: "xs",
                                        color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                                        children: endDate ? t("subscription.trial.expireAfter", {
                                            days: (0,differenceInDays/* default */.Z)((0,parseISO/* default */.Z)(endDate), new Date())
                                        }) : t("subscription.trial.expireToday")
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                sx: {
                    borderRadius: theme.radius.sm,
                    maxWidth: 420
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentSubscription_SubscriptionHoverDropDown, {
                    productCode: productCode,
                    unavailableFeature: unavailableFeature,
                    endDate: endDate
                })
            })
        ]
    });
};
/* harmony default export */ var ApplicationLayout_CurrentSubscription = (CurrentSubscription);

// EXTERNAL MODULE: ./src/components/business/Layouts/ApplicationLayout/AppManager/index.module.scss
var AppManager_index_module = __webpack_require__(73499);
var AppManager_index_module_default = /*#__PURE__*/__webpack_require__.n(AppManager_index_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconSelector.js
var IconSelector = __webpack_require__(46282);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/AppManager/AppName.tsx














var AppName = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var router = (0,next_router.useRouter)();
    var appId = router.query.appId;
    var showNotFound = (0,GlobalErrorBoundary/* useGlobalError */.zy)().showNotFound;
    var application = (0,react.useContext)(ApplicationContext/* default */.Z).application;
    var _$ref = (0,react.useState)(application), app = _$ref[0], setApp = _$ref[1];
    var data = (0,domain/* useApplicationBasicInfoQuery */.if_)({
        variables: {
            id: appId
        },
        onError: function(error) {
            showNotFound(error);
        }
    }).data;
    (0,react.useEffect)(function() {
        var fetched = data === null || data === void 0 ? void 0 : data.application;
        if (!fetched) {
            return;
        }
        setApp(fetched);
    }, [
        data,
        application
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        className: (AppManager_index_module_default()).current,
        sx: {
            ":hover": {
                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
            }
        },
        spacing: "xs",
        pl: "md",
        pr: "sm",
        mih: 32,
        noWrap: true,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Icon */.JO, {
                name: config_constants/* channelIconMap */.XW[app === null || app === void 0 ? void 0 : app.distribution.channel],
                className: "p-xs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: (0,getColor/* getTextColor */.uu)("gray.9", theme),
                size: "sm",
                weight: "bold",
                lineClamp: 1,
                className: "break-all",
                children: app === null || app === void 0 ? void 0 : app.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSelector/* default */.Z, {
                className: "shrink-0",
                color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                size: 14,
                stroke: 2
            })
        ]
    }));
});
/* harmony default export */ var AppManager_AppName = (AppName);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/dynamic.js
var dynamic = __webpack_require__(92295);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/AppManager/index.tsx






var AppsSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1125).then(__webpack_require__.bind(__webpack_require__, 81125));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81125)
            ];
        }
    }
});
var AppManager = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], handles = ref[1];
    var handleSwitchModalOpen = function() {
        handles.close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
        opened: opened,
        onChange: handles.toggle,
        shadow: "md",
        width: 300,
        withinPortal: true,
        position: "bottom-start",
        styles: {
            itemIcon: {
                marginRight: 0
            },
            itemLabel: {
                flex: "1 !important"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppManager_AppName, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Dropdown */.v.Dropdown, {
                px: 0,
                children: opened && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppsSelector, {
                    onAccountSwitchModalOpen: handleSwitchModalOpen
                })
            })
        ]
    });
};
/* harmony default export */ var ApplicationLayout_AppManager = (AppManager);

// EXTERNAL MODULE: ./src/components/ui/ClientSideOnly/index.tsx
var ClientSideOnly = __webpack_require__(9456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconBellRinging.js
var IconBellRinging = __webpack_require__(27727);
// EXTERNAL MODULE: ./src/components/business/Layouts/MainLayout/components/MenuWrapper/index.tsx
var MenuWrapper = __webpack_require__(9774);
// EXTERNAL MODULE: ./src/components/business/hooks/useOnboardingCache.ts
var useOnboardingCache = __webpack_require__(35221);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Badge/index.tsx





var OnboardingBadge = function() {
    var pendingTasks = (0,useOnboardingCache/* default */.Z)().pendingTasks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
        sx: function(theme) {
            return {
                background: (0,getColor/* getBackgroundColor */.dF)("brandBlue.7", theme),
                width: "18px",
                height: "18px",
                borderRadius: "50%"
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            size: "xs",
            weight: 600,
            color: "white",
            children: pendingTasks.length
        })
    });
};
/* harmony default export */ var Onboadring_Badge = (OnboardingBadge);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Accordion/Accordion.js + 10 modules
var Accordion = __webpack_require__(1026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/link.js
var next_link = __webpack_require__(19032);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/RadioBtn/index.tsx





var RadioBtn = function(props) {
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var checked = props.checked, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        spacing: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                className: "xm-onboarding-radio",
                "data-testid": "radio",
                sx: function(theme) {
                    return {
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: checked ? "none !important" : "1px solid ".concat((0,getColor/* getBorderColor */.kJ)("gray.3", theme)),
                        background: checked ? "".concat((0,getColor/* getBackgroundColor */.dF)("green.1", theme), " !important") : (0,getColor/* getBackgroundColor */.dF)("white", theme)
                    };
                },
                children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                    stroke: 2,
                    size: 16,
                    color: (0,getColor/* getTextColor */.uu)("green.6", theme)
                })
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                children: label
            })
        ]
    });
};
/* harmony default export */ var Onboadring_RadioBtn = (RadioBtn);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Tasks/Task.tsx




var Task = function(props) {
    var value = props.value, checked = props.checked, title = props.title, descriptions = props.descriptions, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* Accordion.Item */.U.Item, {
        value: value,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion.Control */.U.Control, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring_RadioBtn, {
                            checked: checked
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "sm",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion.Panel */.U.Panel, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: 0,
                    children: [
                        descriptions.map(function(desc, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                size: "xs",
                                c: "dimmed",
                                children: desc
                            }, index);
                        }),
                        children
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Tasks_Task = (Task);

// EXTERNAL MODULE: ./src/modules/Application/Feedback/Create/useCreateFeedback.ts
var useCreateFeedback = __webpack_require__(1778);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Tasks/CampaignCreatedTask.tsx












var CampaignCreatedTask = function() {
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var appId = (0,next_router.useRouter)().query.appId;
    var onboarding = (0,useOnboardingCache/* default */.Z)().onboarding;
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    var isCurrentMiniappDistribution = (0,applicationUtils/* isMiniappDistribution */.kA)(application);
    var ref = (0,useCreateFeedback/* default */.Z)(), createFeedback = ref.createFeedback, loading = ref.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_Task, {
        value: "campaignCreated",
        checked: !!(onboarding === null || onboarding === void 0 ? void 0 : onboarding.campaignCreated),
        title: isCurrentMiniappDistribution ? t("campaign.titleWithoutFeedback") : t("campaign.title"),
        descriptions: t("campaign.descriptions", {}, {
            returnObjects: true
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
            spacing: "sm",
            mt: "md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname: config_constants/* ApplicationSurvey */.mf,
                        query: {
                            appId: appId,
                            templateCode: 1
                        }
                    },
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        component: "a",
                        size: "xs",
                        children: t("campaign.createSurvey")
                    })
                }),
                !isCurrentMiniappDistribution && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    component: "a",
                    onClick: createFeedback,
                    loading: loading,
                    size: "xs",
                    children: t("campaign.createFeedback")
                })
            ]
        })
    });
};
/* harmony default export */ var Tasks_CampaignCreatedTask = (CampaignCreatedTask);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Tasks/SdkTask.tsx













var SdkTask = function() {
    var onboarding = (0,useOnboardingCache/* default */.Z)().onboarding;
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var appId = (0,next_router.useRouter)().query.appId;
    var channel = (0,useApplicationInfoBaseInfoCache/* default */.Z)().channel;
    var sdkConnected = onboarding === null || onboarding === void 0 ? void 0 : onboarding.sdkConnected;
    var sdkSettingCompleted = onboarding === null || onboarding === void 0 ? void 0 : onboarding.sdkSettingCompleted;
    var _obj;
    var label = (_obj = {}, (0,_define_property/* default */.Z)(_obj, domain/* CampaignDistributionChannel.Web */.wQf.Web, t("sdk.sdkSetting.web")), (0,_define_property/* default */.Z)(_obj, domain/* CampaignDistributionChannel.IosSwift */.wQf.IosSwift, t("sdk.sdkSetting.ios")), (0,_define_property/* default */.Z)(_obj, domain/* CampaignDistributionChannel.Android */.wQf.Android, t("sdk.sdkSetting.android")), (0,_define_property/* default */.Z)(_obj, domain/* CampaignDistributionChannel.WechatMiniapp */.wQf.WechatMiniapp, t("sdk.sdkSetting.miniapp")), (0,_define_property/* default */.Z)(_obj, domain/* CampaignDistributionChannel.Link */.wQf.Link, ""), (0,_define_property/* default */.Z)(_obj, domain/* CampaignDistributionChannel.ReactNative */.wQf.ReactNative, ""), _obj);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_Task, {
        value: "sdkCompleted",
        checked: !!(sdkConnected && sdkSettingCompleted),
        title: t("sdk.title"),
        descriptions: t("sdk.descriptions", {}, {
            returnObjects: true
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
            mt: "lg",
            spacing: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "sm",
                    children: [
                        channel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring_RadioBtn, {
                            checked: sdkSettingCompleted,
                            label: label[channel]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                            ml: "2xl",
                            className: "w-[fit-content] p-0 hover:!bg-transparent",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: config_constants/* ApplicationSettingsCodeBasic */.W2,
                                    query: {
                                        appId: appId
                                    }
                                },
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    component: "a",
                                    size: "xs",
                                    children: t("sdk.sdkSetting.goSetting")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring_RadioBtn, {
                            checked: sdkConnected,
                            label: t("sdk.activeSdk.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                            ml: "2xl",
                            className: "w-[fit-content] p-0 hover:!bg-transparent",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: config_constants/* ApplicationSettingsCodeTracking */._F,
                                    query: {
                                        appId: appId
                                    }
                                },
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    component: "a",
                                    size: "xs",
                                    children: t("sdk.activeSdk.viewCode")
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Tasks_SdkTask = (SdkTask);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Tasks/MemberInvitedTask.tsx









var MemberInvitedTask = function() {
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var onboarding = (0,useOnboardingCache/* default */.Z)().onboarding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_Task, {
        value: "memberInvited",
        checked: !!(onboarding === null || onboarding === void 0 ? void 0 : onboarding.memberInvited),
        title: t("members.title"),
        descriptions: t("members.descriptions", {}, {
            returnObjects: true
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
            className: "w-[fit-content] p-0 hover:!bg-transparent",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: config_constants/* ApplicationMembers */.t4,
                    query: {
                        appId: (0,next_router.useRouter)().query.appId
                    }
                },
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    component: "a",
                    size: "xs",
                    mt: "md",
                    children: t("members.invitedMember")
                })
            })
        })
    });
};
/* harmony default export */ var Tasks_MemberInvitedTask = (MemberInvitedTask);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Tasks/EntryCollectedTask.tsx





var EntryCollectedTask = function() {
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var onboarding = (0,useOnboardingCache/* default */.Z)().onboarding;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_Task, {
        value: "entryCollected",
        checked: !!(onboarding === null || onboarding === void 0 ? void 0 : onboarding.entryCollected),
        title: t("entries.title"),
        descriptions: t("entries.descriptions", {}, {
            returnObjects: true
        })
    });
};
/* harmony default export */ var Tasks_EntryCollectedTask = (EntryCollectedTask);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Tasks/index.tsx










var Tasks = function() {
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var pendingTasks = (0,useOnboardingCache/* default */.Z)().pendingTasks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* Accordion */.U, {
        radius: "xs",
        px: "lg",
        pt: "xl",
        pb: "2xl",
        bg: (0,getColor/* getBackgroundColor */.dF)("white", theme),
        variant: "separated",
        defaultValue: pendingTasks[0],
        transitionDuration: 100,
        chevron: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronDown/* default */.Z, {
            color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
            size: 18,
            stroke: 1.5
        }),
        styles: {
            control: {
                padding: 0,
                "&[data-active]": {
                    ".mantine-Text-root": {
                        fontWeight: 600
                    },
                    ".xm-onboarding-radio": {
                        border: "2px solid ".concat((0,getColor/* getBorderColor */.kJ)("brandBlue.2", theme)),
                        background: (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme)
                    }
                }
            },
            label: {
                padding: 0
            },
            item: {
                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("white", theme),
                border: "none",
                "& + &": {
                    marginTop: "24px"
                }
            },
            panel: {
                border: "none",
                marginTop: "8px",
                marginLeft: "35px"
            },
            content: {
                padding: 0
            },
            chevron: {
                width: "28px",
                height: "28px",
                borderRadius: theme.radius.xs,
                "&:hover": {
                    background: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_CampaignCreatedTask, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_SdkTask, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_EntryCollectedTask, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tasks_MemberInvitedTask, {})
        ]
    });
};
/* harmony default export */ var Onboadring_Tasks = (Tasks);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Content/SkipGuide.tsx











var SkipGuide = function(param) {
    var onSkip = param.onSkip;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], ref1 = ref[1], open = ref1.open, close = ref1.close;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,domain/* useSkipApplicationOnboardingMutation */._ex)({
        variables: {
            appId: (0,next_router.useRouter)().query.appId
        }
    }), 1), skipMutation = ref2[0];
    var handleConfirmSkip = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            skipMutation()
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data === null || data === void 0 ? void 0 : data.skipApplicationOnboarding) {
                            onSkip();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmSkip() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* Popover */.J, {
        width: 272,
        position: "top",
        withinPortal: true,
        shadow: "md",
        opened: opened,
        withArrow: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Target */.J.Target, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                    className: "px-sm py-xs rounded-sm hover:bg-brandBlue-1",
                    underline: false,
                    component: "button",
                    c: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                    onClick: open,
                    children: t("skip.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Dropdown */.J.Dropdown, {
                p: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                    spacing: "lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            children: t("skip.description")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                            spacing: "sm",
                            position: "right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    size: "xs",
                                    variant: "default",
                                    onClick: close,
                                    children: t("common:actions.cancel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    size: "xs",
                                    onClick: handleConfirmSkip,
                                    children: t("skip.confirm")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Content_SkipGuide = (SkipGuide);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Content/Title.tsx






var OnboardingTitle = function(props) {
    var onSkip = props.onSkip;
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        p: "lg",
        position: "apart",
        bg: (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 5,
                children: t("title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_SkipGuide, {
                onSkip: onSkip
            })
        ]
    });
};
/* harmony default export */ var Content_Title = (OnboardingTitle);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/Content/index.tsx





var OnboardingContent = function(props) {
    var onSkip = props.onSkip;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        w: 360,
        m: "-xs",
        spacing: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Title, {
                onSkip: onSkip
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring_Tasks, {})
        ]
    });
};
/* harmony default export */ var Onboadring_Content = (OnboardingContent);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Onboadring/index.tsx











var Onboadring_Onboarding = function() {
    var t = (0,useTranslation/* default */.Z)("componentAppOnboarding").t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(true), 2), isSkip = ref[0], close = ref[1].close;
    var onboarding = (0,useOnboardingCache/* default */.Z)().onboarding;
    if (!isSkip || !onboarding) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
        px: "sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWrapper/* default */.Z, {
            buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: 80,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        spacing: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBellRinging/* default */.Z, {
                                size: 22,
                                stroke: 1.5,
                                color: "#5B636F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: t("title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring_Badge, {})
                ]
            }),
            dropdownChildren: /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring_Content, {
                onSkip: close
            }),
            dropdownStyle: {
                width: "360px !important",
                bottom: "80px !important",
                top: "unset !important"
            }
        })
    });
};
/* harmony default export */ var Onboadring = (Onboadring_Onboarding);

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/ApplicationStatus/components/StatusPopover.tsx





var StatusPopover = function(props, ref) {
    var targetIcon = props.targetIcon, color = props.color, targetText = props.targetText, children = props.children;
    var isTargetTextSettled = (0,isNil/* default */.Z)(targetText);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
        width: 360,
        position: "bottom-start",
        shadow: "md",
        offset: 4,
        withinPortal: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                children: isTargetTextSettled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                    size: 32,
                    variant: "transparent",
                    sx: function(theme) {
                        return {
                            "&:hover": {
                                backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                            }
                        };
                    },
                    children: targetIcon
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    ref: ref,
                    styles: function(theme) {
                        return {
                            root: {
                                fontSize: 12,
                                backgroundColor: "transparent",
                                "&:hover": {
                                    backgroundColor: theme.colors.red[0]
                                }
                            }
                        };
                    },
                    variant: "subtle",
                    color: color,
                    size: "sm",
                    leftIcon: targetIcon,
                    children: targetText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                p: "md",
                children: children
            })
        ]
    });
};
/* harmony default export */ var components_StatusPopover = (/*#__PURE__*/(0,react.forwardRef)(StatusPopover));

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/ApplicationStatus/components/StatusContent.tsx



var StatusContent = function(props) {
    var title = props.title, icon = props.icon, content = props.content, link = props.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
        position: "left",
        align: "start",
        spacing: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                mt: "xs",
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                spacing: "sm",
                align: "flex-start",
                sx: {
                    width: "270px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        weight: "600",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        children: [
                            " ",
                            content
                        ]
                    }),
                    link
                ]
            })
        ]
    });
};
/* harmony default export */ var components_StatusContent = (StatusContent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconAccessPoint.js
var IconAccessPoint = __webpack_require__(23294);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconAccessPointOff.js
var IconAccessPointOff = __webpack_require__(87248);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/ApplicationStatus/index.tsx













var ApplicationStatus = function() {
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    var ref = (0,react.useRef)(null);
    var appId = (0,next_router.useRouter)().query.appId;
    var application = (0,react.useContext)(ApplicationContext/* default */.Z).application;
    var _distribution = application.distribution, pingedAt = _distribution.pingedAt, setting = _distribution.setting, channel = _distribution.channel;
    var isCurrentMobileDistribution = (0,applicationUtils/* isMobileDistribution */._Z)(application);
    var currentChannelGroup = (0,applicationUtils/* getDistributionChannelGroup */.cN)(channel);
    var websiteUrl = setting.websiteUrl;
    var name = application.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,applicationUtils/* isApplicationStatusNormal */.ll)(pingedAt) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StatusPopover, {
            ref: ref,
            targetIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAccessPoint/* default */.Z, {
                size: 18,
                color: (0,getColor/* getTextColor */.uu)("teal.6", theme)
            }),
            color: "teal.6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StatusContent, {
                title: t("status.".concat(currentChannelGroup, ".active")),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAccessPoint/* default */.Z, {
                    size: 18,
                    color: (0,getColor/* getTextColor */.uu)("teal.6", theme)
                }),
                content: t("status.".concat(currentChannelGroup, ".appActiveDescription"), {
                    url: websiteUrl,
                    name: name
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StatusPopover, {
            ref: ref,
            targetIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAccessPointOff/* default */.Z, {
                size: 18,
                color: (0,getColor/* getTextColor */.uu)("red.6", theme)
            }),
            color: "red.6",
            children: isCurrentMobileDistribution ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StatusContent, {
                title: t("status.".concat(currentChannelGroup, ".inactive")),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAccessPointOff/* default */.Z, {
                    size: 18,
                    color: (0,getColor/* getTextColor */.uu)("red.6", theme)
                }),
                content: t("status.".concat(currentChannelGroup, ".appInactiveDescription"), {
                    name: name
                }),
                link: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                    href: config_constants/* ApplicationSettingsCodeTracking.replace */._F.replace("[appId]", appId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        onClick: function() {
                            var ref1;
                            ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.click();
                        },
                        color: "brandBlue.6",
                        children: t("status.".concat(currentChannelGroup, ".appCheck"))
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StatusContent, {
                title: t("status.".concat(currentChannelGroup, ".inactive")),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAccessPointOff/* default */.Z, {
                    size: 18,
                    color: (0,getColor/* getTextColor */.uu)("red.6", theme)
                }),
                content: pingedAt ? t("status.web.noRecentResponseDescription", {
                    url: websiteUrl
                }) : t("status.web.noResponseDescription", {
                    url: websiteUrl
                }),
                link: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
                    href: config_constants/* ApplicationSettingsCodeTracking.replace */._F.replace("[appId]", appId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        onClick: function() {
                            var ref1;
                            ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.click();
                        },
                        color: "brandBlue.6",
                        children: t("status.check")
                    })
                })
            })
        })
    });
};
/* harmony default export */ var ApplicationLayout_ApplicationStatus = (ApplicationStatus);

// EXTERNAL MODULE: ./src/components/ui/Icon/index.tsx + 121 modules
var Icon = __webpack_require__(12538);
// EXTERNAL MODULE: ./src/config/constants/routerPath.ts
var routerPath = __webpack_require__(30482);
// EXTERNAL MODULE: ./src/components/business/Layouts/MainLayout/components/MainLink.tsx
var MainLink = __webpack_require__(29864);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Nav/navs.tsx






var Survey = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabSurvey"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabSurveyFill"
        }),
        label: t("nav.survey"),
        pathname: routerPath/* ApplicationSurvey */.mf,
        activePathnames: [
            routerPath/* ApplicationSurveyShow */.Ky,
            routerPath/* ApplicationSurveyReports */.qE,
            routerPath/* ApplicationSurveyEntries */.Zl,
            routerPath/* ApplicationSurveyIntegration */.PW,
            routerPath/* ApplicationSurveyEntry */.__, 
        ]
    });
};
var Feedback = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabFeedback"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabFeedbackFill"
        }),
        label: t("nav.feedback"),
        pathname: routerPath/* ApplicationFeedback */.qN,
        activePathnames: [
            routerPath/* ApplicationFeedbackShow */.PD,
            routerPath/* ApplicationFeedbackEntries */.ry,
            routerPath/* ApplicationFeedbackIntegration */.Ws,
            routerPath/* ApplicationFeedbackEntry */.HE, 
        ]
    });
};
var Customer = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabCustomer"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabCustomerFill"
        }),
        label: t("nav.customer"),
        pathname: routerPath/* ApplicationCustomers */.FT,
        activePathnames: [
            routerPath/* ApplicationCustomers */.FT,
            routerPath/* ApplicationSegmentCustomer */.od
        ]
    });
};
var Reply = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabReply"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabReplyFill"
        }),
        label: t("nav.reply"),
        pathname: routerPath/* ApplicationReply */._S,
        activePathnames: [
            routerPath/* ApplicationReply */._S
        ]
    });
};
var Notification = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabNotification"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabNotificationFill"
        }),
        label: t("nav.notification"),
        pathname: routerPath/* ApplicationNotification */.Ks,
        isNewFeature: true,
        activePathnames: [
            routerPath/* ApplicationNotificationShow */.s3,
            routerPath/* ApplicationNotificationReports */.uz,
            routerPath/* ApplicationNotificationEntries */.LS,
            routerPath/* ApplicationNotificationEntry */.E,
            routerPath/* ApplicationNotificationIntegration */.bk, 
        ]
    });
};
var Template = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabTemplates"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabTemplatesFill"
        }),
        label: t("nav.template"),
        pathname: routerPath/* ApplicationTemplates */.qv,
        activePathnames: [
            routerPath/* ApplicationTemplates */.qv,
            routerPath/* ApplicationTemplate */.cB
        ]
    });
};
var Integration = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabIntegration"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabIntegrationFill"
        }),
        label: t("nav.integration"),
        pathname: routerPath/* ApplicationIntegration */.Pn,
        activePathnames: [
            routerPath/* ApplicationIntegration */.Pn
        ]
    });
};
var Member = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabTeammates"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabTeammatesFill"
        }),
        label: t("nav.member"),
        pathname: routerPath/* ApplicationMembers */.t4,
        activePathnames: [
            routerPath/* ApplicationMembers */.t4
        ]
    });
};
var Setting = function() {
    var t = (0,useTranslation/* default */.Z)("layoutApplication").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLink/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabSetting"
        }),
        iconActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: "tabSettingFill"
        }),
        label: t("nav.setting"),
        pathname: routerPath/* ApplicationSettingsCodeBasic */.W2,
        activePathnames: [
            routerPath/* ApplicationSettingsCodeBasic */.W2,
            routerPath/* ApplicationSettingsCodeTracking */._F,
            routerPath/* ApplicationSettingsDistribution */.xI,
            routerPath/* ApplicationSettingsEvents */.bj,
            routerPath/* ApplicationSettingsCustomerAttributes */.ZX,
            routerPath/* ApplicationSettingsWebhook */.Wi,
            routerPath/* ApplicationSettingsApi */.pH, 
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/Nav/index.tsx













var Navs = function(param) {
    var channel = param.channel;
    switch(channel){
        case domain/* CampaignDistributionChannel.Link */.wQf.Link:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Setting, {})
                ]
            });
        case domain/* CampaignDistributionChannel.WechatMiniapp */.wQf.WechatMiniapp:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Setting, {})
                ]
            });
        case domain/* CampaignDistributionChannel.IosSwift */.wQf.IosSwift:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Setting, {})
                ]
            });
        case domain/* CampaignDistributionChannel.Android */.wQf.Android:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Setting, {})
                ]
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reply, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Integration, {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Member, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Setting, {})
                ]
            });
    }
};
var Nav = function() {
    var ref = (0,react.useContext)(ApplicationContext/* default */.Z), application = ref.application, me = ref.me;
    var isLinkApplication = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    if (!application) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
                px: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: "sm",
                    align: "stretch",
                    mb: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            align: "stretch",
                            className: "flex-1",
                            gap: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationLayout_AppManager, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionAlert/* default */.Z, {
                                        collapsed: true
                                    })
                                })
                            ]
                        }),
                        !isLinkApplication && /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationLayout_ApplicationStatus, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
                grow: true,
                px: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navs, {
                    channel: application.distribution.channel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar.Section */.w.Section, {
                px: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationLayout_CurrentSubscription, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSideOnly/* default */.Z, {
                children: !isLinkApplication && /*#__PURE__*/ (0,jsx_runtime.jsx)(Onboadring, {})
            })
        ]
    });
};
/* harmony default export */ var ApplicationLayout_Nav = (Nav);

// EXTERNAL MODULE: ./src/components/business/Layouts/MainLayout/index.tsx + 6 modules
var MainLayout = __webpack_require__(34383);
;// CONCATENATED MODULE: ./src/components/business/Layouts/ApplicationLayout/index.tsx





var ApplicationLayout = function(param) {
    var children = param.children, application = param.application, account = param.account, me = param.me;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationContext/* default.Provider */.Z.Provider, {
        value: {
            application: application,
            account: account,
            me: me
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
            nav: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationLayout_Nav, {}),
            me: me,
            account: account,
            children: children
        })
    });
};
/* harmony default export */ var Layouts_ApplicationLayout = (ApplicationLayout);

// EXTERNAL MODULE: ./src/components/business/Layouts/OnboardingLayout/index.tsx + 8 modules
var OnboardingLayout = __webpack_require__(19932);
;// CONCATENATED MODULE: ./src/components/business/Layouts/index.ts





// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/indexOf.js
var indexOf = __webpack_require__(42054);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/minBy.js + 2 modules
var minBy = __webpack_require__(68611);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconUxCircle.js
var IconUxCircle = __webpack_require__(30823);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconArrowGuide.js
var IconArrowGuide = __webpack_require__(5167);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconUserQuestion.js
var IconUserQuestion = __webpack_require__(36300);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconTrendingUp.js
var IconTrendingUp = __webpack_require__(22465);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconArrowIteration.js
var IconArrowIteration = __webpack_require__(71983);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconNotification.js
var IconNotification = __webpack_require__(92334);
;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/constant.ts



var orderedCategories = [
    domain/* CampaignTemplateCategory.UserExperience */.tpb.UserExperience,
    domain/* CampaignTemplateCategory.UserGuidance */.tpb.UserGuidance,
    domain/* CampaignTemplateCategory.UserStudy */.tpb.UserStudy,
    domain/* CampaignTemplateCategory.OperatingGrowth */.tpb.OperatingGrowth,
    domain/* CampaignTemplateCategory.ProductsIteration */.tpb.ProductsIteration,
    domain/* CampaignTemplateCategory.BannerNotice */.tpb.BannerNotice, 
];
var CampaigTemplate_constant_obj;
var categoriesIcons = (CampaigTemplate_constant_obj = {}, (0,_define_property/* default */.Z)(CampaigTemplate_constant_obj, domain/* CampaignTemplateCategory.UserExperience */.tpb.UserExperience, IconUxCircle/* default */.Z), (0,_define_property/* default */.Z)(CampaigTemplate_constant_obj, domain/* CampaignTemplateCategory.UserGuidance */.tpb.UserGuidance, IconArrowGuide/* default */.Z), (0,_define_property/* default */.Z)(CampaigTemplate_constant_obj, domain/* CampaignTemplateCategory.UserStudy */.tpb.UserStudy, IconUserQuestion/* default */.Z), (0,_define_property/* default */.Z)(CampaigTemplate_constant_obj, domain/* CampaignTemplateCategory.OperatingGrowth */.tpb.OperatingGrowth, IconTrendingUp/* default */.Z), (0,_define_property/* default */.Z)(CampaigTemplate_constant_obj, domain/* CampaignTemplateCategory.ProductsIteration */.tpb.ProductsIteration, IconArrowIteration/* default */.Z), (0,_define_property/* default */.Z)(CampaigTemplate_constant_obj, domain/* CampaignTemplateCategory.BannerNotice */.tpb.BannerNotice, IconNotification/* default */.Z), CampaigTemplate_constant_obj);

;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/CategoryTab/index.tsx







var Categories = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,useTranslation/* default */.Z)("pageTemplate").t;
    var _autoSelected = props.autoSelected, autoSelected = _autoSelected === void 0 ? false : _autoSelected, onChange = props.onChange;
    var _$ref = (0,react.useState)(orderedCategories[0]), activeTab = _$ref[0], setActiveTab = _$ref[1];
    var handleScroll = function(top) {
        var tabElements = document.querySelectorAll(".categories");
        var tabPositions = Array.from(tabElements).map(function(el) {
            return el.getBoundingClientRect().top;
        });
        var closestTop = top !== null && top !== void 0 ? top : 100;
        var closestTab = orderedCategories.indexOf(activeTab);
        if (tabPositions.some(function(item) {
            return item > 0;
        })) {
            for(var i = 0; i < tabPositions.length; i++){
                if (Math.abs(tabPositions[i] - closestTop) < closestTop) {
                    closestTab = i;
                }
            }
        } else {
            closestTab = tabPositions.length - 1;
        }
        setActiveTab(orderedCategories[closestTab]);
    };
    (0,react.useEffect)(function() {
        if (autoSelected) {
            var tabs = Array.from(document.querySelectorAll(".categories"));
            var tabOffsets = tabs.map(function(el) {
                return el.offsetTop;
            });
            var scrollPosition = document.documentElement.scrollTop;
            var index = (0,indexOf/* default */.Z)(tabOffsets, (0,minBy/* default */.Z)(tabOffsets, function(item) {
                return Math.abs(item - scrollPosition);
            }));
            setActiveTab(index === -1 ? orderedCategories[0] : orderedCategories[index]);
        }
    }, [
        autoSelected
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            onScroll: handleScroll
        };
    });
    var handleTabChange = function(category) {
        var _$ref;
        setActiveTab(category);
        var offsetTop = (_$ref = document.getElementById(category)) === null || _$ref === void 0 ? void 0 : _$ref.offsetTop;
        var scrollOptions = {
            top: offsetTop,
            behavior: "smooth"
        };
        onChange(category, scrollOptions);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs */.m, {
        variant: "pills",
        value: activeTab,
        onTabChange: handleTabChange,
        classNames: {
            tabsList: "justify-center sm:justify-start"
        },
        styles: function(theme) {
            var backgroundColor = (0,getColor/* getBackgroundColor */.dF)("brandBlue.0", theme);
            return {
                tabsList: {
                    gap: 24
                },
                tab: {
                    padding: "6px 12px",
                    fontWeight: 400,
                    fontSize: 14,
                    "&:hover": {
                        backgroundColor: backgroundColor
                    },
                    '&[data-active="true"]': {
                        fontWeight: 400,
                        "&:hover": {
                            backgroundColor: backgroundColor
                        },
                        backgroundColor: backgroundColor,
                        color: (0,getColor/* getTextColor */.uu)("brandBlue.7", theme, "brandBlue.4")
                    }
                }
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.List */.m.List, {
            children: orderedCategories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                    value: category,
                    children: t("".concat(category, ".title"))
                }, category);
            })
        })
    });
});
/* harmony default export */ var CategoryTab = (/*#__PURE__*/(0,react.memo)(Categories));

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/groupBy.js
var groupBy = __webpack_require__(72068);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(58262);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/shuffle.js + 4 modules
var shuffle = __webpack_require__(21820);
;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/CategoryTemplates/getTemplateImageByCode.ts
var getTemplateImageUrlByCode = function(code) {
    var ref, ref1;
    return (ref = __webpack_require__(67535)("./".concat(code, ".png"))) === null || ref === void 0 ? void 0 : (ref1 = ref.default) === null || ref1 === void 0 ? void 0 : ref1.src;
};
/* harmony default export */ var getTemplateImageByCode = (getTemplateImageUrlByCode);

;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/CategoryTemplates/TemplateCard.tsx






var TemplateCard = function(props) {
    var template = props.template, className = props.className, url = props.url;
    var theme = (0,theme_MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* AnchorLink */.PN, {
        href: url,
        passHref: true,
        target: "_self",
        className: "!no-underline",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
            p: "md",
            radius: "md",
            className: classnames_default()(className, "group"),
            withBorder: true,
            sx: function() {
                return {
                    transition: "box-shadow 0.3s",
                    "&:hover": {
                        boxShadow: "0px 12px 16px rgba(16, 24, 40, 0.08), 0px 4px 6px rgba(16, 24, 40, 0.03)"
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        h: 160,
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* Image */.E, {
                            src: getTemplateImageByCode(template.code),
                            height: 160,
                            className: "transition-transform group-hover:scale-105",
                            alt: template.title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    weight: 600,
                    mt: "md",
                    mb: "sm",
                    size: "md",
                    children: template.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    size: "sm",
                    lineClamp: 3,
                    color: (0,getColor/* getTextColor */.uu)("gray.7", theme),
                    children: template.description
                })
            ]
        })
    });
};
/* harmony default export */ var CategoryTemplates_TemplateCard = (TemplateCard);

;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/CategoryTemplates/SiteTemplateCard.tsx



var SiteTemplateCard = function(props) {
    var template = props.template, className = props.className;
    var url = config_constants/* Template.replace */.YS.replace("[templateId]", template.code);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTemplates_TemplateCard, {
        url: url,
        template: template,
        className: className
    });
};
/* harmony default export */ var CategoryTemplates_SiteTemplateCard = (SiteTemplateCard);

;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/CategoryTemplates/SystemTemplateCard.tsx




var SystemTemplateCard = function(props) {
    var template = props.template, className = props.className;
    var appId = (0,next_router.useRouter)().query.appId;
    var url = config_constants/* ApplicationTemplate.replace */.cB.replace("[appId]", appId).replace("[code]", template.code);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTemplates_TemplateCard, {
        url: url,
        template: template,
        className: className
    });
};
/* harmony default export */ var CategoryTemplates_SystemTemplateCard = (SystemTemplateCard);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+hooks@6.0.13_react@18.2.0/node_modules/@mantine/hooks/esm/use-scroll-into-view/use-scroll-into-view.js + 4 modules
var use_scroll_into_view = __webpack_require__(93508);
;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/CategoryTemplates/index.tsx









var TemplateCategory = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var t = (0,useTranslation/* default */.Z)("pageTemplate").t;
    var templates = props.templates, source = props.source, containerRef = props.containerRef, active = props.active;
    var category = (0,react.useMemo)(function() {
        return templates === null || templates === void 0 ? void 0 : templates[0].category;
    }, [
        templates
    ]);
    var isSite = source === "site";
    var ref1 = (0,use_scroll_into_view/* useScrollIntoView */.g)({
        duration: 500
    }), scrollIntoView = ref1.scrollIntoView, targetRef = ref1.targetRef, scrollableRef = ref1.scrollableRef;
    (0,react.useEffect)(function() {
        if (active && containerRef && category !== domain/* CampaignTemplateCategory.UserExperience */.tpb.UserExperience) {
            scrollableRef.current = containerRef.current;
            scrollIntoView();
        }
    }, [
        containerRef,
        active,
        scrollableRef,
        scrollIntoView,
        category
    ]);
    var breakpoints = (0,react.useMemo)(function() {
        return isSite ? [
            {
                maxWidth: 1200,
                cols: 3
            },
            {
                maxWidth: 900,
                cols: 2
            },
            {
                maxWidth: 600,
                cols: 1
            }, 
        ] : [
            {
                maxWidth: 1600,
                cols: 4
            },
            {
                maxWidth: 1200,
                cols: 3
            },
            {
                maxWidth: 900,
                cols: 2
            }, 
        ];
    }, [
        isSite
    ]);
    var shownTemplates = isSite ? (0,shuffle/* default */.Z)(templates) : templates;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: 0,
        id: category,
        ref: targetRef,
        className: "px-[26px] text-center sm:px-xl sm:text-left categories",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                order: 4,
                children: t("".concat(category, ".name"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                mt: "sm",
                mb: "xl",
                c: "dimmed",
                children: t("".concat(category, ".description"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                cols: source === "site" ? 4 : 5,
                spacing: 32,
                breakpoints: breakpoints,
                children: shownTemplates === null || shownTemplates === void 0 ? void 0 : shownTemplates.map(function(template) {
                    return isSite ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTemplates_SiteTemplateCard, {
                        template: template,
                        className: "h-full"
                    }, template.code) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTemplates_SystemTemplateCard, {
                        template: template,
                        className: "h-full"
                    }, template.code);
                })
            })
        ]
    });
});
/* harmony default export */ var CategoryTemplates = (TemplateCategory);

;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/Categories/index.tsx





var Categories_Categories = function(props) {
    var _source = props.source, source = _source === void 0 ? "system" : _source, templates = props.templates, activeCategory = props.activeCategory, containerRef = props.containerRef;
    var categoryTemplates = (0,react.useMemo)(function() {
        return (0,groupBy/* default */.Z)(templates, "category");
    }, [
        templates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
        spacing: 32,
        children: Object.keys(categoryTemplates !== null && categoryTemplates !== void 0 ? categoryTemplates : {}).map(function(category, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTemplates, {
                containerRef: containerRef,
                active: activeCategory === category,
                templates: categoryTemplates[category],
                source: source
            }, index);
        })
    });
};
/* harmony default export */ var CampaigTemplate_Categories = (Categories_Categories);

;// CONCATENATED MODULE: ./src/components/business/CampaigTemplate/index.ts




// EXTERNAL MODULE: ./src/config/themeOverride/index.ts + 2 modules
var config_themeOverride = __webpack_require__(56143);
// EXTERNAL MODULE: ./src/config/constants/localStorage.ts
var localStorage = __webpack_require__(12834);
;// CONCATENATED MODULE: ./src/components/business/TestProvider/index.tsx








var TestProvider = function(param) {
    var apolloMocks = param.apolloMocks, children = param.children;
    return /*#__PURE__*/ _jsx(MockedProvider, {
        mocks: apolloMocks,
        children: /*#__PURE__*/ _jsx(MantineProvider, {
            withCSSVariables: true,
            withGlobalStyles: true,
            withNormalizeCSS: true,
            theme: _object_spread_props(_object_spread({}, themeOverride), {
                colorScheme: {
                    key: XM_COLOR_SCHEME,
                    defaultValue: "light",
                    getInitialValueInEffect: true
                }
            }),
            children: children
        })
    });
};
/* harmony default export */ var business_TestProvider = ((/* unused pure expression or super */ null && (TestProvider)));

// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/index.ts + 35 modules
var CampaignBuilder = __webpack_require__(89433);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/StyleSetting/Locale/utils/getDefaultLocaleWords.ts
var getDefaultLocaleWords = __webpack_require__(63802);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/getNextField.ts + 1 modules
var getNextField = __webpack_require__(7859);
// EXTERNAL MODULE: ./src/components/business/CampaignBuilder/CampaignPreview/utils/parseFieldsToFieldsPages.ts
var parseFieldsToFieldsPages = __webpack_require__(62030);
;// CONCATENATED MODULE: ./src/components/business/SurveyTemplatePreview/index.tsx












var SurveyTemplatePreview = function(props, ref) {
    var fields = props.fields, widget = props.widget, platform = props.platform, channel = props.channel, formSetting = props.formSetting, hideBranding = props.hideBranding, token = props.token, _type = props.type, type = _type === void 0 ? domain/* CampaignType.Survey */.mL.Survey : _type;
    var fieldsPages = (0,parseFieldsToFieldsPages/* default */.Z)(fields);
    var currentWidget = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var outsideContainerRef = (0,react.useRef)(null);
    var _$ref = (0,react.useState)(0), activePageIndex = _$ref[0], setActivePageIndex = _$ref[1];
    var application = (0,useApplicationInfoBaseInfoCache/* default */.Z)().application;
    var isLinkApplication = (0,applicationUtils/* isLinkDistribution */.dQ)(application);
    var pageIndex = 0;
    var handleFieldChange = function(data) {
        var nextFieldIndex = (0,getNextField/* getNextFieldIndex */.h)({
            formFields: fields,
            currentPageValues: data
        });
        pageIndex = nextFieldIndex && nextFieldIndex > -1 ? fields[nextFieldIndex].page : -1;
        setActivePageIndex(pageIndex);
        updateWidget();
    };
    var _colorScheme, _localeSetting;
    var previewProps = {
        interactive: true,
        activePageIndex: activePageIndex,
        formSetting: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, formSetting), {
            colorScheme: (_colorScheme = widget.colorScheme) !== null && _colorScheme !== void 0 ? _colorScheme : CampaignBuilder/* defaultColorScheme */.yi,
            brandingUrl: hideBranding ? null : config_constants/* brandingUrl */.$t,
            localeSetting: (_localeSetting = formSetting.localeSetting) !== null && _localeSetting !== void 0 ? _localeSetting : {
                locale: "zh_CN",
                wordings: (0,getDefaultLocaleWords/* default */.Z)(domain/* Locale.ZhCn */.gor.ZhCn)
            }
        }),
        widget: widget,
        maxHeight: "520px",
        onFieldChange: handleFieldChange,
        startIndex: 0,
        type: type,
        forcePlatformAs: platform,
        token: token,
        onClose: function() {
            destroyWidget();
        }
    };
    var getFinalPreviewPropsByCurrentPageField = function() {
        var common = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, previewProps), {
            pages: fieldsPages,
            activePageIndex: pageIndex
        });
        return isLinkApplication ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, common), {
            forcePlatformAs: "pc",
            isUrlVisit: true
        }) : common;
    };
    var createWidget = function() {
        pageIndex = 0;
        __webpack_require__.e(/* import() */ 408).then(__webpack_require__.bind(__webpack_require__, 40408)).then(function(module) {
            if (isLinkApplication) {
                currentWidget.current = new module.FormPreview((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getFinalPreviewPropsByCurrentPageField()), {
                    container: outsideContainerRef.current
                }));
                currentWidget.current.render();
            } else {
                var XSdk = module.default;
                currentWidget.current = new XSdk((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getFinalPreviewPropsByCurrentPageField()), {
                    container: containerRef.current
                }));
            }
        });
    };
    var updateWidget = function() {
        var _$ref;
        (_$ref = currentWidget.current) === null || _$ref === void 0 ? void 0 : _$ref.update(getFinalPreviewPropsByCurrentPageField());
    };
    var destroyWidget = function() {
        var _$ref, _$ref1;
        (_$ref = currentWidget.current) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.destroyWidget) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(_$ref);
    };
    var refresh = function() {
        destroyWidget();
        createWidget();
    };
    (0,react.useEffect)(function() {
        refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fields,
        channel
    ]);
    (0,react.useEffect)(function() {
        return destroyWidget();
    }, []);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            refresh: refresh
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: outsideContainerRef,
        style: {
            height: "100%",
            position: "relative",
            transform: "translate(0, 0)",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: containerRef
        })
    });
};
/* harmony default export */ var business_SurveyTemplatePreview = (/*#__PURE__*/(0,react.forwardRef)(SurveyTemplatePreview));

;// CONCATENATED MODULE: ./src/components/business/SdkOnboarding/avatar.png
/* harmony default export */ var avatar = ({"src":"https://static-cny.howxm.com/_next/static/media/avatar.9932331b.png","height":132,"width":132,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA3UlEQVR42mMAgSNHjjIyIIEDBw8ywTn37z8AS/7//5/p/v379s+ePpUE8Q8dPQZRtHXzJmYQvXPXrqUHDhz4v2fv3tdbtm2XAYld3bmCFawoJiFJPi8h4n+pl8bvoijv/2lJiSUMaGDK4srE/3fWT/15dHrd/1gHvadPds6NfbNvYQhMQUess+n/ldXJv6vDXf7Vxbj8f7xl6s1H22dHgmWbGxuctm7f8f/kyRN/9u0/8HfNqpX/Jy9cYcoAA/v376/dvXv3/+vXr/8+ePDg73379v8/dvRoLAMDAwMARjNsg/ZX6F8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/components/ui/Chart/useDarkMode.ts
var useDarkMode = __webpack_require__(7137);
;// CONCATENATED MODULE: ./src/components/business/SdkOnboarding/index.tsx








var SdkOnboarding = function(param) {
    var children = param.children;
    (0,plugins_crisp/* useCrisp */.L)();
    var darkMode = (0,useDarkMode/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        justify: "center",
        align: "flex-end",
        sx: function() {
            return {
                position: "fixed",
                bottom: 0,
                left: "252px",
                width: "100%",
                height: "405px",
                background: darkMode ? "linear-gradient(0deg, #25262B 0%, rgba(255, 255, 255, 0) 104.44%)" : "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 104.44%)"
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            px: "2xl",
            mb: "md",
            sx: function(theme) {
                return {
                    background: (0,getColor/* getBackgroundColor */.dF)("black", theme, "dark.8"),
                    width: 490,
                    height: 68,
                    border: "1px solid",
                    borderColor: (0,getColor/* getBorderColor */.kJ)("white", theme, "dark.4"),
                    boxShadow: theme.shadows.xs,
                    borderRadius: "56px",
                    transform: "translateX(-25%)"
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: avatar.src,
                        alt: "avatar",
                        width: 66,
                        height: 66
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
                        spacing: "xs",
                        children: children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var business_SdkOnboarding = (SdkOnboarding);

// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/FileButton/FileButton.js
var FileButton = __webpack_require__(68433);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconRotateClockwise.js
var IconRotateClockwise = __webpack_require__(36618);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconCloudUpload.js
var IconCloudUpload = __webpack_require__(3687);
// EXTERNAL MODULE: ./src/hooks/useUploadFile.ts
var useUploadFile = __webpack_require__(73309);
;// CONCATENATED MODULE: ./src/components/business/ImageUploader/index.tsx












var ACCEPT_DEFAULT = "image/png,image/jpeg,image/gif";
var MAXSIZE_DEFAULT = 2;
var ImageUploader = function(param) {
    var ownerId = param.ownerId, _maxSize = param.maxSize, maxSize = _maxSize === void 0 ? MAXSIZE_DEFAULT : _maxSize, _accept = param.accept, accept = _accept === void 0 ? ACCEPT_DEFAULT : _accept, tip = param.tip, value = param.value, onChange = param.onChange;
    var uploadFile = (0,useUploadFile/* default */.Z)();
    var t = (0,useTranslation/* default */.Z)("common").t;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var resetRef = (0,react.useRef)(null);
    var fileSettled = !!value;
    var getImageDimensions = function(image) {
        return new Promise(function(resolve, reject) {
            if (!image) {
                reject(new Error(t("imageUploader.dimensionsError")));
                return;
            }
            var url = URL.createObjectURL(image);
            var img = new Image();
            img.onload = function() {
                resolve({
                    height: img.height,
                    width: img.width
                });
                URL.revokeObjectURL(img.src);
            };
            img.onerror = function() {
                reject(new Error(t("imageUploader.error")));
            };
            img.src = url;
        });
    };
    var getImageBase64 = function(file) {
        return new Promise(function(resolve, reject) {
            if (!file) {
                reject(new Error(t("imageUploader.transImageError")));
                return;
            }
            var reader = new FileReader();
            reader.onloadend = function() {
                resolve(reader.result);
            };
            reader.readAsDataURL(file);
        });
    };
    var handleFileChange = function(file) {
        if (!file) {
            return;
        }
        var maxAllowedSize = maxSize * 1024 * 1024;
        if (file.size > maxAllowedSize) {
            var ref;
            ui/* message.error */.yw.error(t("imageUploader.maxSizeError", {
                size: maxSize
            }));
            (ref = resetRef.current) === null || ref === void 0 ? void 0 : ref.call(resetRef);
            return;
        }
        setLoading(true);
        uploadFile({
            ownerId: ownerId,
            fileInfo: {
                file: file
            },
            attachmentType: domain/* AttachmentType.Assets */.sfQ.Assets,
            onUploadCompleted: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(fileKey) {
                    var dimensions, tempUrl, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    getImageDimensions(file)
                                ];
                            case 1:
                                dimensions = _state.sent();
                                return [
                                    4,
                                    getImageBase64(file)
                                ];
                            case 2:
                                tempUrl = _state.sent();
                                onChange === null || onChange === void 0 ? void 0 : onChange((0,src_object_spread/* default */.Z)({
                                    url: tempUrl,
                                    storageKey: fileKey
                                }, dimensions));
                                setLoading(false);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                ui/* message.error */.yw.error(error.message);
                                setLoading(false);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(fileKey) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
    };
    var handleFileReset = function() {
        var ref;
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        (ref = resetRef.current) === null || ref === void 0 ? void 0 : ref.call(resetRef);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
        spacing: "sm",
        children: [
            !!tip && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                color: "dimmed",
                size: "xs",
                className: "whitespace-pre",
                children: tip
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                spacing: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FileButton/* FileButton */.S, {
                        onChange: handleFileChange,
                        accept: accept,
                        resetRef: resetRef,
                        children: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                                variant: "default",
                                loading: loading,
                                sx: {
                                    fontWeight: "normal"
                                },
                                leftIcon: fileSettled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRotateClockwise/* default */.Z, {
                                    size: 18,
                                    stroke: 1.5,
                                    className: "rotate-180"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCloudUpload/* default */.Z, {
                                    size: 18,
                                    stroke: 1.5
                                }),
                                children: t(loading ? "imageUploader.uploading" : fileSettled ? "imageUploader.reupload" : "imageUploader.upload")
                            }));
                        }
                    }),
                    fileSettled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: handleFileReset,
                        variant: "default",
                        sx: {
                            fontWeight: "normal"
                        },
                        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrash/* default */.Z, {
                            size: 18,
                            stroke: 1.5
                        }),
                        children: t("common:actions.delete")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var business_ImageUploader = (ImageUploader);

// EXTERNAL MODULE: ./src/components/business/ChannelPreview/index.tsx
var ChannelPreview = __webpack_require__(24023);
;// CONCATENATED MODULE: ./src/components/business/index.ts






















/***/ }),

/***/ 96536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(39747);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98558);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75686);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64405);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65895);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22108);
/* harmony import */ var components_business_ProductsModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7921);
/* harmony import */ var plugins_crisp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7897);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55075);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_business_subscription_useCheckFeatureAlert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(577);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95660);












var SubscriptionAlert = function(param) {
    var _collapsed = param.collapsed, collapsed = _collapsed === void 0 ? false : _collapsed;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("account").t;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .useMantineTheme */ .rZ)();
    var unavailableFeature = (0,components_business_subscription_useCheckFeatureAlert__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    if (!unavailableFeature) {
        return null;
    }
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        i18nKey: "account:subscription.free.tooltip.unavailable.".concat(unavailableFeature),
        components: {
            upgrade: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Anchor */ .e, {
                onClick: function() {
                    return (0,components_business_ProductsModal__WEBPACK_IMPORTED_MODULE_4__/* .openProductsModal */ .$P)(unavailableFeature);
                }
            }),
            crisp: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Anchor */ .e, {
                onClick: plugins_crisp__WEBPACK_IMPORTED_MODULE_5__/* .openCrisp */ .C
            }),
            account: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Anchor */ .e, {
                onClick: function() {
                    return next_router__WEBPACK_IMPORTED_MODULE_7___default().push(config_constants__WEBPACK_IMPORTED_MODULE_9__/* .SystemAccount */ .js);
                }
            })
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: collapsed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .HoverCard */ .z, {
            withinPortal: true,
            position: "bottom-start",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .HoverCard.Target */ .z.Target, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        size: 18,
                        color: "red",
                        stroke: 1.5,
                        className: "cursor-pointer"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .HoverCard.Dropdown */ .z.Dropdown, {
                    sx: {
                        borderRadius: theme.radius.sm,
                        maxWidth: 350
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                        children: content
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Alert */ .b, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                size: 18,
                color: "red",
                stroke: 1.5,
                className: "cursor-pointer"
            }),
            px: "lg",
            py: "md",
            variant: "light",
            color: "red",
            radius: 2,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_6__/* .getTextColor */ .uu)("red", theme),
                children: content
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SubscriptionAlert);


/***/ }),

/***/ 577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCheckFeatureAlert; }
});

// EXTERNAL MODULE: ./src/types/domain.ts + 2 modules
var domain = __webpack_require__(59845);
// EXTERNAL MODULE: ./src/utils/applicationUtils.ts
var applicationUtils = __webpack_require__(13090);
// EXTERNAL MODULE: ./src/components/business/index.ts + 206 modules
var business = __webpack_require__(91404);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./src/components/business/Layouts/ApplicationLayout/ApplicationContext.ts
var ApplicationContext = __webpack_require__(89863);
// EXTERNAL MODULE: ./src/components/business/hooks/useAccountSubscriptionCache.ts
var useAccountSubscriptionCache = __webpack_require__(19190);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isNil.js
var isNil = __webpack_require__(88966);
;// CONCATENATED MODULE: ./src/components/business/hooks/useCheckQuota.ts


function useCheckQuota(defaultForLoading) {
    var ref = (0,useAccountSubscriptionCache/* default */.Z)(), vasBalance = ref.vasBalance, loading = ref.loading;
    return function(feature, allowZero) {
        if (!(0,isNil/* default */.Z)(defaultForLoading) && loading) {
            return defaultForLoading;
        }
        if (allowZero) {
            return (vasBalance === null || vasBalance === void 0 ? void 0 : vasBalance[feature].balance) >= 0;
        }
        return (vasBalance === null || vasBalance === void 0 ? void 0 : vasBalance[feature].balance) > 0;
    };
}

;// CONCATENATED MODULE: ./src/components/business/subscription/useCheckFeatureAlert.ts






function useCheckFeatureAlert() {
    var application = (0,react.useContext)(ApplicationContext/* default */.Z).application;
    var checkFeature = (0,business/* useCheckFeature */.xu)(true);
    var checkQuota = useCheckQuota(true);
    if (!checkQuota(domain/* Feature.EntriesCount */.L0B.EntriesCount, false)) {
        return domain/* Feature.EntriesCount */.L0B.EntriesCount;
    }
    if ((0,applicationUtils/* isMobileDistribution */._Z)(application) && !checkFeature(domain/* Feature.AppApplication */.L0B.AppApplication)) {
        return domain/* Feature.AppApplication */.L0B.AppApplication;
    }
    if (!checkQuota(domain/* Feature.ApplicationsCount */.L0B.ApplicationsCount, true)) {
        return domain/* Feature.ApplicationsCount */.L0B.ApplicationsCount;
    }
}


/***/ }),

/***/ 23866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56674);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95202);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38335);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);





var ActionButton = function(param) {
    var children = param.children;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Menu */ .v, {
        shadow: "md",
        position: "bottom-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Target */ .v.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .ActionIcon */ .A, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        stroke: 2,
                        size: 14,
                        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.9", theme)
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Menu.Dropdown */ .v.Dropdown, {
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActionButton);


/***/ }),

/***/ 83347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HS": function() { return /* reexport */ Button_AddButton; },
  "xE": function() { return /* reexport */ Button_BackButton; },
  "w6": function() { return /* reexport */ Button_EditButton; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(33021);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(46550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72474);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(54594);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_@babel+core@7.18.6_react-dom@18.2.0_react@18.2.0_sass@1.54.9/node_modules/next/link.js
var next_link = __webpack_require__(19032);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+styles@6.0.13_@emotion+react@11.10.5_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(69777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(95202);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronLeft.js
var IconChevronLeft = __webpack_require__(50728);
// EXTERNAL MODULE: ./src/config/themeOverride/getColor.ts
var getColor = __webpack_require__(55075);
;// CONCATENATED MODULE: ./src/components/ui/Button/BackButton/index.tsx








var BackButton = function(props) {
    var href = props.href, actionIconProps = props.actionIconProps, iconProps = props.iconProps, onClick = props.onClick;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                component: "a"
            }, actionIconProps), {
                sx: {
                    ":hover": {
                        backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronLeft/* default */.Z, (0,_object_spread/* default */.Z)({
                    "data-test-id": "page-back",
                    size: 18,
                    stroke: 2,
                    color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
                }, iconProps))
            }))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            component: "a"
        }, actionIconProps), {
            onClick: onClick,
            sx: {
                ":hover": {
                    backgroundColor: (0,getColor/* getBackgroundColor */.dF)("gray.1", theme)
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChevronLeft/* default */.Z, (0,_object_spread/* default */.Z)({
                "data-test-id": "page-back",
                size: 18,
                stroke: 2,
                color: (0,getColor/* getTextColor */.uu)("gray.9", theme)
            }, iconProps))
        }))
    });
};
/* harmony default export */ var Button_BackButton = (BackButton);

// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconEdit.js
var IconEdit = __webpack_require__(51529);
;// CONCATENATED MODULE: ./src/components/ui/Button/EditButton/index.tsx





var EditButton = function(param) {
    var onClick = param.onClick;
    var theme = (0,MantineProvider/* useMantineTheme */.rZ)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconEdit/* default */.Z, {
            stroke: 1.5,
            size: 18,
            color: (0,getColor/* getTextColor */.uu)("gray.7", theme)
        })
    });
};
/* harmony default export */ var Button_EditButton = (EditButton);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(29848);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mantine+core@6.0.13_@emotion+react@11.10.5_@mantine+hooks@6.0.13_@types+react@18.0.18_react-dom@18.2.0_react@18.2.0/node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(34054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tabler+icons-react@2.42.0_react@18.2.0/node_modules/@tabler/icons-react/dist/esm/icons/IconPlus.js
var IconPlus = __webpack_require__(13644);
;// CONCATENATED MODULE: ./src/components/ui/Button/AddButton/index.tsx







var AddButton = function(props) {
    var text = props.text, onClick = props.onClick, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "text",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "subtle",
        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlus/* default */.Z, {
            size: 20,
            strokeWidth: 1.5
        }),
        onClick: onClick,
        styles: function(param) {
            var spacing = param.spacing;
            return {
                root: {
                    paddingLeft: spacing.sm,
                    paddingRight: spacing.sm
                }
            };
        }
    }, restProps), {
        children: text
    }));
};
/* harmony default export */ var Button_AddButton = (AddButton);

;// CONCATENATED MODULE: ./src/components/ui/Button/index.ts





/***/ }),

/***/ 45006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33021);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63332);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55075);




var XMDivider = function(props) {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_1__/* .getBorderColor */ .kJ)("gray.2", theme)
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (XMDivider);


/***/ }),

/***/ 43016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ItemNavigator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95202);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40848);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97547);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55075);





var ItemNavigator = function(props) {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .useMantineTheme */ .rZ)();
    var previousDisabled = props.previousDisabled, nextDisabled = props.nextDisabled, onPrevious = props.onPrevious, onNext = props.onNext;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
        spacing: 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .ActionIcon */ .A, {
                disabled: previousDisabled,
                onClick: onPrevious,
                variant: "outline",
                sx: {
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.7", theme),
                    borderColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBorderColor */ .kJ)("gray.2", theme),
                    borderRightWidth: 0,
                    borderBottomRightRadius: 0,
                    borderTopRightRadius: 0,
                    "&:focus": {
                        outlineWidth: 0
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .ActionIcon */ .A, {
                disabled: nextDisabled,
                onClick: onNext,
                variant: "outline",
                sx: {
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getTextColor */ .uu)("gray.7", theme),
                    borderColor: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_2__/* .getBorderColor */ .kJ)("gray.2", theme),
                    borderBottomLeftRadius: 0,
                    borderTopLeftRadius: 0,
                    "&:focus": {
                        outlineWidth: 0
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    size: 16
                })
            })
        ]
    });
};


/***/ }),

/***/ 76076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CK": function() { return /* binding */ Copy; },
/* harmony export */   "UH": function() { return /* binding */ QrCode; },
/* harmony export */   "c5": function() { return /* binding */ OpenInNewTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77292);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57155);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95202);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75686);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97684);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2000);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7861);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74078);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20230);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68885);






var Copy = function(param) {
    var url = param.url, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, _iconContainerSize = param.iconContainerSize, iconContainerSize = _iconContainerSize === void 0 ? "xs" : _iconContainerSize;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .CopyButton */ .q, {
        value: url,
        children: function(param) {
            var copied = param.copied, copy = param.copy;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
                label: copied ? t("message.duplicateSuccess") : t("componentCampaignList:deliveryUrl.copy"),
                withArrow: true,
                position: "bottom",
                withinPortal: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .ActionIcon */ .A, {
                    size: iconContainerSize,
                    color: copied ? "green" : "gray",
                    onClick: function(e) {
                        e.stopPropagation();
                        copy();
                    },
                    children: copied ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        size: iconSize,
                        stroke: 1.5
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        size: iconSize,
                        stroke: 1.5
                    })
                })
            });
        }
    });
};
var QrCode = function(param) {
    var url = param.url, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, _iconContainerSize = param.iconContainerSize, iconContainerSize = _iconContainerSize === void 0 ? "xs" : _iconContainerSize;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .HoverCard */ .z, {
        withArrow: true,
        withinPortal: true,
        position: "bottom",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .HoverCard.Target */ .z.Target, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .ActionIcon */ .A, {
                    size: iconContainerSize,
                    color: "gray",
                    onClick: function(e) {
                        e.stopPropagation();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        size: iconSize,
                        stroke: 1.5,
                        color: "gray"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .HoverCard.Dropdown */ .z.Dropdown, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Paper */ .X, {
                    p: "xs",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_3__/* .QRCodeSVG */ .tv, {
                        value: url,
                        size: 100,
                        display: "block"
                    })
                })
            })
        ]
    });
};
var OpenInNewTab = function(param) {
    var url = param.url, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, _iconContainerSize = param.iconContainerSize, iconContainerSize = _iconContainerSize === void 0 ? "xs" : _iconContainerSize;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
        label: t("componentCampaignList:deliveryUrl.open"),
        withArrow: true,
        position: "bottom",
        withinPortal: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .ActionIcon */ .A, {
            color: "gray",
            size: iconContainerSize,
            onClick: function(e) {
                e.stopPropagation();
                window.open(url, "_blank");
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                size: iconSize,
                stroke: 1.5
            })
        })
    });
};
var LinkActions = function(param) {
    var url = param.url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Group */ .Z, {
        spacing: "xs",
        noWrap: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Copy, {
                url: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QrCode, {
                url: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OpenInNewTab, {
                url: url
            })
        ]
    });
};
var LinkWithAction = function(param) {
    var url = param.url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Input */ .I, {
        styles: {
            wrapper: {
                minWidth: "340px"
            },
            rightSection: {
                right: 20
            }
        },
        value: url,
        readOnly: true,
        size: "xs",
        rightSection: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkActions, {
            url: url
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (LinkWithAction);


/***/ }),

/***/ 24645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ DefaultCell; },
/* harmony export */   "T": function() { return /* binding */ DateCell; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68711);
/* harmony import */ var _UrlWithTooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81369);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73046);





var DefaultCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    if ((0,utils__WEBPACK_IMPORTED_MODULE_3__/* .isUrl */ .CB)(renderedCellValue)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UrlWithTooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        url: renderedCellValue,
        includeProtocolAndHost: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
        lineClamp: 1,
        children: renderedCellValue
    });
};
var DateCell = function(param) {
    var renderedCellValue = param.renderedCellValue;
    if (!renderedCellValue) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
        children: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .formatISOTimeOrNull */ .y7)(renderedCellValue)
    });
};


/***/ }),

/***/ 88828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23526);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69777);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13192);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53196);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73268);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68711);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55075);






var TableEmpty = function() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .useMantineTheme */ .rZ)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Stack */ .K, {
        spacing: 0,
        align: "center",
        mt: 80,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .ThemeIcon */ .k, {
                radius: "xl",
                size: 48,
                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getBackgroundColor */ .dF)("gray.0", theme),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    size: 30,
                    color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.5", theme)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Title */ .D, {
                mt: "md",
                size: "sm",
                children: t("empty.tableEmpty")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                mt: "sm",
                color: (0,config_themeOverride_getColor__WEBPACK_IMPORTED_MODULE_3__/* .getTextColor */ .uu)("gray.7", theme),
                children: t("empty.filterDescription")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableEmpty);


/***/ }),

/***/ 79206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ TableFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76452);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18919);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4602);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73046);





var TableFooter = function(props) {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var page = props.page, totalPages = props.totalPages, totalCount = props.totalCount, onPageChange = props.onPageChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), jumpValue = ref[0], setJumpValue = ref[1];
    var handleJump = function() {
        if (typeof jumpValue !== "number") return;
        var target = Math.min(Math.max(1, Math.floor(jumpValue)), totalPages);
        if (target !== page) onPageChange(target);
        setJumpValue("");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
        align: "center",
        position: "apart",
        px: "lg",
        pb: "sm",
        children: [
            totalPages > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
                spacing: "lg",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Pagination */ .t, {
                        siblings: 1,
                        boundaries: 2,
                        size: "xs",
                        spacing: "xs",
                        value: page,
                        onChange: onPageChange,
                        total: totalPages
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Group */ .Z, {
                        spacing: 4,
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                size: "xs",
                                color: "dimmed",
                                children: t("common:grid.jumpToPagePrefix")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .NumberInput */ .Y, {
                                size: "xs",
                                hideControls: true,
                                precision: 0,
                                min: 1,
                                max: totalPages,
                                value: jumpValue,
                                onChange: setJumpValue,
                                onKeyDown: function(event) {
                                    if (event.key === "Enter") {
                                        event.preventDefault();
                                        handleJump();
                                    }
                                },
                                styles: {
                                    input: {
                                        width: 48,
                                        textAlign: "center",
                                        paddingLeft: 4,
                                        paddingRight: 4
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                size: "xs",
                                color: "dimmed",
                                children: t("common:grid.jumpToPageSuffix")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                color: "dimmed",
                size: "xs",
                children: t("common:grid.totalCount", {
                    total: totalCount ? (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .formatNumberToThousands */ .NZ)(totalCount) : "-"
                })
            })
        ]
    });
};


/***/ }),

/***/ 68749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ editPathMapping; },
/* harmony export */   "Z": function() { return /* binding */ entriesPathMapping; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17474);
/* harmony import */ var config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30482);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59845);



var _obj;
var editPathMapping = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignType.Survey */ .mL.Survey, config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationSurveyEdit */ .NP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignType.Feedback */ .mL.Feedback, config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationFeedbackEdit */ .WL), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignType.Notification */ .mL.Notification, config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationNotificationEdit */ .yP), _obj);
var _obj1;
var entriesPathMapping = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignType.Survey */ .mL.Survey, config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationSurveyEntries */ .Zl), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignType.Feedback */ .mL.Feedback, config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationFeedbackEntries */ .ry), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, types_domain__WEBPACK_IMPORTED_MODULE_1__/* .CampaignType.Notification */ .mL.Notification, config_constants_routerPath__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationNotificationEntries */ .LS), _obj1);


/***/ }),

/***/ 68123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ DROP_DOWN; },
/* harmony export */   "Dm": function() { return /* binding */ CES_FIELD; },
/* harmony export */   "Gg": function() { return /* binding */ submitOnCode; },
/* harmony export */   "H0": function() { return /* binding */ RADIO_BUTTON; },
/* harmony export */   "KU": function() { return /* binding */ ratingCode; },
/* harmony export */   "PI": function() { return /* binding */ RATING_FIELD; },
/* harmony export */   "PW": function() { return /* binding */ CTA_FIELD; },
/* harmony export */   "Rq": function() { return /* binding */ NPS_FIELD; },
/* harmony export */   "XH": function() { return /* binding */ AttributeFieldType; },
/* harmony export */   "__": function() { return /* binding */ keywordCode; },
/* harmony export */   "a9": function() { return /* binding */ refererCode; },
/* harmony export */   "cL": function() { return /* binding */ CHECK_BOX; },
/* harmony export */   "cn": function() { return /* binding */ SystemFilterableField; },
/* harmony export */   "gi": function() { return /* binding */ SELECTABLE_FIELDS; },
/* harmony export */   "h1": function() { return /* binding */ createdAtCode; },
/* harmony export */   "jC": function() { return /* binding */ deliveryMethodCode; },
/* harmony export */   "mM": function() { return /* binding */ TEXT_AREA; },
/* harmony export */   "pn": function() { return /* binding */ commentedCode; },
/* harmony export */   "uj": function() { return /* binding */ TEXT_FIELD; },
/* harmony export */   "v9": function() { return /* binding */ CSAT_FIELD; },
/* harmony export */   "wz": function() { return /* binding */ textareaCode; },
/* harmony export */   "yV": function() { return /* binding */ DATETIME_FIELD; },
/* harmony export */   "z3": function() { return /* binding */ REPORTABLE_FIELDS; }
/* harmony export */ });
var CHECK_BOX = "CheckBox";
var RADIO_BUTTON = "RadioButton";
var DROP_DOWN = "DropDown";
var TEXT_FIELD = "TextField";
var DATETIME_FIELD = "DateTimeField";
var TEXT_AREA = "TextArea";
var NPS_FIELD = "NpsField";
var CTA_FIELD = "CtaField";
var RATING_FIELD = "RatingField";
var CSAT_FIELD = "CsatField";
var CES_FIELD = "CesField";
var SELECTABLE_FIELDS = [
    CHECK_BOX,
    RADIO_BUTTON,
    DROP_DOWN,
    CTA_FIELD
];
var REPORTABLE_FIELDS = [
    NPS_FIELD,
    CSAT_FIELD,
    CES_FIELD,
    CHECK_BOX,
    RADIO_BUTTON,
    RATING_FIELD,
    CTA_FIELD, 
];
var AttributeFieldType;
(function(AttributeFieldType) {
    AttributeFieldType["DateTimeField"] = "DateTimeField";
    AttributeFieldType["TextField"] = "TextField";
})(AttributeFieldType || (AttributeFieldType = {}));
var SystemFilterableField;
(function(SystemFilterableField) {
    SystemFilterableField["SubmittedOn"] = "entry.submitted_on";
    SystemFilterableField["Referer"] = "entry.referer";
    SystemFilterableField["Commented"] = "entry.$commented";
    SystemFilterableField["DeliveryMethod"] = "entry.delivery_method";
})(SystemFilterableField || (SystemFilterableField = {}));
var ratingCode = "field_1";
var textareaCode = "field_2";
var submitOnCode = "submitted_on";
var deliveryMethodCode = "delivery_method";
var createdAtCode = "created_at";
var refererCode = "referer";
var keywordCode = "$keyword";
var commentedCode = "$commented";


/***/ }),

/***/ 52762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ paidProductCodes; },
/* harmony export */   "G": function() { return /* binding */ ProductCode; }
/* harmony export */ });
var ProductCode;
(function(ProductCode) {
    ProductCode["Free"] = "free";
    ProductCode["Basic"] = "basic";
    ProductCode["Pro"] = "pro";
    ProductCode["Ultimate"] = "ultimate";
    ProductCode["Trial"] = "trial";
})(ProductCode || (ProductCode = {}));
var paidProductCodes = [
    ProductCode.Basic,
    ProductCode.Pro,
    ProductCode.Ultimate
];


/***/ }),

/***/ 73309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUploadFile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25328);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29718);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59845);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22108);




function useUploadFile() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,types_domain__WEBPACK_IMPORTED_MODULE_1__/* .useCreateAttachmentUploadOptionsMutation */ .Tsc)(), 1), createAttachmentUploadOptionsMutation = ref[0];
    return function(param) {
        var ownerId = param.ownerId, fileInfo = param.fileInfo, attachmentType = param.attachmentType, onUploadCompleted = param.onUploadCompleted, onProcessChange = param.onProcessChange;
        var ref;
        createAttachmentUploadOptionsMutation({
            variables: {
                input: {
                    type: attachmentType,
                    fileName: fileInfo === null || fileInfo === void 0 ? void 0 : (ref = fileInfo.file) === null || ref === void 0 ? void 0 : ref.name,
                    ownerId: ownerId
                }
            },
            onCompleted: function(data) {
                if (!(data === null || data === void 0 ? void 0 : data.createAttachmentUploadOptions)) {
                    components_ui__WEBPACK_IMPORTED_MODULE_0__/* .message.error */ .yw.error(t("message.uploadError"));
                    return;
                }
                var fileKey = data.createAttachmentUploadOptions.key;
                var url = data.createAttachmentUploadOptions.url;
                var xhr = new XMLHttpRequest();
                xhr.open("PUT", url, true);
                var file = fileInfo.file;
                var extname = file.name.split(".").pop();
                switch(extname){
                    case "xls":
                        xhr.setRequestHeader("Content-Type", "application/vnd.ms-excel");
                        break;
                    case "xlsx":
                        xhr.setRequestHeader("Content-Type", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                        break;
                    default:
                        xhr.setRequestHeader("Content-Type", file.type);
                }
                xhr.upload.onprogress = function(e) {
                    if (e.total > 0) {
                        var percent = e.loaded / e.total * 100;
                        onProcessChange === null || onProcessChange === void 0 ? void 0 : onProcessChange({
                            percent: percent
                        });
                        percent === 100 && (onUploadCompleted === null || onUploadCompleted === void 0 ? void 0 : onUploadCompleted(fileKey));
                    }
                };
                xhr.onerror = function() {
                    components_ui__WEBPACK_IMPORTED_MODULE_0__/* .message.error */ .yw.error(t("message.uploadError"));
                };
                xhr.send(file);
            },
            onError: function(error) {
                components_ui__WEBPACK_IMPORTED_MODULE_0__/* .message.error */ .yw.error(t("message.uploadError"));
            }
        }).then();
    };
}


/***/ }),

/***/ 42771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ defaultFormData; },
/* harmony export */   "eJ": function() { return /* binding */ FEEDBACK_RATING_FIELD_CODE; },
/* harmony export */   "ts": function() { return /* binding */ FEEDBACK_TEXT_AREA_CODE; },
/* harmony export */   "xQ": function() { return /* binding */ getDefaultFeedbackWidgetSetting; }
/* harmony export */ });
/* harmony import */ var components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89433);
/* harmony import */ var components_business_CampaignBuilder_Distribution_When_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13625);
/* harmony import */ var components_business_CampaignBuilder_utils_getWidgetPosition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7695);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59845);
/* harmony import */ var utils_tempCode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78360);





var FEEDBACK_RATING_FIELD_CODE = "field_1";
var FEEDBACK_TEXT_AREA_CODE = "field_2";
var getWidgetType = function(channel) {
    switch(channel){
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Android */ .wQf.Android:
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift:
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp:
            return types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetType.Popup */ .YMh.Popup;
        case types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web:
            return types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetType.Button */ .YMh.Button;
        default:
            return types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetType.Button */ .YMh.Button;
    }
};
function getDefaultFeedbackWidgetSetting() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web;
    return {
        position: (0,components_business_CampaignBuilder_utils_getWidgetPosition__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(channel),
        type: getWidgetType(channel),
        colorScheme: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultColorScheme */ .yi,
        customizedPosition: {
            align: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .Align.Right */ .xMy.Right,
            percentageToTop: 60
        },
        setting: {
            autoOpen: false,
            buttonType: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetButtonType.Aside */ .UUk.Aside,
            icon: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignWidgetIcon.Comment */ .YQl.Comment,
            label: "请给我们评分"
        },
        width: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultWidgetWidth */ .hU[types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignType.Feedback */ .mL.Feedback]
    };
}
var defaultFormData = function() {
    var channel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web, screenshotsEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        name: "未命名评价",
        type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignType.Feedback */ .mL.Feedback,
        enabled: false,
        formFields: [
            {
                code: (0,utils_tempCode__WEBPACK_IMPORTED_MODULE_4__/* .getTempCode */ .jg)(),
                label: "您如何评价当前的体验？",
                ratingMax: 5,
                ratingMaxDescription: "非常满意",
                ratingMinDescription: "非常不满意",
                ratingType: "star",
                page: 0,
                type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FormFieldType.RatingField */ .EIl.RatingField,
                hidden: false,
                labelHidden: false,
                validators: [
                    {
                        type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FieldValidatorType.Presence */ .GT9.Presence
                    }
                ]
            },
            {
                code: (0,utils_tempCode__WEBPACK_IMPORTED_MODULE_4__/* .getTempCode */ .jg)(),
                label: "请说明满意或不满意的原因",
                page: 1,
                type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FormFieldType.TextArea */ .EIl.TextArea,
                hidden: false,
                labelHidden: false,
                screenshotsEnabled: channel == types_domain__WEBPACK_IMPORTED_MODULE_3__/* .CampaignDistributionChannel.Web */ .wQf.Web && screenshotsEnabled
            },
            {
                code: (0,utils_tempCode__WEBPACK_IMPORTED_MODULE_4__/* .getTempCode */ .jg)(),
                label: "提交成功",
                page: 2,
                type: types_domain__WEBPACK_IMPORTED_MODULE_3__/* .FormFieldType.EndingField */ .EIl.EndingField,
                content: "感谢您的评价！",
                setting: {
                    endingContent: "感谢您的评价！"
                },
                hidden: false,
                labelHidden: false
            }, 
        ],
        formSetting: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultFormSetting */ .wH,
        widget: getDefaultFeedbackWidgetSetting(channel),
        targeting: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultTargeting */ .jp,
        trigger: {
            conditions: [],
            operator: components_business_CampaignBuilder_Distribution_When_constant__WEBPACK_IMPORTED_MODULE_1__/* .defaultTriggerOperator */ .zH
        },
        openStrategy: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultOpenStrategy */ .uP,
        localeSetting: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultLocaleSetting */ .CC,
        schedule: components_business_CampaignBuilder__WEBPACK_IMPORTED_MODULE_0__/* .defaultSchedule */ .r4
    };
};


/***/ }),

/***/ 1778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCreateFeedback; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17192);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25328);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33481);
/* harmony import */ var components_business__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91404);
/* harmony import */ var components_business_CampaignBuilder_utils_getCampaignInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60129);
/* harmony import */ var components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51945);
/* harmony import */ var components_business_hooks_useCampaignsCountCache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47820);
/* harmony import */ var components_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29718);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95660);
/* harmony import */ var modules_Application_Feedback_Builder_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42771);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22108);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54594);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59845);
/* harmony import */ var components_business_Campaign_hooks_useGroupCache__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56941);

















function useCreateFeedback() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("common").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var channel = (0,components_business_hooks_useApplicationInfoBaseInfoCache__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().channel;
    var screenshotsEnabled = (0,components_business__WEBPACK_IMPORTED_MODULE_0__/* .useCheckFeature */ .xu)()(types_domain__WEBPACK_IMPORTED_MODULE_10__/* .Feature.ScreenshotField */ .L0B.ScreenshotField);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,types_domain__WEBPACK_IMPORTED_MODULE_10__/* .useCreateCampaignMutation */ .AL$)(), 1), createMutation = ref[0];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var increase = (0,components_business_hooks_useCampaignsCountCache__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(types_domain__WEBPACK_IMPORTED_MODULE_10__/* .CampaignType.Feedback */ .mL.Feedback).increase;
    var getDefaultGroup = (0,components_business_Campaign_hooks_useGroupCache__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().getDefaultGroup;
    var createFeedback = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
            var initialFormData, input, ref, data, campaignId, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        initialFormData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, (0,modules_Application_Feedback_Builder_constants__WEBPACK_IMPORTED_MODULE_6__/* .defaultFormData */ .L7)(channel, screenshotsEnabled));
                        input = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, (0,components_business_CampaignBuilder_utils_getCampaignInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(initialFormData)), {
                            applicationId: router.query.appId,
                            groupId: getDefaultGroup(types_domain__WEBPACK_IMPORTED_MODULE_10__/* .CampaignType.Feedback */ .mL.Feedback)
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            6,
                            7
                        ]);
                        setLoading(true);
                        return [
                            4,
                            createMutation({
                                variables: {
                                    input: input
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        campaignId = data === null || data === void 0 ? void 0 : (ref = data.createCampaign) === null || ref === void 0 ? void 0 : ref.id;
                        if (!campaignId) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            router.push({
                                pathname: config_constants__WEBPACK_IMPORTED_MODULE_5__/* .ApplicationFeedbackEdit.replace */ .WL.replace("[appId]", router.query.appId).replace("[campaignId]", campaignId)
                            }).then(function() {
                                components_ui__WEBPACK_IMPORTED_MODULE_4__/* .message.successMsg */ .yw.successMsg("".concat(t("actions.create")).concat(t("message.success")));
                                increase();
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        e = _state.sent();
                        components_ui__WEBPACK_IMPORTED_MODULE_4__/* .message.error */ .yw.error("".concat(t("actions.create")).concat(t("message.failed")));
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function createFeedback() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        loading: loading,
        createFeedback: createFeedback
    };
}


/***/ }),

/***/ 19892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17192);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33021);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46550);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29848);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25328);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33481);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72474);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68711);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98558);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34054);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59845);
/* harmony import */ var components_ui_Geetest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12686);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73046);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33892);













var timer;
var Sender = function(props) {
    var dateId = props.dateId, tmp = props.countDown, countDownProp = tmp === void 0 ? 60 : tmp, captchaType = props.captchaType, getValidIdentifier = props.getValidIdentifier, onError = props.onError, onSend = props.onSend, getCountDownText = props.getCountDownText, defaultText = props.defaultText, _displayType = props.displayType, displayType = _displayType === void 0 ? "button" : _displayType, disabled = props.disabled, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, [
        "dateId",
        "countDown",
        "captchaType",
        "getValidIdentifier",
        "onError",
        "onSend",
        "getCountDownText",
        "defaultText",
        "displayType",
        "disabled"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), countDown = ref[0], setCountDown = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,types_domain__WEBPACK_IMPORTED_MODULE_2__/* .useSendCaptchaMutation */ .cZC)(), 1), sendCaptchaMutation = ref1[0];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,types_domain__WEBPACK_IMPORTED_MODULE_2__/* .useGeetestConfigurationLazyQuery */ .g_E)({
        fetchPolicy: "no-cache"
    }), 2), getGeetestConfiguration = ref2[0], captchaConfigurationRes = ref2[1];
    var identifierRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getGeetestConfiguration().then();
    //  eslint-disable-next-line
    }, []);
    var handleSendCode = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(captcha) {
            var error, graphQLErrors, defaultErrorHandler;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            sendCaptchaMutation({
                                variables: {
                                    input: {
                                        identifier: identifierRef.current,
                                        type: captchaType,
                                        geetestInfo: captcha && (0,components_ui_Geetest__WEBPACK_IMPORTED_MODULE_9__/* .getGeetestResult */ .o)(captcha)
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        timer && clearInterval(timer);
                        timer = setInterval(function() {
                            return setCountDown(function(countDown) {
                                return countDown > 0 ? countDown - 1 : 0;
                            });
                        }, 1000);
                        setCountDown(countDownProp);
                        utils__WEBPACK_IMPORTED_MODULE_3__/* .Storage.setItem */ .Ke.setItem(dateId, {
                            date: "".concat(new Date().valueOf())
                        });
                        onSend === null || onSend === void 0 ? void 0 : onSend();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        graphQLErrors = error.graphQLErrors;
                        defaultErrorHandler = function() {
                            (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .graphqlErrorCatch */ .Qf)({
                                graphQLErrors: graphQLErrors,
                                mapping: new Map([
                                    [
                                        "error.frequent",
                                        "验证码请求太频繁，请稍后重试"
                                    ]
                                ]),
                                defaultMessage: "验证码获取失败"
                            });
                        };
                        onError ? onError(graphQLErrors, defaultErrorHandler) : defaultErrorHandler();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendCode(captcha) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGeetest */ .ol)(handleSendCode, captchaConfigurationRes), 2), captcha = ref3[0], captchaConfiguration = ref3[1];
    var handleButtonClick = function() {
        getValidIdentifier().then(function(value) {
            identifierRef.current = value;
            if (captchaConfiguration === null || captchaConfiguration === void 0 ? void 0 : captchaConfiguration.enabled) {
                captcha === null || captcha === void 0 ? void 0 : captcha.showBox();
            } else {
                handleSendCode(null).then();
            }
        }).catch(function() {});
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var now = new Date().valueOf();
        var lastTime = parseInt(((ref = utils__WEBPACK_IMPORTED_MODULE_3__/* .Storage.getItem */ .Ke.getItem(dateId)) === null || ref === void 0 ? void 0 : ref.date) || "0", 10);
        var gap = Math.round((now - lastTime) / 1000);
        if (gap < countDownProp) {
            timer = setInterval(function() {
                return setCountDown(function(countDown) {
                    return countDown > 0 ? countDown - 1 : 0;
                });
            }, 1000);
            setCountDown(countDownProp - gap);
        } else {
            setCountDown(0);
        }
        return function() {
            return clearInterval(timer);
        };
    // eslint-disable-next-line
    }, []);
    var ref4;
    var text = countDown ? (ref4 = getCountDownText === null || getCountDownText === void 0 ? void 0 : getCountDownText(countDown)) !== null && ref4 !== void 0 ? ref4 : "".concat(countDown, "s 后重发") : defaultText !== null && defaultText !== void 0 ? defaultText : "获取验证码";
    if (displayType === "link") {
        var color = buttonProps.color, size = buttonProps.size;
        return countDown ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
            color: color,
            size: size,
            styles: {
                display: "inline"
            },
            children: text
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Anchor */ .e, {
            size: size,
            onClick: handleButtonClick,
            children: text
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        fullWidth: true
    }, buttonProps), {
        disabled: disabled || !!countDown,
        onClick: handleButtonClick,
        children: text
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Sender);


/***/ }),

/***/ 16312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isCacheHit; }
/* harmony export */ });
/* unused harmony export updateCache */
/* harmony import */ var plugins_apollo_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3745);

var isCacheHit = function(variables, queryDocument) {
    var client = (0,plugins_apollo_index__WEBPACK_IMPORTED_MODULE_0__/* .initializeApollo */ ["in"])();
    var complete = client.cache.diff({
        query: client.cache.transformDocument(queryDocument),
        variables: variables,
        optimistic: false
    }).complete;
    return !!complete;
};
var updateCache = function(variables, queryDocument, data) {
    var client = initializeApollo();
    var query = client.cache.transformDocument(queryDocument);
    client.cache.writeQuery({
        query: query,
        data: data,
        variables: variables
    });
};


/***/ }),

/***/ 7897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ openCrisp; },
/* harmony export */   "L": function() { return /* binding */ useCrisp; }
/* harmony export */ });
/* harmony import */ var crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54594);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77759);



function identifyCurrentUser(user) {
    var ref, ref1;
    var _email;
    var email = (_email = user.email) !== null && _email !== void 0 ? _email : "".concat(user.mobile, "@howxm.com");
    var accountName = (ref = user.accountUser) === null || ref === void 0 ? void 0 : (ref1 = ref.account) === null || ref1 === void 0 ? void 0 : ref1.name;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.session.setData */ .fv.session.setData({
        user_id: user.id,
        name: user.name,
        account: accountName,
        mobile: user.mobile
    });
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.user.setEmail */ .fv.user.setEmail(email);
    var ref2;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.user.setNickname */ .fv.user.setNickname((ref2 = user === null || user === void 0 ? void 0 : user.name) !== null && ref2 !== void 0 ? ref2 : "");
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.user.setCompany */ .fv.user.setCompany(accountName !== null && accountName !== void 0 ? accountName : "", {});
    var ref3;
    crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.user.setPhone */ .fv.user.setPhone((ref3 = user === null || user === void 0 ? void 0 : user.mobile) !== null && ref3 !== void 0 ? ref3 : "");
}
function useCrisp() {
    var autoload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var user = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().user;
    var crispId = "00e1090b-f176-44f3-9ff7-e593fe7ca5ca";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (crispId) {
            crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.configure */ .fv.configure(crispId, {
                autoload: false
            });
            if (autoload) {
                var ref;
                (ref = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.chat */ .fv.chat) === null || ref === void 0 ? void 0 : ref.show();
            }
        }
        return function() {
            if (crispId) {
                var ref;
                (ref = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.chat */ .fv.chat) === null || ref === void 0 ? void 0 : ref.hide();
            }
        };
    }, [
        autoload,
        crispId
    ]);
    if (user) {
        identifyCurrentUser(user);
    }
}
function openCrisp() {
    var ref;
    (ref = crisp_sdk_web__WEBPACK_IMPORTED_MODULE_0__/* .Crisp.chat */ .fv.chat) === null || ref === void 0 ? void 0 : ref.open();
}


/***/ }),

/***/ 25474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var howxm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13528);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77759);
/* harmony import */ var components_business_hooks_useAccountSubscriptionCache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73654);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);





var sdkHostMapping = {
    dev: "http://localhost:4000/umd",
    usd: "https://static-usd.howxm.com",
    cny: "https://static-cny.howxm.com",
    prod: "https://static.howxm.com"
};
var useHowxmSDK = function(appId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), howxmSdkReady = ref[0], setHowxmSdkReady = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var subscription = (0,components_business_hooks_useAccountSubscriptionCache__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().subscription;
    var user = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().user;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (appId && localStorage) {
            var sdkEnv = localStorage.getItem("sdkEnv") || "prod";
            var sdkUrl = "".concat(sdkHostMapping[sdkEnv], "/sdk.js");
            (0,howxm_js__WEBPACK_IMPORTED_MODULE_1__/* .initHowxmWithCustomSdkUrl */ ._e)(appId, sdkUrl, function() {
                setHowxmSdkReady(true);
            });
        }
    }, [
        appId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        identify(user);
    }, [
        user,
        router
    ]);
    var identify = function(user) {
        var ref;
        if (!howxmSdkReady || !user) {
            return;
        }
        var uid = user.id, email = user.email, name = user.name, mobile = user.mobile, accountUser = user.accountUser, createdAt = user.createdAt;
        var accountId = (accountUser === null || accountUser === void 0 ? void 0 : (ref = accountUser.account) === null || ref === void 0 ? void 0 : ref.id) || "";
        var ref1;
        (0,howxm_js__WEBPACK_IMPORTED_MODULE_1__/* .identifyHowxm */ .Lo)({
            uid: uid,
            email: email || "",
            name: name || "",
            mobile: mobile || "",
            account_id: accountId,
            registered_at: new Date(createdAt).toISOString(),
            subscription: (ref1 = subscription === null || subscription === void 0 ? void 0 : subscription.productCode) !== null && ref1 !== void 0 ? ref1 : "",
            banner_link: "".concat("https://app-cny.howxm.com", "/banner/accounts/").concat(accountId),
            last_seen_at: new Date().toISOString()
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useHowxmSDK);


/***/ }),

/***/ 98926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLogRocket; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54594);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16778);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(logrocket__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77759);
/* provided dependency */ var process = __webpack_require__(68607);



function useLogRocket() {
    var user = (0,components_business_hooks_useCurrentUserCache__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().user;
    var logRocketId = process.env.NEXT_PUBLIC_LOGROCKET_ID;
    var shouldTrack = logRocketId && (user === null || user === void 0 ? void 0 : user.createdAt) && new Date(user === null || user === void 0 ? void 0 : user.createdAt) > new Date(2023, 6, 1);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (shouldTrack) {
            logrocket__WEBPACK_IMPORTED_MODULE_1___default().init(logRocketId);
        }
    }, [
        logRocketId,
        shouldTrack
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref;
        if (!user) {
            return;
        }
        var id = user.id, name = user.name, accountUser = user.accountUser;
        logrocket__WEBPACK_IMPORTED_MODULE_1___default().identify(id, {
            name: name || "",
            accountName: (accountUser === null || accountUser === void 0 ? void 0 : (ref = accountUser.account) === null || ref === void 0 ? void 0 : ref.name) || ""
        });
    }, [
        user
    ]);
    return {
        shouldTrack: shouldTrack
    };
}


/***/ }),

/***/ 13090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RV": function() { return /* binding */ isWebDistribution; },
/* harmony export */   "_Z": function() { return /* binding */ isMobileDistribution; },
/* harmony export */   "cN": function() { return /* binding */ getDistributionChannelGroup; },
/* harmony export */   "dQ": function() { return /* binding */ isLinkDistribution; },
/* harmony export */   "kA": function() { return /* binding */ isMiniappDistribution; },
/* harmony export */   "kS": function() { return /* binding */ canUpdateApplication; },
/* harmony export */   "ll": function() { return /* binding */ isApplicationStatusNormal; },
/* harmony export */   "pC": function() { return /* binding */ isAppDistribution; }
/* harmony export */ });
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);

var isApplicationStatusNormal = function(pingedAt) {
    if (!pingedAt) {
        return false;
    }
    var now = new Date();
    var diff = now.getTime() - new Date(pingedAt).getTime();
    return diff < 1000 * 60 * 60 * 72;
};
var isMiniappDistribution = function(application) {
    if (!application) {
        return false;
    }
    return application.distribution.channel === types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp;
};
var mobileDistributionChannels = [
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Android */ .wQf.Android,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp, 
];
var isMobileDistribution = function(application) {
    if (!application) {
        return false;
    }
    return mobileDistributionChannels.includes(application.distribution.channel);
};
var isLinkDistribution = function(application) {
    if (!application) {
        return false;
    }
    return application.distribution.channel == types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Link */ .wQf.Link;
};
var isWebDistribution = function(application) {
    if (!application) {
        return false;
    }
    return types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Web */ .wQf.Web === application.distribution.channel;
};
var appDistributionChannels = [
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Android */ .wQf.Android,
    types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift
];
var isAppDistribution = function(application) {
    if (!application) {
        return false;
    }
    return appDistributionChannels.includes(application.distribution.channel);
};
var getDistributionChannelGroup = function(channel) {
    switch(channel){
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Web */ .wQf.Web:
            return "web";
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.IosSwift */ .wQf.IosSwift:
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Android */ .wQf.Android:
            return "mobileApp";
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.WechatMiniapp */ .wQf.WechatMiniapp:
            return "miniapp";
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignDistributionChannel.Link */ .wQf.Link:
            return "link";
    }
};
var canUpdateApplication = function(application) {
    var ref;
    return application === null || application === void 0 ? void 0 : (ref = application.role) === null || ref === void 0 ? void 0 : ref.permissions.includes(types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ApplicationPermission.ApplicationUpdate */ .eC6.ApplicationUpdate);
};


/***/ }),

/***/ 10806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDefaultTableConfig; }
/* harmony export */ });
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21409);
/* harmony import */ var mantine_react_table_locales_zh_Hans__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57547);


var defaultTableConfig = {
    localization: mantine_react_table_locales_zh_Hans__WEBPACK_IMPORTED_MODULE_0__/* .MRT_Localization_ZH_HANS */ .k,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableHiding: false,
    mantineLoadingOverlayProps: {
        zIndex: 200
    },
    mantineTableContainerProps: {
        sx: {
            height: "100%"
        }
    },
    initialState: {
        density: "xs"
    },
    mantinePaperProps: {
        withBorder: false,
        radius: 0,
        sx: {
            height: "100%"
        }
    },
    mantineTableProps: {
        sx: {
            tableLayout: "fixed"
        }
    },
    mantineTableBodyRowProps: function() {
        return {
            className: "group"
        };
    }
};
function getDefaultTableConfig() {
    return (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTableConfig);
}


/***/ }),

/***/ 22857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getConditionValid; }
/* harmony export */ });
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);
/* harmony import */ var components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14418);


var getConditionValid = function(condition) {
    if (!condition.operator) {
        return false;
    }
    switch(condition.operator){
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.IsNull */ .N0$.IsNull:
        case types_domain__WEBPACK_IMPORTED_MODULE_0__/* .ConditionOperator.IsNotNull */ .N0$.IsNotNull:
        case components_business_Filter_DefaultFilter_Conditions_Operator_getOperatorOptions__WEBPACK_IMPORTED_MODULE_1__/* .Mine */ .zn:
            return true;
        default:
            var ref;
            var secondNodeValue = (ref = condition.secondNode) === null || ref === void 0 ? void 0 : ref.value;
            return !!secondNodeValue || secondNodeValue === 0;
    }
};


/***/ }),

/***/ 45559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JV": function() { return /* binding */ typeIconMapping; },
/* harmony export */   "gN": function() { return /* binding */ reservedFieldIconMapping; },
/* harmony export */   "o4": function() { return /* binding */ formFieldIconMapping; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17474);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95660);
/* harmony import */ var config_constants_fieldType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68123);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59845);




var formFieldIconMapping = function(theme) {
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.NpsField */ .EIl.NpsField, {
        iconName: "nps",
        bg: theme.colors.teal[3],
        iconColor: "#004537"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.CsatField */ .EIl.CsatField, {
        iconName: "csat",
        bg: theme.colors.red[3],
        iconColor: "#87121D"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.CesField */ .EIl.CesField, {
        iconName: "ces",
        bg: theme.colors.green[3],
        iconColor: "#0E4D20"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.RadioButton */ .EIl.RadioButton, {
        iconName: "radio",
        bg: theme.colors.cyan[3],
        iconColor: "#003C4D"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.CheckBox */ .EIl.CheckBox, {
        iconName: "checkbox",
        bg: theme.colors.indigo[3],
        iconColor: "#111C82"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.TextArea */ .EIl.TextArea, {
        iconName: "textArea",
        bg: theme.colors.blue[3],
        iconColor: "#003273"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.TextField */ .EIl.TextField, {
        iconName: "textField",
        bg: theme.colors.yellow[3],
        iconColor: "#483C09"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.EndingField */ .EIl.EndingField, {
        iconName: "ending",
        bg: theme.colors.gray[1],
        iconColor: theme.colors.gray[7]
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.RatingField */ .EIl.RatingField, {
        iconName: "rating",
        bg: theme.colors.orange[3],
        iconColor: "#8A3000"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.WelcomeField */ .EIl.WelcomeField, {
        iconName: "welcome",
        bg: theme.colors.gray[1],
        iconColor: theme.colors.gray[7]
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.DescriptionField */ .EIl.DescriptionField, {
        iconName: "description",
        bg: theme.colors.pink[3],
        iconColor: "#A11344"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FormFieldType.CtaField */ .EIl.CtaField, {
        iconName: "cta",
        bg: theme.colors.cyan[3],
        iconColor: "#003C4D"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, config_constants__WEBPACK_IMPORTED_MODULE_0__/* .NEXT_FIELD */ .bg, {
        iconName: "arrowAutofitDown",
        bg: theme.colors.gray[1],
        iconColor: theme.colors.gray[7]
    }), _obj;
};
var reservedFieldIconMapping = function(theme) {
    return {
        "entry.createdAt": {
            iconName: "calendar",
            bg: theme.colors.brandBlue[3],
            iconColor: theme.colors.brandBlue[9]
        },
        "entry.fillingDuration": {
            iconName: "time",
            bg: theme.colors.teal[3],
            iconColor: theme.colors.teal[9]
        },
        "entry.submittedOn": {
            iconName: "upCloud",
            bg: theme.colors.pink[3],
            iconColor: theme.colors.pink[9]
        },
        "entry.submitted_on": {
            iconName: "upCloud",
            bg: theme.colors.pink[3],
            iconColor: theme.colors.pink[9]
        },
        "entry.region": {
            iconName: "map",
            bg: theme.colors.cyan[3],
            iconColor: theme.colors.cyan[9]
        },
        "entry.browser": {
            iconName: "browser",
            bg: theme.colors.green[3],
            iconColor: theme.colors.green[9]
        },
        "entry.screenResolution": {
            iconName: "resolution",
            bg: theme.colors.violet[3],
            iconColor: theme.colors.violet[9]
        },
        "entry.ip": {
            iconName: "earth",
            bg: theme.colors.yellow[3],
            iconColor: theme.colors.yellow[9]
        },
        "entry.referer": {
            iconName: "signPaper",
            bg: theme.colors.indigo[3],
            iconColor: theme.colors.indigo[9]
        },
        "entry.os": {
            iconName: "os",
            bg: theme.colors.orange[3],
            iconColor: theme.colors.orange[9]
        },
        "entry.deliveryMethod": {
            iconName: "affiliate",
            bg: theme.colors.lime[3],
            iconColor: theme.colors.lime[9]
        },
        "entry.delivery_method": {
            iconName: "affiliate",
            bg: theme.colors.lime[3],
            iconColor: theme.colors.lime[9]
        },
        "entry.$commented": {
            iconName: "commented",
            bg: theme.colors.orange[3],
            iconColor: theme.colors.orange[9]
        },
        customer_mobile: {
            iconName: "mobile",
            bg: theme.colors.blue[3],
            iconColor: theme.colors.blue[9]
        },
        mobile: {
            iconName: "mobile",
            bg: theme.colors.blue[3],
            iconColor: theme.colors.blue[9]
        },
        customer_email: {
            iconName: "email",
            bg: theme.colors.lime[3],
            iconColor: theme.colors.lime[9]
        },
        email: {
            iconName: "email",
            bg: theme.colors.lime[3],
            iconColor: theme.colors.lime[9]
        },
        customer_name: {
            iconName: "user",
            bg: theme.colors.brandBlue[3],
            iconColor: theme.colors.brandBlue[9]
        },
        name: {
            iconName: "user",
            bg: theme.colors.brandBlue[3],
            iconColor: theme.colors.brandBlue[9]
        },
        customer_uid: {
            iconName: "uid",
            bg: theme.colors.red[3],
            iconColor: theme.colors.red[9]
        },
        uid: {
            iconName: "uid",
            bg: theme.colors.red[3],
            iconColor: theme.colors.red[9]
        }
    };
};
var typeIconMapping = function(theme) {
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_2__/* .FieldType.DateTime */ .fSu.DateTime, {
        iconName: "dateTime",
        bg: theme.colors.teal[3],
        iconColor: theme.colors.teal[9]
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, config_constants_fieldType__WEBPACK_IMPORTED_MODULE_1__/* .AttributeFieldType.DateTimeField */ .XH.DateTimeField, {
        iconName: "dateTime",
        bg: theme.colors.teal[3],
        iconColor: theme.colors.teal[9]
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, config_constants_fieldType__WEBPACK_IMPORTED_MODULE_1__/* .AttributeFieldType.TextField */ .XH.TextField, {
        iconName: "info",
        bg: theme.colors.cyan[3],
        iconColor: theme.colors.cyan[9]
    }), _obj;
};


/***/ }),

/***/ 6371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getXFormUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17474);
/* harmony import */ var types_domain__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59845);


var _obj;
var xFormPrefixMapping = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignType.Feedback */ .mL.Feedback, "xf"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignType.Survey */ .mL.Survey, "xs"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, types_domain__WEBPACK_IMPORTED_MODULE_0__/* .CampaignType.Notification */ .mL.Notification, "xn"), _obj);
var getXFormUrl = function(token, type, isUrlVisit) {
    var baseUrl = "https://f-cny.howxm.com";
    return "".concat(baseUrl, "/").concat(xFormPrefixMapping[type]).concat(isUrlVisit ? "/u" : "", "/").concat(token);
};


/***/ }),

/***/ 78360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L3": function() { return /* binding */ clearPreCode; },
  "jg": function() { return /* binding */ getTempCode; },
  "np": function() { return /* binding */ isTempCode; }
});

// UNUSED EXPORTS: tempCodePrefix

// EXTERNAL MODULE: ./node_modules/.pnpm/short-uuid@4.2.0/node_modules/short-uuid/index.js
var short_uuid = __webpack_require__(49543);
var short_uuid_default = /*#__PURE__*/__webpack_require__.n(short_uuid);
;// CONCATENATED MODULE: ./src/utils/getUuid.ts

function getUuid() {
    var firstCode = getFirstRandomCode();
    return firstCode + short_uuid_default().generate();
}
function getFirstRandomCode() {
    var isUpperCase = Math.random() < 0.5;
    var offset = Math.floor(Math.random() * 26);
    return String.fromCharCode((isUpperCase ? 65 : 97) + offset);
}

;// CONCATENATED MODULE: ./src/utils/tempCode.ts

var tempCodePrefix = "temp-code-";
var isTempCode = function(code) {
    var ref;
    return code === null || code === void 0 ? void 0 : (ref = code.startsWith) === null || ref === void 0 ? void 0 : ref.call(code, tempCodePrefix);
};
var clearPreCode = function(code) {
    if (isTempCode(code)) {
        return code.replace(/^temp-code-/, "");
    }
    return code;
};
var getTempCode = function() {
    var _obj, ref;
    return tempCodePrefix + ((ref = (_obj = getUuid()).substring) === null || ref === void 0 ? void 0 : ref.call(_obj, 0, 4));
};


/***/ }),

/***/ 73499:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"current":"AppManager_current__KtsoG","active":"AppManager_active___IRl6"};

/***/ }),

/***/ 9557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"browser":"FakeBrowser_browser__bUHXK"};

/***/ }),

/***/ 61915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"condition":"Conditions_condition__raAAN","node":"Conditions_node__nMpCH","operator":"Conditions_operator__9hT1i"};

/***/ }),

/***/ 67535:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./1.png": 14122,
	"./10.png": 88775,
	"./11.png": 96865,
	"./12.png": 53705,
	"./13.png": 44570,
	"./14.png": 24029,
	"./15.png": 23746,
	"./16.png": 59676,
	"./17.png": 32534,
	"./18.png": 50970,
	"./19.png": 5740,
	"./2.png": 81120,
	"./20.png": 38149,
	"./21.png": 98784,
	"./22.png": 41732,
	"./23.png": 94494,
	"./24.png": 48108,
	"./25.png": 66206,
	"./26.png": 10466,
	"./27.png": 59358,
	"./28.png": 5008,
	"./29.png": 64849,
	"./3.png": 80455,
	"./30.png": 37771,
	"./31.png": 57783,
	"./32.png": 81586,
	"./33.png": 29000,
	"./34.png": 45005,
	"./35.png": 33284,
	"./36.png": 92850,
	"./37.png": 42595,
	"./38.png": 39781,
	"./39.png": 38893,
	"./4.png": 74105,
	"./40.png": 51721,
	"./41.png": 50046,
	"./42.png": 29473,
	"./43.png": 21065,
	"./44.png": 12593,
	"./45.png": 40959,
	"./5.png": 90337,
	"./6.png": 48652,
	"./7.png": 91145,
	"./8.png": 84055,
	"./9.png": 33673,
	"./b1.png": 93151,
	"./b2.png": 51958,
	"./b3.png": 59298,
	"./b4.png": 6376,
	"./b5.png": 5485,
	"./b6.png": 95842,
	"./b7.png": 61472,
	"./b8.png": 46064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67535;

/***/ }),

/***/ 71095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./FEEDBACK/entries/1200px-dark.png": 87731,
	"./FEEDBACK/entries/1200px-light.png": 51500,
	"./FEEDBACK/entries/1440px-dark.png": 35180,
	"./FEEDBACK/entries/1440px-light.png": 92337,
	"./FEEDBACK/entries/1680px-dark.png": 96399,
	"./FEEDBACK/entries/1680px-light.png": 2623,
	"./FEEDBACK/entries/1920px-dark.png": 86700,
	"./FEEDBACK/entries/1920px-light.png": 30274,
	"./FEEDBACK/overview/1200px-dark.png": 44484,
	"./FEEDBACK/overview/1200px-light.png": 39767,
	"./FEEDBACK/overview/1440px-dark.png": 76603,
	"./FEEDBACK/overview/1440px-light.png": 45917,
	"./FEEDBACK/overview/1680px-dark.png": 58176,
	"./FEEDBACK/overview/1680px-light.png": 69287,
	"./FEEDBACK/overview/1920px-dark.png": 43005,
	"./FEEDBACK/overview/1920px-light.png": 28949,
	"./SURVEY/entries/1200px-dark.png": 5622,
	"./SURVEY/entries/1200px-light.png": 61009,
	"./SURVEY/entries/1440px-dark.png": 70475,
	"./SURVEY/entries/1440px-light.png": 57045,
	"./SURVEY/entries/1680px-dark.png": 83351,
	"./SURVEY/entries/1680px-light.png": 48923,
	"./SURVEY/entries/1920px-dark.png": 27959,
	"./SURVEY/entries/1920px-light.png": 57188,
	"./SURVEY/overview/1200px-dark.png": 31027,
	"./SURVEY/overview/1200px-light.png": 11619,
	"./SURVEY/overview/1440px-dark.png": 97201,
	"./SURVEY/overview/1440px-light.png": 75010,
	"./SURVEY/overview/1680px-dark.png": 15164,
	"./SURVEY/overview/1680px-light.png": 83444,
	"./SURVEY/overview/1920px-dark.png": 18282,
	"./SURVEY/overview/1920px-light.png": 49480,
	"./SURVEY/reports/1200px-dark.png": 48113,
	"./SURVEY/reports/1200px-light.png": 79420,
	"./SURVEY/reports/1440px-dark.png": 78629,
	"./SURVEY/reports/1440px-light.png": 82872,
	"./SURVEY/reports/1680px-dark.png": 5555,
	"./SURVEY/reports/1680px-light.png": 66425,
	"./SURVEY/reports/1920px-dark.png": 92893,
	"./SURVEY/reports/1920px-light.png": 13904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71095;

/***/ }),

/***/ 13813:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./browser-dark.png": 48532,
	"./browser-light.png": 84876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13813;

/***/ }),

/***/ 93098:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./browser-end-dark.png": 11403,
	"./browser-end-light.png": 32636,
	"./browser-repeat-dark.png": 57914,
	"./browser-repeat-light.png": 76422,
	"./browser-start-dark.png": 88581,
	"./browser-start-light.png": 88353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93098;

/***/ })

}]);